require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.promise.finally.js");
module.exports = function (e) {
  var t = {};
  function n(a) {
    if (t[a]) return t[a].exports;
    var r = t[a] = {
      i: a,
      l: !1,
      exports: {}
    };
    return e[a].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
  }
  return n.m = e, n.c = t, n.d = function (e, t, a) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: a
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var a = Object.create(null);
    if (n.r(a), Object.defineProperty(a, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var r in e) n.d(a, r, function (t) {
      return e[t];
    }.bind(null, r));
    return a;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 267);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t, n) {
  (function (e) {
    e.exports = function () {
      "use strict";

      var t, a;
      function r() {
        return t.apply(null, arguments);
      }
      function i(e) {
        return e instanceof Array || "[object Array]" === Object.prototype.toString.call(e);
      }
      function o(e) {
        return null != e && "[object Object]" === Object.prototype.toString.call(e);
      }
      function s(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }
      function l(e) {
        if (Object.getOwnPropertyNames) return 0 === Object.getOwnPropertyNames(e).length;
        var t;
        for (t in e) if (s(e, t)) return !1;
        return !0;
      }
      function d(e) {
        return void 0 === e;
      }
      function u(e) {
        return "number" == typeof e || "[object Number]" === Object.prototype.toString.call(e);
      }
      function c(e) {
        return e instanceof Date || "[object Date]" === Object.prototype.toString.call(e);
      }
      function m(e, t) {
        var n,
          a = [];
        for (n = 0; n < e.length; ++n) a.push(t(e[n], n));
        return a;
      }
      function f(e, t) {
        for (var n in t) s(t, n) && (e[n] = t[n]);
        return s(t, "toString") && (e.toString = t.toString), s(t, "valueOf") && (e.valueOf = t.valueOf), e;
      }
      function p(e, t, n, a) {
        return Yt(e, t, n, a, !0).utc();
      }
      function _(e) {
        return null == e._pf && (e._pf = {
          empty: !1,
          unusedTokens: [],
          unusedInput: [],
          overflow: -2,
          charsLeftOver: 0,
          nullInput: !1,
          invalidEra: null,
          invalidMonth: null,
          invalidFormat: !1,
          userInvalidated: !1,
          iso: !1,
          parsedDateParts: [],
          era: null,
          meridiem: null,
          rfc2822: !1,
          weekdayMismatch: !1
        }), e._pf;
      }
      function h(e) {
        if (null == e._isValid) {
          var t = _(e),
            n = a.call(t.parsedDateParts, function (e) {
              return null != e;
            }),
            r = !isNaN(e._d.getTime()) && t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && n);
          if (e._strict && (r = r && 0 === t.charsLeftOver && 0 === t.unusedTokens.length && void 0 === t.bigHour), null != Object.isFrozen && Object.isFrozen(e)) return r;
          e._isValid = r;
        }
        return e._isValid;
      }
      function y(e) {
        var t = p(NaN);
        return null != e ? f(_(t), e) : _(t).userInvalidated = !0, t;
      }
      a = Array.prototype.some ? Array.prototype.some : function (e) {
        var t,
          n = Object(this),
          a = n.length >>> 0;
        for (t = 0; t < a; t++) if (t in n && e.call(this, n[t], t, n)) return !0;
        return !1;
      };
      var g = r.momentProperties = [],
        v = !1;
      function M(e, t) {
        var n, a, r;
        if (d(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), d(t._i) || (e._i = t._i), d(t._f) || (e._f = t._f), d(t._l) || (e._l = t._l), d(t._strict) || (e._strict = t._strict), d(t._tzm) || (e._tzm = t._tzm), d(t._isUTC) || (e._isUTC = t._isUTC), d(t._offset) || (e._offset = t._offset), d(t._pf) || (e._pf = _(t)), d(t._locale) || (e._locale = t._locale), g.length > 0) for (n = 0; n < g.length; n++) d(r = t[a = g[n]]) || (e[a] = r);
        return e;
      }
      function L(e) {
        M(this, e), this._d = new Date(null != e._d ? e._d.getTime() : NaN), this.isValid() || (this._d = new Date(NaN)), !1 === v && (v = !0, r.updateOffset(this), v = !1);
      }
      function b(e) {
        return e instanceof L || null != e && null != e._isAMomentObject;
      }
      function w(e) {
        !1 === r.suppressDeprecationWarnings && "undefined" != typeof console && console.warn && console.warn("Deprecation warning: " + e);
      }
      function k(e, t) {
        var n = !0;
        return f(function () {
          if (null != r.deprecationHandler && r.deprecationHandler(null, e), n) {
            var a,
              i,
              o,
              l = [];
            for (i = 0; i < arguments.length; i++) {
              if (a = "", "object" == typeof arguments[i]) {
                for (o in a += "\n[" + i + "] ", arguments[0]) s(arguments[0], o) && (a += o + ": " + arguments[0][o] + ", ");
                a = a.slice(0, -2);
              } else a = arguments[i];
              l.push(a);
            }
            w(e + "\nArguments: " + Array.prototype.slice.call(l).join("") + "\n" + new Error().stack), n = !1;
          }
          return t.apply(this, arguments);
        }, t);
      }
      var Y,
        D = {};
      function S(e, t) {
        null != r.deprecationHandler && r.deprecationHandler(e, t), D[e] || (w(t), D[e] = !0);
      }
      function T(e) {
        return "undefined" != typeof Function && e instanceof Function || "[object Function]" === Object.prototype.toString.call(e);
      }
      function E(e, t) {
        var n,
          a = f({}, e);
        for (n in t) s(t, n) && (o(e[n]) && o(t[n]) ? (a[n] = {}, f(a[n], e[n]), f(a[n], t[n])) : null != t[n] ? a[n] = t[n] : delete a[n]);
        for (n in e) s(e, n) && !s(t, n) && o(e[n]) && (a[n] = f({}, a[n]));
        return a;
      }
      function x(e) {
        null != e && this.set(e);
      }
      function C(e, t, n) {
        var a = "" + Math.abs(e),
          r = t - a.length;
        return (e >= 0 ? n ? "+" : "" : "-") + Math.pow(10, Math.max(0, r)).toString().substr(1) + a;
      }
      r.suppressDeprecationWarnings = !1, r.deprecationHandler = null, Y = Object.keys ? Object.keys : function (e) {
        var t,
          n = [];
        for (t in e) s(e, t) && n.push(t);
        return n;
      };
      var j = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        P = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        N = {},
        H = {};
      function O(e, t, n, a) {
        var r = a;
        "string" == typeof a && (r = function () {
          return this[a]();
        }), e && (H[e] = r), t && (H[t[0]] = function () {
          return C(r.apply(this, arguments), t[1], t[2]);
        }), n && (H[n] = function () {
          return this.localeData().ordinal(r.apply(this, arguments), e);
        });
      }
      function I(e, t) {
        return e.isValid() ? (t = z(t, e.localeData()), N[t] = N[t] || function (e) {
          var t,
            n,
            a,
            r = e.match(j);
          for (t = 0, n = r.length; t < n; t++) H[r[t]] ? r[t] = H[r[t]] : r[t] = (a = r[t]).match(/\[[\s\S]/) ? a.replace(/^\[|\]$/g, "") : a.replace(/\\/g, "");
          return function (t) {
            var a,
              i = "";
            for (a = 0; a < n; a++) i += T(r[a]) ? r[a].call(t, e) : r[a];
            return i;
          };
        }(t), N[t](e)) : e.localeData().invalidDate();
      }
      function z(e, t) {
        var n = 5;
        function a(e) {
          return t.longDateFormat(e) || e;
        }
        for (P.lastIndex = 0; n >= 0 && P.test(e);) e = e.replace(P, a), P.lastIndex = 0, n -= 1;
        return e;
      }
      var A = {};
      function F(e, t) {
        var n = e.toLowerCase();
        A[n] = A[n + "s"] = A[t] = e;
      }
      function R(e) {
        return "string" == typeof e ? A[e] || A[e.toLowerCase()] : void 0;
      }
      function W(e) {
        var t,
          n,
          a = {};
        for (n in e) s(e, n) && (t = R(n)) && (a[t] = e[n]);
        return a;
      }
      var V = {};
      function K(e, t) {
        V[e] = t;
      }
      function B(e) {
        return e % 4 == 0 && e % 100 != 0 || e % 400 == 0;
      }
      function U(e) {
        return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
      }
      function q(e) {
        var t = +e,
          n = 0;
        return 0 !== t && isFinite(t) && (n = U(t)), n;
      }
      function J(e, t) {
        return function (n) {
          return null != n ? (G(this, e, n), r.updateOffset(this, t), this) : Z(this, e);
        };
      }
      function Z(e, t) {
        return e.isValid() ? e._d["get" + (e._isUTC ? "UTC" : "") + t]() : NaN;
      }
      function G(e, t, n) {
        e.isValid() && !isNaN(n) && ("FullYear" === t && B(e.year()) && 1 === e.month() && 29 === e.date() ? (n = q(n), e._d["set" + (e._isUTC ? "UTC" : "") + t](n, e.month(), be(n, e.month()))) : e._d["set" + (e._isUTC ? "UTC" : "") + t](n));
      }
      var $,
        X = /\d/,
        Q = /\d\d/,
        ee = /\d{3}/,
        te = /\d{4}/,
        ne = /[+-]?\d{6}/,
        ae = /\d\d?/,
        re = /\d\d\d\d?/,
        ie = /\d\d\d\d\d\d?/,
        oe = /\d{1,3}/,
        se = /\d{1,4}/,
        le = /[+-]?\d{1,6}/,
        de = /\d+/,
        ue = /[+-]?\d+/,
        ce = /Z|[+-]\d\d:?\d\d/gi,
        me = /Z|[+-]\d\d(?::?\d\d)?/gi,
        fe = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
      function pe(e, t, n) {
        $[e] = T(t) ? t : function (e, a) {
          return e && n ? n : t;
        };
      }
      function _e(e, t) {
        return s($, e) ? $[e](t._strict, t._locale) : new RegExp(he(e.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (e, t, n, a, r) {
          return t || n || a || r;
        })));
      }
      function he(e) {
        return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
      }
      $ = {};
      var ye,
        ge = {};
      function ve(e, t) {
        var n,
          a = t;
        for ("string" == typeof e && (e = [e]), u(t) && (a = function (e, n) {
          n[t] = q(e);
        }), n = 0; n < e.length; n++) ge[e[n]] = a;
      }
      function Me(e, t) {
        ve(e, function (e, n, a, r) {
          a._w = a._w || {}, t(e, a._w, a, r);
        });
      }
      function Le(e, t, n) {
        null != t && s(ge, e) && ge[e](t, n._a, n, e);
      }
      function be(e, t) {
        if (isNaN(e) || isNaN(t)) return NaN;
        var n,
          a = (t % (n = 12) + n) % n;
        return e += (t - a) / 12, 1 === a ? B(e) ? 29 : 28 : 31 - a % 7 % 2;
      }
      ye = Array.prototype.indexOf ? Array.prototype.indexOf : function (e) {
        var t;
        for (t = 0; t < this.length; ++t) if (this[t] === e) return t;
        return -1;
      }, O("M", ["MM", 2], "Mo", function () {
        return this.month() + 1;
      }), O("MMM", 0, 0, function (e) {
        return this.localeData().monthsShort(this, e);
      }), O("MMMM", 0, 0, function (e) {
        return this.localeData().months(this, e);
      }), F("month", "M"), K("month", 8), pe("M", ae), pe("MM", ae, Q), pe("MMM", function (e, t) {
        return t.monthsShortRegex(e);
      }), pe("MMMM", function (e, t) {
        return t.monthsRegex(e);
      }), ve(["M", "MM"], function (e, t) {
        t[1] = q(e) - 1;
      }), ve(["MMM", "MMMM"], function (e, t, n, a) {
        var r = n._locale.monthsParse(e, a, n._strict);
        null != r ? t[1] = r : _(n).invalidMonth = e;
      });
      var we = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ke = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
        Ye = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        De = fe,
        Se = fe;
      function Te(e, t, n) {
        var a,
          r,
          i,
          o = e.toLocaleLowerCase();
        if (!this._monthsParse) for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], a = 0; a < 12; ++a) i = p([2e3, a]), this._shortMonthsParse[a] = this.monthsShort(i, "").toLocaleLowerCase(), this._longMonthsParse[a] = this.months(i, "").toLocaleLowerCase();
        return n ? "MMM" === t ? -1 !== (r = ye.call(this._shortMonthsParse, o)) ? r : null : -1 !== (r = ye.call(this._longMonthsParse, o)) ? r : null : "MMM" === t ? -1 !== (r = ye.call(this._shortMonthsParse, o)) || -1 !== (r = ye.call(this._longMonthsParse, o)) ? r : null : -1 !== (r = ye.call(this._longMonthsParse, o)) || -1 !== (r = ye.call(this._shortMonthsParse, o)) ? r : null;
      }
      function Ee(e, t) {
        var n;
        if (!e.isValid()) return e;
        if ("string" == typeof t) if (/^\d+$/.test(t)) t = q(t);else if (!u(t = e.localeData().monthsParse(t))) return e;
        return n = Math.min(e.date(), be(e.year(), t)), e._d["set" + (e._isUTC ? "UTC" : "") + "Month"](t, n), e;
      }
      function xe(e) {
        return null != e ? (Ee(this, e), r.updateOffset(this, !0), this) : Z(this, "Month");
      }
      function Ce() {
        function e(e, t) {
          return t.length - e.length;
        }
        var t,
          n,
          a = [],
          r = [],
          i = [];
        for (t = 0; t < 12; t++) n = p([2e3, t]), a.push(this.monthsShort(n, "")), r.push(this.months(n, "")), i.push(this.months(n, "")), i.push(this.monthsShort(n, ""));
        for (a.sort(e), r.sort(e), i.sort(e), t = 0; t < 12; t++) a[t] = he(a[t]), r[t] = he(r[t]);
        for (t = 0; t < 24; t++) i[t] = he(i[t]);
        this._monthsRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._monthsShortStrictRegex = new RegExp("^(" + a.join("|") + ")", "i");
      }
      function je(e) {
        return B(e) ? 366 : 365;
      }
      O("Y", 0, 0, function () {
        var e = this.year();
        return e <= 9999 ? C(e, 4) : "+" + e;
      }), O(0, ["YY", 2], 0, function () {
        return this.year() % 100;
      }), O(0, ["YYYY", 4], 0, "year"), O(0, ["YYYYY", 5], 0, "year"), O(0, ["YYYYYY", 6, !0], 0, "year"), F("year", "y"), K("year", 1), pe("Y", ue), pe("YY", ae, Q), pe("YYYY", se, te), pe("YYYYY", le, ne), pe("YYYYYY", le, ne), ve(["YYYYY", "YYYYYY"], 0), ve("YYYY", function (e, t) {
        t[0] = 2 === e.length ? r.parseTwoDigitYear(e) : q(e);
      }), ve("YY", function (e, t) {
        t[0] = r.parseTwoDigitYear(e);
      }), ve("Y", function (e, t) {
        t[0] = parseInt(e, 10);
      }), r.parseTwoDigitYear = function (e) {
        return q(e) + (q(e) > 68 ? 1900 : 2e3);
      };
      var Pe = J("FullYear", !0);
      function Ne(e, t, n, a, r, i, o) {
        var s;
        return e < 100 && e >= 0 ? (s = new Date(e + 400, t, n, a, r, i, o), isFinite(s.getFullYear()) && s.setFullYear(e)) : s = new Date(e, t, n, a, r, i, o), s;
      }
      function He(e) {
        var t, n;
        return e < 100 && e >= 0 ? ((n = Array.prototype.slice.call(arguments))[0] = e + 400, t = new Date(Date.UTC.apply(null, n)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
      }
      function Oe(e, t, n) {
        var a = 7 + t - n;
        return -(7 + He(e, 0, a).getUTCDay() - t) % 7 + a - 1;
      }
      function Ie(e, t, n, a, r) {
        var i,
          o,
          s = 1 + 7 * (t - 1) + (7 + n - a) % 7 + Oe(e, a, r);
        return s <= 0 ? o = je(i = e - 1) + s : s > je(e) ? (i = e + 1, o = s - je(e)) : (i = e, o = s), {
          year: i,
          dayOfYear: o
        };
      }
      function ze(e, t, n) {
        var a,
          r,
          i = Oe(e.year(), t, n),
          o = Math.floor((e.dayOfYear() - i - 1) / 7) + 1;
        return o < 1 ? a = o + Ae(r = e.year() - 1, t, n) : o > Ae(e.year(), t, n) ? (a = o - Ae(e.year(), t, n), r = e.year() + 1) : (r = e.year(), a = o), {
          week: a,
          year: r
        };
      }
      function Ae(e, t, n) {
        var a = Oe(e, t, n),
          r = Oe(e + 1, t, n);
        return (je(e) - a + r) / 7;
      }
      function Fe(e, t) {
        return e.slice(t, 7).concat(e.slice(0, t));
      }
      O("w", ["ww", 2], "wo", "week"), O("W", ["WW", 2], "Wo", "isoWeek"), F("week", "w"), F("isoWeek", "W"), K("week", 5), K("isoWeek", 5), pe("w", ae), pe("ww", ae, Q), pe("W", ae), pe("WW", ae, Q), Me(["w", "ww", "W", "WW"], function (e, t, n, a) {
        t[a.substr(0, 1)] = q(e);
      }), O("d", 0, "do", "day"), O("dd", 0, 0, function (e) {
        return this.localeData().weekdaysMin(this, e);
      }), O("ddd", 0, 0, function (e) {
        return this.localeData().weekdaysShort(this, e);
      }), O("dddd", 0, 0, function (e) {
        return this.localeData().weekdays(this, e);
      }), O("e", 0, 0, "weekday"), O("E", 0, 0, "isoWeekday"), F("day", "d"), F("weekday", "e"), F("isoWeekday", "E"), K("day", 11), K("weekday", 11), K("isoWeekday", 11), pe("d", ae), pe("e", ae), pe("E", ae), pe("dd", function (e, t) {
        return t.weekdaysMinRegex(e);
      }), pe("ddd", function (e, t) {
        return t.weekdaysShortRegex(e);
      }), pe("dddd", function (e, t) {
        return t.weekdaysRegex(e);
      }), Me(["dd", "ddd", "dddd"], function (e, t, n, a) {
        var r = n._locale.weekdaysParse(e, a, n._strict);
        null != r ? t.d = r : _(n).invalidWeekday = e;
      }), Me(["d", "e", "E"], function (e, t, n, a) {
        t[a] = q(e);
      });
      var Re = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        We = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
        Ve = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
        Ke = fe,
        Be = fe,
        Ue = fe;
      function qe(e, t, n) {
        var a,
          r,
          i,
          o = e.toLocaleLowerCase();
        if (!this._weekdaysParse) for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], a = 0; a < 7; ++a) i = p([2e3, 1]).day(a), this._minWeekdaysParse[a] = this.weekdaysMin(i, "").toLocaleLowerCase(), this._shortWeekdaysParse[a] = this.weekdaysShort(i, "").toLocaleLowerCase(), this._weekdaysParse[a] = this.weekdays(i, "").toLocaleLowerCase();
        return n ? "dddd" === t ? -1 !== (r = ye.call(this._weekdaysParse, o)) ? r : null : "ddd" === t ? -1 !== (r = ye.call(this._shortWeekdaysParse, o)) ? r : null : -1 !== (r = ye.call(this._minWeekdaysParse, o)) ? r : null : "dddd" === t ? -1 !== (r = ye.call(this._weekdaysParse, o)) || -1 !== (r = ye.call(this._shortWeekdaysParse, o)) || -1 !== (r = ye.call(this._minWeekdaysParse, o)) ? r : null : "ddd" === t ? -1 !== (r = ye.call(this._shortWeekdaysParse, o)) || -1 !== (r = ye.call(this._weekdaysParse, o)) || -1 !== (r = ye.call(this._minWeekdaysParse, o)) ? r : null : -1 !== (r = ye.call(this._minWeekdaysParse, o)) || -1 !== (r = ye.call(this._weekdaysParse, o)) || -1 !== (r = ye.call(this._shortWeekdaysParse, o)) ? r : null;
      }
      function Je() {
        function e(e, t) {
          return t.length - e.length;
        }
        var t,
          n,
          a,
          r,
          i,
          o = [],
          s = [],
          l = [],
          d = [];
        for (t = 0; t < 7; t++) n = p([2e3, 1]).day(t), a = he(this.weekdaysMin(n, "")), r = he(this.weekdaysShort(n, "")), i = he(this.weekdays(n, "")), o.push(a), s.push(r), l.push(i), d.push(a), d.push(r), d.push(i);
        o.sort(e), s.sort(e), l.sort(e), d.sort(e), this._weekdaysRegex = new RegExp("^(" + d.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp("^(" + l.join("|") + ")", "i"), this._weekdaysShortStrictRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._weekdaysMinStrictRegex = new RegExp("^(" + o.join("|") + ")", "i");
      }
      function Ze() {
        return this.hours() % 12 || 12;
      }
      function Ge(e, t) {
        O(e, 0, 0, function () {
          return this.localeData().meridiem(this.hours(), this.minutes(), t);
        });
      }
      function $e(e, t) {
        return t._meridiemParse;
      }
      O("H", ["HH", 2], 0, "hour"), O("h", ["hh", 2], 0, Ze), O("k", ["kk", 2], 0, function () {
        return this.hours() || 24;
      }), O("hmm", 0, 0, function () {
        return "" + Ze.apply(this) + C(this.minutes(), 2);
      }), O("hmmss", 0, 0, function () {
        return "" + Ze.apply(this) + C(this.minutes(), 2) + C(this.seconds(), 2);
      }), O("Hmm", 0, 0, function () {
        return "" + this.hours() + C(this.minutes(), 2);
      }), O("Hmmss", 0, 0, function () {
        return "" + this.hours() + C(this.minutes(), 2) + C(this.seconds(), 2);
      }), Ge("a", !0), Ge("A", !1), F("hour", "h"), K("hour", 13), pe("a", $e), pe("A", $e), pe("H", ae), pe("h", ae), pe("k", ae), pe("HH", ae, Q), pe("hh", ae, Q), pe("kk", ae, Q), pe("hmm", re), pe("hmmss", ie), pe("Hmm", re), pe("Hmmss", ie), ve(["H", "HH"], 3), ve(["k", "kk"], function (e, t, n) {
        var a = q(e);
        t[3] = 24 === a ? 0 : a;
      }), ve(["a", "A"], function (e, t, n) {
        n._isPm = n._locale.isPM(e), n._meridiem = e;
      }), ve(["h", "hh"], function (e, t, n) {
        t[3] = q(e), _(n).bigHour = !0;
      }), ve("hmm", function (e, t, n) {
        var a = e.length - 2;
        t[3] = q(e.substr(0, a)), t[4] = q(e.substr(a)), _(n).bigHour = !0;
      }), ve("hmmss", function (e, t, n) {
        var a = e.length - 4,
          r = e.length - 2;
        t[3] = q(e.substr(0, a)), t[4] = q(e.substr(a, 2)), t[5] = q(e.substr(r)), _(n).bigHour = !0;
      }), ve("Hmm", function (e, t, n) {
        var a = e.length - 2;
        t[3] = q(e.substr(0, a)), t[4] = q(e.substr(a));
      }), ve("Hmmss", function (e, t, n) {
        var a = e.length - 4,
          r = e.length - 2;
        t[3] = q(e.substr(0, a)), t[4] = q(e.substr(a, 2)), t[5] = q(e.substr(r));
      });
      var Xe,
        Qe = J("Hours", !0),
        et = {
          calendar: {
            sameDay: "[Today at] LT",
            nextDay: "[Tomorrow at] LT",
            nextWeek: "dddd [at] LT",
            lastDay: "[Yesterday at] LT",
            lastWeek: "[Last] dddd [at] LT",
            sameElse: "L"
          },
          longDateFormat: {
            LTS: "h:mm:ss A",
            LT: "h:mm A",
            L: "MM/DD/YYYY",
            LL: "MMMM D, YYYY",
            LLL: "MMMM D, YYYY h:mm A",
            LLLL: "dddd, MMMM D, YYYY h:mm A"
          },
          invalidDate: "Invalid date",
          ordinal: "%d",
          dayOfMonthOrdinalParse: /\d{1,2}/,
          relativeTime: {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            ss: "%d seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            w: "a week",
            ww: "%d weeks",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
          },
          months: we,
          monthsShort: ke,
          week: {
            dow: 0,
            doy: 6
          },
          weekdays: Re,
          weekdaysMin: Ve,
          weekdaysShort: We,
          meridiemParse: /[ap]\.?m?\.?/i
        },
        tt = {},
        nt = {};
      function at(e, t) {
        var n,
          a = Math.min(e.length, t.length);
        for (n = 0; n < a; n += 1) if (e[n] !== t[n]) return n;
        return a;
      }
      function rt(e) {
        return e ? e.toLowerCase().replace("_", "-") : e;
      }
      function it(t) {
        var a = null;
        if (void 0 === tt[t] && void 0 !== e && e && e.exports) try {
          a = Xe._abbr, n(287)("./" + t), ot(a);
        } catch (e) {
          tt[t] = null;
        }
        return tt[t];
      }
      function ot(e, t) {
        var n;
        return e && ((n = d(t) ? lt(e) : st(e, t)) ? Xe = n : "undefined" != typeof console && console.warn && console.warn("Locale " + e + " not found. Did you forget to load it?")), Xe._abbr;
      }
      function st(e, t) {
        if (null !== t) {
          var n,
            a = et;
          if (t.abbr = e, null != tt[e]) S("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."), a = tt[e]._config;else if (null != t.parentLocale) if (null != tt[t.parentLocale]) a = tt[t.parentLocale]._config;else {
            if (null == (n = it(t.parentLocale))) return nt[t.parentLocale] || (nt[t.parentLocale] = []), nt[t.parentLocale].push({
              name: e,
              config: t
            }), null;
            a = n._config;
          }
          return tt[e] = new x(E(a, t)), nt[e] && nt[e].forEach(function (e) {
            st(e.name, e.config);
          }), ot(e), tt[e];
        }
        return delete tt[e], null;
      }
      function lt(e) {
        var t;
        if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e) return Xe;
        if (!i(e)) {
          if (t = it(e)) return t;
          e = [e];
        }
        return function (e) {
          for (var t, n, a, r, i = 0; i < e.length;) {
            for (t = (r = rt(e[i]).split("-")).length, n = (n = rt(e[i + 1])) ? n.split("-") : null; t > 0;) {
              if (a = it(r.slice(0, t).join("-"))) return a;
              if (n && n.length >= t && at(r, n) >= t - 1) break;
              t--;
            }
            i++;
          }
          return Xe;
        }(e);
      }
      function dt(e) {
        var t,
          n = e._a;
        return n && -2 === _(e).overflow && (t = n[1] < 0 || n[1] > 11 ? 1 : n[2] < 1 || n[2] > be(n[0], n[1]) ? 2 : n[3] < 0 || n[3] > 24 || 24 === n[3] && (0 !== n[4] || 0 !== n[5] || 0 !== n[6]) ? 3 : n[4] < 0 || n[4] > 59 ? 4 : n[5] < 0 || n[5] > 59 ? 5 : n[6] < 0 || n[6] > 999 ? 6 : -1, _(e)._overflowDayOfYear && (t < 0 || t > 2) && (t = 2), _(e)._overflowWeeks && -1 === t && (t = 7), _(e)._overflowWeekday && -1 === t && (t = 8), _(e).overflow = t), e;
      }
      var ut = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        ct = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        mt = /Z|[+-]\d\d(?::?\d\d)?/,
        ft = [["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/], ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/], ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/], ["GGGG-[W]WW", /\d{4}-W\d\d/, !1], ["YYYY-DDD", /\d{4}-\d{3}/], ["YYYY-MM", /\d{4}-\d\d/, !1], ["YYYYYYMMDD", /[+-]\d{10}/], ["YYYYMMDD", /\d{8}/], ["GGGG[W]WWE", /\d{4}W\d{3}/], ["GGGG[W]WW", /\d{4}W\d{2}/, !1], ["YYYYDDD", /\d{7}/], ["YYYYMM", /\d{6}/, !1], ["YYYY", /\d{4}/, !1]],
        pt = [["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/], ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/], ["HH:mm:ss", /\d\d:\d\d:\d\d/], ["HH:mm", /\d\d:\d\d/], ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/], ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/], ["HHmmss", /\d\d\d\d\d\d/], ["HHmm", /\d\d\d\d/], ["HH", /\d\d/]],
        _t = /^\/?Date\((-?\d+)/i,
        ht = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        yt = {
          UT: 0,
          GMT: 0,
          EDT: -240,
          EST: -300,
          CDT: -300,
          CST: -360,
          MDT: -360,
          MST: -420,
          PDT: -420,
          PST: -480
        };
      function gt(e) {
        var t,
          n,
          a,
          r,
          i,
          o,
          s = e._i,
          l = ut.exec(s) || ct.exec(s);
        if (l) {
          for (_(e).iso = !0, t = 0, n = ft.length; t < n; t++) if (ft[t][1].exec(l[1])) {
            r = ft[t][0], a = !1 !== ft[t][2];
            break;
          }
          if (null == r) return void (e._isValid = !1);
          if (l[3]) {
            for (t = 0, n = pt.length; t < n; t++) if (pt[t][1].exec(l[3])) {
              i = (l[2] || " ") + pt[t][0];
              break;
            }
            if (null == i) return void (e._isValid = !1);
          }
          if (!a && null != i) return void (e._isValid = !1);
          if (l[4]) {
            if (!mt.exec(l[4])) return void (e._isValid = !1);
            o = "Z";
          }
          e._f = r + (i || "") + (o || ""), wt(e);
        } else e._isValid = !1;
      }
      function vt(e) {
        var t = parseInt(e, 10);
        return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
      }
      function Mt(e) {
        var t,
          n,
          a,
          r,
          i,
          o,
          s,
          l,
          d = ht.exec(e._i.replace(/\([^)]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, ""));
        if (d) {
          if (n = d[4], a = d[3], r = d[2], i = d[5], o = d[6], s = d[7], l = [vt(n), ke.indexOf(a), parseInt(r, 10), parseInt(i, 10), parseInt(o, 10)], s && l.push(parseInt(s, 10)), t = l, !function (e, t, n) {
            return !e || We.indexOf(e) === new Date(t[0], t[1], t[2]).getDay() || (_(n).weekdayMismatch = !0, n._isValid = !1, !1);
          }(d[1], t, e)) return;
          e._a = t, e._tzm = function (e, t, n) {
            if (e) return yt[e];
            if (t) return 0;
            var a = parseInt(n, 10),
              r = a % 100;
            return (a - r) / 100 * 60 + r;
          }(d[8], d[9], d[10]), e._d = He.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), _(e).rfc2822 = !0;
        } else e._isValid = !1;
      }
      function Lt(e, t, n) {
        return null != e ? e : null != t ? t : n;
      }
      function bt(e) {
        var t,
          n,
          a,
          i,
          o,
          s = [];
        if (!e._d) {
          for (a = function (e) {
            var t = new Date(r.now());
            return e._useUTC ? [t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate()] : [t.getFullYear(), t.getMonth(), t.getDate()];
          }(e), e._w && null == e._a[2] && null == e._a[1] && function (e) {
            var t, n, a, r, i, o, s, l, d;
            null != (t = e._w).GG || null != t.W || null != t.E ? (i = 1, o = 4, n = Lt(t.GG, e._a[0], ze(Dt(), 1, 4).year), a = Lt(t.W, 1), ((r = Lt(t.E, 1)) < 1 || r > 7) && (l = !0)) : (i = e._locale._week.dow, o = e._locale._week.doy, d = ze(Dt(), i, o), n = Lt(t.gg, e._a[0], d.year), a = Lt(t.w, d.week), null != t.d ? ((r = t.d) < 0 || r > 6) && (l = !0) : null != t.e ? (r = t.e + i, (t.e < 0 || t.e > 6) && (l = !0)) : r = i), a < 1 || a > Ae(n, i, o) ? _(e)._overflowWeeks = !0 : null != l ? _(e)._overflowWeekday = !0 : (s = Ie(n, a, r, i, o), e._a[0] = s.year, e._dayOfYear = s.dayOfYear);
          }(e), null != e._dayOfYear && (o = Lt(e._a[0], a[0]), (e._dayOfYear > je(o) || 0 === e._dayOfYear) && (_(e)._overflowDayOfYear = !0), n = He(o, 0, e._dayOfYear), e._a[1] = n.getUTCMonth(), e._a[2] = n.getUTCDate()), t = 0; t < 3 && null == e._a[t]; ++t) e._a[t] = s[t] = a[t];
          for (; t < 7; t++) e._a[t] = s[t] = null == e._a[t] ? 2 === t ? 1 : 0 : e._a[t];
          24 === e._a[3] && 0 === e._a[4] && 0 === e._a[5] && 0 === e._a[6] && (e._nextDay = !0, e._a[3] = 0), e._d = (e._useUTC ? He : Ne).apply(null, s), i = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), null != e._tzm && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[3] = 24), e._w && void 0 !== e._w.d && e._w.d !== i && (_(e).weekdayMismatch = !0);
        }
      }
      function wt(e) {
        if (e._f !== r.ISO_8601) {
          if (e._f !== r.RFC_2822) {
            e._a = [], _(e).empty = !0;
            var t,
              n,
              a,
              i,
              o,
              s,
              l = "" + e._i,
              d = l.length,
              u = 0;
            for (a = z(e._f, e._locale).match(j) || [], t = 0; t < a.length; t++) i = a[t], (n = (l.match(_e(i, e)) || [])[0]) && ((o = l.substr(0, l.indexOf(n))).length > 0 && _(e).unusedInput.push(o), l = l.slice(l.indexOf(n) + n.length), u += n.length), H[i] ? (n ? _(e).empty = !1 : _(e).unusedTokens.push(i), Le(i, n, e)) : e._strict && !n && _(e).unusedTokens.push(i);
            _(e).charsLeftOver = d - u, l.length > 0 && _(e).unusedInput.push(l), e._a[3] <= 12 && !0 === _(e).bigHour && e._a[3] > 0 && (_(e).bigHour = void 0), _(e).parsedDateParts = e._a.slice(0), _(e).meridiem = e._meridiem, e._a[3] = function (e, t, n) {
              var a;
              return null == n ? t : null != e.meridiemHour ? e.meridiemHour(t, n) : null != e.isPM ? ((a = e.isPM(n)) && t < 12 && (t += 12), a || 12 !== t || (t = 0), t) : t;
            }(e._locale, e._a[3], e._meridiem), null !== (s = _(e).era) && (e._a[0] = e._locale.erasConvertYear(s, e._a[0])), bt(e), dt(e);
          } else Mt(e);
        } else gt(e);
      }
      function kt(e) {
        var t = e._i,
          n = e._f;
        return e._locale = e._locale || lt(e._l), null === t || void 0 === n && "" === t ? y({
          nullInput: !0
        }) : ("string" == typeof t && (e._i = t = e._locale.preparse(t)), b(t) ? new L(dt(t)) : (c(t) ? e._d = t : i(n) ? function (e) {
          var t,
            n,
            a,
            r,
            i,
            o,
            s = !1;
          if (0 === e._f.length) return _(e).invalidFormat = !0, void (e._d = new Date(NaN));
          for (r = 0; r < e._f.length; r++) i = 0, o = !1, t = M({}, e), null != e._useUTC && (t._useUTC = e._useUTC), t._f = e._f[r], wt(t), h(t) && (o = !0), i += _(t).charsLeftOver, i += 10 * _(t).unusedTokens.length, _(t).score = i, s ? i < a && (a = i, n = t) : (null == a || i < a || o) && (a = i, n = t, o && (s = !0));
          f(e, n || t);
        }(e) : n ? wt(e) : function (e) {
          var t = e._i;
          d(t) ? e._d = new Date(r.now()) : c(t) ? e._d = new Date(t.valueOf()) : "string" == typeof t ? function (e) {
            var t = _t.exec(e._i);
            null === t ? (gt(e), !1 === e._isValid && (delete e._isValid, Mt(e), !1 === e._isValid && (delete e._isValid, e._strict ? e._isValid = !1 : r.createFromInputFallback(e)))) : e._d = new Date(+t[1]);
          }(e) : i(t) ? (e._a = m(t.slice(0), function (e) {
            return parseInt(e, 10);
          }), bt(e)) : o(t) ? function (e) {
            if (!e._d) {
              var t = W(e._i),
                n = void 0 === t.day ? t.date : t.day;
              e._a = m([t.year, t.month, n, t.hour, t.minute, t.second, t.millisecond], function (e) {
                return e && parseInt(e, 10);
              }), bt(e);
            }
          }(e) : u(t) ? e._d = new Date(t) : r.createFromInputFallback(e);
        }(e), h(e) || (e._d = null), e));
      }
      function Yt(e, t, n, a, r) {
        var s,
          d = {};
        return !0 !== t && !1 !== t || (a = t, t = void 0), !0 !== n && !1 !== n || (a = n, n = void 0), (o(e) && l(e) || i(e) && 0 === e.length) && (e = void 0), d._isAMomentObject = !0, d._useUTC = d._isUTC = r, d._l = n, d._i = e, d._f = t, d._strict = a, (s = new L(dt(kt(d))))._nextDay && (s.add(1, "d"), s._nextDay = void 0), s;
      }
      function Dt(e, t, n, a) {
        return Yt(e, t, n, a, !1);
      }
      r.createFromInputFallback = k("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function (e) {
        e._d = new Date(e._i + (e._useUTC ? " UTC" : ""));
      }), r.ISO_8601 = function () {}, r.RFC_2822 = function () {};
      var St = k("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function () {
          var e = Dt.apply(null, arguments);
          return this.isValid() && e.isValid() ? e < this ? this : e : y();
        }),
        Tt = k("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function () {
          var e = Dt.apply(null, arguments);
          return this.isValid() && e.isValid() ? e > this ? this : e : y();
        });
      function Et(e, t) {
        var n, a;
        if (1 === t.length && i(t[0]) && (t = t[0]), !t.length) return Dt();
        for (n = t[0], a = 1; a < t.length; ++a) t[a].isValid() && !t[a][e](n) || (n = t[a]);
        return n;
      }
      var xt = ["year", "quarter", "month", "week", "day", "hour", "minute", "second", "millisecond"];
      function Ct(e) {
        var t = W(e),
          n = t.year || 0,
          a = t.quarter || 0,
          r = t.month || 0,
          i = t.week || t.isoWeek || 0,
          o = t.day || 0,
          l = t.hour || 0,
          d = t.minute || 0,
          u = t.second || 0,
          c = t.millisecond || 0;
        this._isValid = function (e) {
          var t,
            n,
            a = !1;
          for (t in e) if (s(e, t) && (-1 === ye.call(xt, t) || null != e[t] && isNaN(e[t]))) return !1;
          for (n = 0; n < xt.length; ++n) if (e[xt[n]]) {
            if (a) return !1;
            parseFloat(e[xt[n]]) !== q(e[xt[n]]) && (a = !0);
          }
          return !0;
        }(t), this._milliseconds = +c + 1e3 * u + 6e4 * d + 1e3 * l * 60 * 60, this._days = +o + 7 * i, this._months = +r + 3 * a + 12 * n, this._data = {}, this._locale = lt(), this._bubble();
      }
      function jt(e) {
        return e instanceof Ct;
      }
      function Pt(e) {
        return e < 0 ? -1 * Math.round(-1 * e) : Math.round(e);
      }
      function Nt(e, t) {
        O(e, 0, 0, function () {
          var e = this.utcOffset(),
            n = "+";
          return e < 0 && (e = -e, n = "-"), n + C(~~(e / 60), 2) + t + C(~~e % 60, 2);
        });
      }
      Nt("Z", ":"), Nt("ZZ", ""), pe("Z", me), pe("ZZ", me), ve(["Z", "ZZ"], function (e, t, n) {
        n._useUTC = !0, n._tzm = Ot(me, e);
      });
      var Ht = /([\+\-]|\d\d)/gi;
      function Ot(e, t) {
        var n,
          a,
          r = (t || "").match(e);
        return null === r ? null : 0 === (a = 60 * (n = ((r[r.length - 1] || []) + "").match(Ht) || ["-", 0, 0])[1] + q(n[2])) ? 0 : "+" === n[0] ? a : -a;
      }
      function It(e, t) {
        var n, a;
        return t._isUTC ? (n = t.clone(), a = (b(e) || c(e) ? e.valueOf() : Dt(e).valueOf()) - n.valueOf(), n._d.setTime(n._d.valueOf() + a), r.updateOffset(n, !1), n) : Dt(e).local();
      }
      function zt(e) {
        return -Math.round(e._d.getTimezoneOffset());
      }
      function At() {
        return !!this.isValid() && this._isUTC && 0 === this._offset;
      }
      r.updateOffset = function () {};
      var Ft = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        Rt = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
      function Wt(e, t) {
        var n,
          a,
          r,
          i,
          o,
          l,
          d = e,
          c = null;
        return jt(e) ? d = {
          ms: e._milliseconds,
          d: e._days,
          M: e._months
        } : u(e) || !isNaN(+e) ? (d = {}, t ? d[t] = +e : d.milliseconds = +e) : (c = Ft.exec(e)) ? (n = "-" === c[1] ? -1 : 1, d = {
          y: 0,
          d: q(c[2]) * n,
          h: q(c[3]) * n,
          m: q(c[4]) * n,
          s: q(c[5]) * n,
          ms: q(Pt(1e3 * c[6])) * n
        }) : (c = Rt.exec(e)) ? (n = "-" === c[1] ? -1 : 1, d = {
          y: Vt(c[2], n),
          M: Vt(c[3], n),
          w: Vt(c[4], n),
          d: Vt(c[5], n),
          h: Vt(c[6], n),
          m: Vt(c[7], n),
          s: Vt(c[8], n)
        }) : null == d ? d = {} : "object" == typeof d && ("from" in d || "to" in d) && (i = Dt(d.from), o = Dt(d.to), r = i.isValid() && o.isValid() ? (o = It(o, i), i.isBefore(o) ? l = Kt(i, o) : ((l = Kt(o, i)).milliseconds = -l.milliseconds, l.months = -l.months), l) : {
          milliseconds: 0,
          months: 0
        }, (d = {}).ms = r.milliseconds, d.M = r.months), a = new Ct(d), jt(e) && s(e, "_locale") && (a._locale = e._locale), jt(e) && s(e, "_isValid") && (a._isValid = e._isValid), a;
      }
      function Vt(e, t) {
        var n = e && parseFloat(e.replace(",", "."));
        return (isNaN(n) ? 0 : n) * t;
      }
      function Kt(e, t) {
        var n = {};
        return n.months = t.month() - e.month() + 12 * (t.year() - e.year()), e.clone().add(n.months, "M").isAfter(t) && --n.months, n.milliseconds = +t - +e.clone().add(n.months, "M"), n;
      }
      function Bt(e, t) {
        return function (n, a) {
          var r;
          return null === a || isNaN(+a) || (S(t, "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."), r = n, n = a, a = r), Ut(this, Wt(n, a), e), this;
        };
      }
      function Ut(e, t, n, a) {
        var i = t._milliseconds,
          o = Pt(t._days),
          s = Pt(t._months);
        e.isValid() && (a = null == a || a, s && Ee(e, Z(e, "Month") + s * n), o && G(e, "Date", Z(e, "Date") + o * n), i && e._d.setTime(e._d.valueOf() + i * n), a && r.updateOffset(e, o || s));
      }
      Wt.fn = Ct.prototype, Wt.invalid = function () {
        return Wt(NaN);
      };
      var qt = Bt(1, "add"),
        Jt = Bt(-1, "subtract");
      function Zt(e) {
        return "string" == typeof e || e instanceof String;
      }
      function Gt(e) {
        return b(e) || c(e) || Zt(e) || u(e) || function (e) {
          var t = i(e),
            n = !1;
          return t && (n = 0 === e.filter(function (t) {
            return !u(t) && Zt(e);
          }).length), t && n;
        }(e) || function (e) {
          var t,
            n,
            a = o(e) && !l(e),
            r = !1,
            i = ["years", "year", "y", "months", "month", "M", "days", "day", "d", "dates", "date", "D", "hours", "hour", "h", "minutes", "minute", "m", "seconds", "second", "s", "milliseconds", "millisecond", "ms"];
          for (t = 0; t < i.length; t += 1) n = i[t], r = r || s(e, n);
          return a && r;
        }(e) || null == e;
      }
      function $t(e) {
        var t,
          n = o(e) && !l(e),
          a = !1,
          r = ["sameDay", "nextDay", "lastDay", "nextWeek", "lastWeek", "sameElse"];
        for (t = 0; t < r.length; t += 1) a = a || s(e, r[t]);
        return n && a;
      }
      function Xt(e, t) {
        if (e.date() < t.date()) return -Xt(t, e);
        var n = 12 * (t.year() - e.year()) + (t.month() - e.month()),
          a = e.clone().add(n, "months");
        return -(n + (t - a < 0 ? (t - a) / (a - e.clone().add(n - 1, "months")) : (t - a) / (e.clone().add(n + 1, "months") - a))) || 0;
      }
      function Qt(e) {
        var t;
        return void 0 === e ? this._locale._abbr : (null != (t = lt(e)) && (this._locale = t), this);
      }
      r.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ", r.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
      var en = k("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function (e) {
        return void 0 === e ? this.localeData() : this.locale(e);
      });
      function tn() {
        return this._locale;
      }
      function nn(e, t) {
        return (e % t + t) % t;
      }
      function an(e, t, n) {
        return e < 100 && e >= 0 ? new Date(e + 400, t, n) - 126227808e5 : new Date(e, t, n).valueOf();
      }
      function rn(e, t, n) {
        return e < 100 && e >= 0 ? Date.UTC(e + 400, t, n) - 126227808e5 : Date.UTC(e, t, n);
      }
      function on(e, t) {
        return t.erasAbbrRegex(e);
      }
      function sn() {
        var e,
          t,
          n = [],
          a = [],
          r = [],
          i = [],
          o = this.eras();
        for (e = 0, t = o.length; e < t; ++e) a.push(he(o[e].name)), n.push(he(o[e].abbr)), r.push(he(o[e].narrow)), i.push(he(o[e].name)), i.push(he(o[e].abbr)), i.push(he(o[e].narrow));
        this._erasRegex = new RegExp("^(" + i.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + a.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp("^(" + r.join("|") + ")", "i");
      }
      function ln(e, t) {
        O(0, [e, e.length], 0, t);
      }
      function dn(e, t, n, a, r) {
        var i;
        return null == e ? ze(this, a, r).year : (t > (i = Ae(e, a, r)) && (t = i), un.call(this, e, t, n, a, r));
      }
      function un(e, t, n, a, r) {
        var i = Ie(e, t, n, a, r),
          o = He(i.year, 0, i.dayOfYear);
        return this.year(o.getUTCFullYear()), this.month(o.getUTCMonth()), this.date(o.getUTCDate()), this;
      }
      O("N", 0, 0, "eraAbbr"), O("NN", 0, 0, "eraAbbr"), O("NNN", 0, 0, "eraAbbr"), O("NNNN", 0, 0, "eraName"), O("NNNNN", 0, 0, "eraNarrow"), O("y", ["y", 1], "yo", "eraYear"), O("y", ["yy", 2], 0, "eraYear"), O("y", ["yyy", 3], 0, "eraYear"), O("y", ["yyyy", 4], 0, "eraYear"), pe("N", on), pe("NN", on), pe("NNN", on), pe("NNNN", function (e, t) {
        return t.erasNameRegex(e);
      }), pe("NNNNN", function (e, t) {
        return t.erasNarrowRegex(e);
      }), ve(["N", "NN", "NNN", "NNNN", "NNNNN"], function (e, t, n, a) {
        var r = n._locale.erasParse(e, a, n._strict);
        r ? _(n).era = r : _(n).invalidEra = e;
      }), pe("y", de), pe("yy", de), pe("yyy", de), pe("yyyy", de), pe("yo", function (e, t) {
        return t._eraYearOrdinalRegex || de;
      }), ve(["y", "yy", "yyy", "yyyy"], 0), ve(["yo"], function (e, t, n, a) {
        var r;
        n._locale._eraYearOrdinalRegex && (r = e.match(n._locale._eraYearOrdinalRegex)), n._locale.eraYearOrdinalParse ? t[0] = n._locale.eraYearOrdinalParse(e, r) : t[0] = parseInt(e, 10);
      }), O(0, ["gg", 2], 0, function () {
        return this.weekYear() % 100;
      }), O(0, ["GG", 2], 0, function () {
        return this.isoWeekYear() % 100;
      }), ln("gggg", "weekYear"), ln("ggggg", "weekYear"), ln("GGGG", "isoWeekYear"), ln("GGGGG", "isoWeekYear"), F("weekYear", "gg"), F("isoWeekYear", "GG"), K("weekYear", 1), K("isoWeekYear", 1), pe("G", ue), pe("g", ue), pe("GG", ae, Q), pe("gg", ae, Q), pe("GGGG", se, te), pe("gggg", se, te), pe("GGGGG", le, ne), pe("ggggg", le, ne), Me(["gggg", "ggggg", "GGGG", "GGGGG"], function (e, t, n, a) {
        t[a.substr(0, 2)] = q(e);
      }), Me(["gg", "GG"], function (e, t, n, a) {
        t[a] = r.parseTwoDigitYear(e);
      }), O("Q", 0, "Qo", "quarter"), F("quarter", "Q"), K("quarter", 7), pe("Q", X), ve("Q", function (e, t) {
        t[1] = 3 * (q(e) - 1);
      }), O("D", ["DD", 2], "Do", "date"), F("date", "D"), K("date", 9), pe("D", ae), pe("DD", ae, Q), pe("Do", function (e, t) {
        return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
      }), ve(["D", "DD"], 2), ve("Do", function (e, t) {
        t[2] = q(e.match(ae)[0]);
      });
      var cn = J("Date", !0);
      O("DDD", ["DDDD", 3], "DDDo", "dayOfYear"), F("dayOfYear", "DDD"), K("dayOfYear", 4), pe("DDD", oe), pe("DDDD", ee), ve(["DDD", "DDDD"], function (e, t, n) {
        n._dayOfYear = q(e);
      }), O("m", ["mm", 2], 0, "minute"), F("minute", "m"), K("minute", 14), pe("m", ae), pe("mm", ae, Q), ve(["m", "mm"], 4);
      var mn = J("Minutes", !1);
      O("s", ["ss", 2], 0, "second"), F("second", "s"), K("second", 15), pe("s", ae), pe("ss", ae, Q), ve(["s", "ss"], 5);
      var fn,
        pn,
        _n = J("Seconds", !1);
      for (O("S", 0, 0, function () {
        return ~~(this.millisecond() / 100);
      }), O(0, ["SS", 2], 0, function () {
        return ~~(this.millisecond() / 10);
      }), O(0, ["SSS", 3], 0, "millisecond"), O(0, ["SSSS", 4], 0, function () {
        return 10 * this.millisecond();
      }), O(0, ["SSSSS", 5], 0, function () {
        return 100 * this.millisecond();
      }), O(0, ["SSSSSS", 6], 0, function () {
        return 1e3 * this.millisecond();
      }), O(0, ["SSSSSSS", 7], 0, function () {
        return 1e4 * this.millisecond();
      }), O(0, ["SSSSSSSS", 8], 0, function () {
        return 1e5 * this.millisecond();
      }), O(0, ["SSSSSSSSS", 9], 0, function () {
        return 1e6 * this.millisecond();
      }), F("millisecond", "ms"), K("millisecond", 16), pe("S", oe, X), pe("SS", oe, Q), pe("SSS", oe, ee), fn = "SSSS"; fn.length <= 9; fn += "S") pe(fn, de);
      function hn(e, t) {
        t[6] = q(1e3 * ("0." + e));
      }
      for (fn = "S"; fn.length <= 9; fn += "S") ve(fn, hn);
      pn = J("Milliseconds", !1), O("z", 0, 0, "zoneAbbr"), O("zz", 0, 0, "zoneName");
      var yn = L.prototype;
      function gn(e) {
        return e;
      }
      yn.add = qt, yn.calendar = function (e, t) {
        1 === arguments.length && (arguments[0] ? Gt(arguments[0]) ? (e = arguments[0], t = void 0) : $t(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
        var n = e || Dt(),
          a = It(n, this).startOf("day"),
          i = r.calendarFormat(this, a) || "sameElse",
          o = t && (T(t[i]) ? t[i].call(this, n) : t[i]);
        return this.format(o || this.localeData().calendar(i, this, Dt(n)));
      }, yn.clone = function () {
        return new L(this);
      }, yn.diff = function (e, t, n) {
        var a, r, i;
        if (!this.isValid()) return NaN;
        if (!(a = It(e, this)).isValid()) return NaN;
        switch (r = 6e4 * (a.utcOffset() - this.utcOffset()), t = R(t)) {
          case "year":
            i = Xt(this, a) / 12;
            break;
          case "month":
            i = Xt(this, a);
            break;
          case "quarter":
            i = Xt(this, a) / 3;
            break;
          case "second":
            i = (this - a) / 1e3;
            break;
          case "minute":
            i = (this - a) / 6e4;
            break;
          case "hour":
            i = (this - a) / 36e5;
            break;
          case "day":
            i = (this - a - r) / 864e5;
            break;
          case "week":
            i = (this - a - r) / 6048e5;
            break;
          default:
            i = this - a;
        }
        return n ? i : U(i);
      }, yn.endOf = function (e) {
        var t, n;
        if (void 0 === (e = R(e)) || "millisecond" === e || !this.isValid()) return this;
        switch (n = this._isUTC ? rn : an, e) {
          case "year":
            t = n(this.year() + 1, 0, 1) - 1;
            break;
          case "quarter":
            t = n(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
            break;
          case "month":
            t = n(this.year(), this.month() + 1, 1) - 1;
            break;
          case "week":
            t = n(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
            break;
          case "isoWeek":
            t = n(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
            break;
          case "day":
          case "date":
            t = n(this.year(), this.month(), this.date() + 1) - 1;
            break;
          case "hour":
            t = this._d.valueOf(), t += 36e5 - nn(t + (this._isUTC ? 0 : 6e4 * this.utcOffset()), 36e5) - 1;
            break;
          case "minute":
            t = this._d.valueOf(), t += 6e4 - nn(t, 6e4) - 1;
            break;
          case "second":
            t = this._d.valueOf(), t += 1e3 - nn(t, 1e3) - 1;
        }
        return this._d.setTime(t), r.updateOffset(this, !0), this;
      }, yn.format = function (e) {
        e || (e = this.isUtc() ? r.defaultFormatUtc : r.defaultFormat);
        var t = I(this, e);
        return this.localeData().postformat(t);
      }, yn.from = function (e, t) {
        return this.isValid() && (b(e) && e.isValid() || Dt(e).isValid()) ? Wt({
          to: this,
          from: e
        }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
      }, yn.fromNow = function (e) {
        return this.from(Dt(), e);
      }, yn.to = function (e, t) {
        return this.isValid() && (b(e) && e.isValid() || Dt(e).isValid()) ? Wt({
          from: this,
          to: e
        }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
      }, yn.toNow = function (e) {
        return this.to(Dt(), e);
      }, yn.get = function (e) {
        return T(this[e = R(e)]) ? this[e]() : this;
      }, yn.invalidAt = function () {
        return _(this).overflow;
      }, yn.isAfter = function (e, t) {
        var n = b(e) ? e : Dt(e);
        return !(!this.isValid() || !n.isValid()) && ("millisecond" === (t = R(t) || "millisecond") ? this.valueOf() > n.valueOf() : n.valueOf() < this.clone().startOf(t).valueOf());
      }, yn.isBefore = function (e, t) {
        var n = b(e) ? e : Dt(e);
        return !(!this.isValid() || !n.isValid()) && ("millisecond" === (t = R(t) || "millisecond") ? this.valueOf() < n.valueOf() : this.clone().endOf(t).valueOf() < n.valueOf());
      }, yn.isBetween = function (e, t, n, a) {
        var r = b(e) ? e : Dt(e),
          i = b(t) ? t : Dt(t);
        return !!(this.isValid() && r.isValid() && i.isValid()) && ("(" === (a = a || "()")[0] ? this.isAfter(r, n) : !this.isBefore(r, n)) && (")" === a[1] ? this.isBefore(i, n) : !this.isAfter(i, n));
      }, yn.isSame = function (e, t) {
        var n,
          a = b(e) ? e : Dt(e);
        return !(!this.isValid() || !a.isValid()) && ("millisecond" === (t = R(t) || "millisecond") ? this.valueOf() === a.valueOf() : (n = a.valueOf(), this.clone().startOf(t).valueOf() <= n && n <= this.clone().endOf(t).valueOf()));
      }, yn.isSameOrAfter = function (e, t) {
        return this.isSame(e, t) || this.isAfter(e, t);
      }, yn.isSameOrBefore = function (e, t) {
        return this.isSame(e, t) || this.isBefore(e, t);
      }, yn.isValid = function () {
        return h(this);
      }, yn.lang = en, yn.locale = Qt, yn.localeData = tn, yn.max = Tt, yn.min = St, yn.parsingFlags = function () {
        return f({}, _(this));
      }, yn.set = function (e, t) {
        if ("object" == typeof e) {
          var n,
            a = function (e) {
              var t,
                n = [];
              for (t in e) s(e, t) && n.push({
                unit: t,
                priority: V[t]
              });
              return n.sort(function (e, t) {
                return e.priority - t.priority;
              }), n;
            }(e = W(e));
          for (n = 0; n < a.length; n++) this[a[n].unit](e[a[n].unit]);
        } else if (T(this[e = R(e)])) return this[e](t);
        return this;
      }, yn.startOf = function (e) {
        var t, n;
        if (void 0 === (e = R(e)) || "millisecond" === e || !this.isValid()) return this;
        switch (n = this._isUTC ? rn : an, e) {
          case "year":
            t = n(this.year(), 0, 1);
            break;
          case "quarter":
            t = n(this.year(), this.month() - this.month() % 3, 1);
            break;
          case "month":
            t = n(this.year(), this.month(), 1);
            break;
          case "week":
            t = n(this.year(), this.month(), this.date() - this.weekday());
            break;
          case "isoWeek":
            t = n(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
            break;
          case "day":
          case "date":
            t = n(this.year(), this.month(), this.date());
            break;
          case "hour":
            t = this._d.valueOf(), t -= nn(t + (this._isUTC ? 0 : 6e4 * this.utcOffset()), 36e5);
            break;
          case "minute":
            t = this._d.valueOf(), t -= nn(t, 6e4);
            break;
          case "second":
            t = this._d.valueOf(), t -= nn(t, 1e3);
        }
        return this._d.setTime(t), r.updateOffset(this, !0), this;
      }, yn.subtract = Jt, yn.toArray = function () {
        var e = this;
        return [e.year(), e.month(), e.date(), e.hour(), e.minute(), e.second(), e.millisecond()];
      }, yn.toObject = function () {
        var e = this;
        return {
          years: e.year(),
          months: e.month(),
          date: e.date(),
          hours: e.hours(),
          minutes: e.minutes(),
          seconds: e.seconds(),
          milliseconds: e.milliseconds()
        };
      }, yn.toDate = function () {
        return new Date(this.valueOf());
      }, yn.toISOString = function (e) {
        if (!this.isValid()) return null;
        var t = !0 !== e,
          n = t ? this.clone().utc() : this;
        return n.year() < 0 || n.year() > 9999 ? I(n, t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ") : T(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + 60 * this.utcOffset() * 1e3).toISOString().replace("Z", I(n, "Z")) : I(n, t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
      }, yn.inspect = function () {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var e,
          t,
          n,
          a = "moment",
          r = "";
        return this.isLocal() || (a = 0 === this.utcOffset() ? "moment.utc" : "moment.parseZone", r = "Z"), e = "[" + a + '("]', t = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", n = r + '[")]', this.format(e + t + "-MM-DD[T]HH:mm:ss.SSS" + n);
      }, "undefined" != typeof Symbol && null != Symbol.for && (yn[Symbol.for("nodejs.util.inspect.custom")] = function () {
        return "Moment<" + this.format() + ">";
      }), yn.toJSON = function () {
        return this.isValid() ? this.toISOString() : null;
      }, yn.toString = function () {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
      }, yn.unix = function () {
        return Math.floor(this.valueOf() / 1e3);
      }, yn.valueOf = function () {
        return this._d.valueOf() - 6e4 * (this._offset || 0);
      }, yn.creationData = function () {
        return {
          input: this._i,
          format: this._f,
          locale: this._locale,
          isUTC: this._isUTC,
          strict: this._strict
        };
      }, yn.eraName = function () {
        var e,
          t,
          n,
          a = this.localeData().eras();
        for (e = 0, t = a.length; e < t; ++e) {
          if (n = this.clone().startOf("day").valueOf(), a[e].since <= n && n <= a[e].until) return a[e].name;
          if (a[e].until <= n && n <= a[e].since) return a[e].name;
        }
        return "";
      }, yn.eraNarrow = function () {
        var e,
          t,
          n,
          a = this.localeData().eras();
        for (e = 0, t = a.length; e < t; ++e) {
          if (n = this.clone().startOf("day").valueOf(), a[e].since <= n && n <= a[e].until) return a[e].narrow;
          if (a[e].until <= n && n <= a[e].since) return a[e].narrow;
        }
        return "";
      }, yn.eraAbbr = function () {
        var e,
          t,
          n,
          a = this.localeData().eras();
        for (e = 0, t = a.length; e < t; ++e) {
          if (n = this.clone().startOf("day").valueOf(), a[e].since <= n && n <= a[e].until) return a[e].abbr;
          if (a[e].until <= n && n <= a[e].since) return a[e].abbr;
        }
        return "";
      }, yn.eraYear = function () {
        var e,
          t,
          n,
          a,
          i = this.localeData().eras();
        for (e = 0, t = i.length; e < t; ++e) if (n = i[e].since <= i[e].until ? 1 : -1, a = this.clone().startOf("day").valueOf(), i[e].since <= a && a <= i[e].until || i[e].until <= a && a <= i[e].since) return (this.year() - r(i[e].since).year()) * n + i[e].offset;
        return this.year();
      }, yn.year = Pe, yn.isLeapYear = function () {
        return B(this.year());
      }, yn.weekYear = function (e) {
        return dn.call(this, e, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
      }, yn.isoWeekYear = function (e) {
        return dn.call(this, e, this.isoWeek(), this.isoWeekday(), 1, 4);
      }, yn.quarter = yn.quarters = function (e) {
        return null == e ? Math.ceil((this.month() + 1) / 3) : this.month(3 * (e - 1) + this.month() % 3);
      }, yn.month = xe, yn.daysInMonth = function () {
        return be(this.year(), this.month());
      }, yn.week = yn.weeks = function (e) {
        var t = this.localeData().week(this);
        return null == e ? t : this.add(7 * (e - t), "d");
      }, yn.isoWeek = yn.isoWeeks = function (e) {
        var t = ze(this, 1, 4).week;
        return null == e ? t : this.add(7 * (e - t), "d");
      }, yn.weeksInYear = function () {
        var e = this.localeData()._week;
        return Ae(this.year(), e.dow, e.doy);
      }, yn.weeksInWeekYear = function () {
        var e = this.localeData()._week;
        return Ae(this.weekYear(), e.dow, e.doy);
      }, yn.isoWeeksInYear = function () {
        return Ae(this.year(), 1, 4);
      }, yn.isoWeeksInISOWeekYear = function () {
        return Ae(this.isoWeekYear(), 1, 4);
      }, yn.date = cn, yn.day = yn.days = function (e) {
        if (!this.isValid()) return null != e ? this : NaN;
        var t = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        return null != e ? (e = function (e, t) {
          return "string" != typeof e ? e : isNaN(e) ? "number" == typeof (e = t.weekdaysParse(e)) ? e : null : parseInt(e, 10);
        }(e, this.localeData()), this.add(e - t, "d")) : t;
      }, yn.weekday = function (e) {
        if (!this.isValid()) return null != e ? this : NaN;
        var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return null == e ? t : this.add(e - t, "d");
      }, yn.isoWeekday = function (e) {
        if (!this.isValid()) return null != e ? this : NaN;
        if (null != e) {
          var t = function (e, t) {
            return "string" == typeof e ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
          }(e, this.localeData());
          return this.day(this.day() % 7 ? t : t - 7);
        }
        return this.day() || 7;
      }, yn.dayOfYear = function (e) {
        var t = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return null == e ? t : this.add(e - t, "d");
      }, yn.hour = yn.hours = Qe, yn.minute = yn.minutes = mn, yn.second = yn.seconds = _n, yn.millisecond = yn.milliseconds = pn, yn.utcOffset = function (e, t, n) {
        var a,
          i = this._offset || 0;
        if (!this.isValid()) return null != e ? this : NaN;
        if (null != e) {
          if ("string" == typeof e) {
            if (null === (e = Ot(me, e))) return this;
          } else Math.abs(e) < 16 && !n && (e *= 60);
          return !this._isUTC && t && (a = zt(this)), this._offset = e, this._isUTC = !0, null != a && this.add(a, "m"), i !== e && (!t || this._changeInProgress ? Ut(this, Wt(e - i, "m"), 1, !1) : this._changeInProgress || (this._changeInProgress = !0, r.updateOffset(this, !0), this._changeInProgress = null)), this;
        }
        return this._isUTC ? i : zt(this);
      }, yn.utc = function (e) {
        return this.utcOffset(0, e);
      }, yn.local = function (e) {
        return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(zt(this), "m")), this;
      }, yn.parseZone = function () {
        if (null != this._tzm) this.utcOffset(this._tzm, !1, !0);else if ("string" == typeof this._i) {
          var e = Ot(ce, this._i);
          null != e ? this.utcOffset(e) : this.utcOffset(0, !0);
        }
        return this;
      }, yn.hasAlignedHourOffset = function (e) {
        return !!this.isValid() && (e = e ? Dt(e).utcOffset() : 0, (this.utcOffset() - e) % 60 == 0);
      }, yn.isDST = function () {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
      }, yn.isLocal = function () {
        return !!this.isValid() && !this._isUTC;
      }, yn.isUtcOffset = function () {
        return !!this.isValid() && this._isUTC;
      }, yn.isUtc = At, yn.isUTC = At, yn.zoneAbbr = function () {
        return this._isUTC ? "UTC" : "";
      }, yn.zoneName = function () {
        return this._isUTC ? "Coordinated Universal Time" : "";
      }, yn.dates = k("dates accessor is deprecated. Use date instead.", cn), yn.months = k("months accessor is deprecated. Use month instead", xe), yn.years = k("years accessor is deprecated. Use year instead", Pe), yn.zone = k("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", function (e, t) {
        return null != e ? ("string" != typeof e && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
      }), yn.isDSTShifted = k("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", function () {
        if (!d(this._isDSTShifted)) return this._isDSTShifted;
        var e,
          t = {};
        return M(t, this), (t = kt(t))._a ? (e = t._isUTC ? p(t._a) : Dt(t._a), this._isDSTShifted = this.isValid() && function (e, t, n) {
          var a,
            r = Math.min(e.length, t.length),
            i = Math.abs(e.length - t.length),
            o = 0;
          for (a = 0; a < r; a++) (n && e[a] !== t[a] || !n && q(e[a]) !== q(t[a])) && o++;
          return o + i;
        }(t._a, e.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
      });
      var vn = x.prototype;
      function Mn(e, t, n, a) {
        var r = lt(),
          i = p().set(a, t);
        return r[n](i, e);
      }
      function Ln(e, t, n) {
        if (u(e) && (t = e, e = void 0), e = e || "", null != t) return Mn(e, t, n, "month");
        var a,
          r = [];
        for (a = 0; a < 12; a++) r[a] = Mn(e, a, n, "month");
        return r;
      }
      function bn(e, t, n, a) {
        "boolean" == typeof e ? (u(t) && (n = t, t = void 0), t = t || "") : (n = t = e, e = !1, u(t) && (n = t, t = void 0), t = t || "");
        var r,
          i = lt(),
          o = e ? i._week.dow : 0,
          s = [];
        if (null != n) return Mn(t, (n + o) % 7, a, "day");
        for (r = 0; r < 7; r++) s[r] = Mn(t, (r + o) % 7, a, "day");
        return s;
      }
      vn.calendar = function (e, t, n) {
        var a = this._calendar[e] || this._calendar.sameElse;
        return T(a) ? a.call(t, n) : a;
      }, vn.longDateFormat = function (e) {
        var t = this._longDateFormat[e],
          n = this._longDateFormat[e.toUpperCase()];
        return t || !n ? t : (this._longDateFormat[e] = n.match(j).map(function (e) {
          return "MMMM" === e || "MM" === e || "DD" === e || "dddd" === e ? e.slice(1) : e;
        }).join(""), this._longDateFormat[e]);
      }, vn.invalidDate = function () {
        return this._invalidDate;
      }, vn.ordinal = function (e) {
        return this._ordinal.replace("%d", e);
      }, vn.preparse = gn, vn.postformat = gn, vn.relativeTime = function (e, t, n, a) {
        var r = this._relativeTime[n];
        return T(r) ? r(e, t, n, a) : r.replace(/%d/i, e);
      }, vn.pastFuture = function (e, t) {
        var n = this._relativeTime[e > 0 ? "future" : "past"];
        return T(n) ? n(t) : n.replace(/%s/i, t);
      }, vn.set = function (e) {
        var t, n;
        for (n in e) s(e, n) && (T(t = e[n]) ? this[n] = t : this["_" + n] = t);
        this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
      }, vn.eras = function (e, t) {
        var n,
          a,
          i,
          o = this._eras || lt("en")._eras;
        for (n = 0, a = o.length; n < a; ++n) {
          switch (typeof o[n].since) {
            case "string":
              i = r(o[n].since).startOf("day"), o[n].since = i.valueOf();
          }
          switch (typeof o[n].until) {
            case "undefined":
              o[n].until = 1 / 0;
              break;
            case "string":
              i = r(o[n].until).startOf("day").valueOf(), o[n].until = i.valueOf();
          }
        }
        return o;
      }, vn.erasParse = function (e, t, n) {
        var a,
          r,
          i,
          o,
          s,
          l = this.eras();
        for (e = e.toUpperCase(), a = 0, r = l.length; a < r; ++a) if (i = l[a].name.toUpperCase(), o = l[a].abbr.toUpperCase(), s = l[a].narrow.toUpperCase(), n) switch (t) {
          case "N":
          case "NN":
          case "NNN":
            if (o === e) return l[a];
            break;
          case "NNNN":
            if (i === e) return l[a];
            break;
          case "NNNNN":
            if (s === e) return l[a];
        } else if ([i, o, s].indexOf(e) >= 0) return l[a];
      }, vn.erasConvertYear = function (e, t) {
        var n = e.since <= e.until ? 1 : -1;
        return void 0 === t ? r(e.since).year() : r(e.since).year() + (t - e.offset) * n;
      }, vn.erasAbbrRegex = function (e) {
        return s(this, "_erasAbbrRegex") || sn.call(this), e ? this._erasAbbrRegex : this._erasRegex;
      }, vn.erasNameRegex = function (e) {
        return s(this, "_erasNameRegex") || sn.call(this), e ? this._erasNameRegex : this._erasRegex;
      }, vn.erasNarrowRegex = function (e) {
        return s(this, "_erasNarrowRegex") || sn.call(this), e ? this._erasNarrowRegex : this._erasRegex;
      }, vn.months = function (e, t) {
        return e ? i(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || Ye).test(t) ? "format" : "standalone"][e.month()] : i(this._months) ? this._months : this._months.standalone;
      }, vn.monthsShort = function (e, t) {
        return e ? i(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[Ye.test(t) ? "format" : "standalone"][e.month()] : i(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
      }, vn.monthsParse = function (e, t, n) {
        var a, r, i;
        if (this._monthsParseExact) return Te.call(this, e, t, n);
        for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), a = 0; a < 12; a++) {
          if (r = p([2e3, a]), n && !this._longMonthsParse[a] && (this._longMonthsParse[a] = new RegExp("^" + this.months(r, "").replace(".", "") + "$", "i"), this._shortMonthsParse[a] = new RegExp("^" + this.monthsShort(r, "").replace(".", "") + "$", "i")), n || this._monthsParse[a] || (i = "^" + this.months(r, "") + "|^" + this.monthsShort(r, ""), this._monthsParse[a] = new RegExp(i.replace(".", ""), "i")), n && "MMMM" === t && this._longMonthsParse[a].test(e)) return a;
          if (n && "MMM" === t && this._shortMonthsParse[a].test(e)) return a;
          if (!n && this._monthsParse[a].test(e)) return a;
        }
      }, vn.monthsRegex = function (e) {
        return this._monthsParseExact ? (s(this, "_monthsRegex") || Ce.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (s(this, "_monthsRegex") || (this._monthsRegex = Se), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
      }, vn.monthsShortRegex = function (e) {
        return this._monthsParseExact ? (s(this, "_monthsRegex") || Ce.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (s(this, "_monthsShortRegex") || (this._monthsShortRegex = De), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
      }, vn.week = function (e) {
        return ze(e, this._week.dow, this._week.doy).week;
      }, vn.firstDayOfYear = function () {
        return this._week.doy;
      }, vn.firstDayOfWeek = function () {
        return this._week.dow;
      }, vn.weekdays = function (e, t) {
        var n = i(this._weekdays) ? this._weekdays : this._weekdays[e && !0 !== e && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
        return !0 === e ? Fe(n, this._week.dow) : e ? n[e.day()] : n;
      }, vn.weekdaysMin = function (e) {
        return !0 === e ? Fe(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
      }, vn.weekdaysShort = function (e) {
        return !0 === e ? Fe(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
      }, vn.weekdaysParse = function (e, t, n) {
        var a, r, i;
        if (this._weekdaysParseExact) return qe.call(this, e, t, n);
        for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), a = 0; a < 7; a++) {
          if (r = p([2e3, 1]).day(a), n && !this._fullWeekdaysParse[a] && (this._fullWeekdaysParse[a] = new RegExp("^" + this.weekdays(r, "").replace(".", "\\.?") + "$", "i"), this._shortWeekdaysParse[a] = new RegExp("^" + this.weekdaysShort(r, "").replace(".", "\\.?") + "$", "i"), this._minWeekdaysParse[a] = new RegExp("^" + this.weekdaysMin(r, "").replace(".", "\\.?") + "$", "i")), this._weekdaysParse[a] || (i = "^" + this.weekdays(r, "") + "|^" + this.weekdaysShort(r, "") + "|^" + this.weekdaysMin(r, ""), this._weekdaysParse[a] = new RegExp(i.replace(".", ""), "i")), n && "dddd" === t && this._fullWeekdaysParse[a].test(e)) return a;
          if (n && "ddd" === t && this._shortWeekdaysParse[a].test(e)) return a;
          if (n && "dd" === t && this._minWeekdaysParse[a].test(e)) return a;
          if (!n && this._weekdaysParse[a].test(e)) return a;
        }
      }, vn.weekdaysRegex = function (e) {
        return this._weekdaysParseExact ? (s(this, "_weekdaysRegex") || Je.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (s(this, "_weekdaysRegex") || (this._weekdaysRegex = Ke), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
      }, vn.weekdaysShortRegex = function (e) {
        return this._weekdaysParseExact ? (s(this, "_weekdaysRegex") || Je.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (s(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Be), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
      }, vn.weekdaysMinRegex = function (e) {
        return this._weekdaysParseExact ? (s(this, "_weekdaysRegex") || Je.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (s(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Ue), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
      }, vn.isPM = function (e) {
        return "p" === (e + "").toLowerCase().charAt(0);
      }, vn.meridiem = function (e, t, n) {
        return e > 11 ? n ? "pm" : "PM" : n ? "am" : "AM";
      }, ot("en", {
        eras: [{
          since: "0001-01-01",
          until: 1 / 0,
          offset: 1,
          name: "Anno Domini",
          narrow: "AD",
          abbr: "AD"
        }, {
          since: "0000-12-31",
          until: -1 / 0,
          offset: 1,
          name: "Before Christ",
          narrow: "BC",
          abbr: "BC"
        }],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (e) {
          var t = e % 10;
          return e + (1 === q(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th");
        }
      }), r.lang = k("moment.lang is deprecated. Use moment.locale instead.", ot), r.langData = k("moment.langData is deprecated. Use moment.localeData instead.", lt);
      var wn = Math.abs;
      function kn(e, t, n, a) {
        var r = Wt(t, n);
        return e._milliseconds += a * r._milliseconds, e._days += a * r._days, e._months += a * r._months, e._bubble();
      }
      function Yn(e) {
        return e < 0 ? Math.floor(e) : Math.ceil(e);
      }
      function Dn(e) {
        return 4800 * e / 146097;
      }
      function Sn(e) {
        return 146097 * e / 4800;
      }
      function Tn(e) {
        return function () {
          return this.as(e);
        };
      }
      var En = Tn("ms"),
        xn = Tn("s"),
        Cn = Tn("m"),
        jn = Tn("h"),
        Pn = Tn("d"),
        Nn = Tn("w"),
        Hn = Tn("M"),
        On = Tn("Q"),
        In = Tn("y");
      function zn(e) {
        return function () {
          return this.isValid() ? this._data[e] : NaN;
        };
      }
      var An = zn("milliseconds"),
        Fn = zn("seconds"),
        Rn = zn("minutes"),
        Wn = zn("hours"),
        Vn = zn("days"),
        Kn = zn("months"),
        Bn = zn("years"),
        Un = Math.round,
        qn = {
          ss: 44,
          s: 45,
          m: 45,
          h: 22,
          d: 26,
          w: null,
          M: 11
        };
      function Jn(e, t, n, a, r) {
        return r.relativeTime(t || 1, !!n, e, a);
      }
      var Zn = Math.abs;
      function Gn(e) {
        return (e > 0) - (e < 0) || +e;
      }
      function $n() {
        if (!this.isValid()) return this.localeData().invalidDate();
        var e,
          t,
          n,
          a,
          r,
          i,
          o,
          s,
          l = Zn(this._milliseconds) / 1e3,
          d = Zn(this._days),
          u = Zn(this._months),
          c = this.asSeconds();
        return c ? (e = U(l / 60), t = U(e / 60), l %= 60, e %= 60, n = U(u / 12), u %= 12, a = l ? l.toFixed(3).replace(/\.?0+$/, "") : "", r = c < 0 ? "-" : "", i = Gn(this._months) !== Gn(c) ? "-" : "", o = Gn(this._days) !== Gn(c) ? "-" : "", s = Gn(this._milliseconds) !== Gn(c) ? "-" : "", r + "P" + (n ? i + n + "Y" : "") + (u ? i + u + "M" : "") + (d ? o + d + "D" : "") + (t || e || l ? "T" : "") + (t ? s + t + "H" : "") + (e ? s + e + "M" : "") + (l ? s + a + "S" : "")) : "P0D";
      }
      var Xn = Ct.prototype;
      return Xn.isValid = function () {
        return this._isValid;
      }, Xn.abs = function () {
        var e = this._data;
        return this._milliseconds = wn(this._milliseconds), this._days = wn(this._days), this._months = wn(this._months), e.milliseconds = wn(e.milliseconds), e.seconds = wn(e.seconds), e.minutes = wn(e.minutes), e.hours = wn(e.hours), e.months = wn(e.months), e.years = wn(e.years), this;
      }, Xn.add = function (e, t) {
        return kn(this, e, t, 1);
      }, Xn.subtract = function (e, t) {
        return kn(this, e, t, -1);
      }, Xn.as = function (e) {
        if (!this.isValid()) return NaN;
        var t,
          n,
          a = this._milliseconds;
        if ("month" === (e = R(e)) || "quarter" === e || "year" === e) switch (t = this._days + a / 864e5, n = this._months + Dn(t), e) {
          case "month":
            return n;
          case "quarter":
            return n / 3;
          case "year":
            return n / 12;
        } else switch (t = this._days + Math.round(Sn(this._months)), e) {
          case "week":
            return t / 7 + a / 6048e5;
          case "day":
            return t + a / 864e5;
          case "hour":
            return 24 * t + a / 36e5;
          case "minute":
            return 1440 * t + a / 6e4;
          case "second":
            return 86400 * t + a / 1e3;
          case "millisecond":
            return Math.floor(864e5 * t) + a;
          default:
            throw new Error("Unknown unit " + e);
        }
      }, Xn.asMilliseconds = En, Xn.asSeconds = xn, Xn.asMinutes = Cn, Xn.asHours = jn, Xn.asDays = Pn, Xn.asWeeks = Nn, Xn.asMonths = Hn, Xn.asQuarters = On, Xn.asYears = In, Xn.valueOf = function () {
        return this.isValid() ? this._milliseconds + 864e5 * this._days + this._months % 12 * 2592e6 + 31536e6 * q(this._months / 12) : NaN;
      }, Xn._bubble = function () {
        var e,
          t,
          n,
          a,
          r,
          i = this._milliseconds,
          o = this._days,
          s = this._months,
          l = this._data;
        return i >= 0 && o >= 0 && s >= 0 || i <= 0 && o <= 0 && s <= 0 || (i += 864e5 * Yn(Sn(s) + o), o = 0, s = 0), l.milliseconds = i % 1e3, e = U(i / 1e3), l.seconds = e % 60, t = U(e / 60), l.minutes = t % 60, n = U(t / 60), l.hours = n % 24, o += U(n / 24), r = U(Dn(o)), s += r, o -= Yn(Sn(r)), a = U(s / 12), s %= 12, l.days = o, l.months = s, l.years = a, this;
      }, Xn.clone = function () {
        return Wt(this);
      }, Xn.get = function (e) {
        return e = R(e), this.isValid() ? this[e + "s"]() : NaN;
      }, Xn.milliseconds = An, Xn.seconds = Fn, Xn.minutes = Rn, Xn.hours = Wn, Xn.days = Vn, Xn.weeks = function () {
        return U(this.days() / 7);
      }, Xn.months = Kn, Xn.years = Bn, Xn.humanize = function (e, t) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var n,
          a,
          r = !1,
          i = qn;
        return "object" == typeof e && (t = e, e = !1), "boolean" == typeof e && (r = e), "object" == typeof t && (i = Object.assign({}, qn, t), null != t.s && null == t.ss && (i.ss = t.s - 1)), n = this.localeData(), a = function (e, t, n, a) {
          var r = Wt(e).abs(),
            i = Un(r.as("s")),
            o = Un(r.as("m")),
            s = Un(r.as("h")),
            l = Un(r.as("d")),
            d = Un(r.as("M")),
            u = Un(r.as("w")),
            c = Un(r.as("y")),
            m = i <= n.ss && ["s", i] || i < n.s && ["ss", i] || o <= 1 && ["m"] || o < n.m && ["mm", o] || s <= 1 && ["h"] || s < n.h && ["hh", s] || l <= 1 && ["d"] || l < n.d && ["dd", l];
          return null != n.w && (m = m || u <= 1 && ["w"] || u < n.w && ["ww", u]), (m = m || d <= 1 && ["M"] || d < n.M && ["MM", d] || c <= 1 && ["y"] || ["yy", c])[2] = t, m[3] = +e > 0, m[4] = a, Jn.apply(null, m);
        }(this, !r, i, n), r && (a = n.pastFuture(+this, a)), n.postformat(a);
      }, Xn.toISOString = $n, Xn.toString = $n, Xn.toJSON = $n, Xn.locale = Qt, Xn.localeData = tn, Xn.toIsoString = k("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", $n), Xn.lang = en, O("X", 0, 0, "unix"), O("x", 0, 0, "valueOf"), pe("x", ue), pe("X", /[+-]?\d+(\.\d{1,3})?/), ve("X", function (e, t, n) {
        n._d = new Date(1e3 * parseFloat(e));
      }), ve("x", function (e, t, n) {
        n._d = new Date(q(e));
      }),
      //! moment.js
      r.version = "2.29.1", t = Dt, r.fn = yn, r.min = function () {
        var e = [].slice.call(arguments, 0);
        return Et("isBefore", e);
      }, r.max = function () {
        var e = [].slice.call(arguments, 0);
        return Et("isAfter", e);
      }, r.now = function () {
        return Date.now ? Date.now() : +new Date();
      }, r.utc = p, r.unix = function (e) {
        return Dt(1e3 * e);
      }, r.months = function (e, t) {
        return Ln(e, t, "months");
      }, r.isDate = c, r.locale = ot, r.invalid = y, r.duration = Wt, r.isMoment = b, r.weekdays = function (e, t, n) {
        return bn(e, t, n, "weekdays");
      }, r.parseZone = function () {
        return Dt.apply(null, arguments).parseZone();
      }, r.localeData = lt, r.isDuration = jt, r.monthsShort = function (e, t) {
        return Ln(e, t, "monthsShort");
      }, r.weekdaysMin = function (e, t, n) {
        return bn(e, t, n, "weekdaysMin");
      }, r.defineLocale = st, r.updateLocale = function (e, t) {
        if (null != t) {
          var n,
            a,
            r = et;
          null != tt[e] && null != tt[e].parentLocale ? tt[e].set(E(tt[e]._config, t)) : (null != (a = it(e)) && (r = a._config), t = E(r, t), null == a && (t.abbr = e), (n = new x(t)).parentLocale = tt[e], tt[e] = n), ot(e);
        } else null != tt[e] && (null != tt[e].parentLocale ? (tt[e] = tt[e].parentLocale, e === ot() && ot(e)) : null != tt[e] && delete tt[e]);
        return tt[e];
      }, r.locales = function () {
        return Y(tt);
      }, r.weekdaysShort = function (e, t, n) {
        return bn(e, t, n, "weekdaysShort");
      }, r.normalizeUnits = R, r.relativeTimeRounding = function (e) {
        return void 0 === e ? Un : "function" == typeof e && (Un = e, !0);
      }, r.relativeTimeThreshold = function (e, t) {
        return void 0 !== qn[e] && (void 0 === t ? qn[e] : (qn[e] = t, "s" === e && (qn.ss = t - 1), !0));
      }, r.calendarFormat = function (e, t) {
        var n = e.diff(t, "days", !0);
        return n < -6 ? "sameElse" : n < -1 ? "lastWeek" : n < 0 ? "lastDay" : n < 1 ? "sameDay" : n < 2 ? "nextDay" : n < 7 ? "nextWeek" : "sameElse";
      }, r.prototype = yn, r.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
      }, r;
    }();
  }).call(this, n(286)(e));
}, function (e, t) {
  e.exports = require("styled-components");
}, function (e, t) {
  e.exports = require("axios");
}, function (e, t, n) {
  e.exports = n(298)();
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.genarateComponentLevelStyleConfigurations = function (e) {
    var t = {},
      n = Object.keys(e);
    0 !== n.length && n.forEach(function (n, a) {
      var r = e[n],
        i = Object.keys(r);
      if (i.includes("customCSS")) {
        var o = r.customCSS;
        t.customCSS = o.replace(/\r?\n|\r/g, "");
      }
      if (i.includes("cssClass")) {
        var s = r.cssClass;
        t.cssClass = s.replace(/\r?\n|\r/g, " ").replace(/,/g, " ");
      }
      i.forEach(function (e, n) {
        if ("customCSS" !== e && "cssClass" !== e) {
          var a = r[e];
          if ("string" == typeof a) t[e] = a;else Object.keys(a).forEach(function (e, n) {
            "" != a[e] && (t[e] = a[e]);
          });
        }
      });
    });
    return t;
  };
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "ParagraphComponent", function () {
    return m;
  });
  var a,
    r = n(0),
    i = n.n(r),
    o = n(2),
    s = n.n(o),
    l = n(5),
    d = function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    u = function () {
      return (u = Object.assign || function (e) {
        for (var t, n = 1, a = arguments.length; n < a; n++) for (var r in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        return e;
      }).apply(this, arguments);
    },
    c = s.a.div(a || (a = d(["\n    > figure.table {\n        overflow-x: auto !important;\n    }\n\n    > figure.image img {\n        max-width: 100% !important;\n        height: auto !important;\n    }\n\n    ", "\n\n    ", "\n    \n    ", "\n    \n    ", "\n    \n    ", "\n    \n    ", "\n    \n    ", "\n    \n    ", "\n\n    ", "\n"], ["\n    > figure.table {\n        overflow-x: auto !important;\n    }\n\n    > figure.image img {\n        max-width: 100% !important;\n        height: auto !important;\n    }\n\n    ", "\n\n    ", "\n    \n    ", "\n    \n    ", "\n    \n    ", "\n    \n    ", "\n    \n    ", "\n    \n    ", "\n\n    ", "\n"])), function (e) {
      var t, n, a;
      return "color: ".concat(e.textColor ? e.textColor : null === (a = null === (n = null === (t = null == e ? void 0 : e.theme) || void 0 === t ? void 0 : t.properties) || void 0 === n ? void 0 : n.h2[0]) || void 0 === a ? void 0 : a.value, ";");
    }, function (e) {
      var t, n, a;
      return "font-family: ".concat(e.selectedFontFamily ? e.selectedFontFamily : null === (a = null === (n = null === (t = null == e ? void 0 : e.theme) || void 0 === t ? void 0 : t.properties) || void 0 === n ? void 0 : n.h2[0]) || void 0 === a ? void 0 : a.value, "};");
    }, function (e) {
      var t, n, a;
      return "font-size: ".concat(e.selectedFontSize ? e.selectedFontSize : null === (a = null === (n = null === (t = null == e ? void 0 : e.theme) || void 0 === t ? void 0 : t.properties) || void 0 === n ? void 0 : n.h2[1]) || void 0 === a ? void 0 : a.value, "};");
    }, function (e) {
      var t, n, a;
      return "font-style: ".concat(e.selectedFontStyle ? e.selectedFontStyle : null === (a = null === (n = null === (t = null == e ? void 0 : e.theme) || void 0 === t ? void 0 : t.properties) || void 0 === n ? void 0 : n.h2[0]) || void 0 === a ? void 0 : a.value, "};");
    }, function (e) {
      var t, n, a;
      return "text-transform: ".concat(e.selectedTextTransform ? e.selectedTextTransform : null === (a = null === (n = null === (t = null == e ? void 0 : e.theme) || void 0 === t ? void 0 : t.properties) || void 0 === n ? void 0 : n.h2[0]) || void 0 === a ? void 0 : a.value, "};");
    }, function (e) {
      var t, n, a;
      return "text-decoration: ".concat(e.selectedTextDecoration ? e.selectedTextDecoration : null === (a = null === (n = null === (t = null == e ? void 0 : e.theme) || void 0 === t ? void 0 : t.properties) || void 0 === n ? void 0 : n.h2[0]) || void 0 === a ? void 0 : a.value, "};");
    }, function (e) {
      var t, n, a;
      return "text-align: ".concat(e.textAlignment ? e.textAlignment : null === (a = null === (n = null === (t = null == e ? void 0 : e.theme) || void 0 === t ? void 0 : t.properties) || void 0 === n ? void 0 : n.h2[0]) || void 0 === a ? void 0 : a.value, ";");
    }, function (e) {
      var t, n, a;
      return "text-shadow: ".concat(e.selectedTextShadow ? e.selectedTextShadow : null === (a = null === (n = null === (t = null == e ? void 0 : e.theme) || void 0 === t ? void 0 : t.properties) || void 0 === n ? void 0 : n.h2[0]) || void 0 === a ? void 0 : a.value, "};");
    }, function (e) {
      return e.customCSS ? e.customCSS : "";
    }),
    m = function (e) {
      var t = {},
        n = {},
        a = e.data,
        r = a.data,
        o = a.styles;
      return o && (n = Object(l.genarateComponentLevelStyleConfigurations)(o)), void 0 !== r && (t = {
        __html: r.paragraph
      }), i.a.createElement(c, u({}, n, {
        dangerouslySetInnerHTML: t,
        className: (null == n ? void 0 : n.cssClass) ? n.cssClass : ""
      }));
    };
}, function (e, t) {
  e.exports = require("uuid");
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  };
  t.default = function (e) {
    return o.default.createElement("svg", a({
      viewBox: "0 0 14.93 14.93"
    }, e), o.default.createElement("title", null, "pageedit-section-edit"), o.default.createElement("g", {
      "data-name": "Layer 2"
    }, o.default.createElement("g", {
      "data-name": "Layer 1"
    }, o.default.createElement("path", {
      fill: "none",
      d: "M0 0h14.93v14.93H0z"
    }), o.default.createElement("path", {
      d: "M12 2.94A3 3 0 007.8 3L2.13 8.69v4.16h4.11L12 7.07a2.94 2.94 0 000-4.13zm-6 9.2H4L2.83 11V9L7 4.74l3.21 3.07z",
      fill: "#606b8c"
    }))));
  };
  var r,
    i = n(0),
    o = (r = i) && r.__esModule ? r : {
      default: r
    };
}, function (e, t, n) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = n(0),
    r = function () {
      return window._customEventTargetElement || (window._customEventTargetElement = document.createElement("div")), window._customEventTargetElement;
    };
  t.emitCustomEvent = function (e, t) {
    var n = r(),
      a = new CustomEvent(e, {
        detail: t
      });
    n.dispatchEvent(a);
  }, t.useCustomEventListener = function (e, t) {
    a.useEffect(function () {
      var n = r(),
        a = function (e) {
          var n = e.detail;
          t(n);
        };
      return n.addEventListener(e, a, !1), function () {
        n.removeEventListener(e, a, !1);
      };
    });
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: e.width,
      height: e.height,
      viewBox: "0 0 24 24"
    }, i.default.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    }), i.default.createElement("path", {
      d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
    }));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a,
    r,
    i = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      }
      return e;
    },
    o = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    s = (a = ["\n    position: relative;\n    z-index: 20;\n    ", "\n"], r = ["\n    position: relative;\n    z-index: 20;\n    ", "\n"], Object.freeze(Object.defineProperties(a, {
      raw: {
        value: Object.freeze(r)
      }
    })));
  t.BannerComponent = function (e) {
    var t = (0, l.useState)({}),
      n = o(t, 2),
      a = n[0],
      r = n[1],
      s = e.commonConfigs,
      c = e.componentIndex,
      p = e.data,
      h = (p.data, p.styles),
      y = p.settings,
      g = e.lang,
      v = y.banner,
      M = y.interval,
      L = (v.uniqueId, v.value),
      b = (s.isEditMode, s.isPreview),
      w = 5e3;
    M && M.value && (w = 1e3 * M.value);
    function k() {
      return a ? a.title.replace(/[^A-Z0-9]+/gi, "") : "bannerCarousel";
    }
    function Y(e) {
      return e ? e.boundUrl && "" !== e.boundUrl ? b ? d.default.createElement("a", {
        href: e.boundUrl,
        rel: "noreferrer",
        target: "_blank"
      }, D(e.imagePath, e.thumbnail, e.bannerText)) : d.default.createElement(m.OutboundLink, {
        href: e.boundUrl,
        rel: "noreferrer",
        target: "_blank",
        eventLabel: k() + (c ? "-" + c : "")
      }, D(e.imagePath, e.thumbnail, e.bannerText)) : D(e.imagePath, e.thumbnail, e.bannerText) : d.default.createElement(d.default.Fragment, null);
    }
    function D(e, t, n) {
      var a = e.split("/"),
        r = a[a.length - 1];
      if (e && n) {
        var o = {
            styles: {},
            data: {
              paragraph: n
            }
          },
          s = i({}, h, {
            language: g
          });
        return d.default.createElement(d.default.Fragment, null, d.default.createElement("img", {
          style: {
            width: "100%",
            objectFit: "cover",
            height: "100%"
          },
          src: b ? e : "/images/" + r,
          className: "img-responsive",
          alt: "bannerImage"
        }), d.default.createElement("div", {
          className: "container carousel-content"
        }, d.default.createElement(_, s, d.default.createElement(f.ParagraphComponent, {
          data: o
        }))));
      }
      return e ? d.default.createElement("img", {
        style: {
          width: "100%",
          objectFit: "cover",
          height: "100%"
        },
        src: b ? e : "/images/" + r,
        className: "img-responsive",
        alt: "bannerImage"
      }) : d.default.createElement(d.default.Fragment, null);
    }
    return (0, l.useEffect)(function () {
      var t = !1;
      return !t && L && "" !== L && function (t) {
        var n = localStorage.getItem("jwt-token"),
          a = "/api/banner",
          i = {
            id: L,
            nameSpace: e.dbName
          };
        b && (a = "/api/banners/banner", i = {
          id: L,
          dbName: e.dbName
        });
        var o = {
          headers: {
            Authorization: n
          },
          params: i
        };
        u.default.get(a, o).then(function (e) {
          !t && e && e.data && r(e.data);
        }).catch(function (e) {
          console.log(e);
        });
      }(t), function () {
        t = !0;
      };
    }, [L]), a && a.bannerData && g && g.langKey && a.bannerData[g.langKey] ? 1 === a.bannerData[g.langKey].length ? Y(a.bannerData[g.langKey][0]) : d.default.createElement("div", null, d.default.createElement("div", {
      id: k(),
      className: "carousel slide carousel-fade",
      "data-ride": "carousel"
    }, d.default.createElement("ol", {
      className: "carousel-indicators"
    }, a.bannerData[g.langKey].map(function (e, t) {
      var n = "";
      return 0 === t && (n = "active"), d.default.createElement("li", {
        key: "bannerCarouselIndicator" + t,
        "data-target": "#" + k(),
        "data-slide-to": t,
        className: n
      });
    })), d.default.createElement("div", {
      className: "carousel-inner"
    }, a.bannerData[g.langKey].map(function (e, t) {
      var n = "carousel-item";
      return 0 === t && (n = "carousel-item active"), d.default.createElement("div", {
        key: "bannerCarousel" + t,
        className: n,
        "data-interval": w
      }, Y(e));
    })), d.default.createElement("a", {
      className: "carousel-control-prev",
      href: "#" + k(),
      role: "button",
      "data-slide": "prev"
    }, d.default.createElement("span", {
      className: "carousel-control-prev-icon",
      "aria-hidden": "true"
    }), d.default.createElement("span", {
      className: "sr-only"
    }, "Previous")), d.default.createElement("a", {
      className: "carousel-control-next",
      href: "#" + k(),
      role: "button",
      "data-slide": "next"
    }, d.default.createElement("span", {
      className: "carousel-control-next-icon",
      "aria-hidden": "true"
    }), d.default.createElement("span", {
      className: "sr-only"
    }, "Next")))) : d.default.createElement(d.default.Fragment, null);
  };
  var l = n(0),
    d = p(l),
    u = p(n(3)),
    c = (n(278), p(n(2))),
    m = n(279),
    f = n(6);
  function p(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  var _ = c.default.div(s, function (e) {
    if (!(e && e.position && e.position.contentPosition)) return "top: 0%; left: 0%;";
    var t = "left",
      n = "right";
    switch (e.language && "rtl" === e.language.direction && (t = "right", n = "left"), e.position.contentPosition) {
      case "topLeft":
        return "top: 0%; " + t + ": 0%;";
      case "topCenter":
        return "top: 0%; " + t + ": 50%; " + n + ": 50%;";
      case "topRight":
        return "top: 0%; " + n + ": 0%;";
      case "midLeft":
        return "top: 50%; bottom: 50%; " + t + ": 0%;";
      case "midCenter":
        return "top: 50%; bottom: 50%; " + t + ": 50%; " + n + ": 50%;";
      case "midRight":
        return "top: 50%; bottom: 50%; " + n + ": 0%;";
      case "bottomLeft":
        return "bottom: 0%; " + t + ": 0%;";
      case "bottomCenter":
        return "bottom: 0%; " + t + ": 50%; " + n + ": 50%;";
      case "bottomRight":
        return "bottom: 0%; " + n + ": 0%;";
      default:
        return "top: 0%; " + t + ": 0%;";
    }
  });
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  };
  t.default = function (e) {
    return o.default.createElement("svg", a({
      viewBox: "0 0 14.93 14.93"
    }, e), o.default.createElement("title", null, "pageedit-section-settings"), o.default.createElement("g", {
      "data-name": "Layer 2"
    }, o.default.createElement("g", {
      "data-name": "Layer 1"
    }, o.default.createElement("path", {
      fill: "none",
      d: "M0 0h14.93v14.93H0z"
    }), o.default.createElement("path", {
      d: "M12.07 5.9h-.05l-.23-.53c.67-1.54.63-1.58.51-1.69l-.9-.88a.2.2 0 00-.15-.06 5.74 5.74 0 00-1.54.6h-.05l-.55-.22c-.63-1.55-.69-1.55-.85-1.55H7c-.16 0-.23 0-.81 1.55v.06l-.54.22h-.06A8.67 8.67 0 004 2.7a.24.24 0 00-.16.07L3 3.65c-.11.11-.16.16.55 1.66v.05l-.23.53c-1.59.61-1.59.67-1.59.83V8c0 .16 0 .23 1.59.8h.06l.22.53v.05c-.77 1.55-.73 1.62-.6 1.7l.9.88a.23.23 0 00.16.06 5.82 5.82 0 001.53-.6h.06l.55.22v.05c.62 1.55.69 1.55.84 1.55h1.29c.16 0 .22 0 .8-1.55v-.06l.55-.22h.05a9 9 0 001.56.58.28.28 0 00.16-.06l.91-.89c.11-.11.16-.16-.56-1.66v-.05l.2-.53h.05c1.59-.62 1.59-.68 1.59-.84V6.7c.02-.16.02-.23-1.57-.8zm-4.41 4a2.56 2.56 0 112.61-2.55A2.58 2.58 0 017.66 9.9z",
      fill: "#606b8c"
    }))));
  };
  var r,
    i = n(0),
    o = (r = i) && r.__esModule ? r : {
      default: r
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  };
  t.default = function (e) {
    return o.default.createElement("svg", a({
      viewBox: "0 0 14.93 14.93"
    }, e), o.default.createElement("defs", null, o.default.createElement("style", null, ".prefix__cls-2{fill:#606b8c}")), o.default.createElement("title", null, "pageedit-section-delete"), o.default.createElement("g", {
      id: "prefix__Layer_2",
      "data-name": "Layer 2"
    }, o.default.createElement("g", {
      id: "prefix__Layer_1-2",
      "data-name": "Layer 1"
    }, o.default.createElement("path", {
      fill: "none",
      d: "M0 0h14.93v14.93H0z"
    }), o.default.createElement("path", {
      className: "prefix__cls-2",
      d: "M12.15 2.72h-3v-.91a.47.47 0 00-.47-.46H6.3a.47.47 0 00-.47.46v.91H2.78a.47.47 0 00-.47.47V5a.47.47 0 00.47.47h.7v6.67a1.18 1.18 0 001.17 1.18h5.63a1.17 1.17 0 001.17-1.18V5.5h.7a.47.47 0 00.47-.5V3.19a.47.47 0 00-.47-.47zm-5.39-.44h1.41v.44H6.76zm3.75 9.89a.23.23 0 01-.23.24H4.65a.24.24 0 01-.23-.24V5.5h6.09zm1.18-7.61H3.25v-.9h8.44z"
    }), o.default.createElement("path", {
      className: "prefix__cls-2",
      d: "M6.3 6.19a.47.47 0 00-.47.47v4.59a.47.47 0 10.93 0V6.66a.47.47 0 00-.46-.47zM8.64 6.19a.47.47 0 00-.47.47v4.59a.47.47 0 10.94 0V6.66a.47.47 0 00-.47-.47z"
    }))));
  };
  var r,
    i = n(0),
    o = (r = i) && r.__esModule ? r : {
      default: r
    };
}, function (e, t) {
  e.exports = require("react-bootstrap");
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  t.default = function (e, t, n) {
    var a = 0 === e ? e : e + t;
    return "translate3d" + ("(" + ("horizontal" === n ? [a, 0, 0] : [0, a, 0]).join(",") + ")");
  };
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "ImageComponent", function () {
    return m;
  });
  var a,
    r = n(0),
    i = n.n(r),
    o = n(2),
    s = n.n(o),
    l = n(5),
    d = function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    u = function () {
      return (u = Object.assign || function (e) {
        for (var t, n = 1, a = arguments.length; n < a; n++) for (var r in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        return e;
      }).apply(this, arguments);
    },
    c = s.a.div(a || (a = d(["\n    > img {\n        ", "\n    }\n"], ["\n    > img {\n        ", "\n    }\n"])), function (e) {
      if (e.customCSS) return e.customCSS;
    }),
    m = function (e) {
      var t = e.commonConfigs,
        n = {},
        a = e.data,
        r = a.data,
        o = a.styles,
        s = a.settings,
        d = t.isPreview;
      o && (n = Object(l.genarateComponentLevelStyleConfigurations)(o));
      var m = "",
        f = "",
        p = "";
      if (r) {
        var _ = r.image;
        _ && (m = d ? _.filePath : "/images/" + _.fileName, _.thumbnailUri, f = _.description ? _.description : "", p = _.boundUrl ? _.boundUrl : "");
      }
      return 0 !== m.length ? i.a.createElement(c, u({}, n), "" != p && s && s.seprateLink && s.seprateLink.value && i.a.createElement("a", {
        href: p,
        target: "_blank"
      }, i.a.createElement("img", {
        className: "img-fluid ".concat((null == n ? void 0 : n.cssClass) ? n.cssClass : ""),
        style: {
          maxWidth: "100%",
          height: "auto"
        },
        src: m,
        alt: f || "Image"
      })), "" != p && s && (void 0 === s.seprateLink || s.seprateLink && !s.seprateLink.value) && i.a.createElement("a", {
        href: p
      }, i.a.createElement("img", {
        className: "img-fluid ".concat((null == n ? void 0 : n.cssClass) ? n.cssClass : ""),
        style: {
          maxWidth: "100%",
          height: "auto"
        },
        src: m,
        alt: f || "Image"
      })), "" === p && i.a.createElement("img", {
        className: "img-fluid ".concat((null == n ? void 0 : n.cssClass) ? n.cssClass : ""),
        style: {
          maxWidth: "100%",
          height: "auto"
        },
        src: m,
        alt: f || "Image"
      })) : i.a.createElement(i.a.Fragment, null);
    };
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "TitleComponent", function () {
    return m;
  });
  var a,
    r = n(0),
    i = n.n(r),
    o = n(2),
    s = n.n(o),
    l = n(5),
    d = function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    u = function () {
      return (u = Object.assign || function (e) {
        for (var t, n = 1, a = arguments.length; n < a; n++) for (var r in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        return e;
      }).apply(this, arguments);
    },
    c = s.a.h1(a || (a = d(["\n    ", "\n\n    ", "\n    \n    ", "\n    \n    ", "\n    \n    ", "\n    \n    ", "\n    \n    ", "\n    \n    ", "\n\n    ", "\n"], ["\n    ", "\n\n    ", "\n    \n    ", "\n    \n    ", "\n    \n    ", "\n    \n    ", "\n    \n    ", "\n    \n    ", "\n\n    ", "\n"])), function (e) {
      var t, n, a;
      return "color: ".concat(e.textColor ? e.textColor : null === (a = null === (n = null === (t = null == e ? void 0 : e.theme) || void 0 === t ? void 0 : t.properties) || void 0 === n ? void 0 : n.h1[0]) || void 0 === a ? void 0 : a.value, ";");
    }, function (e) {
      var t, n, a;
      return "font-family: ".concat(e.selectedFontFamily ? e.selectedFontFamily : null === (a = null === (n = null === (t = null == e ? void 0 : e.theme) || void 0 === t ? void 0 : t.properties) || void 0 === n ? void 0 : n.h1[0]) || void 0 === a ? void 0 : a.value, "};");
    }, function (e) {
      var t, n, a;
      return "font-size: ".concat(e.selectedFontSize ? e.selectedFontSize : null === (a = null === (n = null === (t = null == e ? void 0 : e.theme) || void 0 === t ? void 0 : t.properties) || void 0 === n ? void 0 : n.h1[1]) || void 0 === a ? void 0 : a.value, "};");
    }, function (e) {
      var t, n, a;
      return "font-style: ".concat(e.selectedFontStyle ? e.selectedFontStyle : null === (a = null === (n = null === (t = null == e ? void 0 : e.theme) || void 0 === t ? void 0 : t.properties) || void 0 === n ? void 0 : n.h1[0]) || void 0 === a ? void 0 : a.value, "};");
    }, function (e) {
      var t, n, a;
      return "text-transform: ".concat(e.selectedTextTransform ? e.selectedTextTransform : null === (a = null === (n = null === (t = null == e ? void 0 : e.theme) || void 0 === t ? void 0 : t.properties) || void 0 === n ? void 0 : n.h1[0]) || void 0 === a ? void 0 : a.value, "};");
    }, function (e) {
      var t, n, a;
      return "text-decoration: ".concat(e.selectedTextDecoration ? e.selectedTextDecoration : null === (a = null === (n = null === (t = null == e ? void 0 : e.theme) || void 0 === t ? void 0 : t.properties) || void 0 === n ? void 0 : n.h1[0]) || void 0 === a ? void 0 : a.value, "};");
    }, function (e) {
      var t, n, a;
      return "text-align: ".concat(e.textAlignment ? e.textAlignment : null === (a = null === (n = null === (t = null == e ? void 0 : e.theme) || void 0 === t ? void 0 : t.properties) || void 0 === n ? void 0 : n.h1[0]) || void 0 === a ? void 0 : a.value, ";");
    }, function (e) {
      var t, n, a;
      return "text-shadow: ".concat(e.selectedTextShadow ? e.selectedTextShadow : null === (a = null === (n = null === (t = null == e ? void 0 : e.theme) || void 0 === t ? void 0 : t.properties) || void 0 === n ? void 0 : n.h1[0]) || void 0 === a ? void 0 : a.value, "};");
    }, function (e) {
      return e.customCSS ? e.customCSS : "";
    }),
    m = function (e) {
      var t = "",
        n = {},
        a = e.data,
        r = a.data,
        o = a.styles;
      return o && (n = Object(l.genarateComponentLevelStyleConfigurations)(o)), void 0 !== r && (t = r.title), i.a.createElement("div", null, i.a.createElement(c, u({}, n, {
        className: (null == n ? void 0 : n.cssClass) ? n.cssClass : ""
      }), t));
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.MainMenuComponent = void 0;
  var a,
    r,
    i = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    o = (a = ["\n    background: #eee;\n    padding: 2rem;\n    color: #4b4c4d;\n    border: none;\n    background-color: white;\n\n    > .row {\n        > .col-md {\n            min-width: 25%;\n            margin-bottom: 1rem;\n            &:nth-child(5),\n            &:nth-child(6),\n            &:nth-child(7),\n            &:nth-child(8),\n            &:nth-child(9),\n            &:nth-child(10) {\n                max-width: 25%;\n            }\n\n            > h6 {\n                font-size: 1.125rem;\n                font-weight: 600;\n                &:after {\n                    width: 1.5rem;\n                    height: 0.2rem;\n                    position: relative;\n                    content: '';\n                    display: block;\n                    background: #c7954a;\n                    z-index: 0;\n                    border-radius: 1px;\n                }\n            }\n\n            > ul {\n                padding-bottom: 0.5rem;\n                > li {\n                    > a {\n                        color: #4b4c4d;\n                    }\n                }\n            }\n\n            &:last-child:not(:only-child):not(:nth-child(5)):not(:nth-child(6)):not(:nth-child(7)):not(:nth-child(8)):not(:nth-child(9)) {\n                margin: -2rem -1rem;\n                padding: 2rem;\n                background: #435058;\n                color: #fff;\n\n                > h6 {\n                    color: #fff;\n                }\n\n                > ul {\n                    > li {\n                        > a {\n                            color: #ffffffa3;\n                        }\n                    }\n                }\n            }\n        }\n    }\n"], r = ["\n    background: #eee;\n    padding: 2rem;\n    color: #4b4c4d;\n    border: none;\n    background-color: white;\n\n    > .row {\n        > .col-md {\n            min-width: 25%;\n            margin-bottom: 1rem;\n            &:nth-child(5),\n            &:nth-child(6),\n            &:nth-child(7),\n            &:nth-child(8),\n            &:nth-child(9),\n            &:nth-child(10) {\n                max-width: 25%;\n            }\n\n            > h6 {\n                font-size: 1.125rem;\n                font-weight: 600;\n                &:after {\n                    width: 1.5rem;\n                    height: 0.2rem;\n                    position: relative;\n                    content: '';\n                    display: block;\n                    background: #c7954a;\n                    z-index: 0;\n                    border-radius: 1px;\n                }\n            }\n\n            > ul {\n                padding-bottom: 0.5rem;\n                > li {\n                    > a {\n                        color: #4b4c4d;\n                    }\n                }\n            }\n\n            &:last-child:not(:only-child):not(:nth-child(5)):not(:nth-child(6)):not(:nth-child(7)):not(:nth-child(8)):not(:nth-child(9)) {\n                margin: -2rem -1rem;\n                padding: 2rem;\n                background: #435058;\n                color: #fff;\n\n                > h6 {\n                    color: #fff;\n                }\n\n                > ul {\n                    > li {\n                        > a {\n                            color: #ffffffa3;\n                        }\n                    }\n                }\n            }\n        }\n    }\n"], Object.freeze(Object.defineProperties(a, {
      raw: {
        value: Object.freeze(r)
      }
    }))),
    s = n(0),
    l = f(s),
    d = f(n(3)),
    u = f(n(2)),
    c = f(n(32)),
    m = n(274);
  function f(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  u.default.li(o), t.MainMenuComponent = function (e) {
    var t = (0, s.useState)(!1),
      n = i(t, 2),
      a = (n[0], n[1]),
      r = (0, s.useState)(null),
      o = i(r, 2),
      u = o[0],
      f = o[1],
      p = (0, s.useState)(null),
      _ = i(p, 2),
      h = (_[0], _[1]),
      y = (0, s.useState)(""),
      g = i(y, 2),
      v = (g[0], g[1]),
      M = (0, s.useState)("#"),
      L = i(M, 2),
      b = L[0],
      w = L[1],
      k = e.commonConfigs,
      Y = (k.isEditMode, k.isPreview),
      D = Y || !1,
      S = new c.default(),
      T = e.lang,
      E = S.get("bk_name") ? S.get("bk_name") : void 0;
    function x() {
      var e = {
        headers: {
          Authorization: localStorage.getItem("jwt-token")
        },
        params: {
          sessionId: localStorage.getItem("sessionId")
        }
      };
      d.default.get("/api/menus", e).then(function (e) {
        console.log("Menu Result on page main menu comp: ", e.data[0]), sessionStorage.setItem("menu", JSON.stringify(e.data[0])), f(e.data[0]);
      }).catch(function (e) {
        console.log(e);
      });
    }
    function C(e) {
      return !D && (null === sessionStorage.getItem("permission") || !sessionStorage.getItem("permission").includes(e.path));
    }
    (0, s.useEffect)(function () {
      var t,
        n,
        r,
        i = !0;
      if (i) if (D) t = localStorage.getItem("jwt-token"), n = localStorage.getItem("sessionId"), r = {
        headers: {
          Authorization: t
        },
        params: {
          dbName: e.dbName,
          websiteName: e.dbName,
          sessionId: n
        }
      }, d.default.get("/api/menus", r).then(function (e) {
        a(!0), f(function (t) {
          return e.data[0];
        }), v(e.data[0]._id);
      }).catch(function (e) {
        a(!1), h(e), console.log(e);
      });else {
        var o = sessionStorage.getItem("menu"),
          s = sessionStorage.getItem("permission");
        null == s || "" === s ? (console.log("Permission not available. Requesting again from Client"), function () {
          var e = localStorage.getItem("jwt-token"),
            t = localStorage.getItem("sessionId"),
            n = {
              headers: {
                Authorization: e
              },
              params: {
                sessionId: t
              }
            };
          d.default.get("/api/getPermissions", n).then(function (e) {
            sessionStorage.setItem("permission", e.data);
          }).catch(function (e) {
            console.log(e);
          }).finally(function () {
            x();
          });
        }()) : null == o || "" === o ? (console.log("Menus not available. Requesting again from Client"), x()) : f(JSON.parse(o));
      }
      return function () {
        i = !1;
      };
    }, []), (0, s.useEffect)(function () {
      var e = !0;
      return e && T && ("en" === T.langKey.toLowerCase() ? w(P("ar")) : "ar" === T.langKey.toLowerCase() && w(P("en"))), function () {
        e = !1;
      };
    }, [T]);
    var j = function (e, t, n, a) {
        var r = n + "-" + a;
        return l.default.createElement(l.default.Fragment, {
          key: "sm-" + r
        }, l.default.createElement("div", {
          className: "col-md"
        }, l.default.createElement("h6", {
          className: "title",
          hidden: C(t)
        }, t.name[T.langKey.toLowerCase()]), null != t.subLinks && t.subLinks.map(function (r, i) {
          return function (e, t, n, a, r, i) {
            var o = t + "-" + n + "-" + a,
              s = "";
            if ("external-link" !== e.menuType) return s = "/" + T.langKey.toLowerCase() + i.path + r.path + e.path + "/", l.default.createElement(l.default.Fragment, {
              key: "sm2-" + o
            }, l.default.createElement("ul", {
              className: "list-unstyled"
            }, l.default.createElement("li", null, l.default.createElement("a", {
              href: s,
              hidden: C(e)
            }, e.name[T.langKey.toLowerCase()]))));
            var d = T.langKey.toLowerCase(),
              u = e.extLinks ? e.extLinks[d] : "";
            return e.extLinks && e.extLinks[d] && !e.extLinks[d].includes("http://") && !e.extLinks[d].includes("https://") && (u = "/" + d + "/" + e.extLinks[d]), s = u, l.default.createElement(l.default.Fragment, {
              key: "sm2-" + o
            }, l.default.createElement("ul", {
              className: "list-unstyled"
            }, l.default.createElement("li", null, l.default.createElement("a", {
              href: s,
              hidden: C(e),
              target: "_blank"
            }, e.name[d]))));
          }(r, n, a, i, t, e);
        })));
      },
      P = function (e) {
        var t = "#";
        if ("undefined" != typeof window) {
          var n = window.location.href,
            a = (window.location.hostname, window.location.pathname);
          window.location.protocol;
          if (t = n, a.length > 0) {
            var r = a.split("/")[1];
            if (["en", "ar"].includes(r)) {
              var i = a.replace(r, e);
              t = n.replace(a, i);
            }
          }
        }
        return t;
      };
    return l.default.createElement(l.default.Fragment, null, l.default.createElement("nav", {
      className: "navbar navbar-expand-lg " + (e.editMode ? "navbar_edit_mode" : "")
    }, l.default.createElement("div", {
      className: "container"
    }, l.default.createElement("a", {
      className: "navbar-brand primary-logo",
      href: (T && T.langKey && T.langKey.toLowerCase().length > 0 ? "/" + T.langKey.toLowerCase() : "/en") + "/",
      "aria-label": "home-page"
    }, l.default.createElement("img", {
      className: "primary-logo",
      src: "/bk-icons/bk-logo.svg",
      alt: ""
    })), l.default.createElement("div", {
      className: "nav-float"
    }, l.default.createElement("div", {
      className: "collapse navbar-collapse",
      id: "mainMenuNavBarToggle"
    }, E && l.default.createElement("span", {
      className: "bk-loggedUser mobile-only  d-md-none"
    }, " ", l.default.createElement(m.LoggedUserComponent, {
      lang: T
    })), l.default.createElement("div", {
      className: "navbar-nav"
    }, null !== u && T && T.langKey && l.default.createElement(l.default.Fragment, {
      key: "M_1"
    }, u.menu.map(function (e, t) {
      return function (e, t) {
        return l.default.createElement(l.default.Fragment, {
          key: "m-" + t
        }, l.default.createElement("div", {
          className: "nav-item dropdown has-megamenu"
        }, l.default.createElement("a", {
          className: "nav-link dropdown-toggle",
          href: "#",
          "data-toggle": "dropdown",
          style: {
            color: "#000000"
          },
          hidden: C(e)
        }, e.name[T.langKey.toLowerCase()]), l.default.createElement("li", {
          className: "mainMenuDropDownStyle dropdown-menu megamenu dropdown-large menu__dropdown",
          onMouseOver: function (e) {
            return e.stopPropagation();
          }
        }, l.default.createElement("div", {
          className: "row"
        }, e.subLinks && e.subLinks.map(function (n, a) {
          return j(e, n, t, a);
        })))));
      }(e, t);
    })))), l.default.createElement("div", {
      className: "otc-logo-container"
    }, l.default.createElement("img", {
      className: "secondary-logo",
      src: "/bk-icons/bk-otc-logo.svg",
      alt: ""
    }))), l.default.createElement("div", {
      className: "header__utility mobile-only d-md-none"
    }, l.default.createElement("div", {
      className: "input-group flex-nowrap"
    }, l.default.createElement("div", {
      className: "btn-group header-lang",
      role: "group",
      "aria-label": "Menu Btn"
    }, T && "en" === T.langKey.toLowerCase() && l.default.createElement("a", {
      className: "lang-button btn bg-transparent btn-sm text-nowrap",
      href: b,
      target: "_self"
    }, l.default.createElement("img", {
      src: "/bk-icons/bk-lang-arabic.svg",
      height: "24",
      alt: "lang"
    })), T && "ar" === T.langKey.toLowerCase() && l.default.createElement("a", {
      className: "lang-button btn bg-transparent btn-sm text-nowrap",
      href: b,
      target: "_self"
    }, l.default.createElement("img", {
      src: "/bk-icons/bk-lang-english.svg",
      height: "24"
    }))), void 0 === E && l.default.createElement("div", {
      className: "btn-group header-signin",
      role: "group",
      "aria-label": "Menu Btn"
    }, T && "en" === T.langKey.toLowerCase() && l.default.createElement(l.default.Fragment, null, l.default.createElement("button", {
      type: "button",
      className: "btn btn-transparent btn-sm text-nowrap",
      onClick: function () {
        location && (location.href = "/en/login");
      }
    }, "Sign In")), T && "ar" === T.langKey.toLowerCase() && l.default.createElement(l.default.Fragment, null, l.default.createElement("button", {
      type: "button",
      className: "btn btn-transparent btn-sm text-nowrap",
      onClick: function () {
        location && (location.href = "/ar/login");
      }
    }, "تسجيل الدخول"))))), l.default.createElement("div", {
      className: "header__utility web-only d-none d-md-block"
    }, l.default.createElement("div", {
      className: "input-group flex-nowrap"
    }, l.default.createElement("div", {
      className: "btn-group header-lang",
      role: "group",
      "aria-label": "Menu Btn"
    }, T && "en" === T.langKey.toLowerCase() && l.default.createElement("a", {
      type: "button",
      className: "btn bg-transparent btn-sm text-nowrap",
      href: b,
      target: "_self"
    }, l.default.createElement("img", {
      src: "/bk-icons/bk-lang-arabic.svg",
      height: "24",
      alt: "lang"
    })), T && "ar" === T.langKey.toLowerCase() && l.default.createElement("a", {
      type: "button",
      className: "btn bg-transparent btn-sm text-nowrap",
      href: b,
      target: "_self"
    }, l.default.createElement("img", {
      src: "/bk-icons/bk-lang-english.svg",
      height: "24"
    }))), E && l.default.createElement("span", {
      className: "bk-loggedUser web-only"
    }, " ", l.default.createElement(m.LoggedUserComponent, {
      lang: T
    })), void 0 === E && l.default.createElement("div", {
      className: "btn-group header-signin",
      role: "group",
      "aria-label": "Menu Btn"
    }, T && "en" === T.langKey.toLowerCase() && l.default.createElement(l.default.Fragment, null, l.default.createElement("button", {
      type: "button",
      className: "btn btn-transparent btn-sm text-nowrap",
      onClick: function () {
        location && (location.href = "/en/login");
      }
    }, "Sign In")), T && "ar" === T.langKey.toLowerCase() && l.default.createElement(l.default.Fragment, null, l.default.createElement("button", {
      type: "button",
      className: "btn btn-transparent btn-sm text-nowrap",
      onClick: function () {
        location && (location.href = "/ar/login");
      }
    }, "تسجيل الدخول"))))), l.default.createElement("button", {
      className: "navbar-toggler navbar-light",
      type: "button",
      "data-toggle": "collapse",
      "data-target": "#mainMenuNavBarToggle",
      "aria-controls": "mainMenuNavBarToggle",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }, l.default.createElement("span", {
      className: "navbar-toggler-icon"
    })))));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.FooterMenuComponent = t.GlobalStyles = void 0;
  var a,
    r,
    i = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    o = (a = ["\n  \n    figure.image {\n        text-align: center;\n    }\n    \n    \n\n"], r = ["\n  \n    figure.image {\n        text-align: center;\n    }\n    \n    \n\n"], Object.freeze(Object.defineProperties(a, {
      raw: {
        value: Object.freeze(r)
      }
    }))),
    s = n(0),
    l = c(s),
    d = c(n(3)),
    u = n(2);
  function c(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  t.GlobalStyles = (0, u.createGlobalStyle)(o), t.FooterMenuComponent = function (e) {
    var t = (0, s.useState)(!1),
      n = i(t, 2),
      a = (n[0], n[1]),
      r = (0, s.useState)([]),
      o = i(r, 2),
      u = o[0],
      c = o[1],
      m = (0, s.useState)(null),
      f = i(m, 2),
      p = (f[0], f[1]),
      _ = (0, s.useState)(""),
      h = i(_, 2),
      y = (h[0], h[1]),
      g = e.lang,
      v = e.commonConfigs,
      M = (v.isEditMode, v.isPreview),
      L = M || !1;
    (0, s.useEffect)(function () {
      var t,
        n,
        r,
        i = !0;
      if (i) if (L) t = localStorage.getItem("jwt-token"), n = localStorage.getItem("sessionId"), r = {
        headers: {
          Authorization: t
        },
        params: {
          dbName: e.dbName,
          websiteName: e.dbName,
          sessionId: n
        }
      }, d.default.get("/api/menus", r).then(function (e) {
        a(!0), c(function (t) {
          return [e.data[1]];
        }), y(e.data[1]._id);
      }).catch(function (e) {
        a(!1), p(e), console.log(e);
      });else {
        var o = sessionStorage.getItem("footer-menu"),
          s = sessionStorage.getItem("permission");
        console.log("menuPermissions"), null == s || "" === s ? (console.log("Permission not available. Requesting again from Client"), function () {
          var e = localStorage.getItem("jwt-token"),
            t = localStorage.getItem("sessionId"),
            n = {
              headers: {
                Authorization: e
              },
              params: {
                sessionId: t
              }
            };
          d.default.get("/api/getPermissions", n).then(function (e) {
            sessionStorage.setItem("permission", e.data);
          }).catch(function (e) {
            console.log(e);
          }).finally(function () {
            k();
          });
        }()) : null == o || "" === o ? (console.log("Menus not available. Requesting again from Client"), k()) : c([JSON.parse(o)]);
      }
      return function () {
        i = !1;
      };
    }, []);
    var b = function (e, t) {
      return l.default.createElement(l.default.Fragment, {
        key: "m-" + t
      }, l.default.createElement("div", {
        className: "col-lg"
      }, l.default.createElement("h6", {
        className: "title",
        hidden: w(e)
      }, l.default.createElement("b", null, e.name[g.langKey.toLowerCase()]), l.default.createElement("hr", null)), l.default.createElement("ul", {
        className: "list-unstyled"
      }, e.subLinks && e.subLinks.map(function (e, n) {
        return function (e, t, n, a) {
          var r = t + "-" + n,
            i = "",
            o = g.langKey.toLowerCase();
          return i = "external-link" !== e.menuType ? "/" + o + "/" + e.path + "/" : e.extLinks[o], l.default.createElement(l.default.Fragment, {
            key: "sm-" + r
          }, l.default.createElement("li", null, l.default.createElement("a", {
            href: i,
            hidden: w(e)
          }, e.name[o])));
        }(e, t, n);
      }))));
    };
    function w(e) {
      return !L && (null === sessionStorage.getItem("permission") || !sessionStorage.getItem("permission").includes(e.path));
    }
    function k() {
      var e = {
        headers: {
          Authorization: localStorage.getItem("jwt-token")
        },
        params: {
          sessionId: localStorage.getItem("sessionId")
        }
      };
      d.default.get("/api/menus", e).then(function (e) {
        console.log("Footer Menu Result on page main menu comp: ", e.data[1]), sessionStorage.setItem("footer-menu", JSON.stringify(e.data[1])), c([e.data[1]]);
      }).catch(function (e) {
        console.log(e);
      });
    }
    return l.default.createElement(l.default.Fragment, null, l.default.createElement("div", {
      className: "footer__container jumbotron jumbotron-fluid " + (e.editMode ? "footer_container_edit_mode" : "")
    }, l.default.createElement("div", {
      className: "container"
    }, g && g.langKey && u.map(function (e, t) {
      return l.default.createElement(l.default.Fragment, {
        key: t
      }, l.default.createElement("div", {
        className: "row"
      }, e.menu.map(function (e, t) {
        return b(e, t);
      })));
    }))));
  };
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "TitleParagraphComponent", function () {
    return i;
  });
  var a = n(0),
    r = n.n(a),
    i = function (e) {
      var t,
        n = e.data.data,
        a = {};
      return void 0 !== n && (t = n.title), void 0 !== n && (a = {
        __html: n.description
      }), r.a.createElement("div", null, r.a.createElement("h4", null, t), r.a.createElement("div", {
        dangerouslySetInnerHTML: a
      }));
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a,
    r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      }
      return e;
    },
    i = n(0),
    o = (a = i) && a.__esModule ? a : {
      default: a
    };
  t.default = function (e) {
    return o.default.createElement("svg", r({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 58.9 58.9"
    }, e), o.default.createElement("title", null, "bk-doc-icon"), o.default.createElement("g", {
      "data-name": "Layer 2"
    }, o.default.createElement("g", {
      "data-name": "Layer 1"
    }, o.default.createElement("path", {
      fill: "none",
      d: "M0 0h58.9v58.9H0z"
    }), o.default.createElement("path", {
      d: "M52.9 14.6v40.3H21.4a8.07 8.07 0 01-8.1-8.1V4.4H43z",
      fill: "#fff"
    }), o.default.createElement("path", {
      d: "M52.9 56.2H21.4a9.56 9.56 0 01-9.5-9.5V4.4A1.43 1.43 0 0113.3 3H43a1.28 1.28 0 011 .4l9.9 10.2a1.8 1.8 0 01.4.9v40.3a1.37 1.37 0 01-1.4 1.4zM14.6 5.7v41a6.81 6.81 0 006.8 6.8h30.2V15.1l-9.2-9.4z",
      fill: "#435058"
    }), o.default.createElement("path", {
      d: "M52.9 16.1H43a1.43 1.43 0 01-1.4-1.4V4.4h2.7v9.1h8.6z",
      fill: "#435058"
    }), o.default.createElement("path", {
      fill: "#185abd",
      d: "M50.4 13.6l-6.3-6.5-.2 6.5h6.5zM8.1 49.9H45a3 3 0 003-3V35.4a3 3 0 00-3-3H8.1a3 3 0 00-3 3v11.4a3.1 3.1 0 003 3.1z"
    }), o.default.createElement("path", {
      d: "M12.75 46.7V35.48h3.61a5.31 5.31 0 012.68.67 4.76 4.76 0 011.85 1.9 5.78 5.78 0 01.68 2.76v.52a5.8 5.8 0 01-.65 2.76A4.77 4.77 0 0119.08 46a5.16 5.16 0 01-2.64.7zm2.7-9.13v7h.95a2.1 2.1 0 001.78-.83 4 4 0 00.63-2.46v-.49a4 4 0 00-.63-2.45 2.13 2.13 0 00-1.82-.82zM32.46 41.32a6.59 6.59 0 01-.61 2.91 4.42 4.42 0 01-1.73 1.94 4.75 4.75 0 01-2.55.69A4.89 4.89 0 0125 46.2a4.53 4.53 0 01-1.73-1.89 6.43 6.43 0 01-.65-2.81v-.63a6.53 6.53 0 01.63-2.87A4.45 4.45 0 0125 36a5.13 5.13 0 015.12 0 4.58 4.58 0 011.73 1.93 6.31 6.31 0 01.63 2.87zm-2.75-.47a4.74 4.74 0 00-.56-2.54 1.78 1.78 0 00-1.6-.87c-1.35 0-2.07 1-2.15 3.06v.82a4.81 4.81 0 00.55 2.54 1.8 1.8 0 001.63.88 1.77 1.77 0 001.58-.87 4.65 4.65 0 00.56-2.5zM42.94 42.9a4.1 4.1 0 01-.63 2.1 3.87 3.87 0 01-1.62 1.39 5.55 5.55 0 01-2.39.5 4.36 4.36 0 01-3.48-1.45 5.93 5.93 0 01-1.28-4.07v-.55a6.72 6.72 0 01.58-2.89A4.35 4.35 0 0135.77 36a4.61 4.61 0 012.5-.68 4.8 4.8 0 013.28 1.08 4.22 4.22 0 011.41 3h-2.69a2.07 2.07 0 00-.52-1.47 2.11 2.11 0 00-1.48-.45 1.63 1.63 0 00-1.48.76 4.93 4.93 0 00-.5 2.41v.8a5.31 5.31 0 00.46 2.55 1.63 1.63 0 001.55.78 2.11 2.11 0 001.43-.44 1.88 1.88 0 00.52-1.4z",
      fill: "#fff"
    }))));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a,
    r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      }
      return e;
    },
    i = n(0),
    o = (a = i) && a.__esModule ? a : {
      default: a
    };
  t.default = function (e) {
    return o.default.createElement("svg", r({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 58.9 58.9"
    }, e), o.default.createElement("title", null, "bk-xls-icon"), o.default.createElement("g", {
      "data-name": "Layer 2"
    }, o.default.createElement("g", {
      "data-name": "Layer 1"
    }, o.default.createElement("path", {
      fill: "none",
      d: "M0 0h58.9v58.9H0z"
    }), o.default.createElement("path", {
      d: "M52.9 14.6v40.3H21.4a8.07 8.07 0 01-8.1-8.1V4.4H43z",
      fill: "#fff"
    }), o.default.createElement("path", {
      d: "M52.9 56.2H21.4a9.56 9.56 0 01-9.5-9.5V4.4A1.43 1.43 0 0113.3 3H43a1.28 1.28 0 011 .4l9.9 10.2a1.8 1.8 0 01.4.9v40.3a1.37 1.37 0 01-1.4 1.4zM14.6 5.7v41a6.81 6.81 0 006.8 6.8h30.2V15.1l-9.2-9.4z",
      fill: "#435058"
    }), o.default.createElement("path", {
      d: "M52.9 16.1H43a1.43 1.43 0 01-1.4-1.4V4.4h2.7v9.1h8.6z",
      fill: "#435058"
    }), o.default.createElement("path", {
      fill: "#178f3c",
      d: "M50.4 13.6l-6.3-6.5-.2 6.5h6.5zM8.1 49.9H45a3 3 0 003-3V35.4a3 3 0 00-3-3H8.1a3 3 0 00-3 3v11.4a3.1 3.1 0 003 3.1z"
    }), o.default.createElement("path", {
      d: "M18.33 39.21l1.84-3.73h3.09L20.12 41l3.23 5.66h-3.13l-1.89-3.8-1.88 3.8h-3.12L16.55 41l-3.14-5.56h3.09zM26.93 44.62h4.71v2.08h-7.42V35.48h2.71zM38.57 43.72a1.11 1.11 0 00-.42-.93 5.09 5.09 0 00-1.47-.68 14.74 14.74 0 01-1.68-.69 3.26 3.26 0 01-2.18-2.94 2.64 2.64 0 01.54-1.65 3.45 3.45 0 011.54-1.11 5.87 5.87 0 012.23-.4 5.4 5.4 0 012.18.43A3.49 3.49 0 0140.75 37a3.27 3.27 0 01.53 1.83h-2.7a1.38 1.38 0 00-.42-1.07 1.65 1.65 0 00-1.16-.39 1.86 1.86 0 00-1.14.31 1 1 0 00-.42.82 1 1 0 00.46.78 5.94 5.94 0 001.63.73 9.46 9.46 0 011.91.8 3.22 3.22 0 011.82 2.89 2.76 2.76 0 01-1.09 2.3 5 5 0 01-3.05.84 6.15 6.15 0 01-2.47-.49A3.76 3.76 0 0133 45a3.47 3.47 0 01-.56-2h2.71a1.72 1.72 0 00.47 1.33 2.16 2.16 0 001.51.43 1.76 1.76 0 001.06-.29.94.94 0 00.38-.75z",
      fill: "#fff"
    }))));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      xmlns: "http://www.w3.org/1999/xlink",
      viewBox: "0 0 100 50",
      width: e.width,
      height: e.height,
      fill: e.fill
    }, i.default.createElement("path", {
      d: "M15,0V50H0V0Z M32,0V50H17V0Z M49,0V50H34V0Z M66,0V50H51V0Z M83,0V50H68V0Z M100,0V50H85V0Z",
      onMouseEnter: e.onMouseEnter,
      onMouseLeave: e.onMouseLeave
    }));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "TabUiComponent", function () {
    return i;
  });
  var a = n(0),
    r = n.n(a);
  function i(e) {
    var t = e.commonConfigs;
    Object(a.useEffect)(function () {
      !function () {
        if (!t.isEditMode && "" != n[0].sectionId) {
          l();
          var e = document.getElementById(n[0].sectionId);
          e && (e.style.display = "block");
        }
      }();
    }, []);
    var n = [{
        caption: "",
        sectionId: ""
      }],
      i = e.data,
      o = i.data,
      s = (i.styles, i.settings);
    function l() {
      if (!t.isEditMode) for (var e = 0; e < n.length; e++) if (n[e] && n[e].sectionId && "" != n[e].sectionId) {
        var a = document.getElementById(n[e].sectionId);
        a && (a.style.display = "none");
      }
    }
    function d(e) {
      l();
      var t = document.getElementById(e);
      t && ("none" === t.style.display ? t.style.display = "block" : t.style.display = "none");
    }
    o.tab && Array.isArray(o.tab) && o.tab.length > 0 && (n = o.tab);
    var u = function (e, t) {
      return "".concat(t.caption, "-").concat(e);
    };
    return r.a.createElement(r.a.Fragment, null, !(s && s.tab && "vertical" === s.tab.value) && r.a.createElement("ul", {
      className: "nav nav-tabs",
      id: "myTab",
      role: "tablist"
    }, n.map(function (e, t) {
      if (e && "" != e.sectionId) {
        var n = 0 === t ? " active" : "";
        return r.a.createElement("li", {
          key: u(t, e),
          className: "nav-item",
          role: "presentation"
        }, r.a.createElement("a", {
          className: "nav-link " + n,
          id: e.sectionId + "-tab",
          "data-toggle": "tab",
          href: "#" + e.sectionId,
          role: "tab",
          "aria-controls": e.sectionId,
          "aria-selected": "true",
          onClick: function () {
            d(e.sectionId);
          }
        }, e.caption));
      }
      return null;
    })), s && s.tab && "vertical" === s.tab.value && r.a.createElement("ul", {
      className: "nav flex-column nav-pills",
      id: "v-pills-tab",
      role: "tablist",
      "aria-orientation": "vertical"
    }, n.map(function (e, t) {
      if (e && "" != e.sectionId) {
        var n = 0 === t ? " active" : "";
        return r.a.createElement("li", {
          key: u(t, e),
          className: "nav-item",
          role: "presentation"
        }, r.a.createElement("a", {
          className: "nav-link " + n,
          id: e.sectionId + "-pill",
          "data-toggle": "pill",
          href: "#" + e.sectionId,
          role: "tab",
          "aria-controls": e.sectionId,
          "aria-selected": "true",
          onClick: function () {
            d(e.sectionId);
          }
        }, e.caption));
      }
      return null;
    })));
  }
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.CMSTableComponent = void 0;
  var a,
    r = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    i = n(0),
    o = (a = i) && a.__esModule ? a : {
      default: a
    },
    s = n(280),
    l = n(5);
  t.CMSTableComponent = function (e) {
    var t = void 0,
      n = void 0,
      a = e.dbName,
      d = e.componentIndex,
      u = e.commonConfigs,
      c = e.data,
      m = c.data,
      f = c.styles,
      p = c.settings,
      _ = e.lang,
      h = (u.isEditMode, u.isPreview);
    p && (t = p.collection, n = p.uiConfigs), f && (0, l.genarateComponentLevelStyleConfigurations)(f), null == m && m.title;
    var y = (0, i.useState)(L()),
      g = r(y, 2),
      v = g[0],
      M = g[1];
    function L() {
      var r = {};
      if (null != t && null != n) {
        var i = n.columns;
        r = {
          menuName: t.value.menuName,
          showColumnTitle: !0,
          collectionType: t.value.collectionType,
          baseUrl: p.collection.externalParams.BaseUrl,
          httpRequest: {
            dataSource: t.externalParams.dataSourceUrl,
            header: {
              headers: {},
              params: {
                nameSpace: e.dbName,
                collectionName: t.value.customeCollectionName,
                searchQuery: JSON.stringify({
                  active: !0
                })
              }
            }
          },
          dbName: a,
          columns: i,
          languageKey: _.langKey
        };
      }
      return r;
    }
    return (0, i.useEffect)(function () {
      var e = !0;
      return e && M(L()), function () {
        return e = !1;
      };
    }, [p]), o.default.createElement("div", null, o.default.createElement(s.TableUiComponent, {
      componentSettings: v,
      isPreview: h,
      componentIndex: d
    }));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
  t.default = function (e) {
    return i.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      x: "0",
      y: "0",
      enableBackground: "new 0 0 58.9 58.9",
      version: "1.1",
      viewBox: "0 0 56 56",
      xmlSpace: "preserve",
      height: e.height,
      width: e.width
    }, i.default.createElement("path", {
      fill: "#FFF",
      d: "M52.9 14.6v40.3H21.4c-4.5 0-8.1-3.6-8.1-8.1V4.4H43l9.9 10.2z",
      className: "st0"
    }), i.default.createElement("path", {
      fill: "#435058",
      d: "M52.9 56.2H21.4c-5.2 0-9.5-4.3-9.5-9.5V4.4c0-.7.6-1.4 1.4-1.4H43c.4 0 .7.1 1 .4l9.9 10.2c.2.3.4.6.4.9v40.3c0 .8-.6 1.4-1.4 1.4zM14.6 5.7v41c0 3.7 3 6.8 6.8 6.8h30.2V15.1l-9.2-9.4H14.6z",
      className: "st1"
    }), i.default.createElement("path", {
      fill: "#435058",
      d: "M52.9 16.1H43c-.7 0-1.4-.6-1.4-1.4V4.4h2.7v9.1h8.6v2.6z",
      className: "st1"
    }), i.default.createElement("path", {
      fill: "#C8964B",
      d: "M50.4 13.6L44.1 7.1 43.9 13.6z",
      className: "st2"
    }), i.default.createElement("path", {
      fill: "#C8964B",
      d: "M8.1 49.9H45c1.7 0 3-1.3 3-3V35.4c0-1.7-1.3-3-3-3H8.1c-1.7 0-3 1.3-3 3v11.4c0 1.7 1.4 3.1 3 3.1z",
      className: "st2"
    }), i.default.createElement("g", null, i.default.createElement("path", {
      fill: "#FFF",
      d: "M11.9 35.8c.2-.1 2.4-.2 3.4-.2 3.4 0 4.5 1.6 4.5 3.6 0 3.5-2.7 4.1-3.9 4.1-.3 0-1.2-.1-1.2-.2v4.1h-2.8V35.8zm3.8 5.3c.5 0 1.2-.4 1.2-1.7 0-1.3-.6-1.6-1.2-1.6h-.1c-.4 0-.8.1-.9.1v3c.4.2.8.2 1 .2zM21.9 35.8c.2-.1 2-.2 3.3-.2 4 0 6.2 2.4 6.2 5.8 0 3.8-2.1 6.1-6.5 6.1-.4 0-2.2-.1-3-.2V35.8zm2.8 9.4c.2 0 .4.1.6.1 2 0 3.2-1.2 3.2-3.8 0-2.5-1.4-3.7-3.2-3.7-.2 0-.4 0-.6.1v7.3zM33.4 35.8h7.8V38h-5v2.3h4.2v2.2h-4.2v4.8h-2.8V35.8z",
      className: "st0"
    })));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
  t.default = function (e) {
    var t = "",
      n = e.commonConfigs,
      a = (e.dbName, e.data),
      r = a.data,
      o = (a.styles, a.settings, e.lang);
    if (n.isEditMode, n.isPreview, void 0 !== r && (t = r.card), o && t) {
      var s = t,
        l = (s.header, s.footer, s.title),
        d = (s.subTitle, s.text),
        u = s.image,
        c = s.link;
      return i.default.createElement(i.default.Fragment, null, i.default.createElement("div", {
        className: "card"
      }, i.default.createElement("a", {
        href: c || "#",
        rel: "noreferrer",
        target: "_blank"
      }, u && i.default.createElement("img", {
        className: "card-img-bottom",
        src: u,
        alt: "Card image cap"
      }), i.default.createElement("div", {
        className: "card-body"
      }, l && i.default.createElement("h5", {
        className: "card-title"
      }, l), i.default.createElement("div", {
        className: "card-content"
      }, d && i.default.createElement("p", {
        className: "card-text"
      }, d))))));
    }
    return i.default.createElement(i.default.Fragment, null);
  };
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "LinkListUiComponent", function () {
    return o;
  });
  var a = n(0),
    r = n.n(a),
    i = n(7);
  function o(e) {
    e.commonConfigs;
    var t = Object(a.useState)(""),
      n = t[0],
      o = t[1],
      s = "";
    "undefined" != typeof window && (s = window.location.href), Object(a.useEffect)(function () {
      o(Object(i.v1)());
    }, []);
    var l = [{
        caption: "",
        link: ""
      }],
      d = e.data,
      u = d.data,
      c = (d.styles, d.settings);
    return u.linkList && (l = u.linkList), r.a.createElement(r.a.Fragment, null, c && c.linkList && "horizontal" === c.linkList.value && r.a.createElement("ul", {
      className: "nav nav-tabs",
      id: "myTab",
      role: "tablist"
    }, l.map(function (e, t) {
      var a,
        i,
        o = null == s ? void 0 : s.split("/"),
        l = o[o.length - 1],
        d = (i = c && c.useUrlHash && c.useUrlHash.value && (a = null == l ? void 0 : l.split("#"))[1] ? e.link + "#" + a[1] : e.link) && i.indexOf(l) > 0 ? " active" : "";
      return r.a.createElement("li", {
        className: "nav-item",
        role: "presentation",
        key: n + "-" + t
      }, r.a.createElement("a", {
        className: "nav-link " + d,
        id: e.link + "-pill",
        href: i
      }, e.caption));
    })), !(c && c.linkList && "horizontal" === c.linkList.value) && r.a.createElement("ul", {
      className: "nav flex-column nav-pills",
      id: "v-pills-tab",
      role: "tablist",
      "aria-orientation": "vertical"
    }, l.map(function (e, t) {
      var a,
        i,
        o = null == s ? void 0 : s.split("/"),
        l = o[o.length - 1],
        d = (i = c && c.useUrlHash && c.useUrlHash.value && (a = null == l ? void 0 : l.split("#"))[1] ? e.link + "#" + a[1] : e.link) && i.indexOf(l) > 0 ? " active" : "";
      return r.a.createElement("li", {
        className: "nav-item",
        role: "presentation",
        key: n + "-" + t
      }, r.a.createElement("a", {
        className: "nav-link " + d,
        id: e.link + "-pill",
        href: i
      }, e.caption));
    })));
  }
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.FormComponent = void 0;
  var a,
    r,
    i = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      }
      return e;
    },
    o = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    s = (a = ["\n    ", "\n"], r = ["\n    ", "\n"], Object.freeze(Object.defineProperties(a, {
      raw: {
        value: Object.freeze(r)
      }
    }))),
    l = n(0),
    d = p(l),
    u = p(n(3)),
    c = p(n(2)),
    m = p(n(291)),
    f = n(292);
  function p(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  function _(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  var h = c.default.div(s, function (e) {}),
    y = c.default.div(s, function (e) {}),
    g = function (e) {
      var t = e.section,
        n = e.dbName,
        a = e.commonConfigs,
        r = e.disableSubmitButton,
        i = e.validationErrors,
        o = e.recaptchaSiteKey,
        s = e.recaptchaRef,
        l = e.formData;
      function u(t) {
        e.handleValueChanges(t);
      }
      if (t && e.selectedLanguage) {
        var c = t.columns,
          m = t.sectionStyles;
        return d.default.createElement(h, {
          className: m && m.classes || ""
        }, c && c.map(function (t, c) {
          var m = t.columnId,
            p = t.compType,
            _ = t.label,
            h = t.placeholder,
            g = t.columnStyles,
            v = t.activeStatus,
            M = t.mappingField,
            L = t.settings,
            b = t.uiProperties,
            w = t.description,
            k = f.formComponentsMapping[p],
            Y = i && i.find(function (e) {
              return e.field == M;
            });
          return v && _ && k ? d.default.createElement(y, {
            className: g && g.classes || "",
            key: "form-component-form-group-" + m
          }, d.default.createElement(k, {
            id: M,
            value: l ? l[M] : void 0,
            label: _[e.selectedLanguage.langKey] || "",
            placeholder: h ? h[e.selectedLanguage.langKey] : "",
            settings: L && L.validations || void 0,
            uiProperties: b,
            disableSubmitButton: r,
            dbName: n,
            recaptchaSiteKey: o,
            validationErrors: Y,
            commonConfigs: a,
            recaptchaRef: s,
            selectedLanguage: e.selectedLanguage,
            description: w && w[e.selectedLanguage.langKey] || "",
            handleValueChanges: u,
            handleRichTextValueChanges: e.handleRichTextValueChanges,
            handleFileUpload: e.handleFileUpload,
            handleDatePickerValueChanges: e.handleDatePickerValueChanges,
            resetForm: e.resetForm,
            handleNumberCmpValueChanges: e.handleNumberCmpValueChanges,
            handleGoogleRecaptchaValueChanges: e.handleGoogleRecaptchaValueChanges,
            handleCheckBoxCmpValueChanges: e.handleCheckBoxCmpValueChanges,
            handleRadioButtonValueChanges: e.handleRadioButtonValueChanges
          })) : null;
        }));
      }
      return null;
    };
  t.FormComponent = d.default.memo(function (e) {
    var t = e.commonConfigs,
      n = e.data,
      a = e.dbName,
      r = e.lang,
      s = (0, l.useState)(e.selectedForm),
      c = o(s, 2),
      p = c[0],
      h = c[1],
      y = (0, l.useState)(void 0),
      v = o(y, 2),
      M = v[0],
      L = v[1],
      b = (0, l.useState)(void 0),
      w = o(b, 2),
      k = w[0],
      Y = w[1],
      D = (0, l.useState)(!1),
      S = o(D, 2),
      T = S[0],
      E = S[1],
      x = (0, l.useState)(void 0),
      C = o(x, 2),
      j = C[0],
      P = C[1],
      N = (0, l.useState)(void 0),
      H = o(N, 2),
      O = H[0],
      I = H[1],
      z = (0, l.useState)(!1),
      A = o(z, 2),
      F = A[0],
      R = A[1],
      W = (0, l.useState)(""),
      V = o(W, 2),
      K = V[0],
      B = V[1],
      U = (0, l.useState)(""),
      q = o(U, 2),
      J = q[0],
      Z = q[1],
      G = (0, l.useRef)();
    if ((0, l.useEffect)(function () {
      var r = !0;
      return r && (e.selectedForm || p || function () {
        if (n) {
          var e = n.settings;
          if (e && e.collection && e.collection.value) {
            var r = {
              headers: {},
              params: {
                collectionName: "forms",
                searchId: e.collection.value
              }
            };
            t ? t.isPreview ? r.params.dbName = a : r.params.nameSpace = a : r.params.dbName = a, u.default.get("/api/cms/getSingleDocumentById", r).then(function (e) {
              var t = e.data;
              200 === e.status && t && h(t);
            }).catch(function (e) {
              console.log(e);
            });
          }
        }
      }(), "" === J && t && (t.isPreview || u.default.get("/api/site/getValidationKey", {}).then(function (e) {
        var t = e.data;
        200 === e.status && t && "success" === t.status && t.key && Z(t.key);
      }).catch(function (e) {
        console.log(e);
      }))), function () {
        r = !1;
      };
    }, []), (0, l.useEffect)(function () {
      var e = !0;
      return e && function () {
        if (p && r) {
          var e = p.sections;
          if (e.length > 0) {
            var t = {},
              n = e[0].columns,
              a = !0,
              o = !1,
              s = void 0;
            try {
              for (var l, d = n[Symbol.iterator](); !(a = (l = d.next()).done); a = !0) {
                var u = l.value,
                  c = {},
                  m = u.mappingField,
                  h = u.compType,
                  y = u.settings,
                  g = u.label,
                  v = u.activeStatus;
                if (m && h && y && v) {
                  var M = y.validations;
                  if (M) {
                    var L = M.required,
                      b = M.min,
                      w = M.max;
                    f.formComponentsDataTypeMappings[h] && "string" === f.formComponentsDataTypeMappings[h] && ("numbers" === h ? (t = i({}, t, _({}, m, {
                      type: "string",
                      pattern: /^[0-9]*$/gm
                    })), c = i({}, c, {
                      stringPattern: "Invalid character found. The " + g[r.langKey] + " field can contain only numbers"
                    })) : (t = i({}, t, _({}, m, {
                      type: "string",
                      pattern: /^[A-Za-z0-9\.\ \-\_\/\?\,\'"]*$/gm
                    })), c = i({}, c, {
                      stringPattern: "Invalid character found. The " + g[r.langKey] + " field can't contain any of the following characters. <>\\:;*+()[]{}!@#$%&=~`^"
                    })), L ? c = i({}, c, {
                      string: "The " + g[r.langKey] + " field is required."
                    }) : t = i({}, t, _({}, m, i({}, t[m], {
                      optional: !0
                    }))), b && "0" !== b && (t = i({}, t, _({}, m, i({}, t[m], {
                      min: parseInt(b)
                    }))), c = i({}, c, {
                      stringMin: "The " + g[r.langKey] + " field length must be greater than or equal to " + b + " characters long."
                    })), w && "0" !== w && (t = i({}, t, _({}, m, i({}, t[m], {
                      max: parseInt(w)
                    }))), c = i({}, c, {
                      stringMax: "The " + g[r.langKey] + " field length must be less than or equal to " + w + " characters long."
                    })), t = i({}, t, _({}, m, i({}, t[m], {
                      messages: c
                    })))), f.formComponentsDataTypeMappings[h] && "number" === f.formComponentsDataTypeMappings[h] && (t = i({}, t, _({}, m, {
                      type: "number",
                      optional: !L && L
                    })), L && (c = i({}, c, {
                      number: "The " + g[r.langKey] + " field is required."
                    })), b && "0" !== b && (t = i({}, t, _({}, m, i({}, t[m], {
                      min: parseInt(b)
                    }))), c = i({}, c, {
                      numberMin: "The " + g[r.langKey] + " field must be greater than or equal to " + b + "."
                    })), w && "0" !== w && (t = i({}, t, _({}, m, i({}, t[m], {
                      max: parseInt(w)
                    }))), c = i({}, c, {
                      numberMax: "The " + g[r.langKey] + " field must be less than or equal to " + w + "."
                    })), t = i({}, t, _({}, m, i({}, t[m], {
                      messages: c
                    })))), f.formComponentsDataTypeMappings[h] && "email" === f.formComponentsDataTypeMappings[h] && (t = i({}, t, _({}, m, {
                      type: "email",
                      optional: !L && L
                    })), c = i({}, c, {
                      email: "The " + g[r.langKey] + " field must be a valid e mail."
                    }), L && (c = i({}, c, {
                      emailEmpty: "The " + g[r.langKey] + " field is required."
                    })), b && "0" !== b && (t = i({}, t, _({}, m, i({}, t[m], {
                      min: parseInt(b)
                    }))), c = i({}, c, {
                      emailMin: "The " + g[r.langKey] + " field must be greater than or equal to " + b + "."
                    })), w && "0" !== w && (t = i({}, t, _({}, m, i({}, t[m], {
                      max: parseInt(w)
                    }))), c = i({}, c, {
                      emailMax: "The " + g[r.langKey] + " field must be less than or equal to " + w + "."
                    })), t = i({}, t, _({}, m, i({}, t[m], {
                      messages: c
                    })))), f.formComponentsDataTypeMappings[h] && "object" === f.formComponentsDataTypeMappings[h] && (t = i({}, t, _({}, m, {
                      type: "object",
                      optional: !L && L
                    })), L && (c = i({}, c, {
                      object: "The " + g[r.langKey] + " field is required."
                    })), t = i({}, t, _({}, m, i({}, t[m], {
                      messages: c
                    })))), f.formComponentsDataTypeMappings[h] && "date" === f.formComponentsDataTypeMappings[h] && (t = i({}, t, _({}, m, {
                      type: "date",
                      optional: !L && L
                    })), L && (c = i({}, c, {
                      date: "The " + g[r.langKey] + " field is required."
                    })), t = i({}, t, _({}, m, i({}, t[m], {
                      messages: c
                    }))));
                  }
                }
              }
            } catch (e) {
              o = !0, s = e;
            } finally {
              try {
                !a && d.return && d.return();
              } finally {
                if (o) throw s;
              }
            }
            P(t);
          }
        }
      }(), function () {
        e = !1;
      };
    }, [p]), (0, l.useEffect)(function () {
      var t = !0;
      return t && e.selectedForm && h(e.selectedForm), function () {
        t = !1;
      };
    }, [e.selectedForm]), p && r) {
      var $ = p.sections;
      return $.length > 0 ? d.default.createElement(d.default.Fragment, null, function () {
        if (k) {
          var e = "alert-danger";
          return "success" === k.responseCode && (e = "alert-success"), d.default.createElement("div", {
            className: "row"
          }, d.default.createElement("div", {
            className: "col-md-12"
          }, d.default.createElement("div", {
            className: "alert " + e + " alert-dismissible fade show mt-2",
            role: "alert"
          }, d.default.createElement("strong", null, k.status), " ", k.msg, d.default.createElement("button", {
            type: "button",
            className: "close",
            "data-dismiss": "alert",
            "aria-label": "Close"
          }, d.default.createElement("span", {
            "aria-hidden": "true"
          }, "×")))));
        }
        return d.default.createElement(d.default.Fragment, null);
      }(), d.default.createElement("form", {
        onSubmit: function (e) {
          if (e.preventDefault(), F && "" != K) {
            if (t && M && p && r) {
              var n = new m.default().compile(j)(M);
              if (!0 === n) {
                E(!0);
                var i = p._id,
                  o = p.customCollection,
                  s = (p.title, {
                    fieldData: _({}, r.langKey, M),
                    active: !0,
                    language: r,
                    formId: i.toString()
                  });
                u.default.post("/api/customCollections/add-record", {
                  nameSpace: a,
                  collectionName: o + "-drafts",
                  data: s,
                  token: K
                }, {}).then(function (e) {
                  var t = e.status,
                    n = e.data;
                  if (E(!1), 200 === t && n) {
                    var a = n.responseCode;
                    a ? ("success" === a && (L(void 0), I(void 0), R(!1), G && G.current && G.current.reset && G.current.reset()), Y(n)) : Y({
                      responseCode: "fail",
                      status: "Failed",
                      msg: "Failed to add record"
                    }), setTimeout(function () {
                      Y(void 0);
                    }, 3e3);
                  }
                }).catch(function (e) {
                  console.log("error", e);
                });
              } else I(n);
            }
          } else Y({
            responseCode: "fail",
            status: "Failed",
            msg: "Recaptcha validation failed"
          }), setTimeout(function () {
            Y(void 0);
          }, 3e3);
        }
      }, d.default.createElement(g, {
        formData: M,
        section: $[0],
        commonConfigs: t,
        selectedLanguage: r,
        disableSubmitButton: T,
        dbName: a,
        recaptchaSiteKey: J,
        validationErrors: O,
        recaptchaRef: G,
        handleValueChanges: function (e) {
          if (t) {
            var n = e.target.name,
              a = e.target.value;
            L(i({}, M, _({}, n, a)));
          }
        },
        handleRichTextValueChanges: function (e, n) {
          if (t) {
            var a = e.getData();
            L(i({}, M, _({}, n, a)));
          }
        },
        handleFileUpload: function (e, n) {
          if (t) {
            var a = e.filename;
            a ? L(i({}, M, _({}, n, a))) : (L(void 0), I(void 0), R(!1));
          }
        },
        handleDatePickerValueChanges: function (e, n) {
          t && (null === e ? L(i({}, M, _({}, n, void 0))) : e instanceof Date ? L(i({}, M, _({}, n, e))) : L(i({}, M, _({}, n, new Date(e)))));
        },
        resetForm: function () {
          L(void 0), I(void 0), R(!1), G && G.current && G.current.reset && G.current.reset();
        },
        setValidationSchemas: P,
        handleNumberCmpValueChanges: function (e) {
          if (t) {
            var n = e.target.name,
              a = parseInt(e.target.value);
            L(i({}, M, _({}, n, a)));
          }
        },
        handleGoogleRecaptchaValueChanges: function (e, n) {
          t && (R(!0), B(e));
        },
        handleCheckBoxCmpValueChanges: function (e, t) {
          L(i({}, M, _({}, t, e)));
        },
        handleRadioButtonValueChanges: function (e, t) {
          L(i({}, M, _({}, t, e)));
        }
      }))) : null;
    }
    return null;
  });
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    r = w([""], [""]),
    i = w(["\n    margin: 0;\n    padding: 0;\n    list-style: none;\n"], ["\n    margin: 0;\n    padding: 0;\n    list-style: none;\n"]),
    o = w(["\n    border-bottom: 1px solid rgb(75, 75, 75);\n"], ["\n    border-bottom: 1px solid rgb(75, 75, 75);\n"]),
    s = w(["\n    max-width: 100%;\n    height: auto;\n"], ["\n    max-width: 100%;\n    height: auto;\n"]),
    l = w(["\n    color: #0955b4;\n    font-family: Roboto, sans-serif;\n    font-size: 26px;\n    font-weight: 600;\n"], ["\n    color: #0955b4;\n    font-family: Roboto, sans-serif;\n    font-size: 26px;\n    font-weight: 600;\n"]),
    d = w(["\n    background-color: #b5bdc4;\n    color: rgb(0, 0, 0);\n    font-family: Roboto, sans-serif;\n    font-size: 14px;\n    width: auto;\n    display: table;\n    padding: 0px 6px;\n"], ["\n    background-color: #b5bdc4;\n    color: rgb(0, 0, 0);\n    font-family: Roboto, sans-serif;\n    font-size: 14px;\n    width: auto;\n    display: table;\n    padding: 0px 6px;\n"]),
    u = w(["\n    color: #2d3943;\n    font-family: Roboto, sans-serif !important;\n    font-size: 14px;\n"], ["\n    color: #2d3943;\n    font-family: Roboto, sans-serif !important;\n    font-size: 14px;\n"]),
    c = w(["\n    color: #b5bdc4;\n    font-family: Roboto, sans-serif !important;\n    font-size: 14px;\n"], ["\n    color: #b5bdc4;\n    font-family: Roboto, sans-serif !important;\n    font-size: 14px;\n"]),
    m = w(["\n    position: relative;\n    &:after {\n        content: '';\n        display: block;\n        background: linear-gradient(360deg, rgba(1, 98, 139, 0.77) 0%, rgba(0, 0, 0, 0) 100%);\n        width: 100%;\n        height: 100%;\n        top: 0;\n        left: 0;\n        margin: 1re;\n        position: absolute;\n    }\n"], ["\n    position: relative;\n    &:after {\n        content: '';\n        display: block;\n        background: linear-gradient(360deg, rgba(1, 98, 139, 0.77) 0%, rgba(0, 0, 0, 0) 100%);\n        width: 100%;\n        height: 100%;\n        top: 0;\n        left: 0;\n        margin: 1re;\n        position: absolute;\n    }\n"]),
    f = w(["\n    height: 300px;\n    object-fit: cover;\n    width: 100%;\n"], ["\n    height: 300px;\n    object-fit: cover;\n    width: 100%;\n"]),
    p = w(["\n    font-size: 13px;\n    line-height: 22px;\n    color: #ffffff;\n    max-height: 20px;\n"], ["\n    font-size: 13px;\n    line-height: 22px;\n    color: #ffffff;\n    max-height: 20px;\n"]),
    _ = w(["\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 26px;\n    color: #bdbdbd;\n"], ["\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 26px;\n    color: #bdbdbd;\n"]),
    h = w(["\n    margin: 0 auto;\n    max-width: 100%;\n    -moz-column-count: 2;\n    -webkit-column-count: 2;\n    column-count: 2;\n    -moz-column-gap: 2em;\n    -webkit-column-gap: 2em;\n    column-gap: 2em;\n    break-inside: avoid-column;\n"], ["\n    margin: 0 auto;\n    max-width: 100%;\n    -moz-column-count: 2;\n    -webkit-column-count: 2;\n    column-count: 2;\n    -moz-column-gap: 2em;\n    -webkit-column-gap: 2em;\n    column-gap: 2em;\n    break-inside: avoid-column;\n"]),
    y = w(["\n    font-size: 13px;\n    line-height: 17px;\n    color: #bdbdbd;\n"], ["\n    font-size: 13px;\n    line-height: 17px;\n    color: #bdbdbd;\n"]),
    g = n(0),
    v = b(g),
    M = b(n(2)),
    L = b(n(3));
  function b(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  function w(e, t) {
    return Object.freeze(Object.defineProperties(e, {
      raw: {
        value: Object.freeze(t)
      }
    }));
  }
  t.default = function (e) {
    var t = e.isNewsList,
      n = e.lang;
    if (t) {
      var a = e.blogListItemImg,
        r = e.blogListItemPostTitle,
        i = e.blogListItemPostLabelImg,
        o = e.blogListItemPostDate,
        s = e.blogListItemPostDescription,
        l = e.viewMoreLink;
      return v.default.createElement(k, {
        blogListItemImg: a,
        blogListItemPostTitle: r,
        blogListItemPostLabelImg: i,
        blogListItemPostDate: o,
        blogListItemPostDescription: s,
        viewMoreLink: l,
        selectedLanguage: n
      });
    }
    var d = e.commonConfigs,
      u = (e.componentIndex, e.dbName),
      c = (e.editMode, e.data);
    if (c) {
      var m = c.data,
        f = c.settings;
      c.styles;
      if (m && m.news && m.news.features && f && f.news && f.news.value) {
        var p = f.news.value,
          _ = p.collection,
          h = p.documentId,
          y = m.news.features.blogListItemImg ? m.news.features.blogListItemImg.mappingField : void 0,
          g = m.news.features.blogListItemPostTitle ? m.news.features.blogListItemPostTitle.mappingField : void 0,
          M = m.news.features.blogListItemPostLabelImg ? m.news.features.blogListItemPostLabelImg.mappingField : void 0,
          L = m.news.features.blogListItemPostDate ? m.news.features.blogListItemPostDate.mappingField : void 0,
          b = m.news.features.blogListItemPostDescription ? m.news.features.blogListItemPostDescription.mappingField : void 0;
        return v.default.createElement(A, {
          blogListItemImg: y,
          blogListItemPostTitle: g,
          blogListItemPostLabelImg: M,
          blogListItemPostDate: L,
          blogListItemPostDescription: b,
          selectedLanguage: n,
          collectionName: _ || "",
          documentId: h || "",
          dbName: u,
          commonConfigs: d
        });
      }
      return null;
    }
    return null;
  };
  var k = function (e) {
      var t = e.blogListItemImg,
        n = e.blogListItemPostTitle,
        a = e.blogListItemPostLabelImg,
        r = e.blogListItemPostDate,
        i = e.blogListItemPostDescription,
        o = e.viewMoreLink,
        s = e.selectedLanguage;
      return v.default.createElement(Y, {
        className: "blog-list"
      }, v.default.createElement(D, {
        className: "blog-list-container"
      }, v.default.createElement(S, {
        className: "blog-list-item mb-3"
      }, v.default.createElement(T, {
        className: "row"
      }, t && "string" == typeof t && "" !== t && v.default.createElement(E, {
        className: "col-md-2"
      }, v.default.createElement(x, {
        className: "img-fluid",
        src: t,
        alt: "Image"
      })), v.default.createElement(C, {
        className: "col-md-11 mb-3"
      }, a && "string" == typeof a && "" !== a && v.default.createElement(j, {
        className: "post-label mb-3"
      }, v.default.createElement(P, {
        className: "img-fluid",
        src: a
      })), n && "string" == typeof n && "" !== n && v.default.createElement(N, {
        className: "post-title mb-3"
      }, n), r && "string" == typeof r && "" !== r && v.default.createElement(H, {
        className: "post-date mb-3"
      }, r), i && "string" == typeof i && "" !== i && v.default.createElement(O, {
        className: "post-desc mb-3"
      }, i), o && "string" == typeof o && "" !== o && v.default.createElement(I, null, s && "en" === s.langKey.toLowerCase() && v.default.createElement(z, {
        href: o,
        className: "pb-4 mb-3"
      }, "Read more ❯"), s && "ar" === s.langKey.toLowerCase() && v.default.createElement(z, {
        href: o,
        className: "pb-4 mb-3"
      }, "اقرأ المزيد ❯")))))));
    },
    Y = M.default.div(r),
    D = M.default.ul(i),
    S = M.default.li(o),
    T = M.default.div(r),
    E = M.default.div(r),
    x = M.default.img(s),
    C = M.default.div(r),
    j = M.default.div(r),
    P = M.default.img(r),
    N = M.default.div(l),
    H = M.default.div(d),
    O = M.default.div(u),
    I = M.default.div(r),
    z = M.default.a(c),
    A = function (e) {
      var t = e.blogListItemImg,
        n = e.blogListItemPostTitle,
        r = e.blogListItemPostLabelImg,
        i = e.blogListItemPostDate,
        o = e.blogListItemPostDescription,
        s = e.selectedLanguage,
        l = e.collectionName,
        d = e.documentId,
        u = e.dbName,
        c = (e.commonConfigs, (0, g.useState)(void 0)),
        m = a(c, 2),
        f = m[0],
        p = m[1];
      return (0, g.useEffect)(function () {
        var e,
          t = !0;
        return t && (e = {
          headers: {},
          params: {
            dbName: u,
            collectionName: l,
            searchId: d
          }
        }, L.default.get("/api/cms/getSingleDocumentById", e).then(function (e) {
          var t = e.status,
            n = e.data;
          if (200 === t && n) {
            var a = n.fieldData;
            a && s && s.langKey && p(a[s.langKey]);
          }
        }).catch(function (e) {
          console.log(e);
        })), function () {
          t = !1;
        };
      }, [l, d, u]), f ? v.default.createElement(F, null, v.default.createElement(R, null, v.default.createElement(W, {
        src: "/api/documents/" + u + "/" + f[t],
        className: "img-fluid"
      })), v.default.createElement(V, null, v.default.createElement(K, {
        className: "mt-3 row"
      }, v.default.createElement(B, {
        className: "col"
      }, v.default.createElement(U, null, f[i])), v.default.createElement(q, {
        className: "col text-right"
      }, v.default.createElement(J, {
        src: "/api/documents/" + u + "/" + f[r]
      }))), v.default.createElement(Z, {
        className: "mt-3 mb-3"
      }, f[n]), v.default.createElement(G, {
        className: "mt-4"
      }, v.default.createElement($, null, v.default.createElement(X, null, f[o]))))) : null;
    },
    F = M.default.div(r),
    R = M.default.div(m),
    W = M.default.img(f),
    V = M.default.div(r),
    K = M.default.div(r),
    B = M.default.div(r),
    U = M.default.div(p),
    q = M.default.div(r),
    J = M.default.img(r),
    Z = M.default.div(_),
    G = M.default.div(r),
    $ = M.default.blockquote(h),
    X = M.default.p(y);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      height: e.height,
      viewBox: "0 0 24 24",
      width: e.width,
      fill: "#000000"
    }, i.default.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    }), i.default.createElement("path", {
      d: "M7 10l5 5 5-5z"
    }));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t) {
  e.exports = require("universal-cookie/es6");
}, function (e, t, n) {
  "use strict";

  var a;
  n.r(t), n.d(t, "SortingDirections", function () {
    return a;
  }), function (e) {
    e[e.ascending = 1] = "ascending", e[e.descending = -1] = "descending";
  }(a || (a = {}));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("af", {
      months: "Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember".split("_"),
      monthsShort: "Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des".split("_"),
      weekdays: "Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag".split("_"),
      weekdaysShort: "Son_Maa_Din_Woe_Don_Vry_Sat".split("_"),
      weekdaysMin: "So_Ma_Di_Wo_Do_Vr_Sa".split("_"),
      meridiemParse: /vm|nm/i,
      isPM: function (e) {
        return /^nm$/i.test(e);
      },
      meridiem: function (e, t, n) {
        return e < 12 ? n ? "vm" : "VM" : n ? "nm" : "NM";
      },
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd, D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[Vandag om] LT",
        nextDay: "[Môre om] LT",
        nextWeek: "dddd [om] LT",
        lastDay: "[Gister om] LT",
        lastWeek: "[Laas] dddd [om] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "oor %s",
        past: "%s gelede",
        s: "'n paar sekondes",
        ss: "%d sekondes",
        m: "'n minuut",
        mm: "%d minute",
        h: "'n uur",
        hh: "%d ure",
        d: "'n dag",
        dd: "%d dae",
        M: "'n maand",
        MM: "%d maande",
        y: "'n jaar",
        yy: "%d jaar"
      },
      dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
      ordinal: function (e) {
        return e + (1 === e || 8 === e || e >= 20 ? "ste" : "de");
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = {
        1: "١",
        2: "٢",
        3: "٣",
        4: "٤",
        5: "٥",
        6: "٦",
        7: "٧",
        8: "٨",
        9: "٩",
        0: "٠"
      },
      n = {
        "١": "1",
        "٢": "2",
        "٣": "3",
        "٤": "4",
        "٥": "5",
        "٦": "6",
        "٧": "7",
        "٨": "8",
        "٩": "9",
        "٠": "0"
      },
      a = function (e) {
        return 0 === e ? 0 : 1 === e ? 1 : 2 === e ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5;
      },
      r = {
        s: ["أقل من ثانية", "ثانية واحدة", ["ثانيتان", "ثانيتين"], "%d ثوان", "%d ثانية", "%d ثانية"],
        m: ["أقل من دقيقة", "دقيقة واحدة", ["دقيقتان", "دقيقتين"], "%d دقائق", "%d دقيقة", "%d دقيقة"],
        h: ["أقل من ساعة", "ساعة واحدة", ["ساعتان", "ساعتين"], "%d ساعات", "%d ساعة", "%d ساعة"],
        d: ["أقل من يوم", "يوم واحد", ["يومان", "يومين"], "%d أيام", "%d يومًا", "%d يوم"],
        M: ["أقل من شهر", "شهر واحد", ["شهران", "شهرين"], "%d أشهر", "%d شهرا", "%d شهر"],
        y: ["أقل من عام", "عام واحد", ["عامان", "عامين"], "%d أعوام", "%d عامًا", "%d عام"]
      },
      i = function (e) {
        return function (t, n, i, o) {
          var s = a(t),
            l = r[e][a(t)];
          return 2 === s && (l = l[n ? 0 : 1]), l.replace(/%d/i, t);
        };
      },
      o = ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"];
    e.defineLocale("ar", {
      months: o,
      monthsShort: o,
      weekdays: "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
      weekdaysShort: "أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),
      weekdaysMin: "ح_ن_ث_ر_خ_ج_س".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "D/‏M/‏YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd D MMMM YYYY HH:mm"
      },
      meridiemParse: /ص|م/,
      isPM: function (e) {
        return "م" === e;
      },
      meridiem: function (e, t, n) {
        return e < 12 ? "ص" : "م";
      },
      calendar: {
        sameDay: "[اليوم عند الساعة] LT",
        nextDay: "[غدًا عند الساعة] LT",
        nextWeek: "dddd [عند الساعة] LT",
        lastDay: "[أمس عند الساعة] LT",
        lastWeek: "dddd [عند الساعة] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "بعد %s",
        past: "منذ %s",
        s: i("s"),
        ss: i("s"),
        m: i("m"),
        mm: i("m"),
        h: i("h"),
        hh: i("h"),
        d: i("d"),
        dd: i("d"),
        M: i("M"),
        MM: i("M"),
        y: i("y"),
        yy: i("y")
      },
      preparse: function (e) {
        return e.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (e) {
          return n[e];
        }).replace(/،/g, ",");
      },
      postformat: function (e) {
        return e.replace(/\d/g, function (e) {
          return t[e];
        }).replace(/,/g, "،");
      },
      week: {
        dow: 6,
        doy: 12
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = function (e) {
        return 0 === e ? 0 : 1 === e ? 1 : 2 === e ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5;
      },
      n = {
        s: ["أقل من ثانية", "ثانية واحدة", ["ثانيتان", "ثانيتين"], "%d ثوان", "%d ثانية", "%d ثانية"],
        m: ["أقل من دقيقة", "دقيقة واحدة", ["دقيقتان", "دقيقتين"], "%d دقائق", "%d دقيقة", "%d دقيقة"],
        h: ["أقل من ساعة", "ساعة واحدة", ["ساعتان", "ساعتين"], "%d ساعات", "%d ساعة", "%d ساعة"],
        d: ["أقل من يوم", "يوم واحد", ["يومان", "يومين"], "%d أيام", "%d يومًا", "%d يوم"],
        M: ["أقل من شهر", "شهر واحد", ["شهران", "شهرين"], "%d أشهر", "%d شهرا", "%d شهر"],
        y: ["أقل من عام", "عام واحد", ["عامان", "عامين"], "%d أعوام", "%d عامًا", "%d عام"]
      },
      a = function (e) {
        return function (a, r, i, o) {
          var s = t(a),
            l = n[e][t(a)];
          return 2 === s && (l = l[r ? 0 : 1]), l.replace(/%d/i, a);
        };
      },
      r = ["جانفي", "فيفري", "مارس", "أفريل", "ماي", "جوان", "جويلية", "أوت", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"];
    e.defineLocale("ar-dz", {
      months: r,
      monthsShort: r,
      weekdays: "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
      weekdaysShort: "أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),
      weekdaysMin: "ح_ن_ث_ر_خ_ج_س".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "D/‏M/‏YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd D MMMM YYYY HH:mm"
      },
      meridiemParse: /ص|م/,
      isPM: function (e) {
        return "م" === e;
      },
      meridiem: function (e, t, n) {
        return e < 12 ? "ص" : "م";
      },
      calendar: {
        sameDay: "[اليوم عند الساعة] LT",
        nextDay: "[غدًا عند الساعة] LT",
        nextWeek: "dddd [عند الساعة] LT",
        lastDay: "[أمس عند الساعة] LT",
        lastWeek: "dddd [عند الساعة] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "بعد %s",
        past: "منذ %s",
        s: a("s"),
        ss: a("s"),
        m: a("m"),
        mm: a("m"),
        h: a("h"),
        hh: a("h"),
        d: a("d"),
        dd: a("d"),
        M: a("M"),
        MM: a("M"),
        y: a("y"),
        yy: a("y")
      },
      postformat: function (e) {
        return e.replace(/,/g, "،");
      },
      week: {
        dow: 0,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("ar-kw", {
      months: "يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),
      monthsShort: "يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),
      weekdays: "الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
      weekdaysShort: "احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت".split("_"),
      weekdaysMin: "ح_ن_ث_ر_خ_ج_س".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[اليوم على الساعة] LT",
        nextDay: "[غدا على الساعة] LT",
        nextWeek: "dddd [على الساعة] LT",
        lastDay: "[أمس على الساعة] LT",
        lastWeek: "dddd [على الساعة] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "في %s",
        past: "منذ %s",
        s: "ثوان",
        ss: "%d ثانية",
        m: "دقيقة",
        mm: "%d دقائق",
        h: "ساعة",
        hh: "%d ساعات",
        d: "يوم",
        dd: "%d أيام",
        M: "شهر",
        MM: "%d أشهر",
        y: "سنة",
        yy: "%d سنوات"
      },
      week: {
        dow: 0,
        doy: 12
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = {
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        0: "0"
      },
      n = function (e) {
        return 0 === e ? 0 : 1 === e ? 1 : 2 === e ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5;
      },
      a = {
        s: ["أقل من ثانية", "ثانية واحدة", ["ثانيتان", "ثانيتين"], "%d ثوان", "%d ثانية", "%d ثانية"],
        m: ["أقل من دقيقة", "دقيقة واحدة", ["دقيقتان", "دقيقتين"], "%d دقائق", "%d دقيقة", "%d دقيقة"],
        h: ["أقل من ساعة", "ساعة واحدة", ["ساعتان", "ساعتين"], "%d ساعات", "%d ساعة", "%d ساعة"],
        d: ["أقل من يوم", "يوم واحد", ["يومان", "يومين"], "%d أيام", "%d يومًا", "%d يوم"],
        M: ["أقل من شهر", "شهر واحد", ["شهران", "شهرين"], "%d أشهر", "%d شهرا", "%d شهر"],
        y: ["أقل من عام", "عام واحد", ["عامان", "عامين"], "%d أعوام", "%d عامًا", "%d عام"]
      },
      r = function (e) {
        return function (t, r, i, o) {
          var s = n(t),
            l = a[e][n(t)];
          return 2 === s && (l = l[r ? 0 : 1]), l.replace(/%d/i, t);
        };
      },
      i = ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"];
    e.defineLocale("ar-ly", {
      months: i,
      monthsShort: i,
      weekdays: "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
      weekdaysShort: "أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),
      weekdaysMin: "ح_ن_ث_ر_خ_ج_س".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "D/‏M/‏YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd D MMMM YYYY HH:mm"
      },
      meridiemParse: /ص|م/,
      isPM: function (e) {
        return "م" === e;
      },
      meridiem: function (e, t, n) {
        return e < 12 ? "ص" : "م";
      },
      calendar: {
        sameDay: "[اليوم عند الساعة] LT",
        nextDay: "[غدًا عند الساعة] LT",
        nextWeek: "dddd [عند الساعة] LT",
        lastDay: "[أمس عند الساعة] LT",
        lastWeek: "dddd [عند الساعة] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "بعد %s",
        past: "منذ %s",
        s: r("s"),
        ss: r("s"),
        m: r("m"),
        mm: r("m"),
        h: r("h"),
        hh: r("h"),
        d: r("d"),
        dd: r("d"),
        M: r("M"),
        MM: r("M"),
        y: r("y"),
        yy: r("y")
      },
      preparse: function (e) {
        return e.replace(/،/g, ",");
      },
      postformat: function (e) {
        return e.replace(/\d/g, function (e) {
          return t[e];
        }).replace(/,/g, "،");
      },
      week: {
        dow: 6,
        doy: 12
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("ar-ma", {
      months: "يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),
      monthsShort: "يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),
      weekdays: "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
      weekdaysShort: "احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت".split("_"),
      weekdaysMin: "ح_ن_ث_ر_خ_ج_س".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[اليوم على الساعة] LT",
        nextDay: "[غدا على الساعة] LT",
        nextWeek: "dddd [على الساعة] LT",
        lastDay: "[أمس على الساعة] LT",
        lastWeek: "dddd [على الساعة] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "في %s",
        past: "منذ %s",
        s: "ثوان",
        ss: "%d ثانية",
        m: "دقيقة",
        mm: "%d دقائق",
        h: "ساعة",
        hh: "%d ساعات",
        d: "يوم",
        dd: "%d أيام",
        M: "شهر",
        MM: "%d أشهر",
        y: "سنة",
        yy: "%d سنوات"
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = {
        1: "١",
        2: "٢",
        3: "٣",
        4: "٤",
        5: "٥",
        6: "٦",
        7: "٧",
        8: "٨",
        9: "٩",
        0: "٠"
      },
      n = {
        "١": "1",
        "٢": "2",
        "٣": "3",
        "٤": "4",
        "٥": "5",
        "٦": "6",
        "٧": "7",
        "٨": "8",
        "٩": "9",
        "٠": "0"
      };
    e.defineLocale("ar-sa", {
      months: "يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),
      monthsShort: "يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),
      weekdays: "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
      weekdaysShort: "أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),
      weekdaysMin: "ح_ن_ث_ر_خ_ج_س".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd D MMMM YYYY HH:mm"
      },
      meridiemParse: /ص|م/,
      isPM: function (e) {
        return "م" === e;
      },
      meridiem: function (e, t, n) {
        return e < 12 ? "ص" : "م";
      },
      calendar: {
        sameDay: "[اليوم على الساعة] LT",
        nextDay: "[غدا على الساعة] LT",
        nextWeek: "dddd [على الساعة] LT",
        lastDay: "[أمس على الساعة] LT",
        lastWeek: "dddd [على الساعة] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "في %s",
        past: "منذ %s",
        s: "ثوان",
        ss: "%d ثانية",
        m: "دقيقة",
        mm: "%d دقائق",
        h: "ساعة",
        hh: "%d ساعات",
        d: "يوم",
        dd: "%d أيام",
        M: "شهر",
        MM: "%d أشهر",
        y: "سنة",
        yy: "%d سنوات"
      },
      preparse: function (e) {
        return e.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (e) {
          return n[e];
        }).replace(/،/g, ",");
      },
      postformat: function (e) {
        return e.replace(/\d/g, function (e) {
          return t[e];
        }).replace(/,/g, "،");
      },
      week: {
        dow: 0,
        doy: 6
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("ar-tn", {
      months: "جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),
      monthsShort: "جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),
      weekdays: "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
      weekdaysShort: "أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),
      weekdaysMin: "ح_ن_ث_ر_خ_ج_س".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[اليوم على الساعة] LT",
        nextDay: "[غدا على الساعة] LT",
        nextWeek: "dddd [على الساعة] LT",
        lastDay: "[أمس على الساعة] LT",
        lastWeek: "dddd [على الساعة] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "في %s",
        past: "منذ %s",
        s: "ثوان",
        ss: "%d ثانية",
        m: "دقيقة",
        mm: "%d دقائق",
        h: "ساعة",
        hh: "%d ساعات",
        d: "يوم",
        dd: "%d أيام",
        M: "شهر",
        MM: "%d أشهر",
        y: "سنة",
        yy: "%d سنوات"
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = {
      1: "-inci",
      5: "-inci",
      8: "-inci",
      70: "-inci",
      80: "-inci",
      2: "-nci",
      7: "-nci",
      20: "-nci",
      50: "-nci",
      3: "-üncü",
      4: "-üncü",
      100: "-üncü",
      6: "-ncı",
      9: "-uncu",
      10: "-uncu",
      30: "-uncu",
      60: "-ıncı",
      90: "-ıncı"
    };
    e.defineLocale("az", {
      months: "yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr".split("_"),
      monthsShort: "yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek".split("_"),
      weekdays: "Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə".split("_"),
      weekdaysShort: "Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən".split("_"),
      weekdaysMin: "Bz_BE_ÇA_Çə_CA_Cü_Şə".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD.MM.YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd, D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[bugün saat] LT",
        nextDay: "[sabah saat] LT",
        nextWeek: "[gələn həftə] dddd [saat] LT",
        lastDay: "[dünən] LT",
        lastWeek: "[keçən həftə] dddd [saat] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%s sonra",
        past: "%s əvvəl",
        s: "bir neçə saniyə",
        ss: "%d saniyə",
        m: "bir dəqiqə",
        mm: "%d dəqiqə",
        h: "bir saat",
        hh: "%d saat",
        d: "bir gün",
        dd: "%d gün",
        M: "bir ay",
        MM: "%d ay",
        y: "bir il",
        yy: "%d il"
      },
      meridiemParse: /gecə|səhər|gündüz|axşam/,
      isPM: function (e) {
        return /^(gündüz|axşam)$/.test(e);
      },
      meridiem: function (e, t, n) {
        return e < 4 ? "gecə" : e < 12 ? "səhər" : e < 17 ? "gündüz" : "axşam";
      },
      dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
      ordinal: function (e) {
        if (0 === e) return e + "-ıncı";
        var n = e % 10;
        return e + (t[n] || t[e % 100 - n] || t[e >= 100 ? 100 : null]);
      },
      week: {
        dow: 1,
        doy: 7
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    function t(e, t, n) {
      var a, r;
      return "m" === n ? t ? "хвіліна" : "хвіліну" : "h" === n ? t ? "гадзіна" : "гадзіну" : e + " " + (a = +e, r = {
        ss: t ? "секунда_секунды_секунд" : "секунду_секунды_секунд",
        mm: t ? "хвіліна_хвіліны_хвілін" : "хвіліну_хвіліны_хвілін",
        hh: t ? "гадзіна_гадзіны_гадзін" : "гадзіну_гадзіны_гадзін",
        dd: "дзень_дні_дзён",
        MM: "месяц_месяцы_месяцаў",
        yy: "год_гады_гадоў"
      }[n].split("_"), a % 10 == 1 && a % 100 != 11 ? r[0] : a % 10 >= 2 && a % 10 <= 4 && (a % 100 < 10 || a % 100 >= 20) ? r[1] : r[2]);
    }
    e.defineLocale("be", {
      months: {
        format: "студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня".split("_"),
        standalone: "студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань".split("_")
      },
      monthsShort: "студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж".split("_"),
      weekdays: {
        format: "нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу".split("_"),
        standalone: "нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота".split("_"),
        isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
      },
      weekdaysShort: "нд_пн_ат_ср_чц_пт_сб".split("_"),
      weekdaysMin: "нд_пн_ат_ср_чц_пт_сб".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD.MM.YYYY",
        LL: "D MMMM YYYY г.",
        LLL: "D MMMM YYYY г., HH:mm",
        LLLL: "dddd, D MMMM YYYY г., HH:mm"
      },
      calendar: {
        sameDay: "[Сёння ў] LT",
        nextDay: "[Заўтра ў] LT",
        lastDay: "[Учора ў] LT",
        nextWeek: function () {
          return "[У] dddd [ў] LT";
        },
        lastWeek: function () {
          switch (this.day()) {
            case 0:
            case 3:
            case 5:
            case 6:
              return "[У мінулую] dddd [ў] LT";
            case 1:
            case 2:
            case 4:
              return "[У мінулы] dddd [ў] LT";
          }
        },
        sameElse: "L"
      },
      relativeTime: {
        future: "праз %s",
        past: "%s таму",
        s: "некалькі секунд",
        m: t,
        mm: t,
        h: t,
        hh: t,
        d: "дзень",
        dd: t,
        M: "месяц",
        MM: t,
        y: "год",
        yy: t
      },
      meridiemParse: /ночы|раніцы|дня|вечара/,
      isPM: function (e) {
        return /^(дня|вечара)$/.test(e);
      },
      meridiem: function (e, t, n) {
        return e < 4 ? "ночы" : e < 12 ? "раніцы" : e < 17 ? "дня" : "вечара";
      },
      dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
      ordinal: function (e, t) {
        switch (t) {
          case "M":
          case "d":
          case "DDD":
          case "w":
          case "W":
            return e % 10 != 2 && e % 10 != 3 || e % 100 == 12 || e % 100 == 13 ? e + "-ы" : e + "-і";
          case "D":
            return e + "-га";
          default:
            return e;
        }
      },
      week: {
        dow: 1,
        doy: 7
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("bg", {
      months: "януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември".split("_"),
      monthsShort: "яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек".split("_"),
      weekdays: "неделя_понеделник_вторник_сряда_четвъртък_петък_събота".split("_"),
      weekdaysShort: "нед_пон_вто_сря_чет_пет_съб".split("_"),
      weekdaysMin: "нд_пн_вт_ср_чт_пт_сб".split("_"),
      longDateFormat: {
        LT: "H:mm",
        LTS: "H:mm:ss",
        L: "D.MM.YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY H:mm",
        LLLL: "dddd, D MMMM YYYY H:mm"
      },
      calendar: {
        sameDay: "[Днес в] LT",
        nextDay: "[Утре в] LT",
        nextWeek: "dddd [в] LT",
        lastDay: "[Вчера в] LT",
        lastWeek: function () {
          switch (this.day()) {
            case 0:
            case 3:
            case 6:
              return "[Миналата] dddd [в] LT";
            case 1:
            case 2:
            case 4:
            case 5:
              return "[Миналия] dddd [в] LT";
          }
        },
        sameElse: "L"
      },
      relativeTime: {
        future: "след %s",
        past: "преди %s",
        s: "няколко секунди",
        ss: "%d секунди",
        m: "минута",
        mm: "%d минути",
        h: "час",
        hh: "%d часа",
        d: "ден",
        dd: "%d дена",
        w: "седмица",
        ww: "%d седмици",
        M: "месец",
        MM: "%d месеца",
        y: "година",
        yy: "%d години"
      },
      dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
      ordinal: function (e) {
        var t = e % 10,
          n = e % 100;
        return 0 === e ? e + "-ев" : 0 === n ? e + "-ен" : n > 10 && n < 20 ? e + "-ти" : 1 === t ? e + "-ви" : 2 === t ? e + "-ри" : 7 === t || 8 === t ? e + "-ми" : e + "-ти";
      },
      week: {
        dow: 1,
        doy: 7
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("bm", {
      months: "Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo".split("_"),
      monthsShort: "Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des".split("_"),
      weekdays: "Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri".split("_"),
      weekdaysShort: "Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib".split("_"),
      weekdaysMin: "Ka_Nt_Ta_Ar_Al_Ju_Si".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "MMMM [tile] D [san] YYYY",
        LLL: "MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm",
        LLLL: "dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm"
      },
      calendar: {
        sameDay: "[Bi lɛrɛ] LT",
        nextDay: "[Sini lɛrɛ] LT",
        nextWeek: "dddd [don lɛrɛ] LT",
        lastDay: "[Kunu lɛrɛ] LT",
        lastWeek: "dddd [tɛmɛnen lɛrɛ] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%s kɔnɔ",
        past: "a bɛ %s bɔ",
        s: "sanga dama dama",
        ss: "sekondi %d",
        m: "miniti kelen",
        mm: "miniti %d",
        h: "lɛrɛ kelen",
        hh: "lɛrɛ %d",
        d: "tile kelen",
        dd: "tile %d",
        M: "kalo kelen",
        MM: "kalo %d",
        y: "san kelen",
        yy: "san %d"
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = {
        1: "১",
        2: "২",
        3: "৩",
        4: "৪",
        5: "৫",
        6: "৬",
        7: "৭",
        8: "৮",
        9: "৯",
        0: "০"
      },
      n = {
        "১": "1",
        "২": "2",
        "৩": "3",
        "৪": "4",
        "৫": "5",
        "৬": "6",
        "৭": "7",
        "৮": "8",
        "৯": "9",
        "০": "0"
      };
    e.defineLocale("bn", {
      months: "জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর".split("_"),
      monthsShort: "জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে".split("_"),
      weekdays: "রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার".split("_"),
      weekdaysShort: "রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি".split("_"),
      weekdaysMin: "রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি".split("_"),
      longDateFormat: {
        LT: "A h:mm সময়",
        LTS: "A h:mm:ss সময়",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY, A h:mm সময়",
        LLLL: "dddd, D MMMM YYYY, A h:mm সময়"
      },
      calendar: {
        sameDay: "[আজ] LT",
        nextDay: "[আগামীকাল] LT",
        nextWeek: "dddd, LT",
        lastDay: "[গতকাল] LT",
        lastWeek: "[গত] dddd, LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%s পরে",
        past: "%s আগে",
        s: "কয়েক সেকেন্ড",
        ss: "%d সেকেন্ড",
        m: "এক মিনিট",
        mm: "%d মিনিট",
        h: "এক ঘন্টা",
        hh: "%d ঘন্টা",
        d: "এক দিন",
        dd: "%d দিন",
        M: "এক মাস",
        MM: "%d মাস",
        y: "এক বছর",
        yy: "%d বছর"
      },
      preparse: function (e) {
        return e.replace(/[১২৩৪৫৬৭৮৯০]/g, function (e) {
          return n[e];
        });
      },
      postformat: function (e) {
        return e.replace(/\d/g, function (e) {
          return t[e];
        });
      },
      meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
      meridiemHour: function (e, t) {
        return 12 === e && (e = 0), "রাত" === t && e >= 4 || "দুপুর" === t && e < 5 || "বিকাল" === t ? e + 12 : e;
      },
      meridiem: function (e, t, n) {
        return e < 4 ? "রাত" : e < 10 ? "সকাল" : e < 17 ? "দুপুর" : e < 20 ? "বিকাল" : "রাত";
      },
      week: {
        dow: 0,
        doy: 6
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = {
        1: "১",
        2: "২",
        3: "৩",
        4: "৪",
        5: "৫",
        6: "৬",
        7: "৭",
        8: "৮",
        9: "৯",
        0: "০"
      },
      n = {
        "১": "1",
        "২": "2",
        "৩": "3",
        "৪": "4",
        "৫": "5",
        "৬": "6",
        "৭": "7",
        "৮": "8",
        "৯": "9",
        "০": "0"
      };
    e.defineLocale("bn-bd", {
      months: "জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর".split("_"),
      monthsShort: "জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে".split("_"),
      weekdays: "রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার".split("_"),
      weekdaysShort: "রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি".split("_"),
      weekdaysMin: "রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি".split("_"),
      longDateFormat: {
        LT: "A h:mm সময়",
        LTS: "A h:mm:ss সময়",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY, A h:mm সময়",
        LLLL: "dddd, D MMMM YYYY, A h:mm সময়"
      },
      calendar: {
        sameDay: "[আজ] LT",
        nextDay: "[আগামীকাল] LT",
        nextWeek: "dddd, LT",
        lastDay: "[গতকাল] LT",
        lastWeek: "[গত] dddd, LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%s পরে",
        past: "%s আগে",
        s: "কয়েক সেকেন্ড",
        ss: "%d সেকেন্ড",
        m: "এক মিনিট",
        mm: "%d মিনিট",
        h: "এক ঘন্টা",
        hh: "%d ঘন্টা",
        d: "এক দিন",
        dd: "%d দিন",
        M: "এক মাস",
        MM: "%d মাস",
        y: "এক বছর",
        yy: "%d বছর"
      },
      preparse: function (e) {
        return e.replace(/[১২৩৪৫৬৭৮৯০]/g, function (e) {
          return n[e];
        });
      },
      postformat: function (e) {
        return e.replace(/\d/g, function (e) {
          return t[e];
        });
      },
      meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
      meridiemHour: function (e, t) {
        return 12 === e && (e = 0), "রাত" === t ? e < 4 ? e : e + 12 : "ভোর" === t || "সকাল" === t ? e : "দুপুর" === t ? e >= 3 ? e : e + 12 : "বিকাল" === t || "সন্ধ্যা" === t ? e + 12 : void 0;
      },
      meridiem: function (e, t, n) {
        return e < 4 ? "রাত" : e < 6 ? "ভোর" : e < 12 ? "সকাল" : e < 15 ? "দুপুর" : e < 18 ? "বিকাল" : e < 20 ? "সন্ধ্যা" : "রাত";
      },
      week: {
        dow: 0,
        doy: 6
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = {
        1: "༡",
        2: "༢",
        3: "༣",
        4: "༤",
        5: "༥",
        6: "༦",
        7: "༧",
        8: "༨",
        9: "༩",
        0: "༠"
      },
      n = {
        "༡": "1",
        "༢": "2",
        "༣": "3",
        "༤": "4",
        "༥": "5",
        "༦": "6",
        "༧": "7",
        "༨": "8",
        "༩": "9",
        "༠": "0"
      };
    e.defineLocale("bo", {
      months: "ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ".split("_"),
      monthsShort: "ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12".split("_"),
      monthsShortRegex: /^(ཟླ་\d{1,2})/,
      monthsParseExact: !0,
      weekdays: "གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་".split("_"),
      weekdaysShort: "ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་".split("_"),
      weekdaysMin: "ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན".split("_"),
      longDateFormat: {
        LT: "A h:mm",
        LTS: "A h:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY, A h:mm",
        LLLL: "dddd, D MMMM YYYY, A h:mm"
      },
      calendar: {
        sameDay: "[དི་རིང] LT",
        nextDay: "[སང་ཉིན] LT",
        nextWeek: "[བདུན་ཕྲག་རྗེས་མ], LT",
        lastDay: "[ཁ་སང] LT",
        lastWeek: "[བདུན་ཕྲག་མཐའ་མ] dddd, LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%s ལ་",
        past: "%s སྔན་ལ",
        s: "ལམ་སང",
        ss: "%d སྐར་ཆ།",
        m: "སྐར་མ་གཅིག",
        mm: "%d སྐར་མ",
        h: "ཆུ་ཚོད་གཅིག",
        hh: "%d ཆུ་ཚོད",
        d: "ཉིན་གཅིག",
        dd: "%d ཉིན་",
        M: "ཟླ་བ་གཅིག",
        MM: "%d ཟླ་བ",
        y: "ལོ་གཅིག",
        yy: "%d ལོ"
      },
      preparse: function (e) {
        return e.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (e) {
          return n[e];
        });
      },
      postformat: function (e) {
        return e.replace(/\d/g, function (e) {
          return t[e];
        });
      },
      meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
      meridiemHour: function (e, t) {
        return 12 === e && (e = 0), "མཚན་མོ" === t && e >= 4 || "ཉིན་གུང" === t && e < 5 || "དགོང་དག" === t ? e + 12 : e;
      },
      meridiem: function (e, t, n) {
        return e < 4 ? "མཚན་མོ" : e < 10 ? "ཞོགས་ཀས" : e < 17 ? "ཉིན་གུང" : e < 20 ? "དགོང་དག" : "མཚན་མོ";
      },
      week: {
        dow: 0,
        doy: 6
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    function t(e, t, n) {
      return e + " " + function (e, t) {
        return 2 === t ? function (e) {
          var t = {
            m: "v",
            b: "v",
            d: "z"
          };
          return void 0 === t[e.charAt(0)] ? e : t[e.charAt(0)] + e.substring(1);
        }(e) : e;
      }({
        mm: "munutenn",
        MM: "miz",
        dd: "devezh"
      }[n], e);
    }
    var n = [/^gen/i, /^c[ʼ\']hwe/i, /^meu/i, /^ebr/i, /^mae/i, /^(mez|eve)/i, /^gou/i, /^eos/i, /^gwe/i, /^her/i, /^du/i, /^ker/i],
      a = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
      r = [/^Su/i, /^Lu/i, /^Me([^r]|$)/i, /^Mer/i, /^Ya/i, /^Gw/i, /^Sa/i];
    e.defineLocale("br", {
      months: "Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu".split("_"),
      monthsShort: "Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker".split("_"),
      weekdays: "Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn".split("_"),
      weekdaysShort: "Sul_Lun_Meu_Mer_Yao_Gwe_Sad".split("_"),
      weekdaysMin: "Su_Lu_Me_Mer_Ya_Gw_Sa".split("_"),
      weekdaysParse: r,
      fullWeekdaysParse: [/^sul/i, /^lun/i, /^meurzh/i, /^merc[ʼ\']her/i, /^yaou/i, /^gwener/i, /^sadorn/i],
      shortWeekdaysParse: [/^Sul/i, /^Lun/i, /^Meu/i, /^Mer/i, /^Yao/i, /^Gwe/i, /^Sad/i],
      minWeekdaysParse: r,
      monthsRegex: a,
      monthsShortRegex: a,
      monthsStrictRegex: /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
      monthsShortStrictRegex: /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
      monthsParse: n,
      longMonthsParse: n,
      shortMonthsParse: n,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D [a viz] MMMM YYYY",
        LLL: "D [a viz] MMMM YYYY HH:mm",
        LLLL: "dddd, D [a viz] MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[Hiziv da] LT",
        nextDay: "[Warcʼhoazh da] LT",
        nextWeek: "dddd [da] LT",
        lastDay: "[Decʼh da] LT",
        lastWeek: "dddd [paset da] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "a-benn %s",
        past: "%s ʼzo",
        s: "un nebeud segondennoù",
        ss: "%d eilenn",
        m: "ur vunutenn",
        mm: t,
        h: "un eur",
        hh: "%d eur",
        d: "un devezh",
        dd: t,
        M: "ur miz",
        MM: t,
        y: "ur bloaz",
        yy: function (e) {
          switch (function e(t) {
            return t > 9 ? e(t % 10) : t;
          }(e)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
              return e + " bloaz";
            default:
              return e + " vloaz";
          }
        }
      },
      dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
      ordinal: function (e) {
        return e + (1 === e ? "añ" : "vet");
      },
      week: {
        dow: 1,
        doy: 4
      },
      meridiemParse: /a.m.|g.m./,
      isPM: function (e) {
        return "g.m." === e;
      },
      meridiem: function (e, t, n) {
        return e < 12 ? "a.m." : "g.m.";
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    function t(e, t, n) {
      var a = e + " ";
      switch (n) {
        case "ss":
          return a += 1 === e ? "sekunda" : 2 === e || 3 === e || 4 === e ? "sekunde" : "sekundi";
        case "m":
          return t ? "jedna minuta" : "jedne minute";
        case "mm":
          return a += 1 === e ? "minuta" : 2 === e || 3 === e || 4 === e ? "minute" : "minuta";
        case "h":
          return t ? "jedan sat" : "jednog sata";
        case "hh":
          return a += 1 === e ? "sat" : 2 === e || 3 === e || 4 === e ? "sata" : "sati";
        case "dd":
          return a += 1 === e ? "dan" : "dana";
        case "MM":
          return a += 1 === e ? "mjesec" : 2 === e || 3 === e || 4 === e ? "mjeseca" : "mjeseci";
        case "yy":
          return a += 1 === e ? "godina" : 2 === e || 3 === e || 4 === e ? "godine" : "godina";
      }
    }
    e.defineLocale("bs", {
      months: "januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar".split("_"),
      monthsShort: "jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.".split("_"),
      monthsParseExact: !0,
      weekdays: "nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split("_"),
      weekdaysShort: "ned._pon._uto._sri._čet._pet._sub.".split("_"),
      weekdaysMin: "ne_po_ut_sr_če_pe_su".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "H:mm",
        LTS: "H:mm:ss",
        L: "DD.MM.YYYY",
        LL: "D. MMMM YYYY",
        LLL: "D. MMMM YYYY H:mm",
        LLLL: "dddd, D. MMMM YYYY H:mm"
      },
      calendar: {
        sameDay: "[danas u] LT",
        nextDay: "[sutra u] LT",
        nextWeek: function () {
          switch (this.day()) {
            case 0:
              return "[u] [nedjelju] [u] LT";
            case 3:
              return "[u] [srijedu] [u] LT";
            case 6:
              return "[u] [subotu] [u] LT";
            case 1:
            case 2:
            case 4:
            case 5:
              return "[u] dddd [u] LT";
          }
        },
        lastDay: "[jučer u] LT",
        lastWeek: function () {
          switch (this.day()) {
            case 0:
            case 3:
              return "[prošlu] dddd [u] LT";
            case 6:
              return "[prošle] [subote] [u] LT";
            case 1:
            case 2:
            case 4:
            case 5:
              return "[prošli] dddd [u] LT";
          }
        },
        sameElse: "L"
      },
      relativeTime: {
        future: "za %s",
        past: "prije %s",
        s: "par sekundi",
        ss: t,
        m: t,
        mm: t,
        h: t,
        hh: t,
        d: "dan",
        dd: t,
        M: "mjesec",
        MM: t,
        y: "godinu",
        yy: t
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: "%d.",
      week: {
        dow: 1,
        doy: 7
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("ca", {
      months: {
        standalone: "gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre".split("_"),
        format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split("_"),
        isFormat: /D[oD]?(\s)+MMMM/
      },
      monthsShort: "gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.".split("_"),
      monthsParseExact: !0,
      weekdays: "diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte".split("_"),
      weekdaysShort: "dg._dl._dt._dc._dj._dv._ds.".split("_"),
      weekdaysMin: "dg_dl_dt_dc_dj_dv_ds".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "H:mm",
        LTS: "H:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM [de] YYYY",
        ll: "D MMM YYYY",
        LLL: "D MMMM [de] YYYY [a les] H:mm",
        lll: "D MMM YYYY, H:mm",
        LLLL: "dddd D MMMM [de] YYYY [a les] H:mm",
        llll: "ddd D MMM YYYY, H:mm"
      },
      calendar: {
        sameDay: function () {
          return "[avui a " + (1 !== this.hours() ? "les" : "la") + "] LT";
        },
        nextDay: function () {
          return "[demà a " + (1 !== this.hours() ? "les" : "la") + "] LT";
        },
        nextWeek: function () {
          return "dddd [a " + (1 !== this.hours() ? "les" : "la") + "] LT";
        },
        lastDay: function () {
          return "[ahir a " + (1 !== this.hours() ? "les" : "la") + "] LT";
        },
        lastWeek: function () {
          return "[el] dddd [passat a " + (1 !== this.hours() ? "les" : "la") + "] LT";
        },
        sameElse: "L"
      },
      relativeTime: {
        future: "d'aquí %s",
        past: "fa %s",
        s: "uns segons",
        ss: "%d segons",
        m: "un minut",
        mm: "%d minuts",
        h: "una hora",
        hh: "%d hores",
        d: "un dia",
        dd: "%d dies",
        M: "un mes",
        MM: "%d mesos",
        y: "un any",
        yy: "%d anys"
      },
      dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
      ordinal: function (e, t) {
        var n = 1 === e ? "r" : 2 === e ? "n" : 3 === e ? "r" : 4 === e ? "t" : "è";
        return "w" !== t && "W" !== t || (n = "a"), e + n;
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = "leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec".split("_"),
      n = "led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro".split("_"),
      a = [/^led/i, /^úno/i, /^bře/i, /^dub/i, /^kvě/i, /^(čvn|červen$|června)/i, /^(čvc|červenec|července)/i, /^srp/i, /^zář/i, /^říj/i, /^lis/i, /^pro/i],
      r = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
    function i(e) {
      return e > 1 && e < 5 && 1 != ~~(e / 10);
    }
    function o(e, t, n, a) {
      var r = e + " ";
      switch (n) {
        case "s":
          return t || a ? "pár sekund" : "pár sekundami";
        case "ss":
          return t || a ? r + (i(e) ? "sekundy" : "sekund") : r + "sekundami";
        case "m":
          return t ? "minuta" : a ? "minutu" : "minutou";
        case "mm":
          return t || a ? r + (i(e) ? "minuty" : "minut") : r + "minutami";
        case "h":
          return t ? "hodina" : a ? "hodinu" : "hodinou";
        case "hh":
          return t || a ? r + (i(e) ? "hodiny" : "hodin") : r + "hodinami";
        case "d":
          return t || a ? "den" : "dnem";
        case "dd":
          return t || a ? r + (i(e) ? "dny" : "dní") : r + "dny";
        case "M":
          return t || a ? "měsíc" : "měsícem";
        case "MM":
          return t || a ? r + (i(e) ? "měsíce" : "měsíců") : r + "měsíci";
        case "y":
          return t || a ? "rok" : "rokem";
        case "yy":
          return t || a ? r + (i(e) ? "roky" : "let") : r + "lety";
      }
    }
    e.defineLocale("cs", {
      months: t,
      monthsShort: n,
      monthsRegex: r,
      monthsShortRegex: r,
      monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
      monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
      monthsParse: a,
      longMonthsParse: a,
      shortMonthsParse: a,
      weekdays: "neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota".split("_"),
      weekdaysShort: "ne_po_út_st_čt_pá_so".split("_"),
      weekdaysMin: "ne_po_út_st_čt_pá_so".split("_"),
      longDateFormat: {
        LT: "H:mm",
        LTS: "H:mm:ss",
        L: "DD.MM.YYYY",
        LL: "D. MMMM YYYY",
        LLL: "D. MMMM YYYY H:mm",
        LLLL: "dddd D. MMMM YYYY H:mm",
        l: "D. M. YYYY"
      },
      calendar: {
        sameDay: "[dnes v] LT",
        nextDay: "[zítra v] LT",
        nextWeek: function () {
          switch (this.day()) {
            case 0:
              return "[v neděli v] LT";
            case 1:
            case 2:
              return "[v] dddd [v] LT";
            case 3:
              return "[ve středu v] LT";
            case 4:
              return "[ve čtvrtek v] LT";
            case 5:
              return "[v pátek v] LT";
            case 6:
              return "[v sobotu v] LT";
          }
        },
        lastDay: "[včera v] LT",
        lastWeek: function () {
          switch (this.day()) {
            case 0:
              return "[minulou neděli v] LT";
            case 1:
            case 2:
              return "[minulé] dddd [v] LT";
            case 3:
              return "[minulou středu v] LT";
            case 4:
            case 5:
              return "[minulý] dddd [v] LT";
            case 6:
              return "[minulou sobotu v] LT";
          }
        },
        sameElse: "L"
      },
      relativeTime: {
        future: "za %s",
        past: "před %s",
        s: o,
        ss: o,
        m: o,
        mm: o,
        h: o,
        hh: o,
        d: o,
        dd: o,
        M: o,
        MM: o,
        y: o,
        yy: o
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: "%d.",
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("cv", {
      months: "кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав".split("_"),
      monthsShort: "кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш".split("_"),
      weekdays: "вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун".split("_"),
      weekdaysShort: "выр_тун_ытл_юн_кӗҫ_эрн_шӑм".split("_"),
      weekdaysMin: "вр_тн_ыт_юн_кҫ_эр_шм".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD-MM-YYYY",
        LL: "YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]",
        LLL: "YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm",
        LLLL: "dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm"
      },
      calendar: {
        sameDay: "[Паян] LT [сехетре]",
        nextDay: "[Ыран] LT [сехетре]",
        lastDay: "[Ӗнер] LT [сехетре]",
        nextWeek: "[Ҫитес] dddd LT [сехетре]",
        lastWeek: "[Иртнӗ] dddd LT [сехетре]",
        sameElse: "L"
      },
      relativeTime: {
        future: function (e) {
          return e + (/сехет$/i.exec(e) ? "рен" : /ҫул$/i.exec(e) ? "тан" : "ран");
        },
        past: "%s каялла",
        s: "пӗр-ик ҫеккунт",
        ss: "%d ҫеккунт",
        m: "пӗр минут",
        mm: "%d минут",
        h: "пӗр сехет",
        hh: "%d сехет",
        d: "пӗр кун",
        dd: "%d кун",
        M: "пӗр уйӑх",
        MM: "%d уйӑх",
        y: "пӗр ҫул",
        yy: "%d ҫул"
      },
      dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
      ordinal: "%d-мӗш",
      week: {
        dow: 1,
        doy: 7
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("cy", {
      months: "Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr".split("_"),
      monthsShort: "Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag".split("_"),
      weekdays: "Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn".split("_"),
      weekdaysShort: "Sul_Llun_Maw_Mer_Iau_Gwe_Sad".split("_"),
      weekdaysMin: "Su_Ll_Ma_Me_Ia_Gw_Sa".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd, D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[Heddiw am] LT",
        nextDay: "[Yfory am] LT",
        nextWeek: "dddd [am] LT",
        lastDay: "[Ddoe am] LT",
        lastWeek: "dddd [diwethaf am] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "mewn %s",
        past: "%s yn ôl",
        s: "ychydig eiliadau",
        ss: "%d eiliad",
        m: "munud",
        mm: "%d munud",
        h: "awr",
        hh: "%d awr",
        d: "diwrnod",
        dd: "%d diwrnod",
        M: "mis",
        MM: "%d mis",
        y: "blwyddyn",
        yy: "%d flynedd"
      },
      dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
      ordinal: function (e) {
        var t = "";
        return e > 20 ? t = 40 === e || 50 === e || 60 === e || 80 === e || 100 === e ? "fed" : "ain" : e > 0 && (t = ["", "af", "il", "ydd", "ydd", "ed", "ed", "ed", "fed", "fed", "fed", "eg", "fed", "eg", "eg", "fed", "eg", "eg", "fed", "eg", "fed"][e]), e + t;
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("da", {
      months: "januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december".split("_"),
      monthsShort: "jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),
      weekdays: "søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"),
      weekdaysShort: "søn_man_tir_ons_tor_fre_lør".split("_"),
      weekdaysMin: "sø_ma_ti_on_to_fr_lø".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD.MM.YYYY",
        LL: "D. MMMM YYYY",
        LLL: "D. MMMM YYYY HH:mm",
        LLLL: "dddd [d.] D. MMMM YYYY [kl.] HH:mm"
      },
      calendar: {
        sameDay: "[i dag kl.] LT",
        nextDay: "[i morgen kl.] LT",
        nextWeek: "på dddd [kl.] LT",
        lastDay: "[i går kl.] LT",
        lastWeek: "[i] dddd[s kl.] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "om %s",
        past: "%s siden",
        s: "få sekunder",
        ss: "%d sekunder",
        m: "et minut",
        mm: "%d minutter",
        h: "en time",
        hh: "%d timer",
        d: "en dag",
        dd: "%d dage",
        M: "en måned",
        MM: "%d måneder",
        y: "et år",
        yy: "%d år"
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: "%d.",
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    function t(e, t, n, a) {
      var r = {
        m: ["eine Minute", "einer Minute"],
        h: ["eine Stunde", "einer Stunde"],
        d: ["ein Tag", "einem Tag"],
        dd: [e + " Tage", e + " Tagen"],
        w: ["eine Woche", "einer Woche"],
        M: ["ein Monat", "einem Monat"],
        MM: [e + " Monate", e + " Monaten"],
        y: ["ein Jahr", "einem Jahr"],
        yy: [e + " Jahre", e + " Jahren"]
      };
      return t ? r[n][0] : r[n][1];
    }
    e.defineLocale("de", {
      months: "Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
      monthsShort: "Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),
      monthsParseExact: !0,
      weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
      weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),
      weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD.MM.YYYY",
        LL: "D. MMMM YYYY",
        LLL: "D. MMMM YYYY HH:mm",
        LLLL: "dddd, D. MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[heute um] LT [Uhr]",
        sameElse: "L",
        nextDay: "[morgen um] LT [Uhr]",
        nextWeek: "dddd [um] LT [Uhr]",
        lastDay: "[gestern um] LT [Uhr]",
        lastWeek: "[letzten] dddd [um] LT [Uhr]"
      },
      relativeTime: {
        future: "in %s",
        past: "vor %s",
        s: "ein paar Sekunden",
        ss: "%d Sekunden",
        m: t,
        mm: "%d Minuten",
        h: t,
        hh: "%d Stunden",
        d: t,
        dd: t,
        w: t,
        ww: "%d Wochen",
        M: t,
        MM: t,
        y: t,
        yy: t
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: "%d.",
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    function t(e, t, n, a) {
      var r = {
        m: ["eine Minute", "einer Minute"],
        h: ["eine Stunde", "einer Stunde"],
        d: ["ein Tag", "einem Tag"],
        dd: [e + " Tage", e + " Tagen"],
        w: ["eine Woche", "einer Woche"],
        M: ["ein Monat", "einem Monat"],
        MM: [e + " Monate", e + " Monaten"],
        y: ["ein Jahr", "einem Jahr"],
        yy: [e + " Jahre", e + " Jahren"]
      };
      return t ? r[n][0] : r[n][1];
    }
    e.defineLocale("de-at", {
      months: "Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
      monthsShort: "Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),
      monthsParseExact: !0,
      weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
      weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),
      weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD.MM.YYYY",
        LL: "D. MMMM YYYY",
        LLL: "D. MMMM YYYY HH:mm",
        LLLL: "dddd, D. MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[heute um] LT [Uhr]",
        sameElse: "L",
        nextDay: "[morgen um] LT [Uhr]",
        nextWeek: "dddd [um] LT [Uhr]",
        lastDay: "[gestern um] LT [Uhr]",
        lastWeek: "[letzten] dddd [um] LT [Uhr]"
      },
      relativeTime: {
        future: "in %s",
        past: "vor %s",
        s: "ein paar Sekunden",
        ss: "%d Sekunden",
        m: t,
        mm: "%d Minuten",
        h: t,
        hh: "%d Stunden",
        d: t,
        dd: t,
        w: t,
        ww: "%d Wochen",
        M: t,
        MM: t,
        y: t,
        yy: t
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: "%d.",
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    function t(e, t, n, a) {
      var r = {
        m: ["eine Minute", "einer Minute"],
        h: ["eine Stunde", "einer Stunde"],
        d: ["ein Tag", "einem Tag"],
        dd: [e + " Tage", e + " Tagen"],
        w: ["eine Woche", "einer Woche"],
        M: ["ein Monat", "einem Monat"],
        MM: [e + " Monate", e + " Monaten"],
        y: ["ein Jahr", "einem Jahr"],
        yy: [e + " Jahre", e + " Jahren"]
      };
      return t ? r[n][0] : r[n][1];
    }
    e.defineLocale("de-ch", {
      months: "Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
      monthsShort: "Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),
      monthsParseExact: !0,
      weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),
      weekdaysShort: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
      weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD.MM.YYYY",
        LL: "D. MMMM YYYY",
        LLL: "D. MMMM YYYY HH:mm",
        LLLL: "dddd, D. MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[heute um] LT [Uhr]",
        sameElse: "L",
        nextDay: "[morgen um] LT [Uhr]",
        nextWeek: "dddd [um] LT [Uhr]",
        lastDay: "[gestern um] LT [Uhr]",
        lastWeek: "[letzten] dddd [um] LT [Uhr]"
      },
      relativeTime: {
        future: "in %s",
        past: "vor %s",
        s: "ein paar Sekunden",
        ss: "%d Sekunden",
        m: t,
        mm: "%d Minuten",
        h: t,
        hh: "%d Stunden",
        d: t,
        dd: t,
        w: t,
        ww: "%d Wochen",
        M: t,
        MM: t,
        y: t,
        yy: t
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: "%d.",
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = ["ޖެނުއަރީ", "ފެބްރުއަރީ", "މާރިޗު", "އޭޕްރީލު", "މޭ", "ޖޫން", "ޖުލައި", "އޯގަސްޓު", "ސެޕްޓެމްބަރު", "އޮކްޓޯބަރު", "ނޮވެމްބަރު", "ޑިސެމްބަރު"],
      n = ["އާދިއްތަ", "ހޯމަ", "އަންގާރަ", "ބުދަ", "ބުރާސްފަތި", "ހުކުރު", "ހޮނިހިރު"];
    e.defineLocale("dv", {
      months: t,
      monthsShort: t,
      weekdays: n,
      weekdaysShort: n,
      weekdaysMin: "އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "D/M/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd D MMMM YYYY HH:mm"
      },
      meridiemParse: /މކ|މފ/,
      isPM: function (e) {
        return "މފ" === e;
      },
      meridiem: function (e, t, n) {
        return e < 12 ? "މކ" : "މފ";
      },
      calendar: {
        sameDay: "[މިއަދު] LT",
        nextDay: "[މާދަމާ] LT",
        nextWeek: "dddd LT",
        lastDay: "[އިއްޔެ] LT",
        lastWeek: "[ފާއިތުވި] dddd LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "ތެރޭގައި %s",
        past: "ކުރިން %s",
        s: "ސިކުންތުކޮޅެއް",
        ss: "d% ސިކުންތު",
        m: "މިނިޓެއް",
        mm: "މިނިޓު %d",
        h: "ގަޑިއިރެއް",
        hh: "ގަޑިއިރު %d",
        d: "ދުވަހެއް",
        dd: "ދުވަސް %d",
        M: "މަހެއް",
        MM: "މަސް %d",
        y: "އަހަރެއް",
        yy: "އަހަރު %d"
      },
      preparse: function (e) {
        return e.replace(/،/g, ",");
      },
      postformat: function (e) {
        return e.replace(/,/g, "،");
      },
      week: {
        dow: 7,
        doy: 12
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("el", {
      monthsNominativeEl: "Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος".split("_"),
      monthsGenitiveEl: "Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου".split("_"),
      months: function (e, t) {
        return e ? "string" == typeof t && /D/.test(t.substring(0, t.indexOf("MMMM"))) ? this._monthsGenitiveEl[e.month()] : this._monthsNominativeEl[e.month()] : this._monthsNominativeEl;
      },
      monthsShort: "Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ".split("_"),
      weekdays: "Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο".split("_"),
      weekdaysShort: "Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ".split("_"),
      weekdaysMin: "Κυ_Δε_Τρ_Τε_Πε_Πα_Σα".split("_"),
      meridiem: function (e, t, n) {
        return e > 11 ? n ? "μμ" : "ΜΜ" : n ? "πμ" : "ΠΜ";
      },
      isPM: function (e) {
        return "μ" === (e + "").toLowerCase()[0];
      },
      meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
      longDateFormat: {
        LT: "h:mm A",
        LTS: "h:mm:ss A",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY h:mm A",
        LLLL: "dddd, D MMMM YYYY h:mm A"
      },
      calendarEl: {
        sameDay: "[Σήμερα {}] LT",
        nextDay: "[Αύριο {}] LT",
        nextWeek: "dddd [{}] LT",
        lastDay: "[Χθες {}] LT",
        lastWeek: function () {
          switch (this.day()) {
            case 6:
              return "[το προηγούμενο] dddd [{}] LT";
            default:
              return "[την προηγούμενη] dddd [{}] LT";
          }
        },
        sameElse: "L"
      },
      calendar: function (e, t) {
        var n,
          a = this._calendarEl[e],
          r = t && t.hours();
        return n = a, ("undefined" != typeof Function && n instanceof Function || "[object Function]" === Object.prototype.toString.call(n)) && (a = a.apply(t)), a.replace("{}", r % 12 == 1 ? "στη" : "στις");
      },
      relativeTime: {
        future: "σε %s",
        past: "%s πριν",
        s: "λίγα δευτερόλεπτα",
        ss: "%d δευτερόλεπτα",
        m: "ένα λεπτό",
        mm: "%d λεπτά",
        h: "μία ώρα",
        hh: "%d ώρες",
        d: "μία μέρα",
        dd: "%d μέρες",
        M: "ένας μήνας",
        MM: "%d μήνες",
        y: "ένας χρόνος",
        yy: "%d χρόνια"
      },
      dayOfMonthOrdinalParse: /\d{1,2}η/,
      ordinal: "%dη",
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("en-au", {
      months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
      monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
      weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
      weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
      weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
      longDateFormat: {
        LT: "h:mm A",
        LTS: "h:mm:ss A",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY h:mm A",
        LLLL: "dddd, D MMMM YYYY h:mm A"
      },
      calendar: {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
      },
      dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
      ordinal: function (e) {
        var t = e % 10;
        return e + (1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th");
      },
      week: {
        dow: 0,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("en-ca", {
      months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
      monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
      weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
      weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
      weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
      longDateFormat: {
        LT: "h:mm A",
        LTS: "h:mm:ss A",
        L: "YYYY-MM-DD",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
      },
      calendar: {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
      },
      dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
      ordinal: function (e) {
        var t = e % 10;
        return e + (1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th");
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("en-gb", {
      months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
      monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
      weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
      weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
      weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd, D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
      },
      dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
      ordinal: function (e) {
        var t = e % 10;
        return e + (1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th");
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("en-ie", {
      months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
      monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
      weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
      weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
      weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
      },
      dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
      ordinal: function (e) {
        var t = e % 10;
        return e + (1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th");
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("en-il", {
      months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
      monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
      weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
      weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
      weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd, D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
      },
      dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
      ordinal: function (e) {
        var t = e % 10;
        return e + (1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th");
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("en-in", {
      months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
      monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
      weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
      weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
      weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
      longDateFormat: {
        LT: "h:mm A",
        LTS: "h:mm:ss A",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY h:mm A",
        LLLL: "dddd, D MMMM YYYY h:mm A"
      },
      calendar: {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
      },
      dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
      ordinal: function (e) {
        var t = e % 10;
        return e + (1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th");
      },
      week: {
        dow: 0,
        doy: 6
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("en-nz", {
      months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
      monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
      weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
      weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
      weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
      longDateFormat: {
        LT: "h:mm A",
        LTS: "h:mm:ss A",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY h:mm A",
        LLLL: "dddd, D MMMM YYYY h:mm A"
      },
      calendar: {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
      },
      dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
      ordinal: function (e) {
        var t = e % 10;
        return e + (1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th");
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("en-sg", {
      months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
      monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
      weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
      weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
      weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd, D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
      },
      dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
      ordinal: function (e) {
        var t = e % 10;
        return e + (1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th");
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("eo", {
      months: "januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro".split("_"),
      monthsShort: "jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec".split("_"),
      weekdays: "dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato".split("_"),
      weekdaysShort: "dim_lun_mard_merk_ĵaŭ_ven_sab".split("_"),
      weekdaysMin: "di_lu_ma_me_ĵa_ve_sa".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "YYYY-MM-DD",
        LL: "[la] D[-an de] MMMM, YYYY",
        LLL: "[la] D[-an de] MMMM, YYYY HH:mm",
        LLLL: "dddd[n], [la] D[-an de] MMMM, YYYY HH:mm",
        llll: "ddd, [la] D[-an de] MMM, YYYY HH:mm"
      },
      meridiemParse: /[ap]\.t\.m/i,
      isPM: function (e) {
        return "p" === e.charAt(0).toLowerCase();
      },
      meridiem: function (e, t, n) {
        return e > 11 ? n ? "p.t.m." : "P.T.M." : n ? "a.t.m." : "A.T.M.";
      },
      calendar: {
        sameDay: "[Hodiaŭ je] LT",
        nextDay: "[Morgaŭ je] LT",
        nextWeek: "dddd[n je] LT",
        lastDay: "[Hieraŭ je] LT",
        lastWeek: "[pasintan] dddd[n je] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "post %s",
        past: "antaŭ %s",
        s: "kelkaj sekundoj",
        ss: "%d sekundoj",
        m: "unu minuto",
        mm: "%d minutoj",
        h: "unu horo",
        hh: "%d horoj",
        d: "unu tago",
        dd: "%d tagoj",
        M: "unu monato",
        MM: "%d monatoj",
        y: "unu jaro",
        yy: "%d jaroj"
      },
      dayOfMonthOrdinalParse: /\d{1,2}a/,
      ordinal: "%da",
      week: {
        dow: 1,
        doy: 7
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),
      n = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
      a = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i],
      r = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
    e.defineLocale("es", {
      months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
      monthsShort: function (e, a) {
        return e ? /-MMM-/.test(a) ? n[e.month()] : t[e.month()] : t;
      },
      monthsRegex: r,
      monthsShortRegex: r,
      monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
      monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
      monthsParse: a,
      longMonthsParse: a,
      shortMonthsParse: a,
      weekdays: "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),
      weekdaysShort: "dom._lun._mar._mié._jue._vie._sáb.".split("_"),
      weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "H:mm",
        LTS: "H:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D [de] MMMM [de] YYYY",
        LLL: "D [de] MMMM [de] YYYY H:mm",
        LLLL: "dddd, D [de] MMMM [de] YYYY H:mm"
      },
      calendar: {
        sameDay: function () {
          return "[hoy a la" + (1 !== this.hours() ? "s" : "") + "] LT";
        },
        nextDay: function () {
          return "[mañana a la" + (1 !== this.hours() ? "s" : "") + "] LT";
        },
        nextWeek: function () {
          return "dddd [a la" + (1 !== this.hours() ? "s" : "") + "] LT";
        },
        lastDay: function () {
          return "[ayer a la" + (1 !== this.hours() ? "s" : "") + "] LT";
        },
        lastWeek: function () {
          return "[el] dddd [pasado a la" + (1 !== this.hours() ? "s" : "") + "] LT";
        },
        sameElse: "L"
      },
      relativeTime: {
        future: "en %s",
        past: "hace %s",
        s: "unos segundos",
        ss: "%d segundos",
        m: "un minuto",
        mm: "%d minutos",
        h: "una hora",
        hh: "%d horas",
        d: "un día",
        dd: "%d días",
        w: "una semana",
        ww: "%d semanas",
        M: "un mes",
        MM: "%d meses",
        y: "un año",
        yy: "%d años"
      },
      dayOfMonthOrdinalParse: /\d{1,2}º/,
      ordinal: "%dº",
      week: {
        dow: 1,
        doy: 4
      },
      invalidDate: "Fecha inválida"
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),
      n = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
      a = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i],
      r = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
    e.defineLocale("es-do", {
      months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
      monthsShort: function (e, a) {
        return e ? /-MMM-/.test(a) ? n[e.month()] : t[e.month()] : t;
      },
      monthsRegex: r,
      monthsShortRegex: r,
      monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
      monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
      monthsParse: a,
      longMonthsParse: a,
      shortMonthsParse: a,
      weekdays: "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),
      weekdaysShort: "dom._lun._mar._mié._jue._vie._sáb.".split("_"),
      weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "h:mm A",
        LTS: "h:mm:ss A",
        L: "DD/MM/YYYY",
        LL: "D [de] MMMM [de] YYYY",
        LLL: "D [de] MMMM [de] YYYY h:mm A",
        LLLL: "dddd, D [de] MMMM [de] YYYY h:mm A"
      },
      calendar: {
        sameDay: function () {
          return "[hoy a la" + (1 !== this.hours() ? "s" : "") + "] LT";
        },
        nextDay: function () {
          return "[mañana a la" + (1 !== this.hours() ? "s" : "") + "] LT";
        },
        nextWeek: function () {
          return "dddd [a la" + (1 !== this.hours() ? "s" : "") + "] LT";
        },
        lastDay: function () {
          return "[ayer a la" + (1 !== this.hours() ? "s" : "") + "] LT";
        },
        lastWeek: function () {
          return "[el] dddd [pasado a la" + (1 !== this.hours() ? "s" : "") + "] LT";
        },
        sameElse: "L"
      },
      relativeTime: {
        future: "en %s",
        past: "hace %s",
        s: "unos segundos",
        ss: "%d segundos",
        m: "un minuto",
        mm: "%d minutos",
        h: "una hora",
        hh: "%d horas",
        d: "un día",
        dd: "%d días",
        w: "una semana",
        ww: "%d semanas",
        M: "un mes",
        MM: "%d meses",
        y: "un año",
        yy: "%d años"
      },
      dayOfMonthOrdinalParse: /\d{1,2}º/,
      ordinal: "%dº",
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),
      n = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
      a = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i],
      r = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
    e.defineLocale("es-mx", {
      months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
      monthsShort: function (e, a) {
        return e ? /-MMM-/.test(a) ? n[e.month()] : t[e.month()] : t;
      },
      monthsRegex: r,
      monthsShortRegex: r,
      monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
      monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
      monthsParse: a,
      longMonthsParse: a,
      shortMonthsParse: a,
      weekdays: "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),
      weekdaysShort: "dom._lun._mar._mié._jue._vie._sáb.".split("_"),
      weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "H:mm",
        LTS: "H:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D [de] MMMM [de] YYYY",
        LLL: "D [de] MMMM [de] YYYY H:mm",
        LLLL: "dddd, D [de] MMMM [de] YYYY H:mm"
      },
      calendar: {
        sameDay: function () {
          return "[hoy a la" + (1 !== this.hours() ? "s" : "") + "] LT";
        },
        nextDay: function () {
          return "[mañana a la" + (1 !== this.hours() ? "s" : "") + "] LT";
        },
        nextWeek: function () {
          return "dddd [a la" + (1 !== this.hours() ? "s" : "") + "] LT";
        },
        lastDay: function () {
          return "[ayer a la" + (1 !== this.hours() ? "s" : "") + "] LT";
        },
        lastWeek: function () {
          return "[el] dddd [pasado a la" + (1 !== this.hours() ? "s" : "") + "] LT";
        },
        sameElse: "L"
      },
      relativeTime: {
        future: "en %s",
        past: "hace %s",
        s: "unos segundos",
        ss: "%d segundos",
        m: "un minuto",
        mm: "%d minutos",
        h: "una hora",
        hh: "%d horas",
        d: "un día",
        dd: "%d días",
        w: "una semana",
        ww: "%d semanas",
        M: "un mes",
        MM: "%d meses",
        y: "un año",
        yy: "%d años"
      },
      dayOfMonthOrdinalParse: /\d{1,2}º/,
      ordinal: "%dº",
      week: {
        dow: 0,
        doy: 4
      },
      invalidDate: "Fecha inválida"
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),
      n = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
      a = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i],
      r = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
    e.defineLocale("es-us", {
      months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),
      monthsShort: function (e, a) {
        return e ? /-MMM-/.test(a) ? n[e.month()] : t[e.month()] : t;
      },
      monthsRegex: r,
      monthsShortRegex: r,
      monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
      monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
      monthsParse: a,
      longMonthsParse: a,
      shortMonthsParse: a,
      weekdays: "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),
      weekdaysShort: "dom._lun._mar._mié._jue._vie._sáb.".split("_"),
      weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "h:mm A",
        LTS: "h:mm:ss A",
        L: "MM/DD/YYYY",
        LL: "D [de] MMMM [de] YYYY",
        LLL: "D [de] MMMM [de] YYYY h:mm A",
        LLLL: "dddd, D [de] MMMM [de] YYYY h:mm A"
      },
      calendar: {
        sameDay: function () {
          return "[hoy a la" + (1 !== this.hours() ? "s" : "") + "] LT";
        },
        nextDay: function () {
          return "[mañana a la" + (1 !== this.hours() ? "s" : "") + "] LT";
        },
        nextWeek: function () {
          return "dddd [a la" + (1 !== this.hours() ? "s" : "") + "] LT";
        },
        lastDay: function () {
          return "[ayer a la" + (1 !== this.hours() ? "s" : "") + "] LT";
        },
        lastWeek: function () {
          return "[el] dddd [pasado a la" + (1 !== this.hours() ? "s" : "") + "] LT";
        },
        sameElse: "L"
      },
      relativeTime: {
        future: "en %s",
        past: "hace %s",
        s: "unos segundos",
        ss: "%d segundos",
        m: "un minuto",
        mm: "%d minutos",
        h: "una hora",
        hh: "%d horas",
        d: "un día",
        dd: "%d días",
        w: "una semana",
        ww: "%d semanas",
        M: "un mes",
        MM: "%d meses",
        y: "un año",
        yy: "%d años"
      },
      dayOfMonthOrdinalParse: /\d{1,2}º/,
      ordinal: "%dº",
      week: {
        dow: 0,
        doy: 6
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    function t(e, t, n, a) {
      var r = {
        s: ["mõne sekundi", "mõni sekund", "paar sekundit"],
        ss: [e + "sekundi", e + "sekundit"],
        m: ["ühe minuti", "üks minut"],
        mm: [e + " minuti", e + " minutit"],
        h: ["ühe tunni", "tund aega", "üks tund"],
        hh: [e + " tunni", e + " tundi"],
        d: ["ühe päeva", "üks päev"],
        M: ["kuu aja", "kuu aega", "üks kuu"],
        MM: [e + " kuu", e + " kuud"],
        y: ["ühe aasta", "aasta", "üks aasta"],
        yy: [e + " aasta", e + " aastat"]
      };
      return t ? r[n][2] ? r[n][2] : r[n][1] : a ? r[n][0] : r[n][1];
    }
    e.defineLocale("et", {
      months: "jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember".split("_"),
      monthsShort: "jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets".split("_"),
      weekdays: "pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev".split("_"),
      weekdaysShort: "P_E_T_K_N_R_L".split("_"),
      weekdaysMin: "P_E_T_K_N_R_L".split("_"),
      longDateFormat: {
        LT: "H:mm",
        LTS: "H:mm:ss",
        L: "DD.MM.YYYY",
        LL: "D. MMMM YYYY",
        LLL: "D. MMMM YYYY H:mm",
        LLLL: "dddd, D. MMMM YYYY H:mm"
      },
      calendar: {
        sameDay: "[Täna,] LT",
        nextDay: "[Homme,] LT",
        nextWeek: "[Järgmine] dddd LT",
        lastDay: "[Eile,] LT",
        lastWeek: "[Eelmine] dddd LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%s pärast",
        past: "%s tagasi",
        s: t,
        ss: t,
        m: t,
        mm: t,
        h: t,
        hh: t,
        d: t,
        dd: "%d päeva",
        M: t,
        MM: t,
        y: t,
        yy: t
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: "%d.",
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("eu", {
      months: "urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua".split("_"),
      monthsShort: "urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.".split("_"),
      monthsParseExact: !0,
      weekdays: "igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata".split("_"),
      weekdaysShort: "ig._al._ar._az._og._ol._lr.".split("_"),
      weekdaysMin: "ig_al_ar_az_og_ol_lr".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "YYYY-MM-DD",
        LL: "YYYY[ko] MMMM[ren] D[a]",
        LLL: "YYYY[ko] MMMM[ren] D[a] HH:mm",
        LLLL: "dddd, YYYY[ko] MMMM[ren] D[a] HH:mm",
        l: "YYYY-M-D",
        ll: "YYYY[ko] MMM D[a]",
        lll: "YYYY[ko] MMM D[a] HH:mm",
        llll: "ddd, YYYY[ko] MMM D[a] HH:mm"
      },
      calendar: {
        sameDay: "[gaur] LT[etan]",
        nextDay: "[bihar] LT[etan]",
        nextWeek: "dddd LT[etan]",
        lastDay: "[atzo] LT[etan]",
        lastWeek: "[aurreko] dddd LT[etan]",
        sameElse: "L"
      },
      relativeTime: {
        future: "%s barru",
        past: "duela %s",
        s: "segundo batzuk",
        ss: "%d segundo",
        m: "minutu bat",
        mm: "%d minutu",
        h: "ordu bat",
        hh: "%d ordu",
        d: "egun bat",
        dd: "%d egun",
        M: "hilabete bat",
        MM: "%d hilabete",
        y: "urte bat",
        yy: "%d urte"
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: "%d.",
      week: {
        dow: 1,
        doy: 7
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = {
        1: "۱",
        2: "۲",
        3: "۳",
        4: "۴",
        5: "۵",
        6: "۶",
        7: "۷",
        8: "۸",
        9: "۹",
        0: "۰"
      },
      n = {
        "۱": "1",
        "۲": "2",
        "۳": "3",
        "۴": "4",
        "۵": "5",
        "۶": "6",
        "۷": "7",
        "۸": "8",
        "۹": "9",
        "۰": "0"
      };
    e.defineLocale("fa", {
      months: "ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر".split("_"),
      monthsShort: "ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر".split("_"),
      weekdays: "یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه".split("_"),
      weekdaysShort: "یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه".split("_"),
      weekdaysMin: "ی_د_س_چ_پ_ج_ش".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd, D MMMM YYYY HH:mm"
      },
      meridiemParse: /قبل از ظهر|بعد از ظهر/,
      isPM: function (e) {
        return /بعد از ظهر/.test(e);
      },
      meridiem: function (e, t, n) {
        return e < 12 ? "قبل از ظهر" : "بعد از ظهر";
      },
      calendar: {
        sameDay: "[امروز ساعت] LT",
        nextDay: "[فردا ساعت] LT",
        nextWeek: "dddd [ساعت] LT",
        lastDay: "[دیروز ساعت] LT",
        lastWeek: "dddd [پیش] [ساعت] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "در %s",
        past: "%s پیش",
        s: "چند ثانیه",
        ss: "%d ثانیه",
        m: "یک دقیقه",
        mm: "%d دقیقه",
        h: "یک ساعت",
        hh: "%d ساعت",
        d: "یک روز",
        dd: "%d روز",
        M: "یک ماه",
        MM: "%d ماه",
        y: "یک سال",
        yy: "%d سال"
      },
      preparse: function (e) {
        return e.replace(/[۰-۹]/g, function (e) {
          return n[e];
        }).replace(/،/g, ",");
      },
      postformat: function (e) {
        return e.replace(/\d/g, function (e) {
          return t[e];
        }).replace(/,/g, "،");
      },
      dayOfMonthOrdinalParse: /\d{1,2}م/,
      ordinal: "%dم",
      week: {
        dow: 6,
        doy: 12
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = "nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän".split(" "),
      n = ["nolla", "yhden", "kahden", "kolmen", "neljän", "viiden", "kuuden", t[7], t[8], t[9]];
    function a(e, a, r, i) {
      var o = "";
      switch (r) {
        case "s":
          return i ? "muutaman sekunnin" : "muutama sekunti";
        case "ss":
          o = i ? "sekunnin" : "sekuntia";
          break;
        case "m":
          return i ? "minuutin" : "minuutti";
        case "mm":
          o = i ? "minuutin" : "minuuttia";
          break;
        case "h":
          return i ? "tunnin" : "tunti";
        case "hh":
          o = i ? "tunnin" : "tuntia";
          break;
        case "d":
          return i ? "päivän" : "päivä";
        case "dd":
          o = i ? "päivän" : "päivää";
          break;
        case "M":
          return i ? "kuukauden" : "kuukausi";
        case "MM":
          o = i ? "kuukauden" : "kuukautta";
          break;
        case "y":
          return i ? "vuoden" : "vuosi";
        case "yy":
          o = i ? "vuoden" : "vuotta";
      }
      return o = function (e, a) {
        return e < 10 ? a ? n[e] : t[e] : e;
      }(e, i) + " " + o;
    }
    e.defineLocale("fi", {
      months: "tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu".split("_"),
      monthsShort: "tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu".split("_"),
      weekdays: "sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai".split("_"),
      weekdaysShort: "su_ma_ti_ke_to_pe_la".split("_"),
      weekdaysMin: "su_ma_ti_ke_to_pe_la".split("_"),
      longDateFormat: {
        LT: "HH.mm",
        LTS: "HH.mm.ss",
        L: "DD.MM.YYYY",
        LL: "Do MMMM[ta] YYYY",
        LLL: "Do MMMM[ta] YYYY, [klo] HH.mm",
        LLLL: "dddd, Do MMMM[ta] YYYY, [klo] HH.mm",
        l: "D.M.YYYY",
        ll: "Do MMM YYYY",
        lll: "Do MMM YYYY, [klo] HH.mm",
        llll: "ddd, Do MMM YYYY, [klo] HH.mm"
      },
      calendar: {
        sameDay: "[tänään] [klo] LT",
        nextDay: "[huomenna] [klo] LT",
        nextWeek: "dddd [klo] LT",
        lastDay: "[eilen] [klo] LT",
        lastWeek: "[viime] dddd[na] [klo] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%s päästä",
        past: "%s sitten",
        s: a,
        ss: a,
        m: a,
        mm: a,
        h: a,
        hh: a,
        d: a,
        dd: a,
        M: a,
        MM: a,
        y: a,
        yy: a
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: "%d.",
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("fil", {
      months: "Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre".split("_"),
      monthsShort: "Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis".split("_"),
      weekdays: "Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado".split("_"),
      weekdaysShort: "Lin_Lun_Mar_Miy_Huw_Biy_Sab".split("_"),
      weekdaysMin: "Li_Lu_Ma_Mi_Hu_Bi_Sab".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "MM/D/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY HH:mm",
        LLLL: "dddd, MMMM DD, YYYY HH:mm"
      },
      calendar: {
        sameDay: "LT [ngayong araw]",
        nextDay: "[Bukas ng] LT",
        nextWeek: "LT [sa susunod na] dddd",
        lastDay: "LT [kahapon]",
        lastWeek: "LT [noong nakaraang] dddd",
        sameElse: "L"
      },
      relativeTime: {
        future: "sa loob ng %s",
        past: "%s ang nakalipas",
        s: "ilang segundo",
        ss: "%d segundo",
        m: "isang minuto",
        mm: "%d minuto",
        h: "isang oras",
        hh: "%d oras",
        d: "isang araw",
        dd: "%d araw",
        M: "isang buwan",
        MM: "%d buwan",
        y: "isang taon",
        yy: "%d taon"
      },
      dayOfMonthOrdinalParse: /\d{1,2}/,
      ordinal: function (e) {
        return e;
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("fo", {
      months: "januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember".split("_"),
      monthsShort: "jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_"),
      weekdays: "sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur".split("_"),
      weekdaysShort: "sun_mán_týs_mik_hós_frí_ley".split("_"),
      weekdaysMin: "su_má_tý_mi_hó_fr_le".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd D. MMMM, YYYY HH:mm"
      },
      calendar: {
        sameDay: "[Í dag kl.] LT",
        nextDay: "[Í morgin kl.] LT",
        nextWeek: "dddd [kl.] LT",
        lastDay: "[Í gjár kl.] LT",
        lastWeek: "[síðstu] dddd [kl] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "um %s",
        past: "%s síðani",
        s: "fá sekund",
        ss: "%d sekundir",
        m: "ein minuttur",
        mm: "%d minuttir",
        h: "ein tími",
        hh: "%d tímar",
        d: "ein dagur",
        dd: "%d dagar",
        M: "ein mánaður",
        MM: "%d mánaðir",
        y: "eitt ár",
        yy: "%d ár"
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: "%d.",
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
      n = [/^janv/i, /^févr/i, /^mars/i, /^avr/i, /^mai/i, /^juin/i, /^juil/i, /^août/i, /^sept/i, /^oct/i, /^nov/i, /^déc/i];
    e.defineLocale("fr", {
      months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
      monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
      monthsRegex: t,
      monthsShortRegex: t,
      monthsStrictRegex: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
      monthsShortStrictRegex: /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
      monthsParse: n,
      longMonthsParse: n,
      shortMonthsParse: n,
      weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
      weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
      weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[Aujourd’hui à] LT",
        nextDay: "[Demain à] LT",
        nextWeek: "dddd [à] LT",
        lastDay: "[Hier à] LT",
        lastWeek: "dddd [dernier à] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "dans %s",
        past: "il y a %s",
        s: "quelques secondes",
        ss: "%d secondes",
        m: "une minute",
        mm: "%d minutes",
        h: "une heure",
        hh: "%d heures",
        d: "un jour",
        dd: "%d jours",
        w: "une semaine",
        ww: "%d semaines",
        M: "un mois",
        MM: "%d mois",
        y: "un an",
        yy: "%d ans"
      },
      dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
      ordinal: function (e, t) {
        switch (t) {
          case "D":
            return e + (1 === e ? "er" : "");
          default:
          case "M":
          case "Q":
          case "DDD":
          case "d":
            return e + (1 === e ? "er" : "e");
          case "w":
          case "W":
            return e + (1 === e ? "re" : "e");
        }
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("fr-ca", {
      months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
      monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
      monthsParseExact: !0,
      weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
      weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
      weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "YYYY-MM-DD",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[Aujourd’hui à] LT",
        nextDay: "[Demain à] LT",
        nextWeek: "dddd [à] LT",
        lastDay: "[Hier à] LT",
        lastWeek: "dddd [dernier à] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "dans %s",
        past: "il y a %s",
        s: "quelques secondes",
        ss: "%d secondes",
        m: "une minute",
        mm: "%d minutes",
        h: "une heure",
        hh: "%d heures",
        d: "un jour",
        dd: "%d jours",
        M: "un mois",
        MM: "%d mois",
        y: "un an",
        yy: "%d ans"
      },
      dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
      ordinal: function (e, t) {
        switch (t) {
          default:
          case "M":
          case "Q":
          case "D":
          case "DDD":
          case "d":
            return e + (1 === e ? "er" : "e");
          case "w":
          case "W":
            return e + (1 === e ? "re" : "e");
        }
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("fr-ch", {
      months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
      monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
      monthsParseExact: !0,
      weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
      weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
      weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD.MM.YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[Aujourd’hui à] LT",
        nextDay: "[Demain à] LT",
        nextWeek: "dddd [à] LT",
        lastDay: "[Hier à] LT",
        lastWeek: "dddd [dernier à] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "dans %s",
        past: "il y a %s",
        s: "quelques secondes",
        ss: "%d secondes",
        m: "une minute",
        mm: "%d minutes",
        h: "une heure",
        hh: "%d heures",
        d: "un jour",
        dd: "%d jours",
        M: "un mois",
        MM: "%d mois",
        y: "un an",
        yy: "%d ans"
      },
      dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
      ordinal: function (e, t) {
        switch (t) {
          default:
          case "M":
          case "Q":
          case "D":
          case "DDD":
          case "d":
            return e + (1 === e ? "er" : "e");
          case "w":
          case "W":
            return e + (1 === e ? "re" : "e");
        }
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = "jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.".split("_"),
      n = "jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_");
    e.defineLocale("fy", {
      months: "jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber".split("_"),
      monthsShort: function (e, a) {
        return e ? /-MMM-/.test(a) ? n[e.month()] : t[e.month()] : t;
      },
      monthsParseExact: !0,
      weekdays: "snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon".split("_"),
      weekdaysShort: "si._mo._ti._wo._to._fr._so.".split("_"),
      weekdaysMin: "Si_Mo_Ti_Wo_To_Fr_So".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD-MM-YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[hjoed om] LT",
        nextDay: "[moarn om] LT",
        nextWeek: "dddd [om] LT",
        lastDay: "[juster om] LT",
        lastWeek: "[ôfrûne] dddd [om] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "oer %s",
        past: "%s lyn",
        s: "in pear sekonden",
        ss: "%d sekonden",
        m: "ien minút",
        mm: "%d minuten",
        h: "ien oere",
        hh: "%d oeren",
        d: "ien dei",
        dd: "%d dagen",
        M: "ien moanne",
        MM: "%d moannen",
        y: "ien jier",
        yy: "%d jierren"
      },
      dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
      ordinal: function (e) {
        return e + (1 === e || 8 === e || e >= 20 ? "ste" : "de");
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("ga", {
      months: ["Eanáir", "Feabhra", "Márta", "Aibreán", "Bealtaine", "Meitheamh", "Iúil", "Lúnasa", "Meán Fómhair", "Deireadh Fómhair", "Samhain", "Nollaig"],
      monthsShort: ["Ean", "Feabh", "Márt", "Aib", "Beal", "Meith", "Iúil", "Lún", "M.F.", "D.F.", "Samh", "Noll"],
      monthsParseExact: !0,
      weekdays: ["Dé Domhnaigh", "Dé Luain", "Dé Máirt", "Dé Céadaoin", "Déardaoin", "Dé hAoine", "Dé Sathairn"],
      weekdaysShort: ["Domh", "Luan", "Máirt", "Céad", "Déar", "Aoine", "Sath"],
      weekdaysMin: ["Do", "Lu", "Má", "Cé", "Dé", "A", "Sa"],
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd, D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[Inniu ag] LT",
        nextDay: "[Amárach ag] LT",
        nextWeek: "dddd [ag] LT",
        lastDay: "[Inné ag] LT",
        lastWeek: "dddd [seo caite] [ag] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "i %s",
        past: "%s ó shin",
        s: "cúpla soicind",
        ss: "%d soicind",
        m: "nóiméad",
        mm: "%d nóiméad",
        h: "uair an chloig",
        hh: "%d uair an chloig",
        d: "lá",
        dd: "%d lá",
        M: "mí",
        MM: "%d míonna",
        y: "bliain",
        yy: "%d bliain"
      },
      dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
      ordinal: function (e) {
        return e + (1 === e ? "d" : e % 10 == 2 ? "na" : "mh");
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("gd", {
      months: ["Am Faoilleach", "An Gearran", "Am Màrt", "An Giblean", "An Cèitean", "An t-Ògmhios", "An t-Iuchar", "An Lùnastal", "An t-Sultain", "An Dàmhair", "An t-Samhain", "An Dùbhlachd"],
      monthsShort: ["Faoi", "Gear", "Màrt", "Gibl", "Cèit", "Ògmh", "Iuch", "Lùn", "Sult", "Dàmh", "Samh", "Dùbh"],
      monthsParseExact: !0,
      weekdays: ["Didòmhnaich", "Diluain", "Dimàirt", "Diciadain", "Diardaoin", "Dihaoine", "Disathairne"],
      weekdaysShort: ["Did", "Dil", "Dim", "Dic", "Dia", "Dih", "Dis"],
      weekdaysMin: ["Dò", "Lu", "Mà", "Ci", "Ar", "Ha", "Sa"],
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd, D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[An-diugh aig] LT",
        nextDay: "[A-màireach aig] LT",
        nextWeek: "dddd [aig] LT",
        lastDay: "[An-dè aig] LT",
        lastWeek: "dddd [seo chaidh] [aig] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "ann an %s",
        past: "bho chionn %s",
        s: "beagan diogan",
        ss: "%d diogan",
        m: "mionaid",
        mm: "%d mionaidean",
        h: "uair",
        hh: "%d uairean",
        d: "latha",
        dd: "%d latha",
        M: "mìos",
        MM: "%d mìosan",
        y: "bliadhna",
        yy: "%d bliadhna"
      },
      dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
      ordinal: function (e) {
        return e + (1 === e ? "d" : e % 10 == 2 ? "na" : "mh");
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("gl", {
      months: "xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro".split("_"),
      monthsShort: "xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.".split("_"),
      monthsParseExact: !0,
      weekdays: "domingo_luns_martes_mércores_xoves_venres_sábado".split("_"),
      weekdaysShort: "dom._lun._mar._mér._xov._ven._sáb.".split("_"),
      weekdaysMin: "do_lu_ma_mé_xo_ve_sá".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "H:mm",
        LTS: "H:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D [de] MMMM [de] YYYY",
        LLL: "D [de] MMMM [de] YYYY H:mm",
        LLLL: "dddd, D [de] MMMM [de] YYYY H:mm"
      },
      calendar: {
        sameDay: function () {
          return "[hoxe " + (1 !== this.hours() ? "ás" : "á") + "] LT";
        },
        nextDay: function () {
          return "[mañá " + (1 !== this.hours() ? "ás" : "á") + "] LT";
        },
        nextWeek: function () {
          return "dddd [" + (1 !== this.hours() ? "ás" : "a") + "] LT";
        },
        lastDay: function () {
          return "[onte " + (1 !== this.hours() ? "á" : "a") + "] LT";
        },
        lastWeek: function () {
          return "[o] dddd [pasado " + (1 !== this.hours() ? "ás" : "a") + "] LT";
        },
        sameElse: "L"
      },
      relativeTime: {
        future: function (e) {
          return 0 === e.indexOf("un") ? "n" + e : "en " + e;
        },
        past: "hai %s",
        s: "uns segundos",
        ss: "%d segundos",
        m: "un minuto",
        mm: "%d minutos",
        h: "unha hora",
        hh: "%d horas",
        d: "un día",
        dd: "%d días",
        M: "un mes",
        MM: "%d meses",
        y: "un ano",
        yy: "%d anos"
      },
      dayOfMonthOrdinalParse: /\d{1,2}º/,
      ordinal: "%dº",
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    function t(e, t, n, a) {
      var r = {
        s: ["थोडया सॅकंडांनी", "थोडे सॅकंड"],
        ss: [e + " सॅकंडांनी", e + " सॅकंड"],
        m: ["एका मिणटान", "एक मिनूट"],
        mm: [e + " मिणटांनी", e + " मिणटां"],
        h: ["एका वरान", "एक वर"],
        hh: [e + " वरांनी", e + " वरां"],
        d: ["एका दिसान", "एक दीस"],
        dd: [e + " दिसांनी", e + " दीस"],
        M: ["एका म्हयन्यान", "एक म्हयनो"],
        MM: [e + " म्हयन्यानी", e + " म्हयने"],
        y: ["एका वर्सान", "एक वर्स"],
        yy: [e + " वर्सांनी", e + " वर्सां"]
      };
      return a ? r[n][0] : r[n][1];
    }
    e.defineLocale("gom-deva", {
      months: {
        standalone: "जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर".split("_"),
        format: "जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या".split("_"),
        isFormat: /MMMM(\s)+D[oD]?/
      },
      monthsShort: "जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.".split("_"),
      monthsParseExact: !0,
      weekdays: "आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार".split("_"),
      weekdaysShort: "आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.".split("_"),
      weekdaysMin: "आ_सो_मं_बु_ब्रे_सु_शे".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "A h:mm [वाजतां]",
        LTS: "A h:mm:ss [वाजतां]",
        L: "DD-MM-YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY A h:mm [वाजतां]",
        LLLL: "dddd, MMMM Do, YYYY, A h:mm [वाजतां]",
        llll: "ddd, D MMM YYYY, A h:mm [वाजतां]"
      },
      calendar: {
        sameDay: "[आयज] LT",
        nextDay: "[फाल्यां] LT",
        nextWeek: "[फुडलो] dddd[,] LT",
        lastDay: "[काल] LT",
        lastWeek: "[फाटलो] dddd[,] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%s",
        past: "%s आदीं",
        s: t,
        ss: t,
        m: t,
        mm: t,
        h: t,
        hh: t,
        d: t,
        dd: t,
        M: t,
        MM: t,
        y: t,
        yy: t
      },
      dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
      ordinal: function (e, t) {
        switch (t) {
          case "D":
            return e + "वेर";
          default:
          case "M":
          case "Q":
          case "DDD":
          case "d":
          case "w":
          case "W":
            return e;
        }
      },
      week: {
        dow: 0,
        doy: 3
      },
      meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
      meridiemHour: function (e, t) {
        return 12 === e && (e = 0), "राती" === t ? e < 4 ? e : e + 12 : "सकाळीं" === t ? e : "दनपारां" === t ? e > 12 ? e : e + 12 : "सांजे" === t ? e + 12 : void 0;
      },
      meridiem: function (e, t, n) {
        return e < 4 ? "राती" : e < 12 ? "सकाळीं" : e < 16 ? "दनपारां" : e < 20 ? "सांजे" : "राती";
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    function t(e, t, n, a) {
      var r = {
        s: ["thoddea sekondamni", "thodde sekond"],
        ss: [e + " sekondamni", e + " sekond"],
        m: ["eka mintan", "ek minut"],
        mm: [e + " mintamni", e + " mintam"],
        h: ["eka voran", "ek vor"],
        hh: [e + " voramni", e + " voram"],
        d: ["eka disan", "ek dis"],
        dd: [e + " disamni", e + " dis"],
        M: ["eka mhoinean", "ek mhoino"],
        MM: [e + " mhoineamni", e + " mhoine"],
        y: ["eka vorsan", "ek voros"],
        yy: [e + " vorsamni", e + " vorsam"]
      };
      return a ? r[n][0] : r[n][1];
    }
    e.defineLocale("gom-latn", {
      months: {
        standalone: "Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr".split("_"),
        format: "Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea".split("_"),
        isFormat: /MMMM(\s)+D[oD]?/
      },
      monthsShort: "Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.".split("_"),
      monthsParseExact: !0,
      weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split("_"),
      weekdaysShort: "Ait._Som._Mon._Bud._Bre._Suk._Son.".split("_"),
      weekdaysMin: "Ai_Sm_Mo_Bu_Br_Su_Sn".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "A h:mm [vazta]",
        LTS: "A h:mm:ss [vazta]",
        L: "DD-MM-YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY A h:mm [vazta]",
        LLLL: "dddd, MMMM Do, YYYY, A h:mm [vazta]",
        llll: "ddd, D MMM YYYY, A h:mm [vazta]"
      },
      calendar: {
        sameDay: "[Aiz] LT",
        nextDay: "[Faleam] LT",
        nextWeek: "[Fuddlo] dddd[,] LT",
        lastDay: "[Kal] LT",
        lastWeek: "[Fattlo] dddd[,] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%s",
        past: "%s adim",
        s: t,
        ss: t,
        m: t,
        mm: t,
        h: t,
        hh: t,
        d: t,
        dd: t,
        M: t,
        MM: t,
        y: t,
        yy: t
      },
      dayOfMonthOrdinalParse: /\d{1,2}(er)/,
      ordinal: function (e, t) {
        switch (t) {
          case "D":
            return e + "er";
          default:
          case "M":
          case "Q":
          case "DDD":
          case "d":
          case "w":
          case "W":
            return e;
        }
      },
      week: {
        dow: 0,
        doy: 3
      },
      meridiemParse: /rati|sokallim|donparam|sanje/,
      meridiemHour: function (e, t) {
        return 12 === e && (e = 0), "rati" === t ? e < 4 ? e : e + 12 : "sokallim" === t ? e : "donparam" === t ? e > 12 ? e : e + 12 : "sanje" === t ? e + 12 : void 0;
      },
      meridiem: function (e, t, n) {
        return e < 4 ? "rati" : e < 12 ? "sokallim" : e < 16 ? "donparam" : e < 20 ? "sanje" : "rati";
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = {
        1: "૧",
        2: "૨",
        3: "૩",
        4: "૪",
        5: "૫",
        6: "૬",
        7: "૭",
        8: "૮",
        9: "૯",
        0: "૦"
      },
      n = {
        "૧": "1",
        "૨": "2",
        "૩": "3",
        "૪": "4",
        "૫": "5",
        "૬": "6",
        "૭": "7",
        "૮": "8",
        "૯": "9",
        "૦": "0"
      };
    e.defineLocale("gu", {
      months: "જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર".split("_"),
      monthsShort: "જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.".split("_"),
      monthsParseExact: !0,
      weekdays: "રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર".split("_"),
      weekdaysShort: "રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ".split("_"),
      weekdaysMin: "ર_સો_મં_બુ_ગુ_શુ_શ".split("_"),
      longDateFormat: {
        LT: "A h:mm વાગ્યે",
        LTS: "A h:mm:ss વાગ્યે",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY, A h:mm વાગ્યે",
        LLLL: "dddd, D MMMM YYYY, A h:mm વાગ્યે"
      },
      calendar: {
        sameDay: "[આજ] LT",
        nextDay: "[કાલે] LT",
        nextWeek: "dddd, LT",
        lastDay: "[ગઇકાલે] LT",
        lastWeek: "[પાછલા] dddd, LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%s મા",
        past: "%s પહેલા",
        s: "અમુક પળો",
        ss: "%d સેકંડ",
        m: "એક મિનિટ",
        mm: "%d મિનિટ",
        h: "એક કલાક",
        hh: "%d કલાક",
        d: "એક દિવસ",
        dd: "%d દિવસ",
        M: "એક મહિનો",
        MM: "%d મહિનો",
        y: "એક વર્ષ",
        yy: "%d વર્ષ"
      },
      preparse: function (e) {
        return e.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (e) {
          return n[e];
        });
      },
      postformat: function (e) {
        return e.replace(/\d/g, function (e) {
          return t[e];
        });
      },
      meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
      meridiemHour: function (e, t) {
        return 12 === e && (e = 0), "રાત" === t ? e < 4 ? e : e + 12 : "સવાર" === t ? e : "બપોર" === t ? e >= 10 ? e : e + 12 : "સાંજ" === t ? e + 12 : void 0;
      },
      meridiem: function (e, t, n) {
        return e < 4 ? "રાત" : e < 10 ? "સવાર" : e < 17 ? "બપોર" : e < 20 ? "સાંજ" : "રાત";
      },
      week: {
        dow: 0,
        doy: 6
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("he", {
      months: "ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר".split("_"),
      monthsShort: "ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳".split("_"),
      weekdays: "ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת".split("_"),
      weekdaysShort: "א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳".split("_"),
      weekdaysMin: "א_ב_ג_ד_ה_ו_ש".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D [ב]MMMM YYYY",
        LLL: "D [ב]MMMM YYYY HH:mm",
        LLLL: "dddd, D [ב]MMMM YYYY HH:mm",
        l: "D/M/YYYY",
        ll: "D MMM YYYY",
        lll: "D MMM YYYY HH:mm",
        llll: "ddd, D MMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[היום ב־]LT",
        nextDay: "[מחר ב־]LT",
        nextWeek: "dddd [בשעה] LT",
        lastDay: "[אתמול ב־]LT",
        lastWeek: "[ביום] dddd [האחרון בשעה] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "בעוד %s",
        past: "לפני %s",
        s: "מספר שניות",
        ss: "%d שניות",
        m: "דקה",
        mm: "%d דקות",
        h: "שעה",
        hh: function (e) {
          return 2 === e ? "שעתיים" : e + " שעות";
        },
        d: "יום",
        dd: function (e) {
          return 2 === e ? "יומיים" : e + " ימים";
        },
        M: "חודש",
        MM: function (e) {
          return 2 === e ? "חודשיים" : e + " חודשים";
        },
        y: "שנה",
        yy: function (e) {
          return 2 === e ? "שנתיים" : e % 10 == 0 && 10 !== e ? e + " שנה" : e + " שנים";
        }
      },
      meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
      isPM: function (e) {
        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(e);
      },
      meridiem: function (e, t, n) {
        return e < 5 ? "לפנות בוקר" : e < 10 ? "בבוקר" : e < 12 ? n ? 'לפנה"צ' : "לפני הצהריים" : e < 18 ? n ? 'אחה"צ' : "אחרי הצהריים" : "בערב";
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = {
        1: "१",
        2: "२",
        3: "३",
        4: "४",
        5: "५",
        6: "६",
        7: "७",
        8: "८",
        9: "९",
        0: "०"
      },
      n = {
        "१": "1",
        "२": "2",
        "३": "3",
        "४": "4",
        "५": "5",
        "६": "6",
        "७": "7",
        "८": "8",
        "९": "9",
        "०": "0"
      },
      a = [/^जन/i, /^फ़र|फर/i, /^मार्च/i, /^अप्रै/i, /^मई/i, /^जून/i, /^जुल/i, /^अग/i, /^सितं|सित/i, /^अक्टू/i, /^नव|नवं/i, /^दिसं|दिस/i];
    e.defineLocale("hi", {
      months: {
        format: "जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर".split("_"),
        standalone: "जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर".split("_")
      },
      monthsShort: "जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.".split("_"),
      weekdays: "रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार".split("_"),
      weekdaysShort: "रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि".split("_"),
      weekdaysMin: "र_सो_मं_बु_गु_शु_श".split("_"),
      longDateFormat: {
        LT: "A h:mm बजे",
        LTS: "A h:mm:ss बजे",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY, A h:mm बजे",
        LLLL: "dddd, D MMMM YYYY, A h:mm बजे"
      },
      monthsParse: a,
      longMonthsParse: a,
      shortMonthsParse: [/^जन/i, /^फ़र/i, /^मार्च/i, /^अप्रै/i, /^मई/i, /^जून/i, /^जुल/i, /^अग/i, /^सित/i, /^अक्टू/i, /^नव/i, /^दिस/i],
      monthsRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
      monthsShortRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
      monthsStrictRegex: /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
      monthsShortStrictRegex: /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
      calendar: {
        sameDay: "[आज] LT",
        nextDay: "[कल] LT",
        nextWeek: "dddd, LT",
        lastDay: "[कल] LT",
        lastWeek: "[पिछले] dddd, LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%s में",
        past: "%s पहले",
        s: "कुछ ही क्षण",
        ss: "%d सेकंड",
        m: "एक मिनट",
        mm: "%d मिनट",
        h: "एक घंटा",
        hh: "%d घंटे",
        d: "एक दिन",
        dd: "%d दिन",
        M: "एक महीने",
        MM: "%d महीने",
        y: "एक वर्ष",
        yy: "%d वर्ष"
      },
      preparse: function (e) {
        return e.replace(/[१२३४५६७८९०]/g, function (e) {
          return n[e];
        });
      },
      postformat: function (e) {
        return e.replace(/\d/g, function (e) {
          return t[e];
        });
      },
      meridiemParse: /रात|सुबह|दोपहर|शाम/,
      meridiemHour: function (e, t) {
        return 12 === e && (e = 0), "रात" === t ? e < 4 ? e : e + 12 : "सुबह" === t ? e : "दोपहर" === t ? e >= 10 ? e : e + 12 : "शाम" === t ? e + 12 : void 0;
      },
      meridiem: function (e, t, n) {
        return e < 4 ? "रात" : e < 10 ? "सुबह" : e < 17 ? "दोपहर" : e < 20 ? "शाम" : "रात";
      },
      week: {
        dow: 0,
        doy: 6
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    function t(e, t, n) {
      var a = e + " ";
      switch (n) {
        case "ss":
          return a += 1 === e ? "sekunda" : 2 === e || 3 === e || 4 === e ? "sekunde" : "sekundi";
        case "m":
          return t ? "jedna minuta" : "jedne minute";
        case "mm":
          return a += 1 === e ? "minuta" : 2 === e || 3 === e || 4 === e ? "minute" : "minuta";
        case "h":
          return t ? "jedan sat" : "jednog sata";
        case "hh":
          return a += 1 === e ? "sat" : 2 === e || 3 === e || 4 === e ? "sata" : "sati";
        case "dd":
          return a += 1 === e ? "dan" : "dana";
        case "MM":
          return a += 1 === e ? "mjesec" : 2 === e || 3 === e || 4 === e ? "mjeseca" : "mjeseci";
        case "yy":
          return a += 1 === e ? "godina" : 2 === e || 3 === e || 4 === e ? "godine" : "godina";
      }
    }
    e.defineLocale("hr", {
      months: {
        format: "siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca".split("_"),
        standalone: "siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac".split("_")
      },
      monthsShort: "sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.".split("_"),
      monthsParseExact: !0,
      weekdays: "nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split("_"),
      weekdaysShort: "ned._pon._uto._sri._čet._pet._sub.".split("_"),
      weekdaysMin: "ne_po_ut_sr_če_pe_su".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "H:mm",
        LTS: "H:mm:ss",
        L: "DD.MM.YYYY",
        LL: "Do MMMM YYYY",
        LLL: "Do MMMM YYYY H:mm",
        LLLL: "dddd, Do MMMM YYYY H:mm"
      },
      calendar: {
        sameDay: "[danas u] LT",
        nextDay: "[sutra u] LT",
        nextWeek: function () {
          switch (this.day()) {
            case 0:
              return "[u] [nedjelju] [u] LT";
            case 3:
              return "[u] [srijedu] [u] LT";
            case 6:
              return "[u] [subotu] [u] LT";
            case 1:
            case 2:
            case 4:
            case 5:
              return "[u] dddd [u] LT";
          }
        },
        lastDay: "[jučer u] LT",
        lastWeek: function () {
          switch (this.day()) {
            case 0:
              return "[prošlu] [nedjelju] [u] LT";
            case 3:
              return "[prošlu] [srijedu] [u] LT";
            case 6:
              return "[prošle] [subote] [u] LT";
            case 1:
            case 2:
            case 4:
            case 5:
              return "[prošli] dddd [u] LT";
          }
        },
        sameElse: "L"
      },
      relativeTime: {
        future: "za %s",
        past: "prije %s",
        s: "par sekundi",
        ss: t,
        m: t,
        mm: t,
        h: t,
        hh: t,
        d: "dan",
        dd: t,
        M: "mjesec",
        MM: t,
        y: "godinu",
        yy: t
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: "%d.",
      week: {
        dow: 1,
        doy: 7
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = "vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton".split(" ");
    function n(e, t, n, a) {
      var r = e;
      switch (n) {
        case "s":
          return a || t ? "néhány másodperc" : "néhány másodperce";
        case "ss":
          return r + (a || t) ? " másodperc" : " másodperce";
        case "m":
          return "egy" + (a || t ? " perc" : " perce");
        case "mm":
          return r + (a || t ? " perc" : " perce");
        case "h":
          return "egy" + (a || t ? " óra" : " órája");
        case "hh":
          return r + (a || t ? " óra" : " órája");
        case "d":
          return "egy" + (a || t ? " nap" : " napja");
        case "dd":
          return r + (a || t ? " nap" : " napja");
        case "M":
          return "egy" + (a || t ? " hónap" : " hónapja");
        case "MM":
          return r + (a || t ? " hónap" : " hónapja");
        case "y":
          return "egy" + (a || t ? " év" : " éve");
        case "yy":
          return r + (a || t ? " év" : " éve");
      }
      return "";
    }
    function a(e) {
      return (e ? "" : "[múlt] ") + "[" + t[this.day()] + "] LT[-kor]";
    }
    e.defineLocale("hu", {
      months: "január_február_március_április_május_június_július_augusztus_szeptember_október_november_december".split("_"),
      monthsShort: "jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.".split("_"),
      monthsParseExact: !0,
      weekdays: "vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat".split("_"),
      weekdaysShort: "vas_hét_kedd_sze_csüt_pén_szo".split("_"),
      weekdaysMin: "v_h_k_sze_cs_p_szo".split("_"),
      longDateFormat: {
        LT: "H:mm",
        LTS: "H:mm:ss",
        L: "YYYY.MM.DD.",
        LL: "YYYY. MMMM D.",
        LLL: "YYYY. MMMM D. H:mm",
        LLLL: "YYYY. MMMM D., dddd H:mm"
      },
      meridiemParse: /de|du/i,
      isPM: function (e) {
        return "u" === e.charAt(1).toLowerCase();
      },
      meridiem: function (e, t, n) {
        return e < 12 ? !0 === n ? "de" : "DE" : !0 === n ? "du" : "DU";
      },
      calendar: {
        sameDay: "[ma] LT[-kor]",
        nextDay: "[holnap] LT[-kor]",
        nextWeek: function () {
          return a.call(this, !0);
        },
        lastDay: "[tegnap] LT[-kor]",
        lastWeek: function () {
          return a.call(this, !1);
        },
        sameElse: "L"
      },
      relativeTime: {
        future: "%s múlva",
        past: "%s",
        s: n,
        ss: n,
        m: n,
        mm: n,
        h: n,
        hh: n,
        d: n,
        dd: n,
        M: n,
        MM: n,
        y: n,
        yy: n
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: "%d.",
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("hy-am", {
      months: {
        format: "հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի".split("_"),
        standalone: "հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր".split("_")
      },
      monthsShort: "հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ".split("_"),
      weekdays: "կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ".split("_"),
      weekdaysShort: "կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ".split("_"),
      weekdaysMin: "կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD.MM.YYYY",
        LL: "D MMMM YYYY թ.",
        LLL: "D MMMM YYYY թ., HH:mm",
        LLLL: "dddd, D MMMM YYYY թ., HH:mm"
      },
      calendar: {
        sameDay: "[այսօր] LT",
        nextDay: "[վաղը] LT",
        lastDay: "[երեկ] LT",
        nextWeek: function () {
          return "dddd [օրը ժամը] LT";
        },
        lastWeek: function () {
          return "[անցած] dddd [օրը ժամը] LT";
        },
        sameElse: "L"
      },
      relativeTime: {
        future: "%s հետո",
        past: "%s առաջ",
        s: "մի քանի վայրկյան",
        ss: "%d վայրկյան",
        m: "րոպե",
        mm: "%d րոպե",
        h: "ժամ",
        hh: "%d ժամ",
        d: "օր",
        dd: "%d օր",
        M: "ամիս",
        MM: "%d ամիս",
        y: "տարի",
        yy: "%d տարի"
      },
      meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
      isPM: function (e) {
        return /^(ցերեկվա|երեկոյան)$/.test(e);
      },
      meridiem: function (e) {
        return e < 4 ? "գիշերվա" : e < 12 ? "առավոտվա" : e < 17 ? "ցերեկվա" : "երեկոյան";
      },
      dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
      ordinal: function (e, t) {
        switch (t) {
          case "DDD":
          case "w":
          case "W":
          case "DDDo":
            return 1 === e ? e + "-ին" : e + "-րդ";
          default:
            return e;
        }
      },
      week: {
        dow: 1,
        doy: 7
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("id", {
      months: "Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember".split("_"),
      monthsShort: "Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des".split("_"),
      weekdays: "Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu".split("_"),
      weekdaysShort: "Min_Sen_Sel_Rab_Kam_Jum_Sab".split("_"),
      weekdaysMin: "Mg_Sn_Sl_Rb_Km_Jm_Sb".split("_"),
      longDateFormat: {
        LT: "HH.mm",
        LTS: "HH.mm.ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY [pukul] HH.mm",
        LLLL: "dddd, D MMMM YYYY [pukul] HH.mm"
      },
      meridiemParse: /pagi|siang|sore|malam/,
      meridiemHour: function (e, t) {
        return 12 === e && (e = 0), "pagi" === t ? e : "siang" === t ? e >= 11 ? e : e + 12 : "sore" === t || "malam" === t ? e + 12 : void 0;
      },
      meridiem: function (e, t, n) {
        return e < 11 ? "pagi" : e < 15 ? "siang" : e < 19 ? "sore" : "malam";
      },
      calendar: {
        sameDay: "[Hari ini pukul] LT",
        nextDay: "[Besok pukul] LT",
        nextWeek: "dddd [pukul] LT",
        lastDay: "[Kemarin pukul] LT",
        lastWeek: "dddd [lalu pukul] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "dalam %s",
        past: "%s yang lalu",
        s: "beberapa detik",
        ss: "%d detik",
        m: "semenit",
        mm: "%d menit",
        h: "sejam",
        hh: "%d jam",
        d: "sehari",
        dd: "%d hari",
        M: "sebulan",
        MM: "%d bulan",
        y: "setahun",
        yy: "%d tahun"
      },
      week: {
        dow: 0,
        doy: 6
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    function t(e) {
      return e % 100 == 11 || e % 10 != 1;
    }
    function n(e, n, a, r) {
      var i = e + " ";
      switch (a) {
        case "s":
          return n || r ? "nokkrar sekúndur" : "nokkrum sekúndum";
        case "ss":
          return t(e) ? i + (n || r ? "sekúndur" : "sekúndum") : i + "sekúnda";
        case "m":
          return n ? "mínúta" : "mínútu";
        case "mm":
          return t(e) ? i + (n || r ? "mínútur" : "mínútum") : n ? i + "mínúta" : i + "mínútu";
        case "hh":
          return t(e) ? i + (n || r ? "klukkustundir" : "klukkustundum") : i + "klukkustund";
        case "d":
          return n ? "dagur" : r ? "dag" : "degi";
        case "dd":
          return t(e) ? n ? i + "dagar" : i + (r ? "daga" : "dögum") : n ? i + "dagur" : i + (r ? "dag" : "degi");
        case "M":
          return n ? "mánuður" : r ? "mánuð" : "mánuði";
        case "MM":
          return t(e) ? n ? i + "mánuðir" : i + (r ? "mánuði" : "mánuðum") : n ? i + "mánuður" : i + (r ? "mánuð" : "mánuði");
        case "y":
          return n || r ? "ár" : "ári";
        case "yy":
          return t(e) ? i + (n || r ? "ár" : "árum") : i + (n || r ? "ár" : "ári");
      }
    }
    e.defineLocale("is", {
      months: "janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember".split("_"),
      monthsShort: "jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des".split("_"),
      weekdays: "sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur".split("_"),
      weekdaysShort: "sun_mán_þri_mið_fim_fös_lau".split("_"),
      weekdaysMin: "Su_Má_Þr_Mi_Fi_Fö_La".split("_"),
      longDateFormat: {
        LT: "H:mm",
        LTS: "H:mm:ss",
        L: "DD.MM.YYYY",
        LL: "D. MMMM YYYY",
        LLL: "D. MMMM YYYY [kl.] H:mm",
        LLLL: "dddd, D. MMMM YYYY [kl.] H:mm"
      },
      calendar: {
        sameDay: "[í dag kl.] LT",
        nextDay: "[á morgun kl.] LT",
        nextWeek: "dddd [kl.] LT",
        lastDay: "[í gær kl.] LT",
        lastWeek: "[síðasta] dddd [kl.] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "eftir %s",
        past: "fyrir %s síðan",
        s: n,
        ss: n,
        m: n,
        mm: n,
        h: "klukkustund",
        hh: n,
        d: n,
        dd: n,
        M: n,
        MM: n,
        y: n,
        yy: n
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: "%d.",
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("it", {
      months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),
      monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
      weekdays: "domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split("_"),
      weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
      weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: function () {
          return "[Oggi a" + (this.hours() > 1 ? "lle " : 0 === this.hours() ? " " : "ll'") + "]LT";
        },
        nextDay: function () {
          return "[Domani a" + (this.hours() > 1 ? "lle " : 0 === this.hours() ? " " : "ll'") + "]LT";
        },
        nextWeek: function () {
          return "dddd [a" + (this.hours() > 1 ? "lle " : 0 === this.hours() ? " " : "ll'") + "]LT";
        },
        lastDay: function () {
          return "[Ieri a" + (this.hours() > 1 ? "lle " : 0 === this.hours() ? " " : "ll'") + "]LT";
        },
        lastWeek: function () {
          switch (this.day()) {
            case 0:
              return "[La scorsa] dddd [a" + (this.hours() > 1 ? "lle " : 0 === this.hours() ? " " : "ll'") + "]LT";
            default:
              return "[Lo scorso] dddd [a" + (this.hours() > 1 ? "lle " : 0 === this.hours() ? " " : "ll'") + "]LT";
          }
        },
        sameElse: "L"
      },
      relativeTime: {
        future: "tra %s",
        past: "%s fa",
        s: "alcuni secondi",
        ss: "%d secondi",
        m: "un minuto",
        mm: "%d minuti",
        h: "un'ora",
        hh: "%d ore",
        d: "un giorno",
        dd: "%d giorni",
        w: "una settimana",
        ww: "%d settimane",
        M: "un mese",
        MM: "%d mesi",
        y: "un anno",
        yy: "%d anni"
      },
      dayOfMonthOrdinalParse: /\d{1,2}º/,
      ordinal: "%dº",
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("it-ch", {
      months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),
      monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
      weekdays: "domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split("_"),
      weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
      weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD.MM.YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[Oggi alle] LT",
        nextDay: "[Domani alle] LT",
        nextWeek: "dddd [alle] LT",
        lastDay: "[Ieri alle] LT",
        lastWeek: function () {
          switch (this.day()) {
            case 0:
              return "[la scorsa] dddd [alle] LT";
            default:
              return "[lo scorso] dddd [alle] LT";
          }
        },
        sameElse: "L"
      },
      relativeTime: {
        future: function (e) {
          return (/^[0-9].+$/.test(e) ? "tra" : "in") + " " + e;
        },
        past: "%s fa",
        s: "alcuni secondi",
        ss: "%d secondi",
        m: "un minuto",
        mm: "%d minuti",
        h: "un'ora",
        hh: "%d ore",
        d: "un giorno",
        dd: "%d giorni",
        M: "un mese",
        MM: "%d mesi",
        y: "un anno",
        yy: "%d anni"
      },
      dayOfMonthOrdinalParse: /\d{1,2}º/,
      ordinal: "%dº",
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("ja", {
      eras: [{
        since: "2019-05-01",
        offset: 1,
        name: "令和",
        narrow: "㋿",
        abbr: "R"
      }, {
        since: "1989-01-08",
        until: "2019-04-30",
        offset: 1,
        name: "平成",
        narrow: "㍻",
        abbr: "H"
      }, {
        since: "1926-12-25",
        until: "1989-01-07",
        offset: 1,
        name: "昭和",
        narrow: "㍼",
        abbr: "S"
      }, {
        since: "1912-07-30",
        until: "1926-12-24",
        offset: 1,
        name: "大正",
        narrow: "㍽",
        abbr: "T"
      }, {
        since: "1873-01-01",
        until: "1912-07-29",
        offset: 6,
        name: "明治",
        narrow: "㍾",
        abbr: "M"
      }, {
        since: "0001-01-01",
        until: "1873-12-31",
        offset: 1,
        name: "西暦",
        narrow: "AD",
        abbr: "AD"
      }, {
        since: "0000-12-31",
        until: -1 / 0,
        offset: 1,
        name: "紀元前",
        narrow: "BC",
        abbr: "BC"
      }],
      eraYearOrdinalRegex: /(元|\d+)年/,
      eraYearOrdinalParse: function (e, t) {
        return "元" === t[1] ? 1 : parseInt(t[1] || e, 10);
      },
      months: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
      monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
      weekdays: "日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日".split("_"),
      weekdaysShort: "日_月_火_水_木_金_土".split("_"),
      weekdaysMin: "日_月_火_水_木_金_土".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "YYYY/MM/DD",
        LL: "YYYY年M月D日",
        LLL: "YYYY年M月D日 HH:mm",
        LLLL: "YYYY年M月D日 dddd HH:mm",
        l: "YYYY/MM/DD",
        ll: "YYYY年M月D日",
        lll: "YYYY年M月D日 HH:mm",
        llll: "YYYY年M月D日(ddd) HH:mm"
      },
      meridiemParse: /午前|午後/i,
      isPM: function (e) {
        return "午後" === e;
      },
      meridiem: function (e, t, n) {
        return e < 12 ? "午前" : "午後";
      },
      calendar: {
        sameDay: "[今日] LT",
        nextDay: "[明日] LT",
        nextWeek: function (e) {
          return e.week() !== this.week() ? "[来週]dddd LT" : "dddd LT";
        },
        lastDay: "[昨日] LT",
        lastWeek: function (e) {
          return this.week() !== e.week() ? "[先週]dddd LT" : "dddd LT";
        },
        sameElse: "L"
      },
      dayOfMonthOrdinalParse: /\d{1,2}日/,
      ordinal: function (e, t) {
        switch (t) {
          case "y":
            return 1 === e ? "元年" : e + "年";
          case "d":
          case "D":
          case "DDD":
            return e + "日";
          default:
            return e;
        }
      },
      relativeTime: {
        future: "%s後",
        past: "%s前",
        s: "数秒",
        ss: "%d秒",
        m: "1分",
        mm: "%d分",
        h: "1時間",
        hh: "%d時間",
        d: "1日",
        dd: "%d日",
        M: "1ヶ月",
        MM: "%dヶ月",
        y: "1年",
        yy: "%d年"
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("jv", {
      months: "Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember".split("_"),
      monthsShort: "Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des".split("_"),
      weekdays: "Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu".split("_"),
      weekdaysShort: "Min_Sen_Sel_Reb_Kem_Jem_Sep".split("_"),
      weekdaysMin: "Mg_Sn_Sl_Rb_Km_Jm_Sp".split("_"),
      longDateFormat: {
        LT: "HH.mm",
        LTS: "HH.mm.ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY [pukul] HH.mm",
        LLLL: "dddd, D MMMM YYYY [pukul] HH.mm"
      },
      meridiemParse: /enjing|siyang|sonten|ndalu/,
      meridiemHour: function (e, t) {
        return 12 === e && (e = 0), "enjing" === t ? e : "siyang" === t ? e >= 11 ? e : e + 12 : "sonten" === t || "ndalu" === t ? e + 12 : void 0;
      },
      meridiem: function (e, t, n) {
        return e < 11 ? "enjing" : e < 15 ? "siyang" : e < 19 ? "sonten" : "ndalu";
      },
      calendar: {
        sameDay: "[Dinten puniko pukul] LT",
        nextDay: "[Mbenjang pukul] LT",
        nextWeek: "dddd [pukul] LT",
        lastDay: "[Kala wingi pukul] LT",
        lastWeek: "dddd [kepengker pukul] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "wonten ing %s",
        past: "%s ingkang kepengker",
        s: "sawetawis detik",
        ss: "%d detik",
        m: "setunggal menit",
        mm: "%d menit",
        h: "setunggal jam",
        hh: "%d jam",
        d: "sedinten",
        dd: "%d dinten",
        M: "sewulan",
        MM: "%d wulan",
        y: "setaun",
        yy: "%d taun"
      },
      week: {
        dow: 1,
        doy: 7
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("ka", {
      months: "იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი".split("_"),
      monthsShort: "იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ".split("_"),
      weekdays: {
        standalone: "კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი".split("_"),
        format: "კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს".split("_"),
        isFormat: /(წინა|შემდეგ)/
      },
      weekdaysShort: "კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ".split("_"),
      weekdaysMin: "კვ_ორ_სა_ოთ_ხუ_პა_შა".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd, D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[დღეს] LT[-ზე]",
        nextDay: "[ხვალ] LT[-ზე]",
        lastDay: "[გუშინ] LT[-ზე]",
        nextWeek: "[შემდეგ] dddd LT[-ზე]",
        lastWeek: "[წინა] dddd LT-ზე",
        sameElse: "L"
      },
      relativeTime: {
        future: function (e) {
          return e.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/, function (e, t, n) {
            return "ი" === n ? t + "ში" : t + n + "ში";
          });
        },
        past: function (e) {
          return /(წამი|წუთი|საათი|დღე|თვე)/.test(e) ? e.replace(/(ი|ე)$/, "ის წინ") : /წელი/.test(e) ? e.replace(/წელი$/, "წლის წინ") : e;
        },
        s: "რამდენიმე წამი",
        ss: "%d წამი",
        m: "წუთი",
        mm: "%d წუთი",
        h: "საათი",
        hh: "%d საათი",
        d: "დღე",
        dd: "%d დღე",
        M: "თვე",
        MM: "%d თვე",
        y: "წელი",
        yy: "%d წელი"
      },
      dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
      ordinal: function (e) {
        return 0 === e ? e : 1 === e ? e + "-ლი" : e < 20 || e <= 100 && e % 20 == 0 || e % 100 == 0 ? "მე-" + e : e + "-ე";
      },
      week: {
        dow: 1,
        doy: 7
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = {
      0: "-ші",
      1: "-ші",
      2: "-ші",
      3: "-ші",
      4: "-ші",
      5: "-ші",
      6: "-шы",
      7: "-ші",
      8: "-ші",
      9: "-шы",
      10: "-шы",
      20: "-шы",
      30: "-шы",
      40: "-шы",
      50: "-ші",
      60: "-шы",
      70: "-ші",
      80: "-ші",
      90: "-шы",
      100: "-ші"
    };
    e.defineLocale("kk", {
      months: "қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан".split("_"),
      monthsShort: "қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел".split("_"),
      weekdays: "жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі".split("_"),
      weekdaysShort: "жек_дүй_сей_сәр_бей_жұм_сен".split("_"),
      weekdaysMin: "жк_дй_сй_ср_бй_жм_сн".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD.MM.YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd, D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[Бүгін сағат] LT",
        nextDay: "[Ертең сағат] LT",
        nextWeek: "dddd [сағат] LT",
        lastDay: "[Кеше сағат] LT",
        lastWeek: "[Өткен аптаның] dddd [сағат] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%s ішінде",
        past: "%s бұрын",
        s: "бірнеше секунд",
        ss: "%d секунд",
        m: "бір минут",
        mm: "%d минут",
        h: "бір сағат",
        hh: "%d сағат",
        d: "бір күн",
        dd: "%d күн",
        M: "бір ай",
        MM: "%d ай",
        y: "бір жыл",
        yy: "%d жыл"
      },
      dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
      ordinal: function (e) {
        return e + (t[e] || t[e % 10] || t[e >= 100 ? 100 : null]);
      },
      week: {
        dow: 1,
        doy: 7
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = {
        1: "១",
        2: "២",
        3: "៣",
        4: "៤",
        5: "៥",
        6: "៦",
        7: "៧",
        8: "៨",
        9: "៩",
        0: "០"
      },
      n = {
        "១": "1",
        "២": "2",
        "៣": "3",
        "៤": "4",
        "៥": "5",
        "៦": "6",
        "៧": "7",
        "៨": "8",
        "៩": "9",
        "០": "0"
      };
    e.defineLocale("km", {
      months: "មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ".split("_"),
      monthsShort: "មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ".split("_"),
      weekdays: "អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍".split("_"),
      weekdaysShort: "អា_ច_អ_ព_ព្រ_សុ_ស".split("_"),
      weekdaysMin: "អា_ច_អ_ព_ព្រ_សុ_ស".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd, D MMMM YYYY HH:mm"
      },
      meridiemParse: /ព្រឹក|ល្ងាច/,
      isPM: function (e) {
        return "ល្ងាច" === e;
      },
      meridiem: function (e, t, n) {
        return e < 12 ? "ព្រឹក" : "ល្ងាច";
      },
      calendar: {
        sameDay: "[ថ្ងៃនេះ ម៉ោង] LT",
        nextDay: "[ស្អែក ម៉ោង] LT",
        nextWeek: "dddd [ម៉ោង] LT",
        lastDay: "[ម្សិលមិញ ម៉ោង] LT",
        lastWeek: "dddd [សប្តាហ៍មុន] [ម៉ោង] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%sទៀត",
        past: "%sមុន",
        s: "ប៉ុន្មានវិនាទី",
        ss: "%d វិនាទី",
        m: "មួយនាទី",
        mm: "%d នាទី",
        h: "មួយម៉ោង",
        hh: "%d ម៉ោង",
        d: "មួយថ្ងៃ",
        dd: "%d ថ្ងៃ",
        M: "មួយខែ",
        MM: "%d ខែ",
        y: "មួយឆ្នាំ",
        yy: "%d ឆ្នាំ"
      },
      dayOfMonthOrdinalParse: /ទី\d{1,2}/,
      ordinal: "ទី%d",
      preparse: function (e) {
        return e.replace(/[១២៣៤៥៦៧៨៩០]/g, function (e) {
          return n[e];
        });
      },
      postformat: function (e) {
        return e.replace(/\d/g, function (e) {
          return t[e];
        });
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = {
        1: "೧",
        2: "೨",
        3: "೩",
        4: "೪",
        5: "೫",
        6: "೬",
        7: "೭",
        8: "೮",
        9: "೯",
        0: "೦"
      },
      n = {
        "೧": "1",
        "೨": "2",
        "೩": "3",
        "೪": "4",
        "೫": "5",
        "೬": "6",
        "೭": "7",
        "೮": "8",
        "೯": "9",
        "೦": "0"
      };
    e.defineLocale("kn", {
      months: "ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್".split("_"),
      monthsShort: "ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ".split("_"),
      monthsParseExact: !0,
      weekdays: "ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ".split("_"),
      weekdaysShort: "ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ".split("_"),
      weekdaysMin: "ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ".split("_"),
      longDateFormat: {
        LT: "A h:mm",
        LTS: "A h:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY, A h:mm",
        LLLL: "dddd, D MMMM YYYY, A h:mm"
      },
      calendar: {
        sameDay: "[ಇಂದು] LT",
        nextDay: "[ನಾಳೆ] LT",
        nextWeek: "dddd, LT",
        lastDay: "[ನಿನ್ನೆ] LT",
        lastWeek: "[ಕೊನೆಯ] dddd, LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%s ನಂತರ",
        past: "%s ಹಿಂದೆ",
        s: "ಕೆಲವು ಕ್ಷಣಗಳು",
        ss: "%d ಸೆಕೆಂಡುಗಳು",
        m: "ಒಂದು ನಿಮಿಷ",
        mm: "%d ನಿಮಿಷ",
        h: "ಒಂದು ಗಂಟೆ",
        hh: "%d ಗಂಟೆ",
        d: "ಒಂದು ದಿನ",
        dd: "%d ದಿನ",
        M: "ಒಂದು ತಿಂಗಳು",
        MM: "%d ತಿಂಗಳು",
        y: "ಒಂದು ವರ್ಷ",
        yy: "%d ವರ್ಷ"
      },
      preparse: function (e) {
        return e.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (e) {
          return n[e];
        });
      },
      postformat: function (e) {
        return e.replace(/\d/g, function (e) {
          return t[e];
        });
      },
      meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
      meridiemHour: function (e, t) {
        return 12 === e && (e = 0), "ರಾತ್ರಿ" === t ? e < 4 ? e : e + 12 : "ಬೆಳಿಗ್ಗೆ" === t ? e : "ಮಧ್ಯಾಹ್ನ" === t ? e >= 10 ? e : e + 12 : "ಸಂಜೆ" === t ? e + 12 : void 0;
      },
      meridiem: function (e, t, n) {
        return e < 4 ? "ರಾತ್ರಿ" : e < 10 ? "ಬೆಳಿಗ್ಗೆ" : e < 17 ? "ಮಧ್ಯಾಹ್ನ" : e < 20 ? "ಸಂಜೆ" : "ರಾತ್ರಿ";
      },
      dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
      ordinal: function (e) {
        return e + "ನೇ";
      },
      week: {
        dow: 0,
        doy: 6
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("ko", {
      months: "1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"),
      monthsShort: "1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"),
      weekdays: "일요일_월요일_화요일_수요일_목요일_금요일_토요일".split("_"),
      weekdaysShort: "일_월_화_수_목_금_토".split("_"),
      weekdaysMin: "일_월_화_수_목_금_토".split("_"),
      longDateFormat: {
        LT: "A h:mm",
        LTS: "A h:mm:ss",
        L: "YYYY.MM.DD.",
        LL: "YYYY년 MMMM D일",
        LLL: "YYYY년 MMMM D일 A h:mm",
        LLLL: "YYYY년 MMMM D일 dddd A h:mm",
        l: "YYYY.MM.DD.",
        ll: "YYYY년 MMMM D일",
        lll: "YYYY년 MMMM D일 A h:mm",
        llll: "YYYY년 MMMM D일 dddd A h:mm"
      },
      calendar: {
        sameDay: "오늘 LT",
        nextDay: "내일 LT",
        nextWeek: "dddd LT",
        lastDay: "어제 LT",
        lastWeek: "지난주 dddd LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%s 후",
        past: "%s 전",
        s: "몇 초",
        ss: "%d초",
        m: "1분",
        mm: "%d분",
        h: "한 시간",
        hh: "%d시간",
        d: "하루",
        dd: "%d일",
        M: "한 달",
        MM: "%d달",
        y: "일 년",
        yy: "%d년"
      },
      dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
      ordinal: function (e, t) {
        switch (t) {
          case "d":
          case "D":
          case "DDD":
            return e + "일";
          case "M":
            return e + "월";
          case "w":
          case "W":
            return e + "주";
          default:
            return e;
        }
      },
      meridiemParse: /오전|오후/,
      isPM: function (e) {
        return "오후" === e;
      },
      meridiem: function (e, t, n) {
        return e < 12 ? "오전" : "오후";
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = {
        1: "١",
        2: "٢",
        3: "٣",
        4: "٤",
        5: "٥",
        6: "٦",
        7: "٧",
        8: "٨",
        9: "٩",
        0: "٠"
      },
      n = {
        "١": "1",
        "٢": "2",
        "٣": "3",
        "٤": "4",
        "٥": "5",
        "٦": "6",
        "٧": "7",
        "٨": "8",
        "٩": "9",
        "٠": "0"
      },
      a = ["کانونی دووەم", "شوبات", "ئازار", "نیسان", "ئایار", "حوزەیران", "تەمموز", "ئاب", "ئەیلوول", "تشرینی یەكەم", "تشرینی دووەم", "كانونی یەکەم"];
    e.defineLocale("ku", {
      months: a,
      monthsShort: a,
      weekdays: "یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌".split("_"),
      weekdaysShort: "یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌".split("_"),
      weekdaysMin: "ی_د_س_چ_پ_ه_ش".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd, D MMMM YYYY HH:mm"
      },
      meridiemParse: /ئێواره‌|به‌یانی/,
      isPM: function (e) {
        return /ئێواره‌/.test(e);
      },
      meridiem: function (e, t, n) {
        return e < 12 ? "به‌یانی" : "ئێواره‌";
      },
      calendar: {
        sameDay: "[ئه‌مرۆ كاتژمێر] LT",
        nextDay: "[به‌یانی كاتژمێر] LT",
        nextWeek: "dddd [كاتژمێر] LT",
        lastDay: "[دوێنێ كاتژمێر] LT",
        lastWeek: "dddd [كاتژمێر] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "له‌ %s",
        past: "%s",
        s: "چه‌ند چركه‌یه‌ك",
        ss: "چركه‌ %d",
        m: "یه‌ك خوله‌ك",
        mm: "%d خوله‌ك",
        h: "یه‌ك كاتژمێر",
        hh: "%d كاتژمێر",
        d: "یه‌ك ڕۆژ",
        dd: "%d ڕۆژ",
        M: "یه‌ك مانگ",
        MM: "%d مانگ",
        y: "یه‌ك ساڵ",
        yy: "%d ساڵ"
      },
      preparse: function (e) {
        return e.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (e) {
          return n[e];
        }).replace(/،/g, ",");
      },
      postformat: function (e) {
        return e.replace(/\d/g, function (e) {
          return t[e];
        }).replace(/,/g, "،");
      },
      week: {
        dow: 6,
        doy: 12
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = {
      0: "-чү",
      1: "-чи",
      2: "-чи",
      3: "-чү",
      4: "-чү",
      5: "-чи",
      6: "-чы",
      7: "-чи",
      8: "-чи",
      9: "-чу",
      10: "-чу",
      20: "-чы",
      30: "-чу",
      40: "-чы",
      50: "-чү",
      60: "-чы",
      70: "-чи",
      80: "-чи",
      90: "-чу",
      100: "-чү"
    };
    e.defineLocale("ky", {
      months: "январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split("_"),
      monthsShort: "янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек".split("_"),
      weekdays: "Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби".split("_"),
      weekdaysShort: "Жек_Дүй_Шей_Шар_Бей_Жум_Ише".split("_"),
      weekdaysMin: "Жк_Дй_Шй_Шр_Бй_Жм_Иш".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD.MM.YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd, D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[Бүгүн саат] LT",
        nextDay: "[Эртең саат] LT",
        nextWeek: "dddd [саат] LT",
        lastDay: "[Кечээ саат] LT",
        lastWeek: "[Өткөн аптанын] dddd [күнү] [саат] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%s ичинде",
        past: "%s мурун",
        s: "бирнече секунд",
        ss: "%d секунд",
        m: "бир мүнөт",
        mm: "%d мүнөт",
        h: "бир саат",
        hh: "%d саат",
        d: "бир күн",
        dd: "%d күн",
        M: "бир ай",
        MM: "%d ай",
        y: "бир жыл",
        yy: "%d жыл"
      },
      dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
      ordinal: function (e) {
        return e + (t[e] || t[e % 10] || t[e >= 100 ? 100 : null]);
      },
      week: {
        dow: 1,
        doy: 7
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    function t(e, t, n, a) {
      var r = {
        m: ["eng Minutt", "enger Minutt"],
        h: ["eng Stonn", "enger Stonn"],
        d: ["een Dag", "engem Dag"],
        M: ["ee Mount", "engem Mount"],
        y: ["ee Joer", "engem Joer"]
      };
      return t ? r[n][0] : r[n][1];
    }
    function n(e) {
      if (e = parseInt(e, 10), isNaN(e)) return !1;
      if (e < 0) return !0;
      if (e < 10) return 4 <= e && e <= 7;
      if (e < 100) {
        var t = e % 10;
        return n(0 === t ? e / 10 : t);
      }
      if (e < 1e4) {
        for (; e >= 10;) e /= 10;
        return n(e);
      }
      return n(e /= 1e3);
    }
    e.defineLocale("lb", {
      months: "Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),
      monthsShort: "Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.".split("_"),
      monthsParseExact: !0,
      weekdays: "Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg".split("_"),
      weekdaysShort: "So._Mé._Dë._Më._Do._Fr._Sa.".split("_"),
      weekdaysMin: "So_Mé_Dë_Më_Do_Fr_Sa".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "H:mm [Auer]",
        LTS: "H:mm:ss [Auer]",
        L: "DD.MM.YYYY",
        LL: "D. MMMM YYYY",
        LLL: "D. MMMM YYYY H:mm [Auer]",
        LLLL: "dddd, D. MMMM YYYY H:mm [Auer]"
      },
      calendar: {
        sameDay: "[Haut um] LT",
        sameElse: "L",
        nextDay: "[Muer um] LT",
        nextWeek: "dddd [um] LT",
        lastDay: "[Gëschter um] LT",
        lastWeek: function () {
          switch (this.day()) {
            case 2:
            case 4:
              return "[Leschten] dddd [um] LT";
            default:
              return "[Leschte] dddd [um] LT";
          }
        }
      },
      relativeTime: {
        future: function (e) {
          return n(e.substr(0, e.indexOf(" "))) ? "a " + e : "an " + e;
        },
        past: function (e) {
          return n(e.substr(0, e.indexOf(" "))) ? "viru " + e : "virun " + e;
        },
        s: "e puer Sekonnen",
        ss: "%d Sekonnen",
        m: t,
        mm: "%d Minutten",
        h: t,
        hh: "%d Stonnen",
        d: t,
        dd: "%d Deeg",
        M: t,
        MM: "%d Méint",
        y: t,
        yy: "%d Joer"
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: "%d.",
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("lo", {
      months: "ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ".split("_"),
      monthsShort: "ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ".split("_"),
      weekdays: "ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ".split("_"),
      weekdaysShort: "ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ".split("_"),
      weekdaysMin: "ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "ວັນdddd D MMMM YYYY HH:mm"
      },
      meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
      isPM: function (e) {
        return "ຕອນແລງ" === e;
      },
      meridiem: function (e, t, n) {
        return e < 12 ? "ຕອນເຊົ້າ" : "ຕອນແລງ";
      },
      calendar: {
        sameDay: "[ມື້ນີ້ເວລາ] LT",
        nextDay: "[ມື້ອື່ນເວລາ] LT",
        nextWeek: "[ວັນ]dddd[ໜ້າເວລາ] LT",
        lastDay: "[ມື້ວານນີ້ເວລາ] LT",
        lastWeek: "[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "ອີກ %s",
        past: "%sຜ່ານມາ",
        s: "ບໍ່ເທົ່າໃດວິນາທີ",
        ss: "%d ວິນາທີ",
        m: "1 ນາທີ",
        mm: "%d ນາທີ",
        h: "1 ຊົ່ວໂມງ",
        hh: "%d ຊົ່ວໂມງ",
        d: "1 ມື້",
        dd: "%d ມື້",
        M: "1 ເດືອນ",
        MM: "%d ເດືອນ",
        y: "1 ປີ",
        yy: "%d ປີ"
      },
      dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
      ordinal: function (e) {
        return "ທີ່" + e;
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = {
      ss: "sekundė_sekundžių_sekundes",
      m: "minutė_minutės_minutę",
      mm: "minutės_minučių_minutes",
      h: "valanda_valandos_valandą",
      hh: "valandos_valandų_valandas",
      d: "diena_dienos_dieną",
      dd: "dienos_dienų_dienas",
      M: "mėnuo_mėnesio_mėnesį",
      MM: "mėnesiai_mėnesių_mėnesius",
      y: "metai_metų_metus",
      yy: "metai_metų_metus"
    };
    function n(e, t, n, a) {
      return t ? r(n)[0] : a ? r(n)[1] : r(n)[2];
    }
    function a(e) {
      return e % 10 == 0 || e > 10 && e < 20;
    }
    function r(e) {
      return t[e].split("_");
    }
    function i(e, t, i, o) {
      var s = e + " ";
      return 1 === e ? s + n(0, t, i[0], o) : t ? s + (a(e) ? r(i)[1] : r(i)[0]) : o ? s + r(i)[1] : s + (a(e) ? r(i)[1] : r(i)[2]);
    }
    e.defineLocale("lt", {
      months: {
        format: "sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio".split("_"),
        standalone: "sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis".split("_"),
        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
      },
      monthsShort: "sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd".split("_"),
      weekdays: {
        format: "sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį".split("_"),
        standalone: "sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis".split("_"),
        isFormat: /dddd HH:mm/
      },
      weekdaysShort: "Sek_Pir_Ant_Tre_Ket_Pen_Šeš".split("_"),
      weekdaysMin: "S_P_A_T_K_Pn_Š".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "YYYY-MM-DD",
        LL: "YYYY [m.] MMMM D [d.]",
        LLL: "YYYY [m.] MMMM D [d.], HH:mm [val.]",
        LLLL: "YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]",
        l: "YYYY-MM-DD",
        ll: "YYYY [m.] MMMM D [d.]",
        lll: "YYYY [m.] MMMM D [d.], HH:mm [val.]",
        llll: "YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]"
      },
      calendar: {
        sameDay: "[Šiandien] LT",
        nextDay: "[Rytoj] LT",
        nextWeek: "dddd LT",
        lastDay: "[Vakar] LT",
        lastWeek: "[Praėjusį] dddd LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "po %s",
        past: "prieš %s",
        s: function (e, t, n, a) {
          return t ? "kelios sekundės" : a ? "kelių sekundžių" : "kelias sekundes";
        },
        ss: i,
        m: n,
        mm: i,
        h: n,
        hh: i,
        d: n,
        dd: i,
        M: n,
        MM: i,
        y: n,
        yy: i
      },
      dayOfMonthOrdinalParse: /\d{1,2}-oji/,
      ordinal: function (e) {
        return e + "-oji";
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = {
      ss: "sekundes_sekundēm_sekunde_sekundes".split("_"),
      m: "minūtes_minūtēm_minūte_minūtes".split("_"),
      mm: "minūtes_minūtēm_minūte_minūtes".split("_"),
      h: "stundas_stundām_stunda_stundas".split("_"),
      hh: "stundas_stundām_stunda_stundas".split("_"),
      d: "dienas_dienām_diena_dienas".split("_"),
      dd: "dienas_dienām_diena_dienas".split("_"),
      M: "mēneša_mēnešiem_mēnesis_mēneši".split("_"),
      MM: "mēneša_mēnešiem_mēnesis_mēneši".split("_"),
      y: "gada_gadiem_gads_gadi".split("_"),
      yy: "gada_gadiem_gads_gadi".split("_")
    };
    function n(e, t, n) {
      return n ? t % 10 == 1 && t % 100 != 11 ? e[2] : e[3] : t % 10 == 1 && t % 100 != 11 ? e[0] : e[1];
    }
    function a(e, a, r) {
      return e + " " + n(t[r], e, a);
    }
    function r(e, a, r) {
      return n(t[r], e, a);
    }
    e.defineLocale("lv", {
      months: "janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris".split("_"),
      monthsShort: "jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec".split("_"),
      weekdays: "svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena".split("_"),
      weekdaysShort: "Sv_P_O_T_C_Pk_S".split("_"),
      weekdaysMin: "Sv_P_O_T_C_Pk_S".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD.MM.YYYY.",
        LL: "YYYY. [gada] D. MMMM",
        LLL: "YYYY. [gada] D. MMMM, HH:mm",
        LLLL: "YYYY. [gada] D. MMMM, dddd, HH:mm"
      },
      calendar: {
        sameDay: "[Šodien pulksten] LT",
        nextDay: "[Rīt pulksten] LT",
        nextWeek: "dddd [pulksten] LT",
        lastDay: "[Vakar pulksten] LT",
        lastWeek: "[Pagājušā] dddd [pulksten] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "pēc %s",
        past: "pirms %s",
        s: function (e, t) {
          return t ? "dažas sekundes" : "dažām sekundēm";
        },
        ss: a,
        m: r,
        mm: a,
        h: r,
        hh: a,
        d: r,
        dd: a,
        M: r,
        MM: a,
        y: r,
        yy: a
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: "%d.",
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = {
      words: {
        ss: ["sekund", "sekunda", "sekundi"],
        m: ["jedan minut", "jednog minuta"],
        mm: ["minut", "minuta", "minuta"],
        h: ["jedan sat", "jednog sata"],
        hh: ["sat", "sata", "sati"],
        dd: ["dan", "dana", "dana"],
        MM: ["mjesec", "mjeseca", "mjeseci"],
        yy: ["godina", "godine", "godina"]
      },
      correctGrammaticalCase: function (e, t) {
        return 1 === e ? t[0] : e >= 2 && e <= 4 ? t[1] : t[2];
      },
      translate: function (e, n, a) {
        var r = t.words[a];
        return 1 === a.length ? n ? r[0] : r[1] : e + " " + t.correctGrammaticalCase(e, r);
      }
    };
    e.defineLocale("me", {
      months: "januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split("_"),
      monthsShort: "jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),
      monthsParseExact: !0,
      weekdays: "nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split("_"),
      weekdaysShort: "ned._pon._uto._sri._čet._pet._sub.".split("_"),
      weekdaysMin: "ne_po_ut_sr_če_pe_su".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "H:mm",
        LTS: "H:mm:ss",
        L: "DD.MM.YYYY",
        LL: "D. MMMM YYYY",
        LLL: "D. MMMM YYYY H:mm",
        LLLL: "dddd, D. MMMM YYYY H:mm"
      },
      calendar: {
        sameDay: "[danas u] LT",
        nextDay: "[sjutra u] LT",
        nextWeek: function () {
          switch (this.day()) {
            case 0:
              return "[u] [nedjelju] [u] LT";
            case 3:
              return "[u] [srijedu] [u] LT";
            case 6:
              return "[u] [subotu] [u] LT";
            case 1:
            case 2:
            case 4:
            case 5:
              return "[u] dddd [u] LT";
          }
        },
        lastDay: "[juče u] LT",
        lastWeek: function () {
          return ["[prošle] [nedjelje] [u] LT", "[prošlog] [ponedjeljka] [u] LT", "[prošlog] [utorka] [u] LT", "[prošle] [srijede] [u] LT", "[prošlog] [četvrtka] [u] LT", "[prošlog] [petka] [u] LT", "[prošle] [subote] [u] LT"][this.day()];
        },
        sameElse: "L"
      },
      relativeTime: {
        future: "za %s",
        past: "prije %s",
        s: "nekoliko sekundi",
        ss: t.translate,
        m: t.translate,
        mm: t.translate,
        h: t.translate,
        hh: t.translate,
        d: "dan",
        dd: t.translate,
        M: "mjesec",
        MM: t.translate,
        y: "godinu",
        yy: t.translate
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: "%d.",
      week: {
        dow: 1,
        doy: 7
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("mi", {
      months: "Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea".split("_"),
      monthsShort: "Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki".split("_"),
      monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
      monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
      monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
      monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
      weekdays: "Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei".split("_"),
      weekdaysShort: "Ta_Ma_Tū_We_Tāi_Pa_Hā".split("_"),
      weekdaysMin: "Ta_Ma_Tū_We_Tāi_Pa_Hā".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY [i] HH:mm",
        LLLL: "dddd, D MMMM YYYY [i] HH:mm"
      },
      calendar: {
        sameDay: "[i teie mahana, i] LT",
        nextDay: "[apopo i] LT",
        nextWeek: "dddd [i] LT",
        lastDay: "[inanahi i] LT",
        lastWeek: "dddd [whakamutunga i] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "i roto i %s",
        past: "%s i mua",
        s: "te hēkona ruarua",
        ss: "%d hēkona",
        m: "he meneti",
        mm: "%d meneti",
        h: "te haora",
        hh: "%d haora",
        d: "he ra",
        dd: "%d ra",
        M: "he marama",
        MM: "%d marama",
        y: "he tau",
        yy: "%d tau"
      },
      dayOfMonthOrdinalParse: /\d{1,2}º/,
      ordinal: "%dº",
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("mk", {
      months: "јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември".split("_"),
      monthsShort: "јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек".split("_"),
      weekdays: "недела_понеделник_вторник_среда_четврток_петок_сабота".split("_"),
      weekdaysShort: "нед_пон_вто_сре_чет_пет_саб".split("_"),
      weekdaysMin: "нe_пo_вт_ср_че_пе_сa".split("_"),
      longDateFormat: {
        LT: "H:mm",
        LTS: "H:mm:ss",
        L: "D.MM.YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY H:mm",
        LLLL: "dddd, D MMMM YYYY H:mm"
      },
      calendar: {
        sameDay: "[Денес во] LT",
        nextDay: "[Утре во] LT",
        nextWeek: "[Во] dddd [во] LT",
        lastDay: "[Вчера во] LT",
        lastWeek: function () {
          switch (this.day()) {
            case 0:
            case 3:
            case 6:
              return "[Изминатата] dddd [во] LT";
            case 1:
            case 2:
            case 4:
            case 5:
              return "[Изминатиот] dddd [во] LT";
          }
        },
        sameElse: "L"
      },
      relativeTime: {
        future: "за %s",
        past: "пред %s",
        s: "неколку секунди",
        ss: "%d секунди",
        m: "една минута",
        mm: "%d минути",
        h: "еден час",
        hh: "%d часа",
        d: "еден ден",
        dd: "%d дена",
        M: "еден месец",
        MM: "%d месеци",
        y: "една година",
        yy: "%d години"
      },
      dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
      ordinal: function (e) {
        var t = e % 10,
          n = e % 100;
        return 0 === e ? e + "-ев" : 0 === n ? e + "-ен" : n > 10 && n < 20 ? e + "-ти" : 1 === t ? e + "-ви" : 2 === t ? e + "-ри" : 7 === t || 8 === t ? e + "-ми" : e + "-ти";
      },
      week: {
        dow: 1,
        doy: 7
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("ml", {
      months: "ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ".split("_"),
      monthsShort: "ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.".split("_"),
      monthsParseExact: !0,
      weekdays: "ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച".split("_"),
      weekdaysShort: "ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി".split("_"),
      weekdaysMin: "ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ".split("_"),
      longDateFormat: {
        LT: "A h:mm -നു",
        LTS: "A h:mm:ss -നു",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY, A h:mm -നു",
        LLLL: "dddd, D MMMM YYYY, A h:mm -നു"
      },
      calendar: {
        sameDay: "[ഇന്ന്] LT",
        nextDay: "[നാളെ] LT",
        nextWeek: "dddd, LT",
        lastDay: "[ഇന്നലെ] LT",
        lastWeek: "[കഴിഞ്ഞ] dddd, LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%s കഴിഞ്ഞ്",
        past: "%s മുൻപ്",
        s: "അൽപ നിമിഷങ്ങൾ",
        ss: "%d സെക്കൻഡ്",
        m: "ഒരു മിനിറ്റ്",
        mm: "%d മിനിറ്റ്",
        h: "ഒരു മണിക്കൂർ",
        hh: "%d മണിക്കൂർ",
        d: "ഒരു ദിവസം",
        dd: "%d ദിവസം",
        M: "ഒരു മാസം",
        MM: "%d മാസം",
        y: "ഒരു വർഷം",
        yy: "%d വർഷം"
      },
      meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
      meridiemHour: function (e, t) {
        return 12 === e && (e = 0), "രാത്രി" === t && e >= 4 || "ഉച്ച കഴിഞ്ഞ്" === t || "വൈകുന്നേരം" === t ? e + 12 : e;
      },
      meridiem: function (e, t, n) {
        return e < 4 ? "രാത്രി" : e < 12 ? "രാവിലെ" : e < 17 ? "ഉച്ച കഴിഞ്ഞ്" : e < 20 ? "വൈകുന്നേരം" : "രാത്രി";
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    function t(e, t, n, a) {
      switch (n) {
        case "s":
          return t ? "хэдхэн секунд" : "хэдхэн секундын";
        case "ss":
          return e + (t ? " секунд" : " секундын");
        case "m":
        case "mm":
          return e + (t ? " минут" : " минутын");
        case "h":
        case "hh":
          return e + (t ? " цаг" : " цагийн");
        case "d":
        case "dd":
          return e + (t ? " өдөр" : " өдрийн");
        case "M":
        case "MM":
          return e + (t ? " сар" : " сарын");
        case "y":
        case "yy":
          return e + (t ? " жил" : " жилийн");
        default:
          return e;
      }
    }
    e.defineLocale("mn", {
      months: "Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар".split("_"),
      monthsShort: "1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар".split("_"),
      monthsParseExact: !0,
      weekdays: "Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба".split("_"),
      weekdaysShort: "Ням_Дав_Мяг_Лха_Пүр_Баа_Бям".split("_"),
      weekdaysMin: "Ня_Да_Мя_Лх_Пү_Ба_Бя".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "YYYY-MM-DD",
        LL: "YYYY оны MMMMын D",
        LLL: "YYYY оны MMMMын D HH:mm",
        LLLL: "dddd, YYYY оны MMMMын D HH:mm"
      },
      meridiemParse: /ҮӨ|ҮХ/i,
      isPM: function (e) {
        return "ҮХ" === e;
      },
      meridiem: function (e, t, n) {
        return e < 12 ? "ҮӨ" : "ҮХ";
      },
      calendar: {
        sameDay: "[Өнөөдөр] LT",
        nextDay: "[Маргааш] LT",
        nextWeek: "[Ирэх] dddd LT",
        lastDay: "[Өчигдөр] LT",
        lastWeek: "[Өнгөрсөн] dddd LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%s дараа",
        past: "%s өмнө",
        s: t,
        ss: t,
        m: t,
        mm: t,
        h: t,
        hh: t,
        d: t,
        dd: t,
        M: t,
        MM: t,
        y: t,
        yy: t
      },
      dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
      ordinal: function (e, t) {
        switch (t) {
          case "d":
          case "D":
          case "DDD":
            return e + " өдөр";
          default:
            return e;
        }
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = {
        1: "१",
        2: "२",
        3: "३",
        4: "४",
        5: "५",
        6: "६",
        7: "७",
        8: "८",
        9: "९",
        0: "०"
      },
      n = {
        "१": "1",
        "२": "2",
        "३": "3",
        "४": "4",
        "५": "5",
        "६": "6",
        "७": "7",
        "८": "8",
        "९": "9",
        "०": "0"
      };
    function a(e, t, n, a) {
      var r = "";
      if (t) switch (n) {
        case "s":
          r = "काही सेकंद";
          break;
        case "ss":
          r = "%d सेकंद";
          break;
        case "m":
          r = "एक मिनिट";
          break;
        case "mm":
          r = "%d मिनिटे";
          break;
        case "h":
          r = "एक तास";
          break;
        case "hh":
          r = "%d तास";
          break;
        case "d":
          r = "एक दिवस";
          break;
        case "dd":
          r = "%d दिवस";
          break;
        case "M":
          r = "एक महिना";
          break;
        case "MM":
          r = "%d महिने";
          break;
        case "y":
          r = "एक वर्ष";
          break;
        case "yy":
          r = "%d वर्षे";
      } else switch (n) {
        case "s":
          r = "काही सेकंदां";
          break;
        case "ss":
          r = "%d सेकंदां";
          break;
        case "m":
          r = "एका मिनिटा";
          break;
        case "mm":
          r = "%d मिनिटां";
          break;
        case "h":
          r = "एका तासा";
          break;
        case "hh":
          r = "%d तासां";
          break;
        case "d":
          r = "एका दिवसा";
          break;
        case "dd":
          r = "%d दिवसां";
          break;
        case "M":
          r = "एका महिन्या";
          break;
        case "MM":
          r = "%d महिन्यां";
          break;
        case "y":
          r = "एका वर्षा";
          break;
        case "yy":
          r = "%d वर्षां";
      }
      return r.replace(/%d/i, e);
    }
    e.defineLocale("mr", {
      months: "जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर".split("_"),
      monthsShort: "जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.".split("_"),
      monthsParseExact: !0,
      weekdays: "रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार".split("_"),
      weekdaysShort: "रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि".split("_"),
      weekdaysMin: "र_सो_मं_बु_गु_शु_श".split("_"),
      longDateFormat: {
        LT: "A h:mm वाजता",
        LTS: "A h:mm:ss वाजता",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY, A h:mm वाजता",
        LLLL: "dddd, D MMMM YYYY, A h:mm वाजता"
      },
      calendar: {
        sameDay: "[आज] LT",
        nextDay: "[उद्या] LT",
        nextWeek: "dddd, LT",
        lastDay: "[काल] LT",
        lastWeek: "[मागील] dddd, LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%sमध्ये",
        past: "%sपूर्वी",
        s: a,
        ss: a,
        m: a,
        mm: a,
        h: a,
        hh: a,
        d: a,
        dd: a,
        M: a,
        MM: a,
        y: a,
        yy: a
      },
      preparse: function (e) {
        return e.replace(/[१२३४५६७८९०]/g, function (e) {
          return n[e];
        });
      },
      postformat: function (e) {
        return e.replace(/\d/g, function (e) {
          return t[e];
        });
      },
      meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
      meridiemHour: function (e, t) {
        return 12 === e && (e = 0), "पहाटे" === t || "सकाळी" === t ? e : "दुपारी" === t || "सायंकाळी" === t || "रात्री" === t ? e >= 12 ? e : e + 12 : void 0;
      },
      meridiem: function (e, t, n) {
        return e >= 0 && e < 6 ? "पहाटे" : e < 12 ? "सकाळी" : e < 17 ? "दुपारी" : e < 20 ? "सायंकाळी" : "रात्री";
      },
      week: {
        dow: 0,
        doy: 6
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("ms", {
      months: "Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),
      monthsShort: "Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),
      weekdays: "Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),
      weekdaysShort: "Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),
      weekdaysMin: "Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),
      longDateFormat: {
        LT: "HH.mm",
        LTS: "HH.mm.ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY [pukul] HH.mm",
        LLLL: "dddd, D MMMM YYYY [pukul] HH.mm"
      },
      meridiemParse: /pagi|tengahari|petang|malam/,
      meridiemHour: function (e, t) {
        return 12 === e && (e = 0), "pagi" === t ? e : "tengahari" === t ? e >= 11 ? e : e + 12 : "petang" === t || "malam" === t ? e + 12 : void 0;
      },
      meridiem: function (e, t, n) {
        return e < 11 ? "pagi" : e < 15 ? "tengahari" : e < 19 ? "petang" : "malam";
      },
      calendar: {
        sameDay: "[Hari ini pukul] LT",
        nextDay: "[Esok pukul] LT",
        nextWeek: "dddd [pukul] LT",
        lastDay: "[Kelmarin pukul] LT",
        lastWeek: "dddd [lepas pukul] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "dalam %s",
        past: "%s yang lepas",
        s: "beberapa saat",
        ss: "%d saat",
        m: "seminit",
        mm: "%d minit",
        h: "sejam",
        hh: "%d jam",
        d: "sehari",
        dd: "%d hari",
        M: "sebulan",
        MM: "%d bulan",
        y: "setahun",
        yy: "%d tahun"
      },
      week: {
        dow: 1,
        doy: 7
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("ms-my", {
      months: "Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),
      monthsShort: "Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),
      weekdays: "Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),
      weekdaysShort: "Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),
      weekdaysMin: "Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),
      longDateFormat: {
        LT: "HH.mm",
        LTS: "HH.mm.ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY [pukul] HH.mm",
        LLLL: "dddd, D MMMM YYYY [pukul] HH.mm"
      },
      meridiemParse: /pagi|tengahari|petang|malam/,
      meridiemHour: function (e, t) {
        return 12 === e && (e = 0), "pagi" === t ? e : "tengahari" === t ? e >= 11 ? e : e + 12 : "petang" === t || "malam" === t ? e + 12 : void 0;
      },
      meridiem: function (e, t, n) {
        return e < 11 ? "pagi" : e < 15 ? "tengahari" : e < 19 ? "petang" : "malam";
      },
      calendar: {
        sameDay: "[Hari ini pukul] LT",
        nextDay: "[Esok pukul] LT",
        nextWeek: "dddd [pukul] LT",
        lastDay: "[Kelmarin pukul] LT",
        lastWeek: "dddd [lepas pukul] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "dalam %s",
        past: "%s yang lepas",
        s: "beberapa saat",
        ss: "%d saat",
        m: "seminit",
        mm: "%d minit",
        h: "sejam",
        hh: "%d jam",
        d: "sehari",
        dd: "%d hari",
        M: "sebulan",
        MM: "%d bulan",
        y: "setahun",
        yy: "%d tahun"
      },
      week: {
        dow: 1,
        doy: 7
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("mt", {
      months: "Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru".split("_"),
      monthsShort: "Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ".split("_"),
      weekdays: "Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt".split("_"),
      weekdaysShort: "Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib".split("_"),
      weekdaysMin: "Ħa_Tn_Tl_Er_Ħa_Ġi_Si".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd, D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[Illum fil-]LT",
        nextDay: "[Għada fil-]LT",
        nextWeek: "dddd [fil-]LT",
        lastDay: "[Il-bieraħ fil-]LT",
        lastWeek: "dddd [li għadda] [fil-]LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "f’ %s",
        past: "%s ilu",
        s: "ftit sekondi",
        ss: "%d sekondi",
        m: "minuta",
        mm: "%d minuti",
        h: "siegħa",
        hh: "%d siegħat",
        d: "ġurnata",
        dd: "%d ġranet",
        M: "xahar",
        MM: "%d xhur",
        y: "sena",
        yy: "%d sni"
      },
      dayOfMonthOrdinalParse: /\d{1,2}º/,
      ordinal: "%dº",
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = {
        1: "၁",
        2: "၂",
        3: "၃",
        4: "၄",
        5: "၅",
        6: "၆",
        7: "၇",
        8: "၈",
        9: "၉",
        0: "၀"
      },
      n = {
        "၁": "1",
        "၂": "2",
        "၃": "3",
        "၄": "4",
        "၅": "5",
        "၆": "6",
        "၇": "7",
        "၈": "8",
        "၉": "9",
        "၀": "0"
      };
    e.defineLocale("my", {
      months: "ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ".split("_"),
      monthsShort: "ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ".split("_"),
      weekdays: "တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ".split("_"),
      weekdaysShort: "နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ".split("_"),
      weekdaysMin: "နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[ယနေ.] LT [မှာ]",
        nextDay: "[မနက်ဖြန်] LT [မှာ]",
        nextWeek: "dddd LT [မှာ]",
        lastDay: "[မနေ.က] LT [မှာ]",
        lastWeek: "[ပြီးခဲ့သော] dddd LT [မှာ]",
        sameElse: "L"
      },
      relativeTime: {
        future: "လာမည့် %s မှာ",
        past: "လွန်ခဲ့သော %s က",
        s: "စက္ကန်.အနည်းငယ်",
        ss: "%d စက္ကန့်",
        m: "တစ်မိနစ်",
        mm: "%d မိနစ်",
        h: "တစ်နာရီ",
        hh: "%d နာရီ",
        d: "တစ်ရက်",
        dd: "%d ရက်",
        M: "တစ်လ",
        MM: "%d လ",
        y: "တစ်နှစ်",
        yy: "%d နှစ်"
      },
      preparse: function (e) {
        return e.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (e) {
          return n[e];
        });
      },
      postformat: function (e) {
        return e.replace(/\d/g, function (e) {
          return t[e];
        });
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("nb", {
      months: "januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),
      monthsShort: "jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.".split("_"),
      monthsParseExact: !0,
      weekdays: "søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"),
      weekdaysShort: "sø._ma._ti._on._to._fr._lø.".split("_"),
      weekdaysMin: "sø_ma_ti_on_to_fr_lø".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD.MM.YYYY",
        LL: "D. MMMM YYYY",
        LLL: "D. MMMM YYYY [kl.] HH:mm",
        LLLL: "dddd D. MMMM YYYY [kl.] HH:mm"
      },
      calendar: {
        sameDay: "[i dag kl.] LT",
        nextDay: "[i morgen kl.] LT",
        nextWeek: "dddd [kl.] LT",
        lastDay: "[i går kl.] LT",
        lastWeek: "[forrige] dddd [kl.] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "om %s",
        past: "%s siden",
        s: "noen sekunder",
        ss: "%d sekunder",
        m: "ett minutt",
        mm: "%d minutter",
        h: "en time",
        hh: "%d timer",
        d: "en dag",
        dd: "%d dager",
        w: "en uke",
        ww: "%d uker",
        M: "en måned",
        MM: "%d måneder",
        y: "ett år",
        yy: "%d år"
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: "%d.",
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = {
        1: "१",
        2: "२",
        3: "३",
        4: "४",
        5: "५",
        6: "६",
        7: "७",
        8: "८",
        9: "९",
        0: "०"
      },
      n = {
        "१": "1",
        "२": "2",
        "३": "3",
        "४": "4",
        "५": "5",
        "६": "6",
        "७": "7",
        "८": "8",
        "९": "9",
        "०": "0"
      };
    e.defineLocale("ne", {
      months: "जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर".split("_"),
      monthsShort: "जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.".split("_"),
      monthsParseExact: !0,
      weekdays: "आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार".split("_"),
      weekdaysShort: "आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.".split("_"),
      weekdaysMin: "आ._सो._मं._बु._बि._शु._श.".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "Aको h:mm बजे",
        LTS: "Aको h:mm:ss बजे",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY, Aको h:mm बजे",
        LLLL: "dddd, D MMMM YYYY, Aको h:mm बजे"
      },
      preparse: function (e) {
        return e.replace(/[१२३४५६७८९०]/g, function (e) {
          return n[e];
        });
      },
      postformat: function (e) {
        return e.replace(/\d/g, function (e) {
          return t[e];
        });
      },
      meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
      meridiemHour: function (e, t) {
        return 12 === e && (e = 0), "राति" === t ? e < 4 ? e : e + 12 : "बिहान" === t ? e : "दिउँसो" === t ? e >= 10 ? e : e + 12 : "साँझ" === t ? e + 12 : void 0;
      },
      meridiem: function (e, t, n) {
        return e < 3 ? "राति" : e < 12 ? "बिहान" : e < 16 ? "दिउँसो" : e < 20 ? "साँझ" : "राति";
      },
      calendar: {
        sameDay: "[आज] LT",
        nextDay: "[भोलि] LT",
        nextWeek: "[आउँदो] dddd[,] LT",
        lastDay: "[हिजो] LT",
        lastWeek: "[गएको] dddd[,] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%sमा",
        past: "%s अगाडि",
        s: "केही क्षण",
        ss: "%d सेकेण्ड",
        m: "एक मिनेट",
        mm: "%d मिनेट",
        h: "एक घण्टा",
        hh: "%d घण्टा",
        d: "एक दिन",
        dd: "%d दिन",
        M: "एक महिना",
        MM: "%d महिना",
        y: "एक बर्ष",
        yy: "%d बर्ष"
      },
      week: {
        dow: 0,
        doy: 6
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = "jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"),
      n = "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),
      a = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i],
      r = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
    e.defineLocale("nl", {
      months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
      monthsShort: function (e, a) {
        return e ? /-MMM-/.test(a) ? n[e.month()] : t[e.month()] : t;
      },
      monthsRegex: r,
      monthsShortRegex: r,
      monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
      monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
      monthsParse: a,
      longMonthsParse: a,
      shortMonthsParse: a,
      weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
      weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
      weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD-MM-YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[vandaag om] LT",
        nextDay: "[morgen om] LT",
        nextWeek: "dddd [om] LT",
        lastDay: "[gisteren om] LT",
        lastWeek: "[afgelopen] dddd [om] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "over %s",
        past: "%s geleden",
        s: "een paar seconden",
        ss: "%d seconden",
        m: "één minuut",
        mm: "%d minuten",
        h: "één uur",
        hh: "%d uur",
        d: "één dag",
        dd: "%d dagen",
        w: "één week",
        ww: "%d weken",
        M: "één maand",
        MM: "%d maanden",
        y: "één jaar",
        yy: "%d jaar"
      },
      dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
      ordinal: function (e) {
        return e + (1 === e || 8 === e || e >= 20 ? "ste" : "de");
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = "jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"),
      n = "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),
      a = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i],
      r = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
    e.defineLocale("nl-be", {
      months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
      monthsShort: function (e, a) {
        return e ? /-MMM-/.test(a) ? n[e.month()] : t[e.month()] : t;
      },
      monthsRegex: r,
      monthsShortRegex: r,
      monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
      monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
      monthsParse: a,
      longMonthsParse: a,
      shortMonthsParse: a,
      weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
      weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
      weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[vandaag om] LT",
        nextDay: "[morgen om] LT",
        nextWeek: "dddd [om] LT",
        lastDay: "[gisteren om] LT",
        lastWeek: "[afgelopen] dddd [om] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "over %s",
        past: "%s geleden",
        s: "een paar seconden",
        ss: "%d seconden",
        m: "één minuut",
        mm: "%d minuten",
        h: "één uur",
        hh: "%d uur",
        d: "één dag",
        dd: "%d dagen",
        M: "één maand",
        MM: "%d maanden",
        y: "één jaar",
        yy: "%d jaar"
      },
      dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
      ordinal: function (e) {
        return e + (1 === e || 8 === e || e >= 20 ? "ste" : "de");
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("nn", {
      months: "januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),
      monthsShort: "jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.".split("_"),
      monthsParseExact: !0,
      weekdays: "sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag".split("_"),
      weekdaysShort: "su._må._ty._on._to._fr._lau.".split("_"),
      weekdaysMin: "su_må_ty_on_to_fr_la".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD.MM.YYYY",
        LL: "D. MMMM YYYY",
        LLL: "D. MMMM YYYY [kl.] H:mm",
        LLLL: "dddd D. MMMM YYYY [kl.] HH:mm"
      },
      calendar: {
        sameDay: "[I dag klokka] LT",
        nextDay: "[I morgon klokka] LT",
        nextWeek: "dddd [klokka] LT",
        lastDay: "[I går klokka] LT",
        lastWeek: "[Føregåande] dddd [klokka] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "om %s",
        past: "%s sidan",
        s: "nokre sekund",
        ss: "%d sekund",
        m: "eit minutt",
        mm: "%d minutt",
        h: "ein time",
        hh: "%d timar",
        d: "ein dag",
        dd: "%d dagar",
        w: "ei veke",
        ww: "%d veker",
        M: "ein månad",
        MM: "%d månader",
        y: "eit år",
        yy: "%d år"
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: "%d.",
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("oc-lnc", {
      months: {
        standalone: "genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre".split("_"),
        format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split("_"),
        isFormat: /D[oD]?(\s)+MMMM/
      },
      monthsShort: "gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.".split("_"),
      monthsParseExact: !0,
      weekdays: "dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte".split("_"),
      weekdaysShort: "dg._dl._dm._dc._dj._dv._ds.".split("_"),
      weekdaysMin: "dg_dl_dm_dc_dj_dv_ds".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "H:mm",
        LTS: "H:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM [de] YYYY",
        ll: "D MMM YYYY",
        LLL: "D MMMM [de] YYYY [a] H:mm",
        lll: "D MMM YYYY, H:mm",
        LLLL: "dddd D MMMM [de] YYYY [a] H:mm",
        llll: "ddd D MMM YYYY, H:mm"
      },
      calendar: {
        sameDay: "[uèi a] LT",
        nextDay: "[deman a] LT",
        nextWeek: "dddd [a] LT",
        lastDay: "[ièr a] LT",
        lastWeek: "dddd [passat a] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "d'aquí %s",
        past: "fa %s",
        s: "unas segondas",
        ss: "%d segondas",
        m: "una minuta",
        mm: "%d minutas",
        h: "una ora",
        hh: "%d oras",
        d: "un jorn",
        dd: "%d jorns",
        M: "un mes",
        MM: "%d meses",
        y: "un an",
        yy: "%d ans"
      },
      dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
      ordinal: function (e, t) {
        var n = 1 === e ? "r" : 2 === e ? "n" : 3 === e ? "r" : 4 === e ? "t" : "è";
        return "w" !== t && "W" !== t || (n = "a"), e + n;
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = {
        1: "੧",
        2: "੨",
        3: "੩",
        4: "੪",
        5: "੫",
        6: "੬",
        7: "੭",
        8: "੮",
        9: "੯",
        0: "੦"
      },
      n = {
        "੧": "1",
        "੨": "2",
        "੩": "3",
        "੪": "4",
        "੫": "5",
        "੬": "6",
        "੭": "7",
        "੮": "8",
        "੯": "9",
        "੦": "0"
      };
    e.defineLocale("pa-in", {
      months: "ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ".split("_"),
      monthsShort: "ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ".split("_"),
      weekdays: "ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ".split("_"),
      weekdaysShort: "ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ".split("_"),
      weekdaysMin: "ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ".split("_"),
      longDateFormat: {
        LT: "A h:mm ਵਜੇ",
        LTS: "A h:mm:ss ਵਜੇ",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY, A h:mm ਵਜੇ",
        LLLL: "dddd, D MMMM YYYY, A h:mm ਵਜੇ"
      },
      calendar: {
        sameDay: "[ਅਜ] LT",
        nextDay: "[ਕਲ] LT",
        nextWeek: "[ਅਗਲਾ] dddd, LT",
        lastDay: "[ਕਲ] LT",
        lastWeek: "[ਪਿਛਲੇ] dddd, LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%s ਵਿੱਚ",
        past: "%s ਪਿਛਲੇ",
        s: "ਕੁਝ ਸਕਿੰਟ",
        ss: "%d ਸਕਿੰਟ",
        m: "ਇਕ ਮਿੰਟ",
        mm: "%d ਮਿੰਟ",
        h: "ਇੱਕ ਘੰਟਾ",
        hh: "%d ਘੰਟੇ",
        d: "ਇੱਕ ਦਿਨ",
        dd: "%d ਦਿਨ",
        M: "ਇੱਕ ਮਹੀਨਾ",
        MM: "%d ਮਹੀਨੇ",
        y: "ਇੱਕ ਸਾਲ",
        yy: "%d ਸਾਲ"
      },
      preparse: function (e) {
        return e.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (e) {
          return n[e];
        });
      },
      postformat: function (e) {
        return e.replace(/\d/g, function (e) {
          return t[e];
        });
      },
      meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
      meridiemHour: function (e, t) {
        return 12 === e && (e = 0), "ਰਾਤ" === t ? e < 4 ? e : e + 12 : "ਸਵੇਰ" === t ? e : "ਦੁਪਹਿਰ" === t ? e >= 10 ? e : e + 12 : "ਸ਼ਾਮ" === t ? e + 12 : void 0;
      },
      meridiem: function (e, t, n) {
        return e < 4 ? "ਰਾਤ" : e < 10 ? "ਸਵੇਰ" : e < 17 ? "ਦੁਪਹਿਰ" : e < 20 ? "ਸ਼ਾਮ" : "ਰਾਤ";
      },
      week: {
        dow: 0,
        doy: 6
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = "styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień".split("_"),
      n = "stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia".split("_"),
      a = [/^sty/i, /^lut/i, /^mar/i, /^kwi/i, /^maj/i, /^cze/i, /^lip/i, /^sie/i, /^wrz/i, /^paź/i, /^lis/i, /^gru/i];
    function r(e) {
      return e % 10 < 5 && e % 10 > 1 && ~~(e / 10) % 10 != 1;
    }
    function i(e, t, n) {
      var a = e + " ";
      switch (n) {
        case "ss":
          return a + (r(e) ? "sekundy" : "sekund");
        case "m":
          return t ? "minuta" : "minutę";
        case "mm":
          return a + (r(e) ? "minuty" : "minut");
        case "h":
          return t ? "godzina" : "godzinę";
        case "hh":
          return a + (r(e) ? "godziny" : "godzin");
        case "ww":
          return a + (r(e) ? "tygodnie" : "tygodni");
        case "MM":
          return a + (r(e) ? "miesiące" : "miesięcy");
        case "yy":
          return a + (r(e) ? "lata" : "lat");
      }
    }
    e.defineLocale("pl", {
      months: function (e, a) {
        return e ? /D MMMM/.test(a) ? n[e.month()] : t[e.month()] : t;
      },
      monthsShort: "sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru".split("_"),
      monthsParse: a,
      longMonthsParse: a,
      shortMonthsParse: a,
      weekdays: "niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota".split("_"),
      weekdaysShort: "ndz_pon_wt_śr_czw_pt_sob".split("_"),
      weekdaysMin: "Nd_Pn_Wt_Śr_Cz_Pt_So".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD.MM.YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd, D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[Dziś o] LT",
        nextDay: "[Jutro o] LT",
        nextWeek: function () {
          switch (this.day()) {
            case 0:
              return "[W niedzielę o] LT";
            case 2:
              return "[We wtorek o] LT";
            case 3:
              return "[W środę o] LT";
            case 6:
              return "[W sobotę o] LT";
            default:
              return "[W] dddd [o] LT";
          }
        },
        lastDay: "[Wczoraj o] LT",
        lastWeek: function () {
          switch (this.day()) {
            case 0:
              return "[W zeszłą niedzielę o] LT";
            case 3:
              return "[W zeszłą środę o] LT";
            case 6:
              return "[W zeszłą sobotę o] LT";
            default:
              return "[W zeszły] dddd [o] LT";
          }
        },
        sameElse: "L"
      },
      relativeTime: {
        future: "za %s",
        past: "%s temu",
        s: "kilka sekund",
        ss: i,
        m: i,
        mm: i,
        h: i,
        hh: i,
        d: "1 dzień",
        dd: "%d dni",
        w: "tydzień",
        ww: i,
        M: "miesiąc",
        MM: i,
        y: "rok",
        yy: i
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: "%d.",
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("pt", {
      months: "janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),
      monthsShort: "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),
      weekdays: "Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado".split("_"),
      weekdaysShort: "Dom_Seg_Ter_Qua_Qui_Sex_Sáb".split("_"),
      weekdaysMin: "Do_2ª_3ª_4ª_5ª_6ª_Sá".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D [de] MMMM [de] YYYY",
        LLL: "D [de] MMMM [de] YYYY HH:mm",
        LLLL: "dddd, D [de] MMMM [de] YYYY HH:mm"
      },
      calendar: {
        sameDay: "[Hoje às] LT",
        nextDay: "[Amanhã às] LT",
        nextWeek: "dddd [às] LT",
        lastDay: "[Ontem às] LT",
        lastWeek: function () {
          return 0 === this.day() || 6 === this.day() ? "[Último] dddd [às] LT" : "[Última] dddd [às] LT";
        },
        sameElse: "L"
      },
      relativeTime: {
        future: "em %s",
        past: "há %s",
        s: "segundos",
        ss: "%d segundos",
        m: "um minuto",
        mm: "%d minutos",
        h: "uma hora",
        hh: "%d horas",
        d: "um dia",
        dd: "%d dias",
        w: "uma semana",
        ww: "%d semanas",
        M: "um mês",
        MM: "%d meses",
        y: "um ano",
        yy: "%d anos"
      },
      dayOfMonthOrdinalParse: /\d{1,2}º/,
      ordinal: "%dº",
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("pt-br", {
      months: "janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),
      monthsShort: "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),
      weekdays: "domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado".split("_"),
      weekdaysShort: "dom_seg_ter_qua_qui_sex_sáb".split("_"),
      weekdaysMin: "do_2ª_3ª_4ª_5ª_6ª_sá".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D [de] MMMM [de] YYYY",
        LLL: "D [de] MMMM [de] YYYY [às] HH:mm",
        LLLL: "dddd, D [de] MMMM [de] YYYY [às] HH:mm"
      },
      calendar: {
        sameDay: "[Hoje às] LT",
        nextDay: "[Amanhã às] LT",
        nextWeek: "dddd [às] LT",
        lastDay: "[Ontem às] LT",
        lastWeek: function () {
          return 0 === this.day() || 6 === this.day() ? "[Último] dddd [às] LT" : "[Última] dddd [às] LT";
        },
        sameElse: "L"
      },
      relativeTime: {
        future: "em %s",
        past: "há %s",
        s: "poucos segundos",
        ss: "%d segundos",
        m: "um minuto",
        mm: "%d minutos",
        h: "uma hora",
        hh: "%d horas",
        d: "um dia",
        dd: "%d dias",
        M: "um mês",
        MM: "%d meses",
        y: "um ano",
        yy: "%d anos"
      },
      dayOfMonthOrdinalParse: /\d{1,2}º/,
      ordinal: "%dº",
      invalidDate: "Data inválida"
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    function t(e, t, n) {
      var a = " ";
      return (e % 100 >= 20 || e >= 100 && e % 100 == 0) && (a = " de "), e + a + {
        ss: "secunde",
        mm: "minute",
        hh: "ore",
        dd: "zile",
        ww: "săptămâni",
        MM: "luni",
        yy: "ani"
      }[n];
    }
    e.defineLocale("ro", {
      months: "ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie".split("_"),
      monthsShort: "ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.".split("_"),
      monthsParseExact: !0,
      weekdays: "duminică_luni_marți_miercuri_joi_vineri_sâmbătă".split("_"),
      weekdaysShort: "Dum_Lun_Mar_Mie_Joi_Vin_Sâm".split("_"),
      weekdaysMin: "Du_Lu_Ma_Mi_Jo_Vi_Sâ".split("_"),
      longDateFormat: {
        LT: "H:mm",
        LTS: "H:mm:ss",
        L: "DD.MM.YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY H:mm",
        LLLL: "dddd, D MMMM YYYY H:mm"
      },
      calendar: {
        sameDay: "[azi la] LT",
        nextDay: "[mâine la] LT",
        nextWeek: "dddd [la] LT",
        lastDay: "[ieri la] LT",
        lastWeek: "[fosta] dddd [la] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "peste %s",
        past: "%s în urmă",
        s: "câteva secunde",
        ss: t,
        m: "un minut",
        mm: t,
        h: "o oră",
        hh: t,
        d: "o zi",
        dd: t,
        w: "o săptămână",
        ww: t,
        M: "o lună",
        MM: t,
        y: "un an",
        yy: t
      },
      week: {
        dow: 1,
        doy: 7
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    function t(e, t, n) {
      var a, r;
      return "m" === n ? t ? "минута" : "минуту" : e + " " + (a = +e, r = {
        ss: t ? "секунда_секунды_секунд" : "секунду_секунды_секунд",
        mm: t ? "минута_минуты_минут" : "минуту_минуты_минут",
        hh: "час_часа_часов",
        dd: "день_дня_дней",
        ww: "неделя_недели_недель",
        MM: "месяц_месяца_месяцев",
        yy: "год_года_лет"
      }[n].split("_"), a % 10 == 1 && a % 100 != 11 ? r[0] : a % 10 >= 2 && a % 10 <= 4 && (a % 100 < 10 || a % 100 >= 20) ? r[1] : r[2]);
    }
    var n = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
    e.defineLocale("ru", {
      months: {
        format: "января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря".split("_"),
        standalone: "январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split("_")
      },
      monthsShort: {
        format: "янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.".split("_"),
        standalone: "янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.".split("_")
      },
      weekdays: {
        standalone: "воскресенье_понедельник_вторник_среда_четверг_пятница_суббота".split("_"),
        format: "воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу".split("_"),
        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/
      },
      weekdaysShort: "вс_пн_вт_ср_чт_пт_сб".split("_"),
      weekdaysMin: "вс_пн_вт_ср_чт_пт_сб".split("_"),
      monthsParse: n,
      longMonthsParse: n,
      shortMonthsParse: n,
      monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
      monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
      monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
      monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
      longDateFormat: {
        LT: "H:mm",
        LTS: "H:mm:ss",
        L: "DD.MM.YYYY",
        LL: "D MMMM YYYY г.",
        LLL: "D MMMM YYYY г., H:mm",
        LLLL: "dddd, D MMMM YYYY г., H:mm"
      },
      calendar: {
        sameDay: "[Сегодня, в] LT",
        nextDay: "[Завтра, в] LT",
        lastDay: "[Вчера, в] LT",
        nextWeek: function (e) {
          if (e.week() === this.week()) return 2 === this.day() ? "[Во] dddd, [в] LT" : "[В] dddd, [в] LT";
          switch (this.day()) {
            case 0:
              return "[В следующее] dddd, [в] LT";
            case 1:
            case 2:
            case 4:
              return "[В следующий] dddd, [в] LT";
            case 3:
            case 5:
            case 6:
              return "[В следующую] dddd, [в] LT";
          }
        },
        lastWeek: function (e) {
          if (e.week() === this.week()) return 2 === this.day() ? "[Во] dddd, [в] LT" : "[В] dddd, [в] LT";
          switch (this.day()) {
            case 0:
              return "[В прошлое] dddd, [в] LT";
            case 1:
            case 2:
            case 4:
              return "[В прошлый] dddd, [в] LT";
            case 3:
            case 5:
            case 6:
              return "[В прошлую] dddd, [в] LT";
          }
        },
        sameElse: "L"
      },
      relativeTime: {
        future: "через %s",
        past: "%s назад",
        s: "несколько секунд",
        ss: t,
        m: t,
        mm: t,
        h: "час",
        hh: t,
        d: "день",
        dd: t,
        w: "неделя",
        ww: t,
        M: "месяц",
        MM: t,
        y: "год",
        yy: t
      },
      meridiemParse: /ночи|утра|дня|вечера/i,
      isPM: function (e) {
        return /^(дня|вечера)$/.test(e);
      },
      meridiem: function (e, t, n) {
        return e < 4 ? "ночи" : e < 12 ? "утра" : e < 17 ? "дня" : "вечера";
      },
      dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
      ordinal: function (e, t) {
        switch (t) {
          case "M":
          case "d":
          case "DDD":
            return e + "-й";
          case "D":
            return e + "-го";
          case "w":
          case "W":
            return e + "-я";
          default:
            return e;
        }
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = ["جنوري", "فيبروري", "مارچ", "اپريل", "مئي", "جون", "جولاءِ", "آگسٽ", "سيپٽمبر", "آڪٽوبر", "نومبر", "ڊسمبر"],
      n = ["آچر", "سومر", "اڱارو", "اربع", "خميس", "جمع", "ڇنڇر"];
    e.defineLocale("sd", {
      months: t,
      monthsShort: t,
      weekdays: n,
      weekdaysShort: n,
      weekdaysMin: n,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd، D MMMM YYYY HH:mm"
      },
      meridiemParse: /صبح|شام/,
      isPM: function (e) {
        return "شام" === e;
      },
      meridiem: function (e, t, n) {
        return e < 12 ? "صبح" : "شام";
      },
      calendar: {
        sameDay: "[اڄ] LT",
        nextDay: "[سڀاڻي] LT",
        nextWeek: "dddd [اڳين هفتي تي] LT",
        lastDay: "[ڪالهه] LT",
        lastWeek: "[گزريل هفتي] dddd [تي] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%s پوء",
        past: "%s اڳ",
        s: "چند سيڪنڊ",
        ss: "%d سيڪنڊ",
        m: "هڪ منٽ",
        mm: "%d منٽ",
        h: "هڪ ڪلاڪ",
        hh: "%d ڪلاڪ",
        d: "هڪ ڏينهن",
        dd: "%d ڏينهن",
        M: "هڪ مهينو",
        MM: "%d مهينا",
        y: "هڪ سال",
        yy: "%d سال"
      },
      preparse: function (e) {
        return e.replace(/،/g, ",");
      },
      postformat: function (e) {
        return e.replace(/,/g, "،");
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("se", {
      months: "ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu".split("_"),
      monthsShort: "ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov".split("_"),
      weekdays: "sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat".split("_"),
      weekdaysShort: "sotn_vuos_maŋ_gask_duor_bear_láv".split("_"),
      weekdaysMin: "s_v_m_g_d_b_L".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD.MM.YYYY",
        LL: "MMMM D. [b.] YYYY",
        LLL: "MMMM D. [b.] YYYY [ti.] HH:mm",
        LLLL: "dddd, MMMM D. [b.] YYYY [ti.] HH:mm"
      },
      calendar: {
        sameDay: "[otne ti] LT",
        nextDay: "[ihttin ti] LT",
        nextWeek: "dddd [ti] LT",
        lastDay: "[ikte ti] LT",
        lastWeek: "[ovddit] dddd [ti] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%s geažes",
        past: "maŋit %s",
        s: "moadde sekunddat",
        ss: "%d sekunddat",
        m: "okta minuhta",
        mm: "%d minuhtat",
        h: "okta diimmu",
        hh: "%d diimmut",
        d: "okta beaivi",
        dd: "%d beaivvit",
        M: "okta mánnu",
        MM: "%d mánut",
        y: "okta jahki",
        yy: "%d jagit"
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: "%d.",
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("si", {
      months: "ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්".split("_"),
      monthsShort: "ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ".split("_"),
      weekdays: "ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා".split("_"),
      weekdaysShort: "ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන".split("_"),
      weekdaysMin: "ඉ_ස_අ_බ_බ්‍ර_සි_සෙ".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "a h:mm",
        LTS: "a h:mm:ss",
        L: "YYYY/MM/DD",
        LL: "YYYY MMMM D",
        LLL: "YYYY MMMM D, a h:mm",
        LLLL: "YYYY MMMM D [වැනි] dddd, a h:mm:ss"
      },
      calendar: {
        sameDay: "[අද] LT[ට]",
        nextDay: "[හෙට] LT[ට]",
        nextWeek: "dddd LT[ට]",
        lastDay: "[ඊයේ] LT[ට]",
        lastWeek: "[පසුගිය] dddd LT[ට]",
        sameElse: "L"
      },
      relativeTime: {
        future: "%sකින්",
        past: "%sකට පෙර",
        s: "තත්පර කිහිපය",
        ss: "තත්පර %d",
        m: "මිනිත්තුව",
        mm: "මිනිත්තු %d",
        h: "පැය",
        hh: "පැය %d",
        d: "දිනය",
        dd: "දින %d",
        M: "මාසය",
        MM: "මාස %d",
        y: "වසර",
        yy: "වසර %d"
      },
      dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
      ordinal: function (e) {
        return e + " වැනි";
      },
      meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
      isPM: function (e) {
        return "ප.ව." === e || "පස් වරු" === e;
      },
      meridiem: function (e, t, n) {
        return e > 11 ? n ? "ප.ව." : "පස් වරු" : n ? "පෙ.ව." : "පෙර වරු";
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = "január_február_marec_apríl_máj_jún_júl_august_september_október_november_december".split("_"),
      n = "jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec".split("_");
    function a(e) {
      return e > 1 && e < 5;
    }
    function r(e, t, n, r) {
      var i = e + " ";
      switch (n) {
        case "s":
          return t || r ? "pár sekúnd" : "pár sekundami";
        case "ss":
          return t || r ? i + (a(e) ? "sekundy" : "sekúnd") : i + "sekundami";
        case "m":
          return t ? "minúta" : r ? "minútu" : "minútou";
        case "mm":
          return t || r ? i + (a(e) ? "minúty" : "minút") : i + "minútami";
        case "h":
          return t ? "hodina" : r ? "hodinu" : "hodinou";
        case "hh":
          return t || r ? i + (a(e) ? "hodiny" : "hodín") : i + "hodinami";
        case "d":
          return t || r ? "deň" : "dňom";
        case "dd":
          return t || r ? i + (a(e) ? "dni" : "dní") : i + "dňami";
        case "M":
          return t || r ? "mesiac" : "mesiacom";
        case "MM":
          return t || r ? i + (a(e) ? "mesiace" : "mesiacov") : i + "mesiacmi";
        case "y":
          return t || r ? "rok" : "rokom";
        case "yy":
          return t || r ? i + (a(e) ? "roky" : "rokov") : i + "rokmi";
      }
    }
    e.defineLocale("sk", {
      months: t,
      monthsShort: n,
      weekdays: "nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota".split("_"),
      weekdaysShort: "ne_po_ut_st_št_pi_so".split("_"),
      weekdaysMin: "ne_po_ut_st_št_pi_so".split("_"),
      longDateFormat: {
        LT: "H:mm",
        LTS: "H:mm:ss",
        L: "DD.MM.YYYY",
        LL: "D. MMMM YYYY",
        LLL: "D. MMMM YYYY H:mm",
        LLLL: "dddd D. MMMM YYYY H:mm"
      },
      calendar: {
        sameDay: "[dnes o] LT",
        nextDay: "[zajtra o] LT",
        nextWeek: function () {
          switch (this.day()) {
            case 0:
              return "[v nedeľu o] LT";
            case 1:
            case 2:
              return "[v] dddd [o] LT";
            case 3:
              return "[v stredu o] LT";
            case 4:
              return "[vo štvrtok o] LT";
            case 5:
              return "[v piatok o] LT";
            case 6:
              return "[v sobotu o] LT";
          }
        },
        lastDay: "[včera o] LT",
        lastWeek: function () {
          switch (this.day()) {
            case 0:
              return "[minulú nedeľu o] LT";
            case 1:
            case 2:
              return "[minulý] dddd [o] LT";
            case 3:
              return "[minulú stredu o] LT";
            case 4:
            case 5:
              return "[minulý] dddd [o] LT";
            case 6:
              return "[minulú sobotu o] LT";
          }
        },
        sameElse: "L"
      },
      relativeTime: {
        future: "za %s",
        past: "pred %s",
        s: r,
        ss: r,
        m: r,
        mm: r,
        h: r,
        hh: r,
        d: r,
        dd: r,
        M: r,
        MM: r,
        y: r,
        yy: r
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: "%d.",
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    function t(e, t, n, a) {
      var r = e + " ";
      switch (n) {
        case "s":
          return t || a ? "nekaj sekund" : "nekaj sekundami";
        case "ss":
          return r += 1 === e ? t ? "sekundo" : "sekundi" : 2 === e ? t || a ? "sekundi" : "sekundah" : e < 5 ? t || a ? "sekunde" : "sekundah" : "sekund";
        case "m":
          return t ? "ena minuta" : "eno minuto";
        case "mm":
          return r += 1 === e ? t ? "minuta" : "minuto" : 2 === e ? t || a ? "minuti" : "minutama" : e < 5 ? t || a ? "minute" : "minutami" : t || a ? "minut" : "minutami";
        case "h":
          return t ? "ena ura" : "eno uro";
        case "hh":
          return r += 1 === e ? t ? "ura" : "uro" : 2 === e ? t || a ? "uri" : "urama" : e < 5 ? t || a ? "ure" : "urami" : t || a ? "ur" : "urami";
        case "d":
          return t || a ? "en dan" : "enim dnem";
        case "dd":
          return r += 1 === e ? t || a ? "dan" : "dnem" : 2 === e ? t || a ? "dni" : "dnevoma" : t || a ? "dni" : "dnevi";
        case "M":
          return t || a ? "en mesec" : "enim mesecem";
        case "MM":
          return r += 1 === e ? t || a ? "mesec" : "mesecem" : 2 === e ? t || a ? "meseca" : "mesecema" : e < 5 ? t || a ? "mesece" : "meseci" : t || a ? "mesecev" : "meseci";
        case "y":
          return t || a ? "eno leto" : "enim letom";
        case "yy":
          return r += 1 === e ? t || a ? "leto" : "letom" : 2 === e ? t || a ? "leti" : "letoma" : e < 5 ? t || a ? "leta" : "leti" : t || a ? "let" : "leti";
      }
    }
    e.defineLocale("sl", {
      months: "januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december".split("_"),
      monthsShort: "jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.".split("_"),
      monthsParseExact: !0,
      weekdays: "nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota".split("_"),
      weekdaysShort: "ned._pon._tor._sre._čet._pet._sob.".split("_"),
      weekdaysMin: "ne_po_to_sr_če_pe_so".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "H:mm",
        LTS: "H:mm:ss",
        L: "DD. MM. YYYY",
        LL: "D. MMMM YYYY",
        LLL: "D. MMMM YYYY H:mm",
        LLLL: "dddd, D. MMMM YYYY H:mm"
      },
      calendar: {
        sameDay: "[danes ob] LT",
        nextDay: "[jutri ob] LT",
        nextWeek: function () {
          switch (this.day()) {
            case 0:
              return "[v] [nedeljo] [ob] LT";
            case 3:
              return "[v] [sredo] [ob] LT";
            case 6:
              return "[v] [soboto] [ob] LT";
            case 1:
            case 2:
            case 4:
            case 5:
              return "[v] dddd [ob] LT";
          }
        },
        lastDay: "[včeraj ob] LT",
        lastWeek: function () {
          switch (this.day()) {
            case 0:
              return "[prejšnjo] [nedeljo] [ob] LT";
            case 3:
              return "[prejšnjo] [sredo] [ob] LT";
            case 6:
              return "[prejšnjo] [soboto] [ob] LT";
            case 1:
            case 2:
            case 4:
            case 5:
              return "[prejšnji] dddd [ob] LT";
          }
        },
        sameElse: "L"
      },
      relativeTime: {
        future: "čez %s",
        past: "pred %s",
        s: t,
        ss: t,
        m: t,
        mm: t,
        h: t,
        hh: t,
        d: t,
        dd: t,
        M: t,
        MM: t,
        y: t,
        yy: t
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: "%d.",
      week: {
        dow: 1,
        doy: 7
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("sq", {
      months: "Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor".split("_"),
      monthsShort: "Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj".split("_"),
      weekdays: "E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë".split("_"),
      weekdaysShort: "Die_Hën_Mar_Mër_Enj_Pre_Sht".split("_"),
      weekdaysMin: "D_H_Ma_Më_E_P_Sh".split("_"),
      weekdaysParseExact: !0,
      meridiemParse: /PD|MD/,
      isPM: function (e) {
        return "M" === e.charAt(0);
      },
      meridiem: function (e, t, n) {
        return e < 12 ? "PD" : "MD";
      },
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd, D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[Sot në] LT",
        nextDay: "[Nesër në] LT",
        nextWeek: "dddd [në] LT",
        lastDay: "[Dje në] LT",
        lastWeek: "dddd [e kaluar në] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "në %s",
        past: "%s më parë",
        s: "disa sekonda",
        ss: "%d sekonda",
        m: "një minutë",
        mm: "%d minuta",
        h: "një orë",
        hh: "%d orë",
        d: "një ditë",
        dd: "%d ditë",
        M: "një muaj",
        MM: "%d muaj",
        y: "një vit",
        yy: "%d vite"
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: "%d.",
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = {
      words: {
        ss: ["sekunda", "sekunde", "sekundi"],
        m: ["jedan minut", "jedne minute"],
        mm: ["minut", "minute", "minuta"],
        h: ["jedan sat", "jednog sata"],
        hh: ["sat", "sata", "sati"],
        dd: ["dan", "dana", "dana"],
        MM: ["mesec", "meseca", "meseci"],
        yy: ["godina", "godine", "godina"]
      },
      correctGrammaticalCase: function (e, t) {
        return 1 === e ? t[0] : e >= 2 && e <= 4 ? t[1] : t[2];
      },
      translate: function (e, n, a) {
        var r = t.words[a];
        return 1 === a.length ? n ? r[0] : r[1] : e + " " + t.correctGrammaticalCase(e, r);
      }
    };
    e.defineLocale("sr", {
      months: "januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split("_"),
      monthsShort: "jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),
      monthsParseExact: !0,
      weekdays: "nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota".split("_"),
      weekdaysShort: "ned._pon._uto._sre._čet._pet._sub.".split("_"),
      weekdaysMin: "ne_po_ut_sr_če_pe_su".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "H:mm",
        LTS: "H:mm:ss",
        L: "D. M. YYYY.",
        LL: "D. MMMM YYYY.",
        LLL: "D. MMMM YYYY. H:mm",
        LLLL: "dddd, D. MMMM YYYY. H:mm"
      },
      calendar: {
        sameDay: "[danas u] LT",
        nextDay: "[sutra u] LT",
        nextWeek: function () {
          switch (this.day()) {
            case 0:
              return "[u] [nedelju] [u] LT";
            case 3:
              return "[u] [sredu] [u] LT";
            case 6:
              return "[u] [subotu] [u] LT";
            case 1:
            case 2:
            case 4:
            case 5:
              return "[u] dddd [u] LT";
          }
        },
        lastDay: "[juče u] LT",
        lastWeek: function () {
          return ["[prošle] [nedelje] [u] LT", "[prošlog] [ponedeljka] [u] LT", "[prošlog] [utorka] [u] LT", "[prošle] [srede] [u] LT", "[prošlog] [četvrtka] [u] LT", "[prošlog] [petka] [u] LT", "[prošle] [subote] [u] LT"][this.day()];
        },
        sameElse: "L"
      },
      relativeTime: {
        future: "za %s",
        past: "pre %s",
        s: "nekoliko sekundi",
        ss: t.translate,
        m: t.translate,
        mm: t.translate,
        h: t.translate,
        hh: t.translate,
        d: "dan",
        dd: t.translate,
        M: "mesec",
        MM: t.translate,
        y: "godinu",
        yy: t.translate
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: "%d.",
      week: {
        dow: 1,
        doy: 7
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = {
      words: {
        ss: ["секунда", "секунде", "секунди"],
        m: ["један минут", "једне минуте"],
        mm: ["минут", "минуте", "минута"],
        h: ["један сат", "једног сата"],
        hh: ["сат", "сата", "сати"],
        dd: ["дан", "дана", "дана"],
        MM: ["месец", "месеца", "месеци"],
        yy: ["година", "године", "година"]
      },
      correctGrammaticalCase: function (e, t) {
        return 1 === e ? t[0] : e >= 2 && e <= 4 ? t[1] : t[2];
      },
      translate: function (e, n, a) {
        var r = t.words[a];
        return 1 === a.length ? n ? r[0] : r[1] : e + " " + t.correctGrammaticalCase(e, r);
      }
    };
    e.defineLocale("sr-cyrl", {
      months: "јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар".split("_"),
      monthsShort: "јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.".split("_"),
      monthsParseExact: !0,
      weekdays: "недеља_понедељак_уторак_среда_четвртак_петак_субота".split("_"),
      weekdaysShort: "нед._пон._уто._сре._чет._пет._суб.".split("_"),
      weekdaysMin: "не_по_ут_ср_че_пе_су".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "H:mm",
        LTS: "H:mm:ss",
        L: "D. M. YYYY.",
        LL: "D. MMMM YYYY.",
        LLL: "D. MMMM YYYY. H:mm",
        LLLL: "dddd, D. MMMM YYYY. H:mm"
      },
      calendar: {
        sameDay: "[данас у] LT",
        nextDay: "[сутра у] LT",
        nextWeek: function () {
          switch (this.day()) {
            case 0:
              return "[у] [недељу] [у] LT";
            case 3:
              return "[у] [среду] [у] LT";
            case 6:
              return "[у] [суботу] [у] LT";
            case 1:
            case 2:
            case 4:
            case 5:
              return "[у] dddd [у] LT";
          }
        },
        lastDay: "[јуче у] LT",
        lastWeek: function () {
          return ["[прошле] [недеље] [у] LT", "[прошлог] [понедељка] [у] LT", "[прошлог] [уторка] [у] LT", "[прошле] [среде] [у] LT", "[прошлог] [четвртка] [у] LT", "[прошлог] [петка] [у] LT", "[прошле] [суботе] [у] LT"][this.day()];
        },
        sameElse: "L"
      },
      relativeTime: {
        future: "за %s",
        past: "пре %s",
        s: "неколико секунди",
        ss: t.translate,
        m: t.translate,
        mm: t.translate,
        h: t.translate,
        hh: t.translate,
        d: "дан",
        dd: t.translate,
        M: "месец",
        MM: t.translate,
        y: "годину",
        yy: t.translate
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: "%d.",
      week: {
        dow: 1,
        doy: 7
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("ss", {
      months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split("_"),
      monthsShort: "Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo".split("_"),
      weekdays: "Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo".split("_"),
      weekdaysShort: "Lis_Umb_Lsb_Les_Lsi_Lsh_Umg".split("_"),
      weekdaysMin: "Li_Us_Lb_Lt_Ls_Lh_Ug".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "h:mm A",
        LTS: "h:mm:ss A",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY h:mm A",
        LLLL: "dddd, D MMMM YYYY h:mm A"
      },
      calendar: {
        sameDay: "[Namuhla nga] LT",
        nextDay: "[Kusasa nga] LT",
        nextWeek: "dddd [nga] LT",
        lastDay: "[Itolo nga] LT",
        lastWeek: "dddd [leliphelile] [nga] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "nga %s",
        past: "wenteka nga %s",
        s: "emizuzwana lomcane",
        ss: "%d mzuzwana",
        m: "umzuzu",
        mm: "%d emizuzu",
        h: "lihora",
        hh: "%d emahora",
        d: "lilanga",
        dd: "%d emalanga",
        M: "inyanga",
        MM: "%d tinyanga",
        y: "umnyaka",
        yy: "%d iminyaka"
      },
      meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
      meridiem: function (e, t, n) {
        return e < 11 ? "ekuseni" : e < 15 ? "emini" : e < 19 ? "entsambama" : "ebusuku";
      },
      meridiemHour: function (e, t) {
        return 12 === e && (e = 0), "ekuseni" === t ? e : "emini" === t ? e >= 11 ? e : e + 12 : "entsambama" === t || "ebusuku" === t ? 0 === e ? 0 : e + 12 : void 0;
      },
      dayOfMonthOrdinalParse: /\d{1,2}/,
      ordinal: "%d",
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("sv", {
      months: "januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december".split("_"),
      monthsShort: "jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),
      weekdays: "söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag".split("_"),
      weekdaysShort: "sön_mån_tis_ons_tor_fre_lör".split("_"),
      weekdaysMin: "sö_må_ti_on_to_fr_lö".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "YYYY-MM-DD",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY [kl.] HH:mm",
        LLLL: "dddd D MMMM YYYY [kl.] HH:mm",
        lll: "D MMM YYYY HH:mm",
        llll: "ddd D MMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[Idag] LT",
        nextDay: "[Imorgon] LT",
        lastDay: "[Igår] LT",
        nextWeek: "[På] dddd LT",
        lastWeek: "[I] dddd[s] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "om %s",
        past: "för %s sedan",
        s: "några sekunder",
        ss: "%d sekunder",
        m: "en minut",
        mm: "%d minuter",
        h: "en timme",
        hh: "%d timmar",
        d: "en dag",
        dd: "%d dagar",
        M: "en månad",
        MM: "%d månader",
        y: "ett år",
        yy: "%d år"
      },
      dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
      ordinal: function (e) {
        var t = e % 10;
        return e + (1 == ~~(e % 100 / 10) ? ":e" : 1 === t || 2 === t ? ":a" : ":e");
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("sw", {
      months: "Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba".split("_"),
      monthsShort: "Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des".split("_"),
      weekdays: "Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi".split("_"),
      weekdaysShort: "Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos".split("_"),
      weekdaysMin: "J2_J3_J4_J5_Al_Ij_J1".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "hh:mm A",
        LTS: "HH:mm:ss",
        L: "DD.MM.YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd, D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[leo saa] LT",
        nextDay: "[kesho saa] LT",
        nextWeek: "[wiki ijayo] dddd [saat] LT",
        lastDay: "[jana] LT",
        lastWeek: "[wiki iliyopita] dddd [saat] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%s baadaye",
        past: "tokea %s",
        s: "hivi punde",
        ss: "sekunde %d",
        m: "dakika moja",
        mm: "dakika %d",
        h: "saa limoja",
        hh: "masaa %d",
        d: "siku moja",
        dd: "siku %d",
        M: "mwezi mmoja",
        MM: "miezi %d",
        y: "mwaka mmoja",
        yy: "miaka %d"
      },
      week: {
        dow: 1,
        doy: 7
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = {
        1: "௧",
        2: "௨",
        3: "௩",
        4: "௪",
        5: "௫",
        6: "௬",
        7: "௭",
        8: "௮",
        9: "௯",
        0: "௦"
      },
      n = {
        "௧": "1",
        "௨": "2",
        "௩": "3",
        "௪": "4",
        "௫": "5",
        "௬": "6",
        "௭": "7",
        "௮": "8",
        "௯": "9",
        "௦": "0"
      };
    e.defineLocale("ta", {
      months: "ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்".split("_"),
      monthsShort: "ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்".split("_"),
      weekdays: "ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை".split("_"),
      weekdaysShort: "ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி".split("_"),
      weekdaysMin: "ஞா_தி_செ_பு_வி_வெ_ச".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY, HH:mm",
        LLLL: "dddd, D MMMM YYYY, HH:mm"
      },
      calendar: {
        sameDay: "[இன்று] LT",
        nextDay: "[நாளை] LT",
        nextWeek: "dddd, LT",
        lastDay: "[நேற்று] LT",
        lastWeek: "[கடந்த வாரம்] dddd, LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%s இல்",
        past: "%s முன்",
        s: "ஒரு சில விநாடிகள்",
        ss: "%d விநாடிகள்",
        m: "ஒரு நிமிடம்",
        mm: "%d நிமிடங்கள்",
        h: "ஒரு மணி நேரம்",
        hh: "%d மணி நேரம்",
        d: "ஒரு நாள்",
        dd: "%d நாட்கள்",
        M: "ஒரு மாதம்",
        MM: "%d மாதங்கள்",
        y: "ஒரு வருடம்",
        yy: "%d ஆண்டுகள்"
      },
      dayOfMonthOrdinalParse: /\d{1,2}வது/,
      ordinal: function (e) {
        return e + "வது";
      },
      preparse: function (e) {
        return e.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (e) {
          return n[e];
        });
      },
      postformat: function (e) {
        return e.replace(/\d/g, function (e) {
          return t[e];
        });
      },
      meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
      meridiem: function (e, t, n) {
        return e < 2 ? " யாமம்" : e < 6 ? " வைகறை" : e < 10 ? " காலை" : e < 14 ? " நண்பகல்" : e < 18 ? " எற்பாடு" : e < 22 ? " மாலை" : " யாமம்";
      },
      meridiemHour: function (e, t) {
        return 12 === e && (e = 0), "யாமம்" === t ? e < 2 ? e : e + 12 : "வைகறை" === t || "காலை" === t || "நண்பகல்" === t && e >= 10 ? e : e + 12;
      },
      week: {
        dow: 0,
        doy: 6
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("te", {
      months: "జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్".split("_"),
      monthsShort: "జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.".split("_"),
      monthsParseExact: !0,
      weekdays: "ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం".split("_"),
      weekdaysShort: "ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని".split("_"),
      weekdaysMin: "ఆ_సో_మం_బు_గు_శు_శ".split("_"),
      longDateFormat: {
        LT: "A h:mm",
        LTS: "A h:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY, A h:mm",
        LLLL: "dddd, D MMMM YYYY, A h:mm"
      },
      calendar: {
        sameDay: "[నేడు] LT",
        nextDay: "[రేపు] LT",
        nextWeek: "dddd, LT",
        lastDay: "[నిన్న] LT",
        lastWeek: "[గత] dddd, LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%s లో",
        past: "%s క్రితం",
        s: "కొన్ని క్షణాలు",
        ss: "%d సెకన్లు",
        m: "ఒక నిమిషం",
        mm: "%d నిమిషాలు",
        h: "ఒక గంట",
        hh: "%d గంటలు",
        d: "ఒక రోజు",
        dd: "%d రోజులు",
        M: "ఒక నెల",
        MM: "%d నెలలు",
        y: "ఒక సంవత్సరం",
        yy: "%d సంవత్సరాలు"
      },
      dayOfMonthOrdinalParse: /\d{1,2}వ/,
      ordinal: "%dవ",
      meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
      meridiemHour: function (e, t) {
        return 12 === e && (e = 0), "రాత్రి" === t ? e < 4 ? e : e + 12 : "ఉదయం" === t ? e : "మధ్యాహ్నం" === t ? e >= 10 ? e : e + 12 : "సాయంత్రం" === t ? e + 12 : void 0;
      },
      meridiem: function (e, t, n) {
        return e < 4 ? "రాత్రి" : e < 10 ? "ఉదయం" : e < 17 ? "మధ్యాహ్నం" : e < 20 ? "సాయంత్రం" : "రాత్రి";
      },
      week: {
        dow: 0,
        doy: 6
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("tet", {
      months: "Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru".split("_"),
      monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
      weekdays: "Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu".split("_"),
      weekdaysShort: "Dom_Seg_Ters_Kua_Kint_Sest_Sab".split("_"),
      weekdaysMin: "Do_Seg_Te_Ku_Ki_Ses_Sa".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd, D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[Ohin iha] LT",
        nextDay: "[Aban iha] LT",
        nextWeek: "dddd [iha] LT",
        lastDay: "[Horiseik iha] LT",
        lastWeek: "dddd [semana kotuk] [iha] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "iha %s",
        past: "%s liuba",
        s: "segundu balun",
        ss: "segundu %d",
        m: "minutu ida",
        mm: "minutu %d",
        h: "oras ida",
        hh: "oras %d",
        d: "loron ida",
        dd: "loron %d",
        M: "fulan ida",
        MM: "fulan %d",
        y: "tinan ida",
        yy: "tinan %d"
      },
      dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
      ordinal: function (e) {
        var t = e % 10;
        return e + (1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th");
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = {
      0: "-ум",
      1: "-ум",
      2: "-юм",
      3: "-юм",
      4: "-ум",
      5: "-ум",
      6: "-ум",
      7: "-ум",
      8: "-ум",
      9: "-ум",
      10: "-ум",
      12: "-ум",
      13: "-ум",
      20: "-ум",
      30: "-юм",
      40: "-ум",
      50: "-ум",
      60: "-ум",
      70: "-ум",
      80: "-ум",
      90: "-ум",
      100: "-ум"
    };
    e.defineLocale("tg", {
      months: {
        format: "январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри".split("_"),
        standalone: "январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр".split("_")
      },
      monthsShort: "янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек".split("_"),
      weekdays: "якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе".split("_"),
      weekdaysShort: "яшб_дшб_сшб_чшб_пшб_ҷум_шнб".split("_"),
      weekdaysMin: "яш_дш_сш_чш_пш_ҷм_шб".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD.MM.YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd, D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[Имрӯз соати] LT",
        nextDay: "[Фардо соати] LT",
        lastDay: "[Дирӯз соати] LT",
        nextWeek: "dddd[и] [ҳафтаи оянда соати] LT",
        lastWeek: "dddd[и] [ҳафтаи гузашта соати] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "баъди %s",
        past: "%s пеш",
        s: "якчанд сония",
        m: "як дақиқа",
        mm: "%d дақиқа",
        h: "як соат",
        hh: "%d соат",
        d: "як рӯз",
        dd: "%d рӯз",
        M: "як моҳ",
        MM: "%d моҳ",
        y: "як сол",
        yy: "%d сол"
      },
      meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
      meridiemHour: function (e, t) {
        return 12 === e && (e = 0), "шаб" === t ? e < 4 ? e : e + 12 : "субҳ" === t ? e : "рӯз" === t ? e >= 11 ? e : e + 12 : "бегоҳ" === t ? e + 12 : void 0;
      },
      meridiem: function (e, t, n) {
        return e < 4 ? "шаб" : e < 11 ? "субҳ" : e < 16 ? "рӯз" : e < 19 ? "бегоҳ" : "шаб";
      },
      dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
      ordinal: function (e) {
        return e + (t[e] || t[e % 10] || t[e >= 100 ? 100 : null]);
      },
      week: {
        dow: 1,
        doy: 7
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("th", {
      months: "มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม".split("_"),
      monthsShort: "ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.".split("_"),
      monthsParseExact: !0,
      weekdays: "อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์".split("_"),
      weekdaysShort: "อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์".split("_"),
      weekdaysMin: "อา._จ._อ._พ._พฤ._ศ._ส.".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "H:mm",
        LTS: "H:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY เวลา H:mm",
        LLLL: "วันddddที่ D MMMM YYYY เวลา H:mm"
      },
      meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
      isPM: function (e) {
        return "หลังเที่ยง" === e;
      },
      meridiem: function (e, t, n) {
        return e < 12 ? "ก่อนเที่ยง" : "หลังเที่ยง";
      },
      calendar: {
        sameDay: "[วันนี้ เวลา] LT",
        nextDay: "[พรุ่งนี้ เวลา] LT",
        nextWeek: "dddd[หน้า เวลา] LT",
        lastDay: "[เมื่อวานนี้ เวลา] LT",
        lastWeek: "[วัน]dddd[ที่แล้ว เวลา] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "อีก %s",
        past: "%sที่แล้ว",
        s: "ไม่กี่วินาที",
        ss: "%d วินาที",
        m: "1 นาที",
        mm: "%d นาที",
        h: "1 ชั่วโมง",
        hh: "%d ชั่วโมง",
        d: "1 วัน",
        dd: "%d วัน",
        w: "1 สัปดาห์",
        ww: "%d สัปดาห์",
        M: "1 เดือน",
        MM: "%d เดือน",
        y: "1 ปี",
        yy: "%d ปี"
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = {
      1: "'inji",
      5: "'inji",
      8: "'inji",
      70: "'inji",
      80: "'inji",
      2: "'nji",
      7: "'nji",
      20: "'nji",
      50: "'nji",
      3: "'ünji",
      4: "'ünji",
      100: "'ünji",
      6: "'njy",
      9: "'unjy",
      10: "'unjy",
      30: "'unjy",
      60: "'ynjy",
      90: "'ynjy"
    };
    e.defineLocale("tk", {
      months: "Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr".split("_"),
      monthsShort: "Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek".split("_"),
      weekdays: "Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe".split("_"),
      weekdaysShort: "Ýek_Duş_Siş_Çar_Pen_Ann_Şen".split("_"),
      weekdaysMin: "Ýk_Dş_Sş_Çr_Pn_An_Şn".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD.MM.YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd, D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[bugün sagat] LT",
        nextDay: "[ertir sagat] LT",
        nextWeek: "[indiki] dddd [sagat] LT",
        lastDay: "[düýn] LT",
        lastWeek: "[geçen] dddd [sagat] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%s soň",
        past: "%s öň",
        s: "birnäçe sekunt",
        m: "bir minut",
        mm: "%d minut",
        h: "bir sagat",
        hh: "%d sagat",
        d: "bir gün",
        dd: "%d gün",
        M: "bir aý",
        MM: "%d aý",
        y: "bir ýyl",
        yy: "%d ýyl"
      },
      ordinal: function (e, n) {
        switch (n) {
          case "d":
          case "D":
          case "Do":
          case "DD":
            return e;
          default:
            if (0 === e) return e + "'unjy";
            var a = e % 10;
            return e + (t[a] || t[e % 100 - a] || t[e >= 100 ? 100 : null]);
        }
      },
      week: {
        dow: 1,
        doy: 7
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("tl-ph", {
      months: "Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre".split("_"),
      monthsShort: "Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis".split("_"),
      weekdays: "Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado".split("_"),
      weekdaysShort: "Lin_Lun_Mar_Miy_Huw_Biy_Sab".split("_"),
      weekdaysMin: "Li_Lu_Ma_Mi_Hu_Bi_Sab".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "MM/D/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY HH:mm",
        LLLL: "dddd, MMMM DD, YYYY HH:mm"
      },
      calendar: {
        sameDay: "LT [ngayong araw]",
        nextDay: "[Bukas ng] LT",
        nextWeek: "LT [sa susunod na] dddd",
        lastDay: "LT [kahapon]",
        lastWeek: "LT [noong nakaraang] dddd",
        sameElse: "L"
      },
      relativeTime: {
        future: "sa loob ng %s",
        past: "%s ang nakalipas",
        s: "ilang segundo",
        ss: "%d segundo",
        m: "isang minuto",
        mm: "%d minuto",
        h: "isang oras",
        hh: "%d oras",
        d: "isang araw",
        dd: "%d araw",
        M: "isang buwan",
        MM: "%d buwan",
        y: "isang taon",
        yy: "%d taon"
      },
      dayOfMonthOrdinalParse: /\d{1,2}/,
      ordinal: function (e) {
        return e;
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = "pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut".split("_");
    function n(e, n, a, r) {
      var i = function (e) {
        var n = Math.floor(e % 1e3 / 100),
          a = Math.floor(e % 100 / 10),
          r = e % 10,
          i = "";
        return n > 0 && (i += t[n] + "vatlh"), a > 0 && (i += ("" !== i ? " " : "") + t[a] + "maH"), r > 0 && (i += ("" !== i ? " " : "") + t[r]), "" === i ? "pagh" : i;
      }(e);
      switch (a) {
        case "ss":
          return i + " lup";
        case "mm":
          return i + " tup";
        case "hh":
          return i + " rep";
        case "dd":
          return i + " jaj";
        case "MM":
          return i + " jar";
        case "yy":
          return i + " DIS";
      }
    }
    e.defineLocale("tlh", {
      months: "tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’".split("_"),
      monthsShort: "jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’".split("_"),
      monthsParseExact: !0,
      weekdays: "lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),
      weekdaysShort: "lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),
      weekdaysMin: "lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD.MM.YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd, D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[DaHjaj] LT",
        nextDay: "[wa’leS] LT",
        nextWeek: "LLL",
        lastDay: "[wa’Hu’] LT",
        lastWeek: "LLL",
        sameElse: "L"
      },
      relativeTime: {
        future: function (e) {
          var t = e;
          return t = -1 !== e.indexOf("jaj") ? t.slice(0, -3) + "leS" : -1 !== e.indexOf("jar") ? t.slice(0, -3) + "waQ" : -1 !== e.indexOf("DIS") ? t.slice(0, -3) + "nem" : t + " pIq";
        },
        past: function (e) {
          var t = e;
          return t = -1 !== e.indexOf("jaj") ? t.slice(0, -3) + "Hu’" : -1 !== e.indexOf("jar") ? t.slice(0, -3) + "wen" : -1 !== e.indexOf("DIS") ? t.slice(0, -3) + "ben" : t + " ret";
        },
        s: "puS lup",
        ss: n,
        m: "wa’ tup",
        mm: n,
        h: "wa’ rep",
        hh: n,
        d: "wa’ jaj",
        dd: n,
        M: "wa’ jar",
        MM: n,
        y: "wa’ DIS",
        yy: n
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: "%d.",
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = {
      1: "'inci",
      5: "'inci",
      8: "'inci",
      70: "'inci",
      80: "'inci",
      2: "'nci",
      7: "'nci",
      20: "'nci",
      50: "'nci",
      3: "'üncü",
      4: "'üncü",
      100: "'üncü",
      6: "'ncı",
      9: "'uncu",
      10: "'uncu",
      30: "'uncu",
      60: "'ıncı",
      90: "'ıncı"
    };
    e.defineLocale("tr", {
      months: "Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık".split("_"),
      monthsShort: "Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara".split("_"),
      weekdays: "Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi".split("_"),
      weekdaysShort: "Paz_Pts_Sal_Çar_Per_Cum_Cts".split("_"),
      weekdaysMin: "Pz_Pt_Sa_Ça_Pe_Cu_Ct".split("_"),
      meridiem: function (e, t, n) {
        return e < 12 ? n ? "öö" : "ÖÖ" : n ? "ös" : "ÖS";
      },
      meridiemParse: /öö|ÖÖ|ös|ÖS/,
      isPM: function (e) {
        return "ös" === e || "ÖS" === e;
      },
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD.MM.YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd, D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[bugün saat] LT",
        nextDay: "[yarın saat] LT",
        nextWeek: "[gelecek] dddd [saat] LT",
        lastDay: "[dün] LT",
        lastWeek: "[geçen] dddd [saat] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%s sonra",
        past: "%s önce",
        s: "birkaç saniye",
        ss: "%d saniye",
        m: "bir dakika",
        mm: "%d dakika",
        h: "bir saat",
        hh: "%d saat",
        d: "bir gün",
        dd: "%d gün",
        w: "bir hafta",
        ww: "%d hafta",
        M: "bir ay",
        MM: "%d ay",
        y: "bir yıl",
        yy: "%d yıl"
      },
      ordinal: function (e, n) {
        switch (n) {
          case "d":
          case "D":
          case "Do":
          case "DD":
            return e;
          default:
            if (0 === e) return e + "'ıncı";
            var a = e % 10;
            return e + (t[a] || t[e % 100 - a] || t[e >= 100 ? 100 : null]);
        }
      },
      week: {
        dow: 1,
        doy: 7
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    function t(e, t, n, a) {
      var r = {
        s: ["viensas secunds", "'iensas secunds"],
        ss: [e + " secunds", e + " secunds"],
        m: ["'n míut", "'iens míut"],
        mm: [e + " míuts", e + " míuts"],
        h: ["'n þora", "'iensa þora"],
        hh: [e + " þoras", e + " þoras"],
        d: ["'n ziua", "'iensa ziua"],
        dd: [e + " ziuas", e + " ziuas"],
        M: ["'n mes", "'iens mes"],
        MM: [e + " mesen", e + " mesen"],
        y: ["'n ar", "'iens ar"],
        yy: [e + " ars", e + " ars"]
      };
      return a || t ? r[n][0] : r[n][1];
    }
    e.defineLocale("tzl", {
      months: "Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar".split("_"),
      monthsShort: "Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec".split("_"),
      weekdays: "Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi".split("_"),
      weekdaysShort: "Súl_Lún_Mai_Már_Xhú_Vié_Sát".split("_"),
      weekdaysMin: "Sú_Lú_Ma_Má_Xh_Vi_Sá".split("_"),
      longDateFormat: {
        LT: "HH.mm",
        LTS: "HH.mm.ss",
        L: "DD.MM.YYYY",
        LL: "D. MMMM [dallas] YYYY",
        LLL: "D. MMMM [dallas] YYYY HH.mm",
        LLLL: "dddd, [li] D. MMMM [dallas] YYYY HH.mm"
      },
      meridiemParse: /d\'o|d\'a/i,
      isPM: function (e) {
        return "d'o" === e.toLowerCase();
      },
      meridiem: function (e, t, n) {
        return e > 11 ? n ? "d'o" : "D'O" : n ? "d'a" : "D'A";
      },
      calendar: {
        sameDay: "[oxhi à] LT",
        nextDay: "[demà à] LT",
        nextWeek: "dddd [à] LT",
        lastDay: "[ieiri à] LT",
        lastWeek: "[sür el] dddd [lasteu à] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "osprei %s",
        past: "ja%s",
        s: t,
        ss: t,
        m: t,
        mm: t,
        h: t,
        hh: t,
        d: t,
        dd: t,
        M: t,
        MM: t,
        y: t,
        yy: t
      },
      dayOfMonthOrdinalParse: /\d{1,2}\./,
      ordinal: "%d.",
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("tzm", {
      months: "ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ".split("_"),
      monthsShort: "ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ".split("_"),
      weekdays: "ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ".split("_"),
      weekdaysShort: "ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ".split("_"),
      weekdaysMin: "ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[ⴰⵙⴷⵅ ⴴ] LT",
        nextDay: "[ⴰⵙⴽⴰ ⴴ] LT",
        nextWeek: "dddd [ⴴ] LT",
        lastDay: "[ⴰⵚⴰⵏⵜ ⴴ] LT",
        lastWeek: "dddd [ⴴ] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s",
        past: "ⵢⴰⵏ %s",
        s: "ⵉⵎⵉⴽ",
        ss: "%d ⵉⵎⵉⴽ",
        m: "ⵎⵉⵏⵓⴺ",
        mm: "%d ⵎⵉⵏⵓⴺ",
        h: "ⵙⴰⵄⴰ",
        hh: "%d ⵜⴰⵙⵙⴰⵄⵉⵏ",
        d: "ⴰⵙⵙ",
        dd: "%d oⵙⵙⴰⵏ",
        M: "ⴰⵢoⵓⵔ",
        MM: "%d ⵉⵢⵢⵉⵔⵏ",
        y: "ⴰⵙⴳⴰⵙ",
        yy: "%d ⵉⵙⴳⴰⵙⵏ"
      },
      week: {
        dow: 6,
        doy: 12
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("tzm-latn", {
      months: "innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir".split("_"),
      monthsShort: "innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir".split("_"),
      weekdays: "asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas".split("_"),
      weekdaysShort: "asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas".split("_"),
      weekdaysMin: "asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[asdkh g] LT",
        nextDay: "[aska g] LT",
        nextWeek: "dddd [g] LT",
        lastDay: "[assant g] LT",
        lastWeek: "dddd [g] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "dadkh s yan %s",
        past: "yan %s",
        s: "imik",
        ss: "%d imik",
        m: "minuḍ",
        mm: "%d minuḍ",
        h: "saɛa",
        hh: "%d tassaɛin",
        d: "ass",
        dd: "%d ossan",
        M: "ayowr",
        MM: "%d iyyirn",
        y: "asgas",
        yy: "%d isgasn"
      },
      week: {
        dow: 6,
        doy: 12
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("ug-cn", {
      months: "يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر".split("_"),
      monthsShort: "يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر".split("_"),
      weekdays: "يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە".split("_"),
      weekdaysShort: "يە_دۈ_سە_چا_پە_جۈ_شە".split("_"),
      weekdaysMin: "يە_دۈ_سە_چا_پە_جۈ_شە".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "YYYY-MM-DD",
        LL: "YYYY-يىلىM-ئاينىڭD-كۈنى",
        LLL: "YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm",
        LLLL: "dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm"
      },
      meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
      meridiemHour: function (e, t) {
        return 12 === e && (e = 0), "يېرىم كېچە" === t || "سەھەر" === t || "چۈشتىن بۇرۇن" === t ? e : "چۈشتىن كېيىن" === t || "كەچ" === t ? e + 12 : e >= 11 ? e : e + 12;
      },
      meridiem: function (e, t, n) {
        var a = 100 * e + t;
        return a < 600 ? "يېرىم كېچە" : a < 900 ? "سەھەر" : a < 1130 ? "چۈشتىن بۇرۇن" : a < 1230 ? "چۈش" : a < 1800 ? "چۈشتىن كېيىن" : "كەچ";
      },
      calendar: {
        sameDay: "[بۈگۈن سائەت] LT",
        nextDay: "[ئەتە سائەت] LT",
        nextWeek: "[كېلەركى] dddd [سائەت] LT",
        lastDay: "[تۆنۈگۈن] LT",
        lastWeek: "[ئالدىنقى] dddd [سائەت] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%s كېيىن",
        past: "%s بۇرۇن",
        s: "نەچچە سېكونت",
        ss: "%d سېكونت",
        m: "بىر مىنۇت",
        mm: "%d مىنۇت",
        h: "بىر سائەت",
        hh: "%d سائەت",
        d: "بىر كۈن",
        dd: "%d كۈن",
        M: "بىر ئاي",
        MM: "%d ئاي",
        y: "بىر يىل",
        yy: "%d يىل"
      },
      dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
      ordinal: function (e, t) {
        switch (t) {
          case "d":
          case "D":
          case "DDD":
            return e + "-كۈنى";
          case "w":
          case "W":
            return e + "-ھەپتە";
          default:
            return e;
        }
      },
      preparse: function (e) {
        return e.replace(/،/g, ",");
      },
      postformat: function (e) {
        return e.replace(/,/g, "،");
      },
      week: {
        dow: 1,
        doy: 7
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    function t(e, t, n) {
      var a, r;
      return "m" === n ? t ? "хвилина" : "хвилину" : "h" === n ? t ? "година" : "годину" : e + " " + (a = +e, r = {
        ss: t ? "секунда_секунди_секунд" : "секунду_секунди_секунд",
        mm: t ? "хвилина_хвилини_хвилин" : "хвилину_хвилини_хвилин",
        hh: t ? "година_години_годин" : "годину_години_годин",
        dd: "день_дні_днів",
        MM: "місяць_місяці_місяців",
        yy: "рік_роки_років"
      }[n].split("_"), a % 10 == 1 && a % 100 != 11 ? r[0] : a % 10 >= 2 && a % 10 <= 4 && (a % 100 < 10 || a % 100 >= 20) ? r[1] : r[2]);
    }
    function n(e) {
      return function () {
        return e + "о" + (11 === this.hours() ? "б" : "") + "] LT";
      };
    }
    e.defineLocale("uk", {
      months: {
        format: "січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня".split("_"),
        standalone: "січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень".split("_")
      },
      monthsShort: "січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд".split("_"),
      weekdays: function (e, t) {
        var n = {
          nominative: "неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота".split("_"),
          accusative: "неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу".split("_"),
          genitive: "неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи".split("_")
        };
        return !0 === e ? n.nominative.slice(1, 7).concat(n.nominative.slice(0, 1)) : e ? n[/(\[[ВвУу]\]) ?dddd/.test(t) ? "accusative" : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(t) ? "genitive" : "nominative"][e.day()] : n.nominative;
      },
      weekdaysShort: "нд_пн_вт_ср_чт_пт_сб".split("_"),
      weekdaysMin: "нд_пн_вт_ср_чт_пт_сб".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD.MM.YYYY",
        LL: "D MMMM YYYY р.",
        LLL: "D MMMM YYYY р., HH:mm",
        LLLL: "dddd, D MMMM YYYY р., HH:mm"
      },
      calendar: {
        sameDay: n("[Сьогодні "),
        nextDay: n("[Завтра "),
        lastDay: n("[Вчора "),
        nextWeek: n("[У] dddd ["),
        lastWeek: function () {
          switch (this.day()) {
            case 0:
            case 3:
            case 5:
            case 6:
              return n("[Минулої] dddd [").call(this);
            case 1:
            case 2:
            case 4:
              return n("[Минулого] dddd [").call(this);
          }
        },
        sameElse: "L"
      },
      relativeTime: {
        future: "за %s",
        past: "%s тому",
        s: "декілька секунд",
        ss: t,
        m: t,
        mm: t,
        h: "годину",
        hh: t,
        d: "день",
        dd: t,
        M: "місяць",
        MM: t,
        y: "рік",
        yy: t
      },
      meridiemParse: /ночі|ранку|дня|вечора/,
      isPM: function (e) {
        return /^(дня|вечора)$/.test(e);
      },
      meridiem: function (e, t, n) {
        return e < 4 ? "ночі" : e < 12 ? "ранку" : e < 17 ? "дня" : "вечора";
      },
      dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
      ordinal: function (e, t) {
        switch (t) {
          case "M":
          case "d":
          case "DDD":
          case "w":
          case "W":
            return e + "-й";
          case "D":
            return e + "-го";
          default:
            return e;
        }
      },
      week: {
        dow: 1,
        doy: 7
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    var t = ["جنوری", "فروری", "مارچ", "اپریل", "مئی", "جون", "جولائی", "اگست", "ستمبر", "اکتوبر", "نومبر", "دسمبر"],
      n = ["اتوار", "پیر", "منگل", "بدھ", "جمعرات", "جمعہ", "ہفتہ"];
    e.defineLocale("ur", {
      months: t,
      monthsShort: t,
      weekdays: n,
      weekdaysShort: n,
      weekdaysMin: n,
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd، D MMMM YYYY HH:mm"
      },
      meridiemParse: /صبح|شام/,
      isPM: function (e) {
        return "شام" === e;
      },
      meridiem: function (e, t, n) {
        return e < 12 ? "صبح" : "شام";
      },
      calendar: {
        sameDay: "[آج بوقت] LT",
        nextDay: "[کل بوقت] LT",
        nextWeek: "dddd [بوقت] LT",
        lastDay: "[گذشتہ روز بوقت] LT",
        lastWeek: "[گذشتہ] dddd [بوقت] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%s بعد",
        past: "%s قبل",
        s: "چند سیکنڈ",
        ss: "%d سیکنڈ",
        m: "ایک منٹ",
        mm: "%d منٹ",
        h: "ایک گھنٹہ",
        hh: "%d گھنٹے",
        d: "ایک دن",
        dd: "%d دن",
        M: "ایک ماہ",
        MM: "%d ماہ",
        y: "ایک سال",
        yy: "%d سال"
      },
      preparse: function (e) {
        return e.replace(/،/g, ",");
      },
      postformat: function (e) {
        return e.replace(/,/g, "،");
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("uz", {
      months: "январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр".split("_"),
      monthsShort: "янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек".split("_"),
      weekdays: "Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба".split("_"),
      weekdaysShort: "Якш_Душ_Сеш_Чор_Пай_Жум_Шан".split("_"),
      weekdaysMin: "Як_Ду_Се_Чо_Па_Жу_Ша".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "D MMMM YYYY, dddd HH:mm"
      },
      calendar: {
        sameDay: "[Бугун соат] LT [да]",
        nextDay: "[Эртага] LT [да]",
        nextWeek: "dddd [куни соат] LT [да]",
        lastDay: "[Кеча соат] LT [да]",
        lastWeek: "[Утган] dddd [куни соат] LT [да]",
        sameElse: "L"
      },
      relativeTime: {
        future: "Якин %s ичида",
        past: "Бир неча %s олдин",
        s: "фурсат",
        ss: "%d фурсат",
        m: "бир дакика",
        mm: "%d дакика",
        h: "бир соат",
        hh: "%d соат",
        d: "бир кун",
        dd: "%d кун",
        M: "бир ой",
        MM: "%d ой",
        y: "бир йил",
        yy: "%d йил"
      },
      week: {
        dow: 1,
        doy: 7
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("uz-latn", {
      months: "Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr".split("_"),
      monthsShort: "Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek".split("_"),
      weekdays: "Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba".split("_"),
      weekdaysShort: "Yak_Dush_Sesh_Chor_Pay_Jum_Shan".split("_"),
      weekdaysMin: "Ya_Du_Se_Cho_Pa_Ju_Sha".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "D MMMM YYYY, dddd HH:mm"
      },
      calendar: {
        sameDay: "[Bugun soat] LT [da]",
        nextDay: "[Ertaga] LT [da]",
        nextWeek: "dddd [kuni soat] LT [da]",
        lastDay: "[Kecha soat] LT [da]",
        lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
        sameElse: "L"
      },
      relativeTime: {
        future: "Yaqin %s ichida",
        past: "Bir necha %s oldin",
        s: "soniya",
        ss: "%d soniya",
        m: "bir daqiqa",
        mm: "%d daqiqa",
        h: "bir soat",
        hh: "%d soat",
        d: "bir kun",
        dd: "%d kun",
        M: "bir oy",
        MM: "%d oy",
        y: "bir yil",
        yy: "%d yil"
      },
      week: {
        dow: 1,
        doy: 7
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("vi", {
      months: "tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12".split("_"),
      monthsShort: "Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12".split("_"),
      monthsParseExact: !0,
      weekdays: "chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy".split("_"),
      weekdaysShort: "CN_T2_T3_T4_T5_T6_T7".split("_"),
      weekdaysMin: "CN_T2_T3_T4_T5_T6_T7".split("_"),
      weekdaysParseExact: !0,
      meridiemParse: /sa|ch/i,
      isPM: function (e) {
        return /^ch$/i.test(e);
      },
      meridiem: function (e, t, n) {
        return e < 12 ? n ? "sa" : "SA" : n ? "ch" : "CH";
      },
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "D MMMM [năm] YYYY",
        LLL: "D MMMM [năm] YYYY HH:mm",
        LLLL: "dddd, D MMMM [năm] YYYY HH:mm",
        l: "DD/M/YYYY",
        ll: "D MMM YYYY",
        lll: "D MMM YYYY HH:mm",
        llll: "ddd, D MMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[Hôm nay lúc] LT",
        nextDay: "[Ngày mai lúc] LT",
        nextWeek: "dddd [tuần tới lúc] LT",
        lastDay: "[Hôm qua lúc] LT",
        lastWeek: "dddd [tuần trước lúc] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "%s tới",
        past: "%s trước",
        s: "vài giây",
        ss: "%d giây",
        m: "một phút",
        mm: "%d phút",
        h: "một giờ",
        hh: "%d giờ",
        d: "một ngày",
        dd: "%d ngày",
        w: "một tuần",
        ww: "%d tuần",
        M: "một tháng",
        MM: "%d tháng",
        y: "một năm",
        yy: "%d năm"
      },
      dayOfMonthOrdinalParse: /\d{1,2}/,
      ordinal: function (e) {
        return e;
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("x-pseudo", {
      months: "J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér".split("_"),
      monthsShort: "J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc".split("_"),
      monthsParseExact: !0,
      weekdays: "S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý".split("_"),
      weekdaysShort: "S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát".split("_"),
      weekdaysMin: "S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá".split("_"),
      weekdaysParseExact: !0,
      longDateFormat: {
        LT: "HH:mm",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY HH:mm",
        LLLL: "dddd, D MMMM YYYY HH:mm"
      },
      calendar: {
        sameDay: "[T~ódá~ý át] LT",
        nextDay: "[T~ómó~rró~w át] LT",
        nextWeek: "dddd [át] LT",
        lastDay: "[Ý~ést~érdá~ý át] LT",
        lastWeek: "[L~ást] dddd [át] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "í~ñ %s",
        past: "%s á~gó",
        s: "á ~féw ~sécó~ñds",
        ss: "%d s~écóñ~ds",
        m: "á ~míñ~úté",
        mm: "%d m~íñú~tés",
        h: "á~ñ hó~úr",
        hh: "%d h~óúrs",
        d: "á ~dáý",
        dd: "%d d~áýs",
        M: "á ~móñ~th",
        MM: "%d m~óñt~hs",
        y: "á ~ýéár",
        yy: "%d ý~éárs"
      },
      dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
      ordinal: function (e) {
        var t = e % 10;
        return e + (1 == ~~(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th");
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("yo", {
      months: "Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀".split("_"),
      monthsShort: "Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀".split("_"),
      weekdays: "Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta".split("_"),
      weekdaysShort: "Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá".split("_"),
      weekdaysMin: "Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb".split("_"),
      longDateFormat: {
        LT: "h:mm A",
        LTS: "h:mm:ss A",
        L: "DD/MM/YYYY",
        LL: "D MMMM YYYY",
        LLL: "D MMMM YYYY h:mm A",
        LLLL: "dddd, D MMMM YYYY h:mm A"
      },
      calendar: {
        sameDay: "[Ònì ni] LT",
        nextDay: "[Ọ̀la ni] LT",
        nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
        lastDay: "[Àna ni] LT",
        lastWeek: "dddd [Ọsẹ̀ tólọ́] [ni] LT",
        sameElse: "L"
      },
      relativeTime: {
        future: "ní %s",
        past: "%s kọjá",
        s: "ìsẹjú aayá die",
        ss: "aayá %d",
        m: "ìsẹjú kan",
        mm: "ìsẹjú %d",
        h: "wákati kan",
        hh: "wákati %d",
        d: "ọjọ́ kan",
        dd: "ọjọ́ %d",
        M: "osù kan",
        MM: "osù %d",
        y: "ọdún kan",
        yy: "ọdún %d"
      },
      dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
      ordinal: "ọjọ́ %d",
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("zh-cn", {
      months: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),
      monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
      weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),
      weekdaysShort: "周日_周一_周二_周三_周四_周五_周六".split("_"),
      weekdaysMin: "日_一_二_三_四_五_六".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "YYYY/MM/DD",
        LL: "YYYY年M月D日",
        LLL: "YYYY年M月D日Ah点mm分",
        LLLL: "YYYY年M月D日ddddAh点mm分",
        l: "YYYY/M/D",
        ll: "YYYY年M月D日",
        lll: "YYYY年M月D日 HH:mm",
        llll: "YYYY年M月D日dddd HH:mm"
      },
      meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
      meridiemHour: function (e, t) {
        return 12 === e && (e = 0), "凌晨" === t || "早上" === t || "上午" === t ? e : "下午" === t || "晚上" === t ? e + 12 : e >= 11 ? e : e + 12;
      },
      meridiem: function (e, t, n) {
        var a = 100 * e + t;
        return a < 600 ? "凌晨" : a < 900 ? "早上" : a < 1130 ? "上午" : a < 1230 ? "中午" : a < 1800 ? "下午" : "晚上";
      },
      calendar: {
        sameDay: "[今天]LT",
        nextDay: "[明天]LT",
        nextWeek: function (e) {
          return e.week() !== this.week() ? "[下]dddLT" : "[本]dddLT";
        },
        lastDay: "[昨天]LT",
        lastWeek: function (e) {
          return this.week() !== e.week() ? "[上]dddLT" : "[本]dddLT";
        },
        sameElse: "L"
      },
      dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
      ordinal: function (e, t) {
        switch (t) {
          case "d":
          case "D":
          case "DDD":
            return e + "日";
          case "M":
            return e + "月";
          case "w":
          case "W":
            return e + "周";
          default:
            return e;
        }
      },
      relativeTime: {
        future: "%s后",
        past: "%s前",
        s: "几秒",
        ss: "%d 秒",
        m: "1 分钟",
        mm: "%d 分钟",
        h: "1 小时",
        hh: "%d 小时",
        d: "1 天",
        dd: "%d 天",
        w: "1 周",
        ww: "%d 周",
        M: "1 个月",
        MM: "%d 个月",
        y: "1 年",
        yy: "%d 年"
      },
      week: {
        dow: 1,
        doy: 4
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("zh-hk", {
      months: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),
      monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
      weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),
      weekdaysShort: "週日_週一_週二_週三_週四_週五_週六".split("_"),
      weekdaysMin: "日_一_二_三_四_五_六".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "YYYY/MM/DD",
        LL: "YYYY年M月D日",
        LLL: "YYYY年M月D日 HH:mm",
        LLLL: "YYYY年M月D日dddd HH:mm",
        l: "YYYY/M/D",
        ll: "YYYY年M月D日",
        lll: "YYYY年M月D日 HH:mm",
        llll: "YYYY年M月D日dddd HH:mm"
      },
      meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
      meridiemHour: function (e, t) {
        return 12 === e && (e = 0), "凌晨" === t || "早上" === t || "上午" === t ? e : "中午" === t ? e >= 11 ? e : e + 12 : "下午" === t || "晚上" === t ? e + 12 : void 0;
      },
      meridiem: function (e, t, n) {
        var a = 100 * e + t;
        return a < 600 ? "凌晨" : a < 900 ? "早上" : a < 1200 ? "上午" : 1200 === a ? "中午" : a < 1800 ? "下午" : "晚上";
      },
      calendar: {
        sameDay: "[今天]LT",
        nextDay: "[明天]LT",
        nextWeek: "[下]ddddLT",
        lastDay: "[昨天]LT",
        lastWeek: "[上]ddddLT",
        sameElse: "L"
      },
      dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
      ordinal: function (e, t) {
        switch (t) {
          case "d":
          case "D":
          case "DDD":
            return e + "日";
          case "M":
            return e + "月";
          case "w":
          case "W":
            return e + "週";
          default:
            return e;
        }
      },
      relativeTime: {
        future: "%s後",
        past: "%s前",
        s: "幾秒",
        ss: "%d 秒",
        m: "1 分鐘",
        mm: "%d 分鐘",
        h: "1 小時",
        hh: "%d 小時",
        d: "1 天",
        dd: "%d 天",
        M: "1 個月",
        MM: "%d 個月",
        y: "1 年",
        yy: "%d 年"
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("zh-mo", {
      months: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),
      monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
      weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),
      weekdaysShort: "週日_週一_週二_週三_週四_週五_週六".split("_"),
      weekdaysMin: "日_一_二_三_四_五_六".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "DD/MM/YYYY",
        LL: "YYYY年M月D日",
        LLL: "YYYY年M月D日 HH:mm",
        LLLL: "YYYY年M月D日dddd HH:mm",
        l: "D/M/YYYY",
        ll: "YYYY年M月D日",
        lll: "YYYY年M月D日 HH:mm",
        llll: "YYYY年M月D日dddd HH:mm"
      },
      meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
      meridiemHour: function (e, t) {
        return 12 === e && (e = 0), "凌晨" === t || "早上" === t || "上午" === t ? e : "中午" === t ? e >= 11 ? e : e + 12 : "下午" === t || "晚上" === t ? e + 12 : void 0;
      },
      meridiem: function (e, t, n) {
        var a = 100 * e + t;
        return a < 600 ? "凌晨" : a < 900 ? "早上" : a < 1130 ? "上午" : a < 1230 ? "中午" : a < 1800 ? "下午" : "晚上";
      },
      calendar: {
        sameDay: "[今天] LT",
        nextDay: "[明天] LT",
        nextWeek: "[下]dddd LT",
        lastDay: "[昨天] LT",
        lastWeek: "[上]dddd LT",
        sameElse: "L"
      },
      dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
      ordinal: function (e, t) {
        switch (t) {
          case "d":
          case "D":
          case "DDD":
            return e + "日";
          case "M":
            return e + "月";
          case "w":
          case "W":
            return e + "週";
          default:
            return e;
        }
      },
      relativeTime: {
        future: "%s內",
        past: "%s前",
        s: "幾秒",
        ss: "%d 秒",
        m: "1 分鐘",
        mm: "%d 分鐘",
        h: "1 小時",
        hh: "%d 小時",
        d: "1 天",
        dd: "%d 天",
        M: "1 個月",
        MM: "%d 個月",
        y: "1 年",
        yy: "%d 年"
      }
    });
  }(n(1));
}, function (e, t, n) {
  !function (e) {
    "use strict";

    //! moment.js locale configuration
    e.defineLocale("zh-tw", {
      months: "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),
      monthsShort: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
      weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),
      weekdaysShort: "週日_週一_週二_週三_週四_週五_週六".split("_"),
      weekdaysMin: "日_一_二_三_四_五_六".split("_"),
      longDateFormat: {
        LT: "HH:mm",
        LTS: "HH:mm:ss",
        L: "YYYY/MM/DD",
        LL: "YYYY年M月D日",
        LLL: "YYYY年M月D日 HH:mm",
        LLLL: "YYYY年M月D日dddd HH:mm",
        l: "YYYY/M/D",
        ll: "YYYY年M月D日",
        lll: "YYYY年M月D日 HH:mm",
        llll: "YYYY年M月D日dddd HH:mm"
      },
      meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
      meridiemHour: function (e, t) {
        return 12 === e && (e = 0), "凌晨" === t || "早上" === t || "上午" === t ? e : "中午" === t ? e >= 11 ? e : e + 12 : "下午" === t || "晚上" === t ? e + 12 : void 0;
      },
      meridiem: function (e, t, n) {
        var a = 100 * e + t;
        return a < 600 ? "凌晨" : a < 900 ? "早上" : a < 1130 ? "上午" : a < 1230 ? "中午" : a < 1800 ? "下午" : "晚上";
      },
      calendar: {
        sameDay: "[今天] LT",
        nextDay: "[明天] LT",
        nextWeek: "[下]dddd LT",
        lastDay: "[昨天] LT",
        lastWeek: "[上]dddd LT",
        sameElse: "L"
      },
      dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
      ordinal: function (e, t) {
        switch (t) {
          case "d":
          case "D":
          case "DDD":
            return e + "日";
          case "M":
            return e + "月";
          case "w":
          case "W":
            return e + "週";
          default:
            return e;
        }
      },
      relativeTime: {
        future: "%s後",
        past: "%s前",
        s: "幾秒",
        ss: "%d 秒",
        m: "1 分鐘",
        mm: "%d 分鐘",
        h: "1 小時",
        hh: "%d 小時",
        d: "1 天",
        dd: "%d 天",
        M: "1 個月",
        MM: "%d 個月",
        y: "1 年",
        yy: "%d 年"
      }
    });
  }(n(1));
}, function (e, t) {
  e.exports = require("react-router-dom");
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = function (e, t) {
    if (Array.isArray(e)) return e;
    if (Symbol.iterator in Object(e)) return function (e, t) {
      var n = [],
        a = !0,
        r = !1,
        i = void 0;
      try {
        for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
      } catch (e) {
        r = !0, i = e;
      } finally {
        try {
          !a && s.return && s.return();
        } finally {
          if (r) throw i;
        }
      }
      return n;
    }(e, t);
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  };
  t.SearchInputComponent = function (e) {
    var t = (0, r.useState)(""),
      n = a(t, 2),
      s = n[0],
      l = n[1],
      d = e.lang ? e.lang : "en";
    return (0, r.useEffect)(function () {
      e.keyword && l(e.keyword);
    }, []), i.default.createElement("form", {
      onSubmit: function (e) {
        e.preventDefault(), "undefined" != typeof window && (window.location.href = "/" + d + "/search#" + s);
      }
    }, i.default.createElement("div", {
      className: "form-group"
    }, i.default.createElement("div", {
      className: "input-group mt-2 mb-5"
    }, i.default.createElement("input", {
      type: "search",
      className: "form-control",
      id: "siteSearch",
      name: "siteSearch",
      placeholder: "Search",
      value: s,
      onChange: function (e) {
        l(e.target.value);
      },
      autoComplete: "off"
    }), i.default.createElement("div", {
      className: "input-group-search"
    }, i.default.createElement("a", {
      href: "/" + d + "/search#" + s
    }, i.default.createElement("button", {
      type: "submit",
      className: "btn btn-bk-primary"
    }, i.default.createElement("span", null, i.default.createElement(o.default, {
      width: "24",
      height: "24"
    }))))))));
  };
  var r = n(0),
    i = s(r),
    o = s(n(10));
  function s(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
}, function (e, t, n) {
  (function (a) {
    var r;
    e.exports = (r = n(0), function (e) {
      var t = {};
      function n(a) {
        if (t[a]) return t[a].exports;
        var r = t[a] = {
          i: a,
          l: !1,
          exports: {}
        };
        return e[a].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
      }
      return n.m = e, n.c = t, n.d = function (e, t, a) {
        n.o(e, t) || Object.defineProperty(e, t, {
          enumerable: !0,
          get: a
        });
      }, n.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }, n.t = function (e, t) {
        if (1 & t && (e = n(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var a = Object.create(null);
        if (n.r(a), Object.defineProperty(a, "default", {
          enumerable: !0,
          value: e
        }), 2 & t && "string" != typeof e) for (var r in e) n.d(a, r, function (t) {
          return e[t];
        }.bind(null, r));
        return a;
      }, n.n = function (e) {
        var t = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };
        return n.d(t, "a", t), t;
      }, n.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, n.p = "", n(n.s = 4);
    }([function (e, t, n) {
      e.exports = n(2)();
    }, function (e, t) {
      e.exports = r;
    }, function (e, t, n) {
      "use strict";

      var a = n(3);
      function r() {}
      function i() {}
      i.resetWarningCache = r, e.exports = function () {
        function e(e, t, n, r, i, o) {
          if (o !== a) {
            var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
            throw s.name = "Invariant Violation", s;
          }
        }
        function t() {
          return e;
        }
        e.isRequired = e;
        var n = {
          array: e,
          bool: e,
          func: e,
          number: e,
          object: e,
          string: e,
          symbol: e,
          any: e,
          arrayOf: t,
          element: e,
          elementType: e,
          instanceOf: t,
          node: e,
          objectOf: t,
          oneOf: t,
          oneOfType: t,
          shape: t,
          exact: t,
          checkPropTypes: i,
          resetWarningCache: r
        };
        return n.PropTypes = n, n;
      };
    }, function (e, t, n) {
      "use strict";

      e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    }, function (e, n, a) {
      "use strict";

      a.r(n);
      var r = a(1),
        i = a.n(r),
        o = a(0),
        s = a.n(o);
      function l() {
        return (l = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];
            for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
          }
          return e;
        }).apply(this, arguments);
      }
      var d = function (e) {
        var t = e.pageClassName,
          n = e.pageLinkClassName,
          a = e.page,
          r = e.selected,
          o = e.activeClassName,
          s = e.activeLinkClassName,
          d = e.getEventListener,
          u = e.pageSelectedHandler,
          c = e.href,
          m = e.extraAriaContext,
          f = e.ariaLabel || "Page " + a + (m ? " " + m : ""),
          p = null;
        return r && (p = "page", f = e.ariaLabel || "Page " + a + " is your current page", t = void 0 !== t ? t + " " + o : o, void 0 !== n ? void 0 !== s && (n = n + " " + s) : n = s), i.a.createElement("li", {
          className: t
        }, i.a.createElement("a", l({
          role: "button",
          className: n,
          href: c,
          tabIndex: "0",
          "aria-label": f,
          "aria-current": p,
          onKeyPress: u
        }, d(u)), a));
      };
      d.propTypes = {
        pageSelectedHandler: s.a.func.isRequired,
        selected: s.a.bool.isRequired,
        pageClassName: s.a.string,
        pageLinkClassName: s.a.string,
        activeClassName: s.a.string,
        activeLinkClassName: s.a.string,
        extraAriaContext: s.a.string,
        href: s.a.string,
        ariaLabel: s.a.string,
        page: s.a.number.isRequired,
        getEventListener: s.a.func.isRequired
      };
      var u = d;
      function c() {
        return (c = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];
            for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
          }
          return e;
        }).apply(this, arguments);
      }
      !function () {
        var e = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.default : void 0;
        if (e) {
          var a = void 0 !== n ? n : t;
          if (a) if ("function" != typeof a) {
            for (var r in a) if (Object.prototype.hasOwnProperty.call(a, r)) {
              var i = void 0;
              try {
                i = a[r];
              } catch (e) {
                continue;
              }
              e.register(i, r, "/home/adele/workspace/react-paginate/react_components/PageView.js");
            }
          } else e.register(a, "module.exports", "/home/adele/workspace/react-paginate/react_components/PageView.js");
        }
      }();
      var m = function (e) {
        var t = e.breakLabel,
          n = e.breakClassName,
          a = e.breakLinkClassName,
          r = e.breakHandler,
          o = e.getEventListener,
          s = n || "break";
        return i.a.createElement("li", {
          className: s
        }, i.a.createElement("a", c({
          className: a,
          role: "button",
          tabIndex: "0",
          onKeyPress: r
        }, o(r)), t));
      };
      m.propTypes = {
        breakLabel: s.a.oneOfType([s.a.string, s.a.node]),
        breakClassName: s.a.string,
        breakLinkClassName: s.a.string,
        breakHandler: s.a.func.isRequired,
        getEventListener: s.a.func.isRequired
      };
      var f = m;
      function p(e) {
        return (p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
      }
      function _() {
        return (_ = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];
            for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
          }
          return e;
        }).apply(this, arguments);
      }
      function h(e, t) {
        for (var n = 0; n < t.length; n++) {
          var a = t[n];
          a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
        }
      }
      function y(e, t) {
        return (y = Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }
      function g(e, t) {
        return !t || "object" !== p(t) && "function" != typeof t ? v(e) : t;
      }
      function v(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }
      function M(e) {
        return (M = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
          return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
      }
      function L(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }
      !function () {
        var e = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.default : void 0;
        if (e) {
          var a = void 0 !== n ? n : t;
          if (a) if ("function" != typeof a) {
            for (var r in a) if (Object.prototype.hasOwnProperty.call(a, r)) {
              var i = void 0;
              try {
                i = a[r];
              } catch (e) {
                continue;
              }
              e.register(i, r, "/home/adele/workspace/react-paginate/react_components/BreakView.js");
            }
          } else e.register(a, "module.exports", "/home/adele/workspace/react-paginate/react_components/BreakView.js");
        }
      }();
      var b = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), t && y(e, t);
        }(r, e);
        var t,
          n,
          a = function (e) {
            var t = function () {
              if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
              if (Reflect.construct.sham) return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
              } catch (e) {
                return !1;
              }
            }();
            return function () {
              var n,
                a = M(e);
              if (t) {
                var r = M(this).constructor;
                n = Reflect.construct(a, arguments, r);
              } else n = a.apply(this, arguments);
              return g(this, n);
            };
          }(r);
        function r(e) {
          var t, n;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, r), L(v(t = a.call(this, e)), "handlePreviousPage", function (e) {
            var n = t.state.selected;
            e.preventDefault ? e.preventDefault() : e.returnValue = !1, n > 0 && t.handlePageSelected(n - 1, e);
          }), L(v(t), "handleNextPage", function (e) {
            var n = t.state.selected,
              a = t.props.pageCount;
            e.preventDefault ? e.preventDefault() : e.returnValue = !1, n < a - 1 && t.handlePageSelected(n + 1, e);
          }), L(v(t), "handlePageSelected", function (e, n) {
            n.preventDefault ? n.preventDefault() : n.returnValue = !1, t.state.selected !== e && (t.setState({
              selected: e
            }), t.callCallback(e));
          }), L(v(t), "getEventListener", function (e) {
            return L({}, t.props.eventListener, e);
          }), L(v(t), "handleBreakClick", function (e, n) {
            n.preventDefault ? n.preventDefault() : n.returnValue = !1;
            var a = t.state.selected;
            t.handlePageSelected(a < e ? t.getForwardJump() : t.getBackwardJump(), n);
          }), L(v(t), "callCallback", function (e) {
            void 0 !== t.props.onPageChange && "function" == typeof t.props.onPageChange && t.props.onPageChange({
              selected: e
            });
          }), L(v(t), "pagination", function () {
            var e = [],
              n = t.props,
              a = n.pageRangeDisplayed,
              r = n.pageCount,
              o = n.marginPagesDisplayed,
              s = n.breakLabel,
              l = n.breakClassName,
              d = n.breakLinkClassName,
              u = t.state.selected;
            if (r <= a) for (var c = 0; c < r; c++) e.push(t.getPageElement(c));else {
              var m,
                p,
                _,
                h = a / 2,
                y = a - h;
              u > r - a / 2 ? h = a - (y = r - u) : u < a / 2 && (y = a - (h = u));
              var g = function (e) {
                return t.getPageElement(e);
              };
              for (m = 0; m < r; m++) (p = m + 1) <= o || p > r - o || m >= u - h && m <= u + y ? e.push(g(m)) : s && e[e.length - 1] !== _ && (_ = i.a.createElement(f, {
                key: m,
                breakLabel: s,
                breakClassName: l,
                breakLinkClassName: d,
                breakHandler: t.handleBreakClick.bind(null, m),
                getEventListener: t.getEventListener
              }), e.push(_));
            }
            return e;
          }), n = e.initialPage ? e.initialPage : e.forcePage ? e.forcePage : 0, t.state = {
            selected: n
          }, t;
        }
        return t = r, (n = [{
          key: "componentDidMount",
          value: function () {
            var e = this.props,
              t = e.initialPage,
              n = e.disableInitialCallback,
              a = e.extraAriaContext;
            void 0 === t || n || this.callCallback(t), a && console.warn("DEPRECATED (react-paginate): The extraAriaContext prop is deprecated. You should now use the ariaLabelBuilder instead.");
          }
        }, {
          key: "componentDidUpdate",
          value: function (e) {
            void 0 !== this.props.forcePage && this.props.forcePage !== e.forcePage && this.setState({
              selected: this.props.forcePage
            });
          }
        }, {
          key: "getForwardJump",
          value: function () {
            var e = this.state.selected,
              t = this.props,
              n = t.pageCount,
              a = e + t.pageRangeDisplayed;
            return a >= n ? n - 1 : a;
          }
        }, {
          key: "getBackwardJump",
          value: function () {
            var e = this.state.selected - this.props.pageRangeDisplayed;
            return e < 0 ? 0 : e;
          }
        }, {
          key: "hrefBuilder",
          value: function (e) {
            var t = this.props,
              n = t.hrefBuilder,
              a = t.pageCount;
            if (n && e !== this.state.selected && e >= 0 && e < a) return n(e + 1);
          }
        }, {
          key: "ariaLabelBuilder",
          value: function (e) {
            var t = e === this.state.selected;
            if (this.props.ariaLabelBuilder && e >= 0 && e < this.props.pageCount) {
              var n = this.props.ariaLabelBuilder(e + 1, t);
              return this.props.extraAriaContext && !t && (n = n + " " + this.props.extraAriaContext), n;
            }
          }
        }, {
          key: "getPageElement",
          value: function (e) {
            var t = this.state.selected,
              n = this.props,
              a = n.pageClassName,
              r = n.pageLinkClassName,
              o = n.activeClassName,
              s = n.activeLinkClassName,
              l = n.extraAriaContext;
            return i.a.createElement(u, {
              key: e,
              pageSelectedHandler: this.handlePageSelected.bind(null, e),
              selected: t === e,
              pageClassName: a,
              pageLinkClassName: r,
              activeClassName: o,
              activeLinkClassName: s,
              extraAriaContext: l,
              href: this.hrefBuilder(e),
              ariaLabel: this.ariaLabelBuilder(e),
              page: e + 1,
              getEventListener: this.getEventListener
            });
          }
        }, {
          key: "render",
          value: function () {
            var e = this.props,
              t = e.disabledClassName,
              n = e.pageCount,
              a = e.containerClassName,
              r = e.previousLabel,
              o = e.previousClassName,
              s = e.previousLinkClassName,
              l = e.previousAriaLabel,
              d = e.prevRel,
              u = e.nextLabel,
              c = e.nextClassName,
              m = e.nextLinkClassName,
              f = e.nextAriaLabel,
              p = e.nextRel,
              h = this.state.selected,
              y = o + (0 === h ? " ".concat(t) : ""),
              g = c + (h === n - 1 ? " ".concat(t) : ""),
              v = 0 === h ? "true" : "false",
              M = h === n - 1 ? "true" : "false";
            return i.a.createElement("ul", {
              className: a
            }, i.a.createElement("li", {
              className: y
            }, i.a.createElement("a", _({
              className: s,
              href: this.hrefBuilder(h - 1),
              tabIndex: "0",
              role: "button",
              onKeyPress: this.handlePreviousPage,
              "aria-disabled": v,
              "aria-label": l,
              rel: d
            }, this.getEventListener(this.handlePreviousPage)), r)), this.pagination(), i.a.createElement("li", {
              className: g
            }, i.a.createElement("a", _({
              className: m,
              href: this.hrefBuilder(h + 1),
              tabIndex: "0",
              role: "button",
              onKeyPress: this.handleNextPage,
              "aria-disabled": M,
              "aria-label": f,
              rel: p
            }, this.getEventListener(this.handleNextPage)), u)));
          }
        }]) && h(t.prototype, n), r;
      }(r.Component);
      L(b, "propTypes", {
        pageCount: s.a.number.isRequired,
        pageRangeDisplayed: s.a.number.isRequired,
        marginPagesDisplayed: s.a.number.isRequired,
        previousLabel: s.a.node,
        previousAriaLabel: s.a.string,
        prevRel: s.a.string,
        nextLabel: s.a.node,
        nextAriaLabel: s.a.string,
        nextRel: s.a.string,
        breakLabel: s.a.oneOfType([s.a.string, s.a.node]),
        hrefBuilder: s.a.func,
        onPageChange: s.a.func,
        initialPage: s.a.number,
        forcePage: s.a.number,
        disableInitialCallback: s.a.bool,
        containerClassName: s.a.string,
        pageClassName: s.a.string,
        pageLinkClassName: s.a.string,
        activeClassName: s.a.string,
        activeLinkClassName: s.a.string,
        previousClassName: s.a.string,
        nextClassName: s.a.string,
        previousLinkClassName: s.a.string,
        nextLinkClassName: s.a.string,
        disabledClassName: s.a.string,
        breakClassName: s.a.string,
        breakLinkClassName: s.a.string,
        extraAriaContext: s.a.string,
        ariaLabelBuilder: s.a.func,
        eventListener: s.a.string
      }), L(b, "defaultProps", {
        pageCount: 10,
        pageRangeDisplayed: 2,
        marginPagesDisplayed: 3,
        activeClassName: "selected",
        previousLabel: "Previous",
        previousClassName: "previous",
        previousAriaLabel: "Previous page",
        prevRel: "prev",
        nextLabel: "Next",
        nextClassName: "next",
        nextAriaLabel: "Next page",
        nextRel: "next",
        breakLabel: "...",
        disabledClassName: "disabled",
        disableInitialCallback: !1,
        eventListener: "onClick"
      }), function () {
        var e = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.default : void 0;
        if (e) {
          var a = void 0 !== n ? n : t;
          if (a) if ("function" != typeof a) {
            for (var r in a) if (Object.prototype.hasOwnProperty.call(a, r)) {
              var i = void 0;
              try {
                i = a[r];
              } catch (e) {
                continue;
              }
              e.register(i, r, "/home/adele/workspace/react-paginate/react_components/PaginationBoxView.js");
            }
          } else e.register(a, "module.exports", "/home/adele/workspace/react-paginate/react_components/PaginationBoxView.js");
        }
      }(), n.default = b, function () {
        var e = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.default : void 0;
        if (e) {
          var a = void 0 !== n ? n : t;
          if (a) if ("function" != typeof a) {
            for (var r in a) if (Object.prototype.hasOwnProperty.call(a, r)) {
              var i = void 0;
              try {
                i = a[r];
              } catch (e) {
                continue;
              }
              e.register(i, r, "/home/adele/workspace/react-paginate/react_components/index.js");
            }
          } else e.register(a, "module.exports", "/home/adele/workspace/react-paginate/react_components/index.js");
        }
      }();
    }]));
  }).call(this, n(290));
}, function (e, t) {
  e.exports = require("react-player");
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "Carousel", {
    enumerable: !0,
    get: function () {
      return a.default;
    }
  }), Object.defineProperty(t, "CarouselProps", {
    enumerable: !0,
    get: function () {
      return r.CarouselProps;
    }
  }), Object.defineProperty(t, "Thumbs", {
    enumerable: !0,
    get: function () {
      return i.default;
    }
  });
  var a = o(n(313)),
    r = n(319),
    i = o(n(176));
  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
}, function (e, t, n) {
  var a, r, i;
  r = [t, n(314)], void 0 === (i = "function" == typeof (a = function (e, t) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var n,
      a = (n = t) && n.__esModule ? n : {
        default: n
      };
    e.default = a.default;
  }) ? a.apply(t, r) : a) || (e.exports = i);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var a,
    r = (a = n(315)) && a.__esModule ? a : {
      default: a
    };
  var i = {
    ROOT: function (e) {
      return (0, r.default)(function (e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }({
        "carousel-root": !0
      }, e || "", !!e));
    },
    CAROUSEL: function (e) {
      return (0, r.default)({
        carousel: !0,
        "carousel-slider": e
      });
    },
    WRAPPER: function (e, t) {
      return (0, r.default)({
        "thumbs-wrapper": !e,
        "slider-wrapper": e,
        "axis-horizontal": "horizontal" === t,
        "axis-vertical": "horizontal" !== t
      });
    },
    SLIDER: function (e, t) {
      return (0, r.default)({
        thumbs: !e,
        slider: e,
        animated: !t
      });
    },
    ITEM: function (e, t, n) {
      return (0, r.default)({
        thumb: !e,
        slide: e,
        selected: t,
        previous: n
      });
    },
    ARROW_PREV: function (e) {
      return (0, r.default)({
        "control-arrow control-prev": !0,
        "control-disabled": e
      });
    },
    ARROW_NEXT: function (e) {
      return (0, r.default)({
        "control-arrow control-next": !0,
        "control-disabled": e
      });
    },
    DOT: function (e) {
      return (0, r.default)({
        dot: !0,
        selected: e
      });
    }
  };
  t.default = i;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var a = function (e) {
      if (e && e.__esModule) return e;
      if (null === e || "object" !== c(e) && "function" != typeof e) return {
        default: e
      };
      var t = u();
      if (t && t.has(e)) return t.get(e);
      var n = {},
        a = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var r in e) if (Object.prototype.hasOwnProperty.call(e, r)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, r) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, r, i) : n[r] = e[r];
      }
      n.default = e, t && t.set(e, n);
      return n;
    }(n(0)),
    r = d(n(175)),
    i = n(316),
    o = d(n(15)),
    s = d(n(174)),
    l = d(n(177));
  function d(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  function u() {
    if ("function" != typeof WeakMap) return null;
    var e = new WeakMap();
    return u = function () {
      return e;
    }, e;
  }
  function c(e) {
    return (c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function m() {
    return (m = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      }
      return e;
    }).apply(this, arguments);
  }
  function f(e, t) {
    for (var n = 0; n < t.length; n++) {
      var a = t[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  function p(e, t) {
    return (p = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }
  function _(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();
    return function () {
      var n,
        a = g(e);
      if (t) {
        var r = g(this).constructor;
        n = Reflect.construct(a, arguments, r);
      } else n = a.apply(this, arguments);
      return h(this, n);
    };
  }
  function h(e, t) {
    return !t || "object" !== c(t) && "function" != typeof t ? y(e) : t;
  }
  function y(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function g(e) {
    return (g = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }
  function v(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  var M = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && p(e, t);
    }(c, e);
    var t,
      n,
      d,
      u = _(c);
    function c(e) {
      var t;
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, c), v(y(t = u.call(this, e)), "itemsWrapperRef", void 0), v(y(t), "itemsListRef", void 0), v(y(t), "thumbsRef", void 0), v(y(t), "setItemsWrapperRef", function (e) {
        t.itemsWrapperRef = e;
      }), v(y(t), "setItemsListRef", function (e) {
        t.itemsListRef = e;
      }), v(y(t), "setThumbsRef", function (e, n) {
        t.thumbsRef || (t.thumbsRef = []), t.thumbsRef[n] = e;
      }), v(y(t), "updateSizes", function () {
        if (t.props.children && t.itemsWrapperRef && t.thumbsRef) {
          var e = a.Children.count(t.props.children),
            n = t.itemsWrapperRef.clientWidth,
            r = t.props.thumbWidth ? t.props.thumbWidth : (0, i.outerWidth)(t.thumbsRef[0]),
            o = Math.floor(n / r),
            s = o < e,
            l = s ? e - o : 0;
          t.setState(function (e, n) {
            return {
              itemSize: r,
              visibleItems: o,
              firstItem: s ? t.getFirstItem(n.selectedItem) : 0,
              lastPosition: l,
              showArrows: s
            };
          });
        }
      }), v(y(t), "handleClickItem", function (e, n, a) {
        if (!function (e) {
          return e.hasOwnProperty("key");
        }(a) || "Enter" === a.key) {
          var r = t.props.onSelectItem;
          "function" == typeof r && r(e, n);
        }
      }), v(y(t), "onSwipeStart", function () {
        t.setState({
          swiping: !0
        });
      }), v(y(t), "onSwipeEnd", function () {
        t.setState({
          swiping: !1
        });
      }), v(y(t), "onSwipeMove", function (e) {
        var n = e.x;
        if (!t.state.itemSize || !t.itemsWrapperRef || !t.state.visibleItems) return !1;
        var r = a.Children.count(t.props.children),
          i = -100 * t.state.firstItem / t.state.visibleItems;
        0 === i && n > 0 && (n = 0), i === 100 * -Math.max(r - t.state.visibleItems, 0) / t.state.visibleItems && n < 0 && (n = 0);
        var s = i + 100 / (t.itemsWrapperRef.clientWidth / n);
        return t.itemsListRef && ["WebkitTransform", "MozTransform", "MsTransform", "OTransform", "transform", "msTransform"].forEach(function (e) {
          t.itemsListRef.style[e] = (0, o.default)(s, "%", t.props.axis);
        }), !0;
      }), v(y(t), "slideRight", function (e) {
        t.moveTo(t.state.firstItem - ("number" == typeof e ? e : 1));
      }), v(y(t), "slideLeft", function (e) {
        t.moveTo(t.state.firstItem + ("number" == typeof e ? e : 1));
      }), v(y(t), "moveTo", function (e) {
        e = (e = e < 0 ? 0 : e) >= t.state.lastPosition ? t.state.lastPosition : e, t.setState({
          firstItem: e
        });
      }), t.state = {
        selectedItem: e.selectedItem,
        swiping: !1,
        showArrows: !1,
        firstItem: 0,
        visibleItems: 0,
        lastPosition: 0
      }, t;
    }
    return t = c, (n = [{
      key: "componentDidMount",
      value: function () {
        this.setupThumbs();
      }
    }, {
      key: "componentDidUpdate",
      value: function (e) {
        this.props.selectedItem !== this.state.selectedItem && this.setState({
          selectedItem: this.props.selectedItem,
          firstItem: this.getFirstItem(this.props.selectedItem)
        }), this.props.children !== e.children && this.updateSizes();
      }
    }, {
      key: "componentWillUnmount",
      value: function () {
        this.destroyThumbs();
      }
    }, {
      key: "setupThumbs",
      value: function () {
        (0, l.default)().addEventListener("resize", this.updateSizes), (0, l.default)().addEventListener("DOMContentLoaded", this.updateSizes), this.updateSizes();
      }
    }, {
      key: "destroyThumbs",
      value: function () {
        (0, l.default)().removeEventListener("resize", this.updateSizes), (0, l.default)().removeEventListener("DOMContentLoaded", this.updateSizes);
      }
    }, {
      key: "getFirstItem",
      value: function (e) {
        var t = e;
        return e >= this.state.lastPosition && (t = this.state.lastPosition), e < this.state.firstItem + this.state.visibleItems && (t = this.state.firstItem), e < this.state.firstItem && (t = e), t;
      }
    }, {
      key: "renderItems",
      value: function () {
        var e = this;
        return this.props.children.map(function (t, n) {
          var i = r.default.ITEM(!1, n === e.state.selectedItem),
            o = {
              key: n,
              ref: function (t) {
                return e.setThumbsRef(t, n);
              },
              className: i,
              onClick: e.handleClickItem.bind(e, n, e.props.children[n]),
              onKeyDown: e.handleClickItem.bind(e, n, e.props.children[n]),
              "aria-label": "".concat(e.props.labels.item, " ").concat(n + 1),
              style: {
                width: e.props.thumbWidth
              }
            };
          return a.default.createElement("li", m({}, o, {
            role: "button",
            tabIndex: 0
          }), t);
        });
      }
    }, {
      key: "render",
      value: function () {
        var e = this;
        if (!this.props.children) return null;
        var t,
          n = a.Children.count(this.props.children) > 1,
          i = this.state.showArrows && this.state.firstItem > 0,
          l = this.state.showArrows && this.state.firstItem < this.state.lastPosition,
          d = -this.state.firstItem * (this.state.itemSize || 0),
          u = (0, o.default)(d, "px", this.props.axis),
          c = this.props.transitionTime + "ms";
        return t = {
          WebkitTransform: u,
          MozTransform: u,
          MsTransform: u,
          OTransform: u,
          transform: u,
          msTransform: u,
          WebkitTransitionDuration: c,
          MozTransitionDuration: c,
          MsTransitionDuration: c,
          OTransitionDuration: c,
          transitionDuration: c,
          msTransitionDuration: c
        }, a.default.createElement("div", {
          className: r.default.CAROUSEL(!1)
        }, a.default.createElement("div", {
          className: r.default.WRAPPER(!1),
          ref: this.setItemsWrapperRef
        }, a.default.createElement("button", {
          type: "button",
          className: r.default.ARROW_PREV(!i),
          onClick: function () {
            return e.slideRight();
          },
          "aria-label": this.props.labels.leftArrow
        }), n ? a.default.createElement(s.default, {
          tagName: "ul",
          className: r.default.SLIDER(!1, this.state.swiping),
          onSwipeLeft: this.slideLeft,
          onSwipeRight: this.slideRight,
          onSwipeMove: this.onSwipeMove,
          onSwipeStart: this.onSwipeStart,
          onSwipeEnd: this.onSwipeEnd,
          style: t,
          innerRef: this.setItemsListRef,
          allowMouseEvents: this.props.emulateTouch
        }, this.renderItems()) : a.default.createElement("ul", {
          className: r.default.SLIDER(!1, this.state.swiping),
          ref: function (t) {
            return e.setItemsListRef(t);
          },
          style: t
        }, this.renderItems()), a.default.createElement("button", {
          type: "button",
          className: r.default.ARROW_NEXT(!l),
          onClick: function () {
            return e.slideLeft();
          },
          "aria-label": this.props.labels.rightArrow
        })));
      }
    }]) && f(t.prototype, n), d && f(t, d), c;
  }(a.Component);
  t.default = M, v(M, "displayName", "Thumbs"), v(M, "defaultProps", {
    axis: "horizontal",
    labels: {
      leftArrow: "previous slide / item",
      rightArrow: "next slide / item",
      item: "slide item"
    },
    selectedItem: 0,
    thumbWidth: 80,
    transitionTime: 350
  });
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  t.default = function () {
    return window;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.setPosition = t.getPosition = t.isKeyboardEvent = t.defaultStatusFormatter = t.noop = void 0;
  var a,
    r = n(0),
    i = (a = n(15)) && a.__esModule ? a : {
      default: a
    };
  t.noop = function () {};
  t.defaultStatusFormatter = function (e, t) {
    return "".concat(e, " of ").concat(t);
  };
  t.isKeyboardEvent = function (e) {
    return !!e && e.hasOwnProperty("key");
  };
  t.getPosition = function (e, t) {
    if (t.infiniteLoop && ++e, 0 === e) return 0;
    var n = r.Children.count(t.children);
    if (t.centerMode && "horizontal" === t.axis) {
      var a = -e * t.centerSlidePercentage,
        i = n - 1;
      return e && (e !== i || t.infiniteLoop) ? a += (100 - t.centerSlidePercentage) / 2 : e === i && (a += 100 - t.centerSlidePercentage), a;
    }
    return 100 * -e;
  };
  t.setPosition = function (e, t) {
    var n = {};
    return ["WebkitTransform", "MozTransform", "MsTransform", "OTransform", "transform", "msTransform"].forEach(function (a) {
      n[a] = (0, i.default)(e, "%", t);
    }), n;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.NewsItemComponent = void 0;
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
  t.NewsItemComponent = function (e) {
    console.log("props", e);
    return i.default.createElement("div", null, i.default.createElement("a", {
      className: "card align-items-stretch",
      style: {
        margin: "10px 0px",
        padding: "0px 0px",
        border: "1px solid #ddd"
      },
      href: "detailed-news#" + e.news.entry_name,
      onClick: function () {
        localStorage.setItem("entry_name", JSON.stringify(e.news));
      }
    }, i.default.createElement("img", {
      src: e.img,
      className: "card-img-top",
      alt: "imag1",
      style: {
        height: "224px",
        objectFit: "cover"
      }
    }), i.default.createElement("div", {
      className: "card-body"
    }, i.default.createElement("div", {
      className: "card-title",
      dangerouslySetInnerHTML: {
        __html: e.title
      }
    }), i.default.createElement("div", {
      className: "card-text",
      dangerouslySetInnerHTML: {
        __html: e.description
      }
    }))));
  };
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "PreviewPageComponent", function () {
    return tt;
  });
  var a,
    r = n(0),
    i = n.n(r),
    o = n(6),
    s = n(17),
    l = n(16),
    d = n(20),
    u = n(18),
    c = n(19),
    m = n(11),
    f = n(24),
    p = n(25),
    _ = n(237),
    h = n(238),
    y = n.n(h),
    g = n(27),
    v = n.n(g),
    M = n(28),
    L = n(239),
    b = n(240),
    w = n.n(b),
    k = n(241),
    Y = n.n(k),
    D = n(242),
    S = n.n(D),
    T = n(243),
    E = n(244),
    x = function () {
      var e = Object(r.useState)(""),
        t = e[0],
        n = e[1];
      return Object(r.useEffect)(function () {
        console.log("share on -sm");
        var e = !0;
        return e && n(window.location.href), function () {
          e = !1;
        };
      }, []), i.a.createElement("div", {
        className: "sm-share-toolbar"
      }, i.a.createElement("span", {
        className: "share-title en"
      }, "Share on:"), i.a.createElement("span", {
        className: "share-title ar"
      }, "مشاركه فى"), i.a.createElement("a", {
        className: "share-button facebook",
        href: "https://www.facebook.com/sharer/sharer.php?u=".concat(t),
        rel: "nofollow",
        target: "_blank"
      }, " "), i.a.createElement("a", {
        className: "share-button linkedin",
        href: "https://www.linkedin.com/sharing/share-offsite/?url=".concat(t),
        rel: "nofollow",
        target: "_blank"
      }, " "), i.a.createElement("a", {
        className: "share-button twitter",
        href: "https://twitter.com/intent/tweet?url=".concat(t),
        rel: "nofollow",
        target: "_blank"
      }, " "));
    },
    C = n(245),
    j = n.n(C),
    P = n(246),
    N = n.n(P),
    H = n(247),
    O = n.n(H),
    I = n(248),
    z = n.n(I),
    A = n(249),
    F = n.n(A),
    R = n(2),
    W = n.n(R),
    V = n(5),
    K = function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    B = function () {
      return (B = Object.assign || function (e) {
        for (var t, n = 1, a = arguments.length; n < a; n++) for (var r in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        return e;
      }).apply(this, arguments);
    },
    U = W.a.div(a || (a = K(["\n    > img {\n        ", "\n    }\n"], ["\n    > img {\n        ", "\n    }\n"])), function (e) {
      if (e.customCSS) return e.customCSS;
    });
  var q = n(29),
    J = n(251),
    Z = n(252),
    G = n(253),
    $ = n(7);
  var X = function (e) {
      var t = e.commonConfigs,
        n = "";
      "undefined" != typeof window && (n = window.location.href);
      var a = void 0,
        o = [{
          caption: "",
          link: ""
        }],
        s = e.data,
        l = s.data,
        d = (s.styles, s.settings),
        u = e.lang,
        c = (t.isEditMode, t.isPreview),
        m = c || !1;
      l.basicMenu && (o = l.basicMenu), d && (a = d);
      var f = Object(r.useState)("#"),
        p = (f[0], f[1]);
      Object(r.useEffect)(function () {
        for (var e = window.location.pathname, t = new RegExp(e.replace(/\/$/, "") + "$"), n = document.getElementById("basicNavBarComponent").getElementsByClassName("nav-item"), a = 0; a < n.length; a++) {
          var r = n[a];
          if (r) {
            var i = r.getElementsByClassName("nav-link");
            i && i[0] && t.test(i[0].href.replace(/\/$/, "")) && i[0].classList.add("nav-link-active");
          }
        }
        return function () {
          for (var e = 0; e < n.length; e++) {
            var a = n[e];
            if (a) {
              var r = a.getElementsByClassName("nav-link");
              r && r[0] && t.test(r[0].href.replace(/\/$/, "")) && r[0].classList.remove("nav-link-active");
            }
          }
        };
      }, []), Object(r.useEffect)(function () {
        var e = !0;
        return e && u && ("en" === u.langKey.toLowerCase() ? p(_("ar")) : "ar" === u.langKey.toLowerCase() && p(_("en"))), function () {
          e = !1;
        };
      }, [u]);
      var _ = function (e) {
        var t = "#";
        if ("undefined" != typeof window) {
          var n = window.location.href,
            a = (window.location.hostname, window.location.pathname);
          window.location.protocol;
          if (t = n, a.length > 0) {
            var r = a.split("/")[1];
            if (["en", "ar"].includes(r)) {
              var i = a.replace(r, e);
              t = n.replace(a, i);
            }
          }
        }
        return t;
      };
      return i.a.createElement(i.a.Fragment, null, i.a.createElement("nav", {
        className: "navbar navbar-expand-lg",
        id: "basicNavBarComponent"
      }, i.a.createElement("a", {
        className: "navbar-brand pt-md-0 pt-3 ",
        href: "/en"
      }, m ? i.a.createElement("img", {
        height: "32",
        src: a && a.logo && a.logo.value && a.logo.value.filePath || "/logo/logo.png",
        alt: "LOGO"
      }) : i.a.createElement("img", {
        height: "32",
        src: a && a.logo && a.logo.value && a.logo.value.fileName && "/images/".concat(a.logo.value.fileName) || "/logo/logo.png",
        alt: "LOGO"
      })), i.a.createElement("button", {
        className: "navbar-toggler",
        type: "button",
        "data-toggle": "collapse",
        "data-target": "#basicNavbarToggler",
        "aria-controls": "basicNavbarToggler",
        "aria-expanded": "false",
        "aria-label": "Toggle navigation"
      }, i.a.createElement("span", {
        className: "navbar-toggler-icon"
      })), i.a.createElement("div", {
        className: "collapse navbar-collapse",
        id: "basicNavbarToggler"
      }, i.a.createElement("ul", {
        className: "navbar-nav mr-auto mt-2 mt-lg-0"
      }, o.map(function (e, t) {
        var a = null == n ? void 0 : n.split("/"),
          r = a[a.length - 1],
          o = null == r ? void 0 : r.split("#"),
          s = o[1] ? e.link + "#" + o[1] : e.link,
          l = s && s.indexOf(r) > 0 ? " nav-item-active" : "";
        return i.a.createElement("li", {
          className: "nav-item",
          role: "presentation",
          key: "basic-menu-".concat(t)
        }, i.a.createElement("a", {
          className: "nav-link " + l,
          id: e.link + "-pill",
          href: s
        }, e.caption));
      })))));
    },
    Q = function (e) {
      var t = e.data.data,
        n = {};
      return void 0 !== t && (n = {
        __html: t.title
      }), i.a.createElement("div", null, i.a.createElement("div", {
        dangerouslySetInnerHTML: n
      }));
    },
    ee = n(254),
    te = n.n(ee),
    ne = n(30),
    ae = n.n(ne),
    re = n(255),
    ie = n(31),
    oe = n.n(ie),
    se = function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    le = W.a.div(de || (de = se(["\n    @media (max-width: 900px) {\n        .desktoplinks{\n            display : none !important;\n        }\n        .mobilelinks{\n            display : flex !important;\n        }\n\n        .show-arrow{\n            margin-left : auto ;\n            margin-right : 8px ;\n        }\n    }\n\n    @media (min-width: 901px) {\n        .desktoplinks{\n            display : block !important ;\n        }\n        .mobilelinks{\n            display : none !important;\n        }\n    }\n"], ["\n    @media (max-width: 900px) {\n        .desktoplinks{\n            display : none !important;\n        }\n        .mobilelinks{\n            display : flex !important;\n        }\n\n        .show-arrow{\n            margin-left : auto ;\n            margin-right : 8px ;\n        }\n    }\n\n    @media (min-width: 901px) {\n        .desktoplinks{\n            display : block !important ;\n        }\n        .mobilelinks{\n            display : none !important;\n        }\n    }\n"])));
  var de,
    ue,
    ce = function (e) {
      var t = e.commonConfigs,
        n = "";
      "undefined" != typeof window && (n = window.location.href);
      var a = void 0,
        o = [{
          caption: "",
          link: ""
        }],
        s = e.data,
        l = s.data,
        d = (s.styles, s.settings),
        u = e.lang,
        c = (t.isEditMode, t.isPreview),
        m = c || !1;
      l.advanceMenu && (o = l.advanceMenu), d && (a = d);
      var f = Object(r.useState)("#"),
        p = (f[0], f[1]);
      Object(r.useEffect)(function () {
        for (var e = window.location.pathname, t = new RegExp(e.replace(/\/$/, "") + "$"), n = document.getElementById("basicNavBarComponent").getElementsByClassName("nav-item"), a = 0; a < n.length; a++) {
          var r = n[a];
          if (r) {
            var i = r.getElementsByClassName("nav-link");
            i && i[0] && t.test(i[0].href.replace(/\/$/, "")) && i[0].classList.add("nav-link-active");
          }
        }
        return function () {
          for (var e = 0; e < n.length; e++) {
            var a = n[e];
            if (a) {
              var r = a.getElementsByClassName("nav-link");
              r && r[0] && t.test(r[0].href.replace(/\/$/, "")) && r[0].classList.remove("nav-link-active");
            }
          }
        };
      }, []), Object(r.useEffect)(function () {
        var e = !0;
        return e && u && ("en" === u.langKey.toLowerCase() ? p(_("ar")) : "ar" === u.langKey.toLowerCase() && p(_("en"))), function () {
          e = !1;
        };
      }, [u]);
      var _ = function (e) {
          var t = "#";
          if ("undefined" != typeof window) {
            var n = window.location.href,
              a = (window.location.hostname, window.location.pathname);
            window.location.protocol;
            if (t = n, a.length > 0) {
              var r = a.split("/")[1];
              if (["en", "ar"].includes(r)) {
                var i = a.replace(r, e);
                t = n.replace(a, i);
              }
            }
          }
          return t;
        },
        h = Object(r.useState)({
          display: "none",
          zIndex: 20
        }),
        y = h[0],
        g = h[1],
        v = Object(r.useState)(),
        M = v[0],
        L = v[1],
        b = Object(r.useState)(!1),
        w = b[0],
        k = b[1],
        Y = Object(r.useState)(!1),
        D = Y[0],
        S = Y[1],
        T = function (e, t) {
          g({
            display: e,
            zIndex: 20
          }), L(t);
        },
        E = "/" + e.lang.langKey.toString();
      return i.a.createElement(le, null, i.a.createElement("nav", {
        className: "navbar navbar-expand-lg p-0",
        id: "basicNavBarComponent"
      }, i.a.createElement("a", {
        className: "navbar-brand pt-md-0",
        href: E
      }, m ? i.a.createElement("img", {
        height: "32",
        src: a && a.logo && a.logo.value && a.logo.value.filePath || "/logo/logo.png",
        alt: "LOGO"
      }) : i.a.createElement("img", {
        height: "32",
        src: a && a.logo && a.logo.value && a.logo.value.fileName && "/images/".concat(a.logo.value.fileName) || "/logo/logo.png",
        alt: "LOGO"
      })), i.a.createElement("button", {
        className: "navbar-toggler",
        type: "button",
        "data-toggle": "collapse",
        "data-target": "#advanceMenuNavbarToggler",
        "aria-controls": "advanceMenuNavbarToggler",
        "aria-expanded": "false",
        "aria-label": "Toggle navigation"
      }, i.a.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        className: "feather feather-menu"
      }, i.a.createElement("line", {
        x1: "3",
        y1: "12",
        x2: "21",
        y2: "12"
      }), i.a.createElement("line", {
        x1: "3",
        y1: "6",
        x2: "21",
        y2: "6"
      }), i.a.createElement("line", {
        x1: "3",
        y1: "18",
        x2: "21",
        y2: "18"
      }))), i.a.createElement("div", {
        className: "collapse navbar-collapse",
        id: "advanceMenuNavbarToggler"
      }, i.a.createElement("ul", {
        className: "navbar-nav mr-auto mt-2 mt-lg-0"
      }, o.map(function (e, t) {
        var a = null == n ? void 0 : n.split("/"),
          r = a[a.length - 1],
          o = null == r ? void 0 : r.split("#"),
          s = o[1] ? e.link + "#" + o[1] : e.link,
          l = s && s.indexOf(r) > 0 ? " nav-item-active" : "";
        return i.a.createElement(i.a.Fragment, null, !e.isChildren && i.a.createElement("li", {
          className: "nav-item py-4",
          role: "presentation",
          key: "basic-menu-".concat(t)
        }, i.a.createElement("a", {
          className: "nav-link " + l,
          id: e.link + "-pill",
          href: s
        }, e.caption)), e.isChildren && i.a.createElement(i.a.Fragment, null, i.a.createElement("li", {
          className: "nav-item btn-group show py-3 desktoplinks",
          role: "presentation",
          key: "basic-menu-".concat(t),
          onMouseOver: function (t) {
            return T("block", e);
          },
          onMouseLeave: function (e) {
            return T("none", null);
          },
          style: {
            paddingBottom: "0 !important"
          }
        }, i.a.createElement("a", {
          className: "nav-link d-flex" + l,
          id: e.link + "-pill",
          href: s,
          style: {
            color: "black"
          }
        }, e.caption, "  ", " ", i.a.createElement(oe.a, {
          width: "24px",
          height: "24px"
        })), e === M && i.a.createElement("div", {
          className: "dropdown-menu d-flex",
          style: y
        }, e.children.map(function (e, t) {
          return i.a.createElement("button", {
            key: "child-" + t,
            className: "dropdown-item",
            type: "button",
            onClick: function () {}
          }, i.a.createElement("a", {
            href: e.link
          }, " ", e.caption));
        }))), i.a.createElement("li", {
          className: " ".concat(D ? "active" : "", " nav-item btn-group show py-4 mobilelinks"),
          role: "presentation",
          key: "basic-menu-".concat(t)
        }, i.a.createElement("div", {
          className: "w-100 d-flex justify-content-between",
          style: {
            cursor: "pointer"
          }
        }, i.a.createElement("a", {
          className: "nav-link d-flex" + l,
          id: e.link + "-pill",
          href: s
        }, e.caption, "  ", " "), i.a.createElement("div", {
          className: "px-2",
          onClick: function () {
            return function (e) {
              S(!D), 0 == w ? (k(!0), T("block", e)) : e === M ? (k(!1), T("block", null)) : T("block", e);
            }(e);
          }
        }, i.a.createElement(oe.a, {
          className: "show-arrow",
          width: "32px",
          height: "32px"
        }))), e === M && i.a.createElement("div", {
          className: "dropdown-menu d-flex",
          style: y
        }, e.children.map(function (e, t) {
          return i.a.createElement("button", {
            key: "child-" + t,
            className: "dropdown-item",
            type: "button",
            onClick: function () {}
          }, i.a.createElement("a", {
            href: e.link
          }, " ", e.caption));
        })))));
      })))));
    },
    me = n(256),
    fe = n.n(me),
    pe = n(257),
    _e = n.n(pe),
    he = n(258),
    ye = n.n(he),
    ge = n(259),
    ve = n(260),
    Me = n(261),
    Le = n(262),
    be = n(263),
    we = n.n(be),
    ke = n(264),
    Ye = n(265),
    De = n(266),
    Se = n.n(De),
    Te = function () {
      return (Te = Object.assign || function (e) {
        for (var t, n = 1, a = arguments.length; n < a; n++) for (var r in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        return e;
      }).apply(this, arguments);
    },
    Ee = Te(Te({}, z.a), {
      titleParagraph: d.TitleParagraphComponent,
      paragraph: o.ParagraphComponent,
      title: s.TitleComponent,
      image: l.ImageComponent,
      mainMenu: u.MainMenuComponent,
      footerMenu: c.FooterMenuComponent,
      banner: m.BannerComponent,
      tab: f.TabUiComponent,
      table: p.CMSTableComponent,
      popupBanner: _.PopupBannerComponent,
      cardList: y.a,
      card: v.a,
      linkList: M.LinkListUiComponent,
      button: Se.a,
      socialMedia: function (e) {
        var t = e.data;
        t.data, t.styles;
        return i.a.createElement(i.a.Fragment, null, i.a.createElement("span", null, i.a.createElement("span", null, i.a.createElement("a", {
          href: "https://www.instagram.com/boursakw",
          rel: "noreferrer",
          target: "_blank"
        }, i.a.createElement("img", {
          src: "/bk-icons/social-instagram.svg",
          height: "12",
          className: "mr-2",
          alt: "Instagram"
        }))), i.a.createElement("span", null, i.a.createElement("a", {
          href: "https://twitter.com/BoursaKW",
          rel: "noreferrer",
          target: "_blank"
        }, i.a.createElement("img", {
          src: "/bk-icons/social-twitter.svg",
          height: "12",
          className: "mr-2",
          alt: "Twitter"
        }))), i.a.createElement("span", null, i.a.createElement("a", {
          href: "https://www.linkedin.com/company/10108082/",
          rel: "noreferrer",
          target: "_blank"
        }, i.a.createElement("img", {
          src: "/bk-icons/social-linkedin.svg",
          height: "12",
          className: "mr-2",
          alt: "Linkedin"
        })))));
      },
      list: L.ListComponent,
      treeView: w.a,
      accordionView: Y.a,
      dateVersion: S.a,
      siteSearch: T.SiteSearchComponent,
      siteSearchResults: E.SiteSearchResultsComponent,
      socialMediaShare: x,
      treeSearch: j.a,
      productSubscription: N.a,
      subscriptionConfirmation: O.a,
      video: F.a,
      icon: function (e) {
        var t = {},
          n = e.commonConfigs.isPreview,
          a = e.data,
          r = a.data,
          o = a.styles,
          s = a.settings;
        o && (t = Object(V.genarateComponentLevelStyleConfigurations)(o));
        var l = "",
          d = "";
        if (r) {
          var u = r.icon;
          u && (l = n ? u.filePath : "/icons/" + u.fileName, d = u.boundUrl ? u.boundUrl : "");
        }
        return 0 !== l.length ? i.a.createElement(U, B({}, t), "" != d && s && s.seprateLink && s.seprateLink.value && i.a.createElement("a", {
          href: d,
          target: "_blank"
        }, i.a.createElement("object", {
          type: "image/svg+xml",
          data: l,
          width: s.iconSize ? s.iconSize.value : "24",
          height: s.iconSize ? s.iconSize.value : "24",
          style: {
            pointerEvents: "none",
            color: s.iconColor ? s.iconColor.value : ""
          }
        })), "" != d && s && (void 0 === s.seprateLink || s.seprateLink && !s.seprateLink.value) && i.a.createElement("a", {
          href: d
        }, i.a.createElement("object", {
          type: "image/svg+xml",
          data: l,
          width: s.iconSize ? s.iconSize.value : "24",
          height: s.iconSize ? s.iconSize.value : "24",
          style: {
            pointerEvents: "none",
            color: s.iconColor ? s.iconColor.value : ""
          }
        })), "" === d && i.a.createElement("object", {
          type: "image/svg+xml",
          data: l,
          width: s.iconSize ? s.iconSize.value : "24",
          height: s.iconSize ? s.iconSize.value : "24",
          style: {
            pointerEvents: "none",
            color: s.iconColor ? s.iconColor.value : ""
          }
        })) : i.a.createElement(i.a.Fragment, null);
      },
      form: q.FormComponent,
      tutorialTreeView: J.TutorialTreeViewComponent,
      tutorialView: Z.TutorialViewComponent,
      linkDropdown: G.LinkDropdownComponent,
      imageLinkList: function (e) {
        e.commonConfigs;
        var t = Object(r.useState)(""),
          n = t[0],
          a = t[1],
          o = "";
        "undefined" != typeof window && (o = window.location.href), Object(r.useEffect)(function () {
          a(Object($.v1)());
        }, []);
        var s = [{
            caption: "",
            link: "",
            imageDetails: {}
          }],
          l = e.data,
          d = l.data,
          u = (l.styles, l.settings);
        d.linkList && (s = d.linkList);
        var c = function (e) {
          return !!(e && e.imageDetails && e.imageDetails.thumbnailUri);
        };
        return i.a.createElement(i.a.Fragment, null, u && u.linkList && "horizontal" === u.linkList.value && i.a.createElement("ul", {
          className: "nav nav-tabs",
          id: "myTab",
          role: "tablist"
        }, s.map(function (e, t) {
          var a = null == o ? void 0 : o.split("/"),
            r = a[a.length - 1],
            s = null == r ? void 0 : r.split("#"),
            l = s[1] ? e.link + "#" + s[1] : e.link,
            d = l && l.indexOf(r) > 0 ? " active" : "";
          return i.a.createElement("li", {
            className: "nav-item",
            role: "presentation",
            key: n + "-" + t
          }, i.a.createElement("a", {
            className: "nav-link " + d,
            id: e.link + "-pill",
            href: l
          }, null == e ? void 0 : e.caption, "  ", c(e) && i.a.createElement("img", {
            src: e.imageDetails.thumbnailUri,
            alt: "Image",
            className: "img-fluid",
            style: {
              marginLeft: "2px",
              borderRadius: "100%",
              width: "50px",
              height: "50px"
            }
          })));
        })), !(u && u.linkList && "horizontal" === u.linkList.value) && i.a.createElement("ul", {
          className: "nav flex-column nav-pills",
          id: "v-pills-tab",
          role: "tablist",
          "aria-orientation": "vertical"
        }, s.map(function (e, t) {
          var a = null == o ? void 0 : o.split("/"),
            r = a[a.length - 1],
            s = null == r ? void 0 : r.split("#"),
            l = s[1] ? e.link + "#" + s[1] : e.link,
            d = l && l.indexOf(r) > 0 ? " active" : "";
          return i.a.createElement("li", {
            className: "nav-item",
            role: "presentation",
            key: n + "-" + t
          }, i.a.createElement("a", {
            className: "nav-link " + d,
            id: e.link + "-pill",
            href: l
          }, null == e ? void 0 : e.caption, "  ", c(e) && i.a.createElement("img", {
            src: e.imageDetails.thumbnailUri,
            alt: "Image",
            className: "img-fluid",
            style: {
              marginLeft: "2px",
              borderRadius: "100%",
              width: "50px",
              height: "50px"
            }
          })));
        })));
      },
      basicMenu: X,
      htmlCodeBlock: Q,
      newsList: te.a,
      news: ae.a,
      subscribe: re.SubscribeComponent,
      advanceMenu: ce,
      newsFeed: fe.a,
      topNews: _e.a,
      testimonial: ge.TestimonialComponent,
      transitioncard: ye.a,
      newsAndEvents: ve.NewsAndEventsComponent,
      cardWithImage: Me.CardWithImageComponent,
      careers: Le.CareersComponent,
      cardlistSlider: we.a,
      homeVideoBanner: ke.HomeVideoBannerComponent,
      langSelect: Ye.LanguageSelector
    }),
    xe = function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    Ce = Object(R.createGlobalStyle)(ue || (ue = xe(["\n\n\n    #___gatsby {\n    width: 100%;\n    overflow-x: hidden;\n    }\n\n\n    h1 {\n        color: ", ";\n        font-size: ", ";\n    }\n\n    h2 {\n        color: ", ";\n        font-size: ", ";\n    }\n\n    h3 {\n        color: ", ";\n        font-size: ", ";\n    }\n\n    h4 {\n        color: ", ";\n        font-size: ", ";\n    }\n\n    p {\n        color: ", ";\n        font-size:", "px ;\n    }\n\n    a {\n        color: ", ";\n    }\n\n\n"], ["\n\n\n    #___gatsby {\n    width: 100%;\n    overflow-x: hidden;\n    }\n\n\n    h1 {\n        color: ", ";\n        font-size: ", ";\n    }\n\n    h2 {\n        color: ", ";\n        font-size: ", ";\n    }\n\n    h3 {\n        color: ", ";\n        font-size: ", ";\n    }\n\n    h4 {\n        color: ", ";\n        font-size: ", ";\n    }\n\n    p {\n        color: ", ";\n        font-size:", "px ;\n    }\n\n    a {\n        color: ", ";\n    }\n\n\n"])), function (e) {
      return e.theme.properties.h1[0].value;
    }, function (e) {
      return e.theme.properties.h1[1].value;
    }, function (e) {
      return e.theme.properties.h2[0].value;
    }, function (e) {
      return e.theme.properties.h2[1].value;
    }, function (e) {
      return e.theme.properties.h3[0].value;
    }, function (e) {
      return e.theme.properties.h3[1].value;
    }, function (e) {
      return e.theme.properties.h4[0].value;
    }, function (e) {
      return e.theme.properties.h4[1].value;
    }, function (e) {
      return e.theme.properties.paragraph[0].value;
    }, function (e) {
      return e.theme.properties.paragraph[1].value;
    }, function (e) {
      return e.theme.properties.link[0].value;
    });
  var je = function (e) {
    return i.a.createElement(i.a.Fragment, null, i.a.createElement("div", {
      className: e.colClass
    }, i.a.createElement("div", {
      style: {
        border: "2px dashed #d5dadf",
        backgroundColor: "hsla(0,0%,100%,.5)",
        textAlign: "center",
        margin: "10px 0",
        padding: "10px 0",
        flexGrow: 1,
        boxSizing: "border-box",
        position: "relative"
      }
    }, i.a.createElement("div", {
      className: "btn-group-vertical btn-group-sm",
      role: "group",
      "aria-label": "Basic example"
    }, i.a.createElement("button", {
      type: "button",
      className: "btn btn-outline-primary btn-sm",
      onClick: function () {
        e.onComponentClick(e.activeColumn, {});
      }
    }, "Add New Component"), i.a.createElement("button", {
      type: "button",
      className: "btn btn-outline-success btn-sm",
      onClick: function () {
        var t = e.activeColumn.section.length;
        e.openInnerSectionsList(e.activeColumn, t);
      }
    }, "Add New Section")))));
  };
  var Pe,
    Ne = function (e) {
      return i.a.createElement(i.a.Fragment, null, i.a.createElement("div", {
        className: e.colClass
      }, i.a.createElement("div", {
        style: {
          border: "2px dashed #d5dadf",
          backgroundColor: "hsla(0,0%,100%,.5)",
          textAlign: "center",
          margin: "10px 0",
          padding: "10px 0",
          flexGrow: 1,
          boxSizing: "border-box",
          position: "relative"
        }
      }, i.a.createElement("button", {
        type: "button",
        className: "btn btn-outline-primary btn-sm",
        onClick: function () {
          e.onComponentClick(e.activeColumn, e.activeInnerColumn);
        }
      }, "Add New Component"))));
    },
    He = function (e, t) {
      return Object.defineProperty ? Object.defineProperty(e, "raw", {
        value: t
      }) : e.raw = t, e;
    },
    Oe = function (e, t) {
      return W.a[e](Pe || (Pe = He(["\n        ", "\n\n        ", "\n\n        background-position: center;\n        background-repeat: no-repeat;\n        background-size: cover;\n\n        ", "\n\n        ", "\n\n        ", "\n\n        ", "\n\n        ", "\n\n        ", "\n\n        ", "\n\n        ", "\n\n        ", "\n    "], ["\n        ", "\n\n        ", "\n\n        background-position: center;\n        background-repeat: no-repeat;\n        background-size: cover;\n\n        ", "\n\n        ", "\n\n        ", "\n\n        ", "\n\n        ", "\n\n        ", "\n\n        ", "\n\n        ", "\n\n        ", "\n    "])), function (e) {
        var t, n, a, r;
        if (null === (r = null === (a = null === (n = null === (t = null == e ? void 0 : e.styleProps) || void 0 === t ? void 0 : t.background) || void 0 === n ? void 0 : n.normal) || void 0 === a ? void 0 : a.classic) || void 0 === r ? void 0 : r.color) return "background-color: ".concat(e.styleProps.background.normal.classic.color, ";");
      }, function (e) {
        var n, a, r, i, o;
        if (null === (o = null === (i = null === (r = null === (a = null === (n = null == e ? void 0 : e.styleProps) || void 0 === n ? void 0 : n.background) || void 0 === a ? void 0 : a.normal) || void 0 === r ? void 0 : r.classic) || void 0 === i ? void 0 : i.image) || void 0 === o ? void 0 : o.filePath) {
          var s = e.styleProps.background.normal.classic.image.filePath.split("/"),
            l = s[s.length - 1],
            d = t ? e.styleProps.background.normal.classic.image.filePath : "/images/" + l;
          return "background-image: url(".concat(d, ");");
        }
      }, function (e) {
        var t, n;
        if (null === (n = null === (t = null == e ? void 0 : e.styleProps) || void 0 === t ? void 0 : t.margin) || void 0 === n ? void 0 : n.left) return "margin-left: ".concat(e.styleProps.margin.left, "px;");
      }, function (e) {
        var t, n;
        if (null === (n = null === (t = null == e ? void 0 : e.styleProps) || void 0 === t ? void 0 : t.margin) || void 0 === n ? void 0 : n.right) return "margin-right: ".concat(e.styleProps.margin.right, "px;");
      }, function (e) {
        var t, n;
        if (null === (n = null === (t = null == e ? void 0 : e.styleProps) || void 0 === t ? void 0 : t.margin) || void 0 === n ? void 0 : n.top) return "margin-top: ".concat(e.styleProps.margin.top, "px;");
      }, function (e) {
        var t, n;
        if (null === (n = null === (t = null == e ? void 0 : e.styleProps) || void 0 === t ? void 0 : t.margin) || void 0 === n ? void 0 : n.bottom) return "margin-bottom: ".concat(e.styleProps.margin.bottom, "px;");
      }, function (e) {
        var t, n;
        if (null === (n = null === (t = null == e ? void 0 : e.styleProps) || void 0 === t ? void 0 : t.padding) || void 0 === n ? void 0 : n.left) return "padding-left: ".concat(e.styleProps.padding.left, "px;");
      }, function (e) {
        var t, n;
        if (null === (n = null === (t = null == e ? void 0 : e.styleProps) || void 0 === t ? void 0 : t.padding) || void 0 === n ? void 0 : n.right) return "padding-right: ".concat(e.styleProps.padding.right, "px;");
      }, function (e) {
        var t, n;
        if (null === (n = null === (t = null == e ? void 0 : e.styleProps) || void 0 === t ? void 0 : t.padding) || void 0 === n ? void 0 : n.top) return "padding-top: ".concat(e.styleProps.padding.top, "px;");
      }, function (e) {
        var t, n;
        if (null === (n = null === (t = null == e ? void 0 : e.styleProps) || void 0 === t ? void 0 : t.padding) || void 0 === n ? void 0 : n.bottom) return "padding-bottom: ".concat(e.styleProps.padding.bottom, "px;");
      }, function (e) {
        var t;
        if (null === (t = null == e ? void 0 : e.styleProps) || void 0 === t ? void 0 : t.customCSS) return e.styleProps.customCSS;
      });
    },
    Ie = n(8),
    ze = n.n(Ie),
    Ae = n(12),
    Fe = n.n(Ae),
    Re = n(13),
    We = n.n(Re),
    Ve = function () {
      return (Ve = Object.assign || function (e) {
        for (var t, n = 1, a = arguments.length; n < a; n++) for (var r in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        return e;
      }).apply(this, arguments);
    },
    Ke = {
      extraSmall: "",
      small: "sm",
      medium: "md",
      large: "lg",
      extraLarge: "xl"
    },
    Be = {
      display: "none"
    },
    Ue = function (e) {
      var t = e.buttonText,
        n = e.sectionId,
        a = e.columnId,
        r = e.innerSectionId,
        o = e.innerColumnId,
        s = e.layoutName,
        l = e.layoutStyles,
        d = e.mainColumn,
        u = e.innerColumn,
        c = e.masterTemplatesSection,
        m = e.activeLayoutId,
        f = {
          sectionId: n,
          columnId: a,
          innerSectionId: r,
          innerColumnId: o,
          masterTemplatesSection: c
        };
      return i.a.createElement("div", {
        className: "page--section--edit"
      }, i.a.createElement("span", {
        className: "badge"
      }, t), i.a.createElement("span", {
        className: "section--settings",
        onClick: function (t) {
          e.onChangeSettings && e.onChangeSettings(s, m, l, c);
        }
      }, i.a.createElement(Fe.a, {
        width: "20px",
        height: "20px"
      })), "innerColumn" === s && i.a.createElement("span", {
        className: "section--edit",
        onClick: function () {
          e.editLayout && e.editLayout(d, u);
        }
      }, i.a.createElement(ze.a, {
        width: "20px",
        height: "20px"
      })), ("section" === s || "innerSection" === s) && i.a.createElement("span", {
        className: "section--edit",
        onClick: function () {
          e.editLayout && e.editLayout(s, m);
        }
      }, i.a.createElement(ze.a, {
        width: "20px",
        height: "20px"
      })), "column" !== s && i.a.createElement("span", {
        className: "section--delete",
        onClick: function () {
          e.deleteLayout && e.deleteLayout(f, s);
        }
      }, i.a.createElement(We.a, {
        width: "20px",
        height: "20px"
      })));
    },
    qe = function (e) {
      var t = e.mainColumn,
        n = e.equalColumns,
        a = e.device,
        r = e.editMode,
        o = e.layoutIndexes,
        s = o.mainColumnIndex,
        l = o.mainSectionIndex;
      if (n) {
        if (r) {
          t.columnId;
          var d = "col-".concat(Ke[a]);
          return i.a.createElement(je, {
            key: "emptyEqualColumn".concat(s).concat(l),
            activeColumn: t,
            colClass: d,
            onComponentClick: e.openComponentList,
            openInnerSectionsList: e.openInnerSectionsList
          });
        }
        return i.a.createElement("div", {
          className: "col-".concat(Ke[a]),
          key: "emptyEqualDiv".concat(s).concat(l)
        });
      }
      var u = t.columnSize;
      t.columnId;
      if (r) {
        var c = t.columnSize;
        t.columnId, d = "col-".concat(Ke[a], "-").concat(c);
        return i.a.createElement(je, {
          key: "emptyColumn".concat(s).concat(l),
          activeColumn: t,
          colClass: d,
          onComponentClick: e.openComponentList,
          openInnerSectionsList: e.openInnerSectionsList
        });
      }
      return i.a.createElement("div", {
        className: "col-".concat(Ke[a], "-").concat(u),
        key: "emptyDiv".concat(s).concat(l)
      });
    },
    Je = function (e) {
      e.mainColumn;
      var t = e.innerSection;
      t.equalColumns, t.device, t.sectionId;
      return i.a.createElement(i.a.Fragment, null);
    },
    Ze = function (e) {
      var t = e.innerColumn,
        n = e.equalColumns,
        a = e.device,
        r = e.mainColumn,
        o = e.editMode,
        s = e.innerColumnIndexes,
        l = s.innerColumnIndex,
        d = s.innerSectionIndex,
        u = s.mainSectionIndex,
        c = s.mainColumnIndex,
        m = "".concat(u).concat(c).concat(d).concat(l);
      if (n) {
        t.columnId;
        var f = "col-".concat(Ke[a]);
        return o ? i.a.createElement(Ne, {
          key: "equalEmptyInnerColumn".concat(m),
          activeInnerColumn: t,
          activeColumn: r,
          colClass: f,
          onComponentClick: e.openComponentList
        }) : i.a.createElement("div", {
          className: f,
          key: "equalEmptyInnerDiv".concat(m)
        });
      }
      var p = t.columnSize;
      t.columnId, f = "col-".concat(Ke[a], "-").concat(p);
      return o ? i.a.createElement(Ne, {
        key: "emptyInnerColumn".concat(m),
        activeInnerColumn: t,
        activeColumn: r,
        colClass: f,
        onComponentClick: e.openComponentList
      }) : i.a.createElement("div", {
        className: f,
        key: "emptyInnerDiv".concat(m)
      });
    },
    Ge = function (e) {
      var t = e.mainSection,
        n = e.mainColumn,
        a = e.innerSection,
        r = e.innerColumn,
        o = (e.columnId, e.ThemeProvider),
        s = e.PreviewComponent,
        l = e.previewComponentdata,
        d = e.columnStyles,
        u = e.editMode,
        c = e.theme,
        m = e.dbName,
        f = e.selectedLanguage,
        p = e.commonConfigs,
        _ = e.componentIndex,
        h = e.masterTemplatesSection;
      return i.a.createElement(i.a.Fragment, null, i.a.createElement(o, {
        theme: c
      }, i.a.createElement(Ce, null), i.a.createElement(s, {
        data: l,
        dbName: m,
        editMode: u,
        lang: f,
        commonConfigs: p,
        componentIndex: _
      })), u && i.a.createElement(Ue, {
        onChangeSettings: e.openLayoutStylesList,
        buttonText: "Inner Column",
        layoutName: "innerColumn",
        sectionId: null == t ? void 0 : t.sectionId,
        columnId: null == n ? void 0 : n.columnId,
        innerSectionId: null == a ? void 0 : a.sectionId,
        innerColumnId: null == r ? void 0 : r.columnId,
        layoutStyles: d,
        deleteLayout: e.confirmeLayoutDelete,
        editLayout: e.openComponentEditer,
        mainColumn: n,
        innerColumn: r,
        activeLayoutId: null == r ? void 0 : r.columnId,
        masterTemplatesSection: h
      }));
    },
    $e = function (e) {
      var t = e.mainSection,
        n = e.mainColumn,
        a = e.innerSection,
        r = e.innerColumn,
        o = e.equalColumns,
        s = (e.device, e.themes),
        l = e.data,
        d = e.editMode,
        u = e.dbName,
        c = e.selectedLanguage,
        m = e.commonConfigs,
        f = e.innerColumnIndexes,
        p = e.masterTemplatesSection,
        _ = e.isPreviewMode,
        h = f.mainSectionIndex,
        y = f.mainColumnIndex,
        g = f.innerSectionIndex,
        v = f.innerColumnIndex,
        M = "".concat(h + 1).concat(y + 1).concat(g + 1).concat(v + 1),
        L = Oe("div", _),
        b = {
          border: "1px dashed #d5dadf",
          paddingTop: "35px",
          borderRadius: "4px",
          content: "01"
        };
      if (s) {
        var w = s[0],
          k = Ee[r.compType];
        if (k) {
          for (var Y = {}, D = void 0, S = 0; S < l.length; S++) {
            var T = l[S];
            if (T.id == r.data) {
              Y = T;
              break;
            }
          }
          if (Y && (D = {
            data: Y,
            styles: r.uiProperties,
            settings: r.settings
          }), o) {
            var E = r.columnId,
              x = (null == (C = r.columnStyles) ? void 0 : C.cssClass) ? C.cssClass.replace(/\r?\n|\r/g, " ").replace(/,/g, " ") : "";
            return i.a.createElement(L, {
              className: "".concat(x),
              key: "equalPreview".concat(M),
              style: d ? b : {},
              styleProps: d ? {} : Ve({}, C)
            }, i.a.createElement(Ge, {
              key: "preview-component-".concat(E, "-").concat(v),
              mainSection: t,
              mainColumn: n,
              innerSection: a,
              innerColumn: r,
              columnId: E,
              ThemeProvider: R.ThemeProvider,
              PreviewComponent: k,
              previewComponentdata: D,
              columnStyles: C,
              editMode: d,
              theme: w,
              dbName: u,
              masterTemplatesSection: p,
              componentIndex: M,
              selectedLanguage: c,
              commonConfigs: m,
              confirmeLayoutDelete: e.confirmeLayoutDelete,
              openComponentList: e.openComponentList,
              openLayoutStylesList: e.openLayoutStylesList,
              openComponentEditer: e.openComponentEditer
            }));
          }
          var C;
          r.columnSize, E = r.columnId, x = (null == (C = r.columnStyles) ? void 0 : C.cssClass) ? C.cssClass.replace(/\r?\n|\r/g, " ").replace(/,/g, " ") : "";
          return i.a.createElement(L, {
            className: "".concat(x),
            key: "preview".concat(M),
            style: d ? b : {},
            styleProps: d ? {} : Ve({}, C)
          }, i.a.createElement(Ge, {
            key: "preview-component-".concat(E, "-").concat(v),
            mainSection: t,
            mainColumn: n,
            innerSection: a,
            innerColumn: r,
            columnId: E,
            ThemeProvider: R.ThemeProvider,
            PreviewComponent: k,
            previewComponentdata: D,
            columnStyles: C,
            editMode: d,
            theme: w,
            dbName: u,
            masterTemplatesSection: p,
            componentIndex: M,
            selectedLanguage: c,
            commonConfigs: m,
            confirmeLayoutDelete: e.confirmeLayoutDelete,
            openComponentList: e.openComponentList,
            openLayoutStylesList: e.openLayoutStylesList,
            openComponentEditer: e.openComponentEditer
          }));
        }
        return i.a.createElement(i.a.Fragment, {
          key: "fragment-1-".concat(M)
        });
      }
      return i.a.createElement(i.a.Fragment, {
        key: "fragment-2-".concat(M)
      });
    },
    Xe = function (e) {
      for (var t = e.mainSection, n = e.mainColumn, a = e.innerSection, r = e.editMode, o = e.themes, s = e.data, l = e.dbName, d = e.selectedLanguage, u = e.commonConfigs, c = e.innerLayoutIndexes, m = e.masterTemplatesSection, f = e.isPreviewMode, p = e.tabSections, _ = a.equalColumns, h = a.device, y = a.sectionId, g = a.sectionStyles, v = Oe("section", f), M = c.innerSectionIndex, L = c.mainSectionIndex, b = c.mainColumnIndex, w = (null == g ? void 0 : g.cssClass) ? g.cssClass.replace(/\r?\n|\r/g, " ").replace(/,/g, " ") : "", k = null == g ? void 0 : g.sectionId, Y = !1, D = 0; D < (null == p ? void 0 : p.length); D++) if (p[D] == (null == a ? void 0 : a.sectionId)) {
        Y = !0;
        var S = p.indexOf(null == a ? void 0 : a.sectionId);
        S > -1 && p.splice(S, 1);
      }
      return i.a.createElement(v, {
        id: k || y,
        className: w,
        style: r ? {
          border: "1px dashed #d5dadf",
          paddingTop: "25px",
          paddingLeft: "15px",
          paddingRight: "15px",
          position: "relative",
          borderRadius: "4px",
          content: "02"
        } : Y ? Be : {},
        styleProps: r ? {} : Ve({}, g)
      }, i.a.createElement("div", {
        className: "row"
      }, a.columns && a.columns.map(function (p, y) {
        var g = Ve(Ve({}, c), {
          innerColumnIndex: y
        });
        return "" == p.data ? i.a.createElement(Ze, {
          key: "empty-inner-column-".concat(null == p ? void 0 : p.columnId, "-").concat(y),
          innerColumn: p,
          equalColumns: _,
          device: h,
          mainColumn: n,
          editMode: r,
          openComponentList: e.openComponentList,
          innerColumnIndexes: g
        }) : i.a.createElement($e, {
          key: "inner-column-".concat(null == p ? void 0 : p.columnId, "-").concat(y),
          mainSection: t,
          mainColumn: n,
          innerSection: a,
          innerColumn: p,
          equalColumns: _,
          device: h,
          editMode: r,
          themes: o,
          data: s,
          dbName: l,
          masterTemplatesSection: m,
          innerColumnIndexes: g,
          selectedLanguage: d,
          commonConfigs: u,
          isPreviewMode: f,
          confirmeLayoutDelete: e.confirmeLayoutDelete,
          openComponentList: e.openComponentList,
          openLayoutStylesList: e.openLayoutStylesList,
          openComponentEditer: e.openComponentEditer
        });
      })), r && i.a.createElement(i.a.Fragment, null, i.a.createElement("div", {
        className: "row justify-content-center mb-3",
        key: "inner-section-btn".concat(L).concat(b).concat(M)
      }, i.a.createElement("div", {
        className: "btn-group-vertical btn-group-sm row justify-content-center mb-3",
        role: "group",
        "aria-label": "Basic example",
        key: "inner-section-btn".concat(L).concat(b).concat(M)
      }, i.a.createElement("button", {
        type: "button",
        className: "btn btn-outline-primary btn-sm",
        onClick: function () {
          var t = {
            type: "addNewInnerSection",
            innerSectionIndex: M + 1
          };
          e.openComponentList(n, {}, t);
        }
      }, "Add New Component"), i.a.createElement("button", {
        type: "button",
        className: "btn btn-outline-success btn-sm",
        onClick: function () {
          e.openInnerSectionsList(n, M + 1);
        }
      }, "Add New Inner Section"))), i.a.createElement(Ue, {
        onChangeSettings: e.openLayoutStylesList,
        buttonText: "Inner Section",
        layoutName: "innerSection",
        sectionId: null == t ? void 0 : t.sectionId,
        columnId: n.columnId,
        innerSectionId: y,
        masterTemplatesSection: m,
        layoutStyles: g,
        activeLayoutId: y,
        deleteLayout: e.confirmeLayoutDelete,
        editLayout: e.changeCurrentLayout
      })));
    },
    Qe = function (e) {
      var t = e.mainSection,
        n = e.mainColumn,
        a = e.equalColumns,
        r = (e.device, e.editMode),
        o = e.themes,
        s = e.data,
        l = e.dbName,
        d = e.selectedLanguage,
        u = e.commonConfigs,
        c = e.layoutIndexes,
        m = e.masterTemplatesSection,
        f = e.tabSections,
        p = e.isPreviewMode,
        _ = n.columnId,
        h = n.columnStyles,
        y = Oe("div", p),
        g = (null == h ? void 0 : h.cssClass) ? h.cssClass.replace(/\r?\n|\r/g, " ").replace(/,/g, " ") : "",
        v = c.mainSectionIndex,
        M = c.mainColumnIndex;
      if (a) {
        var L = {
          border: "1px dashed #d5dadf",
          paddingLeft: "0px",
          paddingRight: "0px",
          paddingTop: "25px",
          borderRadius: "4px",
          content: "03"
        };
        return i.a.createElement(y, {
          className: "".concat(g),
          style: r ? L : {},
          styleProps: r ? {} : Ve({}, h)
        }, n.section && n.section.map(function (a, _) {
          var h = a.columns,
            y = Ve(Ve({}, c), {
              innerSectionIndex: _
            });
          return 0 !== h.length ? i.a.createElement(Xe, {
            key: "inner-section-".concat(null == a ? void 0 : a.sectionId, "-").concat(_),
            mainSection: t,
            mainColumn: n,
            innerSection: a,
            editMode: r,
            themes: o,
            data: s,
            dbName: l,
            masterTemplatesSection: m,
            innerLayoutIndexes: y,
            selectedLanguage: d,
            commonConfigs: u,
            isPreviewMode: p,
            confirmeLayoutDelete: e.confirmeLayoutDelete,
            openInnerSectionsList: e.openInnerSectionsList,
            openComponentList: e.openComponentList,
            openLayoutStylesList: e.openLayoutStylesList,
            openComponentEditer: e.openComponentEditer,
            changeCurrentLayout: e.changeCurrentLayout,
            tabSections: f
          }) : i.a.createElement(i.a.Fragment, {
            key: "empty-inner-section-".concat(null == a ? void 0 : a.sectionId, "-").concat(_)
          }, r ? i.a.createElement(Je, {
            key: "empty-inner-section-edit-".concat(null == a ? void 0 : a.sectionId, "-").concat(_)
          }) : i.a.createElement(i.a.Fragment, null));
        }), r && i.a.createElement(Ue, {
          onChangeSettings: e.openLayoutStylesList,
          buttonText: "Column",
          layoutName: "column",
          sectionId: null == t ? void 0 : t.sectionId,
          masterTemplatesSection: m,
          layoutStyles: h,
          activeLayoutId: _,
          deleteLayout: e.confirmeLayoutDelete
        }));
      }
      n.columnSize, L = {
        border: "1px dashed #d5dadf",
        borderRadius: "4px",
        content: "04",
        paddingTop: "25px"
      };
      return i.a.createElement(y, {
        className: "".concat(g),
        key: "inner-section-".concat(v).concat(M),
        style: r ? L : {},
        styleProps: r ? {} : Ve({}, h)
      }, n.section && n.section.map(function (a, _) {
        var h = a.columns,
          y = Ve(Ve({}, c), {
            innerSectionIndex: _
          });
        return 0 !== h.length ? i.a.createElement(Xe, {
          key: "inner-section-".concat(null == a ? void 0 : a.sectionId, "-").concat(_),
          mainSection: t,
          mainColumn: n,
          innerSection: a,
          editMode: r,
          themes: o,
          data: s,
          dbName: l,
          masterTemplatesSection: m,
          innerLayoutIndexes: y,
          selectedLanguage: d,
          commonConfigs: u,
          isPreviewMode: p,
          confirmeLayoutDelete: e.confirmeLayoutDelete,
          openInnerSectionsList: e.openInnerSectionsList,
          openComponentList: e.openComponentList,
          openLayoutStylesList: e.openLayoutStylesList,
          openComponentEditer: e.openComponentEditer,
          changeCurrentLayout: e.changeCurrentLayout,
          tabSections: f
        }) : i.a.createElement(i.a.Fragment, {
          key: "empty-inner-section-".concat(null == a ? void 0 : a.sectionId, "-").concat(_)
        }, r ? i.a.createElement(Je, {
          key: "empty-inner-section-edit-".concat(null == a ? void 0 : a.sectionId, "-").concat(_)
        }) : i.a.createElement(i.a.Fragment, null));
      }), r && i.a.createElement(Ue, {
        onChangeSettings: e.openLayoutStylesList,
        buttonText: "Column",
        layoutName: "column",
        sectionId: null == t ? void 0 : t.sectionId,
        masterTemplatesSection: m,
        layoutStyles: h,
        activeLayoutId: _,
        deleteLayout: e.confirmeLayoutDelete
      }));
    },
    et = function (e) {
      for (var t = e.mainSection, n = e.editMode, a = e.themes, r = e.data, o = e.dbName, s = e.selectedLanguage, l = e.commonConfigs, d = e.mainSectionIndex, u = e.masterTemplatesSection, c = e.tabSections, m = e.isPreviewMode, f = t.equalColumns, p = t.device, _ = t.sectionId, h = t.sectionStyles, y = (null == h ? void 0 : h.cssClass) ? h.cssClass.replace(/\r?\n|\r/g, " ").replace(/,/g, " ") : "", g = null == h ? void 0 : h.sectionId, v = Oe("section", m), M = !1, L = 0; L < (null == c ? void 0 : c.length); L++) if (c[L] === _) {
        M = !0;
        var b = c.indexOf(_);
        b > -1 && c.splice(b, 1);
      }
      return i.a.createElement(v, {
        id: g || _,
        className: "".concat(y),
        style: n ? {
          border: "1px dashed #d5dadf",
          marginBottom: "3rem",
          padding: "25px 15px 5px",
          position: "relative",
          borderRadius: "4px",
          content: "05"
        } : M ? Be : {},
        styleProps: n ? {} : Ve({}, h)
      }, i.a.createElement("div", {
        className: "row"
      }, t.columns && t.columns.length > 0 && t.columns.map(function (_, h) {
        var y = _.section,
          g = {
            mainSectionIndex: d,
            mainColumnIndex: h
          };
        return 0 !== y.length ? i.a.createElement(Qe, {
          key: "main-column-".concat(null == _ ? void 0 : _.columnId, "-").concat(h),
          mainSection: t,
          mainColumn: _,
          equalColumns: f,
          device: p,
          editMode: n,
          themes: a,
          data: r,
          dbName: o,
          masterTemplatesSection: u,
          layoutIndexes: g,
          selectedLanguage: s,
          commonConfigs: l,
          isPreviewMode: m,
          confirmeLayoutDelete: e.confirmeLayoutDelete,
          openInnerSectionsList: e.openInnerSectionsList,
          openComponentList: e.openComponentList,
          openLayoutStylesList: e.openLayoutStylesList,
          openComponentEditer: e.openComponentEditer,
          changeCurrentLayout: e.changeCurrentLayout,
          tabSections: c
        }) : i.a.createElement(qe, {
          key: "main-empty-column-".concat(null == _ ? void 0 : _.columnId, "-").concat(h),
          mainColumn: _,
          equalColumns: f,
          device: p,
          editMode: n,
          openInnerSectionsList: e.openInnerSectionsList,
          openComponentList: e.openComponentList,
          layoutIndexes: g
        });
      })), n && i.a.createElement(Ue, {
        onChangeSettings: e.openLayoutStylesList,
        buttonText: "Section",
        layoutName: "section",
        sectionId: _,
        masterTemplatesSection: u,
        layoutStyles: h,
        activeLayoutId: _,
        deleteLayout: e.confirmeLayoutDelete,
        editLayout: e.changeCurrentLayout
      }));
    };
  function tt(e) {
    var t,
      n,
      a,
      r,
      o,
      s = e.section,
      l = e.page,
      d = e.template,
      u = e.dbName,
      c = e.themes,
      m = !!e.editMode && e.editMode,
      f = !!e.isPreview && e.isPreview,
      p = e.selectedLanguage,
      _ = {
        isEditMode: m,
        isPreview: f
      },
      h = (p.direction && p.direction, p.langKey && p.langKey.toLowerCase(), []),
      y = [];
    e.contentData && (h = e.contentData.data);
    for (var g = 0; g < (null == h ? void 0 : h.length); g++) if (null === (t = h[g]) || void 0 === t ? void 0 : t.tab) {
      y = [];
      for (var v = 0; v < (null === (a = null === (n = h[g]) || void 0 === n ? void 0 : n.tab) || void 0 === a ? void 0 : a.length); v++) y.push(null === (o = null === (r = h[g]) || void 0 === r ? void 0 : r.tab[v]) || void 0 === o ? void 0 : o.sectionId);
    }
    return l && l.section ? i.a.createElement(i.a.Fragment, null, l.section.map(function (t, n) {
      return i.a.createElement(et, {
        key: "page-main-section-" + t.sectionId,
        mainSection: t,
        editMode: m,
        themes: c,
        data: h,
        dbName: u,
        mainSectionIndex: n,
        selectedLanguage: p,
        commonConfigs: _,
        isPreviewMode: f,
        confirmeLayoutDelete: e.confirmeLayoutDelete,
        openInnerSectionsList: e.openInnerSectionsList,
        openComponentList: e.openComponentList,
        openLayoutStylesList: e.openLayoutStylesList,
        openComponentEditer: e.openComponentEditer,
        changeCurrentLayout: e.changeCurrentLayout,
        tabSections: y
      });
    })) : d && "header" == s && d.header && d.header.section ? i.a.createElement(i.a.Fragment, null, d.header.section.map(function (t, n) {
      return i.a.createElement(et, {
        key: "header-main-section-" + t.sectionId,
        mainSection: t,
        editMode: m,
        themes: c,
        data: h,
        dbName: u,
        masterTemplatesSection: "header",
        mainSectionIndex: n,
        selectedLanguage: p,
        commonConfigs: _,
        isPreviewMode: f,
        confirmeLayoutDelete: e.confirmeLayoutDelete,
        openInnerSectionsList: e.openInnerSectionsList,
        openComponentList: e.openComponentList,
        openLayoutStylesList: e.openLayoutStylesList,
        openComponentEditer: e.openComponentEditer,
        changeCurrentLayout: e.changeCurrentLayout
      });
    })) : d && "footer" == s && d.footer && d.footer.section ? i.a.createElement(i.a.Fragment, null, d.footer.section.map(function (t, n) {
      return i.a.createElement(et, {
        key: "footer-main-section-" + t.sectionId,
        mainSection: t,
        editMode: m,
        themes: c,
        data: h,
        dbName: u,
        masterTemplatesSection: "footer",
        mainSectionIndex: n,
        selectedLanguage: p,
        commonConfigs: _,
        isPreviewMode: f,
        confirmeLayoutDelete: e.confirmeLayoutDelete,
        openInnerSectionsList: e.openInnerSectionsList,
        openComponentList: e.openComponentList,
        openLayoutStylesList: e.openLayoutStylesList,
        openComponentEditer: e.openComponentEditer,
        changeCurrentLayout: e.changeCurrentLayout
      });
    })) : i.a.createElement(i.a.Fragment, null);
  }
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      id: "titleIcon",
      height: e.height,
      viewBox: "0 0 24 24",
      width: e.width,
      xmlns: "http://www.w3.org/2000/svg"
    }, i.default.createElement("g", null, i.default.createElement("path", {
      d: "m12.25 12c-.414 0-.75-.336-.75-.75v-.75h-7v.75c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-1.5c0-.414.336-.75.75-.75h8.5c.414 0 .75.336.75.75v1.5c0 .414-.336.75-.75.75z"
    })), i.default.createElement("g", null, i.default.createElement("path", {
      d: "m8 18.75c-.414 0-.75-.336-.75-.75v-8c0-.414.336-.75.75-.75s.75.336.75.75v8c0 .414-.336.75-.75.75z"
    })), i.default.createElement("g", null, i.default.createElement("path", {
      d: "m9.25 19h-2.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h2.5c.414 0 .75.336.75.75s-.336.75-.75.75z"
    })), i.default.createElement("g", null, i.default.createElement("path", {
      d: "m20.25 10.5h-4.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h4.5c.414 0 .75.336.75.75s-.336.75-.75.75z"
    })), i.default.createElement("g", null, i.default.createElement("path", {
      d: "m20.25 14.5h-4.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h4.5c.414 0 .75.336.75.75s-.336.75-.75.75z"
    })), i.default.createElement("g", null, i.default.createElement("path", {
      d: "m20.25 18.5h-4.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h4.5c.414 0 .75.336.75.75s-.336.75-.75.75z"
    })), i.default.createElement("g", null, i.default.createElement("path", {
      d: "m21.25 23h-18.5c-1.517 0-2.75-1.233-2.75-2.75v-16.5c0-1.517 1.233-2.75 2.75-2.75h18.5c1.517 0 2.75 1.233 2.75 2.75v16.5c0 1.517-1.233 2.75-2.75 2.75zm-18.5-20.5c-.689 0-1.25.561-1.25 1.25v16.5c0 .689.561 1.25 1.25 1.25h18.5c.689 0 1.25-.561 1.25-1.25v-16.5c0-.689-.561-1.25-1.25-1.25z"
    })), i.default.createElement("g", null, i.default.createElement("path", {
      d: "m23.25 6h-22.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h22.5c.414 0 .75.336.75.75s-.336.75-.75.75z"
    })));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      id: "paragraphIcon",
      height: e.height,
      viewBox: "0 0 24 24",
      width: e.width,
      xmlns: "http://www.w3.org/2000/svg"
    }, i.default.createElement("path", {
      d: "m18 17h-5c-.553 0-1-.447-1-1s.447-1 1-1h5v-2h-5c-.553 0-1-.447-1-1s.447-1 1-1h5c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2z"
    }), i.default.createElement("path", {
      d: "m7 17h-1c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h1c.553 0 1 .447 1 1s-.447 1-1 1h-1v2h1c.553 0 1 .447 1 1s-.447 1-1 1z"
    }), i.default.createElement("path", {
      d: "m12 18c-.552 0-1-.448-1-1v-6c0-.552.448-1 1-1 .553 0 1-.447 1-1s-.447-1-1-1c-.768 0-1.469.29-2 .766-.531-.476-1.232-.766-2-.766-.553 0-1 .447-1 1s.447 1 1 1c.552 0 1 .448 1 1v6c0 .552-.448 1-1 1-.553 0-1 .447-1 1s.447 1 1 1c.768 0 1.469-.29 2-.766.531.476 1.232.766 2 .766.553 0 1-.447 1-1s-.447-1-1-1z"
    }), i.default.createElement("path", {
      d: "m21 1h-18c-1.654 0-3 1.346-3 3v16c0 1.654 1.346 3 3 3h18c1.654 0 3-1.346 3-3v-16c0-1.654-1.346-3-3-3zm0 20h-18c-.551 0-1-.448-1-1v-14h20v14c0 .552-.449 1-1 1z"
    }));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      height: e.height,
      viewBox: "0 -21 511.98744 511",
      width: e.width,
      xmlns: "http://www.w3.org/2000/svg"
    }, i.default.createElement("path", {
      d: "m133.320312 373.828125c-34.152343 0-64.53125-21.867187-75.5625-54.421875l-.746093-2.453125c-2.601563-8.621094-3.691407-15.871094-3.691407-23.125v-145.453125l-51.753906 172.757812c-6.65625 25.410157 8.511719 51.753907 33.960938 58.773438l329.878906 88.34375c4.117188 1.066406 8.234375 1.578125 12.289062 1.578125 21.246094 0 40.660157-14.101563 46.101563-34.882813l19.21875-61.117187zm0 0"
    }), i.default.createElement("path", {
      d: "m191.988281 149.828125c23.53125 0 42.664063-19.136719 42.664063-42.667969s-19.132813-42.667968-42.664063-42.667968-42.667969 19.136718-42.667969 42.667968 19.136719 42.667969 42.667969 42.667969zm0 0"
    }), i.default.createElement("path", {
      d: "m458.652344.492188h-320c-29.394532 0-53.332032 23.9375-53.332032 53.335937v234.664063c0 29.398437 23.9375 53.335937 53.332032 53.335937h320c29.398437 0 53.335937-23.9375 53.335937-53.335937v-234.664063c0-29.398437-23.9375-53.335937-53.335937-53.335937zm-320 42.667968h320c5.890625 0 10.667968 4.777344 10.667968 10.667969v151.445313l-67.390624-78.636719c-7.148438-8.382813-17.496094-12.863281-28.609376-13.117188-11.050781.0625-21.417968 4.96875-28.5 13.460938l-79.234374 95.101562-25.8125-25.75c-14.589844-14.589843-38.335938-14.589843-52.90625 0l-58.878907 58.859375v-201.363281c0-5.890625 4.777344-10.667969 10.664063-10.667969zm0 0"
    }));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      id: "bold",
      height: e.height,
      viewBox: "0 0 24 24",
      width: e.width,
      xmlns: "http://www.w3.org/2000/svg"
    }, i.default.createElement("g", null, i.default.createElement("path", {
      d: "m19 11h-5c-.552 0-1-.448-1-1s.448-1 1-1h5c.552 0 1 .448 1 1s-.448 1-1 1z"
    })), i.default.createElement("g", null, i.default.createElement("path", {
      d: "m19 15h-5c-.552 0-1-.448-1-1s.448-1 1-1h5c.552 0 1 .448 1 1s-.448 1-1 1z"
    })), i.default.createElement("g", null, i.default.createElement("path", {
      d: "m19 19h-5c-.552 0-1-.448-1-1s.448-1 1-1h5c.552 0 1 .448 1 1s-.448 1-1 1z"
    })), i.default.createElement("g", null, i.default.createElement("path", {
      d: "m9.25 13h-3.5c-.965 0-1.75-.785-1.75-1.75v-1.5c0-.965.785-1.75 1.75-1.75h3.5c.965 0 1.75.785 1.75 1.75v1.5c0 .965-.785 1.75-1.75 1.75z"
    })), i.default.createElement("g", null, i.default.createElement("path", {
      d: "m9.25 20h-3.5c-.965 0-1.75-.785-1.75-1.75v-1.5c0-.965.785-1.75 1.75-1.75h3.5c.965 0 1.75.785 1.75 1.75v1.5c0 .965-.785 1.75-1.75 1.75z"
    })), i.default.createElement("g", null, i.default.createElement("path", {
      d: "m21 1h-18c-1.654 0-3 1.346-3 3v16c0 1.654 1.346 3 3 3h18c1.654 0 3-1.346 3-3v-16c0-1.654-1.346-3-3-3zm0 20h-18c-.551 0-1-.448-1-1v-14h20v14c0 .552-.449 1-1 1z"
    })));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      width: e.width,
      height: e.height,
      viewBox: "0 0 100 100",
      xmlns: "http://www.w3.org/2000/svg"
    }, i.default.createElement("g", {
      id: "25.-Video",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, i.default.createElement("g", {
      transform: "translate(2.000000, 8.000000)",
      stroke: "#222F3E",
      strokeWidth: "4"
    }, i.default.createElement("rect", {
      id: "Layer-1",
      x: "0",
      y: "0",
      width: "96",
      height: "84.48",
      rx: "20"
    }), i.default.createElement("path", {
      d: "M36.48,24.9370316 C36.48,23.2787363 37.6310215,22.6274848 39.0422854,23.4772465 L67.6394029,40.6963747 C69.054514,41.5484529 69.0506668,42.9322612 67.6394029,43.7820228 L39.0422854,61.0011511 C37.6271742,61.8532293 36.48,61.1928227 36.48,59.541366 L36.48,24.9370316 Z",
      id: "Layer-2"
    }))));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      width: e.width,
      height: e.height,
      viewBox: "0 0 50 50",
      xmlns: "http://www.w3.org/2000/svg"
    }, i.default.createElement("g", {
      id: "Layer_1_1_"
    }, i.default.createElement("path", {
      d: "M37,1H13v48h24V1z M35,47H15V3h20V47z"
    }), i.default.createElement("path", {
      d: "M49,4H39v42h10V4z M47,44h-6V6h6V44z"
    }), i.default.createElement("path", {
      d: "M11,4H1v42h10V4z M9,44H3V6h6V44z"
    })));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      width: e.width,
      height: e.height,
      viewBox: "0 0 128 128",
      xmlns: "http://www.w3.org/2000/svg"
    }, i.default.createElement("path", {
      className: "cls-1",
      d: "M64.12712,49.153a2.56353,2.56353,0,0,0,2.56077-2.56055V41.38156a2.56088,2.56088,0,1,0-5.12175,0v5.21093A2.56358,2.56358,0,0,0,64.12712,49.153Z"
    }), i.default.createElement("path", {
      className: "cls-1",
      d: "M83.31228,57.20535a2.5438,2.5438,0,0,0,1.811-.75047L88.808,52.77059a2.56086,2.56086,0,1,0-3.62171-3.6215l-3.68472,3.68472a2.561,2.561,0,0,0,1.81073,4.37153Z"
    }), i.default.createElement("path", {
      className: "cls-1",
      d: "M88.624,73.90431a2.56353,2.56353,0,0,0,2.56077,2.56055h5.21071a2.56077,2.56077,0,1,0,0-5.12154H91.18473A2.5639,2.5639,0,0,0,88.624,73.90431Z"
    }), i.default.createElement("path", {
      className: "cls-1",
      d: "M84.94337,91.27874a2.56086,2.56086,0,1,0-3.62171,3.6215L85.00638,98.585a2.56086,2.56086,0,1,0,3.62171-3.6215Z"
    }), i.default.createElement("path", {
      className: "cls-1",
      d: "M63.87291,98.40094a2.56393,2.56393,0,0,0-2.56079,2.561v5.21049a2.56078,2.56078,0,1,0,5.12156,0v-5.21049A2.56392,2.56392,0,0,0,63.87291,98.40094Z"
    }), i.default.createElement("path", {
      className: "cls-1",
      d: "M42.87677,91.09909,39.192,94.78379a2.56086,2.56086,0,0,0,3.62171,3.6215l3.6847-3.68472a2.56084,2.56084,0,0,0-3.62168-3.62147Z"
    }), i.default.createElement("path", {
      className: "cls-1",
      d: "M39.37607,73.6501a2.56394,2.56394,0,0,0-2.56077-2.561h-5.211a2.56078,2.56078,0,0,0,0,5.12156h5.211A2.56357,2.56357,0,0,0,39.37607,73.6501Z"
    }), i.default.createElement("path", {
      className: "cls-1",
      d: "M42.99362,48.96945a2.56071,2.56071,0,1,0-3.62171,3.62106l3.68472,3.6847a2.56085,2.56085,0,1,0,3.62171-3.62147Z"
    }), i.default.createElement("path", {
      className: "cls-2",
      d: "M81.40125,73.90431a2.1738,2.1738,0,0,0-2.17116-2.17159h-9.526a6.22238,6.22238,0,1,0,0,4.34275h9.526A2.17371,2.17371,0,0,0,81.40125,73.90431Z"
    }), i.default.createElement("path", {
      className: "cls-2",
      d: "M108.701,46.855l6.09114-4.42633a1.73317,1.73317,0,0,0,.38324-2.42089l-7.32239-10.077a1.73317,1.73317,0,0,0-2.42065-.38345l-6.97142,5.06376A52.04906,52.04906,0,0,0,71.29848,22.09373V13.95411H75.345a5.97154,5.97154,0,1,0,0-11.94309h-22.69a5.97154,5.97154,0,1,0,0,11.94309h4.04647v8.12035A52.04956,52.04956,0,0,0,29.53907,34.59182l-6.97139-5.06376a1.7332,1.7332,0,0,0-2.42067.38345l-7.32236,10.077a1.73312,1.73312,0,0,0,.38324,2.42089L19.299,46.83569a52.184,52.184,0,0,0,44.695,79.13385v.01944a52.1841,52.1841,0,0,0,44.707-79.134ZM64.006,115.81508V115.796A42.02853,42.02853,0,0,1,63.994,31.7389V31.758a42.02853,42.02853,0,0,1,.01191,84.05706Z"
    }));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      width: e.width,
      height: e.height,
      viewBox: "0 0 21 20",
      xmlns: "http://www.w3.org/2000/svg"
    }, i.default.createElement("g", {
      id: "Page-1",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd"
    }, i.default.createElement("g", {
      id: "Dribbble-Light-Preview",
      transform: "translate(-299.000000, -680.000000)",
      fill: "#000000"
    }, i.default.createElement("g", {
      id: "icons",
      transform: "translate(56.000000, 160.000000)"
    }, i.default.createElement("path", {
      d: "M245.1,538 L250.35,538 L250.35,536 L245.1,536 L245.1,538 Z M243,540 L252.45,540 L252.45,534 L243,534 L243,540 Z M256.65,524 L261.9,524 L261.9,522 L256.65,522 L256.65,524 Z M254.55,526 L264,526 L264,520 L254.55,520 L254.55,526 Z M256.65,538 L261.9,538 L261.9,530 L256.65,530 L256.65,538 Z M254.55,540 L264,540 L264,528 L254.55,528 L254.55,540 Z M245.1,530 L250.35,530 L250.35,522 L245.1,522 L245.1,530 Z M243,532 L252.45,532 L252.45,520 L243,520 L243,532 Z",
      id: "gallery_grid_view-[#1404]"
    })))));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      width: e.width,
      height: e.height,
      viewBox: "0 0 99.313 99.313",
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      enableBackground: "new 0 0 99.313 99.313"
    }, i.default.createElement("g", null, i.default.createElement("path", {
      fill: "#231F20",
      d: "M69.693,38.046c0.005,0,0.011,0,0.016,0c2.087,0,4.049-0.812,5.527-2.286\r c1.482-1.479,2.3-3.445,2.302-5.539c0.004-4.323-3.508-7.844-7.828-7.85c-0.002,0-0.005,0-0.007,0c-4.319,0-7.835,3.508-7.84,7.823\r c-0.004,2.096,0.811,4.068,2.292,5.552C65.634,37.229,67.602,38.046,69.693,38.046z M69.702,25.34c0.002,0,0.004,0,0.005,0\r c2.684,0.003,4.864,2.192,4.862,4.878c-0.001,1.3-0.509,2.521-1.429,3.439c-0.918,0.916-2.137,1.419-3.435,1.419\r c-0.003,0-0.007,0-0.01,0c-1.3,0-2.521-0.507-3.44-1.427c-0.92-0.922-1.426-2.147-1.424-3.451\r C64.835,27.519,67.019,25.34,69.702,25.34z"
    }), i.default.createElement("path", {
      fill: "#231F20",
      d: "M95.31,84.301L80.282,49.146l5.12-8.19c0.055-0.088,0.1-0.181,0.133-0.276\r c1.751-2.905,2.676-6.196,2.676-9.538c0.008-4.949-1.908-9.603-5.396-13.104c-3.489-3.503-8.137-5.437-13.088-5.444\r c-0.008,0-0.015,0-0.022,0c-10.2,0-18.51,8.292-18.526,18.496c0,3.393,0.928,6.703,2.687,9.59c0.028,0.071,0.062,0.141,0.103,0.208\r l2.779,4.667H21.197c-0.595,0-1.132,0.354-1.365,0.901L3.656,84.301c-0.195,0.458-0.148,0.985,0.126,1.401\r c0.275,0.416,0.74,0.667,1.239,0.667h88.927c0.499,0,0.964-0.25,1.239-0.667C95.459,85.286,95.505,84.759,95.31,84.301z\r M56.524,39.338c-1.556-2.468-2.378-5.32-2.378-8.245c0.015-8.567,6.991-15.529,15.557-15.529c0.007,0,0.013,0,0.02,0\r c4.156,0.006,8.06,1.629,10.989,4.57c2.928,2.94,4.537,6.848,4.53,11.004c0,0.001,0,0.001,0,0.002c0,2.891-0.827,5.741-2.393,8.241\r c-0.054,0.084-0.097,0.173-0.13,0.265l-13.335,21.33l-8.768-14.724c-0.011-0.018-0.02-0.036-0.032-0.053l-3.928-6.596\r C56.622,39.511,56.578,39.422,56.524,39.338z M22.173,48.524h3.383c0.212,4.235,3.843,5.83,6.52,6.998\r c1.405,0.613,2.858,1.246,3.314,2.024c0.72,1.228,0.255,2.083-1.155,4.041c-1.289,1.789-2.894,4.015-1.796,6.934\r c1.702,4.526,10.53,5.742,20.208,6.678c1.757,0.169,3.273,0.316,4.225,0.478c7.474,1.269,9.984,5.506,10.802,7.726H7.267\r L22.173,48.524z M70.791,83.4c-0.676-2.552-3.356-8.944-13.423-10.652c-1.056-0.179-2.621-0.331-4.435-0.506\r c-5.363-0.519-16.523-1.598-17.715-4.768c-0.512-1.36,0.208-2.464,1.425-4.152c1.298-1.8,3.074-4.266,1.308-7.279\r c-0.944-1.611-2.848-2.441-4.688-3.244c-2.793-1.217-4.529-2.153-4.72-4.276h29.97l9.565,16.062c0.265,0.445,0.742,0.72,1.26,0.725\r c0.005,0,0.011,0,0.016,0c0.512,0,0.987-0.263,1.259-0.697l7.752-12.4L91.697,83.4H70.791z"
    })));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      width: e.width,
      height: e.height,
      viewBox: "0 0 58 58",
      xmlns: "http://www.w3.org/2000/svg",
      enableBackground: "new 0 0 58 58"
    }, i.default.createElement("rect", {
      fill: "#E7ECED",
      width: "58",
      height: "58"
    }), i.default.createElement("line", {
      fill: "none",
      stroke: "#424A60",
      strokeWidth: "2",
      strokeMiterlimit: "10",
      x1: "50",
      y1: "29",
      x2: "8",
      y2: "29"
    }), i.default.createElement("path", {
      fill: "none",
      stroke: "#424A60",
      strokeWidth: "2",
      strokeMiterlimit: "10",
      d: "M29,20L29,20c-2.2,0-4-1.8-4-4v0c0-2.2,1.8-4,4-4h0\r c2.2,0,4,1.8,4,4v0C33,18.2,31.2,20,29,20z"
    }), i.default.createElement("path", {
      fill: "none",
      stroke: "#424A60",
      strokeWidth: "2",
      strokeMiterlimit: "10",
      d: "M29,46L29,46c-2.2,0-4-1.8-4-4v0c0-2.2,1.8-4,4-4h0\r c2.2,0,4,1.8,4,4v0C33,44.2,31.2,46,29,46z"
    }), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      width: e.width,
      height: e.height,
      viewBox: "0 0 32 32",
      xmlns: "http://www.w3.org/2000/svg"
    }, i.default.createElement("g", {
      id: "Page-1",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      sketchtype: "MSPage"
    }, i.default.createElement("g", {
      id: "icon-76-document-file-html",
      sketchtype: "MSArtboardGroup",
      fill: "#000000"
    }, i.default.createElement("path", {
      d: "M19,13 L19,10 L19,10 L13,3 L2.00276013,3 C0.896666251,3 0,3.89833832 0,5.00732994 L0,27.9926701 C0,29.1012878 0.890925393,30 1.99742191,30 L17.0025781,30 C18.1057238,30 19,29.1017876 19,28.0092049 L19,26 L29.0057181,26 C30.6594143,26 32,24.6577357 32,23.0012144 L32,15.9987856 C32,14.3426021 30.6594313,13 29.0057181,13 L19,13 L19,13 L19,13 Z M18,26 L18,28.0066023 C18,28.5550537 17.5523026,29 17.0000398,29 L1.9999602,29 C1.45470893,29 1,28.5543187 1,28.004543 L1,4.99545703 C1,4.45526288 1.44573523,4 1.9955775,4 L12,4 L12,8.99408095 C12,10.1134452 12.8944962,11 13.9979131,11 L18,11 L18,13 L5.99428189,13 C4.34058566,13 3,14.3422643 3,15.9987856 L3,23.0012144 C3,24.6573979 4.3405687,26 5.99428189,26 L18,26 L18,26 L18,26 Z M13,4.5 L13,8.99121523 C13,9.54835167 13.4506511,10 13.9967388,10 L17.6999512,10 L13,4.5 L13,4.5 Z M6.00732994,14 C4.89871223,14 4,14.9001762 4,15.992017 L4,23.007983 C4,24.1081436 4.89833832,25 6.00732994,25 L28.9926701,25 C30.1012878,25 31,24.0998238 31,23.007983 L31,15.992017 C31,14.8918564 30.1016617,14 28.9926701,14 L6.00732994,14 L6.00732994,14 Z M29,22 L29,23 L24,23 L24,16 L25,16 L25,22 L29,22 L29,22 Z M14,17 L14,23 L15,23 L15,17 L17,17 L17,16 L12,16 L12,17 L14,17 L14,17 Z M10,19 L10,16 L11,16 L11,23 L10,23 L10,20 L7,20 L7,23 L6,23 L6,16 L7,16 L7,19 L10,19 L10,19 Z M20.5,19 L19,16 L18.5,16 L18,16 L18,23 L19,23 L19,18 L20,20 L20.5,20 L21,20 L22,18 L22,23 L23,23 L23,16 L22.5,16 L22,16 L20.5,19 L20.5,19 Z",
      id: "document-file-html",
      sketchtype: "MSShapeGroup"
    }))));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      id: "Layer_1",
      height: e.height,
      viewBox: "0 0 511.995 511.995",
      width: e.width,
      fill: e.color,
      xmlns: "http://www.w3.org/2000/svg"
    }, i.default.createElement("g", null, i.default.createElement("path", {
      d: "m507.308 236.641-198.98-198.99c-28.86-28.85-75.8-28.85-104.66 0l-198.98 198.99c-6.25 6.25-6.25 16.38 0 22.63 6.24 6.25 16.38 6.25 22.62 0l12.69-12.69v203.4c0 25.405 20.595 46 46 46h80c5.523 0 10-4.477 10-10v-148c0-27.614 22.386-50 50-50h60c27.614 0 50 22.386 50 50v148c0 5.523 4.477 10 10 10h80c25.405 0 46-20.595 46-46v-203.4l12.69 12.69c3.12 3.12 7.22 4.69 11.31 4.69s8.19-1.57 11.31-4.69c6.25-6.25 6.25-16.38 0-22.63z"
    })));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  };
  t.default = function (e) {
    return o.default.createElement("svg", a({
      viewBox: "0 0 22.2 22.2"
    }, e), o.default.createElement("defs", null, o.default.createElement("linearGradient", {
      id: "prefix__a",
      x1: 11.1,
      y1: 1.6,
      x2: 11.1,
      y2: 20.6,
      gradientUnits: "userSpaceOnUse"
    }, o.default.createElement("stop", {
      offset: 0,
      stopColor: "#fff",
      stopOpacity: 0
    }), o.default.createElement("stop", {
      offset: 1,
      stopColor: "#fff",
      stopOpacity: .7
    }))), o.default.createElement("title", null, "home"), o.default.createElement("g", {
      "data-name": "Layer 2"
    }, o.default.createElement("g", {
      "data-name": "Layer 1"
    }, o.default.createElement("path", {
      fill: "none",
      d: "M0 0h22.2v22.2H0z"
    }), o.default.createElement("path", {
      opacity: .25,
      fill: "url(#prefix__a)",
      d: "M20.14 8.72V20.6H2.06V8.72l9.05-7.12 9.03 7.12z"
    }), o.default.createElement("path", {
      d: "M20.64 21.1H1.56V8.47L11.1 1l9.54 7.51zm-18.08-1h17.08V9L11.1 2.24 2.56 9z",
      fill: "#fff"
    }))));
  };
  var r,
    i = n(0),
    o = (r = i) && r.__esModule ? r : {
      default: r
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  };
  t.default = function (e) {
    return o.default.createElement("svg", a({
      viewBox: "0 0 22.2 22.2"
    }, e), o.default.createElement("title", null, "settings"), o.default.createElement("g", {
      "data-name": "Layer 2"
    }, o.default.createElement("g", {
      "data-name": "Layer 1"
    }, o.default.createElement("path", {
      fill: "none",
      d: "M0 0h22.2v22.2H0z"
    }), o.default.createElement("path", {
      d: "M20.28 9.26h-2.07a7.17 7.17 0 00-.78-1.89l1.46-1.47a.92.92 0 000-1.29l-1.3-1.3a.92.92 0 00-1.3 0l-1.46 1.45a7.36 7.36 0 00-1.9-.76V1.92A.91.91 0 0012 1h-1.82a.91.91 0 00-.92.92V4a7.22 7.22 0 00-1.9.77L5.9 3.31a.92.92 0 00-1.3 0l-1.3 1.3a.91.91 0 000 1.29l1.46 1.47A7.17 7.17 0 004 9.26H1.91a.93.93 0 00-.92.93V12a.93.93 0 00.92.93H4a7.17 7.17 0 00.78 1.89L3.3 16.3a.91.91 0 000 1.29l1.3 1.3a.9.9 0 001.3 0l1.46-1.45a7.22 7.22 0 001.9.77v2.07a.92.92 0 00.92.92H12a.92.92 0 00.92-.92v-2.07a7.36 7.36 0 001.9-.77l1.46 1.45a.9.9 0 001.3 0l1.3-1.3a.92.92 0 000-1.29l-1.46-1.47a7.17 7.17 0 00.78-1.89h2.07a.93.93 0 00.93-.94v-1.81a.93.93 0 00-.92-.93zm-9.19 5.51a3.67 3.67 0 113.68-3.68 3.67 3.67 0 01-3.68 3.68z",
      fill: "#fff",
      opacity: .25
    }), o.default.createElement("path", {
      d: "M11.1 6.93a4.17 4.17 0 104.17 4.16 4.17 4.17 0 00-4.17-4.16zm2.25 6.41a3.17 3.17 0 11.92-2.25 3.22 3.22 0 01-.92 2.25zM11.1 6.93a4.17 4.17 0 104.17 4.16 4.17 4.17 0 00-4.17-4.16zm2.25 6.41a3.17 3.17 0 11.92-2.25 3.22 3.22 0 01-.92 2.25z",
      fill: "#fff"
    }), o.default.createElement("path", {
      d: "M20.29 8.76H18.6a7.94 7.94 0 00-.6-1.31l1.21-1.19a1.43 1.43 0 00.4-1 1.4 1.4 0 00-.4-1L17.94 3a1.4 1.4 0 00-1-.42 1.49 1.49 0 00-1 .42l-1.18 1.2a8.5 8.5 0 00-1.32-.54V1.92A1.42 1.42 0 0012 .5h-1.82a1.41 1.41 0 00-1.41 1.42v1.69a8.5 8.5 0 00-1.32.54L6.25 3a1.42 1.42 0 00-1-.42 1.43 1.43 0 00-1 .42L3 4.26a1.39 1.39 0 00-.41 1 1.42 1.42 0 00.41 1l1.2 1.19a8.85 8.85 0 00-.6 1.31H1.91A1.43 1.43 0 00.5 10.19V12a1.41 1.41 0 001.41 1.43H3.6a8.85 8.85 0 00.55 1.31L3 16a1.39 1.39 0 00-.41 1A1.42 1.42 0 003 18l1.3 1.3a1.43 1.43 0 001 .42 1.42 1.42 0 001-.42l1.2-1.2a7.58 7.58 0 001.32.53v1.7a1.4 1.4 0 001.41 1.42H12a1.4 1.4 0 001.41-1.42v-1.7a7.58 7.58 0 001.32-.53l1.19 1.2a1.45 1.45 0 001 .42 1.4 1.4 0 001-.42l1.33-1.3a1.43 1.43 0 00.4-1 1.41 1.41 0 00-.4-1L18 14.75a7.94 7.94 0 00.56-1.31h1.69A1.42 1.42 0 0021.7 12v-1.81a1.42 1.42 0 00-1.41-1.43zM20.7 12a.43.43 0 01-.41.43h-2.46l-.1.38a6.3 6.3 0 01-.73 1.77l-.19.34 1.73 1.72a.44.44 0 01.11.31.41.41 0 01-.11.3l-1.29 1.3a.47.47 0 01-.31.12.44.44 0 01-.3-.12l-1.73-1.73-.33.19a7.39 7.39 0 01-1.77.72l-.38.09v2.46a.41.41 0 01-.41.42h-1.84a.41.41 0 01-.41-.42v-2.46l-.38-.09A6.78 6.78 0 017.62 17l-.33-.2-1.73 1.75a.45.45 0 01-.31.12.44.44 0 01-.3-.12l-1.3-1.3a.5.5 0 01-.11-.3.51.51 0 01.11-.31l1.74-1.72-.2-.34a6.59 6.59 0 01-.72-1.76l-.1-.38H1.91A.41.41 0 011.5 12v-1.81a.42.42 0 01.41-.43h2.46l.1-.38a6.33 6.33 0 01.72-1.76l.2-.34-1.74-1.72a.5.5 0 01-.11-.3.51.51 0 01.11-.26L5 3.65a.44.44 0 01.3-.12.45.45 0 01.31.12l1.68 1.74.33-.19a6.82 6.82 0 011.77-.74l.38-.08V1.92a.4.4 0 01.41-.42H12a.41.41 0 01.41.42v2.46l.38.08a7.45 7.45 0 011.77.74l.33.19 1.73-1.74a.44.44 0 01.3-.12.47.47 0 01.31.12L18.54 5a.42.42 0 01.11.31.41.41 0 01-.11.3l-1.73 1.67.19.34a6.07 6.07 0 01.73 1.76l.1.38h2.46a.43.43 0 01.41.43z",
      fill: "#fff"
    }))));
  };
  var r,
    i = n(0),
    o = (r = i) && r.__esModule ? r : {
      default: r
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  };
  t.default = function (e) {
    return o.default.createElement("svg", a({
      viewBox: "0 0 22.2 22.2"
    }, e), o.default.createElement("title", null, "content"), o.default.createElement("g", {
      "data-name": "Layer 2"
    }, o.default.createElement("g", {
      "data-name": "Layer 1"
    }, o.default.createElement("path", {
      fill: "none",
      d: "M0 0h22.2v22.2H0z"
    }), o.default.createElement("path", {
      d: "M17.52 14.53a2.45 2.45 0 01-4.17 1.73l-.93-.92-5.68-5.63-1-4.48 4.46 1 5.6 5.57 1 1a2.44 2.44 0 01.72 1.73z",
      fill: "#fff",
      opacity: .25
    }), o.default.createElement("path", {
      d: "M15.07 17.47a2.93 2.93 0 01-2.07-.86L6.28 10 5.1 4.56l5.37 1.27 6.67 6.59a3 3 0 01.86 2.11 2.93 2.93 0 01-.87 2.08 3 3 0 01-2.06.86zm-7.88-8l6.51 6.43a1.93 1.93 0 002.74 0 1.91 1.91 0 00.56-1.37 1.93 1.93 0 00-.58-1.39L10 6.73 6.41 5.9z",
      fill: "#fff"
    }), o.default.createElement("path", {
      d: "M15.07 17.47a2.93 2.93 0 01-2.07-.86L6.28 10 5.1 4.56l5.37 1.27 6.67 6.59a3 3 0 01.86 2.11 2.93 2.93 0 01-.87 2.08 3 3 0 01-2.06.86zm-7.88-8l6.51 6.43a1.93 1.93 0 002.74 0 1.91 1.91 0 00.56-1.37 1.93 1.93 0 00-.58-1.39L10 6.73 6.41 5.9z",
      fill: "#fff"
    }), o.default.createElement("path", {
      fill: "#fff",
      d: "M12.048 14.994l3.385-3.543.723.69-3.385 3.544z"
    }), o.default.createElement("path", {
      d: "M19.71 2.1a1.39 1.39 0 011.39 1.39v15.23a1.38 1.38 0 01-1.39 1.38H2.48a1.37 1.37 0 01-1.38-1.38V3.49A1.38 1.38 0 012.48 2.1h17.23m0-1H2.48A2.38 2.38 0 00.1 3.49v15.23a2.37 2.37 0 002.38 2.38h17.23a2.38 2.38 0 002.39-2.38V3.49a2.39 2.39 0 00-2.39-2.39z",
      fill: "#fff"
    }))));
  };
  var r,
    i = n(0),
    o = (r = i) && r.__esModule ? r : {
      default: r
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  };
  t.default = function (e) {
    return o.default.createElement("svg", a({
      viewBox: "0 0 22.2 22.2"
    }, e), o.default.createElement("title", null, "users"), o.default.createElement("g", {
      "data-name": "Layer 2"
    }, o.default.createElement("g", {
      "data-name": "Layer 1"
    }, o.default.createElement("path", {
      fill: "none",
      d: "M0 0h22.2v22.2H0z"
    }), o.default.createElement("path", {
      d: "M4.41 7.31a1.71 1.71 0 01-1.7-1.71 1.7 1.7 0 013.4 0 1.71 1.71 0 01-1.7 1.71zM8.39 7.69a2.77 2.77 0 112.77 2.76 2.78 2.78 0 01-2.77-2.76zM16.65 15.74v2.55H5.55v-2.55a3 3 0 013-3h5.13a3 3 0 012.97 3zM19.56 5.6a1.7 1.7 0 11-3.4 0 1.7 1.7 0 013.4 0z",
      fill: "#fff",
      opacity: .25
    }), o.default.createElement("path", {
      d: "M1.46 12.75h-1v-1.57A2.33 2.33 0 012.8 8.85H6v1H2.8a1.34 1.34 0 00-1.34 1.33zM4.41 7.81a2.2 2.2 0 112.2-2.21 2.21 2.21 0 01-2.2 2.21zm0-3.4a1.2 1.2 0 101.2 1.19 1.19 1.19 0 00-1.2-1.19zM21.74 12.75h-1v-1.56a1.35 1.35 0 00-1.34-1.35h-3.16v-1h3.16a2.35 2.35 0 012.34 2.35zM17.86 7.81a2.2 2.2 0 112.2-2.21 2.21 2.21 0 01-2.2 2.21zm0-3.4a1.2 1.2 0 101.2 1.19 1.19 1.19 0 00-1.2-1.19zM17.15 18.29h-1v-2.55a2.5 2.5 0 00-2.49-2.49H8.53a2.49 2.49 0 00-2.48 2.49v2.55h-1v-2.55a3.49 3.49 0 013.48-3.49h5.13a3.49 3.49 0 013.49 3.49zM11.16 11a3.27 3.27 0 113.26-3.26A3.27 3.27 0 0111.16 11zm0-5.54a2.27 2.27 0 102.26 2.28 2.28 2.28 0 00-2.26-2.33z",
      fill: "#fff"
    }))));
  };
  var r,
    i = n(0),
    o = (r = i) && r.__esModule ? r : {
      default: r
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  };
  t.default = function (e) {
    return o.default.createElement("svg", a({
      viewBox: "0 0 22.2 22.2"
    }, e), o.default.createElement("title", null, "pulish"), o.default.createElement("g", {
      "data-name": "Layer 2"
    }, o.default.createElement("g", {
      "data-name": "Layer 1"
    }, o.default.createElement("path", {
      fill: "none",
      d: "M0 0h22.2v22.2H0z"
    }), o.default.createElement("path", {
      fill: "#fff",
      d: "M21.5 10.55v6.65l-10.43 4.12L.7 17.2v-6.65l10.37 4.13 10.43-4.13z",
      opacity: .25
    }), o.default.createElement("path", {
      d: "M11.07 15.18a.39.39 0 01-.18 0L.52 11a.48.48 0 01-.31-.47.5.5 0 01.32-.46l5.83-2.16A.5.5 0 017 8.2a.49.49 0 01-.29.64L2.1 10.56l9 3.58 9-3.58-4.67-1.73a.5.5 0 01-.3-.64.49.49 0 01.64-.29l5.9 2.18a.52.52 0 01.33.46.5.5 0 01-.32.47l-10.42 4.13a.43.43 0 01-.19.04z",
      fill: "#fff"
    }), o.default.createElement("path", {
      d: "M11.07 21.83a.58.58 0 01-.18 0L.52 17.66a.5.5 0 01-.31-.47v-6.64a.5.5 0 01.5-.5.5.5 0 01.5.5v6.31l9.86 3.93L21 16.85v-6.3a.5.5 0 01.5-.5.5.5 0 01.5.5v6.64a.51.51 0 01-.32.47l-10.42 4.13a.65.65 0 01-.19.04z",
      fill: "#fff"
    }), o.default.createElement("path", {
      d: "M11.07 12.15a.5.5 0 01-.5-.5V1.83a.5.5 0 01.5-.5.51.51 0 01.5.5v9.82a.5.5 0 01-.5.5z",
      fill: "#fff"
    }), o.default.createElement("path", {
      d: "M15.12 5.23a.51.51 0 01-.36-.15l-3.69-3.7-3.7 3.7a.5.5 0 01-.71-.71l4.05-4a.51.51 0 01.71 0l4.05 4.05a.5.5 0 010 .71.49.49 0 01-.35.1zM11.07 21.83a.5.5 0 01-.5-.5v-6.65a.5.5 0 01.5-.5.5.5 0 01.5.5v6.65a.51.51 0 01-.5.5z",
      fill: "#fff"
    }))));
  };
  var r,
    i = n(0),
    o = (r = i) && r.__esModule ? r : {
      default: r
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      width: e.width,
      height: e.height,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg"
    }, i.default.createElement("path", {
      className: "a",
      d: "M12.5,2.5H20a.5.5,0,0,1,.5.5V21a.5.5,0,0,1-.5.5H12.5"
    }), i.default.createElement("path", {
      className: "a",
      d: "M3.5,21.222a.5.5,0,0,0,.392.488l8,1.778A.5.5,0,0,0,12.5,23V1a.5.5,0,0,0-.608-.488l-8,1.778a.5.5,0,0,0-.392.488Z"
    }), i.default.createElement("circle", {
      className: "a",
      cx: "9",
      cy: "12",
      r: "1.5"
    }));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  };
  t.default = function (e) {
    return o.default.createElement("svg", a({
      viewBox: "0 0 22.2 22.2"
    }, e), o.default.createElement("title", null, "menu"), o.default.createElement("g", {
      "data-name": "Layer 2"
    }, o.default.createElement("g", {
      "data-name": "Layer 1"
    }, o.default.createElement("path", {
      fill: "none",
      d: "M0 0h22.2v22.2H0z"
    }), o.default.createElement("circle", {
      cx: 2.33,
      cy: 17.95,
      r: 1.82,
      fill: "#fff",
      opacity: .25
    }), o.default.createElement("path", {
      d: "M4.15 11.09a1.82 1.82 0 11-1.82-1.82 1.83 1.83 0 011.82 1.82z",
      fill: "#fff",
      opacity: .25
    }), o.default.createElement("circle", {
      cx: 2.33,
      cy: 4.25,
      r: 1.82,
      fill: "#fff",
      opacity: .25
    }), o.default.createElement("path", {
      d: "M2.33 6.58a2.32 2.32 0 112.32-2.33 2.34 2.34 0 01-2.32 2.33zm0-3.64a1.32 1.32 0 100 2.64 1.32 1.32 0 100-2.64zM7.56 3.75H22.2v1H7.56zM2.33 13.42a2.33 2.33 0 112.32-2.33 2.32 2.32 0 01-2.32 2.33zm0-3.65a1.33 1.33 0 101.32 1.32 1.33 1.33 0 00-1.32-1.32zM7.56 10.6H22.2v1H7.56zM2.33 20.27a2.32 2.32 0 112.32-2.33 2.34 2.34 0 01-2.32 2.33zm0-3.64a1.32 1.32 0 100 2.64 1.32 1.32 0 100-2.64zM7.56 17.44H22.2v1H7.56z",
      fill: "#fff"
    }))));
  };
  var r,
    i = n(0),
    o = (r = i) && r.__esModule ? r : {
      default: r
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      width: e.width,
      height: e.height,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "feather feather-shopping-cart"
    }, i.default.createElement("circle", {
      cx: "9",
      cy: "21",
      r: "1"
    }), i.default.createElement("circle", {
      cx: "20",
      cy: "21",
      r: "1"
    }), i.default.createElement("path", {
      d: "M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"
    }));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      width: e.width,
      height: e.height,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2"
    }, i.default.createElement("path", {
      d: "M29 17 L29 28 3 28 3 17 M2 8 L30 8 30 16 C30 16 24 20 16 20 8 20 2 16 2 16 L2 8 Z M16 22 L16 18 M20 8 C20 8 20 4 16 4 12 4 12 8 12 8"
    }));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      width: e.width,
      height: e.height,
      viewBox: "0 0 18 20",
      xmlns: "http://www.w3.org/2000/svg"
    }, i.default.createElement("g", {
      id: "Icons",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd"
    }, i.default.createElement("g", {
      id: "Rounded",
      transform: "translate(-817.000000, -4100.000000)"
    }, i.default.createElement("g", {
      id: "Social",
      transform: "translate(100.000000, 4044.000000)"
    }, i.default.createElement("g", {
      id: "-Round-/-Social-/-share",
      transform: "translate(714.000000, 54.000000)"
    }, i.default.createElement("g", null, i.default.createElement("polygon", {
      id: "Path",
      points: "0 0 24 0 24 24 0 24"
    }), i.default.createElement("path", {
      d: "M18,16.08 C17.24,16.08 16.56,16.38 16.04,16.85 L8.91,12.7 C8.96,12.47 9,12.24 9,12 C9,11.76 8.96,11.53 8.91,11.3 L15.96,7.19 C16.5,7.69 17.21,8 18,8 C19.66,8 21,6.66 21,5 C21,3.34 19.66,2 18,2 C16.34,2 15,3.34 15,5 C15,5.24 15.04,5.47 15.09,5.7 L8.04,9.81 C7.5,9.31 6.79,9 6,9 C4.34,9 3,10.34 3,12 C3,13.66 4.34,15 6,15 C6.79,15 7.5,14.69 8.04,14.19 L15.16,18.35 C15.11,18.56 15.08,18.78 15.08,19 C15.08,20.61 16.39,21.92 18,21.92 C19.61,21.92 20.92,20.61 20.92,19 C20.92,17.39 19.61,16.08 18,16.08 Z",
      id: "🔹-Icon-Color",
      fill: "#1D1D1D"
    })))))));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      width: e.width,
      height: e.height,
      viewBox: "0 0 256 248",
      xmlns: "http://www.w3.org/2000/svg"
    }, i.default.createElement("g", null, i.default.createElement("g", null, i.default.createElement("path", {
      d: "M50.1996332,0.0921704986 L255.88951,41.7086408 L214.271911,247.404093 L8.58203488,205.787623 L50.1996332,0.0921704986 L50.1996332,0.0921704986 Z",
      fill: "#512833"
    }), i.default.createElement("path", {
      d: "M24.1706512,9.17308483 L233.053068,29.4464109 L212.779592,238.330372 L3.8971752,218.057046 L24.1706512,9.17308483 L24.1706512,9.17308483 Z",
      fill: "#934358"
    }), i.default.createElement("rect", {
      fill: "#E5637C",
      x: "0.182044444",
      y: "18.8250505",
      width: "209.869317",
      height: "209.869317"
    })), i.default.createElement("path", {
      d: "M72.5690182,162.917366 C72.5690182,161.676671 73.3442586,159.810198 74.9004283,157.322085 C76.4534949,154.835523 77.8529616,153.591725 79.0972768,153.591725 C79.2193293,153.591725 80.2164364,154.18337 82.0818747,155.364073 C83.946796,156.546844 86.6195394,157.72703 90.1021737,158.907733 C93.5822222,160.091022 97.7790707,160.680081 102.692719,160.680081 C107.603782,160.680081 111.645996,159.280614 114.816776,156.483232 C117.988073,153.685333 119.573721,149.893947 119.573721,145.105455 C119.573721,140.319547 118.174255,136.589188 115.376356,133.913341 C112.577939,131.241115 107.01162,128.723006 98.6820525,126.359531 C90.349899,123.99916 84.3196768,120.983014 80.5893172,117.313164 C76.8594747,113.646933 74.9935192,108.07958 74.9935192,100.618861 C74.9935192,93.1581414 77.8524444,86.9096727 83.573398,81.8734545 C89.2912485,76.8372364 96.753002,74.3191273 105.956073,74.3191273 C112.298149,74.3191273 117.955491,75.128501 122.930683,76.7436283 C127.902772,78.3618586 130.390885,80.1657535 130.390885,82.1532444 C130.390885,83.7704404 129.674085,85.8546424 128.246691,88.4017131 C126.81516,90.9518869 125.5424,92.2256808 124.422723,92.2256808 C124.297051,92.2256808 123.489745,91.8522828 121.998222,91.106004 C117.768792,88.8671677 113.012364,87.7485253 107.728937,87.7485253 C102.441891,87.7485253 98.3386505,88.8387232 95.4181818,91.0129131 C92.4946101,93.1896889 91.0346343,96.0196525 91.0346343,99.499701 C91.0346343,102.982335 92.1217293,105.718691 94.2990222,107.706699 C96.4732121,109.69781 100.17461,111.501705 105.39701,113.115798 C117.083539,116.724105 125.011265,120.669608 129.178634,124.960065 C133.343935,129.250521 135.42762,135.717754 135.42762,144.358659 C135.42762,153.003701 132.349931,160.119984 126.194036,165.716299 C120.038659,171.31158 112.67103,174.109479 104.091152,174.109479 C95.5112727,174.109479 88.1105455,172.835685 81.8946586,170.285511 C75.6761859,167.73844 72.5690182,165.28084 72.5690182,162.917366 L72.5690182,162.917366 Z",
      fill: "#FFFFFF"
    })));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      height: e.height,
      viewBox: "0 0 24 24",
      fill: e.color,
      width: e.width
    }, i.default.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    }), i.default.createElement("path", {
      d: "M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
    }));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  };
  t.default = function (e) {
    return o.default.createElement("svg", a({
      viewBox: "0 0 22.2 22.2"
    }, e), o.default.createElement("title", null, "workflow"), o.default.createElement("g", {
      "data-name": "Layer 2"
    }, o.default.createElement("g", {
      "data-name": "Layer 1"
    }, o.default.createElement("path", {
      fill: "none",
      d: "M0 0h22.2v22.2H0z"
    }), o.default.createElement("path", {
      d: "M6.19 17.3a2.76 2.76 0 11-2.76-2.78 2.77 2.77 0 012.76 2.78zM12.93 2.81a2.69 2.69 0 01.78 1.9 2.69 2.69 0 01-5.38 0 2.69 2.69 0 014.6-1.9zM21.52 17.3a2.76 2.76 0 11-2.76-2.78 2.77 2.77 0 012.76 2.78z",
      fill: "#fff",
      opacity: .25
    }), o.default.createElement("path", {
      d: "M3.43 20.58a3.28 3.28 0 010-6.56 3.28 3.28 0 010 6.56zm0-5.56a2.28 2.28 0 102.26 2.28A2.27 2.27 0 003.43 15zM18.76 20.58A3.28 3.28 0 1122 17.3a3.27 3.27 0 01-3.24 3.28zm0-5.56A2.28 2.28 0 1021 17.3a2.27 2.27 0 00-2.24-2.3zM11 8a3.23 3.23 0 113.19-3.24A3.19 3.19 0 0111 8zm0-5.43a2.22 2.22 0 102.19 2.24A2.19 2.19 0 0011 2.52zM19.26 12.95h-1V11.5H3.93v1.45h-1V10.5h16.33v2.45z",
      fill: "#fff"
    }), o.default.createElement("path", {
      fill: "#fff",
      d: "M10.52 9.24h1V11h-1z"
    }))));
  };
  var r,
    i = n(0),
    o = (r = i) && r.__esModule ? r : {
      default: r
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  };
  t.default = function (e) {
    return o.default.createElement("svg", a({
      viewBox: "0 0 22.2 22.2"
    }, e), o.default.createElement("title", null, "templates"), o.default.createElement("g", {
      "data-name": "Layer 2"
    }, o.default.createElement("g", {
      "data-name": "Layer 1"
    }, o.default.createElement("path", {
      fill: "none",
      d: "M0 0h22.2v22.2H0z"
    }), o.default.createElement("path", {
      d: "M6.37 2.42v17.36a.65.65 0 01-.65.64H1.85a.64.64 0 01-.65-.64V2.42a.64.64 0 01.65-.64h3.87a.65.65 0 01.65.64zM21 9.71v10.07a.64.64 0 01-.65.64H10.27a.64.64 0 01-.65-.64V9.71a.65.65 0 01.65-.66h10.07a.65.65 0 01.66.66z",
      fill: "#fff",
      opacity: .25
    }), o.default.createElement("path", {
      d: "M5.72 20.92H1.85A1.15 1.15 0 01.7 19.79V2.42a1.16 1.16 0 011.15-1.15h3.87a1.16 1.16 0 011.15 1.15v17.37a1.15 1.15 0 01-1.15 1.13zM1.85 2.27a.15.15 0 00-.15.15v17.37a.14.14 0 00.15.13h3.87a.14.14 0 00.15-.13V2.42a.16.16 0 00-.15-.15zM20.35 6.08H10.27a1.15 1.15 0 01-1.15-1.14V2.42a1.16 1.16 0 011.15-1.15h10.08a1.16 1.16 0 011.15 1.15v2.52a1.15 1.15 0 01-1.15 1.14zM10.27 2.27a.15.15 0 00-.15.15v2.52a.15.15 0 00.15.14h10.08a.15.15 0 00.15-.14V2.42a.15.15 0 00-.15-.15zM20.34 20.92H10.27a1.15 1.15 0 01-1.15-1.13V9.71a1.15 1.15 0 011.15-1.15h10.07a1.15 1.15 0 011.15 1.15v10.08a1.15 1.15 0 01-1.15 1.13zM10.27 9.56a.15.15 0 00-.15.15v10.08a.14.14 0 00.15.13h10.07a.14.14 0 00.15-.13V9.71a.15.15 0 00-.15-.15z",
      fill: "#fff"
    }))));
  };
  var r,
    i = n(0),
    o = (r = i) && r.__esModule ? r : {
      default: r
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  };
  t.default = function (e) {
    return o.default.createElement("svg", a({
      viewBox: "0 0 22.2 22.2"
    }, e), o.default.createElement("title", null, "pages"), o.default.createElement("g", {
      "data-name": "Layer 2"
    }, o.default.createElement("g", {
      "data-name": "Layer 1"
    }, o.default.createElement("path", {
      fill: "none",
      d: "M0 0h22.2v22.2H0z"
    }), o.default.createElement("path", {
      d: "M11 13.77l-7.55-4.7-2-1.25a.87.87 0 010-1.5L10.58.8a.91.91 0 011 0l9.21 5.52a.87.87 0 010 1.5l-2 1.25-7.79 4.7",
      fill: "#fff",
      opacity: .25
    }), o.default.createElement("path", {
      d: "M11.11 14.08a1.44 1.44 0 01-.75-.21l-9.2-5.63a1.38 1.38 0 01-.67-1.17 1.36 1.36 0 01.67-1.17L10.33.38a1.43 1.43 0 011.49 0L21 5.9a1.34 1.34 0 01.68 1.17A1.37 1.37 0 0121 8.24l-9.18 5.63a1.44 1.44 0 01-.71.21zm0-12.93a.39.39 0 00-.23.07L1.67 6.74a.4.4 0 00-.19.33.37.37 0 00.19.33l9.2 5.6a.46.46 0 00.48 0l9.18-5.6a.37.37 0 00.19-.32.39.39 0 00-.2-.34l-9.21-5.52a.42.42 0 00-.24-.07z",
      fill: "#fff"
    }), o.default.createElement("path", {
      d: "M11.11 18.07a1.4 1.4 0 01-.76-.22l-9.19-5.64A1.33 1.33 0 01.5 11a1.36 1.36 0 01.67-1.17L2.71 9A1.41 1.41 0 014.2 9l6.67 4a.46.46 0 00.48 0L18 9a1.45 1.45 0 011.49 0l1.51.87a1.38 1.38 0 01.67 1.18 1.41 1.41 0 01-.67 1.17l-9.18 5.63a1.36 1.36 0 01-.71.22zM3.44 9.72a.36.36 0 00-.22.07l-1.54.92a.39.39 0 00-.2.34.4.4 0 00.19.33l9.2 5.62a.44.44 0 00.47 0l9.19-5.65a.35.35 0 00.19-.32.38.38 0 00-.19-.34L19 9.79a.46.46 0 00-.48 0l-6.65 4.08a1.44 1.44 0 01-1.5 0L3.69 9.79a.59.59 0 00-.25-.07z",
      fill: "#fff"
    }), o.default.createElement("path", {
      d: "M11.11 22a1.44 1.44 0 01-.75-.21l-9.2-5.59a1.36 1.36 0 010-2.34l1.56-.93a1.45 1.45 0 011.49 0L10.87 17a.44.44 0 00.47 0l6.79-4.15a1.38 1.38 0 011.35.07l1.54.92A1.37 1.37 0 0121.7 15a1.35 1.35 0 01-.7 1.2l-9.18 5.62a1.44 1.44 0 01-.71.18zm-7.64-8.29a.39.39 0 00-.23.07l-1.57.92a.39.39 0 000 .67l9.2 5.63a.51.51 0 00.48 0l9.17-5.62a.39.39 0 00.2-.34.38.38 0 00-.2-.33L19 13.78a.43.43 0 00-.46 0l-6.65 4.07a1.42 1.42 0 01-1.51 0L3.7 13.77a.46.46 0 00-.23-.06z",
      fill: "#fff"
    }))));
  };
  var r,
    i = n(0),
    o = (r = i) && r.__esModule ? r : {
      default: r
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      height: e.height,
      viewBox: "0 0 24 24",
      width: e.width,
      fill: e.color
    }, i.default.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    }), i.default.createElement("path", {
      d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
    }));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  };
  t.default = function (e) {
    return o.default.createElement("svg", a({
      id: "prefix__Layer_1",
      x: 0,
      y: 0,
      viewBox: "0 0 23 21",
      xmlSpace: "preserve"
    }, e), o.default.createElement("title", null, "banners"), o.default.createElement("style", null, ".prefix__st0{fill:none;stroke:#fff;stroke-miterlimit:10}"), o.default.createElement("path", {
      className: "prefix__st0",
      d: "M22.5 2.89v15.23c0 1.32-1.07 2.38-2.39 2.38H2.88C1.56 20.5.5 19.44.5 18.12V2.89C.5 1.57 1.56.5 2.88.5h17.23a2.39 2.39 0 012.39 2.39z"
    }), o.default.createElement("path", {
      d: "M20.11.49H2.88C1.56.49.5 1.56.5 2.88v11.85l7.67-5.79 5.97 5.78 4.01-3.53 4.35 4.34V2.88A2.39 2.39 0 0020.11.49zm-5.97 8.45a2.61 2.61 0 01-2.61-2.6c0-1.44 1.17-2.61 2.61-2.61s2.61 1.17 2.61 2.61c0 1.43-1.17 2.6-2.61 2.6z",
      opacity: .25,
      fill: "#fff"
    }), o.default.createElement("path", {
      className: "prefix__st0",
      d: "M11.53 6.35c0-1.44 1.17-2.61 2.61-2.61s2.61 1.17 2.61 2.61a2.61 2.61 0 01-5.22 0zM22.5 15.53v2.58c0 1.32-1.07 2.38-2.39 2.38H2.88C1.56 20.49.5 19.43.5 18.11v-3.38l7.67-5.79 5.97 5.78 4.01-3.53 4.35 4.34zM20.11 20.49l-5.97-5.77"
    }), o.default.createElement("path", {
      className: "prefix__st0",
      d: "M16.75 6.35a2.61 2.61 0 01-5.22 0c0-1.44 1.17-2.61 2.61-2.61s2.61 1.17 2.61 2.61z"
    }));
  };
  var r,
    i = n(0),
    o = (r = i) && r.__esModule ? r : {
      default: r
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  };
  t.default = function (e) {
    return o.default.createElement("svg", a({
      viewBox: "0 0 22.2 22.2"
    }, e), o.default.createElement("title", null, "pulish"), o.default.createElement("g", {
      "data-name": "Layer 2"
    }, o.default.createElement("g", {
      "data-name": "Layer 1"
    }, o.default.createElement("path", {
      fill: "none",
      d: "M0 0h22.2v22.2H0z"
    }), o.default.createElement("path", {
      fill: "#fff",
      d: "M21.5 10.55v6.65l-10.43 4.12L.7 17.2v-6.65l10.37 4.13 10.43-4.13z",
      opacity: .25
    }), o.default.createElement("path", {
      d: "M11.07 15.18a.39.39 0 01-.18 0L.52 11a.48.48 0 01-.31-.47.5.5 0 01.32-.46l5.83-2.16A.5.5 0 017 8.2a.49.49 0 01-.29.64L2.1 10.56l9 3.58 9-3.58-4.67-1.73a.5.5 0 01-.3-.64.49.49 0 01.64-.29l5.9 2.18a.52.52 0 01.33.46.5.5 0 01-.32.47l-10.42 4.13a.43.43 0 01-.19.04z",
      fill: "#fff"
    }), o.default.createElement("path", {
      d: "M11.07 21.83a.58.58 0 01-.18 0L.52 17.66a.5.5 0 01-.31-.47v-6.64a.5.5 0 01.5-.5.5.5 0 01.5.5v6.31l9.86 3.93L21 16.85v-6.3a.5.5 0 01.5-.5.5.5 0 01.5.5v6.64a.51.51 0 01-.32.47l-10.42 4.13a.65.65 0 01-.19.04z",
      fill: "#fff"
    }), o.default.createElement("path", {
      d: "M11.07 12.15a.5.5 0 01-.5-.5V1.83a.5.5 0 01.5-.5.51.51 0 01.5.5v9.82a.5.5 0 01-.5.5z",
      fill: "#fff"
    }), o.default.createElement("path", {
      d: "M15.12 5.23a.51.51 0 01-.36-.15l-3.69-3.7-3.7 3.7a.5.5 0 01-.71-.71l4.05-4a.51.51 0 01.71 0l4.05 4.05a.5.5 0 010 .71.49.49 0 01-.35.1zM11.07 21.83a.5.5 0 01-.5-.5v-6.65a.5.5 0 01.5-.5.5.5 0 01.5.5v6.65a.51.51 0 01-.5.5z",
      fill: "#fff"
    }))));
  };
  var r,
    i = n(0),
    o = (r = i) && r.__esModule ? r : {
      default: r
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      className: "bi bi-plus-circle-fill",
      viewBox: "0 0 64 64",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      width: e.width,
      height: e.height,
      enableBackground: "new 0 0 64 64"
    }, i.default.createElement("g", null, i.default.createElement("line", {
      fill: "none",
      stroke: "#000000",
      strokeWidth: "2",
      strokeMiterlimit: "10",
      x1: "32",
      y1: "50",
      x2: "32",
      y2: "14"
    }), i.default.createElement("line", {
      fill: "none",
      stroke: "#000000",
      strokeWidth: "2",
      strokeMiterlimit: "10",
      x1: "14",
      y1: "32",
      x2: "50",
      y2: "32"
    })));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      width: e.width,
      height: e.height,
      viewBox: "0 0 475.082 475.081",
      xmlns: "http://www.w3.org/2000/svg",
      enableBackground: "new 0 0 475.082 475.081",
      x: "0px",
      y: "0px"
    }, i.default.createElement("g", null, i.default.createElement("path", {
      d: "M461.667,49.963c-8.949-8.947-19.698-13.418-32.265-13.418H45.682c-12.562,0-23.317,4.471-32.264,13.418\r C4.473,58.912,0,69.663,0,82.228V392.86c0,12.566,4.473,23.309,13.418,32.261c8.947,8.949,19.701,13.415,32.264,13.415h383.72\r c12.566,0,23.315-4.466,32.265-13.415c8.945-8.952,13.415-19.701,13.415-32.261V82.228\r C475.082,69.663,470.612,58.909,461.667,49.963z M146.183,392.85c0,2.673-0.859,4.856-2.574,6.571\r c-1.712,1.711-3.899,2.562-6.567,2.562h-91.36c-2.662,0-4.853-0.852-6.567-2.562c-1.713-1.715-2.568-3.898-2.568-6.571V338.03\r c0-2.669,0.855-4.853,2.568-6.56c1.714-1.719,3.905-2.574,6.567-2.574h91.363c2.667,0,4.858,0.855,6.567,2.574\r c1.711,1.707,2.57,3.891,2.57,6.56V392.85z M146.183,283.221c0,2.663-0.859,4.854-2.574,6.564\r c-1.712,1.714-3.899,2.569-6.567,2.569h-91.36c-2.662,0-4.853-0.855-6.567-2.569c-1.713-1.711-2.568-3.901-2.568-6.564v-54.819\r c0-2.664,0.855-4.854,2.568-6.567c1.714-1.709,3.905-2.565,6.567-2.565h91.363c2.667,0,4.854,0.855,6.567,2.565\r c1.711,1.713,2.57,3.903,2.57,6.567V283.221z M146.183,173.587c0,2.666-0.859,4.853-2.574,6.567\r c-1.712,1.709-3.899,2.568-6.567,2.568h-91.36c-2.662,0-4.853-0.859-6.567-2.568c-1.713-1.715-2.568-3.901-2.568-6.567V118.77\r c0-2.666,0.855-4.856,2.568-6.567c1.714-1.713,3.905-2.568,6.567-2.568h91.363c2.667,0,4.854,0.855,6.567,2.568\r c1.711,1.711,2.57,3.901,2.57,6.567V173.587z M292.362,392.85c0,2.673-0.855,4.856-2.563,6.571c-1.711,1.711-3.9,2.562-6.57,2.562\r H191.86c-2.663,0-4.853-0.852-6.567-2.562c-1.713-1.715-2.568-3.898-2.568-6.571V338.03c0-2.669,0.855-4.853,2.568-6.56\r c1.714-1.719,3.904-2.574,6.567-2.574h91.365c2.669,0,4.859,0.855,6.57,2.574c1.704,1.707,2.56,3.891,2.56,6.56v54.819H292.362z\r M292.362,283.221c0,2.663-0.855,4.854-2.563,6.564c-1.711,1.714-3.9,2.569-6.57,2.569H191.86c-2.663,0-4.853-0.855-6.567-2.569\r c-1.713-1.711-2.568-3.901-2.568-6.564v-54.819c0-2.664,0.855-4.854,2.568-6.567c1.714-1.709,3.904-2.565,6.567-2.565h91.365\r c2.669,0,4.859,0.855,6.57,2.565c1.704,1.713,2.56,3.903,2.56,6.567v54.819H292.362z M292.362,173.587\r c0,2.666-0.855,4.853-2.563,6.567c-1.711,1.709-3.9,2.568-6.57,2.568H191.86c-2.663,0-4.853-0.859-6.567-2.568\r c-1.713-1.715-2.568-3.901-2.568-6.567V118.77c0-2.666,0.855-4.856,2.568-6.567c1.714-1.713,3.904-2.568,6.567-2.568h91.365\r c2.669,0,4.859,0.855,6.57,2.568c1.704,1.711,2.56,3.901,2.56,6.567v54.817H292.362z M438.536,392.85\r c0,2.673-0.855,4.856-2.562,6.571c-1.718,1.711-3.908,2.562-6.571,2.562h-91.354c-2.673,0-4.862-0.852-6.57-2.562\r c-1.711-1.715-2.56-3.898-2.56-6.571V338.03c0-2.669,0.849-4.853,2.56-6.56c1.708-1.719,3.897-2.574,6.57-2.574h91.354\r c2.663,0,4.854,0.855,6.571,2.574c1.707,1.707,2.562,3.891,2.562,6.56V392.85z M438.536,283.221c0,2.663-0.855,4.854-2.562,6.564\r c-1.718,1.714-3.908,2.569-6.571,2.569h-91.354c-2.673,0-4.862-0.855-6.57-2.569c-1.711-1.711-2.56-3.901-2.56-6.564v-54.819\r c0-2.664,0.849-4.854,2.56-6.567c1.708-1.709,3.897-2.565,6.57-2.565h91.354c2.663,0,4.854,0.855,6.571,2.565\r c1.707,1.713,2.562,3.903,2.562,6.567V283.221z M438.536,173.587c0,2.666-0.855,4.853-2.562,6.567\r c-1.718,1.709-3.908,2.568-6.571,2.568h-91.354c-2.673,0-4.862-0.859-6.57-2.568c-1.711-1.715-2.56-3.901-2.56-6.567V118.77\r c0-2.666,0.849-4.856,2.56-6.567c1.708-1.713,3.897-2.568,6.57-2.568h91.354c2.663,0,4.854,0.855,6.571,2.568\r c1.707,1.711,2.562,3.901,2.562,6.567V173.587z"
    })), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      height: e.height,
      viewBox: "0 0 15 20",
      width: e.width,
      className: "bi bi-menu-button-wide-fill",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg"
    }, i.default.createElement("path", {
      fillRule: "evenodd",
      d: "M14 7H2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zM2 6a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H2z"
    }), i.default.createElement("path", {
      fillRule: "evenodd",
      d: "M15 11H1v-1h14v1zM2 12.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM1.5 0A1.5 1.5 0 0 0 0 1.5v2A1.5 1.5 0 0 0 1.5 5h13A1.5 1.5 0 0 0 16 3.5v-2A1.5 1.5 0 0 0 14.5 0h-13zm1 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zm9.927.427l.396.396a.25.25 0 0 0 .354 0l.396-.396A.25.25 0 0 0 13.396 2h-.792a.25.25 0 0 0-.177.427z"
    }));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      height: e.height,
      viewBox: "0 0 15 20",
      width: e.width,
      className: "bi bi-menu-up",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg"
    }, i.default.createElement("path", {
      fillRule: "evenodd",
      d: "M15 3.207v9a1 1 0 0 1-1 1h-3.586A2 2 0 0 0 9 13.793l-1 1-1-1a2 2 0 0 0-1.414-.586H2a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zm-13 11a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-3.586a1 1 0 0 0-.707.293l-1.353 1.354a.5.5 0 0 1-.708 0L6.293 14.5a1 1 0 0 0-.707-.293H2z"
    }), i.default.createElement("path", {
      fillRule: "evenodd",
      d: "M15 5.207H1v1h14v-1zm0 4H1v1h14v-1zm-13-5.5a.5.5 0 0 0 .5.5h6a.5.5 0 1 0 0-1h-6a.5.5 0 0 0-.5.5zm0 4a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 0-1h-11a.5.5 0 0 0-.5.5zm0 4a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 0-1h-8a.5.5 0 0 0-.5.5z"
    }));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: e.width,
      height: e.height,
      viewBox: "0 0 24 24"
    }, i.default.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    }), i.default.createElement("path", {
      d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h10v4h8v10z"
    }));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  };
  t.default = function (e) {
    return o.default.createElement("svg", a({
      width: "1em",
      height: "1em",
      viewBox: "0 0 16 16",
      className: "bi bi-card-list",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg"
    }, e), o.default.createElement("path", {
      fillRule: "evenodd",
      d: "M14.5 3h-13a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"
    }), o.default.createElement("path", {
      fillRule: "evenodd",
      d: "M5 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 8zm0-2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0 5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5z"
    }), o.default.createElement("circle", {
      cx: "3.5",
      cy: "5.5",
      r: ".5"
    }), o.default.createElement("circle", {
      cx: "3.5",
      cy: "8",
      r: ".5"
    }), o.default.createElement("circle", {
      cx: "3.5",
      cy: "10.5",
      r: ".5"
    }));
  };
  var r,
    i = n(0),
    o = (r = i) && r.__esModule ? r : {
      default: r
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  };
  t.default = function (e) {
    return o.default.createElement("svg", a({
      width: "1em",
      height: "1em",
      viewBox: "0 0 16 16",
      className: "bi bi-card-text",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg"
    }, e), o.default.createElement("path", {
      fillRule: "evenodd",
      d: "M14.5 3h-13a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zm-13-1A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13z"
    }), o.default.createElement("path", {
      fillRule: "evenodd",
      d: "M3 5.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 8zm0 2.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"
    }));
  };
  var r,
    i = n(0),
    o = (r = i) && r.__esModule ? r : {
      default: r
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: e.width,
      height: e.height,
      viewBox: "0 0 24 24"
    }, i.default.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    }), i.default.createElement("path", {
      d: "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"
    }));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  };
  t.default = function (e) {
    return o.default.createElement("svg", a({
      viewBox: "0 0 16 16",
      className: "bi bi-link",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      x: 0,
      y: 0
    }, e), o.default.createElement("path", {
      d: "M6.354 5.5H4a3 3 0 0 0 0 6h3a3 3 0 0 0 2.83-4H9c-.086 0-.17.01-.25.031A2 2 0 0 1 7 10.5H4a2 2 0 1 1 0-4h1.535c.218-.376.495-.714.82-1z"
    }), o.default.createElement("path", {
      d: "M9 5.5a3 3 0 0 0-2.83 4h1.098A2 2 0 0 1 9 6.5h3a2 2 0 1 1 0 4h-1.535a4.02 4.02 0 0 1-.82 1H12a3 3 0 1 0 0-6H9z"
    }));
  };
  var r,
    i = n(0),
    o = (r = i) && r.__esModule ? r : {
      default: r
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  };
  t.default = function (e) {
    return o.default.createElement("svg", a({}, e, {
      viewBox: "0 0 512 512",
      xmlns: "http://www.w3.org/2000/svg"
    }), o.default.createElement("path", {
      d: "m512 312v-160h-230v62h-152v-54h100v-160h-230v160h90v294h192v58h230v-160h-230v62h-152v-160h152v58zm-472-272h150v80h-150zm282 352h150v80h-150zm0-200h150v80h-150zm0 0"
    }));
  };
  var r,
    i = n(0),
    o = (r = i) && r.__esModule ? r : {
      default: r
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  };
  t.default = function (e) {
    return o.default.createElement("svg", a({
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      xlink: "http://www.w3.org/1999/xlink",
      viewBox: "0 0 16 16"
    }, e), o.default.createElement("path", {
      d: "M0 4v8h16v-8h-16zM15 11h-14v-4h14v4z"
    }), o.default.createElement("path", {
      d: "M0 0h16v3h-16v-3z"
    }), o.default.createElement("path", {
      d: "M0 13h16v3h-16v-3z"
    }));
  };
  var r,
    i = n(0),
    o = (r = i) && r.__esModule ? r : {
      default: r
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      enableBackground: "new 0 0 24 24",
      width: e.width,
      height: e.height,
      viewBox: "0 0 24 24"
    }, i.default.createElement("g", null, i.default.createElement("rect", {
      fill: "none",
      height: e.height,
      width: e.width
    })), i.default.createElement("g", null, i.default.createElement("g", null, i.default.createElement("path", {
      d: "M14,2H6C4.9,2,4,2.9,4,4v16c0,1.1,0.89,2,1.99,2H18c1.1,0,2-0.9,2-2V8L14,2z M15.04,19.45l-1.88-1.88 c-1.33,0.71-3.01,0.53-4.13-0.59c-1.37-1.37-1.37-3.58,0-4.95c1.37-1.37,3.58-1.37,4.95,0c1.12,1.12,1.31,2.8,0.59,4.13l1.88,1.88 L15.04,19.45z M13,9V3.5L18.5,9H13z"
    }), i.default.createElement("circle", {
      cx: "11.5",
      cy: "14.5",
      r: "1.5"
    }))));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
  t.default = function () {
    return i.default.createElement("svg", {
      width: "21",
      height: "24",
      viewBox: "0 0 21 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, i.default.createElement("title", null, "Forms"), i.default.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.12855 1.62855C1.05994 1.69716 1 1.81362 1 2V6C1 6.18638 1.05994 6.30284 1.12855 6.37145C1.19716 6.44006 1.31362 6.5 1.5 6.5H19.5C19.7919 6.5 20 6.25691 20 6V2C20 1.81362 19.9401 1.69716 19.8714 1.62855C19.8028 1.55994 19.6864 1.5 19.5 1.5H1.5C1.31362 1.5 1.19716 1.55994 1.12855 1.62855ZM0.421447 0.921447C0.702836 0.640057 1.08638 0.5 1.5 0.5H19.5C19.9136 0.5 20.2972 0.640057 20.5786 0.921447C20.8599 1.20284 21 1.58638 21 2V6C21 6.74309 20.4081 7.5 19.5 7.5H1.5C1.08638 7.5 0.702836 7.35994 0.421447 7.07855C0.140057 6.79716 0 6.41362 0 6V2C0 1.58638 0.140057 1.20284 0.421447 0.921447Z",
      fill: "white"
    }), i.default.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.12855 9.9286C1.05994 9.99721 1 10.1137 1 10.3V14.3C1 14.4864 1.05994 14.6029 1.12855 14.6715C1.19716 14.7401 1.31362 14.8 1.5 14.8H19.5C19.6864 14.8 19.8028 14.7401 19.8714 14.6715C19.9401 14.6029 20 14.4864 20 14.3V10.3C20 10.1137 19.9401 9.99721 19.8714 9.9286C19.8028 9.85999 19.6864 9.80005 19.5 9.80005H1.5C1.31362 9.80005 1.19716 9.85999 1.12855 9.9286ZM0.421447 9.2215C0.702836 8.94011 1.08638 8.80005 1.5 8.80005H19.5C19.9136 8.80005 20.2972 8.94011 20.5786 9.2215C20.8599 9.50289 21 9.88642 21 10.3V14.3C21 14.7137 20.8599 15.0972 20.5786 15.3786C20.2972 15.66 19.9136 15.8 19.5 15.8H1.5C1.08638 15.8 0.702836 15.66 0.421447 15.3786C0.140057 15.0972 0 14.7137 0 14.3V10.3C0 9.88642 0.140057 9.50289 0.421447 9.2215Z",
      fill: "white"
    }), i.default.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.22865 18.3285C8.16004 18.3971 8.1001 18.5136 8.1001 18.7V21.7C8.1001 21.8863 8.16004 22.0028 8.22865 22.0714C8.29726 22.14 8.41372 22.2 8.6001 22.2H19.5001C19.792 22.2 20.0001 21.9569 20.0001 21.7V18.7C20.0001 18.5136 19.9402 18.3971 19.8715 18.3285C19.8029 18.2599 19.6865 18.2 19.5001 18.2H8.6001C8.41372 18.2 8.29726 18.2599 8.22865 18.3285ZM7.52154 17.6214C7.80293 17.34 8.18647 17.2 8.6001 17.2H19.5001C19.9137 17.2 20.2973 17.34 20.5787 17.6214C20.86 17.9028 21.0001 18.2863 21.0001 18.7V21.7C21.0001 22.443 20.4082 23.2 19.5001 23.2H8.6001C8.18647 23.2 7.80293 23.0599 7.52154 22.7785C7.24015 22.4971 7.1001 22.1136 7.1001 21.7V18.7C7.1001 18.2863 7.24015 17.9028 7.52154 17.6214Z",
      fill: "white"
    }), i.default.createElement("path", {
      opacity: "0.25",
      d: "M19.5001 22.7H8.6001C8.0001 22.7 7.6001 22.3 7.6001 21.7V18.7C7.6001 18.1 8.0001 17.7 8.6001 17.7H19.5001C20.1001 17.7 20.5001 18.1 20.5001 18.7V21.7C20.5001 22.2 20.1001 22.7 19.5001 22.7Z",
      fill: "white"
    }), i.default.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.2002 5.60005V2.30005H3.2002V5.60005H2.2002Z",
      fill: "white"
    }));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
  t.default = function () {
    return i.default.createElement("svg", {
      width: "22",
      height: "24",
      viewBox: "0 0 22 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, i.default.createElement("title", null, "Forms"), i.default.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.62855 1.62855C1.55994 1.69716 1.5 1.81362 1.5 2V6C1.5 6.18638 1.55994 6.30284 1.62855 6.37145C1.69716 6.44006 1.81362 6.5 2 6.5H20C20.2919 6.5 20.5 6.25691 20.5 6V2C20.5 1.81362 20.4401 1.69716 20.3714 1.62855C20.3028 1.55994 20.1864 1.5 20 1.5H2C1.81362 1.5 1.69716 1.55994 1.62855 1.62855ZM0.921447 0.921447C1.20284 0.640057 1.58638 0.5 2 0.5H20C20.4136 0.5 20.7972 0.640057 21.0786 0.921447C21.3599 1.20284 21.5 1.58638 21.5 2V6C21.5 6.74309 20.9081 7.5 20 7.5H2C1.58638 7.5 1.20284 7.35994 0.921447 7.07855C0.640057 6.79716 0.5 6.41362 0.5 6V2C0.5 1.58638 0.640057 1.20284 0.921447 0.921447Z",
      fill: "#66BCFF"
    }), i.default.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.62855 9.9286C1.55994 9.99721 1.5 10.1137 1.5 10.3V14.3C1.5 14.4864 1.55994 14.6029 1.62855 14.6715C1.69716 14.7401 1.81362 14.8 2 14.8H20C20.1864 14.8 20.3028 14.7401 20.3714 14.6715C20.4401 14.6029 20.5 14.4864 20.5 14.3V10.3C20.5 10.1137 20.4401 9.99721 20.3714 9.9286C20.3028 9.85999 20.1864 9.80005 20 9.80005H2C1.81362 9.80005 1.69716 9.85999 1.62855 9.9286ZM0.921447 9.2215C1.20284 8.94011 1.58638 8.80005 2 8.80005H20C20.4136 8.80005 20.7972 8.94011 21.0786 9.2215C21.3599 9.50289 21.5 9.88642 21.5 10.3V14.3C21.5 14.7137 21.3599 15.0972 21.0786 15.3786C20.7972 15.66 20.4136 15.8 20 15.8H2C1.58638 15.8 1.20284 15.66 0.921447 15.3786C0.640057 15.0972 0.5 14.7137 0.5 14.3V10.3C0.5 9.88642 0.640057 9.50289 0.921447 9.2215Z",
      fill: "#66BCFF"
    }), i.default.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.72865 18.3285C8.66004 18.3971 8.6001 18.5136 8.6001 18.7V21.7C8.6001 21.8863 8.66004 22.0028 8.72865 22.0714C8.79726 22.14 8.91372 22.2 9.1001 22.2H20.0001C20.292 22.2 20.5001 21.9569 20.5001 21.7V18.7C20.5001 18.5136 20.4402 18.3971 20.3715 18.3285C20.3029 18.2599 20.1865 18.2 20.0001 18.2H9.1001C8.91372 18.2 8.79726 18.2599 8.72865 18.3285ZM8.02154 17.6214C8.30293 17.34 8.68647 17.2 9.1001 17.2H20.0001C20.4137 17.2 20.7973 17.34 21.0787 17.6214C21.36 17.9028 21.5001 18.2863 21.5001 18.7V21.7C21.5001 22.443 20.9082 23.2 20.0001 23.2H9.1001C8.68647 23.2 8.30293 23.0599 8.02154 22.7785C7.74015 22.4971 7.6001 22.1136 7.6001 21.7V18.7C7.6001 18.2863 7.74015 17.9028 8.02154 17.6214Z",
      fill: "#66BCFF"
    }), i.default.createElement("path", {
      opacity: "0.25",
      d: "M20.0001 22.7H9.1001C8.5001 22.7 8.1001 22.3 8.1001 21.7V18.7C8.1001 18.1 8.5001 17.7 9.1001 17.7H20.0001C20.6001 17.7 21.0001 18.1 21.0001 18.7V21.7C21.0001 22.2 20.6001 22.7 20.0001 22.7Z",
      fill: "#66BCFF"
    }), i.default.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.7002 5.60005V2.30005H3.7002V5.60005H2.7002Z",
      fill: "#66BCFF"
    }));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      xmlns: "http://www.w3.org/1999/xlink",
      viewBox: "0 0 100 50",
      width: e.width,
      height: e.height,
      fill: e.fill
    }, i.default.createElement("path", {
      d: "M100,0V50H0V0Z",
      onMouseEnter: e.onMouseEnter,
      onMouseLeave: e.onMouseLeave
    }));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      xmlns: "http://www.w3.org/1999/xlink",
      viewBox: "0 0 100 50",
      width: e.width,
      height: e.height,
      fill: e.fill
    }, i.default.createElement("path", {
      d: "M49,0V50H0V0Z M100,0V50H51V0Z",
      onMouseEnter: e.onMouseEnter,
      onMouseLeave: e.onMouseLeave
    }));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      xmlns: "http://www.w3.org/1999/xlink",
      viewBox: "0 0 100 50",
      width: e.width,
      height: e.height,
      fill: e.fill
    }, i.default.createElement("path", {
      d: "M32,0V50H0V0Z M66,0V50H34V0Z M100,0V50H68V0Z",
      onMouseEnter: e.onMouseEnter,
      onMouseLeave: e.onMouseLeave
    }));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      xmlns: "http://www.w3.org/1999/xlink",
      viewBox: "0 0 100 50",
      width: e.width,
      height: e.height,
      fill: e.fill
    }, i.default.createElement("path", {
      d: "M23.5,0V50H0V0Z M49,0V50H25.5V0Z M74.5,0V50H51V0Z M100,0V50H76.5V0Z",
      onMouseEnter: e.onMouseEnter,
      onMouseLeave: e.onMouseLeave
    }));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      xmlns: "http://www.w3.org/1999/xlink",
      viewBox: "0 0 100 50",
      width: e.width,
      height: e.height,
      fill: e.fill
    }, i.default.createElement("path", {
      d: "M18.4,0V50H0V0Z M38.8,0V50H20.4V0Z M59.2,0V50H40.8V0Z M79.6,0V50H61.2V0Z M100,0V50H81.6V0Z",
      onMouseEnter: e.onMouseEnter,
      onMouseLeave: e.onMouseLeave
    }));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      xmlns: "http://www.w3.org/1999/xlink",
      viewBox: "0 0 100 50",
      width: e.width,
      height: e.height,
      fill: e.fill
    }, i.default.createElement("path", {
      d: "M32.6667,0V50H0V0Z M100,0V50H34.6667V0Z",
      onMouseEnter: e.onMouseEnter,
      onMouseLeave: e.onMouseLeave
    }));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      xmlns: "http://www.w3.org/1999/xlink",
      viewBox: "0 0 100 50",
      width: e.width,
      height: e.height,
      fill: e.fill
    }, i.default.createElement("path", {
      d: "M65.3333,0V50H0V0Z M100,0V50H67.3333V0Z",
      onMouseEnter: e.onMouseEnter,
      onMouseLeave: e.onMouseLeave
    }));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      xmlns: "http://www.w3.org/1999/xlink",
      viewBox: "0 0 100 50",
      width: e.width,
      height: e.height,
      fill: e.fill
    }, i.default.createElement("path", {
      d: "M24,0V50H0V0Z M50,0V50H26V0Z M100,0V50H52V0Z",
      onMouseEnter: e.onMouseEnter,
      onMouseLeave: e.onMouseLeave
    }));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      xmlns: "http://www.w3.org/1999/xlink",
      viewBox: "0 0 100 50",
      width: e.width,
      height: e.height,
      fill: e.fill
    }, i.default.createElement("path", {
      d: "M48,0V50H0V0Z M74,0V50H50V0Z M100,0V50H76V0Z",
      onMouseEnter: e.onMouseEnter,
      onMouseLeave: e.onMouseLeave
    }));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      xmlns: "http://www.w3.org/1999/xlink",
      viewBox: "0 0 100 50",
      width: e.width,
      height: e.height,
      fill: e.fill
    }, i.default.createElement("path", {
      d: "M24,0V50H0V0Z M74,0V50H26V0Z M100,0V50H76V0Z",
      onMouseEnter: e.onMouseEnter,
      onMouseLeave: e.onMouseLeave
    }));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      xmlns: "http://www.w3.org/1999/xlink",
      viewBox: "0 0 100 50",
      width: e.width,
      height: e.height,
      fill: e.fill
    }, i.default.createElement("path", {
      d: "M16,0V50H0V0Z M82,0V50H18V0Z M100,0V50H84V0Z",
      onMouseEnter: e.onMouseEnter,
      onMouseLeave: e.onMouseLeave
    }));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = function (e) {
    return i.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      height: e.height,
      viewBox: "0 0 56 56",
      fill: e.color,
      width: e.width,
      enableBackground: "new 0 0 56 56"
    }, i.default.createElement("g", null, i.default.createElement("path", {
      fill: "#E9E9E0",
      d: "M36.985,0H7.963C7.155,0,6.5,0.655,6.5,1.926V55c0,0.345,0.655,1,1.463,1h40.074\r c0.808,0,1.463-0.655,1.463-1V12.978c0-0.696-0.093-0.92-0.257-1.085L37.607,0.257C37.442,0.093,37.218,0,36.985,0z"
    }), i.default.createElement("polygon", {
      fill: "#D9D7CA",
      points: "37.5,0.151 37.5,12 49.349,12 \t"
    }), i.default.createElement("path", {
      fill: "#CC4B4C",
      d: "M19.514,33.324L19.514,33.324c-0.348,0-0.682-0.113-0.967-0.326\r c-1.041-0.781-1.181-1.65-1.115-2.242c0.182-1.628,2.195-3.332,5.985-5.068c1.504-3.296,2.935-7.357,3.788-10.75\r c-0.998-2.172-1.968-4.99-1.261-6.643c0.248-0.579,0.557-1.023,1.134-1.215c0.228-0.076,0.804-0.172,1.016-0.172\r c0.504,0,0.947,0.649,1.261,1.049c0.295,0.376,0.964,1.173-0.373,6.802c1.348,2.784,3.258,5.62,5.088,7.562\r c1.311-0.237,2.439-0.358,3.358-0.358c1.566,0,2.515,0.365,2.902,1.117c0.32,0.622,0.189,1.349-0.39,2.16\r c-0.557,0.779-1.325,1.191-2.22,1.191c-1.216,0-2.632-0.768-4.211-2.285c-2.837,0.593-6.15,1.651-8.828,2.822\r c-0.836,1.774-1.637,3.203-2.383,4.251C21.273,32.654,20.389,33.324,19.514,33.324z M22.176,28.198\r c-2.137,1.201-3.008,2.188-3.071,2.744c-0.01,0.092-0.037,0.334,0.431,0.692C19.685,31.587,20.555,31.19,22.176,28.198z\r M35.813,23.756c0.815,0.627,1.014,0.944,1.547,0.944c0.234,0,0.901-0.01,1.21-0.441c0.149-0.209,0.207-0.343,0.23-0.415\r c-0.123-0.065-0.286-0.197-1.175-0.197C37.12,23.648,36.485,23.67,35.813,23.756z M28.343,17.174\r c-0.715,2.474-1.659,5.145-2.674,7.564c2.09-0.811,4.362-1.519,6.496-2.02C30.815,21.15,29.466,19.192,28.343,17.174z\r M27.736,8.712c-0.098,0.033-1.33,1.757,0.096,3.216C28.781,9.813,27.779,8.698,27.736,8.712z"
    }), i.default.createElement("path", {
      fill: "#CC4B4C",
      d: "M48.037,56H7.963C7.155,56,6.5,55.345,6.5,54.537V39h43v15.537C49.5,55.345,48.845,56,48.037,56z"
    }), i.default.createElement("g", null, i.default.createElement("path", {
      fill: "#FFFFFF;",
      d: "M17.385,53h-1.641V42.924h2.898c0.428,0,0.852,0.068,1.271,0.205\r c0.419,0.137,0.795,0.342,1.128,0.615c0.333,0.273,0.602,0.604,0.807,0.991s0.308,0.822,0.308,1.306\r c0,0.511-0.087,0.973-0.26,1.388c-0.173,0.415-0.415,0.764-0.725,1.046c-0.31,0.282-0.684,0.501-1.121,0.656\r s-0.921,0.232-1.449,0.232h-1.217V53z M17.385,44.168v3.992h1.504c0.2,0,0.398-0.034,0.595-0.103\r c0.196-0.068,0.376-0.18,0.54-0.335c0.164-0.155,0.296-0.371,0.396-0.649c0.1-0.278,0.15-0.622,0.15-1.032\r c0-0.164-0.023-0.354-0.068-0.567c-0.046-0.214-0.139-0.419-0.28-0.615c-0.142-0.196-0.34-0.36-0.595-0.492\r c-0.255-0.132-0.593-0.198-1.012-0.198H17.385z"
    }), i.default.createElement("path", {
      fill: "#FFFFFF",
      d: "M32.219,47.682c0,0.829-0.089,1.538-0.267,2.126s-0.403,1.08-0.677,1.477s-0.581,0.709-0.923,0.937\r s-0.672,0.398-0.991,0.513c-0.319,0.114-0.611,0.187-0.875,0.219C28.222,52.984,28.026,53,27.898,53h-3.814V42.924h3.035\r c0.848,0,1.593,0.135,2.235,0.403s1.176,0.627,1.6,1.073s0.74,0.955,0.95,1.524C32.114,46.494,32.219,47.08,32.219,47.682z\r M27.352,51.797c1.112,0,1.914-0.355,2.406-1.066s0.738-1.741,0.738-3.09c0-0.419-0.05-0.834-0.15-1.244\r c-0.101-0.41-0.294-0.781-0.581-1.114s-0.677-0.602-1.169-0.807s-1.13-0.308-1.914-0.308h-0.957v7.629H27.352z"
    }), i.default.createElement("path", {
      fill: "#FFFFFF",
      d: "M36.266,44.168v3.172h4.211v1.121h-4.211V53h-1.668V42.924H40.9v1.244H36.266z"
    }))), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null), i.default.createElement("g", null));
  };
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = function (e, t) {
    if (Array.isArray(e)) return e;
    if (Symbol.iterator in Object(e)) return function (e, t) {
      var n = [],
        a = !0,
        r = !1,
        i = void 0;
      try {
        for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
      } catch (e) {
        r = !0, i = e;
      } finally {
        try {
          !a && s.return && s.return();
        } finally {
          if (r) throw i;
        }
      }
      return n;
    }(e, t);
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  };
  t.PopupBannerComponent = function (e) {
    var t = (0, i.useState)(!1),
      n = a(t, 2),
      r = n[0],
      d = n[1],
      u = e.commonConfigs,
      c = e.data.settings,
      m = c.displayPopup,
      f = c.banner,
      p = (u.isEditMode, u.isPreview),
      _ = !1;
    return (0, i.useEffect)(function () {
      if (!_ && f && f.uniqueId) if (m && m.value && "showOneTime" === m.value) {
        var e = localStorage.getItem("showPopup-" + f.uniqueId);
        (null == e || "false" !== e && !1 !== e) && (d(!0), localStorage.setItem("showPopup-" + f.uniqueId, !1));
      } else d(!0);
      return function () {
        _ = !0;
      };
    }, []), p ? o.default.createElement("div", {
      class: "alert alert-primary",
      role: "alert"
    }, "Popup banner, Popup will show after page build") : o.default.createElement(o.default.Fragment, null, !_ && o.default.createElement(s.Modal, {
      show: r,
      onHide: function () {
        _ || d(!1);
      },
      size: "xl"
    }, o.default.createElement(s.Modal.Header, {
      closeButton: !0
    }), o.default.createElement(s.Modal.Body, null, o.default.createElement(l.BannerComponent, e))));
  };
  var r,
    i = n(0),
    o = (r = i) && r.__esModule ? r : {
      default: r
    },
    s = n(14),
    l = n(11);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      }
      return e;
    },
    r = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    i = _(["\n    ", "\n"], ["\n    ", "\n"]),
    o = _(["\n    padding-top: 15px;\n    padding-bottom: 15px;\n"], ["\n    padding-top: 15px;\n    padding-bottom: 15px;\n"]),
    s = n(0),
    l = f(s),
    d = f(n(2)),
    u = f(n(3)),
    c = n(5),
    m = f(n(27));
  function f(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  function p(e) {
    if (Array.isArray(e)) {
      for (var t = 0, n = Array(e.length); t < e.length; t++) n[t] = e[t];
      return n;
    }
    return Array.from(e);
  }
  function _(e, t) {
    return Object.freeze(Object.defineProperties(e, {
      raw: {
        value: Object.freeze(t)
      }
    }));
  }
  var h = d.default.div(i, function (e) {
      return e.customCSS ? e.customCSS : "";
    }),
    y = d.default.div(o);
  t.default = function (e) {
    var t = "",
      n = {},
      i = void 0,
      o = void 0,
      d = void 0,
      f = void 0,
      _ = (e.commonConfigs, e.dbName),
      g = e.lang,
      v = e.data,
      M = v.data,
      L = v.styles,
      b = v.settings;
    L && (n = (0, c.genarateComponentLevelStyleConfigurations)(L)), b && (i = b.collection, o = b.recordsLimit ? b.recordsLimit.value : void 0, d = b.cardsPerRow ? b.cardsPerRow.value : void 0, b.viewMoreLink ? b.viewMoreLink.value : void 0, f = b.recordsOrder ? b.recordsOrder.value : void 0), void 0 !== M && (t = M.cardList);
    var w = (0, s.useState)([]),
      k = r(w, 2),
      Y = k[0],
      D = k[1],
      S = (0, s.useState)(void 0),
      T = r(S, 2),
      E = T[0],
      x = T[1];
    if ((0, s.useEffect)(function () {
      var n = !0;
      if (n && i) {
        var a = i.externalParams.dataSourceUrl,
          s = {
            headers: {},
            params: {
              nameSpace: e.dbName,
              collectionName: i.value.customeCollectionName,
              sorter: JSON.stringify({
                _id: -1
              }),
              limit: o || 0,
              searchQuery: JSON.stringify({
                active: !0
              })
            }
          };
        u.default.get(a, s).then(function (e) {
          if (200 === e.status && e.data.length > 0) {
            d && x(Math.ceil(e.data.length / d));
            var n = [];
            if ("desc" === f) {
              var a = 0;
              o > 0 && e.data.length - o > 0 && (a = e.data.length - o);
              for (var i = e.data.length - 1; i >= a; i--) {
                var s = e.data[i];
                n.push(s);
              }
            } else {
              var l = e.data.length;
              o > 0 && e.data.length > o && (l = o);
              for (var u = 0; u < l; u++) {
                var c = e.data[u];
                n.push(c);
              }
            }
            var m = n.map(function (e, n) {
              var a = e._id,
                i = e.fieldData[g.langKey],
                o = {
                  id: a,
                  card: {}
                };
              return t && t.features && i && Object.entries(t.features).map(function (e, t) {
                var n = r(e, 2),
                  a = n[0],
                  s = n[1].mappingField;
                if (o.card[a] = i[s], "image" === a) {
                  var l = i[s] ? "/api/documents/" + _ + "/" + i[s] : "#";
                  o.card[a] = l;
                }
                if ("link" === a) {
                  var d = i[s] ? "/api/documents/" + _ + "/" + i[s] : "#";
                  o.card[a] = d;
                }
              }), o;
            });
            D(m);
          }
        });
      }
      return function () {
        n = !1;
      };
    }, []), E && Y.length > 0) {
      for (var C = [], j = 0; j < E; j++) {
        var P = [].concat(p(Y)).splice(j * d, d);
        C.push(l.default.createElement(h, a({
          className: "row " + (n && n.cssClass ? n.cssClass : ""),
          key: "card-row-" + j
        }, n), P && P.map(function (t, n) {
          var r = t.id,
            i = t.card,
            o = a({}, e.data, {
              data: a({}, e.data.data, {
                card: i,
                id: r
              })
            });
          return l.default.createElement(y, {
            className: "col-md",
            key: r
          }, l.default.createElement(m.default, {
            data: o,
            dbName: e.dbName,
            lang: e.lang,
            editMode: e.editMode,
            componentIndex: e.componentIndex,
            commonConfigs: e.commonConfigs
          }));
        })));
      }
      return l.default.createElement(l.default.Fragment, null, C);
    }
    return l.default.createElement(l.default.Fragment, null);
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    r = _(["\n    float: none;\n"], ["\n    float: none;\n"]),
    i = _(["\n    padding-right: 10px;\n"], ["\n    padding-right: 10px;\n"]);
  t.ListComponent = function (e) {
    e.commonConfigs;
    var t = e.dbName,
      n = e.data,
      r = n.data,
      i = (n.styles, n.settings),
      l = e.lang,
      c = void 0,
      m = void 0,
      f = "";
    i && (c = i.collection, m = i.recordsOrder ? i.recordsOrder.value : void 0);
    void 0 !== r && (f = r.list);
    var p = (0, o.useState)([]),
      _ = a(p, 2),
      v = _[0],
      M = _[1],
      L = (0, o.useState)(""),
      b = a(L, 2),
      w = b[0],
      k = b[1];
    return (0, o.useEffect)(function () {
      k((0, u.v1)());
    }, []), (0, o.useEffect)(function () {
      var n = !0;
      if (n && c) {
        var r = c.externalParams.dataSourceUrl,
          i = {
            headers: {},
            params: {
              nameSpace: e.dbName,
              collectionName: c.value.customeCollectionName,
              sorter: JSON.stringify({
                _id: -1
              }),
              searchQuery: JSON.stringify({
                active: !0
              })
            }
          };
        d.default.get(r, i).then(function (e) {
          if (200 === e.status && e.data.length > 0) {
            var n = [];
            if ("desc" === m) for (var r = e.data.length - 1; r >= 0; r--) {
              var i = e.data[r];
              n.push(i);
            } else for (var o = 0; o < e.data.length; o++) {
              var s = e.data[o];
              n.push(s);
            }
            var d = n.map(function (e, n) {
              var r = e._id,
                i = e.fieldData[l.langKey],
                o = {
                  id: r,
                  listItem: {}
                };
              return f && f.features && i && Object.entries(f.features).map(function (e, n) {
                var r = a(e, 2),
                  s = r[0],
                  l = r[1].mappingField;
                if (o.listItem[s] = i[l], "document" === s) {
                  var d = i[l] ? "/api/documents/" + t + "/" + i[l] : "#";
                  o.listItem[s] = d;
                }
              }), o;
            });
            M(d);
          }
        });
      }
      return function () {
        n = !1;
      };
    }, []), s.default.createElement(s.default.Fragment, null, i && i.collection && s.default.createElement(h, {
      className: "list-group list-group-flush"
    }, v.map(function (e, t) {
      var n = e.listItem.document ? e.listItem.document.split(".") : "",
        a = "" != n ? n[n.length - 1] : "pdf",
        r = "" != a && g[a] ? g[a] : g.pdf;
      return s.default.createElement(s.default.Fragment, null, s.default.createElement("a", {
        className: "list-group-item d-flex align-items-center",
        key: w + "" + e.listItem.title,
        href: e.listItem.document ? e.listItem.document : "#",
        target: "_blank"
      }, "" != r && s.default.createElement(y, null, s.default.createElement(r, {
        width: "48",
        height: "48"
      })), e.listItem.title));
    })));
  };
  var o = n(0),
    s = p(o),
    l = p(n(2)),
    d = p(n(3)),
    u = n(7),
    c = p(n(26)),
    m = p(n(21)),
    f = p(n(22));
  function p(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  function _(e, t) {
    return Object.freeze(Object.defineProperties(e, {
      raw: {
        value: Object.freeze(t)
      }
    }));
  }
  var h = l.default.div(r),
    y = l.default.span(i),
    g = {
      pdf: c.default,
      xlsx: f.default,
      xls: f.default,
      docx: m.default,
      doc: m.default
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    r = n(0),
    i = l(r),
    o = l(n(3)),
    s = n(9);
  function l(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  t.default = function (e) {
    var t,
      n = (0, r.useState)(),
      l = a(n, 2),
      d = l[0],
      u = l[1],
      c = e.commonConfigs,
      m = e.data,
      f = (m.data, m.styles, m.settings),
      p = e.lang,
      _ = f.tree,
      h = f.scroll,
      y = (_.uniqueId, _.value),
      g = (c.isEditMode, c.isPreview),
      v = void 0,
      M = (0, r.useState)(""),
      L = a(M, 2),
      b = L[0],
      w = L[1],
      k = (0, r.useState)(0),
      Y = a(k, 2),
      D = Y[0],
      S = Y[1],
      T = (0, r.useState)(),
      E = a(T, 2),
      x = E[0],
      C = E[1];
    function j(e, t, n) {
      var a = "";
      n && e && e.nodeID && "" !== e.nodeID && (a = n + "/" + e.nodeID, t && t.length > 0 && (a = a + "/" + t.map(function (e) {
        return e + 1;
      }).join("-")));
      return a;
    }
    function P(e) {
      if (e && "" !== e) {
        var t = e.split("/");
        if (t && t.length >= 2) {
          var n = t[1],
            a = "";
          t.length >= 3 && (a = t[2]);
          var r = a.split("-");
          if (r && r.length > 0) try {
            var i = Number(r[0]);
            S(i - 1);
          } catch (e) {
            console.log(e);
          }
          w(n);
        }
      }
    }
    function N(e, t) {
      return e && e.children && e.children.length > 0 ? i.default.createElement("ul", null, e.children.map(function (e, n) {
        var a = [].concat(function (e) {
            if (Array.isArray(e)) {
              for (var t = 0, n = Array(e.length); t < e.length; t++) n[t] = e[t];
              return n;
            }
            return Array.from(e);
          }(t), [n]),
          r = function (e) {
            if (e) {
              if (e.children && e.children.length > 0) {
                for (var t = !0, n = 0; n < e.children.length; n++) {
                  var a = e.children[n];
                  if (a.children && a.children.length > 0) {
                    t = !1;
                    break;
                  }
                }
                return t;
              }
              return !1;
            }
            return !1;
          }(e),
          o = a.map(function (e) {
            return e + 1;
          }).join("-");
        if (r) {
          var s = j(e, a, d._id ? d._id : void 0),
            l = "#000000";
          return "" !== b && b === e.nodeID && (l = "#C6974B"), i.default.createElement("li", {
            key: e.nodeID
          }, i.default.createElement("a", {
            href: "#" + s,
            style: {
              color: l
            },
            onClick: function (e) {
              e.preventDefault(), H(s);
            }
          }, o + " " + e.localizeTitle[p.langKey.toLowerCase()]));
        }
        return i.default.createElement("li", {
          key: e.nodeID
        }, o + " " + e.localizeTitle[p.langKey.toLowerCase()], N(e, a));
      })) : i.default.createElement(i.default.Fragment, null);
    }
    function H(e) {
      "undefined" != typeof history && history.pushState && e && "" !== e && (history.pushState(null, null, "#" + e), (0, s.emitCustomEvent)("treeItemClicked", e), P(e));
    }
    return (0, r.useEffect)(function () {
      var t = !1;
      return !t && y && "" !== y && function (t) {
        var n = localStorage.getItem("jwt-token"),
          a = "/api/tree",
          r = {
            id: y,
            nameSpace: e.dbName
          };
        g && (a = "/api/custom-collections/tree", r = {
          id: y,
          dbName: e.dbName
        });
        var i = {
          headers: {
            Authorization: n
          },
          params: r
        };
        o.default.get(a, i).then(function (e) {
          !t && e && e.data && (u(e.data), function (e, t) {
            if ("undefined" != typeof location && "" === location.hash && e && e.length > 0) {
              var n = j(e[0], [0], t);
              location.hash = n;
            }
          }(e.data.tree, e.data._id));
        }).catch(function (e) {
          console.log(e);
        });
      }(t), function () {
        t = !0;
      };
    }, []), (0, r.useEffect)(function () {
      var e = !1;
      return e || function () {
        if (v && "" !== v) {
          P(v.substr(1));
        }
      }(), function () {
        e = !0;
      };
    }, [function () {
      "undefined" != typeof location && (v = location.hash);
      return v;
    }()]), i.default.createElement(i.default.Fragment, null, i.default.createElement("div", {
      className: "tree-view-toolbar mb-3"
    }, i.default.createElement("button", {
      className: "toolbar-button expand",
      onClick: function () {
        C(function (e) {
          return void 0 === e || !e;
        });
      }
    }, x ? "ar" === p.langKey.toLowerCase() ? "طي الكل" : "Collapse All" : "ar" === p.langKey.toLowerCase() ? "اظهار الكل" : "Expand All")), d && d.tree && d.tree.length > 0 && i.default.createElement("div", {
      id: "treeViewAccordion",
      className: (t = "", h && ("" === t ? t = "rulebook-scroll scrollbar-02" : t += " rulebook-scroll scrollbar-02"), t)
    }, d.tree.map(function (e, t) {
      var n = "collapse";
      n = void 0 === x ? t === D ? "collapse show" : "collapse" : x ? "collapse show" : "collapse";
      var a = "#000000";
      return "" !== b && b === e.nodeID && (a = "#C6974B"), i.default.createElement("div", {
        key: e.nodeID,
        className: "card"
      }, i.default.createElement("div", {
        className: "card-header btn",
        "data-toggle": "collapse",
        "data-target": "#collapseTreeCard" + t,
        "aria-expanded": "true",
        "aria-controls": "collapseTreeCard" + t,
        id: "treeViewCard" + t,
        onClick: function (n) {
          !function (e, t) {
            e && H(j(e, t, d._id ? d._id : void 0));
          }(e, [t]);
        },
        style: {
          color: a
        }
      }, t + 1 + " " + e.localizeTitle[p.langKey.toLowerCase()]), i.default.createElement("div", {
        id: "collapseTreeCard" + t,
        className: n,
        "aria-labelledby": "treeViewCard" + t,
        "data-parent": "#treeViewCard" + t
      }, i.default.createElement("div", {
        className: "card-body"
      }, N(e, [t]))));
    })));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      }
      return e;
    },
    r = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    i = n(0),
    o = c(i),
    s = c(n(3)),
    l = n(169),
    d = n(6),
    u = (n(14), n(9));
  function c(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  t.default = function (e) {
    var t,
      n,
      c = (0, i.useState)(),
      m = r(c, 2),
      f = m[0],
      p = m[1],
      _ = (0, i.useState)(!1),
      h = r(_, 2),
      y = (h[0], h[1], (0, i.useState)()),
      g = r(y, 2),
      v = (g[0], g[1], (0, i.useState)()),
      M = r(v, 2),
      L = (M[0], M[1], (0, i.useState)(!0)),
      b = r(L, 2),
      w = b[0],
      k = b[1],
      Y = (0, i.useState)(""),
      D = r(Y, 2),
      S = D[0],
      T = D[1],
      E = (0, i.useState)(""),
      x = r(E, 2),
      C = x[0],
      j = x[1],
      P = (0, i.useState)(""),
      N = r(P, 2),
      H = N[0],
      O = N[1],
      I = (0, i.useState)(""),
      z = r(I, 2),
      A = z[0],
      F = z[1],
      R = e.commonConfigs,
      W = e.data,
      V = (W.data, W.styles),
      K = W.settings,
      B = e.lang,
      U = (R.isEditMode, R.isPreview),
      q = void 0;
    function J(e) {
      if (e && e.data && e.data.fieldData && e.data.fieldData[B.langKey]) {
        if (K && K.fieldMappings && K.fieldMappings.paragraphDataMap && "" !== K.fieldMappings.paragraphDataMap) {
          var t = K.fieldMappings.paragraphDataMap.toLocaleLowerCase().split(" ").join("_");
          return e.data.fieldData[B.langKey][t];
        }
        return "";
      }
      return "";
    }
    return (0, u.useCustomEventListener)("treeItemClicked", function (e) {
      j(e);
    }), (0, i.useEffect)(function () {
      return function () {
        if (K && K.customReport) {
          var t = K.customReport,
            n = t.collection,
            a = t.documentId,
            r = t.documentField,
            i = localStorage.getItem("jwt-token"),
            o = {
              nameSpace: e.dbName,
              searchId: a,
              collectionName: n
            },
            l = {
              headers: {
                Authorization: i
              },
              params: o
            };
          s.default.get("/api/cms/getSingleDocumentById", l).then(function (e) {
            if (console.log("result", e), e.data) {
              var t = e.data.fieldData[B.langKey],
                n = "",
                a = "";
              t && t[r] ? (n = t[r], a = t.entry_name) : e.data.fieldData.EN && e.data.fieldData.EN[r] && (n = e.data.fieldData.EN[r], a = e.data.fieldData.EN.entry_name), O(n), F(a);
            }
          }).catch(function (e) {
            console.log(e);
          });
        }
      }(), function () {
        !0;
      };
    }, []), (0, i.useEffect)(function () {
      return C && "" !== C && function (t) {
        if (t && "" !== t) {
          var n = t.split("/");
          if (n && n.length >= 2) {
            var r = n[0],
              i = n[1],
              o = "";
            n.length >= 3 && (o = n[2]), function (t) {
              if (t) {
                var n = localStorage.getItem("jwt-token"),
                  r = "/api/tree/collection",
                  i = a({
                    nameSpace: e.dbName
                  }, t);
                U && (r = "/api/custom-collections/tree/collection", i = a({
                  dbName: e.dbName
                }, t));
                var o = {
                  headers: {
                    Authorization: n
                  },
                  params: i
                };
                s.default.get(r, o).then(function (e) {
                  p(e.data);
                }).catch(function (e) {
                  console.log(e);
                });
              }
            }({
              treeId: r,
              nodeId: i,
              nodePath: o
            });
          }
        }
      }(C), function () {
        !0;
      };
    }, [C]), (0, i.useEffect)(function () {
      var e = !1;
      return function (e) {
        if (!e && q && q.hash && "" !== q.hash) {
          var t = q.hash.substr(1);
          j(t);
        }
      }(e), function () {
        e = !0;
      };
    }, [function () {
      if ("undefined" != typeof location && void 0 === q) if (U) try {
        q = (0, l.useLocation)();
      } catch (e) {
        console.log("reactUseLocation error", e);
      } else q = location;
      return q && q.hash ? q.hash : "";
    }()]), o.default.createElement(o.default.Fragment, null, o.default.createElement("div", {
      className: "row"
    }, o.default.createElement("div", {
      className: "col-md-7 col-lg-8"
    }, o.default.createElement("h2", null, o.default.createElement("span", null, (n = "", f && f.traverse && f.traverse.length > 0 && (n = f.traverse[0].localizeTitle[B.langKey.toLowerCase()]), n)))), o.default.createElement("div", {
      className: "col-md-5 col-lg-4"
    })), o.default.createElement("div", {
      className: "row"
    }, o.default.createElement("div", {
      className: "col-md-7 mb-2"
    }, o.default.createElement("div", {
      className: "accordion-data-toolbar mb-3"
    }, o.default.createElement("button", {
      className: "toolbar-button expand",
      onClick: function () {
        k(function (e) {
          return void 0 === e || !e;
        });
      }
    }, w ? "ar" === B.langKey.toLowerCase() ? "طي الكل" : "Collapse All" : "ar" === B.langKey.toLowerCase() ? "اظهار الكل" : "Expand All"), o.default.createElement("button", {
      className: "toolbar-button print",
      onClick: function () {
        if ("undefined" != typeof window) {
          var e = window.open("", "", "height=600,width=920");
          e.document.write("<html><head>"), e.document.write('<link rel="preconnect" href="https://fonts.gstatic.com">\n                <link href="https://fonts.googleapis.com/css2?family=Tajawal:wght@300;500;800&display=swap" rel="stylesheet">\n                <style type="text/css">  \n                    body {\n                        background-color: #ffffff;\n                        direction: ' + (B.direction ? B.direction : "ltr") + ";\n                        font-family: 'Tajawal', sans-serif;\n                        font-size: 16px;\n                    }\n                    h5 {\n                        border-bottom: 1px solid #EEEFF2;\n                    }\n                </style>"), e.document.write("</head><body>"), e.document.write(function () {
            var e = "",
              t = document.getElementById("accordionDetailed"),
              n = t.children,
              a = t.childElementCount;
            if (a > 0) for (var r = 0; r < a; r++) {
              var i = "",
                o = n[r];
              if (o.getElementsByClassName("collapse show").length > 0) {
                var s = o.getElementsByClassName("card-header")[0],
                  l = o.getElementsByClassName("card-body")[0];
                i += '<div style="width:500px; padding: 16px; margin: 8px;">', i += '<h5 style="font-family: Tajawal;font-weight: bold;font-size: 20px ;line-height: 20px;color: #C6974B;">', i += s.innerHTML, i += "</h5>", i += '<div style="font-family: Tajawal;font-weight: normal;font-size: 16px;line-height: 24px;color: #4B4C4D;">', i += l.innerHTML, i += "</div>", e += i += "</div>";
              }
            }
            return e;
          }()), e.document.title = "Rule Book", e.document.write("</body></html>"), e.document.close(), e.focus(), e.print();
        }
      }
    }, "ar" === B.langKey.toLowerCase() ? "طباعة الملف " : "Print To PDF"), "" !== H && o.default.createElement("a", {
      className: "toolbar-button download",
      href: "/api/documents/" + e.dbName + "/" + H,
      download: "" !== A ? A : H
    }, "ar" === B.langKey.toLowerCase() ? "تحميل الكتاب" : "Download PDF"))), o.default.createElement("form", {
      className: "col-md-5 mb-2",
      onSubmit: function (e) {
        e.preventDefault(), "undefined" == typeof window || U || window.open(function () {
          var e = "#";
          if (K && K.searchResultURL && K.searchResultURL.value && "" !== K.searchResultURL.value && B && B.langKey && "" !== B.langKey) {
            var t = B.langKey.toLowerCase();
            e = "/" + t + "/" + (e = 0 == (e = 0 == (e = K.searchResultURL.value.toLowerCase()).indexOf("/") ? e.substring(1) : e).indexOf(t + "/") ? e.substring(3) : e);
          }
          return e;
        }() + "#" + S, "_self");
      }
    }, o.default.createElement("div", {
      className: "input-group "
    }, o.default.createElement("input", {
      type: "text",
      className: "form-control",
      placeholder: "Search",
      value: S,
      required: !0,
      onChange: function (e) {
        T(e.target.value);
      }
    }), o.default.createElement("div", {
      className: "input-group-append"
    }, o.default.createElement("button", {
      className: "btn market-watch-button m-0",
      type: "submit"
    }, "ar" === B.langKey.toLowerCase() ? "بحث" : "Search"))))), f && f.data && o.default.createElement(o.default.Fragment, null, o.default.createElement("div", {
      id: "accordionDetailed",
      className: (t = "", K.scroll && ("" === t ? t = "rulebook-scroll scrollbar-02" : t += " rulebook-scroll scrollbar-02"), t)
    }, f.data.map(function (e, t) {
      var n = "collapse";
      return n = void 0 === w ? 0 === t ? "collapse show" : "collapse" : w ? "collapse show" : "collapse", o.default.createElement("div", {
        key: e._id,
        className: "card",
        id: "detailedInfoCradKey-" + t
      }, o.default.createElement("div", {
        className: "card-header btn",
        "data-toggle": "collapse",
        "data-target": "#collapseDetailedInfoCrad" + t,
        "aria-expanded": "true",
        "aria-controls": "collapseDetailedInfoCrad" + t,
        id: "detailedInfoCrad" + t
      }, function (e) {
        if (e && e.data && e.data.fieldData && e.data.fieldData[B.langKey]) {
          if (K && K.fieldMappings && K.fieldMappings.titleDataMap && "" !== K.fieldMappings.titleDataMap) {
            var t = K.fieldMappings.titleDataMap.toLocaleLowerCase().split(" ").join("_");
            return e.data.fieldData[B.langKey][t];
          }
          return e.data.fieldData[B.langKey].entry_name;
        }
        return "";
      }(e)), o.default.createElement("div", {
        id: "collapseDetailedInfoCrad" + t,
        className: n,
        "aria-labelledby": "detailedInfoCrad" + t,
        "data-parent": "#detailedInfoCrad" + t
      }, o.default.createElement("div", {
        className: "card-body"
      }, o.default.createElement("div", null, function (e) {
        try {
          var t = {
            styles: V,
            data: {
              paragraph: J(e)
            }
          };
          return o.default.createElement(d.ParagraphComponent, {
            data: t
          });
        } catch (t) {
          return console.log("Document Paragraph Type Error", t), o.default.createElement(o.default.Fragment, null, J(e));
        }
      }(e)))));
    }))));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    r = n(0),
    i = s(r),
    o = s(n(3));
  function s(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  t.default = function (e) {
    var t = (0, r.useState)(),
      n = a(t, 2),
      s = n[0],
      l = n[1],
      d = e.commonConfigs,
      u = e.data,
      c = u.data,
      m = (u.styles, u.settings.collection.value),
      f = (e.lang, d.isEditMode, d.isPreview),
      p = "";
    return c && c.text && (p = c.text + " "), (0, r.useEffect)(function () {
      var t = !1;
      return t || function (t) {
        var n = localStorage.getItem("jwt-token"),
          a = "/api/customCollections/last/meta",
          r = {
            collection: m,
            nameSpace: e.dbName
          };
        f && (a = "/api/custom-collections/last/meta", r = {
          collection: m,
          dbName: e.dbName
        });
        var i = {
          headers: {
            Authorization: n
          },
          params: r
        };
        o.default.get(a, i).then(function (e) {
          !t && e && e.data && l(e.data);
        }).catch(function (e) {
          console.log(e);
        });
      }(t), function () {
        t = !0;
      };
    }, []), i.default.createElement("div", null, "" + p + (s && s.modifiedDate ? "string" == typeof s.modifiedDate ? new Date(s.modifiedDate).toLocaleDateString() : s.modifiedDate.toLocaleDateString() : ""));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = function (e, t) {
    if (Array.isArray(e)) return e;
    if (Symbol.iterator in Object(e)) return function (e, t) {
      var n = [],
        a = !0,
        r = !1,
        i = void 0;
      try {
        for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
      } catch (e) {
        r = !0, i = e;
      } finally {
        try {
          !a && s.return && s.return();
        } finally {
          if (r) throw i;
        }
      }
      return n;
    }(e, t);
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  };
  t.SiteSearchComponent = function (e) {
    var t = (0, r.useState)(!1),
      n = a(t, 2),
      d = n[0],
      u = n[1],
      c = (e.commonConfigs, e.data.settings),
      m = !1;
    c && (m = !!c.componentType && c.componentType.value);
    return i.default.createElement(i.default.Fragment, null, !d && !m && i.default.createElement("span", {
      onClick: function () {
        return u(!0);
      }
    }, i.default.createElement(o.default, {
      width: "24",
      height: "24"
    })), m && i.default.createElement(l.SearchInputComponent, null), d && i.default.createElement(s.Modal, {
      className: "search-modal",
      size: "lg",
      show: d,
      onHide: function () {
        u(!1);
      }
    }, i.default.createElement(s.Modal.Header, {
      closeButton: !0
    }, i.default.createElement(s.Modal.Title, null, "Search")), i.default.createElement(s.Modal.Body, null, i.default.createElement(l.SearchInputComponent, null))));
  };
  var r = n(0),
    i = d(r),
    o = d(n(10)),
    s = n(14),
    l = n(170);
  function d(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = function (e, t) {
    if (Array.isArray(e)) return e;
    if (Symbol.iterator in Object(e)) return function (e, t) {
      var n = [],
        a = !0,
        r = !1,
        i = void 0;
      try {
        for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
      } catch (e) {
        r = !0, i = e;
      } finally {
        try {
          !a && s.return && s.return();
        } finally {
          if (r) throw i;
        }
      }
      return n;
    }(e, t);
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  };
  t.SiteSearchResultsComponent = function (e) {
    e.commonConfigs, e.data;
    var t = e.lang,
      n = e.dbName,
      l = e.data.settings,
      d = (0, i.useState)({}),
      u = a(d, 2),
      c = u[0],
      m = u[1],
      f = (0, i.useState)(0),
      p = a(f, 2),
      _ = (p[0], p[1], (0, i.useState)(0)),
      h = a(_, 2),
      y = h[0],
      g = h[1],
      v = (0, i.useState)(!1),
      M = a(v, 2),
      L = M[0],
      b = M[1],
      w = (0, i.useState)(!1),
      k = a(w, 2),
      Y = k[0],
      D = k[1],
      S = (0, i.useState)(!1),
      T = a(S, 2),
      E = T[0],
      x = T[1],
      C = (0, i.useState)(!1),
      j = a(C, 2),
      P = j[0],
      N = j[1],
      H = (0, i.useState)(void 0),
      O = a(H, 2),
      I = O[0],
      z = O[1],
      A = t.langKey.toLowerCase(),
      F = 0,
      R = 5,
      W = "en" === A ? "Filter Results" : "فرز نتائج البحث",
      V = "en" === A ? "No Results Found" : "لا توجد نتائج";
    l && (R = l.recordsLimit ? l.recordsLimit.value : 5);
    (0, i.useEffect)(function () {
      c && c.customCollections && (F = 0, c.customCollections.forEach(function (e) {
        F += e.collectionData.length;
      })), g(F);
    }, [c]);
    var K = {
        menu: "Menu",
        customCollections: "Reports",
        pageContent: "Articles"
      },
      B = {
        menu: "القائمة",
        customCollections: "التقارير",
        pageContent: "المواد"
      },
      U = "",
      q = "";
    "undefined" != typeof window && window && window.location && window.location.hash && (q = decodeURI(window.location.hash), U = q.substring(1));
    return (0, i.useEffect)(function () {
      "" != U && function (e, n) {
        var a = localStorage.getItem("jwt-token"),
          i = (localStorage.getItem("sessionId"), {
            headers: {
              Authorization: a
            },
            params: {
              nameSpace: e,
              keyword: n,
              langKey: t.langKey
            }
          });
        r.default.get("/api/site-search/data", i).then(function (e) {
          Object.keys(e.data).map(function (n, a) {
            e.data[n].length > 0 ? (e.data[n].isVisible = !0, "en" === t.langKey.toLowerCase() ? e.data[n].title = K[n] : e.data[n].title = B[n]) : e.data[n].isVisible = !1;
          }), m(e.data);
        }).catch(function (e) {
          console.log(e);
        });
      }(n, U);
    }, []), o.default.createElement(o.default.Fragment, null, o.default.createElement("div", {
      className: "search-result w-100"
    }, o.default.createElement("div", {
      className: "row"
    }, o.default.createElement("div", {
      className: "col-md-3 result-filter"
    }, o.default.createElement("div", {
      className: ""
    }, o.default.createElement("div", {
      className: "card-body"
    }, o.default.createElement("h5", {
      className: "card-title mb-3 font-weight-bold"
    }, W), o.default.createElement("form", null, o.default.createElement("div", {
      className: ""
    }, Object.keys(c).map(function (e, t) {
      return o.default.createElement(o.default.Fragment, null, o.default.createElement("div", {
        className: "mb-3"
      }, o.default.createElement("input", {
        type: "checkbox",
        className: "form-check-input",
        id: "check" + t,
        onChange: function (t) {
          var n;
          n = t, c[e].isVisible = n.target.checked, N(!P);
        },
        disabled: 0 === c[e].length,
        defaultChecked: c[e].isVisible
      }), o.default.createElement("label", {
        className: "form-check-label",
        htmlFor: "check" + t
      }, "en" == A ? K[e] : B[e], o.default.createElement("span", {
        className: "search-result-count"
      }, e.includes("customCollections") ? y : c[e].length, " "))));
    })))))), o.default.createElement("div", {
      className: "col-md-9 result-content"
    }, o.default.createElement(s.SearchInputComponent, {
      keyword: U,
      lang: A
    }), "" != U && c && c.menu && c.menu.length > 0 && c.menu.isVisible && o.default.createElement("div", {
      className: "result-group"
    }, o.default.createElement("div", {
      className: "result-group-header mb-3"
    }, o.default.createElement("h5", {
      className: "mb-3 "
    }, " ", o.default.createElement("span", {
      className: "font-weight-bold"
    }, " ", c.menu.title, " "), " ", o.default.createElement("span", {
      className: "search-result-count"
    }, " ", c.menu.length, " "), " ")), o.default.createElement("div", {
      className: "card mb-3"
    }, o.default.createElement("div", {
      className: "card-body"
    }, o.default.createElement("ul", null, c.menu.map(function (e, t) {
      return (t < R || Y) && o.default.createElement(o.default.Fragment, {
        key: e.name + "-" + t
      }, o.default.createElement("li", {
        className: "row"
      }, o.default.createElement("a", {
        href: "/" + A + e.path,
        target: "_blank"
      }, " ", e.name)));
    })), c.menu.length > R && !Y && o.default.createElement("span", {
      className: "clickable-01"
    }, o.default.createElement("a", {
      className: "viewall",
      onClick: function () {
        D(!0);
      }
    }, " ", "View all")), Y && o.default.createElement("span", {
      className: "clickable-01"
    }, o.default.createElement("a", {
      className: "showless",
      onClick: function () {
        D(!1);
      }
    }, " ", "Hide")), o.default.createElement("br", null))), o.default.createElement("br", null)), "" != U && c && c.customCollections && c.customCollections.length > 0 && c.customCollections.isVisible && o.default.createElement(o.default.Fragment, null, o.default.createElement("h5", {
      className: "mb-3 "
    }, " ", o.default.createElement("span", {
      className: "font-weight-bold"
    }, " ", c.customCollections.title, " "), " ", o.default.createElement("span", {
      className: "search-result-count"
    }, " ", y, " "), " "), o.default.createElement(o.default.Fragment, null, c.customCollections.map(function (e, t) {
      return o.default.createElement("div", {
        className: "card mb-3",
        key: e.collectionName + "-" + t
      }, o.default.createElement("div", {
        className: "card-body"
      }, o.default.createElement("h5", {
        className: "card-title"
      }, e.collectionName, " ", o.default.createElement("span", {
        className: "search-result-count"
      }, e.collectionData.length)), o.default.createElement("ul", {
        key: t
      }, e.collectionData.map(function (e, n) {
        return (n < R || L && I === t) && o.default.createElement(o.default.Fragment, {
          key: e.name + "-" + n
        }, o.default.createElement("li", {
          className: "row",
          key: e.name + "-" + n
        }, e.path && o.default.createElement("a", {
          href: "/" + e.path,
          target: "_blank"
        }, " ", e.name)));
      })), e.collectionData.length > R && I != t && o.default.createElement("span", {
        className: "clickable-01"
      }, o.default.createElement("a", {
        className: "viewall",
        onClick: function () {
          var e;
          e = t, b(!0), z(e);
        }
      }, " ", "View all")), I === t && o.default.createElement("span", {
        className: "clickable-01"
      }, o.default.createElement("a", {
        className: "showless",
        onClick: function () {
          b(!1), z(void 0);
        }
      }, " ", "Hide")), o.default.createElement("br", null)));
    }))), "" != U && c && c.pageContent && c.pageContent.length > 0 && c.pageContent.isVisible && o.default.createElement("div", {
      className: "result-group"
    }, o.default.createElement("div", {
      className: "result-group-header mb-3"
    }, o.default.createElement("h5", {
      className: "mb-3 "
    }, " ", o.default.createElement("span", {
      className: "font-weight-bold"
    }, " ", c.pageContent.title, " "), " ", o.default.createElement("span", {
      className: "search-result-count"
    }, " ", c.pageContent.length, " "), " ")), o.default.createElement("div", {
      className: "card mb-3"
    }, o.default.createElement("div", {
      className: "card-body"
    }, o.default.createElement("ul", null, c.pageContent.map(function (e, t) {
      return (t < R || E) && o.default.createElement(o.default.Fragment, {
        key: e.name + "-" + t
      }, o.default.createElement("li", {
        className: "row"
      }, e.path && o.default.createElement("a", {
        href: "/" + A + e.path,
        target: "_blank"
      }, " ", e.name)));
    })), c.pageContent.length > R && !E && o.default.createElement("span", {
      className: "clickable-01"
    }, o.default.createElement("a", {
      className: "viewall",
      onClick: function () {
        x(!0);
      }
    }, " ", "View all")), E && o.default.createElement("span", {
      className: "clickable-01"
    }, o.default.createElement("a", {
      className: "showless",
      onClick: function () {
        x(!1);
      }
    }, " ", "Hide")), o.default.createElement("br", null))), o.default.createElement("br", null)), ("" === U || c && c.menu && c.customCollections && 0 === c.pageContent.length && 0 === c.menu.length && 0 === c.customCollections.length && 0 === c.pageContent.length) && o.default.createElement("div", null, V, ".")))));
  };
  var r = l(n(3)),
    i = n(0),
    o = l(i),
    s = (l(n(23)), n(288), n(170));
  function l(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    r = n(0),
    i = c(r),
    o = n(169),
    s = c(n(3)),
    l = n(6),
    d = c(n(289)),
    u = c(n(171));
  function c(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  t.default = function (e) {
    var t = e.commonConfigs,
      n = e.data,
      c = (n.data, n.styles),
      m = n.settings,
      f = e.lang,
      p = m.tree,
      _ = m.paragraphMap,
      h = m.titleMap,
      y = (p.uniqueId, p.value),
      g = (t.isEditMode, t.isPreview),
      v = (0, r.useState)(""),
      M = a(v, 2),
      L = M[0],
      b = M[1],
      w = (0, r.useState)(""),
      k = a(w, 2),
      Y = k[0],
      D = k[1],
      S = (0, r.useState)([]),
      T = a(S, 2),
      E = T[0],
      x = T[1],
      C = (0, r.useState)([]),
      j = a(C, 2),
      P = j[0],
      N = j[1],
      H = (0, r.useState)([]),
      O = a(H, 2),
      I = O[0],
      z = O[1],
      A = (0, r.useState)(),
      F = a(A, 2),
      R = F[0],
      W = F[1],
      V = (0, r.useState)(20),
      K = a(V, 2),
      B = K[0],
      U = K[1],
      q = (0, r.useState)(1),
      J = a(q, 2),
      Z = J[0],
      G = J[1],
      $ = (0, r.useState)("relevance"),
      X = a($, 2),
      Q = X[0],
      ee = X[1],
      te = (0, r.useState)(0),
      ne = a(te, 2),
      ae = ne[0],
      re = ne[1],
      ie = void 0;
    function oe(t) {
      var n = localStorage.getItem("jwt-token"),
        a = I.map(function (e) {
          return e.value;
        }).join("#"),
        r = "/api/tree/search",
        i = {
          treeId: y,
          langKey: f.langKey,
          keyWord: t,
          nameSpace: e.dbName,
          parentNodeIds: a,
          sorting: Q
        };
      g && (r = "/api/custom-collections/tree/search", i = {
        treeId: y,
        langKey: f.langKey,
        keyWord: t,
        dbName: e.dbName,
        parentNodeIds: a,
        sorting: Q
      });
      var o = {
        headers: {
          Authorization: n
        },
        params: i
      };
      s.default.get(r, o).then(function (e) {
        e && e.data && (D(t), N(e.data), e.data.length > 0 ? (x(e.data.slice(0, B)), G(Math.ceil(e.data.length / B))) : x([]));
      }).catch(function (e) {
        console.log(e);
      });
    }
    function se(e, t) {
      return e ? i.default.createElement("tr", {
        key: "searchRecord" + t
      }, i.default.createElement("td", null, function (e) {
        var t = "";
        e && e.parentNode && e.parentNode.localizeTitle && (t = de(t = e.parentNode.localizeTitle[f.langKey.toLowerCase()]));
        return t;
      }(e)), i.default.createElement("td", null, function (e) {
        var t = "";
        if (e && e.fieldData && e.fieldData[f.langKey]) {
          if (h && h.value && "" !== h.value) {
            var n = h.value.toLocaleLowerCase().split(" ").join("_");
            t = e.fieldData[f.langKey][n];
          } else t = e.fieldData[f.langKey].entry_name;
          t = de(t);
        }
        return t;
      }(e)), i.default.createElement("td", null, function (e) {
        try {
          var t = {
            styles: c,
            data: {
              paragraph: le(e)
            }
          };
          return i.default.createElement(l.ParagraphComponent, {
            data: t
          });
        } catch (t) {
          return console.log("Document Paragraph Type Error", t), i.default.createElement(i.default.Fragment, null, le(e));
        }
      }(e))) : i.default.createElement(i.default.Fragment, null);
    }
    function le(e) {
      if (e && e.fieldData && e.fieldData[f.langKey]) {
        if (_ && _.value && "" !== _.value) {
          var t = _.value.toLocaleLowerCase().split(" ").join("_"),
            n = e.fieldData[f.langKey][t];
          return n = de(n, !0);
        }
        return "";
      }
      return "";
    }
    function de(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
      if (console.log("markSearchText function searchText", Y), Y && "" !== Y && e && "" !== e) {
        var n = e.split(new RegExp("(" + Y + ")", "gi")),
          a = n.map(function (e, n) {
            return e.toLowerCase() === Y.toLowerCase() ? t ? "<mark>" + e + "</mark>" : i.default.createElement("mark", null, e) : e;
          });
        return t ? a.join("") : a;
      }
      return e;
    }
    return (0, r.useEffect)(function () {
      var t = !1;
      return !t && y && "" !== y && function (t) {
        var n = localStorage.getItem("jwt-token"),
          a = "/api/tree",
          r = {
            id: y,
            nameSpace: e.dbName
          };
        g && (a = "/api/custom-collections/tree", r = {
          id: y,
          dbName: e.dbName
        });
        var i = {
          headers: {
            Authorization: n
          },
          params: r
        };
        s.default.get(a, i).then(function (e) {
          !t && e && e.data && W(e.data);
        }).catch(function (e) {
          console.log(e);
        });
      }(t), function () {
        t = !0;
      };
    }, []), (0, r.useEffect)(function () {
      var e = !1;
      return function (e) {
        if (!e && ie && ie.hash && "" !== ie.hash) {
          var t = ie.hash.substr(1);
          if (t && "" !== t) {
            var n = decodeURIComponent(t);
            D(n), b(n), oe(n);
          }
        }
      }(e), function () {
        e = !0;
      };
    }, [function () {
      if ("undefined" != typeof location && void 0 === ie) if (g) try {
        ie = (0, o.useLocation)();
      } catch (e) {
        console.log("reactUseLocation error", e);
      } else ie = location;
      return ie && ie.hash ? ie.hash : "";
    }()]), i.default.createElement("div", {
      className: "tree-view-search"
    }, i.default.createElement("form", null, i.default.createElement("div", {
      className: "form-group row"
    }, i.default.createElement("div", {
      className: "col-lg-4 col-md-4 col-sm-12 form-group mb-3"
    }, i.default.createElement("label", {
      className: ""
    }, "Chapter"), i.default.createElement(d.default, {
      className: "multi-select",
      options: R && R.tree && R.tree.length > 0 ? R.tree.map(function (e) {
        return {
          label: e.localizeTitle[f.langKey.toLowerCase()],
          value: e.nodeID
        };
      }) : [],
      value: I,
      onChange: z,
      labelledBy: "Select",
      disableSearch: !0
    })), i.default.createElement("div", {
      className: "col-lg-7 col-md-7 col-sm-12 form-group mb-3"
    }, i.default.createElement("label", {
      className: ""
    }, "Keywords"), i.default.createElement("input", {
      type: "search",
      className: "form-control",
      value: L,
      onChange: function (e) {
        b(e.target.value);
      },
      placeholder: "Keywords",
      autoComplete: "off"
    })), i.default.createElement("div", {
      className: "col-lg-1 mt-4 col-md-1 col-sm-12 form-group mb-3 text-right align-self-center"
    }, i.default.createElement("button", {
      type: "submit",
      className: "btn btn-bk-primary",
      onClick: function (e) {
        e.preventDefault(), oe(L);
      }
    }, "Search")))), i.default.createElement("div", {
      className: "row d-flex mb-3 border-bottom"
    }, i.default.createElement("div", {
      className: "col-lg-1 col-md-2 mr-auto col-sm-4 form-group align-self-center"
    }, i.default.createElement("strong", null, " ", E && E.length > -1 ? E.length + " results found" : "", " ")), i.default.createElement("div", {
      className: "col-lg-2 col-md-3 col-sm-4 form-group"
    }, i.default.createElement("label", {
      className: ""
    }, "Sort By"), i.default.createElement("select", {
      className: "form-select form-control",
      "aria-label": "sortby",
      value: Q,
      onChange: function (e) {
        ee(e.target.value);
      }
    }, i.default.createElement("option", {
      value: "relevance"
    }, "Relevance"), i.default.createElement("option", {
      value: "chapter"
    }, "Chapter"), i.default.createElement("option", {
      value: "articleNumber"
    }, "Article Number"), i.default.createElement("option", {
      value: "revisionDate"
    }, "Revision Date"))), i.default.createElement("div", {
      className: "col-lg-1 col-md-2 col-sm-4 form-group "
    }, i.default.createElement("label", {
      className: ""
    }, "Show"), i.default.createElement("select", {
      className: "form-control form-select",
      "aria-label": "show",
      onChange: function (e) {
        var t = e.target.value;
        U(t), G(Math.ceil(P.length / t)), x(P.slice(0, t));
      },
      value: B
    }, i.default.createElement("option", {
      value: 20
    }, "20"), i.default.createElement("option", {
      value: 40
    }, "40"), i.default.createElement("option", {
      value: 60
    }, "60"), i.default.createElement("option", {
      value: 80
    }, "80")))), i.default.createElement("table", {
      className: "table-borderless table-hover tbl-thm-01 table"
    }, i.default.createElement("tbody", null, E && E.map(function (e, t) {
      return se(e, t);
    }))), E && E.length > 0 && i.default.createElement("nav", {
      "aria-label": "Page navigation",
      className: "search-pagination-nav"
    }, i.default.createElement(u.default, {
      previousLabel: "Previous",
      nextLabel: "Next",
      breakLabel: "...",
      breakClassName: "search-pagination-break",
      pageCount: Z,
      marginPagesDisplayed: 2,
      pageRangeDisplayed: 2,
      onPageChange: function (e) {
        var t = e.selected,
          n = Math.ceil(t * B),
          a = Math.ceil((t + 1) * B);
        re(t), x(P.slice(n, a));
      },
      containerClassName: "search-pagination-container",
      subContainerClassName: "search-pagination-sub-container",
      activeClassName: "active",
      forcePage: ae
    })));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    r = n(0),
    i = s(r),
    o = s(n(3));
  function s(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  t.default = function (e) {
    var t = (0, r.useState)("0"),
      n = a(t, 2),
      s = n[0],
      l = n[1],
      d = "",
      u = [{
        EXPIRY_DATE: "2020-11-14T00:00:00.000Z",
        NEW_EXPIRY_DATE: null,
        NEW_PERIOD_ID: null,
        PERIOD_ID: "1",
        PRODUCT_ID: "1",
        STATUS: 1,
        SUBSCRIBED_DATE: "2020-11-13T00:00:00.000Z",
        SUBSCRIPTION_ID: "21",
        TRANSACTION_CODE: "0000620201113142948",
        UNSUBSCRIBED_DATE: null,
        USER_LOGIN_ID: "6"
      }, {
        EXPIRY_DATE: "2021-03-20T00:00:00.000Z",
        NEW_EXPIRY_DATE: null,
        NEW_PERIOD_ID: null,
        PERIOD_ID: "6",
        PRODUCT_ID: "8",
        STATUS: 1,
        SUBSCRIBED_DATE: "2020-03-20T00:00:00.000Z",
        SUBSCRIPTION_ID: "5",
        TRANSACTION_CODE: null,
        UNSUBSCRIBED_DATE: null,
        USER_LOGIN_ID: "6"
      }, {
        EXPIRY_DATE: "2021-03-20T00:00:00.000Z",
        NEW_EXPIRY_DATE: null,
        NEW_PERIOD_ID: null,
        PERIOD_ID: "6",
        PRODUCT_ID: "18",
        STATUS: 1,
        SUBSCRIBED_DATE: "2020-03-20T00:00:00.000Z",
        SUBSCRIPTION_ID: "6",
        TRANSACTION_CODE: null,
        UNSUBSCRIBED_DATE: null,
        USER_LOGIN_ID: "6"
      }, {
        EXPIRY_DATE: "2020-12-17T00:00:00.000Z",
        NEW_EXPIRY_DATE: null,
        NEW_PERIOD_ID: null,
        PERIOD_ID: "3",
        PRODUCT_ID: "2",
        STATUS: 1,
        SUBSCRIBED_DATE: "2020-11-17T00:00:00.000Z",
        SUBSCRIPTION_ID: "22",
        TRANSACTION_CODE: "0000620201117022704",
        UNSUBSCRIBED_DATE: null,
        USER_LOGIN_ID: "6"
      }, {
        EXPIRY_DATE: "2020-12-25T00:00:00.000Z",
        NEW_EXPIRY_DATE: null,
        NEW_PERIOD_ID: null,
        PERIOD_ID: "3",
        PRODUCT_ID: "19",
        STATUS: 1,
        SUBSCRIBED_DATE: "2020-11-25T00:00:00.000Z",
        SUBSCRIPTION_ID: "27",
        TRANSACTION_CODE: "0000620201125113518",
        UNSUBSCRIBED_DATE: null,
        USER_LOGIN_ID: "6"
      }, {
        EXPIRY_DATE: "2021-03-16T00:00:00.000Z",
        NEW_EXPIRY_DATE: null,
        NEW_PERIOD_ID: null,
        PERIOD_ID: "2",
        PRODUCT_ID: "3",
        STATUS: 1,
        SUBSCRIBED_DATE: "2021-03-09T00:00:00.000Z",
        SUBSCRIPTION_ID: "33",
        TRANSACTION_CODE: "0000620210309110832",
        UNSUBSCRIBED_DATE: null,
        USER_LOGIN_ID: "6"
      }, {
        EXPIRY_DATE: "2021-03-12T00:00:00.000Z",
        NEW_EXPIRY_DATE: null,
        NEW_PERIOD_ID: null,
        PERIOD_ID: "1",
        PRODUCT_ID: "9",
        STATUS: 1,
        SUBSCRIBED_DATE: "2021-03-11T00:00:00.000Z",
        SUBSCRIPTION_ID: "36",
        TRANSACTION_CODE: "0000620210311044314",
        UNSUBSCRIBED_DATE: null,
        USER_LOGIN_ID: "6"
      }, {
        EXPIRY_DATE: "2021-03-10T00:00:00.000Z",
        NEW_EXPIRY_DATE: null,
        NEW_PERIOD_ID: null,
        PERIOD_ID: "1",
        PRODUCT_ID: "7",
        STATUS: 1,
        SUBSCRIBED_DATE: "2021-03-09T00:00:00.000Z",
        SUBSCRIPTION_ID: "34",
        TRANSACTION_CODE: "0000620210309115610",
        UNSUBSCRIBED_DATE: null,
        USER_LOGIN_ID: "6"
      }, {
        EXPIRY_DATE: "2021-09-09T00:00:00.000Z",
        NEW_EXPIRY_DATE: null,
        NEW_PERIOD_ID: null,
        PERIOD_ID: "5",
        PRODUCT_ID: "13",
        STATUS: 1,
        SUBSCRIBED_DATE: "2021-03-09T00:00:00.000Z",
        SUBSCRIPTION_ID: "32",
        TRANSACTION_CODE: "0000620210309034220",
        UNSUBSCRIBED_DATE: null,
        USER_LOGIN_ID: "6"
      }];
    if ("undefined" != typeof window) {
      var c = window.location.pathname;
      c.length > 0 && (d = c.split("/")[1], console.log("currentLangKey: ", d));
    }
    return i.default.createElement("div", null, i.default.createElement("div", {
      className: "row"
    }, i.default.createElement("div", {
      className: "col-lg-3 col-md-3 col-sm-12 form-group mb-3"
    }, i.default.createElement("label", {
      className: ""
    }, "Payable Amount"), i.default.createElement("input", {
      className: "form-control",
      id: "subcriptionAmmount",
      value: s,
      pattern: "[0-9]*",
      onChange: function (e) {
        l(e.target.value);
      },
      placeholder: "Amount"
    })), i.default.createElement("div", {
      className: "col-lg-1 mt-4 col-md-1 col-sm-12 form-group mb-3 text-right align-self-center"
    }, i.default.createElement("button", {
      className: "btn btn-bk-primary",
      id: "subcriptionButton",
      onClick: function (e) {
        e.preventDefault(), function () {
          var e = 0;
          try {
            NaN === (e = Number(s)) && (e = 0);
          } catch (e) {
            console.log("error", e);
          }
          var t = {
              loginId: "6",
              paybleAmount: e,
              lang: d,
              subscriptions: u
            },
            n = {
              headers: {
                Authorization: localStorage.getItem("jwt-token")
              }
            };
          o.default.post("/api/web/subscription/product-subscription", t, n).then(function (e) {
            console.log("response", e.data), "undefined" != typeof window && (window.location = e.data.response_url);
          }).catch(function (e) {
            console.log("error", e);
          });
        }();
      }
    }, "Subscribe"))));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a,
    r = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    i = n(0),
    o = (a = i) && a.__esModule ? a : {
      default: a
    };
  t.default = function (e) {
    var t = void 0,
      n = (0, i.useState)(""),
      a = r(n, 2),
      s = a[0],
      l = a[1],
      d = (0, i.useState)(""),
      u = r(d, 2),
      c = u[0],
      m = u[1];
    return (0, i.useEffect)(function () {
      var e = !1;
      if (!e && t && t.length > 1) {
        var n = t.substr(1).split("&");
        n && n.length > 1 && (l(n[0]), m(n[1]));
      }
      return function () {
        e = !0;
      };
    }, [function () {
      "undefined" != typeof location && (t = location.hash);
      return t;
    }()]), s && "" !== s ? o.default.createElement("div", null, o.default.createElement("div", {
      className: "jumbotron jumbotron-flui"
    }, o.default.createElement("div", {
      class: "container"
    }, o.default.createElement("h1", {
      className: "display-6"
    }, "Transaction : ", c), o.default.createElement("p", {
      className: "lead"
    }, "Product subscription Transaction Reference No : ", s), o.default.createElement("hr", {
      className: "my-4"
    })))) : o.default.createElement("div", null);
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  t.default = {};
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a,
    r,
    i = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      }
      return e;
    },
    o = (a = ["\n    ", "\n"], r = ["\n    ", "\n"], Object.freeze(Object.defineProperties(a, {
      raw: {
        value: Object.freeze(r)
      }
    }))),
    s = c(n(0)),
    l = c(n(2)),
    d = c(n(172)),
    u = n(5);
  function c(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  var m = l.default.div(o, function (e) {
    if (e.customCSS) return e.customCSS;
  });
  t.default = s.default.memo(function (e) {
    var t = e.commonConfigs,
      n = e.data,
      a = n.data,
      r = n.styles,
      o = n.settings,
      l = t.isPreview,
      c = {},
      f = "",
      p = !1,
      _ = !1,
      h = !0,
      y = {},
      g = "100%",
      v = "100%";
    if (a) {
      var M = a.video;
      M && ((_ = M.isExternalUrl) ? (f = M.filePath, M.thumbnailFileURI, g = "640px", v = "360px") : (f = l ? M.filePath : "/videos/" + M.fileName, M.thumbnailFileURI));
    }
    return r && (c = (0, u.genarateComponentLevelStyleConfigurations)(r)), o && (p = !!o.autoPlay && o.autoPlay.value, h = !o.downloadable || o.downloadable.value, _ ? y = {} : h || (y = {
      file: {
        attributes: {
          controlsList: "nodownload"
        }
      }
    })), s.default.createElement(m, i({
      className: c.cssClass ? c.cssClass : ""
    }, c), d.default.canPlay(f) && s.default.createElement(d.default, {
      url: f,
      controls: !0,
      width: g,
      height: v,
      playing: p,
      config: y
    }));
  });
}, function (e, t, n) {
  "use strict";

  var a = n(300),
    r = {
      childContextTypes: !0,
      contextType: !0,
      contextTypes: !0,
      defaultProps: !0,
      displayName: !0,
      getDefaultProps: !0,
      getDerivedStateFromError: !0,
      getDerivedStateFromProps: !0,
      mixins: !0,
      propTypes: !0,
      type: !0
    },
    i = {
      name: !0,
      length: !0,
      prototype: !0,
      caller: !0,
      callee: !0,
      arguments: !0,
      arity: !0
    },
    o = {
      $$typeof: !0,
      compare: !0,
      defaultProps: !0,
      displayName: !0,
      propTypes: !0,
      type: !0
    },
    s = {};
  function l(e) {
    return a.isMemo(e) ? o : s[e.$$typeof] || r;
  }
  s[a.ForwardRef] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, s[a.Memo] = o;
  var d = Object.defineProperty,
    u = Object.getOwnPropertyNames,
    c = Object.getOwnPropertySymbols,
    m = Object.getOwnPropertyDescriptor,
    f = Object.getPrototypeOf,
    p = Object.prototype;
  e.exports = function e(t, n, a) {
    if ("string" != typeof n) {
      if (p) {
        var r = f(n);
        r && r !== p && e(t, r, a);
      }
      var o = u(n);
      c && (o = o.concat(c(n)));
      for (var s = l(t), _ = l(n), h = 0; h < o.length; ++h) {
        var y = o[h];
        if (!(i[y] || a && a[y] || _ && _[y] || s && s[y])) {
          var g = m(n, y);
          try {
            d(t, y, g);
          } catch (e) {}
        }
      }
    }
    return t;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.TutorialTreeViewComponent = void 0;
  var a = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    r = n(0),
    i = l(r),
    o = l(n(3)),
    s = n(9);
  function l(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  function d(e) {
    if (Array.isArray(e)) {
      for (var t = 0, n = Array(e.length); t < e.length; t++) n[t] = e[t];
      return n;
    }
    return Array.from(e);
  }
  t.TutorialTreeViewComponent = function (e) {
    var t = e.commonConfigs,
      n = e.data,
      l = (n.data, n.styles, n.settings),
      u = e.lang,
      c = l.tree,
      m = (c.uniqueId, c.value),
      f = (t.isEditMode, t.isPreview),
      p = (0, r.useState)(),
      _ = a(p, 2),
      h = _[0],
      y = _[1],
      g = (0, r.useState)(),
      v = a(g, 2),
      M = v[0],
      L = v[1],
      b = (0, r.useState)(0),
      w = a(b, 2),
      k = w[0],
      Y = (w[1], (0, r.useState)("")),
      D = a(Y, 2),
      S = D[0];
    D[1];
    (0, r.useEffect)(function () {
      var e = !1;
      return !e && m && "" !== m && T(e), function () {
        e = !0;
      };
    }, []);
    var T = function (t) {
        var n = localStorage.getItem("jwt-token"),
          a = "/api/tree",
          r = {
            id: m,
            nameSpace: e.dbName
          };
        f && (a = "/api/custom-collections/tree", r = {
          id: m,
          dbName: e.dbName
        });
        var i = {
          headers: {
            Authorization: n
          },
          params: r
        };
        o.default.get(a, i).then(function (e) {
          !t && e && e.data && y(e.data);
        }).catch(function (e) {
          console.log(e);
        });
      },
      E = function (e, t, n) {
        var a = "";
        n && e && e.nodeID && "" !== e.nodeID && (a = n + "/" + e.nodeID, t && t.length > 0 && (a = a + "/" + t.map(function (e) {
          return e + 1;
        }).join("-")));
        return a;
      },
      x = function (e) {
        "undefined" != typeof history && history.pushState && e && "" !== e && ((0, s.emitCustomEvent)("tutorialItemClicked", e), C());
      },
      C = function () {
        "undefined" != typeof location && window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      };
    return i.default.createElement(r.Fragment, null, i.default.createElement("div", {
      className: "tree-view-toolbar mb-3"
    }, i.default.createElement("button", {
      className: "toolbar-button expand",
      onClick: function () {
        L(function (e) {
          return void 0 === e || !e;
        });
      }
    }, M ? "ar" === u.langKey.toLowerCase() ? "طي الكل" : "Collapse All" : "ar" === u.langKey.toLowerCase() ? "اظهار الكل" : "Expand All")), h && h.tree && h.tree.length > 0 && i.default.createElement("div", {
      id: "treeViewAccordion",
      className: "scrollbar-02"
    }, h.tree.map(function (e, t) {
      var n = "collapse";
      return n = void 0 === M ? t === k ? "collapse show" : "collapse" : M ? "collapse show" : "collapse", i.default.createElement("div", {
        key: e.nodeID,
        className: "card"
      }, i.default.createElement("div", {
        className: "card-header btn",
        "data-toggle": "collapse",
        "data-target": "#collapseTreeCard" + t,
        "aria-expanded": "true",
        "aria-controls": "collapseTreeCard" + t,
        id: "treeViewCard" + t,
        onClick: function (n) {
          !function (e, t) {
            if (e && e.children && e.children.length > 0) {
              var n = e.children[0],
                a = h._id ? h._id : void 0,
                r = [].concat(d(t), [0]),
                i = E(n, r, a);
              x(i);
            }
          }(e, [t]);
        }
      }, "" + e.localizeTitle[u.langKey.toLowerCase()]), i.default.createElement("div", {
        id: "collapseTreeCard" + t,
        className: n,
        "aria-labelledby": "treeViewCard" + t,
        "data-parent": "#treeViewCard" + t
      }, i.default.createElement("div", {
        className: "card-body"
      }, function e(t, n) {
        return t && t.children && t.children.length > 0 ? i.default.createElement("ul", null, t.children.map(function (t, a) {
          var r = [].concat(d(n), [a]);
          if (function (e) {
            if (e) {
              if (e.children && e.children.length > 0) {
                for (var t = !0, n = 0; n < e.children.length; n++) {
                  var a = e.children[n];
                  if (a.children && a.children.length > 0) {
                    t = !1;
                    break;
                  }
                }
                return t;
              }
              return !1;
            }
            return !1;
          }(t)) {
            var o = h._id ? h._id : void 0,
              s = E(t, r, o),
              l = "#000000";
            return "" !== S && S === t.nodeID && (l = "#C6974B"), i.default.createElement("li", {
              key: t.nodeID
            }, i.default.createElement("a", {
              style: {
                color: l,
                cursor: "pointer"
              },
              onClick: function (e) {
                e.preventDefault(), x(s);
              }
            }, " " + t.localizeTitle[u.langKey.toLowerCase()]));
          }
          return i.default.createElement("li", {
            key: t.nodeID
          }, "" + t.localizeTitle[u.langKey.toLowerCase()], e(t, r));
        })) : i.default.createElement(i.default.Fragment, null);
      }(e, [t]))));
    })));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.TutorialViewComponent = void 0;
  var a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
    r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      }
      return e;
    },
    i = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    o = n(0),
    s = c(o),
    l = c(n(3)),
    d = n(9),
    u = (n(6), c(n(172)));
  function c(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  t.TutorialViewComponent = function (e) {
    var t = e.commonConfigs,
      n = e.data,
      c = (n.data, n.styles, n.settings),
      m = e.lang,
      f = (t.isEditMode, t.isPreview),
      p = (0, o.useState)(),
      _ = i(p, 2),
      h = (_[0], _[1]),
      y = (0, o.useState)(""),
      g = i(y, 2),
      v = g[0],
      M = g[1],
      L = (0, o.useState)(""),
      b = i(L, 2),
      w = (b[0], b[1]),
      k = (0, o.useState)(""),
      Y = i(k, 2),
      D = (Y[0], Y[1]),
      S = (0, o.useState)({}),
      T = i(S, 2),
      E = T[0],
      x = T[1],
      C = (0, o.useState)(""),
      j = i(C, 2),
      P = j[0],
      N = j[1];
    (0, d.useCustomEventListener)("tutorialItemClicked", function (e) {
      M(e);
    }), (0, o.useEffect)(function () {
      return v && "" !== v && H(v), function () {
        !0;
      };
    }, [v]), (0, o.useEffect)(function () {
      return z(), function () {
        !0;
      };
    }, []);
    var H = function (e) {
        if (console.log("===== Testing ======"), e && "" !== e) {
          var t = e.split("/");
          if (t && t.length >= 2) {
            var n = t[0],
              a = t[1],
              r = "";
            t.length >= 3 && (r = t[2]), O({
              treeId: n,
              nodeId: a,
              nodePath: r
            });
          }
        }
      },
      O = function (t) {
        if (t) {
          var n = localStorage.getItem("jwt-token"),
            a = "/api/tree/collection",
            i = r({
              nameSpace: e.dbName
            }, t);
          f && (a = "/api/custom-collections/tree/collection", i = r({
            dbName: e.dbName
          }, t));
          var o = {
            headers: {
              Authorization: n
            },
            params: i
          };
          l.default.get(a, o).then(function (e) {
            I(e.data), h(e.data);
          }).catch(function (e) {
            console.log(e);
          });
        }
      },
      I = function (e) {
        var t = {},
          n = "",
          r = {};
        r = "EN" == m.langKey ? e.data[0].data.fieldData.EN ? e.data[0].data.fieldData.EN : {} : e.data[0].data.fieldData.AR ? e.data[0].data.fieldData.AR : {};
        for (var i = 0; i < Object.keys(r).length; i++) {
          var o = Object.keys(r),
            s = Object.values(r);
          if ("object" == a(s[i])) "video" != o[i] && "image" != o[i] || "" == s[i].fileName ? "external" == o[i] && (n = o[i], t = {
            fileName: s[i]
          }) : (n = o[i], t = s[i]);else {
            var l = s[i].replace(/(>|<)/gi, "").split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/),
              d = s[i].split("/").pop().split(".").pop();
            "https://www.youtube.com/watch?" == l[0] ? (t = {
              fileName: s[i]
            }, n = "youtube") : "pdf" == d && (console.log("This is a pdf", s[i]), t = {
              fileName: s[i]
            }, n = "pdf");
          }
        }
        x(t), N(n);
      },
      z = function () {
        if (c && c.customReport) {
          var e = c.customReport,
            t = e.collection,
            n = e.documentId,
            a = e.documentField,
            r = {
              headers: {
                Authorization: localStorage.getItem("jwt-token")
              },
              params: {
                nameSpace: params.dbName,
                searchId: n,
                collectionName: t
              }
            };
          l.default.get("/api/cms/getSingleDocumentById", r).then(function (e) {
            if (e.data) {
              var t = e.data.fieldData[m.langKey],
                n = "",
                r = "";
              t && t[a] ? (n = t[a], r = t.entry_name) : e.data.fieldData.EN && e.data.fieldData.EN[a] && (n = e.data.fieldData.EN[a], r = e.data.fieldData.EN.entry_name), w(n), D(r);
            }
          }).catch(function (e) {
            console.log(e);
          });
        }
      };
    return s.default.createElement(o.Fragment, null, s.default.createElement("div", {
      className: "row"
    }), E && s.default.createElement("div", {
      id: "accordionDetailed"
    }, P && ("video" == P || "external" == P) && u.default.canPlay(E.filePath) && s.default.createElement(u.default, {
      url: f ? E.filePath : "/videos/" + E.fileName,
      controls: !0,
      width: "640px",
      height: "360px",
      playing: !1,
      config: {}
    })), E && s.default.createElement("div", {
      id: "accordionDetailed"
    }, P && "image" == P && s.default.createElement("img", {
      src: E.filePath,
      width: "640px",
      height: "360px"
    })), E && s.default.createElement("div", {
      id: "accordionDetailed"
    }, P && "youtube" == P && u.default.canPlay(E.fileName) && s.default.createElement(u.default, {
      url: E.fileName,
      controls: !0,
      width: "640px",
      height: "360px",
      playing: !1,
      config: {}
    })), E && s.default.createElement("div", {
      id: "accordionDetailed"
    }, P && "pdf" == P && s.default.createElement("object", {
      data: E.fileName,
      type: "application/pdf",
      width: "100%",
      height: "640px"
    }, s.default.createElement("iframe", {
      src: E.fileName,
      width: "100%",
      height: "640px"
    }))));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.LinkDropdownComponent = void 0;
  var a = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    r = n(0),
    i = l(r),
    o = l(n(3)),
    s = n(7);
  function l(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  t.LinkDropdownComponent = function (e) {
    var t = e.dbName,
      n = e.data,
      l = n.data,
      d = (n.styles, n.settings),
      u = (0, r.useState)([]),
      c = a(u, 2),
      m = c[0],
      f = c[1],
      p = (0, r.useState)(""),
      _ = a(p, 2),
      h = _[0],
      y = _[1],
      g = (0, r.useState)(""),
      v = a(g, 2),
      M = v[0],
      L = v[1],
      b = e.lang,
      w = void 0,
      k = "";
    d && (w = d.collection), void 0 !== l && (k = l.linkDropdown), (0, r.useEffect)(function () {
      w && (y((0, s.v1)()), Y());
    }, []);
    var Y = function () {
      var e = w.externalParams.dataSourceUrl,
        n = {
          headers: {},
          params: {
            nameSpace: t,
            collectionName: w.value.customeCollectionName,
            sorter: JSON.stringify({
              _id: -1
            }),
            searchQuery: JSON.stringify({
              active: !0
            })
          }
        };
      o.default.get(e, n).then(function (e) {
        if (200 === e.status && e.data.length > 0) {
          var t = e.data.map(function (e, t) {
            var n = e._id,
              r = e.fieldData[b.langKey];
            r.dropdown_name && L(r.dropdown_name);
            var i = {
              id: n,
              dropdownItem: {}
            };
            return k && k.features && r && Object.entries(k.features).map(function (e, t) {
              var n = a(e, 2),
                o = n[0],
                s = n[1].mappingField;
              i.dropdownItem[o] = r[s];
            }), i;
          });
          f(t);
        }
      });
    };
    return i.default.createElement(r.Fragment, null, i.default.createElement("div", {
      class: "dropdown show"
    }, i.default.createElement("a", {
      class: "btn btn-secondary dropdown-toggle",
      href: "#",
      role: "button",
      id: "dropdownMenuLink",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }, M || "Web Sites"), i.default.createElement("div", {
      class: "dropdown-menu",
      "aria-labelledby": "dropdownMenuLink"
    }, m.map(function (e, t) {
      return i.default.createElement(r.Fragment, null, function (e) {
        return !!(e && e.dropdownItem && e.dropdownItem.link);
      }(e) && i.default.createElement("a", {
        key: h + "" + e.dropdownItem.name,
        class: "dropdown-item",
        href: e.dropdownItem.link
      }, e.dropdownItem.name));
    }))));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      }
      return e;
    },
    r = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    i = n(0),
    o = u(i),
    s = u(n(3)),
    l = n(5),
    d = u(n(30));
  function u(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  t.default = function (e) {
    var t = "",
      n = void 0,
      u = void 0,
      c = void 0,
      m = (e.commonConfigs, e.dbName, e.lang),
      f = e.data,
      p = f.data,
      _ = f.styles,
      h = f.settings;
    _ && (0, l.genarateComponentLevelStyleConfigurations)(_), h && (n = h.collection, u = h.recordsLimit ? h.recordsLimit.value : void 0, c = h.recordsOrder ? h.recordsOrder.value : void 0), void 0 !== p && (t = p.newsList);
    var y = (0, i.useState)([]),
      g = r(y, 2),
      v = g[0],
      M = g[1];
    return (0, i.useEffect)(function () {
      var a = !0;
      if (a && n) {
        var i = n,
          o = i.externalParams,
          l = i.value;
        if (o && l && e.dbName) {
          var d = o.dataSourceUrl,
            f = l.customeCollectionName;
          d && "string" == typeof d && f && "string" == typeof f && function (e, n, a) {
            var i = {
              headers: {},
              params: {
                nameSpace: e,
                collectionName: a,
                sorter: JSON.stringify({
                  _id: -1
                }),
                limit: u || 0,
                searchQuery: JSON.stringify({
                  active: !0
                })
              }
            };
            s.default.get(n, i).then(function (n) {
              if (200 === n.status && n.data.length > 0) {
                var a = [];
                if ("desc" === c) {
                  var i = 0;
                  u > 0 && n.data.length - u > 0 && (i = n.data.length - u);
                  for (var o = n.data.length - 1; o >= i; o--) {
                    var s = n.data[o];
                    a.push(s);
                  }
                } else {
                  var l = n.data.length;
                  u > 0 && n.data.length > u && (l = u);
                  for (var d = 0; d < l; d++) {
                    var f = n.data[d];
                    a.push(f);
                  }
                }
                var p = a.map(function (n, a) {
                  var i = n._id,
                    o = n.fieldData[m.langKey],
                    s = {
                      id: i,
                      news: {}
                    };
                  return t && t.features && o && Object.entries(t.features).map(function (t, n) {
                    var a = r(t, 2),
                      i = a[0],
                      l = a[1].mappingField;
                    if (s.news[i] = o[l], "blogListItemImg" === i) {
                      var d = o[l] ? "/api/documents/" + e + "/" + o[l] : "#";
                      s.news[i] = d;
                    }
                    if ("blogListItemPostLabelImg" === i) {
                      var u = o[l] ? "/api/documents/" + e + "/" + o[l] : "#";
                      s.news[i] = u;
                    }
                    if ("blogListItemPostDescription" === i) {
                      var c = o[l] ? o[l].slice(0, 299) + " ..." : "";
                      s.news[i] = c;
                    }
                  }), s;
                });
                M(p);
              }
            });
          }(e.dbName, d, f);
        }
      }
      return function () {
        a = !1;
      };
    }, []), v && Array.isArray(v) && v.length > 0 ? o.default.createElement("div", null, v.map(function (t, n) {
      var r = t.id,
        i = t.news;
      return o.default.createElement("div", {
        key: r
      }, o.default.createElement(d.default, a({}, i, {
        isNewsList: !0,
        lang: e.lang
      })));
    })) : o.default.createElement(o.default.Fragment, null);
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.SubscribeComponent = void 0;
  var a,
    r,
    i = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    o = (a = ["\n    background-color : #fefefe ;\n    text-align : center ;\n    padding : 16px ;\n    border-radius : 4px ;\n\n    .subscribe{\n        display : grid ;\n        grid-template-columns : auto 100px ;\n        margin : 32px\n\n        input{\n            border-radius : 4px 0px 0px 4px !important ;\n        }\n\n        .send-button{\n            background-color : #DDDDDD ;\n            border-radius : 0px 4px 4px 0px;\n            color : #ffffff !important ;\n\n            .loader {\n                border: 2px solid #f3f3f3; /* Light grey */\n                border-top: 2px solid #3498db; /* Blue */\n                border-radius: 50%;\n                width: 20px;\n                height: 20px;\n                animation: spin 2s linear infinite;\n            }\n              \n            @keyframes spin {\n                0% { transform: rotate(0deg); }\n                100% { transform: rotate(360deg); }\n              }\n        }\n    }\n"], r = ["\n    background-color : #fefefe ;\n    text-align : center ;\n    padding : 16px ;\n    border-radius : 4px ;\n\n    .subscribe{\n        display : grid ;\n        grid-template-columns : auto 100px ;\n        margin : 32px\n\n        input{\n            border-radius : 4px 0px 0px 4px !important ;\n        }\n\n        .send-button{\n            background-color : #DDDDDD ;\n            border-radius : 0px 4px 4px 0px;\n            color : #ffffff !important ;\n\n            .loader {\n                border: 2px solid #f3f3f3; /* Light grey */\n                border-top: 2px solid #3498db; /* Blue */\n                border-radius: 50%;\n                width: 20px;\n                height: 20px;\n                animation: spin 2s linear infinite;\n            }\n              \n            @keyframes spin {\n                0% { transform: rotate(0deg); }\n                100% { transform: rotate(360deg); }\n              }\n        }\n    }\n"], Object.freeze(Object.defineProperties(a, {
      raw: {
        value: Object.freeze(r)
      }
    }))),
    s = n(0),
    l = c(s),
    d = c(n(2)),
    u = c(n(3));
  function c(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  var m = d.default.div(o);
  t.SubscribeComponent = function (e) {
    var t = e.dbName,
      n = (0, s.useState)(""),
      a = i(n, 2),
      r = a[0],
      o = a[1],
      d = (0, s.useState)(!1),
      c = i(d, 2),
      f = c[0],
      p = c[1],
      _ = (0, s.useState)("Success"),
      h = i(_, 2),
      y = h[0],
      g = h[1],
      v = (0, s.useState)("N/A"),
      M = i(v, 2),
      L = M[0],
      b = M[1],
      w = (0, s.useState)("N/A"),
      k = i(w, 2),
      Y = k[0],
      D = k[1],
      S = (0, s.useState)(!1),
      T = i(S, 2),
      E = T[0],
      x = T[1];
    function C(e, t, n) {
      x(!0), g(e), b(t), D(n);
    }
    return l.default.createElement(m, null, E ? l.default.createElement("div", {
      className: "row"
    }, l.default.createElement("div", {
      className: "col-md-12"
    }, l.default.createElement("div", {
      className: "alert " + y + " alert-dismissible fade show mt-2",
      role: "alert"
    }, l.default.createElement("strong", null, " ", L, " "), " ", Y, l.default.createElement("button", {
      type: "button",
      className: "close",
      "data-dismiss": "alert",
      "aria-label": "Close",
      onClick: function () {
        x(!1);
      }
    }, l.default.createElement("span", {
      "aria-hidden": "true"
    }, "×"))))) : null, l.default.createElement("form", {
      onSubmit: function (e) {
        e.preventDefault(), p(!0), console.log(f), setTimeout(function () {}, 5e3);
        r.match("^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9]+.[a-zA-Z0-9.]+$") ? (!function (e) {
          var n = {
            headers: {
              Authorization: localStorage.getItem("jwt-token")
            },
            dbName: t,
            subscriber: e
          };
          u.default.post("/api/subscribers/add", n).then(function (e) {
            console.log(e), o(""), C("error" === e.data.status ? "alert-danger" : "alert-success", e.data.status, e.data.msg), setTimeout(function () {
              x(!1);
            }, 5e3);
          }).catch(function (e) {
            e.status;
            C("alert-danger", "error", e.msg), setTimeout(function () {
              x(!1);
            }, 5e3);
          });
        }(r), o("")) : alert("Provide a valid email address!"), p(!1), console.log(f);
      }
    }, l.default.createElement("div", {
      className: "subscribe"
    }, l.default.createElement("div", {
      className: "input-group"
    }, l.default.createElement("input", {
      type: "text",
      className: "form-control",
      id: "subscribe",
      name: "subscribe",
      onChange: function (e) {
        return function (e) {
          o(e), "" != r && p(!1);
        }(e.target.value);
      },
      value: r
    })), l.default.createElement("div", {
      className: "send-button"
    }, l.default.createElement("button", {
      disabled: f,
      type: "submit",
      className: "btn btn-bk-primary"
    }, f ? l.default.createElement("div", {
      class: "loader"
    }) : "SEND")))));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    r = n(0),
    i = l(r),
    o = l(n(3)),
    s = l(n(312));
  function l(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  t.default = function (e) {
    var t = (0, r.useState)([]),
      n = a(t, 2),
      l = n[0],
      d = n[1],
      u = (0, r.useState)(null),
      c = a(u, 2),
      m = c[0],
      f = c[1],
      p = (0, r.useState)(Math.random()),
      _ = a(p, 2),
      h = _[0],
      y = _[1];
    (0, r.useEffect)(function () {
      g();
    }, []);
    var g = function () {
        o.default.get("/api/rss-feed/get", {
          headers: {}
        }).then(function (e) {
          var t = e.data.items.map(function (e) {
            var t = v(e.published),
              n = M(e.published),
              a = L(e.title, 0),
              r = L(e.description, 1);
            return {
              date: t,
              time: n,
              image: L(e.enclosures[0].url, 0),
              title: a,
              body: r,
              category: e.category[0]
            };
          });
          d(t), f(t[0]);
        }).catch(function (e) {
          console.log(e);
        });
      },
      v = function (e) {
        var t = new Date(e);
        return t.toLocaleString("en-us", {
          month: "long"
        }) + " " + t.getDate() + ", " + t.getUTCFullYear();
      },
      M = function (e) {
        return new Date(e).toLocaleString("en-US", {
          hour: "numeric",
          minute: "numeric",
          hour12: !0
        });
      },
      L = function (e, t) {
        var n = document.createElement("textarea"),
          a = document.createElement("div");
        a.innerHTML = e, n.innerHTML = a.innerText;
        var r = n.innerText;
        return 1 == t && (r = (r = r.split("\n")).filter(function (e) {
          return e.length > 1;
        })), r;
      };
    return i.default.createElement("div", null, i.default.createElement("div", {
      className: "row align-items-stretch"
    }, l.map(function (e, t) {
      return i.default.createElement("div", {
        className: "col-lg-3 col-md-6 col-sm-12 col-xs-12 mb-3",
        key: e.title
      }, i.default.createElement("div", {
        className: "card m-1 h-100 align-items-stretch",
        onClick: function () {
          return function (e) {
            y(Math.random()), f(e);
          }(e);
        },
        "data-toggle": "modal",
        "data-target": "#newsModal",
        style: {
          cursor: "pointer"
        }
      }, i.default.createElement("img", {
        className: "card-img-top bg-dark w-100",
        src: e.image,
        alt: "Thumbnail not available",
        style: {
          height: "200px",
          objectFit: "cover"
        }
      }), i.default.createElement("div", {
        className: "card-body h-100",
        style: {
          minHeight: "150px"
        }
      }, i.default.createElement("p", {
        className: "card-text text-warning"
      }, e.category || ""), i.default.createElement("p", {
        className: "card-text text-muted"
      }, e.title || "description not available")), i.default.createElement("div", {
        className: "row justify-content-between m-1"
      }, i.default.createElement("p", {
        className: "card-text text-muted ml-3"
      }, e.date || "date not available"), i.default.createElement("p", {
        className: "card-text text-muted text-right mr-3"
      }, e.time || ""))));
    })), m && i.default.createElement(s.default, {
      news: m,
      tempVar: h
    }));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    r = n(0),
    i = s(r),
    o = s(n(3));
  function s(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  t.default = function (e) {
    var t = (0, r.useState)(null),
      n = a(t, 2),
      s = n[0],
      l = n[1];
    (0, r.useEffect)(function () {
      d();
    }, []);
    var d = function () {
        o.default.get("/api/rss-feed/get", {
          headers: {}
        }).then(function (e) {
          var t = e.data.items.map(function (e) {
            var t = u(e.published),
              n = c(e.published),
              a = m(e.title, 0),
              r = m(e.description, 1);
            return {
              date: t,
              time: n,
              image: m(e.enclosures[0].url, 0),
              title: a,
              body: r,
              category: e.category[0]
            };
          });
          l(t[0]);
        }).catch(function (e) {
          console.log(e);
        });
      },
      u = function (e) {
        var t = new Date(e);
        return t.toLocaleString("en-us", {
          month: "long"
        }) + " " + t.getDate() + ", " + t.getUTCFullYear();
      },
      c = function (e) {
        return new Date(e).toLocaleString("en-US", {
          hour: "numeric",
          minute: "numeric",
          hour12: !0
        });
      },
      m = function (e, t) {
        var n = document.createElement("textarea"),
          a = document.createElement("div");
        a.innerHTML = e, n.innerHTML = a.innerText;
        var r = n.innerText;
        return 1 == t && (r = (r = r.split("\n")).filter(function (e) {
          return e.length > 1;
        })), r;
      };
    return i.default.createElement("div", null, null !== s ? i.default.createElement("div", {
      className: "news-page-header"
    }, i.default.createElement("img", {
      className: "top-news-background w-100",
      src: s.image
    }), null !== s ? i.default.createElement("div", {
      className: "news-page-content"
    }, i.default.createElement("div", {
      className: "news-page-title"
    }, " ", s.title, " "), i.default.createElement("button", {
      className: "btn bcp-btn-primary mt-2",
      "data-toggle": "modal",
      "data-target": "#topNewsModal"
    }, " Learn More ")) : null) : null, i.default.createElement("div", {
      className: "modal news-modal fade bg-white",
      id: "topNewsModal",
      tabIndex: "-1",
      role: "dialog",
      "aria-labelledby": "newsModalTitle",
      "aria-hidden": "true"
    }, i.default.createElement("div", {
      className: "modal-dialog modal-dialog-centered modal-xl",
      role: "document"
    }, i.default.createElement("div", {
      className: "modal-content"
    }, i.default.createElement("div", {
      className: "modal-header"
    }, i.default.createElement("button", {
      type: "button",
      className: "close",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }, i.default.createElement("span", {
      "aria-hidden": "true"
    }, "×"))), i.default.createElement("div", {
      className: "modal-body"
    }, null != s && s.body ? i.default.createElement("div", null, i.default.createElement("div", {
      className: "news-detail-header mb-3"
    }, i.default.createElement("img", {
      className: "news-background w-100",
      src: s.image
    }), i.default.createElement("div", {
      className: "news-detail-content"
    }, i.default.createElement("div", {
      className: "news-detail-title"
    }, s.title || "title not available"), i.default.createElement("div", {
      className: "news-detail-date"
    }, i.default.createElement("span", {
      className: "news-detail-date-icon"
    }), " ", s.date || "N/A", " "))), i.default.createElement("div", {
      className: "news-detail-body"
    }, i.default.createElement("div", {
      className: "container"
    }, s.body.map(function (e) {
      return i.default.createElement("p", null, e);
    })))) : null)))));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a,
    r,
    i = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    o = (a = ["\n    .transitionCard {\n        position: relative;\n        transition: all .5s ease-in;\n    }\n    \n    .transitionCardImage {\n        display: block;\n        width: 100%;\n        height: auto;\n    }\n    \n    .transitionCardOverlay {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        height: 100%;\n        width: 100%;\n        opacity: 0;\n        visibility: none;\n        transition: .5s ease;\n        background-color: ", ";\n    }\n    \n    .transitionCard:hover .transitionCardOverlay {\n        opacity: ", ";\n    }\n    \n    .transitionCardDescription {\n        color: white;\n        font-size: 20px;\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        -webkit-transform: translate(-50%, -50%);\n        -ms-transform: translate(-50%, -50%);\n        transform: translate(-50%, -50%);\n        text-align: center;\n    }\n"], r = ["\n    .transitionCard {\n        position: relative;\n        transition: all .5s ease-in;\n    }\n    \n    .transitionCardImage {\n        display: block;\n        width: 100%;\n        height: auto;\n    }\n    \n    .transitionCardOverlay {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        height: 100%;\n        width: 100%;\n        opacity: 0;\n        visibility: none;\n        transition: .5s ease;\n        background-color: ", ";\n    }\n    \n    .transitionCard:hover .transitionCardOverlay {\n        opacity: ", ";\n    }\n    \n    .transitionCardDescription {\n        color: white;\n        font-size: 20px;\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        -webkit-transform: translate(-50%, -50%);\n        -ms-transform: translate(-50%, -50%);\n        transform: translate(-50%, -50%);\n        text-align: center;\n    }\n"], Object.freeze(Object.defineProperties(a, {
      raw: {
        value: Object.freeze(r)
      }
    }))),
    s = n(0),
    l = u(s),
    d = u(n(2));
  function u(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  t.default = function (e) {
    var t = (0, s.useState)({
        image: "",
        description: "",
        opacity: "",
        color: "",
        link: ""
      }),
      n = i(t, 2),
      a = n[0],
      r = n[1];
    (0, s.useEffect)(function () {
      u();
    }, []);
    var u = function () {
        var t = {
          image: e.data.data.image_1 ? e.data.data.image_1.filePath : "",
          description: e.data.data.content_1 ? e.data.data.content_1 : "",
          link: e.data.data.boundUrl ? e.data.data.boundUrl : "",
          opacity: e.data.settings.opacity ? e.data.settings.opacity.value : "0",
          color: e.data.settings.overlaycolor ? e.data.settings.overlaycolor.value : "#FFFFFF"
        };
        r(t);
      },
      c = d.default.div(o, a.color, a.opacity);
    return l.default.createElement(c, null, l.default.createElement("div", {
      className: "transitionCard"
    }, l.default.createElement("img", {
      src: a.image,
      className: "transitionCardImage",
      alt: "none"
    }), l.default.createElement("div", {
      className: "transitionCardOverlay"
    }, l.default.createElement("div", {
      className: "transitionCardOverlayInner"
    }, l.default.createElement("div", {
      className: "transitionCardDescription"
    }, l.default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: a.description
      }
    }))))));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.TestimonialComponent = void 0;
  var a,
    r,
    i = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    o = (a = ["\n    .carousel .control-arrow,\n    .carousel.carousel-slider .control-arrow {\n        -webkit-transition: all 0.25s ease-in;\n        -moz-transition: all 0.25s ease-in;\n        -ms-transition: all 0.25s ease-in;\n        -o-transition: all 0.25s ease-in;\n        transition: all 0.25s ease-in;\n        opacity: 0.4;\n        filter: alpha(opacity=40);\n        position: absolute;\n        z-index: 2;\n        top: 20px;\n        background: none;\n        border: 0;\n        font-size: 32px;\n        cursor: pointer;\n    }\n    .carousel .control-arrow:focus,\n    .carousel .control-arrow:hover {\n        opacity: 1;\n        filter: alpha(opacity=100);\n    }\n    .carousel .control-arrow:before,\n    .carousel.carousel-slider .control-arrow:before {\n        margin: 0 5px;\n        display: inline-block;\n        border-top: 8px solid transparent;\n        border-bottom: 8px solid transparent;\n        content: '';\n    }\n    .carousel .control-disabled.control-arrow {\n        opacity: 0;\n        filter: alpha(opacity=0);\n        cursor: inherit;\n        display: none;\n    }\n    .carousel .control-prev.control-arrow {\n        left: 0;\n    }\n    .carousel .control-prev.control-arrow:before {\n        border-right: 8px solid #fff;\n    }\n    .carousel .control-next.control-arrow {\n        right: 0;\n    }\n    .carousel .control-next.control-arrow:before {\n        border-left: 8px solid #fff;\n    }\n\n    .carousel-root {\n        outline: none;\n    }\n\n    .carousel {\n        position: relative;\n        width: 100%;\n    }\n    .carousel * {\n        -webkit-box-sizing: border-box;\n        -moz-box-sizing: border-box;\n        box-sizing: border-box;\n    }\n    .carousel img {\n        width: 100%;\n        display: inline-block;\n        pointer-events: none;\n    }\n    .carousel .carousel {\n        position: relative;\n    }\n    .carousel .control-arrow {\n        outline: 0;\n        border: 0;\n        background: none;\n        top: 50%;\n        margin-top: -13px;\n        font-size: 18px;\n    }\n    .carousel .thumbs-wrapper {\n        margin: 20px;\n        overflow: hidden;\n    }\n    .carousel .thumbs {\n        -webkit-transition: all 0.15s ease-in;\n        -moz-transition: all 0.15s ease-in;\n        -ms-transition: all 0.15s ease-in;\n        -o-transition: all 0.15s ease-in;\n        transition: all 0.15s ease-in;\n        -webkit-transform: translate3d(0, 0, 0);\n        -moz-transform: translate3d(0, 0, 0);\n        -ms-transform: translate3d(0, 0, 0);\n        -o-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0);\n        position: relative;\n        list-style: none;\n        white-space: nowrap;\n    }\n    .carousel .thumb {\n        -webkit-transition: border 0.15s ease-in;\n        -moz-transition: border 0.15s ease-in;\n        -ms-transition: border 0.15s ease-in;\n        -o-transition: border 0.15s ease-in;\n        transition: border 0.15s ease-in;\n        display: inline-block;\n        margin-right: 6px;\n        white-space: nowrap;\n        overflow: hidden;\n        border: 3px solid #fff;\n        padding: 2px;\n    }\n    .carousel .thumb:focus {\n        border: 3px solid #ccc;\n        outline: none;\n    }\n    .carousel .thumb.selected,\n    .carousel .thumb:hover {\n        border: 3px solid #333;\n    }\n    .carousel .thumb img {\n        vertical-align: top;\n    }\n    .carousel.carousel-slider {\n        position: relative;\n        margin: 0;\n        overflow: hidden;\n    }\n    .carousel.carousel-slider .control-arrow {\n        top: 0;\n        color: #fff;\n        font-size: 26px;\n        bottom: 0;\n        margin-top: 0;\n        padding: 5px;\n    }\n    .carousel.carousel-slider .control-arrow:hover {\n        background: rgba(0, 0, 0, 0.2);\n    }\n    .carousel .slider-wrapper {\n        overflow: hidden;\n        margin: auto;\n        width: 100%;\n        -webkit-transition: height 0.15s ease-in;\n        -moz-transition: height 0.15s ease-in;\n        -ms-transition: height 0.15s ease-in;\n        -o-transition: height 0.15s ease-in;\n        transition: height 0.15s ease-in;\n    }\n    .carousel .slider-wrapper.axis-horizontal .slider {\n        -ms-box-orient: horizontal;\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -moz-flex;\n        display: -webkit-flex;\n        display: flex;\n    }\n    .carousel .slider-wrapper.axis-horizontal .slider .slide {\n        flex-direction: column;\n        flex-flow: column;\n    }\n    .carousel .slider-wrapper.axis-vertical {\n        -ms-box-orient: horizontal;\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -moz-flex;\n        display: -webkit-flex;\n        display: flex;\n    }\n    .carousel .slider-wrapper.axis-vertical .slider {\n        -webkit-flex-direction: column;\n        flex-direction: column;\n    }\n    .carousel .slider {\n        margin: 0;\n        padding: 0;\n        position: relative;\n        list-style: none;\n        width: 100%;\n    }\n    .carousel .slider.animated {\n        -webkit-transition: all 1s ease-in-out;\n        -moz-transition: all 1s ease-in-out;\n        -ms-transition: all 1s ease-in-out;\n        -o-transition: all 1s ease-in-out;\n        transition: all 1s ease-in-out;\n    }\n    .carousel .slide {\n        min-width: 100%;\n        margin: 0;\n        position: relative;\n        text-align: center;\n    }\n    .carousel .slide img {\n        width: 100%;\n        vertical-align: top;\n        border: 0;\n    }\n    .carousel .slide iframe {\n        display: inline-block;\n        width: calc(100% - 80px);\n        margin: 0 40px 40px;\n        border: 0;\n    }\n    .carousel .slide .legend {\n        -webkit-transition: all 0.5s ease-in-out;\n        -moz-transition: all 0.5s ease-in-out;\n        -ms-transition: all 0.5s ease-in-out;\n        -o-transition: all 0.5s ease-in-out;\n        transition: all 0.5s ease-in-out;\n        position: absolute;\n        bottom: 40px;\n        left: 50%;\n        margin-left: -45%;\n        width: 90%;\n        border-radius: 10px;\n        background: #000;\n        color: #fff;\n        padding: 10px;\n        font-size: 12px;\n        text-align: center;\n        opacity: 0.25;\n        -webkit-transition: opacity 1s ease-in-out;\n        -moz-transition: opacity 1s ease-in-out;\n        -ms-transition: opacity 1s ease-in-out;\n        -o-transition: opacity 1s ease-in-out;\n        transition: opacity 1s ease-in-out;\n    }\n    .carousel .control-dots {\n        position: absolute;\n        bottom: 0;\n        margin: 10px 0;\n        padding: 0;\n        text-align: center;\n        width: 100%;\n        z-index: 1;\n    }\n    @media (min-width: 960px) {\n        .carousel .control-dots {\n            bottom: 0;\n        }\n    }\n    .carousel .control-dots .dot {\n        -webkit-transition: opacity 0.25s ease-in;\n        -moz-transition: opacity 0.25s ease-in;\n        -ms-transition: opacity 0.25s ease-in;\n        -o-transition: opacity 0.25s ease-in;\n        transition: opacity 0.25s ease-in;\n        opacity: 0.3;\n        filter: alpha(opacity=30);\n        box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.9);\n        background: #fff;\n        border-radius: 50%;\n        width: 8px;\n        height: 8px;\n        cursor: pointer;\n        display: inline-block;\n        margin: 0 8px;\n    }\n    .carousel .control-dots .dot.selected,\n    .carousel .control-dots .dot:hover {\n        opacity: 1;\n        filter: alpha(opacity=100);\n    }\n    .carousel .carousel-status {\n        position: absolute;\n        top: 0;\n        right: 0;\n        padding: 5px;\n        font-size: 10px;\n        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.9);\n        color: #fff;\n    }\n    .carousel:hover .slide .legend {\n        opacity: 1;\n    }\n"], r = ["\n    .carousel .control-arrow,\n    .carousel.carousel-slider .control-arrow {\n        -webkit-transition: all 0.25s ease-in;\n        -moz-transition: all 0.25s ease-in;\n        -ms-transition: all 0.25s ease-in;\n        -o-transition: all 0.25s ease-in;\n        transition: all 0.25s ease-in;\n        opacity: 0.4;\n        filter: alpha(opacity=40);\n        position: absolute;\n        z-index: 2;\n        top: 20px;\n        background: none;\n        border: 0;\n        font-size: 32px;\n        cursor: pointer;\n    }\n    .carousel .control-arrow:focus,\n    .carousel .control-arrow:hover {\n        opacity: 1;\n        filter: alpha(opacity=100);\n    }\n    .carousel .control-arrow:before,\n    .carousel.carousel-slider .control-arrow:before {\n        margin: 0 5px;\n        display: inline-block;\n        border-top: 8px solid transparent;\n        border-bottom: 8px solid transparent;\n        content: '';\n    }\n    .carousel .control-disabled.control-arrow {\n        opacity: 0;\n        filter: alpha(opacity=0);\n        cursor: inherit;\n        display: none;\n    }\n    .carousel .control-prev.control-arrow {\n        left: 0;\n    }\n    .carousel .control-prev.control-arrow:before {\n        border-right: 8px solid #fff;\n    }\n    .carousel .control-next.control-arrow {\n        right: 0;\n    }\n    .carousel .control-next.control-arrow:before {\n        border-left: 8px solid #fff;\n    }\n\n    .carousel-root {\n        outline: none;\n    }\n\n    .carousel {\n        position: relative;\n        width: 100%;\n    }\n    .carousel * {\n        -webkit-box-sizing: border-box;\n        -moz-box-sizing: border-box;\n        box-sizing: border-box;\n    }\n    .carousel img {\n        width: 100%;\n        display: inline-block;\n        pointer-events: none;\n    }\n    .carousel .carousel {\n        position: relative;\n    }\n    .carousel .control-arrow {\n        outline: 0;\n        border: 0;\n        background: none;\n        top: 50%;\n        margin-top: -13px;\n        font-size: 18px;\n    }\n    .carousel .thumbs-wrapper {\n        margin: 20px;\n        overflow: hidden;\n    }\n    .carousel .thumbs {\n        -webkit-transition: all 0.15s ease-in;\n        -moz-transition: all 0.15s ease-in;\n        -ms-transition: all 0.15s ease-in;\n        -o-transition: all 0.15s ease-in;\n        transition: all 0.15s ease-in;\n        -webkit-transform: translate3d(0, 0, 0);\n        -moz-transform: translate3d(0, 0, 0);\n        -ms-transform: translate3d(0, 0, 0);\n        -o-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0);\n        position: relative;\n        list-style: none;\n        white-space: nowrap;\n    }\n    .carousel .thumb {\n        -webkit-transition: border 0.15s ease-in;\n        -moz-transition: border 0.15s ease-in;\n        -ms-transition: border 0.15s ease-in;\n        -o-transition: border 0.15s ease-in;\n        transition: border 0.15s ease-in;\n        display: inline-block;\n        margin-right: 6px;\n        white-space: nowrap;\n        overflow: hidden;\n        border: 3px solid #fff;\n        padding: 2px;\n    }\n    .carousel .thumb:focus {\n        border: 3px solid #ccc;\n        outline: none;\n    }\n    .carousel .thumb.selected,\n    .carousel .thumb:hover {\n        border: 3px solid #333;\n    }\n    .carousel .thumb img {\n        vertical-align: top;\n    }\n    .carousel.carousel-slider {\n        position: relative;\n        margin: 0;\n        overflow: hidden;\n    }\n    .carousel.carousel-slider .control-arrow {\n        top: 0;\n        color: #fff;\n        font-size: 26px;\n        bottom: 0;\n        margin-top: 0;\n        padding: 5px;\n    }\n    .carousel.carousel-slider .control-arrow:hover {\n        background: rgba(0, 0, 0, 0.2);\n    }\n    .carousel .slider-wrapper {\n        overflow: hidden;\n        margin: auto;\n        width: 100%;\n        -webkit-transition: height 0.15s ease-in;\n        -moz-transition: height 0.15s ease-in;\n        -ms-transition: height 0.15s ease-in;\n        -o-transition: height 0.15s ease-in;\n        transition: height 0.15s ease-in;\n    }\n    .carousel .slider-wrapper.axis-horizontal .slider {\n        -ms-box-orient: horizontal;\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -moz-flex;\n        display: -webkit-flex;\n        display: flex;\n    }\n    .carousel .slider-wrapper.axis-horizontal .slider .slide {\n        flex-direction: column;\n        flex-flow: column;\n    }\n    .carousel .slider-wrapper.axis-vertical {\n        -ms-box-orient: horizontal;\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -moz-flex;\n        display: -webkit-flex;\n        display: flex;\n    }\n    .carousel .slider-wrapper.axis-vertical .slider {\n        -webkit-flex-direction: column;\n        flex-direction: column;\n    }\n    .carousel .slider {\n        margin: 0;\n        padding: 0;\n        position: relative;\n        list-style: none;\n        width: 100%;\n    }\n    .carousel .slider.animated {\n        -webkit-transition: all 1s ease-in-out;\n        -moz-transition: all 1s ease-in-out;\n        -ms-transition: all 1s ease-in-out;\n        -o-transition: all 1s ease-in-out;\n        transition: all 1s ease-in-out;\n    }\n    .carousel .slide {\n        min-width: 100%;\n        margin: 0;\n        position: relative;\n        text-align: center;\n    }\n    .carousel .slide img {\n        width: 100%;\n        vertical-align: top;\n        border: 0;\n    }\n    .carousel .slide iframe {\n        display: inline-block;\n        width: calc(100% - 80px);\n        margin: 0 40px 40px;\n        border: 0;\n    }\n    .carousel .slide .legend {\n        -webkit-transition: all 0.5s ease-in-out;\n        -moz-transition: all 0.5s ease-in-out;\n        -ms-transition: all 0.5s ease-in-out;\n        -o-transition: all 0.5s ease-in-out;\n        transition: all 0.5s ease-in-out;\n        position: absolute;\n        bottom: 40px;\n        left: 50%;\n        margin-left: -45%;\n        width: 90%;\n        border-radius: 10px;\n        background: #000;\n        color: #fff;\n        padding: 10px;\n        font-size: 12px;\n        text-align: center;\n        opacity: 0.25;\n        -webkit-transition: opacity 1s ease-in-out;\n        -moz-transition: opacity 1s ease-in-out;\n        -ms-transition: opacity 1s ease-in-out;\n        -o-transition: opacity 1s ease-in-out;\n        transition: opacity 1s ease-in-out;\n    }\n    .carousel .control-dots {\n        position: absolute;\n        bottom: 0;\n        margin: 10px 0;\n        padding: 0;\n        text-align: center;\n        width: 100%;\n        z-index: 1;\n    }\n    @media (min-width: 960px) {\n        .carousel .control-dots {\n            bottom: 0;\n        }\n    }\n    .carousel .control-dots .dot {\n        -webkit-transition: opacity 0.25s ease-in;\n        -moz-transition: opacity 0.25s ease-in;\n        -ms-transition: opacity 0.25s ease-in;\n        -o-transition: opacity 0.25s ease-in;\n        transition: opacity 0.25s ease-in;\n        opacity: 0.3;\n        filter: alpha(opacity=30);\n        box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.9);\n        background: #fff;\n        border-radius: 50%;\n        width: 8px;\n        height: 8px;\n        cursor: pointer;\n        display: inline-block;\n        margin: 0 8px;\n    }\n    .carousel .control-dots .dot.selected,\n    .carousel .control-dots .dot:hover {\n        opacity: 1;\n        filter: alpha(opacity=100);\n    }\n    .carousel .carousel-status {\n        position: absolute;\n        top: 0;\n        right: 0;\n        padding: 5px;\n        font-size: 10px;\n        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.9);\n        color: #fff;\n    }\n    .carousel:hover .slide .legend {\n        opacity: 1;\n    }\n"], Object.freeze(Object.defineProperties(a, {
      raw: {
        value: Object.freeze(r)
      }
    }))),
    s = n(0),
    l = c(s),
    d = c(n(3)),
    u = n(173);
  function c(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  var m = c(n(2)).default.div(o);
  t.TestimonialComponent = function (e) {
    var t = (0, s.useState)(void 0),
      n = i(t, 2),
      a = n[0],
      r = n[1],
      o = (0, s.useState)("col-md-12 col-lg-12 col-sm-12 col-xs-12"),
      c = i(o, 2),
      f = c[0],
      p = c[1],
      _ = (0, s.useState)([]),
      h = i(_, 2),
      y = h[0],
      g = h[1];
    (0, s.useEffect)(function () {
      v();
    }, []);
    var v = function () {
        var t = {
          headers: {
            Authorization: localStorage.getItem("jwt-token")
          },
          params: {
            dbName: e.dbName,
            collection: e.data.settings.collection.value.customeCollectionName
          }
        };
        d.default.get("/api/custom-collections/all", t).then(function (t) {
          var n = {
            itemsList: t.data[0].fieldData.en ? t.data.map(function (e) {
              return {
                title: e.fieldData.en.description ? e.fieldData.en.description : "N/A",
                image: e.fieldData.en.image ? e.fieldData.en.image.filePath : "N/A"
              };
            }) : t.data.map(function (e) {
              return {
                title: e.fieldData.EN.description ? e.fieldData.EN.description : "N/A",
                image: e.fieldData.EN.image ? e.fieldData.EN.image.filePath : "N/A"
              };
            }),
            carouselType: e.data.settings.testimonialType.value
          };
          r(n), "type1" === n.carouselType ? (p("col-12"), g(M(n.itemsList, 1))) : "type2" === n.carouselType ? (p("col-12 col-md-6 col-lg-6"), g(M(n.itemsList, 2))) : "type3" === n.carouselType ? (p("col-6 col-md-3 col-lg-3"), g(M(n.itemsList, 4))) : "type4" === n.carouselType && (p("col-12 col-md-6 col-lg-6"), g(M(n.itemsList, 1)));
        }).catch(function (e) {
          console.log(e);
        });
      },
      M = function (e, t) {
        return e.reduce(function (e, n, a) {
          var r = Math.floor(a / t);
          return e[r] || (e[r] = []), e[r].push(n), e;
        }, []);
      };
    return l.default.createElement("div", {
      className: "p-2 m-2"
    }, l.default.createElement(m, null, y && y.length > 0 ? l.default.createElement(u.Carousel, {
      autoPlay: !0,
      infiniteLoop: !0,
      showStatus: !1,
      showArrows: !1,
      transitionTime: 2e3
    }, y ? y.map(function (e) {
      return l.default.createElement("div", {
        className: "row p-2 testimonial-wrapper"
      }, e && e.map(function (e) {
        return "type4" === a.carouselType ? l.default.createElement("div", {
          className: "row m-0 p-0"
        }, l.default.createElement("div", {
          className: f + " p-2 testimonial-image"
        }, l.default.createElement("div", {
          className: "img-wrap"
        }, l.default.createElement("img", {
          alt: "",
          src: e.image
        }))), l.default.createElement("div", {
          className: f + " p-2 testimonial-desc"
        }, l.default.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: e.title
          }
        }))) : l.default.createElement("div", {
          className: f + " p-2 testimonial-image"
        }, l.default.createElement("div", {
          className: "img-wrap"
        }, l.default.createElement("img", {
          alt: "",
          src: e.image
        })));
      }));
    }) : null) : null));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.NewsAndEventsComponent = void 0;
  var a,
    r,
    i = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    o = (a = ["\n    .carousel .control-arrow, .carousel.carousel-slider .control-arrow {\n    -webkit-transition: all 0.25s ease-in;\n    -moz-transition: all 0.25s ease-in;\n    -ms-transition: all 0.25s ease-in;\n    -o-transition: all 0.25s ease-in;\n    transition: all 0.25s ease-in;\n    opacity: 0.4;\n    filter: alpha(opacity=40);\n    position: absolute;\n    z-index: 2;\n    top: 20px;\n    background: none;\n    border: 0;\n    font-size: 32px;\n    cursor: pointer; }\n    .carousel .control-arrow:focus, .carousel .control-arrow:hover {\n        opacity: 1;\n        filter: alpha(opacity=100); }\n    .carousel .control-arrow:before, .carousel.carousel-slider .control-arrow:before {\n        margin: 0 5px;\n        display: inline-block;\n        border-top: 8px solid transparent;\n        border-bottom: 8px solid transparent;\n        content: ''; }\n    .carousel .control-disabled.control-arrow {\n        opacity: 0;\n        filter: alpha(opacity=0);\n        cursor: inherit;\n        display: none; }\n    .carousel .control-prev.control-arrow {\n        left: 0; }\n        .carousel .control-prev.control-arrow:before {\n        border-right: 8px solid #fff; }\n    .carousel .control-next.control-arrow {\n        right: 0; }\n        .carousel .control-next.control-arrow:before {\n        border-left: 8px solid #fff; }\n\n    .carousel-root {\n    outline: none; }\n\n    .carousel {\n    position: relative;\n    width: 100%; }\n    .carousel * {\n        -webkit-box-sizing: border-box;\n        -moz-box-sizing: border-box;\n        box-sizing: border-box; }\n    .carousel img {\n        width: 100%;\n        display: inline-block;\n        pointer-events: none; }\n    .carousel .carousel {\n        position: relative; }\n    .carousel .control-arrow {\n        outline: 0;\n        border: 0;\n        background: none;\n        top: 50%;\n        margin-top: -13px;\n        font-size: 18px; }\n    .carousel .thumbs-wrapper {\n        margin: 20px;\n        overflow: hidden; }\n    .carousel .thumbs {\n        -webkit-transition: all 0.15s ease-in;\n        -moz-transition: all 0.15s ease-in;\n        -ms-transition: all 0.15s ease-in;\n        -o-transition: all 0.15s ease-in;\n        transition: all 0.15s ease-in;\n        -webkit-transform: translate3d(0, 0, 0);\n        -moz-transform: translate3d(0, 0, 0);\n        -ms-transform: translate3d(0, 0, 0);\n        -o-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0);\n        position: relative;\n        list-style: none;\n        white-space: nowrap; }\n    .carousel .thumb {\n        -webkit-transition: border 0.15s ease-in;\n        -moz-transition: border 0.15s ease-in;\n        -ms-transition: border 0.15s ease-in;\n        -o-transition: border 0.15s ease-in;\n        transition: border 0.15s ease-in;\n        display: inline-block;\n        margin-right: 6px;\n        white-space: nowrap;\n        overflow: hidden;\n        border: 3px solid #fff;\n        padding: 2px; }\n        .carousel .thumb:focus {\n        border: 3px solid #ccc;\n        outline: none; }\n        .carousel .thumb.selected, .carousel .thumb:hover {\n        border: 3px solid #333; }\n        .carousel .thumb img {\n        vertical-align: top; }\n    .carousel.carousel-slider {\n        position: relative;\n        margin: 0;\n        overflow: hidden; }\n        .carousel.carousel-slider .control-arrow {\n        top: 0;\n        color: #fff;\n        font-size: 26px;\n        bottom: 0;\n        margin-top: 0;\n        padding: 5px; }\n        .carousel.carousel-slider .control-arrow:hover {\n            background: rgba(0, 0, 0, 0.2); }\n    .carousel .slider-wrapper {\n        overflow: hidden;\n        margin: auto;\n        width: 100%;\n        -webkit-transition: height 0.15s ease-in;\n        -moz-transition: height 0.15s ease-in;\n        -ms-transition: height 0.15s ease-in;\n        -o-transition: height 0.15s ease-in;\n        transition: height 0.15s ease-in; }\n        .carousel .slider-wrapper.axis-horizontal .slider {\n        -ms-box-orient: horizontal;\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -moz-flex;\n        display: -webkit-flex;\n        display: flex; }\n        .carousel .slider-wrapper.axis-horizontal .slider .slide {\n            flex-direction: column;\n            flex-flow: column; }\n        .carousel .slider-wrapper.axis-vertical {\n        -ms-box-orient: horizontal;\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -moz-flex;\n        display: -webkit-flex;\n        display: flex; }\n        .carousel .slider-wrapper.axis-vertical .slider {\n            -webkit-flex-direction: column;\n            flex-direction: column; }\n    .carousel .slider {\n        margin: 0;\n        padding: 0;\n        position: relative;\n        list-style: none;\n        width: 100%; }\n        .carousel .slider.animated {\n        -webkit-transition: all 1s ease-in-out;\n        -moz-transition: all 1s ease-in-out;\n        -ms-transition: all 1s ease-in-out;\n        -o-transition: all 1s ease-in-out;\n        transition: all 1s ease-in-out; }\n    .carousel .slide {\n        min-width: 100%;\n        margin: 0;\n        position: relative;\n        text-align: center; }\n        .carousel .slide img {\n        width: 100%;\n        vertical-align: top;\n        border: 0; }\n        .carousel .slide iframe {\n        display: inline-block;\n        width: calc(100% - 80px);\n        margin: 0 40px 40px;\n        border: 0; }\n        .carousel .slide .legend {\n        -webkit-transition: all 0.5s ease-in-out;\n        -moz-transition: all 0.5s ease-in-out;\n        -ms-transition: all 0.5s ease-in-out;\n        -o-transition: all 0.5s ease-in-out;\n        transition: all 0.5s ease-in-out;\n        position: absolute;\n        bottom: 40px;\n        left: 50%;\n        margin-left: -45%;\n        width: 90%;\n        border-radius: 10px;\n        background: #000;\n        color: #fff;\n        padding: 10px;\n        font-size: 12px;\n        text-align: center;\n        opacity: 0.25;\n        -webkit-transition: opacity 1s ease-in-out;\n        -moz-transition: opacity 1s ease-in-out;\n        -ms-transition: opacity 1s ease-in-out;\n        -o-transition: opacity 1s ease-in-out;\n        transition: opacity 1s ease-in-out; }\n    .carousel .control-dots {\n        position: absolute;\n        bottom: 0;\n        margin: 10px 0;\n        padding: 0;\n        text-align: center;\n        width: 100%;\n        z-index: 1; }\n        @media (min-width: 960px) {\n        .carousel .control-dots {\n            bottom: 0; } }\n        .carousel .control-dots .dot {\n        -webkit-transition: opacity 0.25s ease-in;\n        -moz-transition: opacity 0.25s ease-in;\n        -ms-transition: opacity 0.25s ease-in;\n        -o-transition: opacity 0.25s ease-in;\n        transition: opacity 0.25s ease-in;\n        opacity: 0.3;\n        filter: alpha(opacity=30);\n        box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.9);\n        background: #fff;\n        border-radius: 50%;\n        width: 8px;\n        height: 8px;\n        cursor: pointer;\n        display: inline-block;\n        margin: 0 8px; }\n        .carousel .control-dots .dot.selected, .carousel .control-dots .dot:hover {\n            opacity: 1;\n            filter: alpha(opacity=100); }\n    .carousel .carousel-status {\n        position: absolute;\n        top: 0;\n        right: 0;\n        padding: 5px;\n        font-size: 10px;\n        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.9);\n        color: #fff; }\n    .carousel:hover .slide .legend {\n        opacity: 1; }\n"], r = ["\n    .carousel .control-arrow, .carousel.carousel-slider .control-arrow {\n    -webkit-transition: all 0.25s ease-in;\n    -moz-transition: all 0.25s ease-in;\n    -ms-transition: all 0.25s ease-in;\n    -o-transition: all 0.25s ease-in;\n    transition: all 0.25s ease-in;\n    opacity: 0.4;\n    filter: alpha(opacity=40);\n    position: absolute;\n    z-index: 2;\n    top: 20px;\n    background: none;\n    border: 0;\n    font-size: 32px;\n    cursor: pointer; }\n    .carousel .control-arrow:focus, .carousel .control-arrow:hover {\n        opacity: 1;\n        filter: alpha(opacity=100); }\n    .carousel .control-arrow:before, .carousel.carousel-slider .control-arrow:before {\n        margin: 0 5px;\n        display: inline-block;\n        border-top: 8px solid transparent;\n        border-bottom: 8px solid transparent;\n        content: ''; }\n    .carousel .control-disabled.control-arrow {\n        opacity: 0;\n        filter: alpha(opacity=0);\n        cursor: inherit;\n        display: none; }\n    .carousel .control-prev.control-arrow {\n        left: 0; }\n        .carousel .control-prev.control-arrow:before {\n        border-right: 8px solid #fff; }\n    .carousel .control-next.control-arrow {\n        right: 0; }\n        .carousel .control-next.control-arrow:before {\n        border-left: 8px solid #fff; }\n\n    .carousel-root {\n    outline: none; }\n\n    .carousel {\n    position: relative;\n    width: 100%; }\n    .carousel * {\n        -webkit-box-sizing: border-box;\n        -moz-box-sizing: border-box;\n        box-sizing: border-box; }\n    .carousel img {\n        width: 100%;\n        display: inline-block;\n        pointer-events: none; }\n    .carousel .carousel {\n        position: relative; }\n    .carousel .control-arrow {\n        outline: 0;\n        border: 0;\n        background: none;\n        top: 50%;\n        margin-top: -13px;\n        font-size: 18px; }\n    .carousel .thumbs-wrapper {\n        margin: 20px;\n        overflow: hidden; }\n    .carousel .thumbs {\n        -webkit-transition: all 0.15s ease-in;\n        -moz-transition: all 0.15s ease-in;\n        -ms-transition: all 0.15s ease-in;\n        -o-transition: all 0.15s ease-in;\n        transition: all 0.15s ease-in;\n        -webkit-transform: translate3d(0, 0, 0);\n        -moz-transform: translate3d(0, 0, 0);\n        -ms-transform: translate3d(0, 0, 0);\n        -o-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0);\n        position: relative;\n        list-style: none;\n        white-space: nowrap; }\n    .carousel .thumb {\n        -webkit-transition: border 0.15s ease-in;\n        -moz-transition: border 0.15s ease-in;\n        -ms-transition: border 0.15s ease-in;\n        -o-transition: border 0.15s ease-in;\n        transition: border 0.15s ease-in;\n        display: inline-block;\n        margin-right: 6px;\n        white-space: nowrap;\n        overflow: hidden;\n        border: 3px solid #fff;\n        padding: 2px; }\n        .carousel .thumb:focus {\n        border: 3px solid #ccc;\n        outline: none; }\n        .carousel .thumb.selected, .carousel .thumb:hover {\n        border: 3px solid #333; }\n        .carousel .thumb img {\n        vertical-align: top; }\n    .carousel.carousel-slider {\n        position: relative;\n        margin: 0;\n        overflow: hidden; }\n        .carousel.carousel-slider .control-arrow {\n        top: 0;\n        color: #fff;\n        font-size: 26px;\n        bottom: 0;\n        margin-top: 0;\n        padding: 5px; }\n        .carousel.carousel-slider .control-arrow:hover {\n            background: rgba(0, 0, 0, 0.2); }\n    .carousel .slider-wrapper {\n        overflow: hidden;\n        margin: auto;\n        width: 100%;\n        -webkit-transition: height 0.15s ease-in;\n        -moz-transition: height 0.15s ease-in;\n        -ms-transition: height 0.15s ease-in;\n        -o-transition: height 0.15s ease-in;\n        transition: height 0.15s ease-in; }\n        .carousel .slider-wrapper.axis-horizontal .slider {\n        -ms-box-orient: horizontal;\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -moz-flex;\n        display: -webkit-flex;\n        display: flex; }\n        .carousel .slider-wrapper.axis-horizontal .slider .slide {\n            flex-direction: column;\n            flex-flow: column; }\n        .carousel .slider-wrapper.axis-vertical {\n        -ms-box-orient: horizontal;\n        display: -webkit-box;\n        display: -moz-box;\n        display: -ms-flexbox;\n        display: -moz-flex;\n        display: -webkit-flex;\n        display: flex; }\n        .carousel .slider-wrapper.axis-vertical .slider {\n            -webkit-flex-direction: column;\n            flex-direction: column; }\n    .carousel .slider {\n        margin: 0;\n        padding: 0;\n        position: relative;\n        list-style: none;\n        width: 100%; }\n        .carousel .slider.animated {\n        -webkit-transition: all 1s ease-in-out;\n        -moz-transition: all 1s ease-in-out;\n        -ms-transition: all 1s ease-in-out;\n        -o-transition: all 1s ease-in-out;\n        transition: all 1s ease-in-out; }\n    .carousel .slide {\n        min-width: 100%;\n        margin: 0;\n        position: relative;\n        text-align: center; }\n        .carousel .slide img {\n        width: 100%;\n        vertical-align: top;\n        border: 0; }\n        .carousel .slide iframe {\n        display: inline-block;\n        width: calc(100% - 80px);\n        margin: 0 40px 40px;\n        border: 0; }\n        .carousel .slide .legend {\n        -webkit-transition: all 0.5s ease-in-out;\n        -moz-transition: all 0.5s ease-in-out;\n        -ms-transition: all 0.5s ease-in-out;\n        -o-transition: all 0.5s ease-in-out;\n        transition: all 0.5s ease-in-out;\n        position: absolute;\n        bottom: 40px;\n        left: 50%;\n        margin-left: -45%;\n        width: 90%;\n        border-radius: 10px;\n        background: #000;\n        color: #fff;\n        padding: 10px;\n        font-size: 12px;\n        text-align: center;\n        opacity: 0.25;\n        -webkit-transition: opacity 1s ease-in-out;\n        -moz-transition: opacity 1s ease-in-out;\n        -ms-transition: opacity 1s ease-in-out;\n        -o-transition: opacity 1s ease-in-out;\n        transition: opacity 1s ease-in-out; }\n    .carousel .control-dots {\n        position: absolute;\n        bottom: 0;\n        margin: 10px 0;\n        padding: 0;\n        text-align: center;\n        width: 100%;\n        z-index: 1; }\n        @media (min-width: 960px) {\n        .carousel .control-dots {\n            bottom: 0; } }\n        .carousel .control-dots .dot {\n        -webkit-transition: opacity 0.25s ease-in;\n        -moz-transition: opacity 0.25s ease-in;\n        -ms-transition: opacity 0.25s ease-in;\n        -o-transition: opacity 0.25s ease-in;\n        transition: opacity 0.25s ease-in;\n        opacity: 0.3;\n        filter: alpha(opacity=30);\n        box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.9);\n        background: #fff;\n        border-radius: 50%;\n        width: 8px;\n        height: 8px;\n        cursor: pointer;\n        display: inline-block;\n        margin: 0 8px; }\n        .carousel .control-dots .dot.selected, .carousel .control-dots .dot:hover {\n            opacity: 1;\n            filter: alpha(opacity=100); }\n    .carousel .carousel-status {\n        position: absolute;\n        top: 0;\n        right: 0;\n        padding: 5px;\n        font-size: 10px;\n        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.9);\n        color: #fff; }\n    .carousel:hover .slide .legend {\n        opacity: 1; }\n"], Object.freeze(Object.defineProperties(a, {
      raw: {
        value: Object.freeze(r)
      }
    }))),
    s = n(0),
    l = p(s),
    d = p(n(3)),
    u = n(179),
    c = n(173),
    m = p(n(2)),
    f = n(320);
  function p(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  var _ = m.default.div(o),
    h = function (e) {
      switch (e) {
        case "facebook":
          return window.open("http://www.facebook.com/sharer.php?u=" + window.location.href, "sharer", "toolbar=0,status=0,width=626,height=436"), !1;
        case "twitter":
          return window.open("https://twitter.com/intent/tweet?&url=" + window.location.href, "sharer", "toolbar=0,status=0,width=626,height=436"), !1;
        case "linkedIn":
          return window.open("https://www.linkedin.com/sharing/share-offsite/?url=" + window.location.href, "sharer", "toolbar=0,status=0,width=626,height=436"), !1;
        default:
          return;
      }
    },
    y = function (e, t) {
      return e.reduce(function (e, n, a) {
        var r = Math.floor(a / t);
        return e[r] || (e[r] = []), e[r].push(n), e;
      }, []);
    },
    g = function (e, t) {
      return l.default.createElement(_, null, e && e.length > 0 && l.default.createElement(c.Carousel, {
        autoPlay: !0,
        infiniteLoop: !0,
        stopOnHover: !0,
        showStatus: !1,
        showArrows: !1,
        interval: 1e4,
        swipeScrollTolerance: !1,
        transitionTime: 1e3
      }, e.map(function (e) {
        return 1 == t ? l.default.createElement("div", {
          className: "row"
        }, l.default.createElement("div", {
          className: "pl-4 pr-5"
        }, l.default.createElement(u.NewsItemComponent, {
          img: e.image,
          title: e.title,
          description: e.description,
          news: e
        }))) : l.default.createElement("div", {
          className: "row p-3"
        }, e.map(function (e, n) {
          if (n < t) return l.default.createElement("div", {
            className: "col-sm-6 col-md-" + 12 / t + " px-2 m-0"
          }, l.default.createElement(u.NewsItemComponent, {
            img: e.image,
            title: e.title,
            description: e.description,
            news: e
          }));
        }));
      })));
    };
  t.NewsAndEventsComponent = function (e) {
    var t = (0, s.useState)([]),
      n = i(t, 2),
      a = n[0],
      r = n[1],
      o = (0, s.useState)([]),
      c = i(o, 2),
      m = c[0],
      p = c[1],
      _ = (0, s.useState)([]),
      v = i(_, 2),
      M = v[0],
      L = v[1],
      b = (0, s.useState)(),
      w = i(b, 2),
      k = w[0],
      Y = w[1];
    (0, s.useEffect)(function () {
      D();
    }, []);
    var D = function () {
      var t = {
        headers: {
          Authorization: localStorage.getItem("jwt-token")
        },
        params: {
          dbName: e.dbName,
          collection: e.data.settings.collection.value.customeCollectionName
        }
      };
      d.default.get("/api/custom-collections/all", t).then(function (t) {
        var n = t.data,
          a = e.lang.langKey,
          i = a.toUpperCase(),
          o = n[0].fieldData[a] ? n.map(function (e) {
            return {
              title: e.fieldData[a].title ? e.fieldData[a].title : "N/A",
              image: e.fieldData[a].image ? e.fieldData[a].image.filePath : e.fieldData.en.image.filePath,
              description: e.fieldData[a].description ? e.fieldData[a].description : "N/A",
              entry_name: e.fieldData[a].entry_name ? e.fieldData[a].entry_name : e.fieldData.en.entry_name
            };
          }) : n.map(function (e) {
            return {
              title: e.fieldData[i].title ? e.fieldData[i].title : "N/A",
              image: e.fieldData[i].image ? e.fieldData[i].image.filePath : e.fieldData.EN.image.filePath,
              description: e.fieldData[i].description ? e.fieldData[i].description : "N/A",
              entry_name: e.fieldData[i].entry_name ? e.fieldData[i].entry_name : e.fieldData.EN.entry_name
            };
          });
        r(o), L(y(o, 2)), p(y(o, 3));
        var s = localStorage.getItem("entry_name"),
          l = o.filter(function (e) {
            return JSON.stringify(e) === s;
          });
        l[0] ? Y(l[0]) : Y(o[0]);
      }).catch(function (e) {
        console.log(e);
      });
    };
    return "horizontal" === e.data.settings.newsView.value || "cardsCarousel" == e.data.settings.newsView.value ? l.default.createElement("div", {
      className: "newsAndEvents",
      dir: "ltr"
    }, void 0 !== k && "horizontal" === e.data.settings.newsView.value && l.default.createElement("div", {
      className: "card d-none d-md-block",
      style: {
        border: "0px"
      }
    }, l.default.createElement("div", {
      className: "row card-body news-main-card p-0"
    }, l.default.createElement("div", {
      className: "news-content col-12 col-md-12 col-xl-7"
    }, l.default.createElement("div", null, l.default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: k.title
      }
    }), l.default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: k.description
      }
    }))), l.default.createElement("br", null), l.default.createElement("div", {
      className: "news-image col-12 col-md-12 col-xl-5"
    }, l.default.createElement("img", {
      className: "object-fit-cover w-100",
      src: k.image,
      alt: ""
    })))), "horizontal" === e.data.settings.newsView.value && l.default.createElement("div", {
      className: "mb-4 seperator d-none d-md-block"
    }, l.default.createElement("hr", {
      style: {
        borderTop: "2px solid #999",
        width: "60%"
      }
    })), l.default.createElement("div", {
      className: "container"
    }, m && m.length > 0 && l.default.createElement("div", {
      className: "row news-desktop d-none d-lg-block"
    }, g(m, 3)), M && M.length > 0 && l.default.createElement("div", {
      className: "row news-desktop d-none d-md-block d-lg-none"
    }, g(M, 2)), a && a.length > 0 && l.default.createElement("div", {
      className: "row news-mobile d-md-none"
    }, g(a, 1)))) : "vertical" === e.data.settings.newsView.value ? l.default.createElement("div", {
      className: "newsAndEvents",
      dir: "ltr"
    }, void 0 !== k ? l.default.createElement("div", {
      className: "card",
      style: {
        border: "0px"
      }
    }, l.default.createElement("div", {
      className: "row card-body"
    }, l.default.createElement("div", {
      className: "col-lg-8 col-md-12 pt-2"
    }, l.default.createElement("div", null, l.default.createElement("img", {
      src: k.image,
      alt: "",
      width: "100%",
      height: "auto"
    })), l.default.createElement("div", {
      className: "row mt-5"
    }, l.default.createElement("div", {
      className: "col- d-flex",
      style: {
        flexDirection: "column",
        height: "48px",
        marginTop: "48px"
      }
    }, l.default.createElement("a", {
      target: "_blank",
      onClick: function () {
        return h("linkedIn");
      },
      className: "col-12"
    }, l.default.createElement("img", {
      src: "/img/linkedin.png",
      className: "mb-2",
      style: {
        width: "30px",
        height: "30px"
      },
      alt: "linkedin"
    })), l.default.createElement("a", {
      target: "_blank",
      onClick: function () {
        return h("facebook");
      },
      className: "col-12"
    }, l.default.createElement("img", {
      src: "/img/facebook.png",
      className: "mb-2",
      style: {
        width: "30px",
        height: "30px"
      },
      alt: "facebook"
    })), l.default.createElement("a", {
      target: "_blank",
      onClick: function () {
        return h("twitter");
      },
      className: "col-12"
    }, l.default.createElement("img", {
      src: "/img/twitter.png",
      className: "mb-2",
      style: {
        width: "30px",
        height: "30px",
        borderRadius: "4px"
      },
      alt: "twitter"
    }))), l.default.createElement("div", {
      className: "col-md"
    }, l.default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: k.title
      }
    }), l.default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: k.description
      }
    })))), l.default.createElement("br", null), l.default.createElement("div", {
      className: "col-4 p-0 m-0 d-none d-lg-block"
    }, l.default.createElement("div", {
      className: "container"
    }, l.default.createElement("div", {
      className: "column"
    }, a.map(function (e, t) {
      if (t < 3) return l.default.createElement(u.NewsItemComponent, {
        img: e.image,
        title: e.title,
        description: e.description,
        news: e
      });
    })))), l.default.createElement("div", {
      className: "mb-4 seperator d-lg-none"
    }, l.default.createElement("hr", {
      style: {
        borderTop: "2px solid #999",
        width: "60%"
      }
    })), M && M.length > 0 && l.default.createElement("div", {
      className: "row news-desktop d-none d-md-block d-lg-none w-100"
    }, g(M, 2)), a && a.length > 0 && l.default.createElement("div", {
      className: "row news-mobile d-md-none"
    }, g(a, 1)))) : null) : "cards" === e.data.settings.newsView.value ? l.default.createElement("div", {
      className: "newsAndEvents",
      dir: "ltr"
    }, l.default.createElement("div", {
      className: "d-none d-xl-block"
    }, l.default.createElement(f.PaginatedNews, {
      itemsPerPage: 12,
      items: a
    })), l.default.createElement("div", {
      className: "d-none d-md-block d-xl-none"
    }, l.default.createElement(f.PaginatedNews, {
      itemsPerPage: 12,
      items: a
    })), l.default.createElement("div", {
      className: "d-block d-md-none"
    }, l.default.createElement(f.PaginatedNews, {
      itemsPerPage: 6,
      items: a
    }))) : void 0;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.CardWithImageComponent = void 0;
  var a = r(n(0));
  r(n(2));
  function r(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  var i = t.CardWithImageComponent = function (e) {
    return a.default.createElement("div", {
      className: "card image-card"
    }, a.default.createElement("div", {
      className: "card-body image-card-body"
    }, a.default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: e.data.data.content
      }
    })));
  };
  t.default = i;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.CareersComponent = void 0;
  var a,
    r,
    i = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    o = (a = ["\n    padding: 10px;\n    .pill-nav button {\n        background: #ffffff;\n        white-space: nowrap;\n        border: 1px solid #e0e0e0;\n        border-radius: 6px;\n    }\n    .pill-nav {\n        gap: 16px;\n    }\n    .vacancies-heading {\n        font-weight: 600;\n        font-size: 20px;\n        color: #000000;\n    }\n    .tags-container .tag {\n        font-weight: 400;\n        font-size: 15px;\n        color: #5e5e5e;\n    }\n    .tags-container {\n        gap: 0px 12px;\n    }\n    .technologies-container {\n        gap: 8px;\n    }\n    .technologies-container .technology {\n        font-weight: 500;\n        font-size: 15px;\n        color: #5e5e5e;\n        background: #e0e0e0;\n        border-radius: 4px;\n    }\n    .apply-now-btn {\n        background-image: linear-gradient(to right, var(--primary) 0%, #2e64c8   51%, var(--primary)  100%);\n        box-shadow: 0 0 20px #eee;\n        transition: 0.5s;\n        background-size: 200% auto;        \n        color: white;\n        font-weight: 500 ;\n        font-size: 18px;\n        border: none;\n        padding: 8px 24px;\n        border-radius: 6px;\n    }\n    .single-vaccanies-container {\n        padding: 32px 24px;\n        background: #ffffff;\n        border-left: 6px solid #f75590;\n        box-shadow: 0px 0px 12px 1px #e0e0e0;\n        margin-top: 24px;\n        border-radius: 6px;\n    }\n    .pill-nav .active-tag {\n        background: #f75590;\n        color: #ffffff;\n    }\n    @media (max-width: 768px) {\n        .pill-nav {\n            overflow-x: scroll;\n        }\n    }\n"], r = ["\n    padding: 10px;\n    .pill-nav button {\n        background: #ffffff;\n        white-space: nowrap;\n        border: 1px solid #e0e0e0;\n        border-radius: 6px;\n    }\n    .pill-nav {\n        gap: 16px;\n    }\n    .vacancies-heading {\n        font-weight: 600;\n        font-size: 20px;\n        color: #000000;\n    }\n    .tags-container .tag {\n        font-weight: 400;\n        font-size: 15px;\n        color: #5e5e5e;\n    }\n    .tags-container {\n        gap: 0px 12px;\n    }\n    .technologies-container {\n        gap: 8px;\n    }\n    .technologies-container .technology {\n        font-weight: 500;\n        font-size: 15px;\n        color: #5e5e5e;\n        background: #e0e0e0;\n        border-radius: 4px;\n    }\n    .apply-now-btn {\n        background-image: linear-gradient(to right, var(--primary) 0%, #2e64c8   51%, var(--primary)  100%);\n        box-shadow: 0 0 20px #eee;\n        transition: 0.5s;\n        background-size: 200% auto;        \n        color: white;\n        font-weight: 500 ;\n        font-size: 18px;\n        border: none;\n        padding: 8px 24px;\n        border-radius: 6px;\n    }\n    .single-vaccanies-container {\n        padding: 32px 24px;\n        background: #ffffff;\n        border-left: 6px solid #f75590;\n        box-shadow: 0px 0px 12px 1px #e0e0e0;\n        margin-top: 24px;\n        border-radius: 6px;\n    }\n    .pill-nav .active-tag {\n        background: #f75590;\n        color: #ffffff;\n    }\n    @media (max-width: 768px) {\n        .pill-nav {\n            overflow-x: scroll;\n        }\n    }\n"], Object.freeze(Object.defineProperties(a, {
      raw: {
        value: Object.freeze(r)
      }
    }))),
    s = n(0),
    l = u(s),
    d = u(n(3));
  function u(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  var c = u(n(2)).default.div(o);
  t.CareersComponent = function (e) {
    var t = e.dbName,
      n = (0, s.useState)(e.data.settings.tagsCollection.value.customeCollectionName),
      a = i(n, 2),
      r = a[0],
      o = (a[1], (0, s.useState)(e.data.settings.vacancyCollection.value.customeCollectionName)),
      u = i(o, 2),
      m = u[0],
      f = (u[1], (0, s.useState)([])),
      p = i(f, 2),
      _ = p[0],
      h = p[1],
      y = (0, s.useState)([]),
      g = i(y, 2),
      v = g[0],
      M = g[1],
      L = (0, s.useState)([]),
      b = i(L, 2),
      w = b[0],
      k = b[1],
      Y = (0, s.useState)("all"),
      D = i(Y, 2),
      S = D[0],
      T = D[1],
      E = (0, s.useState)(),
      x = i(E, 2),
      C = x[0],
      j = x[1],
      P = e.commonConfigs.isPreview,
      N = P || !1;
    (0, s.useEffect)(function () {
      H();
    }, [r]);
    var H = function () {
        var e = localStorage.getItem("jwt-token"),
          n = {
            headers: {
              Authorization: e
            },
            params: {
              collection: r,
              dbName: t
            }
          };
        d.default.get("/api/custom-collections/all", n).then(function (e) {
          var t = e.data.map(function (e) {
            return e.fieldData.en.tagname;
          });
          h(t);
        }).catch(function (e) {
          console.log(e);
        });
        var a = {
          headers: {
            Authorization: e
          },
          params: {
            collection: m,
            dbName: t
          }
        };
        d.default.get("/api/custom-collections/all", a).then(function (e) {
          var t = e.data.map(function (e) {
            var t = e.fieldData.en.entry_name,
              n = e.fieldData.en.title,
              a = e.fieldData.en.jobtype,
              r = e.fieldData.en.category,
              i = e.fieldData.en.location,
              o = e.fieldData.en.labels.split(",");
            return {
              description: e.fieldData.en.description,
              jobType: a,
              category: r,
              location: i,
              label: o,
              entry_name: t,
              title: n,
              logo: e.fieldData.en.logo,
              responsibilities: e.fieldData.en.responsibilities,
              requirements: e.fieldData.en.requirements
            };
          });
          M(t), k(t);
          var n = t.filter(function (e) {
            return JSON.stringify(e) == localStorage.getItem("vacancy");
          });
          j(n ? n[0] : t[0]);
        }).catch(function (e) {
          console.log(e);
        });
      },
      O = function (e) {
        if (T(e), "all" == e) k(v);else {
          var t = v.filter(function (t) {
            return t.category == e;
          });
          k(t);
        }
      };
    return l.default.createElement("div", null, "list" === e.data.settings.viewType.value ? l.default.createElement(c, null, l.default.createElement("div", {
      className: "pill-nav d-flex overflow-auto flex-lg-wrap mb-5"
    }, l.default.createElement("button", {
      onClick: function () {
        return O("all");
      },
      className: "all" == S ? "active-tag p-3 px-lg-4" : "p-3 px-lg-4"
    }, "All vacancies"), _.map(function (e) {
      return l.default.createElement("button", {
        onClick: function () {
          return O(e);
        },
        key: e,
        className: e == S ? "active-tag p-3 px-lg-4" : "p-3 px-lg-4"
      }, e);
    })), l.default.createElement("div", {
      className: "vaccanies-container px-2"
    }, w.length > 0 ? w.map(function (e) {
      return l.default.createElement("div", {
        key: e.title,
        className: "single-vaccanies-container justify-content-between align-items-center row "
      }, l.default.createElement("div", {
        className: "left-container col-12 col-lg-9"
      }, l.default.createElement("h1", {
        className: "vacancies-heading"
      }, e.title), l.default.createElement("div", {
        className: "tags-container d-flex flex-wrap mt-3 mb-2"
      }, l.default.createElement("div", {
        className: "tag"
      }, e.category, " "), l.default.createElement("div", {
        style: {
          color: "#E0E0E0"
        }
      }, "|"), l.default.createElement("div", {
        className: "tag"
      }, e.jobType), l.default.createElement("div", {
        style: {
          color: "#E0E0E0"
        }
      }, "|"), l.default.createElement("div", {
        className: "tag"
      }, e.location)), l.default.createElement("div", {
        className: "technologies-container d-flex flex-wrap mb-3 mb-lg-0"
      }, e.label.map(function (e) {
        return l.default.createElement("div", {
          key: e,
          className: "technology px-3 py-1"
        }, e);
      }))), l.default.createElement("div", {
        className: "right-container col-12 col-lg-3 d-flex justify-content-lg-end"
      }, l.default.createElement("a", {
        className: "apply-now-btn",
        onClick: function () {
          return function (e) {
            localStorage.setItem("vacancy", JSON.stringify(e));
          }(e);
        },
        href: "/en/vacancy#" + e.entry_name
      }, "Apply Now")));
    }) : l.default.createElement("div", {
      className: "justify-content-center text-center my-5"
    }, l.default.createElement("img", {
      className: "vacant-logo mb-4",
      src: "/dfnlk-icons/vacant.png",
      height: 200,
      alt: ""
    }), l.default.createElement("p", {
      className: "text-muted"
    }, " No Vacancies available at the moment.")))) : l.default.createElement(c, null, l.default.createElement("div", {
      className: "vacancy-page px-lg-5 mt-lg-5 mx-auto "
    }, C ? l.default.createElement("div", {
      className: "container"
    }, l.default.createElement("div", {
      className: "vacancy-header d-flex pb-2"
    }, l.default.createElement("div", {
      className: "vacancy-image mr-3"
    }, N ? l.default.createElement("img", {
      src: C.logo.fileName,
      alt: ""
    }) : l.default.createElement("img", {
      src: C.logo.filePath,
      alt: ""
    })), l.default.createElement("div", {
      className: "vacancy-title"
    }, l.default.createElement("h4", {
      className: "mb-2"
    }, C.title), l.default.createElement("div", {
      className: "tags-container d-flex flex-wrap mt-3 mb-2"
    }, l.default.createElement("div", {
      className: "tag"
    }, C.category, " "), l.default.createElement("div", {
      style: {
        color: "#E0E0E0"
      }
    }, "|"), l.default.createElement("div", {
      className: "tag"
    }, C.jobType), l.default.createElement("div", {
      style: {
        color: "#E0E0E0"
      }
    }, "|"), l.default.createElement("div", {
      className: "tag"
    }, C.location)), l.default.createElement("div", {
      className: "technologies-container d-flex flex-wrap mb-3 mb-lg-0"
    }, C.label.map(function (e) {
      return l.default.createElement("div", {
        key: e,
        className: "technology px-3 py-1"
      }, e);
    })))), l.default.createElement("hr", null), l.default.createElement("div", {
      className: "vacancy-details my-4"
    }, l.default.createElement("div", {
      className: "job-desc mb-4"
    }, l.default.createElement("h5", null, "Job Description"), l.default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: C.description
      }
    })), l.default.createElement("div", {
      className: "responsibilities mb-4"
    }, l.default.createElement("h5", null, "Responsibilities"), l.default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: C.responsibilities
      }
    })), l.default.createElement("div", {
      className: "requirements mb-4"
    }, l.default.createElement("h5", null, "Requirements"), l.default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: C.requirements
      }
    })))) : null)));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    r = n(0),
    i = s(r),
    o = s(n(3));
  function s(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  t.default = function (e) {
    var t = (0, r.useState)("col-md-3"),
      n = a(t, 2),
      s = n[0],
      l = n[1],
      d = (0, r.useState)([]),
      u = a(d, 2),
      c = u[0],
      m = u[1];
    (0, r.useEffect)(function () {
      f(), l(e.data.settings.itemsPerRow.value);
    }, []);
    var f = function () {
      var t = {
        headers: {
          Authorization: localStorage.getItem("jwt-token")
        },
        params: {
          dbName: e.dbName,
          collection: e.data.settings.collection.value.customeCollectionName
        }
      };
      o.default.get("/api/custom-collections/all", t).then(function (e) {
        var t = e.data[0].fieldData.en ? e.data.map(function (e) {
          return {
            image: e.fieldData.en.image.filePath ? e.fieldData.en.image.filePath : "N/A",
            heading: e.fieldData.en.heading ? e.fieldData.en.heading : "N/A",
            subheading: e.fieldData.en.subheading ? e.fieldData.en.subheading : "N/A"
          };
        }) : [];
        m(t);
      }).catch(function (e) {
        console.log(e);
      });
    };
    return i.default.createElement("div", null, i.default.createElement("div", {
      className: "row text-center d-flex flex-nowrap flex-md-wrap overflow-auto"
    }, c.length > 0 && c.map(function (e) {
      return i.default.createElement("div", {
        className: s + " col-8 p-2"
      }, i.default.createElement("div", {
        className: "card cardSlider"
      }, i.default.createElement("div", {
        className: "cardSliderImage"
      }, i.default.createElement("img", {
        className: "w-100",
        src: e.image,
        alt: "cardlist image"
      })), i.default.createElement("div", {
        className: "cardSliderContent"
      }, i.default.createElement("h4", {
        className: "cardSliderHeading m-0 p-0 mt-2"
      }, " ", e.heading), i.default.createElement("p", {
        className: "cardSliderSubHeading"
      }, " ", e.subheading))));
    })));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.HomeVideoBannerComponent = void 0;
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
  var o = t.HomeVideoBannerComponent = function (e) {
    var t = e.data.data,
      n = e.commonConfigs.isPreview,
      a = "";
    if (e.lang && (a = "/dfnlk-icons/video-" + e.lang.langKey + ".mp4"), t) {
      var r = t.video;
      r && (a = n ? r.filePath : "/videos/" + r.fileName);
    }
    return i.default.createElement("div", {
      className: "videoBanner"
    }, i.default.createElement("div", {
      className: "videoContent"
    }, i.default.createElement("video", {
      autoPlay: !0,
      loop: !0,
      muted: !0,
      style: {
        width: "100%",
        height: "100%"
      }
    }, i.default.createElement("source", {
      src: a,
      type: "video/mp4"
    }))), i.default.createElement("div", {
      className: "textContent"
    }, i.default.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: e.data.data.content
      }
    })));
  };
  t.default = o;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.LanguageSelector = void 0;
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    },
    o = n(321),
    s = n(322);
  t.LanguageSelector = function (e) {
    return i.default.createElement(s.SelectLanguage, {
      currentLang: e && e.lang && e.lang.langKey.toLowerCase(),
      fetchURL: (0, o.websitesDataService)()
    });
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      }
      return e;
    },
    r = c([""], [""]),
    i = c(["\n    ", "\n"], ["\n    ", "\n"]),
    o = c(["\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n"], ["\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n"]),
    s = u(n(0)),
    l = u(n(2)),
    d = n(5);
  function u(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  function c(e, t) {
    return Object.freeze(Object.defineProperties(e, {
      raw: {
        value: Object.freeze(t)
      }
    }));
  }
  var m = l.default.div(r),
    f = l.default.a.attrs(function (e) {
      var t = e.target,
        n = e.href,
        a = e.role;
      return {
        href: n,
        target: t,
        rel: e.rel,
        role: a
      };
    })(i, function (e) {
      return e.customCSS ? e.customCSS : "";
    }),
    p = l.default.span(r),
    _ = (l.default.span(r), function (e) {
      return e && e.theme && e.theme.properties && e.theme.properties.h1[0] && e.theme.properties.h1[0].value || "";
    }),
    h = l.default.span(o, function (e) {
      return "color: " + (e.textColor ? e.textColor : _()) + ";";
    }, function (e) {
      return "font-family: " + (e.selectedFontFamily ? e.selectedFontFamily : e.theme.properties.h1[0].value) + "};";
    }, function (e) {
      return "font-size: " + (e.selectedFontSize ? e.selectedFontSize : e.theme && e.theme.properties && e.theme.properties.h1[1] && e.theme.properties.h1[1].value) + "};";
    }, function (e) {
      return "font-style: " + (e.selectedFontStyle ? e.selectedFontStyle : _()) + "};";
    }, function (e) {
      return "text-transform: " + (e.selectedTextTransform ? e.selectedTextTransform : _()) + "};";
    }, function (e) {
      return "text-decoration: " + (e.selectedTextDecoration ? e.selectedTextDecoration : _()) + "};";
    }, function (e) {
      return "text-align: " + (e.textAlignment ? e.textAlignment : _()) + ";";
    }, function (e) {
      return "text-shadow: " + (e.selectedTextShadow ? e.selectedTextShadow : _()) + "};";
    }, function (e) {
      return e.customCSS ? e.customCSS : "";
    });
  t.default = function (e) {
    e.commonConfigs, e.componentIndex;
    var t = e.data,
      n = (e.dbName, e.editMode, e.lang, t && Object.keys(t).length > 0),
      r = null;
    if (e.data.settings.iconName && (r = Icon[e.data.settings.iconName.value]), n) {
      var i = t.settings,
        o = t.styles,
        l = t.data,
        u = a({}, l),
        c = u.addNoFollow,
        _ = void 0 === c ? void 0 : c,
        y = u.link,
        g = void 0 === y ? void 0 : y,
        v = u.openInNewWindow,
        M = void 0 === v ? void 0 : v,
        L = u.text,
        b = void 0 === L ? void 0 : L,
        w = g && g.length > 0,
        k = a({}, i),
        Y = k.buttonSize,
        D = void 0 === Y ? void 0 : Y,
        S = (k.buttonType, k.isBlockLevel),
        T = void 0 === S ? void 0 : S,
        E = D ? {
          small: "btn-sm",
          medium: "btn-md",
          large: "btn-lg"
        }[D.value] : "",
        x = T && T.value ? " btn-block" : "",
        C = {
          target: w ? M ? "_blank" : "_self" : void 0,
          href: w ? g : void 0,
          role: w ? void 0 : "button",
          rel: w && _ ? "nofollow" : void 0
        },
        j = o && o.buttonComponentStyles ? o.buttonComponentStyles : {},
        P = o && o.text ? o.text : {},
        N = (0, d.genarateComponentLevelStyleConfigurations)({
          cmpStyles: j
        }),
        H = (0, d.genarateComponentLevelStyleConfigurations)({
          txtStyles: P
        });
      return s.default.createElement(m, null, s.default.createElement(f, a({
        className: "" + E + x + " " + (j.cssClass ? j.cssClass : "")
      }, C, N), s.default.createElement(p, null, s.default.createElement("div", {
        className: "row m-0 p-0 justify-content-center"
      }, r && s.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: r
        }
      }), s.default.createElement(h, a({}, H, {
        className: P.cssClass ? P.cssClass : ""
      }), b)))));
    }
    return null;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = n(268);
  Object.defineProperty(t, "ComponentsConfiguration", {
    enumerable: !0,
    get: function () {
      return a.ComponentsConfiguration;
    }
  });
  var r = n(269);
  Object.defineProperty(t, "StyleConfigModels", {
    enumerable: !0,
    get: function () {
      return r.StyleConfigModels;
    }
  });
  var i = n(270);
  Object.defineProperty(t, "StyleConfigMappingModels", {
    enumerable: !0,
    get: function () {
      return i.StyleConfigMappingModels;
    }
  });
  var o = n(271);
  Object.defineProperty(t, "SettingsConfigModels", {
    enumerable: !0,
    get: function () {
      return o.SettingsConfigModels;
    }
  });
  var s = n(272);
  Object.defineProperty(t, "SettingsConfigMappingModels", {
    enumerable: !0,
    get: function () {
      return s.SettingsConfigMappingModels;
    }
  });
  var l = n(273);
  Object.defineProperty(t, "SectionsConfigurations", {
    enumerable: !0,
    get: function () {
      return l.SectionsConfigurations;
    }
  });
  var d = n(6);
  Object.defineProperty(t, "ParagraphComponent", {
    enumerable: !0,
    get: function () {
      return d.ParagraphComponent;
    }
  });
  var u = n(16);
  Object.defineProperty(t, "ImageComponent", {
    enumerable: !0,
    get: function () {
      return u.ImageComponent;
    }
  });
  var c = n(17);
  Object.defineProperty(t, "TitleComponent", {
    enumerable: !0,
    get: function () {
      return c.TitleComponent;
    }
  });
  var m = n(18);
  Object.defineProperty(t, "MainMenuComponent", {
    enumerable: !0,
    get: function () {
      return m.MainMenuComponent;
    }
  });
  var f = n(19);
  Object.defineProperty(t, "FooterMenuComponent", {
    enumerable: !0,
    get: function () {
      return f.FooterMenuComponent;
    }
  });
  var p = n(20);
  Object.defineProperty(t, "TitleParagraphComponent", {
    enumerable: !0,
    get: function () {
      return p.TitleParagraphComponent;
    }
  });
  var _ = n(275);
  Object.defineProperty(t, "IconResourcesMap", {
    enumerable: !0,
    get: function () {
      return _.IconResourcesMap;
    }
  });
  var h = n(276);
  Object.defineProperty(t, "IconColumnsMap", {
    enumerable: !0,
    get: function () {
      return h.IconColumnsMap;
    }
  });
  var y = n(277);
  Object.defineProperty(t, "MenusConfigurations", {
    enumerable: !0,
    get: function () {
      return y.MenusConfigurations;
    }
  });
  var g = n(180);
  Object.defineProperty(t, "PreviewPageComponent", {
    enumerable: !0,
    get: function () {
      return g.PreviewPageComponent;
    }
  });
  var v = n(325);
  Object.defineProperty(t, "PagePreviewComponent", {
    enumerable: !0,
    get: function () {
      return v.PagePreviewComponent;
    }
  });
  var M = n(11);
  Object.defineProperty(t, "BannerComponent", {
    enumerable: !0,
    get: function () {
      return M.BannerComponent;
    }
  });
  var L = n(24);
  Object.defineProperty(t, "TabUiComponent", {
    enumerable: !0,
    get: function () {
      return L.TabUiComponent;
    }
  });
  var b = n(25);
  Object.defineProperty(t, "CMSTableComponent", {
    enumerable: !0,
    get: function () {
      return b.CMSTableComponent;
    }
  });
  var w = n(28);
  Object.defineProperty(t, "LinkListUiComponent", {
    enumerable: !0,
    get: function () {
      return w.LinkListUiComponent;
    }
  });
  var k = n(29);
  Object.defineProperty(t, "FormComponent", {
    enumerable: !0,
    get: function () {
      return k.FormComponent;
    }
  });
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "ComponentsConfiguration", function () {
    return a;
  });
  var a = {
    components: [{
      compId: "paragraph",
      parentId: "",
      displayNameTag: "Paragraph",
      displayImage: "paragraphIcon",
      compFields: [{
        fieldType: "fieldLongText",
        dataKey: "paragraph",
        isLanguageWiseContentPresent: !0,
        validations: {
          required: !0,
          minLen: 0,
          maxLen: 1e3
        }
      }]
    }, {
      compId: "title",
      parentId: "",
      displayNameTag: "Title",
      displayImage: "titleIcon",
      compFields: [{
        fieldType: "fieldShortText",
        dataKey: "title",
        isLanguageWiseContentPresent: !0,
        validations: {
          required: !0,
          minLen: 0,
          maxLen: 100
        }
      }]
    }, {
      compId: "image",
      parentId: "",
      displayNameTag: "Image",
      displayImage: "imageIcon",
      settings: [{
        displayTitle: "Settings Input Field",
        settingType: "textInput",
        dataKey: "inputVal"
      }, {
        displayTitle: "Open link in new window",
        settingType: "toggleSwitch",
        dataKey: "seprateLink",
        settingData: {
          defaultValue: !1
        }
      }],
      compFields: [{
        fieldType: "fieldMedia",
        dataKey: "image",
        isLanguageWiseContentPresent: !0,
        validations: {
          required: !0,
          mediaFormat: ""
        }
      }]
    }, {
      compId: "table",
      parentId: "",
      displayNameTag: "Table",
      displayImage: "tableIcon",
      settings: [{
        displayTitle: "Custom Collections",
        settingType: "dropDown",
        dataKey: "collection",
        externalDataSource: {
          request: {
            url: "/api/custom-collections",
            params: {}
          },
          externalParams: {
            dataSourceUrl: "/api/cms/getCollectionData",
            BaseUrl: "/api/"
          },
          uniqueKeyMapping: "_id",
          displayNameMapping: "menuName",
          valueMapping: ""
        }
      }],
      compFields: [{
        fieldType: "fieldTable",
        dataKey: "table",
        isLanguageWiseContentPresent: !1,
        validations: {
          required: !0,
          minLen: 0,
          maxLen: 100
        }
      }]
    }, {
      compId: "banner",
      parentId: "",
      displayNameTag: "Banner",
      displayImage: "mediaCarouselIcon",
      styles: ["position"],
      settings: [{
        displayTitle: "Banner List",
        settingType: "dropDown",
        dataKey: "banner",
        externalDataSource: {
          request: {
            url: "/api/banners",
            params: {}
          },
          externalParams: {},
          uniqueKeyMapping: "_id",
          displayNameMapping: "title",
          valueMapping: "_id"
        }
      }, {
        displayTitle: "Banner interval (Seconds)",
        settingType: "numberInput",
        dataKey: "interval",
        settingData: {
          maxValue: 10,
          minValue: 1,
          defaultValue: 5
        }
      }],
      compFields: []
    }, {
      compId: "tab",
      parentId: "",
      displayNameTag: "Tab",
      displayImage: "tabIcon",
      compFields: [{
        fieldType: "fieldTab",
        dataKey: "tab",
        isLanguageWiseContentPresent: !0,
        validations: {
          required: !0,
          minLen: 0,
          maxLen: 100
        }
      }],
      settings: [{
        displayTitle: "Tab Settings",
        settingType: "dropDown",
        dataKey: "tab",
        settingData: [{
          uniqueKey: "horizontal",
          displayValue: "Horizontal Tab",
          value: "horizontal"
        }, {
          uniqueKey: "vertical",
          displayValue: "Vertical Tab",
          value: "vertical"
        }]
      }]
    }, {
      compId: "linkList",
      parentId: "",
      displayNameTag: "Link List",
      displayImage: "listIcon",
      compFields: [{
        fieldType: "fieldLinkList",
        dataKey: "linkList",
        isLanguageWiseContentPresent: !0,
        validations: {
          required: !0,
          minLen: 0,
          maxLen: 100
        }
      }],
      settings: [{
        displayTitle: "Link List Settings",
        settingType: "dropDown",
        dataKey: "linkList",
        settingData: [{
          uniqueKey: "horizontal",
          displayValue: "Horizontal Linklist",
          value: "horizontal"
        }, {
          uniqueKey: "vertical",
          displayValue: "Vertical Linklist",
          value: "vertical"
        }]
      }, {
        displayTitle: "Use URL Hash value",
        settingType: "toggleSwitch",
        dataKey: "useUrlHash",
        settingData: {
          defaultValue: !1
        }
      }]
    }, {
      compId: "popupBanner",
      displayNameTag: "Popup Banner",
      displayImage: "slidesIcon",
      settings: [{
        displayTitle: "Banner List",
        settingType: "dropDown",
        dataKey: "banner",
        externalDataSource: {
          request: {
            url: "/api/banners",
            params: {}
          },
          externalParams: {},
          uniqueKeyMapping: "_id",
          displayNameMapping: "title",
          valueMapping: "_id"
        }
      }, {
        displayTitle: "Banner interval (Seconds)",
        settingType: "numberInput",
        dataKey: "interval",
        settingData: {
          maxValue: 10,
          minValue: 1,
          defaultValue: 5
        }
      }, {
        displayTitle: "Popup Display Options",
        settingType: "dropDown",
        dataKey: "displayPopup",
        settingData: [{
          uniqueKey: "showAlways",
          displayValue: "Show always",
          value: "showAlways"
        }, {
          uniqueKey: "showOneTime",
          displayValue: "Show One Time",
          value: "showOneTime"
        }]
      }],
      compFields: []
    }, {
      compId: "countDown",
      parentId: "",
      displayNameTag: "Countdown",
      displayImage: "countDownIcon",
      compFields: []
    }, {
      compId: "mainMenu",
      parentId: "",
      displayNameTag: "Main Menu",
      displayImage: "mainMenuIcon",
      compFields: []
    }, {
      compId: "footerMenu",
      parentId: "",
      displayNameTag: "FooterMenu",
      displayImage: "footerMenuIcon",
      compFields: []
    }, {
      compId: "cardList",
      parentId: "",
      displayNameTag: "Card List",
      displayImage: "cardListIcon",
      settings: [{
        displayTitle: "Custom Collections",
        settingType: "dropDown",
        dataKey: "collection",
        externalDataSource: {
          request: {
            url: "/api/custom-collections",
            params: {}
          },
          externalParams: {
            dataSourceUrl: "/api/cms/getCollectionData",
            BaseUrl: "/api/"
          },
          uniqueKeyMapping: "_id",
          displayNameMapping: "menuName",
          valueMapping: ""
        }
      }, {
        displayTitle: "Records Limit",
        settingType: "numberInput",
        dataKey: "recordsLimit",
        settingData: {
          maxValue: 10,
          minValue: 1,
          defaultValue: 6
        }
      }, {
        displayTitle: "Cards Per Row",
        settingType: "numberInput",
        dataKey: "cardsPerRow",
        settingData: {
          maxValue: 6,
          minValue: 1,
          defaultValue: 3
        }
      }, {
        displayTitle: "Records Order",
        settingType: "dropDown",
        dataKey: "recordsOrder",
        settingData: [{
          uniqueKey: "asc",
          displayValue: "Ascending Order",
          value: "asc"
        }, {
          uniqueKey: "desc",
          displayValue: "Descending Order",
          value: "desc"
        }]
      }, {
        displayTitle: "Enable View More link",
        settingType: "toggleSwitch",
        dataKey: "viewMoreLink",
        settingData: {
          defaultValue: !1
        }
      }],
      compFields: [{
        fieldType: "fieldCardList",
        dataKey: "cardList",
        isLanguageWiseContentPresent: !1,
        validations: {
          required: !0,
          minLen: 0,
          maxLen: 100
        }
      }]
    }, {
      compId: "card",
      parentId: "",
      displayNameTag: "Card",
      displayImage: "cardIcon",
      compFields: []
    }, {
      compId: "button",
      parentId: "",
      displayNameTag: "Button",
      displayImage: "buttonIcon",
      styles: ["buttonComponentStyles"],
      settings: [{
        displayTitle: "Button Type",
        settingType: "dropDown",
        dataKey: "buttonType",
        settingData: [{
          uniqueKey: "link",
          displayValue: "Default Link",
          value: "link"
        }, {
          uniqueKey: "button",
          displayValue: "Default Button",
          value: "button"
        }]
      }, {
        displayTitle: "Button Size",
        settingType: "dropDown",
        dataKey: "buttonSize",
        settingData: [{
          uniqueKey: "small",
          displayValue: "Small Button",
          value: "small"
        }, {
          uniqueKey: "medium",
          displayValue: "Medium Button",
          value: "medium"
        }, {
          uniqueKey: "large",
          displayValue: "Large Button",
          value: "large"
        }]
      }, {
        displayTitle: "Enable Block Level",
        settingType: "toggleSwitch",
        dataKey: "isBlockLevel",
        settingData: {
          defaultValue: !1
        }
      }, {
        displayTitle: "Icon Name (React-feather)",
        settingType: "textInput",
        dataKey: "iconName"
      }, {
        displayTitle: "Icon Color (Ex: #000000)",
        settingType: "textInput",
        dataKey: "iconColor"
      }, {
        displayTitle: "Icon Size (Pixels)",
        settingType: "textInput",
        dataKey: "iconSize"
      }],
      compFields: [{
        fieldType: "fieldShortText",
        dataKey: "text",
        isLanguageWiseContentPresent: !0,
        validations: {
          required: !0,
          minLen: 0,
          maxLen: 100
        },
        style: []
      }, {
        fieldType: "fieldShortText",
        dataKey: "link",
        isLanguageWiseContentPresent: !0,
        validations: {
          required: !1,
          minLen: 0,
          maxLen: 100
        },
        style: []
      }, {
        fieldType: "fieldToggleSwitch",
        dataKey: "openInNewWindow",
        isLanguageWiseContentPresent: !1,
        validations: {
          required: !1
        },
        style: []
      }, {
        fieldType: "fieldToggleSwitch",
        dataKey: "addNoFollow",
        isLanguageWiseContentPresent: !1,
        validations: {
          required: !1
        },
        style: []
      }]
    }, {
      compId: "socialMedia",
      parentId: "",
      displayNameTag: "Social Media",
      displayImage: "slidesIcon",
      compFields: []
    }, {
      compId: "list",
      parentId: "",
      displayNameTag: "List",
      displayImage: "cardListIcon",
      settings: [{
        displayTitle: "Custom Collections",
        settingType: "dropDown",
        dataKey: "collection",
        externalDataSource: {
          request: {
            url: "/api/custom-collections",
            params: {}
          },
          externalParams: {
            dataSourceUrl: "/api/cms/getCollectionData",
            BaseUrl: "/api/"
          },
          uniqueKeyMapping: "_id",
          displayNameMapping: "menuName",
          valueMapping: ""
        }
      }, {
        displayTitle: "Records Order",
        settingType: "dropDown",
        dataKey: "recordsOrder",
        settingData: [{
          uniqueKey: "asc",
          displayValue: "Ascending Order",
          value: "asc"
        }, {
          uniqueKey: "desc",
          displayValue: "Descending Order",
          value: "desc"
        }]
      }],
      compFields: [{
        fieldType: "fieldList",
        dataKey: "list",
        isLanguageWiseContentPresent: !1,
        validations: {
          required: !0,
          minLen: 0,
          maxLen: 100
        }
      }]
    }, {
      compId: "treeView",
      parentId: "",
      displayNameTag: "Tree View",
      displayImage: "treeIcon",
      settings: [{
        displayTitle: "Tree List",
        settingType: "dropDown",
        dataKey: "tree",
        externalDataSource: {
          request: {
            url: "/api/custom-collections/tree/all",
            params: {}
          },
          externalParams: {},
          uniqueKeyMapping: "id",
          displayNameMapping: "title",
          valueMapping: "id"
        }
      }, {
        displayTitle: "Enable scrolling",
        settingType: "toggleSwitch",
        dataKey: "scroll",
        settingData: {
          defaultValue: !1
        }
      }],
      compFields: []
    }, {
      compId: "accordionView",
      parentId: "",
      displayNameTag: "Document Accordion View",
      displayImage: "accordionIcon",
      settings: [{
        displayTitle: "Search Result Page",
        settingType: "textInput",
        dataKey: "searchResultURL"
      }, {
        displayTitle: "PDF Download Content",
        settingType: "customCollectionOptionSelect",
        dataKey: "customReport"
      }, {
        displayTitle: "Enable scrolling",
        settingType: "toggleSwitch",
        dataKey: "scroll",
        settingData: {
          defaultValue: !1
        }
      }],
      compFields: [{
        fieldType: "fieldDocumentAccordion",
        dataKey: "dataMap",
        isLanguageWiseContentPresent: !1,
        validations: {
          required: !0,
          minLen: 0,
          maxLen: 100
        }
      }]
    }, {
      compId: "dateVersion",
      parentId: "",
      displayNameTag: "Date Version",
      displayImage: "accordionIcon",
      settings: [{
        displayTitle: "Custom Collections",
        settingType: "dropDown",
        dataKey: "collection",
        externalDataSource: {
          request: {
            url: "/api/custom-collections",
            params: {}
          },
          externalParams: {},
          uniqueKeyMapping: "_id",
          displayNameMapping: "menuName",
          valueMapping: "customeCollectionName"
        }
      }],
      compFields: [{
        fieldType: "fieldShortText",
        dataKey: "text",
        isLanguageWiseContentPresent: !0,
        validations: {
          required: !0,
          minLen: 0,
          maxLen: 100
        },
        style: []
      }]
    }, {
      compId: "siteSearch",
      parentId: "",
      displayNameTag: "Site Search",
      displayImage: "searchIcon",
      settings: [{
        displayTitle: "Full width Component",
        settingType: "toggleSwitch",
        dataKey: "componentType",
        settingData: {
          defaultValue: !1
        }
      }],
      compFields: []
    }, {
      compId: "siteSearchResults",
      parentId: "",
      displayNameTag: "Site Search Results",
      displayImage: "siteSearchIcon",
      settings: [{
        displayTitle: "Records Limit",
        settingType: "numberInput",
        dataKey: "recordsLimit",
        settingData: {
          maxValue: 10,
          minValue: 1,
          defaultValue: 5
        }
      }],
      compFields: []
    }, {
      compId: "socialMediaShare",
      parentId: "",
      displayNameTag: "Social Media Share",
      displayImage: "slidesIcon",
      compFields: []
    }, {
      compId: "treeSearch",
      parentId: "",
      displayNameTag: "Tree Search",
      displayImage: "treeIcon",
      settings: [{
        displayTitle: "Tree List",
        settingType: "dropDown",
        dataKey: "tree",
        externalDataSource: {
          request: {
            url: "/api/custom-collections/tree/all",
            params: {}
          },
          externalParams: {},
          uniqueKeyMapping: "id",
          displayNameMapping: "title",
          valueMapping: "id"
        }
      }, {
        displayTitle: "Title Mapping Field",
        settingType: "textInput",
        dataKey: "titleMap"
      }, {
        displayTitle: "Paragraph Mapping Field",
        settingType: "textInput",
        dataKey: "paragraphMap"
      }],
      compFields: []
    }, {
      compId: "productSubscription",
      parentId: "",
      displayNameTag: "Product Subscription",
      displayImage: "slidesIcon",
      compFields: []
    }, {
      compId: "subscriptionConfirmation",
      parentId: "",
      displayNameTag: "Subscription Confirmation",
      displayImage: "slidesIcon",
      compFields: []
    }, {
      compId: "video",
      parentId: "",
      displayNameTag: "video",
      displayImage: "videoIcon",
      compFields: [{
        fieldType: "fieldVideo",
        dataKey: "video",
        isLanguageWiseContentPresent: !0,
        validations: {}
      }],
      settings: [{
        displayTitle: "Enable Auto Play",
        settingType: "toggleSwitch",
        dataKey: "autoPlay",
        settingData: {
          defaultValue: !1
        }
      }, {
        displayTitle: "Enable Video Download",
        settingType: "toggleSwitch",
        dataKey: "downloadable",
        settingData: {
          defaultValue: !0
        }
      }]
    }, {
      compId: "icon",
      parentId: "",
      displayNameTag: "icon",
      displayImage: "imageIcon",
      compFields: [{
        fieldType: "fieldIcon",
        dataKey: "icon",
        isLanguageWiseContentPresent: !0,
        validations: {}
      }],
      settings: [{
        displayTitle: "Open link in new window",
        settingType: "toggleSwitch",
        dataKey: "seprateLink",
        settingData: {
          defaultValue: !1
        }
      }, {
        displayTitle: "Icon Size",
        settingType: "dropDown",
        dataKey: "iconSize",
        settingData: [{
          uniqueKey: "18dp",
          displayValue: "18dp",
          value: "18"
        }, {
          uniqueKey: "24dp",
          displayValue: "24dp",
          value: "24"
        }, {
          uniqueKey: "36dp",
          displayValue: "36dp",
          value: "36"
        }, {
          uniqueKey: "48dp",
          displayValue: "48dp",
          value: "48"
        }]
      }]
    }, {
      compId: "form",
      parentId: "",
      displayNameTag: "Form",
      displayImage: "accordionIcon",
      settings: [{
        displayTitle: "Custom Collections",
        settingType: "dropDown",
        dataKey: "collection",
        externalDataSource: {
          request: {
            url: "/api/collection/data/all",
            params: {
              collection: "forms"
            }
          },
          externalParams: {},
          uniqueKeyMapping: "_id",
          displayNameMapping: "title",
          valueMapping: "_id"
        }
      }],
      compFields: []
    }, {
      compId: "basicMenu",
      parentId: "",
      displayNameTag: "Basic Menu",
      displayImage: "mainMenuIcon",
      compFields: [{
        fieldType: "fieldLinkList",
        dataKey: "basicMenu",
        isLanguageWiseContentPresent: !0,
        validations: {
          required: !0,
          minLen: 0,
          maxLen: 100
        }
      }],
      settings: [{
        displayTitle: "Logo",
        settingType: "imageGallery",
        dataKey: "logo"
      }]
    }, {
      compId: "htmlCodeBlock",
      parentId: "",
      displayNameTag: "HTML Code Block",
      displayImage: "slidesIcon",
      compFields: [{
        fieldType: "fieldShortText",
        dataKey: "title",
        isLanguageWiseContentPresent: !0
      }]
    }, {
      compId: "newsList",
      parentId: "",
      displayNameTag: "News List",
      displayImage: "slidesIcon",
      settings: [{
        displayTitle: "Custom Collections",
        settingType: "dropDown",
        dataKey: "collection",
        externalDataSource: {
          request: {
            url: "/api/custom-collections",
            params: {}
          },
          externalParams: {
            dataSourceUrl: "/api/cms/getCollectionData",
            BaseUrl: "/api/"
          },
          uniqueKeyMapping: "_id",
          displayNameMapping: "menuName",
          valueMapping: ""
        }
      }, {
        displayTitle: "Records Limit",
        settingType: "numberInput",
        dataKey: "recordsLimit",
        settingData: {
          maxValue: 10,
          minValue: 1,
          defaultValue: 6
        }
      }, {
        displayTitle: "Records Order",
        settingType: "dropDown",
        dataKey: "recordsOrder",
        settingData: [{
          uniqueKey: "asc",
          displayValue: "Ascending Order",
          value: "asc"
        }, {
          uniqueKey: "desc",
          displayValue: "Descending Order",
          value: "desc"
        }]
      }],
      compFields: [{
        fieldType: "fieldNewsList",
        dataKey: "newsList",
        isLanguageWiseContentPresent: !1,
        validations: {
          required: !0,
          minLen: 0,
          maxLen: 100
        }
      }]
    }, {
      compId: "news",
      parentId: "",
      displayNameTag: "News",
      displayImage: "slidesIcon",
      compFields: [{
        fieldType: "fieldNews",
        dataKey: "news",
        isLanguageWiseContentPresent: !1,
        validations: {
          required: !0,
          minLen: 0,
          maxLen: 100
        }
      }],
      settings: [{
        displayTitle: "News Data",
        settingType: "collectionDropDownSelect",
        dataKey: "news",
        settingData: []
      }]
    }, {
      compId: "tutorialTreeView",
      parentId: "",
      displayNameTag: "Tutorial Tree View",
      displayImage: "treeIcon",
      settings: [{
        displayTitle: "Tutorial Tree List",
        settingType: "dropDown",
        dataKey: "tree",
        externalDataSource: {
          request: {
            url: "/api/custom-collections/tree/all",
            params: {}
          },
          externalParams: {},
          uniqueKeyMapping: "id",
          displayNameMapping: "title",
          valueMapping: "id"
        }
      }],
      compFields: []
    }, {
      compId: "tutorialView",
      parentId: "",
      displayNameTag: "Tutorial View",
      displayImage: "accordionIcon",
      settings: [{
        displayTitle: "Custom Collections",
        settingType: "dropDown",
        dataKey: "collection",
        externalDataSource: {
          request: {
            url: "/api/collection/data/all",
            params: {
              collection: "tutorialView"
            }
          },
          externalParams: {},
          uniqueKeyMapping: "_id",
          displayNameMapping: "title",
          valueMapping: "_id"
        }
      }],
      compFields: []
    }, {
      compId: "linkDropdown",
      parentId: "",
      displayNameTag: "Link Dropdown",
      displayImage: "accordionIcon",
      settings: [{
        displayTitle: "Custom Collections",
        settingType: "dropDown",
        dataKey: "collection",
        externalDataSource: {
          request: {
            url: "/api/custom-collections",
            params: {}
          },
          externalParams: {
            dataSourceUrl: "/api/cms/getCollectionData",
            BaseUrl: "/api/"
          },
          uniqueKeyMapping: "_id",
          displayNameMapping: "menuName",
          valueMapping: ""
        }
      }],
      compFields: [{
        fieldType: "fieldLinkDropdown",
        dataKey: "linkDropdown",
        isLanguageWiseContentPresent: !1,
        validations: {
          required: !0,
          minLen: 0,
          maxLen: 100
        }
      }]
    }, {
      compId: "imageLinkList",
      parentId: "",
      displayNameTag: "Image Link List",
      displayImage: "listIcon",
      compFields: [{
        fieldType: "fieldImageLinkList",
        dataKey: "linkList",
        isLanguageWiseContentPresent: !0,
        validations: {
          required: !0,
          minLen: 0,
          maxLen: 100
        }
      }],
      settings: [{
        displayTitle: "Link List Settings",
        settingType: "dropDown",
        dataKey: "linkList",
        settingData: [{
          uniqueKey: "horizontal",
          displayValue: "Horizontal Linklist",
          value: "horizontal"
        }, {
          uniqueKey: "vertical",
          displayValue: "Vertical Linklist",
          value: "vertical"
        }]
      }]
    }, {
      compId: "subscribe",
      parentId: "",
      displayNameTag: "Subscribe",
      displayImage: "slidesIcon",
      settings: [],
      compFields: [],
      styles: []
    }, {
      compId: "advanceMenu",
      parentId: "",
      displayNameTag: "Advance Menu",
      displayImage: "mainMenuIcon",
      compFields: [{
        fieldType: "fieldAdvanceMenu",
        dataKey: "advanceMenu",
        isLanguageWiseContentPresent: !0,
        validations: {
          required: !0,
          minLen: 0,
          maxLen: 100
        }
      }],
      settings: [{
        displayTitle: "Logo",
        settingType: "imageGallery",
        dataKey: "logo"
      }]
    }, {
      compId: "newsFeed",
      parentId: "",
      displayNameTag: "News Feed",
      displayImage: "accordionIcon",
      compFields: []
    }, {
      compId: "topNews",
      parentId: "",
      displayNameTag: "Top News",
      displayImage: "accordionIcon",
      compFields: []
    }, {
      compId: "transitioncard",
      parentId: "",
      displayNameTag: "Transition Card",
      displayImage: "cardIcon",
      settings: [{
        displayTitle: "Overlay Color",
        settingType: "textInput",
        dataKey: "overlaycolor"
      }, {
        displayTitle: "Opacity",
        settingType: "textInput",
        dataKey: "opacity"
      }],
      compFields: [{
        fieldType: "fieldLongText",
        dataKey: "content_1",
        isLanguageWiseContentPresent: !0,
        validations: {
          required: !1,
          minLen: 0,
          maxLen: 1e3
        }
      }, {
        fieldType: "fieldMedia",
        dataKey: "image_1",
        isLanguageWiseContentPresent: !0,
        validations: {
          required: !1,
          mediaFormat: ""
        }
      }]
    }, {
      compId: "cardWithImage",
      parentId: "",
      displayNameTag: "Card With Image",
      displayImage: "cardIcon",
      settings: [],
      compFields: [{
        fieldType: "fieldLongText",
        dataKey: "content",
        isLanguageWiseContentPresent: !0,
        validations: {
          required: !1,
          minLen: 0,
          maxLen: 1e3
        }
      }]
    }, {
      compId: "testimonial",
      parentId: "",
      displayNameTag: "Testimonial",
      displayImage: "accordionIcon",
      compFields: [],
      settings: [{
        displayTitle: "Testimonial Type",
        settingType: "dropDown",
        dataKey: "testimonialType",
        settingData: [{
          uniqueKey: "type1",
          displayValue: "Image Only 1 item per row",
          value: "type1"
        }, {
          uniqueKey: "type2",
          displayValue: "Image Only 2 items per row",
          value: "type2"
        }, {
          uniqueKey: "type3",
          displayValue: "Image Only 4 items per row",
          value: "type3"
        }, {
          uniqueKey: "type4",
          displayValue: "Image with Description",
          value: "type4"
        }]
      }, {
        displayTitle: "Custom Collections",
        settingType: "dropDown",
        dataKey: "collection",
        externalDataSource: {
          request: {
            url: "/api/custom-collections",
            params: {}
          },
          externalParams: {
            dataSourceUrl: "/api/cms/getCollectionData",
            BaseUrl: "/api/"
          },
          uniqueKeyMapping: "_id",
          displayNameMapping: "menuName",
          valueMapping: ""
        }
      }]
    }, {
      compId: "newsAndEvents",
      parentId: "",
      displayNameTag: "News & Events",
      displayImage: "accordionIcon",
      compFields: [],
      settings: [{
        displayTitle: "News cards view type",
        settingType: "dropDown",
        dataKey: "newsView",
        settingData: [{
          uniqueKey: "horizontal",
          displayValue: "Horizontal Slider",
          value: "horizontal"
        }, {
          uniqueKey: "vertical",
          displayValue: "Vertical Slider",
          value: "vertical"
        }, {
          uniqueKey: "cards",
          displayValue: "News Cards Only",
          value: "cards"
        }, {
          uniqueKey: "cards",
          displayValue: "Cards Carousel",
          value: "cardsCarousel"
        }]
      }, {
        displayTitle: "News Data Collection",
        settingType: "dropDown",
        dataKey: "collection",
        externalDataSource: {
          request: {
            url: "/api/custom-collections",
            params: {}
          },
          externalParams: {
            dataSourceUrl: "/api/cms/getCollectionData",
            BaseUrl: "/api/"
          },
          uniqueKeyMapping: "_id",
          displayNameMapping: "menuName",
          valueMapping: ""
        }
      }]
    }, {
      compId: "careers",
      parentId: "",
      displayNameTag: "Careers",
      displayImage: "accordionIcon",
      compFields: [],
      settings: [{
        displayTitle: "Tag Collection",
        settingType: "dropDown",
        dataKey: "tagsCollection",
        externalDataSource: {
          request: {
            url: "/api/custom-collections",
            params: {}
          },
          externalParams: {
            dataSourceUrl: "/api/cms/getCollectionData",
            BaseUrl: "/api/"
          },
          uniqueKeyMapping: "_id",
          displayNameMapping: "menuName",
          valueMapping: ""
        }
      }, {
        displayTitle: "Vacancy Collection",
        settingType: "dropDown",
        dataKey: "vacancyCollection",
        externalDataSource: {
          request: {
            url: "/api/custom-collections",
            params: {}
          },
          externalParams: {
            dataSourceUrl: "/api/cms/getCollectionData",
            BaseUrl: "/api/"
          },
          uniqueKeyMapping: "_id",
          displayNameMapping: "menuName",
          valueMapping: ""
        }
      }, {
        displayTitle: "view type",
        settingType: "dropDown",
        dataKey: "viewType",
        settingData: [{
          uniqueKey: "list",
          displayValue: "list",
          value: "list"
        }, {
          uniqueKey: "detailed",
          displayValue: "detailed",
          value: "detailed"
        }]
      }]
    }, {
      compId: "cardlistSlider",
      parentId: "",
      displayNameTag: "Card List Slider",
      displayImage: "accordionIcon",
      compFields: [],
      settings: [{
        displayTitle: "Items per row (Desktop View)",
        settingType: "dropDown",
        dataKey: "itemsPerRow",
        settingData: [{
          uniqueKey: "4",
          displayValue: "4",
          value: "col-md-3"
        }, {
          uniqueKey: "3",
          displayValue: "3",
          value: "col-md-4"
        }, {
          uniqueKey: "2",
          displayValue: "2",
          value: "col-md-6"
        }]
      }, {
        displayTitle: "CardList Slider Data Collection",
        settingType: "dropDown",
        dataKey: "collection",
        externalDataSource: {
          request: {
            url: "/api/custom-collections",
            params: {}
          },
          externalParams: {
            dataSourceUrl: "/api/cms/getCollectionData",
            BaseUrl: "/api/"
          },
          uniqueKeyMapping: "_id",
          displayNameMapping: "menuName",
          valueMapping: ""
        }
      }]
    }, {
      compId: "homeVideoBanner",
      parentId: "",
      displayNameTag: "Video Banner",
      displayImage: "cardIcon",
      settings: [],
      compFields: [{
        fieldType: "fieldVideo",
        dataKey: "video",
        isLanguageWiseContentPresent: !0,
        validations: {}
      }, {
        fieldType: "fieldLongText",
        dataKey: "content",
        isLanguageWiseContentPresent: !0,
        validations: {
          required: !1,
          minLen: 0,
          maxLen: 1e3
        }
      }]
    }, {
      compId: "langSelect",
      parentId: "",
      displayNameTag: "Language Selector",
      displayImage: "tableIcon",
      compFields: []
    }]
  };
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "StyleConfigModels", function () {
    return a;
  });
  var a = {
    styles: {
      typography: {
        fontFamily: [{
          key: "Tajawal",
          value: "Tajawal"
        }, {
          key: "sans-serif",
          value: "sans-serif"
        }, {
          key: "Poppins",
          value: "Poppins"
        }, {
          key: "Open Sans",
          value: "Open Sans"
        }],
        fontSize: [{
          key: "px",
          value: "PX"
        }, {
          key: "em",
          value: "EM"
        }, {
          key: "rem",
          value: "REM"
        }, {
          key: "vw",
          value: "VW"
        }],
        fontStyle: [{
          key: "italic",
          value: "Italic"
        }, {
          key: "oblique",
          value: "Oblique"
        }],
        fontweight: [{
          key: "bold",
          value: "Bold"
        }],
        textTransform: [{
          key: "upper",
          value: "Upper"
        }, {
          key: "lower",
          value: "Lower"
        }, {
          key: "capitalize",
          value: "Capitalize"
        }],
        textDecoration: [{
          key: "underline",
          value: "Underline"
        }, {
          key: "overline",
          value: "Overline"
        }, {
          key: "lineThrough",
          value: "Line Through"
        }],
        lineHeight: [{
          key: "px",
          value: "PX"
        }, {
          key: "em",
          value: "EM"
        }],
        letterSpacing: [{
          key: "0",
          value: "0"
        }]
      },
      textShadow: [{
        key: "blur",
        value: "Blur"
      }, {
        key: "horizontal",
        value: "Horizontal"
      }, {
        key: "vertical",
        value: "Vertical"
      }],
      textAlignment: [{
        key: "left",
        value: "Left"
      }, {
        key: "right",
        value: "Right"
      }, {
        key: "center",
        value: "Center"
      }, {
        key: "justify",
        value: "Justify"
      }],
      textColor: [{
        key: "htmlDefaultColorPicker",
        value: "Default Color Picker"
      }],
      customCSS: [],
      cssClass: [],
      sectionId: [],
      background: {
        normal: {
          classic: {
            color: [{
              key: "htmlDefaultColorPicker",
              value: "Default Color Picker"
            }],
            image: [{
              key: "defaultImageUploader",
              value: "Default Image Uploader"
            }]
          },
          gradient: {}
        },
        hover: {}
      },
      margin: {
        top: "Margin Top",
        bottom: "Margin Bottom",
        left: "Margin Left",
        right: "Margin Right"
      },
      padding: {
        top: "Padding Top",
        bottom: "Padding Bottom",
        left: "Padding Left",
        right: "Padding Right"
      },
      backgroundOverlay: {},
      border: {},
      contentPosition: [{
        key: "topLeft",
        value: "Top Left"
      }, {
        key: "topCenter",
        value: "Top Center"
      }, {
        key: "topRight",
        value: "Top Right"
      }, {
        key: "midLeft",
        value: "Middle Left"
      }, {
        key: "midCenter",
        value: "Middle Center"
      }, {
        key: "midRight",
        value: "Middle Right"
      }, {
        key: "bottomLeft",
        value: "Bottom Left"
      }, {
        key: "bottomCenter",
        value: "Bottom Center"
      }, {
        key: "bottomRight",
        value: "Bottom Right"
      }]
    }
  };
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "StyleConfigMappingModels", function () {
    return a;
  });
  var a = {
    fieldStyles: {
      fieldShortText: ["textColor", "typography", "textAlignment", "textShadow", "cssClass", "customCSS"],
      fieldLongText: ["cssClass", "customCSS"],
      fieldMedia: ["cssClass", "customCSS"],
      fieldCardList: ["cssClass", "customCSS"],
      fieldVideo: ["cssClass", "customCSS"],
      fieldTab: ["cssClass", "customCSS"],
      fieldLinkList: ["cssClass", "customCSS"],
      fieldList: ["cssClass", "customCSS"],
      fieldIcon: ["textAlignment", "cssClass", "customCSS"]
    },
    _commentLayoutStyles: "LayoutTypes can be an array or an object similar to the stylesConfigurations",
    layoutStyles: {
      section: ["background", "margin", "padding", "sectionId", "cssClass", "customCSS"],
      column: ["background", "margin", "padding", "cssClass", "customCSS"],
      innerSection: ["background", "margin", "padding", "sectionId", "cssClass", "customCSS"],
      innerColumn: ["background", "margin", "padding", "cssClass", "customCSS"]
    },
    componentStyles: {
      position: ["contentPosition", "margin", "padding"],
      buttonComponentStyles: ["cssClass", "customCSS"]
    }
  };
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "SettingsConfigModels", function () {
    return a;
  });
  var a = {
    settings: {
      table: {
        columnName: {
          configs: {
            field: "shortText",
            isLanguageWiseContentPresent: !0,
            labelName: "Column Name",
            dataSource: "",
            dependentFieldName: ""
          }
        },
        mappingField: {
          configs: {
            field: "dropDown",
            isLanguageWiseContentPresent: !1,
            labelName: "Mapping Field",
            dataSource: "componentSettings.fieldsList",
            dependentFieldName: ""
          }
        },
        dataType: {
          values: {
            text: "Text",
            boolean: "Boolean",
            date: "Date",
            number: "Number",
            image: "Image",
            icon: "Icon",
            link: "Link",
            button: "Button"
          },
          configs: {
            field: "dropDown",
            isLanguageWiseContentPresent: !1,
            labelName: "Data Type",
            dataSource: "",
            dependentFieldName: "formatting"
          }
        },
        formatting: {
          values: {
            text: {},
            boolean: {},
            date: {
              "yyyy-mm-dd": "YYYY-MM-DD",
              "yyyy-mm": "YYYY-MM",
              yyyy: "YYYY",
              "yyyy-mm-ddthh:mm:ssz": "YYYY-MM-DDHH:MM:SS",
              "mm/dd/yyyy": "MM/DD/YYYY",
              "yyyy/mm/dd": "YYYY/MM/DD",
              "mm-dd-yyyy": "MM-DD-YYYY"
            },
            number: {
              integer: "Integer",
              decimal: "Decimal",
              exponent: "Exponential",
              fixed: "Fixed",
              precision: "Precision"
            },
            image: {},
            link: {},
            button: {},
            icon: {
              imageFileIcon: "Image Viewer",
              pdfFileIcon: "PDF Viewer",
              docFileIcon: "DOC File Viewer",
              audioFileIcon: "Audio Viewer",
              videoFileIcon: "Video Viewer",
              downloadFileIcon: "File Downloader"
            }
          },
          configs: {
            field: "dropDown",
            isLanguageWiseContentPresent: !1,
            labelName: "Formatting",
            dataSource: "",
            dependentFieldName: ""
          }
        },
        addNewColumn: {
          configs: {
            field: "button",
            isLanguageWiseContentPresent: !1,
            labelName: "Add New Column",
            dataSource: "",
            dependentFieldName: ""
          }
        }
      },
      accordionView: {
        mappingField: {
          configs: {
            field: "shortText",
            isLanguageWiseContentPresent: !1,
            labelName: "Title mapping Field",
            dataSource: "",
            dependentFieldName: ""
          }
        }
      }
    }
  };
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "SettingsConfigMappingModels", function () {
    return a;
  });
  var a = {
    fieldsSettings: {
      fieldTable: ["columnName", "mappingField", "dataType", "formatting", "addNewColumn"],
      fieldDocumentAccordion: ["mappingField"]
    }
  };
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "SectionsConfigurations", function () {
    return a;
  });
  var a = {
    _equalColumnsComment: "['true', 'false']",
    _deviceComment: "['extraSmall', 'small', 'medium', 'large', 'extraLarge']",
    _comment: "If columns are equal, then columnsSize is ignored.",
    sectionTypes: [{
      sectionTypeId: "structure-01",
      displayImage: "colOne",
      columnsCount: 1,
      equalColumns: !0,
      device: "medium",
      columnsSize: []
    }, {
      sectionTypeId: "structure-02",
      displayImage: "colTwo",
      columnsCount: 2,
      equalColumns: !0,
      device: "medium",
      columnsSize: []
    }, {
      sectionTypeId: "structure-03",
      displayImage: "colThree",
      columnsCount: 3,
      equalColumns: !0,
      device: "medium",
      columnsSize: []
    }, {
      sectionTypeId: "structure-04",
      displayImage: "colFour",
      columnsCount: 4,
      equalColumns: !0,
      device: "medium",
      columnsSize: []
    }, {
      sectionTypeId: "structure-05",
      displayImage: "colFive",
      columnsCount: 5,
      equalColumns: !0,
      device: "medium",
      columnsSize: []
    }, {
      sectionTypeId: "structure-06",
      displayImage: "colSix",
      columnsCount: 6,
      equalColumns: !0,
      device: "medium",
      columnsSize: []
    }, {
      sectionTypeId: "structure-07",
      displayImage: "colFourEightLeft",
      columnsCount: 2,
      equalColumns: !1,
      device: "medium",
      columnsSize: [{
        columnSize: 4
      }, {
        columnSize: 8
      }]
    }, {
      sectionTypeId: "structure-08",
      displayImage: "colFourEightRight",
      columnsCount: 2,
      equalColumns: !1,
      device: "medium",
      columnsSize: [{
        columnSize: 8
      }, {
        columnSize: 4
      }]
    }, {
      sectionTypeId: "structure-09",
      displayImage: "colThreeThreeSixLeft",
      columnsCount: 3,
      equalColumns: !1,
      device: "medium",
      columnsSize: [{
        columnSize: 3
      }, {
        columnSize: 3
      }, {
        columnSize: 6
      }]
    }, {
      sectionTypeId: "structure-10",
      displayImage: "colThreeThreeSixRight",
      columnsCount: 3,
      equalColumns: !1,
      device: "medium",
      columnsSize: [{
        columnSize: 6
      }, {
        columnSize: 3
      }, {
        columnSize: 3
      }]
    }, {
      sectionTypeId: "structure-11",
      displayImage: "colThreeSixThree",
      columnsCount: 3,
      equalColumns: !1,
      device: "medium",
      columnsSize: [{
        columnSize: 3
      }, {
        columnSize: 6
      }, {
        columnSize: 3
      }]
    }, {
      sectionTypeId: "structure-12",
      displayImage: "colTwoEightTwo",
      columnsCount: 3,
      equalColumns: !1,
      device: "medium",
      columnsSize: [{
        columnSize: 2
      }, {
        columnSize: 8
      }, {
        columnSize: 2
      }]
    }]
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.LoggedUserComponent = void 0;
  var a = o(n(0)),
    r = o(n(32)),
    i = o(n(3));
  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  t.LoggedUserComponent = function (e) {
    var t = e.lang,
      n = new r.default(),
      o = n.get("bk_name") ? n.get("bk_name") : void 0,
      s = [{
        text: "AR" == t.langKey ? "تغيير كلمة السر" : "Change Password",
        url: "/change-default-password"
      }];
    return o ? a.default.createElement("div", {
      className: "loggedUserContainer"
    }, a.default.createElement("button", {
      "data-toggle": "dropdown",
      className: "user-menu-trigger btn btn-light dropdown-toggle",
      type: "button",
      "aria-expanded": "false"
    }, a.default.createElement("span", null, o)), a.default.createElement("ul", {
      className: "dropdown-menu"
    }, s.map(function (e) {
      return a.default.createElement("li", null, a.default.createElement("a", {
        href: ("AR" == t.langKey ? "/ar" : "/en") + e.url,
        className: "dropdown-item"
      }, e.text));
    }), a.default.createElement("li", null, a.default.createElement("a", {
      href: "#",
      className: "dropdown-item",
      onClick: function () {
        return e = n.get("bk_email"), t = n.get("bk_session"), i.default.get("/api/web/auth/logout", {
          params: {
            email: e,
            sessionId: t,
            prodId: 42
          }
        }), n.remove("bk_session", {
          path: "/"
        }), n.remove("bk_email", {
          path: "/"
        }), n.remove("bk_subscriptions", {
          path: "/"
        }), n.remove("bk_login_id", {
          path: "/"
        }), n.remove("bk_name", {
          path: "/"
        }), void setTimeout(function () {
          return window.location.reload();
        }, 1500);
        var e, t;
      }
    }, "AR" == t.langKey ? "تسجيل الخروج" : "Logout")))) : a.default.createElement(a.default.Fragment, null);
  };
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "IconResourcesMap", function () {
    return Ze;
  });
  var a = n(181),
    r = n.n(a),
    i = n(182),
    o = n.n(i),
    s = n(183),
    l = n.n(s),
    d = n(184),
    u = n.n(d),
    c = n(185),
    m = n.n(c),
    f = n(186),
    p = n.n(f),
    _ = n(187),
    h = n.n(_),
    y = n(188),
    g = n.n(y),
    v = n(189),
    M = n.n(v),
    L = n(190),
    b = n.n(L),
    w = n(191),
    k = n.n(w),
    Y = n(192),
    D = n.n(Y),
    S = n(193),
    T = n.n(S),
    E = n(194),
    x = n.n(E),
    C = n(195),
    j = n.n(C),
    P = n(196),
    N = n.n(P),
    H = n(197),
    O = n.n(H),
    I = n(198),
    z = n.n(I),
    A = n(199),
    F = n.n(A),
    R = n(200),
    W = n.n(R),
    V = n(201),
    K = n.n(V),
    B = n(202),
    U = n.n(B),
    q = n(203),
    J = n.n(q),
    Z = n(204),
    G = n.n(Z),
    $ = n(205),
    X = n.n($),
    Q = n(206),
    ee = n.n(Q),
    te = n(207),
    ne = n.n(te),
    ae = n(208),
    re = n.n(ae),
    ie = n(209),
    oe = n.n(ie),
    se = n(210),
    le = n.n(se),
    de = n(211),
    ue = n.n(de),
    ce = n(212),
    me = n.n(ce),
    fe = n(213),
    pe = n.n(fe),
    _e = n(214),
    he = n.n(_e),
    ye = n(215),
    ge = n.n(ye),
    ve = n(8),
    Me = n.n(ve),
    Le = n(12),
    be = n.n(Le),
    we = n(13),
    ke = n.n(we),
    Ye = n(216),
    De = n.n(Ye),
    Se = n(217),
    Te = n.n(Se),
    Ee = n(218),
    xe = n.n(Ee),
    Ce = n(219),
    je = n.n(Ce),
    Pe = n(21),
    Ne = n.n(Pe),
    He = n(22),
    Oe = n.n(He),
    Ie = n(220),
    ze = n.n(Ie),
    Ae = n(221),
    Fe = n.n(Ae),
    Re = n(10),
    We = n.n(Re),
    Ve = n(222),
    Ke = n.n(Ve),
    Be = n(223),
    Ue = n.n(Be),
    qe = n(224),
    Je = n.n(qe),
    Ze = {
      titleIcon: r.a,
      paragraphIcon: o.a,
      imageIcon: l.a,
      contentIcon: u.a,
      homeIcon: D.a,
      dashboardIcon: T.a,
      settingsIcon: x.a,
      documentsIcon: j.a,
      usersIcon: N.a,
      publishIcon: O.a,
      videoIcon: m.a,
      mediaCarouselIcon: p.a,
      countDownIcon: h.a,
      galleryIcon: g.a,
      googleMapsIcon: M.a,
      dividerIcon: b.a,
      htmlIcon: k.a,
      loginIcon: z.a,
      menuIcon: F.a,
      menuCartIcon: W.a,
      portfolioIcon: K.a,
      shareIcon: U.a,
      slidesIcon: J.a,
      userIcon: G.a,
      workflowIcon: X.a,
      templatesIcon: ee.a,
      pagesIcon: ne.a,
      moreIcon: re.a,
      bannerIcon: oe.a,
      buildIcon: le.a,
      plusIcon: ue.a,
      tableIcon: me.a,
      mainMenuIcon: pe.a,
      footerMenuIcon: he.a,
      tabIcon: ge.a,
      peSectionEdit: Me.a,
      peSectionSettings: be.a,
      peSectionDelete: ke.a,
      cardListIcon: De.a,
      cardIcon: Te.a,
      listIcon: xe.a,
      buttonIcon: je.a,
      wordIcon: Ne.a,
      excelIcon: Oe.a,
      treeIcon: ze.a,
      accordionIcon: Fe.a,
      searchIcon: We.a,
      siteSearchIcon: Ke.a,
      formEditorIcon: Ue.a,
      formEditoriconActive: Je.a
    };
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "IconColumnsMap", function () {
    return S;
  });
  var a = n(225),
    r = n.n(a),
    i = n(226),
    o = n.n(i),
    s = n(227),
    l = n.n(s),
    d = n(228),
    u = n.n(d),
    c = n(229),
    m = n.n(c),
    f = n(23),
    p = n.n(f),
    _ = n(230),
    h = n.n(_),
    y = n(231),
    g = n.n(y),
    v = n(232),
    M = n.n(v),
    L = n(233),
    b = n.n(L),
    w = n(234),
    k = n.n(w),
    Y = n(235),
    D = n.n(Y),
    S = {
      colOne: r.a,
      colTwo: o.a,
      colThree: l.a,
      colFour: u.a,
      colFive: m.a,
      colSix: p.a,
      colFourEightLeft: h.a,
      colFourEightRight: g.a,
      colThreeThreeSixLeft: M.a,
      colThreeThreeSixRight: b.a,
      colThreeSixThree: k.a,
      colTwoEightTwo: D.a
    };
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "MenusConfigurations", function () {
    return a;
  });
  var a = {
    display_name: "Menus",
    name: "menu",
    headerMenuItems: [{
      name: "Dashboard",
      route: "/dashboard",
      icon: "dashboardIcon"
    }],
    middleMenuItems: [{
      name: "Menu",
      route: "/menu",
      icon: "menuIcon"
    }, {
      name: "Templates",
      route: "/templates",
      icon: "templatesIcon"
    }, {
      name: "Pages",
      route: "/pages",
      icon: "pagesIcon"
    }, {
      name: "Documents",
      route: "/documents",
      icon: "documentsIcon"
    }, {
      name: "Banners",
      route: "/banners",
      icon: "bannerIcon"
    }, {
      name: "Forms",
      route: "/forms",
      icon: "formEditorIcon"
    }, {
      name: "Users",
      route: "/users",
      icon: "usersIcon"
    }, {
      name: "Workflow",
      route: "/workflow",
      icon: "workflowIcon"
    }, {
      name: "Settings",
      route: "/settings",
      icon: "settingsIcon"
    }],
    footerMenuItems: [{
      name: "Publish",
      route: "/publish",
      icon: "buildIcon"
    }]
  };
}, function (e, t) {
  e.exports = require("react-lazy-load-image-component");
}, function (e, t) {
  e.exports = require("gatsby-plugin-google-gtag");
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.TableUiComponent = void 0;
  var a,
    r,
    i = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    o = (a = ["\n    background-color: ", ";\n"], r = ["\n    background-color: ", ";\n"], Object.freeze(Object.defineProperties(a, {
      raw: {
        value: Object.freeze(r)
      }
    }))),
    s = n(0),
    l = _(s),
    d = _(n(3)),
    u = _(n(2)),
    c = _(n(281)),
    m = _(n(282)),
    f = n(284),
    p = n(33);
  function _(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  var h = u.default.tr(o, function (e) {
      return e.index % 2 ? " #EAEAEB;" : "FAFAFA";
    }),
    y = {
      colIndex: -1,
      sortDir: p.SortingDirections.ascending,
      column: void 0
    };
  t.TableUiComponent = (0, s.memo)(function (e) {
    var t = (0, s.useState)([]),
      n = i(t, 2),
      a = n[0],
      r = n[1],
      o = (0, s.useState)(y),
      u = i(o, 2),
      _ = u[0],
      g = u[1],
      v = e.componentSettings,
      M = v.columns,
      L = v.httpRequest,
      b = v.showColumnTitle,
      w = v.languageKey,
      k = v.baseUrl,
      Y = v.dbName,
      D = v.collectionType;
    (0, s.useEffect)(function () {
      var e = !0;
      return null != L && d.default.get(L.dataSource, L.header).then(function (t) {
        e && (r(t.data), g(y));
      }), function () {
        e = !1;
      };
    }, [e.componentSettings]);
    var S = function (e, t, n, a, r, i, o) {
      return l.default.createElement(m.default, {
        key: e,
        type: t,
        fieldDataValue: n,
        formatting: a,
        baseUrl: r,
        dbName: i,
        collectionType: o
      });
    };
    return l.default.createElement("div", {
      className: "table-responsive"
    }, l.default.createElement("table", {
      className: "table"
    }, b ? l.default.createElement(c.default, {
      columns: M,
      languageKey: w,
      onHeadClicked: function (e, t) {
        var n = p.SortingDirections.ascending;
        _.colIndex === t && _.sortDir === p.SortingDirections.ascending && (n = p.SortingDirections.descending);
        var i = {
            colIndex: t,
            sortDir: n,
            column: e
          },
          o = void 0,
          s = void 0,
          l = void 0;
        if (w ? (o = e.dataType[w], (s = e.mappingField[w]) && "" !== s && (l = a.map(function (e, t) {
          return {
            index: t,
            value: e.fieldData[w][s]
          };
        }))) : (o = e.dataType, (s = e.mappingField) && "" !== s && (l = a.map(function (e, t) {
          return {
            index: t,
            value: e.fieldData[s]
          };
        }))), o && l && l.length > 0) {
          l.sort(function (e, t) {
            return (0, f.sortCompareValues)(e, t, o) * i.sortDir;
          });
          var d = l.map(function (e) {
            return a[e.index];
          });
          r(d), g(i);
        }
      },
      sortingTableColumn: _
    }) : l.default.createElement(l.default.Fragment, null), l.default.createElement("tbody", null, a && a.map(function (e, t) {
      return l.default.createElement(h, {
        key: t,
        index: t
      }, M && M.map(function (t, n) {
        var a = t.mappingField,
          r = t.dataType,
          o = t.formatting;
        return w ? a ? Object.entries(e.fieldData[w]).map(function (e) {
          var t = i(e, 2),
            s = t[0],
            l = t[1];
          return s === a[w] ? S(n, r && r[w], l, o && o[w], k, Y, D) : null;
        }) : void 0 === a ? S(n, r && r[w], "Custom Column", o && o[w], k, Y, D) : null : a ? Object.entries(e.fieldData).map(function (e) {
          var t = i(e, 2),
            s = t[0],
            l = t[1];
          return s === a ? S(n, r, l, o, k, Y, D) : null;
        }) : void 0 === a ? S(n, r, "Custom Column", o, k, Y, D) : null;
      }));
    }))));
  });
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a,
    r,
    i = (a = ["\n    background: #c6974b;\n    color: white;\n"], r = ["\n    background: #c6974b;\n    color: white;\n"], Object.freeze(Object.defineProperties(a, {
      raw: {
        value: Object.freeze(r)
      }
    }))),
    o = d(n(0)),
    s = d(n(2)),
    l = n(33);
  function d(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  var u = s.default.thead(i);
  t.default = function (e) {
    var t = e.columns,
      n = e.languageKey,
      a = e.onHeadClicked,
      r = e.sortingTableColumn;
    return o.default.createElement(u, {
      className: "thead-dark table-striped"
    }, o.default.createElement("tr", null, t && t.map(function (e, t) {
      var i = e.columnName,
        s = "sortable";
      return r && r.colIndex > -1 && t === r.colIndex && (r.sortDir === l.SortingDirections.ascending ? s = "sortable sortable-ase" : r.sortDir === l.SortingDirections.descending && (s = "sortable sortable-des")), i ? o.default.createElement(o.default.Fragment, {
        key: t
      }, n ? o.default.createElement("th", {
        className: s,
        onClick: function () {
          return a(e, t);
        }
      }, e.columnName[n]) : o.default.createElement("th", {
        className: s,
        onClick: function () {
          return a(e, t);
        }
      }, e.columnName)) : null;
    })));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a,
    r,
    i = (a = ["\n    padding: 0.2em 1em 0.2em 1em;\n    a {\n        color: black;\n        text-decoration: none;\n    }\n"], r = ["\n    padding: 0.2em 1em 0.2em 1em;\n    a {\n        color: black;\n        text-decoration: none;\n    }\n"], Object.freeze(Object.defineProperties(a, {
      raw: {
        value: Object.freeze(r)
      }
    }))),
    o = d(n(0)),
    s = d(n(2)),
    l = n(283);
  function d(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  var u = function (e, t, n, a, r, i) {
      switch (t) {
        case "price":
          return e.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        case "number":
          return "" + e;
        case "text":
          return e;
        case "ticker":
          return e.toUpperCase();
        case "date":
          return e;
        case "link":
          return o.default.createElement("a", {
            href: e.link
          }, e.text);
        case "icon":
          return function (e, t, n, a, r) {
            var i = n + (r ? r.toLowerCase() + "/" : "") + a + "/" + t,
              s = l.IconColumnsFormattingMap.pdfFileIconGold;
            return o.default.createElement("a", {
              href: i,
              target: "_blank"
            }, o.default.createElement(s, {
              width: "48",
              height: "48"
            }));
          }(0, e, a, r, i);
        case "stock":
          return o.default.createElement("a", {
            href: a + "stock/" + e
          }, e);
      }
    },
    c = s.default.td(i);
  t.default = function (e) {
    var t = e.fieldDataValue,
      n = e.type,
      a = (e.formatting, e.baseUrl),
      r = e.dbName,
      i = e.collectionType;
    return o.default.createElement(c, null, u(t, n, 0, a, r, i));
  };
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "IconColumnsFormattingMap", function () {
    return s;
  });
  var a = n(236),
    r = n.n(a),
    i = n(26),
    o = n.n(i),
    s = {
      pdfFileIcon: r.a,
      pdfFileIconGold: o.a
    };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.sortCompareValues = function (e, t, n) {
    switch (n) {
      case "number":
      case "price":
        if (e && t && e.value && t.value) {
          var i = e.value,
            o = t.value;
          try {
            i = Number(i), o = Number(o);
          } catch (e) {
            console.log("Sort error", e);
          }
          return i > o ? 1 : i < o ? -1 : 0;
        }
        return 0;
      case "date":
        if (e && t && e.value && t.value) {
          var s = e.value,
            l = t.value;
          try {
            var d = (0, r.default)(e.value, "DD/MM/YYYY"),
              u = (0, r.default)(t.value, "DD/MM/YYYY");
            return d.isValid() && u.isValid() ? (s = parseInt(d.format("x"), 10), l = parseInt(u.format("x"), 10), s > l ? 1 : s < l ? -1 : 0) : d.isValid() ? 1 : u.isValid() ? -1 : 0;
          } catch (e) {
            console.log("Sort error", e);
          }
          return 0;
        }
        return 0;
      case "link":
        if (e && t && e.value && t.value && e.value.text && t.value.text) {
          var c = e.value.text,
            m = t.value.text;
          try {
            return (0, a.default)(c, m);
          } catch (e) {
            console.log("Sort error", e);
          }
          return 0;
        }
        return 0;
      case "icon":
        return 0;
      case "text":
      case "ticker":
      case "stock":
      default:
        if (e && t && e.value && t.value) {
          try {
            return (0, a.default)(e.value, t.value);
          } catch (e) {
            console.log("Sort error", e);
          }
          return 0;
        }
        return 0;
    }
  };
  var a = i(n(285)),
    r = i(n(1));
  function i(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
}, function (e, t) {
  /*
   * @version    1.4.0
   * @date       2015-10-26
   * @stability  3 - Stable
   * @author     Lauri Rooden (https://github.com/litejs/natural-compare-lite)
   * @license    MIT License
   */
  var n = function (e, t) {
    var n,
      a,
      r = 1,
      i = 0,
      o = 0,
      s = String.alphabet;
    function l(e, t, a) {
      if (a) {
        for (n = t; (a = l(e, n)) < 76 && a > 65;) ++n;
        return +e.slice(t - 1, n);
      }
      return (a = s && s.indexOf(e.charAt(t))) > -1 ? a + 76 : (a = e.charCodeAt(t) || 0) < 45 || a > 127 ? a : a < 46 ? 65 : a < 48 ? a - 1 : a < 58 ? a + 18 : a < 65 ? a - 11 : a < 91 ? a + 11 : a < 97 ? a - 37 : a < 123 ? a + 5 : a - 63;
    }
    if ((e += "") != (t += "")) for (; r;) if (a = l(e, i++), r = l(t, o++), a < 76 && r < 76 && a > 66 && r > 66 && (a = l(e, i, i), r = l(t, o, i = n), o = n), a != r) return a < r ? -1 : 1;
    return 0;
  };
  try {
    e.exports = n;
  } catch (e) {
    String.naturalCompare = n;
  }
}, function (e, t) {
  e.exports = function (e) {
    return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
      enumerable: !0,
      get: function () {
        return e.l;
      }
    }), Object.defineProperty(e, "id", {
      enumerable: !0,
      get: function () {
        return e.i;
      }
    }), e.webpackPolyfill = 1), e;
  };
}, function (e, t, n) {
  var a = {
    "./af": 34,
    "./af.js": 34,
    "./ar": 35,
    "./ar-dz": 36,
    "./ar-dz.js": 36,
    "./ar-kw": 37,
    "./ar-kw.js": 37,
    "./ar-ly": 38,
    "./ar-ly.js": 38,
    "./ar-ma": 39,
    "./ar-ma.js": 39,
    "./ar-sa": 40,
    "./ar-sa.js": 40,
    "./ar-tn": 41,
    "./ar-tn.js": 41,
    "./ar.js": 35,
    "./az": 42,
    "./az.js": 42,
    "./be": 43,
    "./be.js": 43,
    "./bg": 44,
    "./bg.js": 44,
    "./bm": 45,
    "./bm.js": 45,
    "./bn": 46,
    "./bn-bd": 47,
    "./bn-bd.js": 47,
    "./bn.js": 46,
    "./bo": 48,
    "./bo.js": 48,
    "./br": 49,
    "./br.js": 49,
    "./bs": 50,
    "./bs.js": 50,
    "./ca": 51,
    "./ca.js": 51,
    "./cs": 52,
    "./cs.js": 52,
    "./cv": 53,
    "./cv.js": 53,
    "./cy": 54,
    "./cy.js": 54,
    "./da": 55,
    "./da.js": 55,
    "./de": 56,
    "./de-at": 57,
    "./de-at.js": 57,
    "./de-ch": 58,
    "./de-ch.js": 58,
    "./de.js": 56,
    "./dv": 59,
    "./dv.js": 59,
    "./el": 60,
    "./el.js": 60,
    "./en-au": 61,
    "./en-au.js": 61,
    "./en-ca": 62,
    "./en-ca.js": 62,
    "./en-gb": 63,
    "./en-gb.js": 63,
    "./en-ie": 64,
    "./en-ie.js": 64,
    "./en-il": 65,
    "./en-il.js": 65,
    "./en-in": 66,
    "./en-in.js": 66,
    "./en-nz": 67,
    "./en-nz.js": 67,
    "./en-sg": 68,
    "./en-sg.js": 68,
    "./eo": 69,
    "./eo.js": 69,
    "./es": 70,
    "./es-do": 71,
    "./es-do.js": 71,
    "./es-mx": 72,
    "./es-mx.js": 72,
    "./es-us": 73,
    "./es-us.js": 73,
    "./es.js": 70,
    "./et": 74,
    "./et.js": 74,
    "./eu": 75,
    "./eu.js": 75,
    "./fa": 76,
    "./fa.js": 76,
    "./fi": 77,
    "./fi.js": 77,
    "./fil": 78,
    "./fil.js": 78,
    "./fo": 79,
    "./fo.js": 79,
    "./fr": 80,
    "./fr-ca": 81,
    "./fr-ca.js": 81,
    "./fr-ch": 82,
    "./fr-ch.js": 82,
    "./fr.js": 80,
    "./fy": 83,
    "./fy.js": 83,
    "./ga": 84,
    "./ga.js": 84,
    "./gd": 85,
    "./gd.js": 85,
    "./gl": 86,
    "./gl.js": 86,
    "./gom-deva": 87,
    "./gom-deva.js": 87,
    "./gom-latn": 88,
    "./gom-latn.js": 88,
    "./gu": 89,
    "./gu.js": 89,
    "./he": 90,
    "./he.js": 90,
    "./hi": 91,
    "./hi.js": 91,
    "./hr": 92,
    "./hr.js": 92,
    "./hu": 93,
    "./hu.js": 93,
    "./hy-am": 94,
    "./hy-am.js": 94,
    "./id": 95,
    "./id.js": 95,
    "./is": 96,
    "./is.js": 96,
    "./it": 97,
    "./it-ch": 98,
    "./it-ch.js": 98,
    "./it.js": 97,
    "./ja": 99,
    "./ja.js": 99,
    "./jv": 100,
    "./jv.js": 100,
    "./ka": 101,
    "./ka.js": 101,
    "./kk": 102,
    "./kk.js": 102,
    "./km": 103,
    "./km.js": 103,
    "./kn": 104,
    "./kn.js": 104,
    "./ko": 105,
    "./ko.js": 105,
    "./ku": 106,
    "./ku.js": 106,
    "./ky": 107,
    "./ky.js": 107,
    "./lb": 108,
    "./lb.js": 108,
    "./lo": 109,
    "./lo.js": 109,
    "./lt": 110,
    "./lt.js": 110,
    "./lv": 111,
    "./lv.js": 111,
    "./me": 112,
    "./me.js": 112,
    "./mi": 113,
    "./mi.js": 113,
    "./mk": 114,
    "./mk.js": 114,
    "./ml": 115,
    "./ml.js": 115,
    "./mn": 116,
    "./mn.js": 116,
    "./mr": 117,
    "./mr.js": 117,
    "./ms": 118,
    "./ms-my": 119,
    "./ms-my.js": 119,
    "./ms.js": 118,
    "./mt": 120,
    "./mt.js": 120,
    "./my": 121,
    "./my.js": 121,
    "./nb": 122,
    "./nb.js": 122,
    "./ne": 123,
    "./ne.js": 123,
    "./nl": 124,
    "./nl-be": 125,
    "./nl-be.js": 125,
    "./nl.js": 124,
    "./nn": 126,
    "./nn.js": 126,
    "./oc-lnc": 127,
    "./oc-lnc.js": 127,
    "./pa-in": 128,
    "./pa-in.js": 128,
    "./pl": 129,
    "./pl.js": 129,
    "./pt": 130,
    "./pt-br": 131,
    "./pt-br.js": 131,
    "./pt.js": 130,
    "./ro": 132,
    "./ro.js": 132,
    "./ru": 133,
    "./ru.js": 133,
    "./sd": 134,
    "./sd.js": 134,
    "./se": 135,
    "./se.js": 135,
    "./si": 136,
    "./si.js": 136,
    "./sk": 137,
    "./sk.js": 137,
    "./sl": 138,
    "./sl.js": 138,
    "./sq": 139,
    "./sq.js": 139,
    "./sr": 140,
    "./sr-cyrl": 141,
    "./sr-cyrl.js": 141,
    "./sr.js": 140,
    "./ss": 142,
    "./ss.js": 142,
    "./sv": 143,
    "./sv.js": 143,
    "./sw": 144,
    "./sw.js": 144,
    "./ta": 145,
    "./ta.js": 145,
    "./te": 146,
    "./te.js": 146,
    "./tet": 147,
    "./tet.js": 147,
    "./tg": 148,
    "./tg.js": 148,
    "./th": 149,
    "./th.js": 149,
    "./tk": 150,
    "./tk.js": 150,
    "./tl-ph": 151,
    "./tl-ph.js": 151,
    "./tlh": 152,
    "./tlh.js": 152,
    "./tr": 153,
    "./tr.js": 153,
    "./tzl": 154,
    "./tzl.js": 154,
    "./tzm": 155,
    "./tzm-latn": 156,
    "./tzm-latn.js": 156,
    "./tzm.js": 155,
    "./ug-cn": 157,
    "./ug-cn.js": 157,
    "./uk": 158,
    "./uk.js": 158,
    "./ur": 159,
    "./ur.js": 159,
    "./uz": 160,
    "./uz-latn": 161,
    "./uz-latn.js": 161,
    "./uz.js": 160,
    "./vi": 162,
    "./vi.js": 162,
    "./x-pseudo": 163,
    "./x-pseudo.js": 163,
    "./yo": 164,
    "./yo.js": 164,
    "./zh-cn": 165,
    "./zh-cn.js": 165,
    "./zh-hk": 166,
    "./zh-hk.js": 166,
    "./zh-mo": 167,
    "./zh-mo.js": 167,
    "./zh-tw": 168,
    "./zh-tw.js": 168
  };
  function r(e) {
    var t = i(e);
    return n(t);
  }
  function i(e) {
    if (!n.o(a, e)) {
      var t = new Error("Cannot find module '" + e + "'");
      throw t.code = "MODULE_NOT_FOUND", t;
    }
    return a[e];
  }
  r.keys = function () {
    return Object.keys(a);
  }, r.resolve = i, e.exports = r, r.id = 287;
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "SpecificPreviewComponent", function () {
    return r;
  });
  var a = n(0),
    r = function (e) {
      var t = e.title;
      return a.createElement("div", {
        className: "container"
      }, a.createElement("div", {
        className: "row"
      }, a.createElement("div", {
        className: "col-sm-8 text-center"
      }, a.createElement("div", {
        className: "card card-block"
      }, t))));
    };
}, function (e, t) {
  e.exports = require("react-multi-select-component");
}, function (e, t) {
  var n;
  n = function () {
    return this;
  }();
  try {
    n = n || new Function("return this")();
  } catch (e) {
    "object" == typeof window && (n = window);
  }
  e.exports = n;
}, function (e, t) {
  e.exports = require("fastest-validator");
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.formComponentsDataTypeMappings = t.formComponentsMapping = void 0;
  var a = h(n(293)),
    r = h(n(295)),
    i = h(n(296)),
    o = h(n(297)),
    s = h(n(303)),
    l = h(n(304)),
    d = h(n(305)),
    u = h(n(306)),
    c = h(n(307)),
    m = h(n(308)),
    f = h(n(309)),
    p = h(n(310)),
    _ = h(n(311));
  function h(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  t.formComponentsMapping = {
    fieldShortText: c.default,
    fieldLongText: s.default,
    number: d.default,
    email: i.default,
    media: l.default,
    richTextEditor: s.default,
    submit: m.default,
    reset: u.default,
    date: a.default,
    recaptcha: o.default,
    dropDownList: r.default,
    checkbox: f.default,
    radioButton: p.default,
    textField: _.default,
    numbers: c.default
  }, t.formComponentsDataTypeMappings = {
    fieldShortText: "string",
    fieldLongText: "string",
    number: "number",
    email: "email",
    media: "string",
    richTextEditor: "string",
    date: "date",
    numbers: "string"
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = i(n(0)),
    r = i(n(294));
  function i(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  t.default = function (e) {
    var t,
      n,
      i,
      o,
      s,
      l = e.handleDatePickerValueChanges,
      d = (e.disableDatepicker, e.selected, e.onFocus),
      u = e.onBlur,
      c = (e.isClearable, e.placeholderText, e.minDate),
      m = e.maxDate,
      f = e.wrapperClassName,
      p = e.validationErrors;
    return a.default.createElement(a.default.Fragment, null, a.default.createElement("label", {
      htmlFor: e.id,
      className: e.uiProperties.label.classes || ""
    }, e.label), a.default.createElement("div", {
      className: "d-none d-md-block"
    }, a.default.createElement(r.default, {
      className: e.uiProperties.field.classes || "",
      wrapperClassName: f,
      selected: e.value ? new Date(e.value) : "",
      onChange: function (t) {
        l(t, e.id);
      },
      monthsShown: 1,
      isClearable: !0,
      showPreviousMonths: !0,
      showWeekNumbers: !0,
      showMonthDropdown: !0,
      disabled: !1,
      placeholderText: "",
      showYearDropdown: !0,
      onFocus: d || function () {},
      onBlur: u || function () {},
      minDate: c,
      maxDate: m
    }), p && a.default.createElement("div", {
      className: "invalid-feedback d-block"
    }, p.message || "Invalid field data")), a.default.createElement("div", {
      className: "d-md-none"
    }, a.default.createElement("input", {
      className: e.uiProperties.field.classes || "",
      type: "date",
      value: e.value ? (t = e.value, n = new Date(t), i = n.getFullYear(), o = n.getMonth() + 1, s = n.getDate(), s < 10 && (s = "0" + s), o < 10 && (o = "0" + o), i + "-" + o + "-" + s) : "",
      onChange: function (t) {
        l(t.target.value, e.id);
      }
    }), p && a.default.createElement("div", {
      className: "invalid-feedback d-block"
    }, p.message || "Invalid field data")));
  };
}, function (e, t) {
  e.exports = require("react-datepicker");
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    r = n(0),
    i = s(r),
    o = s(n(3));
  function s(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  t.default = function (e) {
    var t = e.id,
      n = e.label,
      s = e.value,
      l = e.dbName,
      d = e.selectedLanguage,
      u = e.settings,
      c = e.uiProperties,
      m = e.validationErrors,
      f = e.handleValueChanges,
      p = (0, r.useState)(void 0),
      _ = a(p, 2),
      h = _[0],
      y = _[1];
    return (0, r.useEffect)(function () {
      if (u) {
        var e = u.itemList,
          t = u.selectedCollection;
        e && e.length > 0 && y(e), t && l && (h || function (e) {
          var t = {
            headers: {},
            params: {
              collectionName: e,
              nameSpace: l
            }
          };
          o.default.get("/api/cms/getCollectionData", t).then(function (e) {
            var t = e.data;
            if (200 === e.status && t && Array.isArray(t) && t.length > 0 && d) {
              var n = t.map(function (e) {
                var t = e.active,
                  n = (e._id, e.fieldData);
                if (t && n[d.langKey] && n[d.langKey].entry_name) return n[d.langKey].entry_name;
              });
              y(n);
            }
          }).catch(function (e) {
            console.log(e);
          });
        }(t));
      }
      return function () {
        !1;
      };
    }, []), t && n ? i.default.createElement(i.default.Fragment, null, i.default.createElement("label", {
      htmlFor: t,
      className: c.label.classes || ""
    }, n), i.default.createElement("select", {
      className: c.field.classes || "",
      id: t,
      placeholder: n,
      value: s || "",
      name: t,
      required: u && u.required || !1,
      onChange: f
    }, i.default.createElement("option", {
      value: ""
    }, "-- select an option --"), h && 0 !== h.length && h.map(function (e, t) {
      return i.default.createElement("option", {
        key: "form-drop-down-component-" + t + "-" + e,
        value: e || ""
      }, e || "");
    })), m && i.default.createElement("div", {
      className: "invalid-feedback d-block"
    }, m.message || "Invalid field data")) : i.default.createElement(i.default.Fragment, null);
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a,
    r,
    i = (a = ["\n    ", "\n"], r = ["\n    ", "\n"], Object.freeze(Object.defineProperties(a, {
      raw: {
        value: Object.freeze(r)
      }
    }))),
    o = l(n(0)),
    s = l(n(2));
  function l(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  var d = s.default.label(i, function (e) {}),
    u = s.default.input(i, function (e) {});
  t.default = function (e) {
    var t = e.id,
      n = e.label,
      a = e.value,
      r = e.placeholder,
      i = e.settings,
      s = e.uiProperties,
      l = e.validationErrors,
      c = e.handleValueChanges;
    return t && n ? o.default.createElement(o.default.Fragment, null, o.default.createElement(d, {
      htmlFor: t,
      className: s.label.classes || ""
    }, n), o.default.createElement(u, {
      type: "email",
      className: s.field.classes || "",
      placeholder: r,
      id: t,
      name: t,
      value: a || "",
      pattern: "[A-Za-z0-9._%+-~]+@[a-z0-9.-]+\\.[a-z]{2,}$",
      required: i && i.required || !1,
      minLength: i && i.min || null,
      maxLength: i && i.max || null,
      onChange: c
    }), l && o.default.createElement("div", {
      className: "invalid-feedback d-block"
    }, l.message || "Invalid field data")) : o.default.createElement(o.default.Fragment, null);
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = o(n(0)),
    r = o(n(328)),
    i = o(n(302));
  function o(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  t.default = function (e) {
    var t = e.id,
      n = (e.label, e.value, e.settings, e.uiProperties, e.validationErrors, e.commonConfigs),
      o = e.recaptchaSiteKey,
      s = e.handleGoogleRecaptchaValueChanges,
      l = e.recaptchaRef;
    return n ? n.isPreview ? a.default.createElement(i.default, null) : o && "" != o ? a.default.createElement(a.default.Fragment, null, a.default.createElement(r.default, {
      ref: l,
      sitekey: o,
      onChange: function (e) {
        s(e, t);
      }
    })) : null : n ? null : a.default.createElement(i.default, null);
  };
}, function (e, t, n) {
  "use strict";

  var a = n(299);
  function r() {}
  function i() {}
  i.resetWarningCache = r, e.exports = function () {
    function e(e, t, n, r, i, o) {
      if (o !== a) {
        var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw s.name = "Invariant Violation", s;
      }
    }
    function t() {
      return e;
    }
    e.isRequired = e;
    var n = {
      array: e,
      bigint: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      elementType: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t,
      checkPropTypes: i,
      resetWarningCache: r
    };
    return n.PropTypes = n, n;
  };
}, function (e, t, n) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (e, t, n) {
  "use strict";

  e.exports = n(301);
}, function (e, t, n) {
  "use strict";

  /** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var a = "function" == typeof Symbol && Symbol.for,
    r = a ? Symbol.for("react.element") : 60103,
    i = a ? Symbol.for("react.portal") : 60106,
    o = a ? Symbol.for("react.fragment") : 60107,
    s = a ? Symbol.for("react.strict_mode") : 60108,
    l = a ? Symbol.for("react.profiler") : 60114,
    d = a ? Symbol.for("react.provider") : 60109,
    u = a ? Symbol.for("react.context") : 60110,
    c = a ? Symbol.for("react.async_mode") : 60111,
    m = a ? Symbol.for("react.concurrent_mode") : 60111,
    f = a ? Symbol.for("react.forward_ref") : 60112,
    p = a ? Symbol.for("react.suspense") : 60113,
    _ = a ? Symbol.for("react.suspense_list") : 60120,
    h = a ? Symbol.for("react.memo") : 60115,
    y = a ? Symbol.for("react.lazy") : 60116,
    g = a ? Symbol.for("react.block") : 60121,
    v = a ? Symbol.for("react.fundamental") : 60117,
    M = a ? Symbol.for("react.responder") : 60118,
    L = a ? Symbol.for("react.scope") : 60119;
  function b(e) {
    if ("object" == typeof e && null !== e) {
      var t = e.$$typeof;
      switch (t) {
        case r:
          switch (e = e.type) {
            case c:
            case m:
            case o:
            case l:
            case s:
            case p:
              return e;
            default:
              switch (e = e && e.$$typeof) {
                case u:
                case f:
                case y:
                case h:
                case d:
                  return e;
                default:
                  return t;
              }
          }
        case i:
          return t;
      }
    }
  }
  function w(e) {
    return b(e) === m;
  }
  t.AsyncMode = c, t.ConcurrentMode = m, t.ContextConsumer = u, t.ContextProvider = d, t.Element = r, t.ForwardRef = f, t.Fragment = o, t.Lazy = y, t.Memo = h, t.Portal = i, t.Profiler = l, t.StrictMode = s, t.Suspense = p, t.isAsyncMode = function (e) {
    return w(e) || b(e) === c;
  }, t.isConcurrentMode = w, t.isContextConsumer = function (e) {
    return b(e) === u;
  }, t.isContextProvider = function (e) {
    return b(e) === d;
  }, t.isElement = function (e) {
    return "object" == typeof e && null !== e && e.$$typeof === r;
  }, t.isForwardRef = function (e) {
    return b(e) === f;
  }, t.isFragment = function (e) {
    return b(e) === o;
  }, t.isLazy = function (e) {
    return b(e) === y;
  }, t.isMemo = function (e) {
    return b(e) === h;
  }, t.isPortal = function (e) {
    return b(e) === i;
  }, t.isProfiler = function (e) {
    return b(e) === l;
  }, t.isStrictMode = function (e) {
    return b(e) === s;
  }, t.isSuspense = function (e) {
    return b(e) === p;
  }, t.isValidElementType = function (e) {
    return "string" == typeof e || "function" == typeof e || e === o || e === m || e === l || e === s || e === p || e === _ || "object" == typeof e && null !== e && (e.$$typeof === y || e.$$typeof === h || e.$$typeof === d || e.$$typeof === u || e.$$typeof === f || e.$$typeof === v || e.$$typeof === M || e.$$typeof === L || e.$$typeof === g);
  }, t.typeOf = b;
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = M(["\n    border: 1px solid #d3d3d3;\n    background: #f9f9f9;\n    color: #000;\n    height: 85px;\n    width: 300px;\n    border-radius: 3px;\n    -webkit-box-shadow: 0 0 4px 1px rgb(0 0 0 / 8%);\n"], ["\n    border: 1px solid #d3d3d3;\n    background: #f9f9f9;\n    color: #000;\n    height: 85px;\n    width: 300px;\n    border-radius: 3px;\n    -webkit-box-shadow: 0 0 4px 1px rgb(0 0 0 / 8%);\n"]),
    r = M(["\n    height: 85px;\n    width: 206px;\n    display: inline-block;\n    position: relative;\n"], ["\n    height: 85px;\n    width: 206px;\n    display: inline-block;\n    position: relative;\n"]),
    i = M(["\n    display: inline-block;\n    height: 100%;\n"], ["\n    display: inline-block;\n    height: 100%;\n"]),
    o = M(["\n    display: table;\n    height: 100%;\n"], ["\n    display: table;\n    height: 100%;\n"]),
    s = M(["\n    display: table-cell;\n    vertical-align: middle;\n"], ["\n    display: table-cell;\n    vertical-align: middle;\n"]),
    l = M(["\n    margin: 0 12px 2px 12px;\n    border: none;\n    font-size: 1px;\n    height: 28px;\n    width: 28px;\n    overflow: visible;\n    outline: 0;\n    vertical-align: text-bottom;\n    position: relative;\n    display: -moz-inline-box;\n    display: inline-block;\n"], ["\n    margin: 0 12px 2px 12px;\n    border: none;\n    font-size: 1px;\n    height: 28px;\n    width: 28px;\n    overflow: visible;\n    outline: 0;\n    vertical-align: text-bottom;\n    position: relative;\n    display: -moz-inline-box;\n    display: inline-block;\n"]),
    d = M(["\n    -webkit-border-radius: 2px;\n    -moz-border-radius: 2px;\n    border-radius: 2px;\n    background-color: #fff;\n    border: 2px solid #c1c1c1;\n    font-size: 1px;\n    height: 24px;\n    position: absolute;\n    width: 24px;\n    z-index: 1;\n"], ["\n    -webkit-border-radius: 2px;\n    -moz-border-radius: 2px;\n    border-radius: 2px;\n    background-color: #fff;\n    border: 2px solid #c1c1c1;\n    font-size: 1px;\n    height: 24px;\n    position: absolute;\n    width: 24px;\n    z-index: 1;\n"]),
    u = M(["\n    width: 152px;\n    font-family: Roboto, helvetica, arial, sans-serif;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 17px;\n    display: table-cell;\n    vertical-align: middle;\n"], ["\n    width: 152px;\n    font-family: Roboto, helvetica, arial, sans-serif;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 17px;\n    display: table-cell;\n    vertical-align: middle;\n"]),
    c = M(["\n    display: inline-block;\n    height: 85px;\n    vertical-align: top;\n    width: 70px;\n"], ["\n    display: inline-block;\n    height: 85px;\n    vertical-align: top;\n    width: 70px;\n"]),
    m = M(["\n    margin: 10px 0 0 26px;\n    width: 58px;\n    -webkit-user-select: none;\n"], ["\n    margin: 10px 0 0 26px;\n    width: 58px;\n    -webkit-user-select: none;\n"]),
    f = M(["\n    background-size: 32px;\n    height: 48px;\n    margin: 0 13px 0 5px;\n    width: 48px;\n    background: url(/recaptcha-logo.png);\n    background-repeat: no-repeat;\n"], ["\n    background-size: 32px;\n    height: 48px;\n    margin: 0 13px 0 5px;\n    width: 48px;\n    background: url(/recaptcha-logo.png);\n    background-repeat: no-repeat;\n"]),
    p = M(["\n    color: #555;\n    cursor: default;\n    font-family: Roboto, helvetica, arial, sans-serif;\n    font-size: 10px;\n    font-weight: 400;\n    line-height: 10px;\n    margin-top: 5px;\n    text-align: center;\n"], ["\n    color: #555;\n    cursor: default;\n    font-family: Roboto, helvetica, arial, sans-serif;\n    font-size: 10px;\n    font-weight: 400;\n    line-height: 10px;\n    margin-top: 5px;\n    text-align: center;\n"]),
    _ = M(["\n    margin: 2px 11px 0 0;\n    padding-right: 2px;\n    position: absolute;\n    left: 20px;\n    text-align: right;\n    width: 276px;\n    font-family: Roboto, helvetica, arial, sans-serif;\n    font-size: 8px;\n    font-weight: 400;\n"], ["\n    margin: 2px 11px 0 0;\n    padding-right: 2px;\n    position: absolute;\n    left: 20px;\n    text-align: right;\n    width: 276px;\n    font-family: Roboto, helvetica, arial, sans-serif;\n    font-size: 8px;\n    font-weight: 400;\n"]),
    h = M(["\n    color: #555;\n    display: inline;\n    padding-left: 1px;\n    padding-right: 1px;\n    padding-top: 2px;\n    padding-bottom: 2px;\n    text-decoration: none;\n"], ["\n    color: #555;\n    display: inline;\n    padding-left: 1px;\n    padding-right: 1px;\n    padding-top: 2px;\n    padding-bottom: 2px;\n    text-decoration: none;\n"]),
    y = v(n(0)),
    g = v(n(2));
  function v(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  function M(e, t) {
    return Object.freeze(Object.defineProperties(e, {
      raw: {
        value: Object.freeze(t)
      }
    }));
  }
  t.default = function () {
    return y.default.createElement(L, {
      id: "rc-anchor-container"
    }, y.default.createElement(b, null, y.default.createElement(w, null, y.default.createElement(k, null, y.default.createElement(Y, null, y.default.createElement(D, {
      tabindex: "0",
      dir: "ltr"
    }, y.default.createElement(S, null))))), y.default.createElement(w, null, y.default.createElement(k, null, y.default.createElement(T, null, y.default.createElement("span", null), "I'm not a robot")))), y.default.createElement(E, null, y.default.createElement(x, null, y.default.createElement(C, null), y.default.createElement(j, null, "reCAPTCHA"))));
  };
  var L = g.default.div(a),
    b = g.default.div(r),
    w = g.default.div(i),
    k = g.default.div(o),
    Y = g.default.div(s),
    D = g.default.span(l),
    S = g.default.div(d),
    T = g.default.label(u),
    E = g.default.div(c),
    x = g.default.div(m),
    C = g.default.div(f),
    j = g.default.div(p);
  g.default.div(_), g.default.span(h);
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
  t.default = function (e) {
    var t = e.id,
      n = e.label,
      a = e.value,
      r = e.placeholder,
      o = e.settings,
      s = e.uiProperties,
      l = e.validationErrors,
      d = e.handleValueChanges;
    return t && n ? i.default.createElement(i.default.Fragment, null, i.default.createElement("label", {
      htmlFor: t,
      className: s.label.classes || ""
    }, n), i.default.createElement("textarea", {
      className: s.field.classes || "",
      placeholder: r,
      id: t,
      name: t,
      value: a || "",
      required: o && o.required || !1,
      minLength: o && o.min || null,
      maxLength: o && o.max || null,
      onChange: d
    }), l && i.default.createElement("div", {
      className: "invalid-feedback d-block"
    }, l.message || "Invalid field data")) : i.default.createElement(i.default.Fragment, null);
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    r = n(0),
    i = s(r),
    o = s(n(3));
  function s(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  t.default = function (e) {
    var t = e.id,
      n = e.label,
      s = e.dbName,
      l = e.value,
      d = e.placeholder,
      u = e.settings,
      c = e.uiProperties,
      m = e.commonConfigs,
      f = e.validationErrors,
      p = e.handleFileUpload,
      _ = (0, r.useState)(void 0),
      h = a(_, 2),
      y = h[0],
      g = h[1],
      v = (0, r.useState)(""),
      M = a(v, 2),
      L = M[0],
      b = M[1],
      w = (0, r.useState)(void 0),
      k = a(w, 2),
      Y = k[0],
      D = k[1];
    function S(e) {
      var n = 1024 * u.maxFileSize * 1024;
      e.target.files[0].size < n ? (b(e.target.files[0].name), function (e) {
        if (e && e.target.files[0]) {
          var n = new FormData(),
            a = {
              allowedExt: u.ext.split(","),
              maxSize: 1024 * u.maxFileSize * 1024
            };
          n.append("file", e.target.files[0]), n.append("fileSettings", JSON.stringify(a)), g(URL.createObjectURL(e.target.files[0])), m ? m.isPreview ? n.set("dbName", s) : n.set("nameSpace", s) : n.set("dbName", s);
          o.default.post("/api/custom-collections/documents/upload", n, {}).then(function (e) {
            var n = e.status,
              a = e.data;
            200 === n && a && p(a, t);
          }).catch(function (e) {
            console.log(e);
          }), D(void 0);
        }
      }(e)) : (D("Invalid File Size"), b("Invalid File"));
    }
    return t && n ? i.default.createElement(i.default.Fragment, null, i.default.createElement("label", null, n), i.default.createElement("div", {
      className: "custom-file " + (c.field.classes || "")
    }, i.default.createElement("input", {
      id: t,
      type: "file",
      className: "custom-file-input",
      name: t,
      onChange: function (e) {
        var t = u.ext.split(","),
          n = "." + e.target.files[0].name.split(".").pop();
        -1 != t.indexOf(n) ? S(e) : (D("Invalid File Type"), b("Invalid File"));
      },
      required: u && u.required || !1,
      accept: u.ext || "",
      onClick: function (e) {
        e.target.value = null;
      }
    }), i.default.createElement("label", {
      htmlFor: t,
      className: "custom-file-label " + (c.label.classes || "")
    }, L || d)), f && i.default.createElement("div", {
      className: "invalid-feedback d-block"
    }, f.message || "Invalid field data"), Y ? i.default.createElement("div", {
      className: "invalid-feedback d-block"
    }, Y) : null, l && y && i.default.createElement("div", null, i.default.createElement("img", {
      src: y,
      alt: "Image",
      className: "img-fluid"
    }))) : i.default.createElement(i.default.Fragment, null);
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
  t.default = function (e) {
    var t = e.id,
      n = e.label,
      a = e.value,
      r = e.placeholder,
      o = e.settings,
      s = e.uiProperties,
      l = e.validationErrors,
      d = e.handleNumberCmpValueChanges;
    return t && n ? i.default.createElement(i.default.Fragment, null, i.default.createElement("label", {
      htmlFor: t,
      className: s.label.classes || ""
    }, n), i.default.createElement("input", {
      type: "number",
      className: s.field.classes || "",
      placeholder: r,
      id: t,
      name: t,
      value: a || "",
      required: o && o.required || !1,
      minLength: o && o.min || null,
      maxLength: o && o.max || null,
      onChange: d
    }), l && i.default.createElement("div", {
      className: "invalid-feedback d-block"
    }, l.message || "Invalid field data")) : i.default.createElement(i.default.Fragment, null);
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
  t.default = function (e) {
    var t = e.id,
      n = e.label,
      a = e.resetForm,
      r = e.uiProperties;
    return t && n ? i.default.createElement(i.default.Fragment, null, i.default.createElement("button", {
      type: "reset",
      className: r.field.classes || "",
      id: t,
      onClick: a
    }, i.default.createElement("span", {
      className: r.label.classes || ""
    }, n))) : i.default.createElement(i.default.Fragment, null);
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
  t.default = function (e) {
    var t = e.id,
      n = e.label,
      a = e.value,
      r = e.placeholder,
      o = e.settings,
      s = e.uiProperties,
      l = e.validationErrors,
      d = e.handleValueChanges;
    return t && n ? i.default.createElement(i.default.Fragment, null, i.default.createElement("label", {
      htmlFor: t,
      className: s.label.classes || ""
    }, n), i.default.createElement("input", {
      type: "text",
      className: s.field.classes || "",
      placeholder: r,
      id: t,
      name: t,
      value: a || "",
      required: o && o.required || !1,
      minLength: o && o.min || null,
      maxLength: o && o.max || null,
      onChange: d
    }), l && i.default.createElement("div", {
      className: "invalid-feedback d-block"
    }, l.message || "Invalid field data")) : i.default.createElement(i.default.Fragment, null);
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
  t.default = function (e) {
    var t = e.id,
      n = e.label,
      a = e.uiProperties,
      r = e.disableSubmitButton;
    return t && n ? i.default.createElement(i.default.Fragment, null, i.default.createElement("button", {
      type: "submit",
      className: a.field.classes || "",
      id: t,
      disabled: r
    }, i.default.createElement("span", {
      className: a.label.classes || ""
    }, n))) : i.default.createElement(i.default.Fragment, null);
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    },
    o = n(6);
  t.default = function (e) {
    var t = e.id,
      n = e.label,
      a = e.value,
      r = e.placeholder,
      s = e.settings,
      l = e.uiProperties,
      d = e.validationErrors,
      u = e.handleCheckBoxCmpValueChanges,
      c = e.description;
    if (t && (n || c)) {
      var m = {
        styles: {},
        data: {
          paragraph: c || n
        }
      };
      return i.default.createElement(i.default.Fragment, null, i.default.createElement("div", {
        className: "d-flex"
      }, i.default.createElement("div", {
        className: "mx-2"
      }, i.default.createElement("input", {
        id: t,
        key: t,
        type: "checkbox",
        placeholder: r,
        value: a || "false",
        required: s && s.required || !1,
        onChange: function (e) {
          !function (e) {
            u(e.target.checked, t);
          }(e);
        }
      }), " "), i.default.createElement("div", {
        className: " " + (l.label.classes || "")
      }, i.default.createElement(o.ParagraphComponent, {
        data: m
      })), d && i.default.createElement("div", {
        className: "invalid-feedback d-block"
      }, d.message || "Invalid field data")));
    }
    return i.default.createElement(i.default.Fragment, null);
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    r = n(0),
    i = s(r),
    o = s(n(3));
  function s(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  t.default = function (e) {
    var t = e.id,
      n = e.label,
      s = (e.value, e.dbName),
      l = e.selectedLanguage,
      d = e.settings,
      u = e.uiProperties,
      c = e.validationErrors,
      m = e.handleRadioButtonValueChanges,
      f = (0, r.useState)(void 0),
      p = a(f, 2),
      _ = p[0],
      h = p[1];
    return (0, r.useEffect)(function () {
      if (d) {
        var e = d.itemList,
          t = d.selectedCollection;
        e && e.length > 0 && h(e), t && s && (_ || function (e) {
          var t = {
            headers: {},
            params: {
              collectionName: e,
              nameSpace: s
            }
          };
          o.default.get("/api/cms/getCollectionData", t).then(function (e) {
            var t = e.data;
            if (200 === e.status && t && Array.isArray(t) && t.length > 0 && l) {
              var n = t.map(function (e) {
                var t = e.active,
                  n = (e._id, e.fieldData);
                if (t && n[l.langKey] && n[l.langKey].entry_name) return n[l.langKey].entry_name;
              });
              h(n);
            }
          }).catch(function (e) {
            console.log(e);
          });
        }(t));
      }
      return function () {
        !1;
      };
    }, []), t && n ? i.default.createElement(i.default.Fragment, null, i.default.createElement("label", {
      htmlFor: t,
      className: u.label.classes || ""
    }, n), i.default.createElement("div", {
      style: {
        marginLeft: "30px"
      }
    }, _ && 0 !== _.length && _.map(function (e, n) {
      return i.default.createElement("div", null, i.default.createElement("input", {
        type: "radio",
        id: n,
        key: "form-drop-down-component-" + n + "-" + e,
        value: e || "",
        checked: e,
        name: "radio",
        required: d && d.required || !1,
        onChange: function (e) {
          !function (e) {
            m(e.target.value, t);
          }(e);
        }
      }), " ", e || "");
    })), c && i.default.createElement("div", {
      className: "invalid-feedback d-block"
    }, c.message || "Invalid field data")) : i.default.createElement(i.default.Fragment, null);
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = i(n(0)),
    r = (i(n(2)), n(6));
  function i(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  t.default = function (e) {
    var t = e.id,
      n = e.label,
      i = (e.value, e.placeholder, e.settings, e.uiProperties),
      o = e.validationErrors,
      s = (e.handleValueChanges, e.description);
    if (t && (n || s)) {
      var l = {
        styles: {},
        data: {
          paragraph: s || n
        }
      };
      return a.default.createElement(a.default.Fragment, null, a.default.createElement("div", {
        className: "row"
      }, a.default.createElement("div", {
        className: "col " + (i.label.classes || ""),
        style: {}
      }, a.default.createElement(r.ParagraphComponent, {
        data: l
      })), o && a.default.createElement("div", {
        className: "invalid-feedback d-block"
      }, o.message || "Invalid field data")));
    }
    return a.default.createElement(a.default.Fragment, null);
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a,
    r = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    i = n(0),
    o = (a = i) && a.__esModule ? a : {
      default: a
    };
  t.default = function (e) {
    var t = (0, i.useState)(e.news),
      n = r(t, 2),
      a = n[0],
      s = n[1];
    (0, i.useEffect)(function () {
      s(e.news);
    }, [e]);
    return o.default.createElement("div", {
      className: "modal news-modal fade bg-white",
      style: {
        padding: "0px !important",
        overflowY: "hidden"
      },
      id: "newsModal",
      tabIndex: "-1",
      role: "dialog",
      "aria-labelledby": "newsModalTitle",
      "aria-hidden": "true"
    }, o.default.createElement("div", {
      className: "modal-dialog modal-dialog-centered modal-xl",
      role: "document",
      style: {
        width: "100vw",
        height: "100vh",
        maxWidth: "none"
      }
    }, o.default.createElement("div", {
      className: "modal-content"
    }, o.default.createElement("div", {
      className: "modal-header"
    }, o.default.createElement("button", {
      type: "button",
      className: "close",
      "data-dismiss": "modal",
      "aria-label": "Close",
      onClick: function () {
        s(null);
      }
    }, o.default.createElement("span", {
      "aria-hidden": "true"
    }, "×"))), o.default.createElement("div", {
      className: "modal-body"
    }, console.log("props in modal", e), null != a && a.body ? o.default.createElement("div", null, o.default.createElement("div", {
      className: "news-detail-header mb-3"
    }, o.default.createElement("img", {
      className: "news-background w-100",
      src: a.image
    }), o.default.createElement("div", {
      className: "news-detail-content"
    }, o.default.createElement("div", {
      className: "news-detail-title"
    }, a.title || "title not available"), o.default.createElement("div", {
      className: "news-detail-date"
    }, o.default.createElement("span", {
      className: "news-detail-date-icon"
    }), " ", a.date || "N/A", " "))), o.default.createElement("div", {
      className: "news-detail-body"
    }, o.default.createElement("div", {
      className: "container"
    }, a.body.map(function (e) {
      return o.default.createElement("p", null, e);
    })))) : null))));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  var a = function (e) {
      if (e && e.__esModule) return e;
      if (null === e || "object" !== f(e) && "function" != typeof e) return {
        default: e
      };
      var t = m();
      if (t && t.has(e)) return t.get(e);
      var n = {},
        a = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var r in e) if (Object.prototype.hasOwnProperty.call(e, r)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, r) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, r, i) : n[r] = e[r];
      }
      n.default = e, t && t.set(e, n);
      return n;
    }(n(0)),
    r = c(n(174)),
    i = c(n(175)),
    o = c(n(176)),
    s = c(n(317)),
    l = c(n(177)),
    d = n(178),
    u = n(318);
  function c(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  function m() {
    if ("function" != typeof WeakMap) return null;
    var e = new WeakMap();
    return m = function () {
      return e;
    }, e;
  }
  function f(e) {
    return (f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }
  function p() {
    return (p = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      }
      return e;
    }).apply(this, arguments);
  }
  function _(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);
      t && (a = a.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, a);
    }
    return n;
  }
  function h(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? _(Object(n), !0).forEach(function (t) {
        w(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : _(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  function y(e, t) {
    for (var n = 0; n < t.length; n++) {
      var a = t[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  function g(e, t) {
    return (g = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }
  function v(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();
    return function () {
      var n,
        a = b(e);
      if (t) {
        var r = b(this).constructor;
        n = Reflect.construct(a, arguments, r);
      } else n = a.apply(this, arguments);
      return M(this, n);
    };
  }
  function M(e, t) {
    return !t || "object" !== f(t) && "function" != typeof t ? L(e) : t;
  }
  function L(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function b(e) {
    return (b = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }
  function w(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  var k = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && g(e, t);
    }(f, e);
    var t,
      n,
      c,
      m = v(f);
    function f(e) {
      var t;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, f), w(L(t = m.call(this, e)), "thumbsRef", void 0), w(L(t), "carouselWrapperRef", void 0), w(L(t), "listRef", void 0), w(L(t), "itemsRef", void 0), w(L(t), "timer", void 0), w(L(t), "animationHandler", void 0), w(L(t), "setThumbsRef", function (e) {
        t.thumbsRef = e;
      }), w(L(t), "setCarouselWrapperRef", function (e) {
        t.carouselWrapperRef = e;
      }), w(L(t), "setListRef", function (e) {
        t.listRef = e;
      }), w(L(t), "setItemsRef", function (e, n) {
        t.itemsRef || (t.itemsRef = []), t.itemsRef[n] = e;
      }), w(L(t), "autoPlay", function () {
        a.Children.count(t.props.children) <= 1 || (t.clearAutoPlay(), t.props.autoPlay && (t.timer = setTimeout(function () {
          t.increment();
        }, t.props.interval)));
      }), w(L(t), "clearAutoPlay", function () {
        t.timer && clearTimeout(t.timer);
      }), w(L(t), "resetAutoPlay", function () {
        t.clearAutoPlay(), t.autoPlay();
      }), w(L(t), "stopOnHover", function () {
        t.setState({
          isMouseEntered: !0
        }, t.clearAutoPlay);
      }), w(L(t), "startOnLeave", function () {
        t.setState({
          isMouseEntered: !1
        }, t.autoPlay);
      }), w(L(t), "isFocusWithinTheCarousel", function () {
        return !!t.carouselWrapperRef && !((0, s.default)().activeElement !== t.carouselWrapperRef && !t.carouselWrapperRef.contains((0, s.default)().activeElement));
      }), w(L(t), "navigateWithKeyboard", function (e) {
        if (t.isFocusWithinTheCarousel()) {
          var n = "horizontal" === t.props.axis,
            a = n ? 37 : 38;
          (n ? 39 : 40) === e.keyCode ? t.increment() : a === e.keyCode && t.decrement();
        }
      }), w(L(t), "updateSizes", function () {
        if (t.state.initialized && t.itemsRef && 0 !== t.itemsRef.length) {
          var e = "horizontal" === t.props.axis,
            n = t.itemsRef[0];
          if (n) {
            var a = e ? n.clientWidth : n.clientHeight;
            t.setState({
              itemSize: a
            }), t.thumbsRef && t.thumbsRef.updateSizes();
          }
        }
      }), w(L(t), "setMountState", function () {
        t.setState({
          hasMount: !0
        }), t.updateSizes();
      }), w(L(t), "handleClickItem", function (e, n) {
        0 !== a.Children.count(t.props.children) && (t.state.cancelClick ? t.setState({
          cancelClick: !1
        }) : (t.props.onClickItem(e, n), e !== t.state.selectedItem && t.setState({
          selectedItem: e
        })));
      }), w(L(t), "handleOnChange", function (e, n) {
        a.Children.count(t.props.children) <= 1 || t.props.onChange(e, n);
      }), w(L(t), "handleClickThumb", function (e, n) {
        t.props.onClickThumb(e, n), t.moveTo(e);
      }), w(L(t), "onSwipeStart", function (e) {
        t.setState({
          swiping: !0
        }), t.props.onSwipeStart(e);
      }), w(L(t), "onSwipeEnd", function (e) {
        t.setState({
          swiping: !1,
          cancelClick: !1,
          swipeMovementStarted: !1
        }), t.props.onSwipeEnd(e), t.clearAutoPlay(), t.state.autoPlay && t.autoPlay();
      }), w(L(t), "onSwipeMove", function (e, n) {
        t.props.onSwipeMove(n);
        var a = t.props.swipeAnimationHandler(e, t.props, t.state, t.setState.bind(L(t)));
        return t.setState(h({}, a)), !!Object.keys(a).length;
      }), w(L(t), "decrement", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
        t.moveTo(t.state.selectedItem - ("number" == typeof e ? e : 1));
      }), w(L(t), "increment", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
        t.moveTo(t.state.selectedItem + ("number" == typeof e ? e : 1));
      }), w(L(t), "moveTo", function (e) {
        if ("number" == typeof e) {
          var n = a.Children.count(t.props.children) - 1;
          e < 0 && (e = t.props.infiniteLoop ? n : 0), e > n && (e = t.props.infiniteLoop ? 0 : n), t.selectItem({
            selectedItem: e
          }), t.state.autoPlay && !1 === t.state.isMouseEntered && t.resetAutoPlay();
        }
      }), w(L(t), "onClickNext", function () {
        t.increment(1);
      }), w(L(t), "onClickPrev", function () {
        t.decrement(1);
      }), w(L(t), "onSwipeForward", function () {
        t.increment(1), t.props.emulateTouch && t.setState({
          cancelClick: !0
        });
      }), w(L(t), "onSwipeBackwards", function () {
        t.decrement(1), t.props.emulateTouch && t.setState({
          cancelClick: !0
        });
      }), w(L(t), "changeItem", function (e) {
        return function (n) {
          (0, d.isKeyboardEvent)(n) && "Enter" !== n.key || t.moveTo(e);
        };
      }), w(L(t), "selectItem", function (e) {
        t.setState(h({
          previousItem: t.state.selectedItem
        }, e), function () {
          t.setState(t.animationHandler(t.props, t.state));
        }), t.handleOnChange(e.selectedItem, a.Children.toArray(t.props.children)[e.selectedItem]);
      }), w(L(t), "getInitialImage", function () {
        var e = t.props.selectedItem,
          n = t.itemsRef && t.itemsRef[e];
        return (n && n.getElementsByTagName("img") || [])[0];
      }), w(L(t), "getVariableItemHeight", function (e) {
        var n = t.itemsRef && t.itemsRef[e];
        if (t.state.hasMount && n && n.children.length) {
          var a = n.children[0].getElementsByTagName("img") || [];
          if (a.length > 0) {
            var r = a[0];
            if (!r.complete) {
              r.addEventListener("load", function e() {
                t.forceUpdate(), r.removeEventListener("load", e);
              });
            }
          }
          var i = (a[0] || n.children[0]).clientHeight;
          return i > 0 ? i : null;
        }
        return null;
      });
      var n = {
        initialized: !1,
        previousItem: e.selectedItem,
        selectedItem: e.selectedItem,
        hasMount: !1,
        isMouseEntered: !1,
        autoPlay: e.autoPlay,
        swiping: !1,
        swipeMovementStarted: !1,
        cancelClick: !1,
        itemSize: 1,
        itemListStyle: {},
        slideStyle: {},
        selectedStyle: {},
        prevStyle: {}
      };
      return t.animationHandler = "function" == typeof e.animationHandler && e.animationHandler || "fade" === e.animationHandler && u.fadeAnimationHandler || u.slideAnimationHandler, t.state = h(h({}, n), t.animationHandler(e, n)), t;
    }
    return t = f, (n = [{
      key: "componentDidMount",
      value: function () {
        this.props.children && this.setupCarousel();
      }
    }, {
      key: "componentDidUpdate",
      value: function (e, t) {
        e.children || !this.props.children || this.state.initialized || this.setupCarousel(), !e.autoFocus && this.props.autoFocus && this.forceFocus(), t.swiping && !this.state.swiping && this.setState(h({}, this.props.stopSwipingHandler(this.props, this.state))), e.selectedItem === this.props.selectedItem && e.centerMode === this.props.centerMode || (this.updateSizes(), this.moveTo(this.props.selectedItem)), e.autoPlay !== this.props.autoPlay && (this.props.autoPlay ? this.setupAutoPlay() : this.destroyAutoPlay(), this.setState({
          autoPlay: this.props.autoPlay
        }));
      }
    }, {
      key: "componentWillUnmount",
      value: function () {
        this.destroyCarousel();
      }
    }, {
      key: "setupCarousel",
      value: function () {
        var e = this;
        this.bindEvents(), this.state.autoPlay && a.Children.count(this.props.children) > 1 && this.setupAutoPlay(), this.props.autoFocus && this.forceFocus(), this.setState({
          initialized: !0
        }, function () {
          var t = e.getInitialImage();
          t && !t.complete ? t.addEventListener("load", e.setMountState) : e.setMountState();
        });
      }
    }, {
      key: "destroyCarousel",
      value: function () {
        this.state.initialized && (this.unbindEvents(), this.destroyAutoPlay());
      }
    }, {
      key: "setupAutoPlay",
      value: function () {
        this.autoPlay();
        var e = this.carouselWrapperRef;
        this.props.stopOnHover && e && (e.addEventListener("mouseenter", this.stopOnHover), e.addEventListener("mouseleave", this.startOnLeave));
      }
    }, {
      key: "destroyAutoPlay",
      value: function () {
        this.clearAutoPlay();
        var e = this.carouselWrapperRef;
        this.props.stopOnHover && e && (e.removeEventListener("mouseenter", this.stopOnHover), e.removeEventListener("mouseleave", this.startOnLeave));
      }
    }, {
      key: "bindEvents",
      value: function () {
        (0, l.default)().addEventListener("resize", this.updateSizes), (0, l.default)().addEventListener("DOMContentLoaded", this.updateSizes), this.props.useKeyboardArrows && (0, s.default)().addEventListener("keydown", this.navigateWithKeyboard);
      }
    }, {
      key: "unbindEvents",
      value: function () {
        (0, l.default)().removeEventListener("resize", this.updateSizes), (0, l.default)().removeEventListener("DOMContentLoaded", this.updateSizes);
        var e = this.getInitialImage();
        e && e.removeEventListener("load", this.setMountState), this.props.useKeyboardArrows && (0, s.default)().removeEventListener("keydown", this.navigateWithKeyboard);
      }
    }, {
      key: "forceFocus",
      value: function () {
        var e;
        null === (e = this.carouselWrapperRef) || void 0 === e || e.focus();
      }
    }, {
      key: "renderItems",
      value: function (e) {
        var t = this;
        return this.props.children ? a.Children.map(this.props.children, function (n, r) {
          var o = r === t.state.selectedItem,
            s = r === t.state.previousItem,
            l = o && t.state.selectedStyle || s && t.state.prevStyle || t.state.slideStyle || {};
          t.props.centerMode && "horizontal" === t.props.axis && (l = h(h({}, l), {}, {
            minWidth: t.props.centerSlidePercentage + "%"
          })), t.state.swiping && t.state.swipeMovementStarted && (l = h(h({}, l), {}, {
            pointerEvents: "none"
          }));
          var d = {
            ref: function (e) {
              return t.setItemsRef(e, r);
            },
            key: "itemKey" + r + (e ? "clone" : ""),
            className: i.default.ITEM(!0, r === t.state.selectedItem, r === t.state.previousItem),
            onClick: t.handleClickItem.bind(t, r, n),
            style: l
          };
          return a.default.createElement("li", d, t.props.renderItem(n, {
            isSelected: r === t.state.selectedItem,
            isPrevious: r === t.state.previousItem
          }));
        }) : [];
      }
    }, {
      key: "renderControls",
      value: function () {
        var e = this,
          t = this.props,
          n = t.showIndicators,
          r = t.labels,
          i = t.renderIndicator,
          o = t.children;
        return n ? a.default.createElement("ul", {
          className: "control-dots"
        }, a.Children.map(o, function (t, n) {
          return i && i(e.changeItem(n), n === e.state.selectedItem, n, r.item);
        })) : null;
      }
    }, {
      key: "renderStatus",
      value: function () {
        return this.props.showStatus ? a.default.createElement("p", {
          className: "carousel-status"
        }, this.props.statusFormatter(this.state.selectedItem + 1, a.Children.count(this.props.children))) : null;
      }
    }, {
      key: "renderThumbs",
      value: function () {
        return this.props.showThumbs && this.props.children && 0 !== a.Children.count(this.props.children) ? a.default.createElement(o.default, {
          ref: this.setThumbsRef,
          onSelectItem: this.handleClickThumb,
          selectedItem: this.state.selectedItem,
          transitionTime: this.props.transitionTime,
          thumbWidth: this.props.thumbWidth,
          labels: this.props.labels,
          emulateTouch: this.props.emulateTouch
        }, this.props.renderThumbs(this.props.children)) : null;
      }
    }, {
      key: "render",
      value: function () {
        var e = this;
        if (!this.props.children || 0 === a.Children.count(this.props.children)) return null;
        var t = this.props.swipeable && a.Children.count(this.props.children) > 1,
          n = "horizontal" === this.props.axis,
          o = this.props.showArrows && a.Children.count(this.props.children) > 1,
          s = o && (this.state.selectedItem > 0 || this.props.infiniteLoop) || !1,
          l = o && (this.state.selectedItem < a.Children.count(this.props.children) - 1 || this.props.infiniteLoop) || !1,
          d = this.renderItems(!0),
          u = d.shift(),
          c = d.pop(),
          m = {
            className: i.default.SLIDER(!0, this.state.swiping),
            onSwipeMove: this.onSwipeMove,
            onSwipeStart: this.onSwipeStart,
            onSwipeEnd: this.onSwipeEnd,
            style: this.state.itemListStyle,
            tolerance: this.props.swipeScrollTolerance
          },
          f = {};
        if (n) {
          if (m.onSwipeLeft = this.onSwipeForward, m.onSwipeRight = this.onSwipeBackwards, this.props.dynamicHeight) {
            var _ = this.getVariableItemHeight(this.state.selectedItem);
            f.height = _ || "auto";
          }
        } else m.onSwipeUp = "natural" === this.props.verticalSwipe ? this.onSwipeBackwards : this.onSwipeForward, m.onSwipeDown = "natural" === this.props.verticalSwipe ? this.onSwipeForward : this.onSwipeBackwards, m.style = h(h({}, m.style), {}, {
          height: this.state.itemSize
        }), f.height = this.state.itemSize;
        return a.default.createElement("div", {
          "aria-label": this.props.ariaLabel,
          className: i.default.ROOT(this.props.className),
          ref: this.setCarouselWrapperRef,
          tabIndex: this.props.useKeyboardArrows ? 0 : void 0
        }, a.default.createElement("div", {
          className: i.default.CAROUSEL(!0),
          style: {
            width: this.props.width
          }
        }, this.renderControls(), this.props.renderArrowPrev(this.onClickPrev, s, this.props.labels.leftArrow), a.default.createElement("div", {
          className: i.default.WRAPPER(!0, this.props.axis),
          style: f
        }, t ? a.default.createElement(r.default, p({
          tagName: "ul",
          innerRef: this.setListRef
        }, m, {
          allowMouseEvents: this.props.emulateTouch
        }), this.props.infiniteLoop && c, this.renderItems(), this.props.infiniteLoop && u) : a.default.createElement("ul", {
          className: i.default.SLIDER(!0, this.state.swiping),
          ref: function (t) {
            return e.setListRef(t);
          },
          style: this.state.itemListStyle || {}
        }, this.props.infiniteLoop && c, this.renderItems(), this.props.infiniteLoop && u)), this.props.renderArrowNext(this.onClickNext, l, this.props.labels.rightArrow), this.renderStatus()), this.renderThumbs());
      }
    }]) && y(t.prototype, n), c && y(t, c), f;
  }(a.default.Component);
  t.default = k, w(k, "displayName", "Carousel"), w(k, "defaultProps", {
    ariaLabel: void 0,
    axis: "horizontal",
    centerSlidePercentage: 80,
    interval: 3e3,
    labels: {
      leftArrow: "previous slide / item",
      rightArrow: "next slide / item",
      item: "slide item"
    },
    onClickItem: d.noop,
    onClickThumb: d.noop,
    onChange: d.noop,
    onSwipeStart: function () {},
    onSwipeEnd: function () {},
    onSwipeMove: function () {
      return !1;
    },
    preventMovementUntilSwipeScrollTolerance: !1,
    renderArrowPrev: function (e, t, n) {
      return a.default.createElement("button", {
        type: "button",
        "aria-label": n,
        className: i.default.ARROW_PREV(!t),
        onClick: e
      });
    },
    renderArrowNext: function (e, t, n) {
      return a.default.createElement("button", {
        type: "button",
        "aria-label": n,
        className: i.default.ARROW_NEXT(!t),
        onClick: e
      });
    },
    renderIndicator: function (e, t, n, r) {
      return a.default.createElement("li", {
        className: i.default.DOT(t),
        onClick: e,
        onKeyDown: e,
        value: n,
        key: n,
        role: "button",
        tabIndex: 0,
        "aria-label": "".concat(r, " ").concat(n + 1)
      });
    },
    renderItem: function (e) {
      return e;
    },
    renderThumbs: function (e) {
      var t = a.Children.map(e, function (e) {
        var t = e;
        if ("img" !== e.type && (t = a.Children.toArray(e.props.children).find(function (e) {
          return "img" === e.type;
        })), t) return t;
      });
      return 0 === t.filter(function (e) {
        return e;
      }).length ? (console.warn("No images found! Can't build the thumb list without images. If you don't need thumbs, set showThumbs={false} in the Carousel. Note that it's not possible to get images rendered inside custom components. More info at https://github.com/leandrowd/react-responsive-carousel/blob/master/TROUBLESHOOTING.md"), []) : t;
    },
    statusFormatter: d.defaultStatusFormatter,
    selectedItem: 0,
    showArrows: !0,
    showIndicators: !0,
    showStatus: !0,
    showThumbs: !0,
    stopOnHover: !0,
    swipeScrollTolerance: 5,
    swipeable: !0,
    transitionTime: 350,
    verticalSwipe: "standard",
    width: "100%",
    animationHandler: "slide",
    swipeAnimationHandler: u.slideSwipeAnimationHandler,
    stopSwipingHandler: u.slideStopSwipingHandler
  });
}, function (e, t, n) {
  var a, r, i;
  r = [t, n(0), n(4)], void 0 === (i = "function" == typeof (a = function (e, t, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.setHasSupportToCaptureOption = c;
    var a = i(t),
      r = i(n);
    function i(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    var o = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      }
      return e;
    };
    function s(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    var l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var a = t[n];
          a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
        }
      }
      return function (t, n, a) {
        return n && e(t.prototype, n), a && e(t, a), t;
      };
    }();
    function d(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }
    var u = !1;
    function c(e) {
      u = e;
    }
    try {
      addEventListener("test", null, Object.defineProperty({}, "capture", {
        get: function () {
          c(!0);
        }
      }));
    } catch (e) {}
    function m() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
        capture: !0
      };
      return u ? e : e.capture;
    }
    function f(e) {
      if ("touches" in e) {
        var t = e.touches[0];
        return {
          x: t.pageX,
          y: t.pageY
        };
      }
      return {
        x: e.screenX,
        y: e.screenY
      };
    }
    var p = function (e) {
      function t() {
        var e;
        s(this, t);
        for (var n = arguments.length, a = Array(n), r = 0; r < n; r++) a[r] = arguments[r];
        var i = d(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(a)));
        return i._handleSwipeStart = i._handleSwipeStart.bind(i), i._handleSwipeMove = i._handleSwipeMove.bind(i), i._handleSwipeEnd = i._handleSwipeEnd.bind(i), i._onMouseDown = i._onMouseDown.bind(i), i._onMouseMove = i._onMouseMove.bind(i), i._onMouseUp = i._onMouseUp.bind(i), i._setSwiperRef = i._setSwiperRef.bind(i), i;
      }
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, e), l(t, [{
        key: "componentDidMount",
        value: function () {
          this.swiper && this.swiper.addEventListener("touchmove", this._handleSwipeMove, m({
            capture: !0,
            passive: !1
          }));
        }
      }, {
        key: "componentWillUnmount",
        value: function () {
          this.swiper && this.swiper.removeEventListener("touchmove", this._handleSwipeMove, m({
            capture: !0,
            passive: !1
          }));
        }
      }, {
        key: "_onMouseDown",
        value: function (e) {
          this.props.allowMouseEvents && (this.mouseDown = !0, document.addEventListener("mouseup", this._onMouseUp), document.addEventListener("mousemove", this._onMouseMove), this._handleSwipeStart(e));
        }
      }, {
        key: "_onMouseMove",
        value: function (e) {
          this.mouseDown && this._handleSwipeMove(e);
        }
      }, {
        key: "_onMouseUp",
        value: function (e) {
          this.mouseDown = !1, document.removeEventListener("mouseup", this._onMouseUp), document.removeEventListener("mousemove", this._onMouseMove), this._handleSwipeEnd(e);
        }
      }, {
        key: "_handleSwipeStart",
        value: function (e) {
          var t = f(e),
            n = t.x,
            a = t.y;
          this.moveStart = {
            x: n,
            y: a
          }, this.props.onSwipeStart(e);
        }
      }, {
        key: "_handleSwipeMove",
        value: function (e) {
          if (this.moveStart) {
            var t = f(e),
              n = t.x,
              a = t.y,
              r = n - this.moveStart.x,
              i = a - this.moveStart.y;
            this.moving = !0, this.props.onSwipeMove({
              x: r,
              y: i
            }, e) && e.cancelable && e.preventDefault(), this.movePosition = {
              deltaX: r,
              deltaY: i
            };
          }
        }
      }, {
        key: "_handleSwipeEnd",
        value: function (e) {
          this.props.onSwipeEnd(e);
          var t = this.props.tolerance;
          this.moving && this.movePosition && (this.movePosition.deltaX < -t ? this.props.onSwipeLeft(1, e) : this.movePosition.deltaX > t && this.props.onSwipeRight(1, e), this.movePosition.deltaY < -t ? this.props.onSwipeUp(1, e) : this.movePosition.deltaY > t && this.props.onSwipeDown(1, e)), this.moveStart = null, this.moving = !1, this.movePosition = null;
        }
      }, {
        key: "_setSwiperRef",
        value: function (e) {
          this.swiper = e, this.props.innerRef(e);
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props,
            t = (e.tagName, e.className),
            n = e.style,
            r = e.children,
            i = (e.allowMouseEvents, e.onSwipeUp, e.onSwipeDown, e.onSwipeLeft, e.onSwipeRight, e.onSwipeStart, e.onSwipeMove, e.onSwipeEnd, e.innerRef, e.tolerance, function (e, t) {
              var n = {};
              for (var a in e) t.indexOf(a) >= 0 || Object.prototype.hasOwnProperty.call(e, a) && (n[a] = e[a]);
              return n;
            }(e, ["tagName", "className", "style", "children", "allowMouseEvents", "onSwipeUp", "onSwipeDown", "onSwipeLeft", "onSwipeRight", "onSwipeStart", "onSwipeMove", "onSwipeEnd", "innerRef", "tolerance"]));
          return a.default.createElement(this.props.tagName, o({
            ref: this._setSwiperRef,
            onMouseDown: this._onMouseDown,
            onTouchStart: this._handleSwipeStart,
            onTouchEnd: this._handleSwipeEnd,
            className: t,
            style: n
          }, i), r);
        }
      }]), t;
    }(t.Component);
    p.displayName = "ReactSwipe", p.propTypes = {
      tagName: r.default.string,
      className: r.default.string,
      style: r.default.object,
      children: r.default.node,
      allowMouseEvents: r.default.bool,
      onSwipeUp: r.default.func,
      onSwipeDown: r.default.func,
      onSwipeLeft: r.default.func,
      onSwipeRight: r.default.func,
      onSwipeStart: r.default.func,
      onSwipeMove: r.default.func,
      onSwipeEnd: r.default.func,
      innerRef: r.default.func,
      tolerance: r.default.number.isRequired
    }, p.defaultProps = {
      tagName: "div",
      allowMouseEvents: !1,
      onSwipeUp: function () {},
      onSwipeDown: function () {},
      onSwipeLeft: function () {},
      onSwipeRight: function () {},
      onSwipeStart: function () {},
      onSwipeMove: function () {},
      onSwipeEnd: function () {},
      innerRef: function () {},
      tolerance: 0
    }, e.default = p;
  }) ? a.apply(t, r) : a) || (e.exports = i);
}, function (e, t, n) {
  var a;
  /*!
  	Copyright (c) 2018 Jed Watson.
  	Licensed under the MIT License (MIT), see
  	http://jedwatson.github.io/classnames
  */
  !function () {
    "use strict";

    var n = {}.hasOwnProperty;
    function r() {
      for (var e = "", t = 0; t < arguments.length; t++) {
        var n = arguments[t];
        n && (e = o(e, i(n)));
      }
      return e;
    }
    function i(e) {
      if ("string" == typeof e || "number" == typeof e) return e;
      if ("object" != typeof e) return "";
      if (Array.isArray(e)) return r.apply(null, e);
      if (e.toString !== Object.prototype.toString && !e.toString.toString().includes("[native code]")) return e.toString();
      var t = "";
      for (var a in e) n.call(e, a) && e[a] && (t = o(t, a));
      return t;
    }
    function o(e, t) {
      return t ? e ? e + " " + t : e + t : e;
    }
    e.exports ? (r.default = r, e.exports = r) : void 0 === (a = function () {
      return r;
    }.apply(t, [])) || (e.exports = a);
  }();
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.outerWidth = void 0;
  t.outerWidth = function (e) {
    var t = e.offsetWidth,
      n = getComputedStyle(e);
    return t += parseInt(n.marginLeft) + parseInt(n.marginRight);
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = void 0;
  t.default = function () {
    return document;
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.fadeAnimationHandler = t.slideStopSwipingHandler = t.slideSwipeAnimationHandler = t.slideAnimationHandler = void 0;
  var a,
    r = n(0),
    i = (a = n(15)) && a.__esModule ? a : {
      default: a
    },
    o = n(178);
  function s(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);
      t && (a = a.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, a);
    }
    return n;
  }
  function l(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? s(Object(n), !0).forEach(function (t) {
        d(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }
    return e;
  }
  function d(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }
  t.slideAnimationHandler = function (e, t) {
    var n = {},
      a = t.selectedItem,
      s = a,
      d = r.Children.count(e.children) - 1;
    if (e.infiniteLoop && (a < 0 || a > d)) return s < 0 ? e.centerMode && e.centerSlidePercentage && "horizontal" === e.axis ? n.itemListStyle = (0, o.setPosition)(-(d + 2) * e.centerSlidePercentage - (100 - e.centerSlidePercentage) / 2, e.axis) : n.itemListStyle = (0, o.setPosition)(100 * -(d + 2), e.axis) : s > d && (n.itemListStyle = (0, o.setPosition)(0, e.axis)), n;
    var u = (0, o.getPosition)(a, e),
      c = (0, i.default)(u, "%", e.axis),
      m = e.transitionTime + "ms";
    return n.itemListStyle = {
      WebkitTransform: c,
      msTransform: c,
      OTransform: c,
      transform: c
    }, t.swiping || (n.itemListStyle = l(l({}, n.itemListStyle), {}, {
      WebkitTransitionDuration: m,
      MozTransitionDuration: m,
      OTransitionDuration: m,
      transitionDuration: m,
      msTransitionDuration: m
    })), n;
  };
  t.slideSwipeAnimationHandler = function (e, t, n, a) {
    var i = {},
      s = "horizontal" === t.axis,
      l = r.Children.count(t.children),
      d = (0, o.getPosition)(n.selectedItem, t),
      u = t.infiniteLoop ? (0, o.getPosition)(l - 1, t) - 100 : (0, o.getPosition)(l - 1, t),
      c = s ? e.x : e.y,
      m = c;
    0 === d && c > 0 && (m = 0), d === u && c < 0 && (m = 0);
    var f = d + 100 / (n.itemSize / m),
      p = Math.abs(c) > t.swipeScrollTolerance;
    return t.infiniteLoop && p && (0 === n.selectedItem && f > -100 ? f -= 100 * l : n.selectedItem === l - 1 && f < 100 * -l && (f += 100 * l)), (!t.preventMovementUntilSwipeScrollTolerance || p || n.swipeMovementStarted) && (n.swipeMovementStarted || a({
      swipeMovementStarted: !0
    }), i.itemListStyle = (0, o.setPosition)(f, t.axis)), p && !n.cancelClick && a({
      cancelClick: !0
    }), i;
  };
  t.slideStopSwipingHandler = function (e, t) {
    var n = (0, o.getPosition)(t.selectedItem, e);
    return {
      itemListStyle: (0, o.setPosition)(n, e.axis)
    };
  };
  t.fadeAnimationHandler = function (e, t) {
    var n = e.transitionTime + "ms",
      a = {
        position: "absolute",
        display: "block",
        zIndex: -2,
        minHeight: "100%",
        opacity: 0,
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
        transitionTimingFunction: "ease-in-out",
        msTransitionTimingFunction: "ease-in-out",
        MozTransitionTimingFunction: "ease-in-out",
        WebkitTransitionTimingFunction: "ease-in-out",
        OTransitionTimingFunction: "ease-in-out"
      };
    return t.swiping || (a = l(l({}, a), {}, {
      WebkitTransitionDuration: n,
      MozTransitionDuration: n,
      OTransitionDuration: n,
      transitionDuration: n,
      msTransitionDuration: n
    })), {
      slideStyle: a,
      selectedStyle: l(l({}, a), {}, {
        opacity: 1,
        position: "relative"
      }),
      prevStyle: l({}, a)
    };
  };
}, function (e, t, n) {}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.PaginatedNews = void 0;
  var a = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    r = n(0),
    i = l(r),
    o = l(n(171)),
    s = n(179);
  function l(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  t.PaginatedNews = function (e) {
    var t = e.itemsPerPage,
      n = e.items,
      l = (0, r.useState)(n.slice(0, e.itemsPerPage)),
      d = a(l, 2),
      u = d[0],
      c = d[1],
      m = Math.ceil(n.length / t);
    (0, r.useEffect)(function () {
      f(0);
    }, []);
    var f = function (e) {
      var a = e + t,
        r = n.slice(e, a);
      c(r);
    };
    return i.default.createElement("div", null, i.default.createElement("div", {
      className: "newsAndEvents"
    }, i.default.createElement("div", {
      className: "row"
    }, u.length > 0 ? u.map(function (e) {
      return i.default.createElement("div", {
        className: "col-12 col-md-6 col-xl-4"
      }, i.default.createElement(s.NewsItemComponent, {
        img: e.image,
        title: e.title,
        description: e.description,
        news: e
      }));
    }) : n.slice(0, e.itemsPerPage).map(function (e) {
      return i.default.createElement("div", {
        className: "col-12 col-md-6 col-xl-4"
      }, i.default.createElement(s.NewsItemComponent, {
        img: e.image,
        title: e.title,
        description: e.description,
        news: e
      }));
    }))), i.default.createElement("div", {
      className: "pagination"
    }, i.default.createElement(o.default, {
      breakLabel: "...",
      nextLabel: "next >",
      onPageChange: function (e) {
        var a = e.selected * t % n.length;
        f(a);
      },
      pageRangeDisplayed: 5,
      pageCount: m,
      previousLabel: "< previous",
      renderOnZeroPageCount: null
    })));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  t.appServerURL = function (e) {
    return "api/getSampleResponse?key=" + e;
  }, t.websitesDataService = function () {
    return "/api/websites";
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.SelectLanguage = void 0;
  var a = function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
          a = !0,
          r = !1,
          i = void 0;
        try {
          for (var o, s = e[Symbol.iterator](); !(a = (o = s.next()).done) && (n.push(o.value), !t || n.length !== t); a = !0);
        } catch (e) {
          r = !0, i = e;
        } finally {
          try {
            !a && s.return && s.return();
          } finally {
            if (r) throw i;
          }
        }
        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    },
    r = n(0),
    i = d(r),
    o = d(n(3)),
    s = n(323),
    l = n(324);
  function d(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
  t.SelectLanguage = function (e) {
    var t = e.currentLang,
      n = e.fetchURL,
      d = (0, r.useState)([]),
      u = a(d, 2),
      c = u[0],
      m = u[1],
      f = (0, r.useState)(t),
      p = a(f, 2),
      _ = p[0],
      h = p[1];
    (0, r.useEffect)(function () {
      o.default.get(n).then(function (e) {
        var t = a(e.data, 1)[0].languages;
        m((void 0 === t ? [] : t).map(l.genarateLangArray));
      });
    }, []);
    var y = function (e) {
      var t;
      t = e, window.location = (0, l.swapLangofURL)(t), h(e);
    };
    return i.default.createElement(s.Select, {
      options: c,
      value: _,
      currentLang: _,
      onChange: function (e, t) {
        e.preventDefault(), y(t);
      },
      customClassName: "lang-select",
      styles: {
        fontWeight: "700"
      }
    });
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.Select = void 0;
  var a,
    r = n(0),
    i = (a = r) && a.__esModule ? a : {
      default: a
    };
  t.Select = function (e) {
    var t = e.onChange,
      n = e.currentLang,
      a = (e.value, e.styles, e.options),
      o = void 0 === a ? [] : a;
    e.customClassName;
    return i.default.createElement(r.Fragment, null, i.default.createElement("div", {
      className: "dropdown show"
    }, i.default.createElement("a", {
      className: "btn btn-secondary dropdown-toggle text-uppercase",
      href: "#",
      role: "button",
      id: "dropdownMenuLink",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false",
      style: {
        fontSize: "12px"
      }
    }, n || "Lang"), i.default.createElement("div", {
      className: "dropdown-menu text-uppercase",
      "aria-labelledby": "dropdownMenuLink",
      style: {
        right: "auto !important"
      }
    }, o.map(function (e, n) {
      return i.default.createElement(r.Fragment, null, i.default.createElement("a", {
        key: n,
        className: "dropdown-item",
        value: e.value,
        onClick: function (n) {
          return t(n, e.value);
        }
      }, e.title));
    }))));
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  t.swapLangofURL = function (e) {
    var t = window.location.href,
      n = window.location.pathname,
      a = t.search(n) + 3;
    return "/" + e + t.substring(a);
  }, t.genarateLangArray = function (e) {
    return {
      title: e.langKey,
      value: e.langKey
    };
  };
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  };
  t.PagePreviewComponent = function (e) {
    var t = e.selectedLanguage,
      n = t.direction ? t.direction : "ltr",
      l = t.langKey ? t.langKey.toLowerCase() : "en";
    return r.default.createElement(r.default.Fragment, null, r.default.createElement("div", {
      dir: n,
      "ua-lang": l,
      id: "ua-lang"
    }, r.default.createElement("div", {
      className: "col-md-12 page__contet__parent",
      id: "fullpage",
      style: {
        minHeight: "calc(100vh - 578px)"
      }
    }, r.default.createElement(i.PreviewPageComponent, a({}, e.headerPreviewData, {
      editMode: e.editMode,
      section: "header",
      openComponentList: e.openComponentList,
      dbName: e.dbName,
      selectedLanguage: e.selectedLanguage,
      isPreview: e.isPreview
    })), r.default.createElement(i.PreviewPageComponent, a({}, e.pagePreviewData, {
      editMode: e.editMode,
      section: "",
      openComponentList: e.openComponentList,
      dbName: e.dbName,
      selectedLanguage: e.selectedLanguage,
      isPreview: e.isPreview
    })), r.default.createElement("div", {
      className: "scroll-to-top"
    }, r.default.createElement(o.default, {
      ContainerClassName: "scrolltotop-container",
      TransitionClassName: "scrolltotop-transition",
      EasingType: "easeInCubic"
    }, r.default.createElement(s.default, {
      width: 48,
      height: 48
    }))), r.default.createElement(i.PreviewPageComponent, a({}, e.footerPreviewData, {
      editMode: e.editMode,
      section: "footer",
      openComponentList: e.openComponentList,
      dbName: e.dbName,
      selectedLanguage: e.selectedLanguage,
      isPreview: e.isPreview
    })))));
  };
  var r = l(n(0)),
    i = n(180),
    o = (l(n(3)), l(n(2)), l(n(326))),
    s = l(n(327));
  function l(e) {
    return e && e.__esModule ? e : {
      default: e
    };
  }
}, function (e, t) {
  e.exports = require("react-scroll-up-button");
}, function (e, t, n) {
  "use strict";

  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var a = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  };
  t.default = function (e) {
    return o.default.createElement("svg", a({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 64 64"
    }, e), o.default.createElement("defs", null, o.default.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#666;}.cls-3{fill:#e6e6e6;}")), o.default.createElement("title", null, "scrolltotop"), o.default.createElement("g", {
      id: "Layer_2",
      dataname: "Layer 2"
    }, o.default.createElement("g", {
      id: "Layer_1-2",
      dataname: "Layer 1"
    }, o.default.createElement("circle", {
      className: "cls-1",
      cx: "32",
      cy: "32",
      r: "32"
    }), o.default.createElement("polygon", {
      className: "cls-2",
      points: "44.02 33.48 42.61 34.89 33 25.29 33 47.18 31 47.18 31 25.29 21.39 34.89 19.98 33.48 32 21.46 44.02 33.48"
    }), o.default.createElement("rect", {
      className: "cls-3",
      x: "19.98",
      y: "19.76",
      width: "24.04",
      height: "1.7"
    }))));
  };
  var r,
    i = n(0),
    o = (r = i) && r.__esModule ? r : {
      default: r
    };
}, function (e, t, n) {
  "use strict";

  n.r(t), n.d(t, "ReCAPTCHA", function () {
    return d;
  });
  var a = n(0),
    r = n.n(a),
    i = n(4),
    o = n.n(i);
  function s() {
    return (s = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      }
      return e;
    }).apply(this, arguments);
  }
  function l(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  var d = function (e) {
    var t, n;
    function a() {
      var t;
      return (t = e.call(this) || this).handleExpired = t.handleExpired.bind(l(t)), t.handleErrored = t.handleErrored.bind(l(t)), t.handleChange = t.handleChange.bind(l(t)), t.handleRecaptchaRef = t.handleRecaptchaRef.bind(l(t)), t;
    }
    n = e, (t = a).prototype = Object.create(n.prototype), t.prototype.constructor = t, t.__proto__ = n;
    var i = a.prototype;
    return i.getValue = function () {
      return this.props.grecaptcha && void 0 !== this._widgetId ? this.props.grecaptcha.getResponse(this._widgetId) : null;
    }, i.getWidgetId = function () {
      return this.props.grecaptcha && void 0 !== this._widgetId ? this._widgetId : null;
    }, i.execute = function () {
      var e = this.props.grecaptcha;
      if (e && void 0 !== this._widgetId) return e.execute(this._widgetId);
      this._executeRequested = !0;
    }, i.executeAsync = function () {
      var e = this;
      return new Promise(function (t, n) {
        e.executionResolve = t, e.executionReject = n, e.execute();
      });
    }, i.reset = function () {
      this.props.grecaptcha && void 0 !== this._widgetId && this.props.grecaptcha.reset(this._widgetId);
    }, i.handleExpired = function () {
      this.props.onExpired ? this.props.onExpired() : this.handleChange(null);
    }, i.handleErrored = function () {
      this.props.onErrored && this.props.onErrored(), this.executionReject && (this.executionReject(), delete this.executionResolve, delete this.executionReject);
    }, i.handleChange = function (e) {
      this.props.onChange && this.props.onChange(e), this.executionResolve && (this.executionResolve(e), delete this.executionReject, delete this.executionResolve);
    }, i.explicitRender = function () {
      if (this.props.grecaptcha && this.props.grecaptcha.render && void 0 === this._widgetId) {
        var e = document.createElement("div");
        this._widgetId = this.props.grecaptcha.render(e, {
          sitekey: this.props.sitekey,
          callback: this.handleChange,
          theme: this.props.theme,
          type: this.props.type,
          tabindex: this.props.tabindex,
          "expired-callback": this.handleExpired,
          "error-callback": this.handleErrored,
          size: this.props.size,
          stoken: this.props.stoken,
          hl: this.props.hl,
          badge: this.props.badge
        }), this.captcha.appendChild(e);
      }
      this._executeRequested && this.props.grecaptcha && void 0 !== this._widgetId && (this._executeRequested = !1, this.execute());
    }, i.componentDidMount = function () {
      this.explicitRender();
    }, i.componentDidUpdate = function () {
      this.explicitRender();
    }, i.componentWillUnmount = function () {
      void 0 !== this._widgetId && (this.delayOfCaptchaIframeRemoving(), this.reset());
    }, i.delayOfCaptchaIframeRemoving = function () {
      var e = document.createElement("div");
      for (document.body.appendChild(e), e.style.display = "none"; this.captcha.firstChild;) e.appendChild(this.captcha.firstChild);
      setTimeout(function () {
        document.body.removeChild(e);
      }, 5e3);
    }, i.handleRecaptchaRef = function (e) {
      this.captcha = e;
    }, i.render = function () {
      var e = this.props,
        t = (e.sitekey, e.onChange, e.theme, e.type, e.tabindex, e.onExpired, e.onErrored, e.size, e.stoken, e.grecaptcha, e.badge, e.hl, function (e, t) {
          if (null == e) return {};
          var n,
            a,
            r = {},
            i = Object.keys(e);
          for (a = 0; a < i.length; a++) n = i[a], t.indexOf(n) >= 0 || (r[n] = e[n]);
          return r;
        }(e, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl"]));
      return r.a.createElement("div", s({}, t, {
        ref: this.handleRecaptchaRef
      }));
    }, a;
  }(r.a.Component);
  d.displayName = "ReCAPTCHA", d.propTypes = {
    sitekey: o.a.string.isRequired,
    onChange: o.a.func,
    grecaptcha: o.a.object,
    theme: o.a.oneOf(["dark", "light"]),
    type: o.a.oneOf(["image", "audio"]),
    tabindex: o.a.number,
    onExpired: o.a.func,
    onErrored: o.a.func,
    size: o.a.oneOf(["compact", "normal", "invisible"]),
    stoken: o.a.string,
    hl: o.a.string,
    badge: o.a.oneOf(["bottomright", "bottomleft", "inline"])
  }, d.defaultProps = {
    onChange: function () {},
    theme: "light",
    type: "image",
    tabindex: 0,
    size: "normal",
    badge: "bottomright"
  };
  var u = n(250),
    c = n.n(u);
  function m() {
    return (m = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      }
      return e;
    }).apply(this, arguments);
  }
  var f = {},
    p = 0;
  var _,
    h,
    y = (_ = function () {
      return "https://" + (("undefined" != typeof window && window.recaptchaOptions || {}).useRecaptchaNet ? "recaptcha.net" : "www.google.com") + "/recaptcha/api.js?onload=onloadcallback&render=explicit";
    }, h = (h = {
      callbackName: "onloadcallback",
      globalName: "grecaptcha"
    }) || {}, function (e) {
      var t = e.displayName || e.name || "Component",
        n = function (t) {
          var n, r;
          function i(e, n) {
            var a;
            return (a = t.call(this, e, n) || this).state = {}, a.__scriptURL = "", a;
          }
          r = t, (n = i).prototype = Object.create(r.prototype), n.prototype.constructor = n, n.__proto__ = r;
          var o = i.prototype;
          return o.asyncScriptLoaderGetScriptLoaderID = function () {
            return this.__scriptLoaderID || (this.__scriptLoaderID = "async-script-loader-" + p++), this.__scriptLoaderID;
          }, o.setupScriptURL = function () {
            return this.__scriptURL = "function" == typeof _ ? _() : _, this.__scriptURL;
          }, o.asyncScriptLoaderHandleLoad = function (e) {
            var t = this;
            this.setState(e, function () {
              return t.props.asyncScriptOnLoad && t.props.asyncScriptOnLoad(t.state);
            });
          }, o.asyncScriptLoaderTriggerOnScriptLoaded = function () {
            var e = f[this.__scriptURL];
            if (!e || !e.loaded) throw new Error("Script is not loaded.");
            for (var t in e.observers) e.observers[t](e);
            delete window[h.callbackName];
          }, o.componentDidMount = function () {
            var e = this,
              t = this.setupScriptURL(),
              n = this.asyncScriptLoaderGetScriptLoaderID(),
              a = h,
              r = a.globalName,
              i = a.callbackName,
              o = a.scriptId;
            if (r && void 0 !== window[r] && (f[t] = {
              loaded: !0,
              observers: {}
            }), f[t]) {
              var s = f[t];
              return s && (s.loaded || s.errored) ? void this.asyncScriptLoaderHandleLoad(s) : void (s.observers[n] = function (t) {
                return e.asyncScriptLoaderHandleLoad(t);
              });
            }
            var l = {};
            l[n] = function (t) {
              return e.asyncScriptLoaderHandleLoad(t);
            }, f[t] = {
              loaded: !1,
              observers: l
            };
            var d = document.createElement("script");
            for (var u in d.src = t, d.async = !0, h.attributes) d.setAttribute(u, h.attributes[u]);
            o && (d.id = o);
            var c = function (e) {
              if (f[t]) {
                var n = f[t].observers;
                for (var a in n) e(n[a]) && delete n[a];
              }
            };
            i && "undefined" != typeof window && (window[i] = function () {
              return e.asyncScriptLoaderTriggerOnScriptLoaded();
            }), d.onload = function () {
              var e = f[t];
              e && (e.loaded = !0, c(function (t) {
                return !i && (t(e), !0);
              }));
            }, d.onerror = function () {
              var e = f[t];
              e && (e.errored = !0, c(function (t) {
                return t(e), !0;
              }));
            }, document.body.appendChild(d);
          }, o.componentWillUnmount = function () {
            var e = this.__scriptURL;
            if (!0 === h.removeOnUnmount) for (var t = document.getElementsByTagName("script"), n = 0; n < t.length; n += 1) t[n].src.indexOf(e) > -1 && t[n].parentNode && t[n].parentNode.removeChild(t[n]);
            var a = f[e];
            a && (delete a.observers[this.asyncScriptLoaderGetScriptLoaderID()], !0 === h.removeOnUnmount && delete f[e]);
          }, o.render = function () {
            var t = h.globalName,
              n = this.props,
              r = (n.asyncScriptOnLoad, n.forwardedRef),
              i = function (e, t) {
                if (null == e) return {};
                var n,
                  a,
                  r = {},
                  i = Object.keys(e);
                for (a = 0; a < i.length; a++) n = i[a], t.indexOf(n) >= 0 || (r[n] = e[n]);
                return r;
              }(n, ["asyncScriptOnLoad", "forwardedRef"]);
            return t && "undefined" != typeof window && (i[t] = void 0 !== window[t] ? window[t] : void 0), i.ref = r, Object(a.createElement)(e, i);
          }, i;
        }(a.Component),
        r = Object(a.forwardRef)(function (e, t) {
          return Object(a.createElement)(n, m({}, e, {
            forwardedRef: t
          }));
        });
      return r.displayName = "AsyncScriptLoader(" + t + ")", r.propTypes = {
        asyncScriptOnLoad: o.a.func
      }, c()(r, e);
    })(d);
  t.default = y;
}]);